function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("dtV5n", function(module, exports) {
    $parcel$export(module.exports, "browseIssueRouteEntry", ()=>$6799e9dd8b372fc2$export$cef770e7c16cfcc);
    $parcel$export(module.exports, "browseIssueEmbedRouteEntry", ()=>$6799e9dd8b372fc2$export$e275b3ca0c6ccb5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $6e4Kt;
    var $2vSU6;
    var $65Ltd;
    var $e2ctp;
    var $co1wz;
    var $4R6GH;
    var $gyYxw;
    var $g5RGc;
    var $1FeCu;
    var $7DqiA;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $93Yeu;
    var $dAfqg;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $bHhiy;
    var $8ZUng;
    var $5CPDv;
    var $9XjL6;
    var $lCj8l;
    var $bmvW5;
    var $eqN9Q;
    var $jdjBW;
    var $3RJkv;
    var $1aAOt;
    var $dxCvy;
    var $1WlLE;
    var $7GnDe;
    var $2Ql51;
    var $gNStA;
    var $fjoQ1;
    var $fw7Rx;
    var $gRzZD;
    var $c65JB;
    var $lGGIs;
    var $5j7Th;
    var $hPtZI;
    var $7tQej;
    var $bmKPg;
    const $6799e9dd8b372fc2$var$pageId = 'spa-issue';
    const $6799e9dd8b372fc2$var$conditionalIssueGiraNonCriticalDataResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w'), (0, (0, parcelRequire("lCj8l")).issueGiraNonCriticalDataResource));
    const $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('smart_replies_m1_jira_labs'), (0, (0, parcelRequire("1FeCu")).smartRepliesOptInStatusResources));
    const $6799e9dd8b372fc2$var$LazyIssuePage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("f1yBu"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
    });
    const $6799e9dd8b372fc2$export$c1a868ace2f38803 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const [issueKey] = (0, (0, parcelRequire("bmKPg")).usePathParam)('issueKey');
        const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
        let actualIssueKey = issueKey;
        if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
        if (!false && data?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6799e9dd8b372fc2$var$LazyIssuePage,
            pageId: $6799e9dd8b372fc2$var$pageId,
            shouldShowSpinner: false
        });
    };
    const $6799e9dd8b372fc2$export$ef02bcc0eb1d9ded = ()=>{
        const [issueKey] = (0, (0, parcelRequire("bmKPg")).usePathParam)('issueKey');
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey || '');
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        const projectId = (0, (0, parcelRequire("93Yeu")).useProjectId)(projectKey);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DqiA")).EmbedModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6799e9dd8b372fc2$export$c1a868ace2f38803, null));
    };
    const $6799e9dd8b372fc2$export$cef770e7c16cfcc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fw7Rx")).browseIssueRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
            preloadOptions: {
                earlyChunks: [
                    'issue-app-early-entry'
                ]
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY),
            component: $6799e9dd8b372fc2$export$c1a868ace2f38803,
            skeleton: (0, (0, parcelRequire("c65JB")).IssueViewSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).fullPageIssuePreloadLayout)),
            navigation: {
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResourceOnNav3Only),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResourceOnNav3Only),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
                ...(0, (0, parcelRequire("1aAOt")).getOfferingCatalogueFeaturesResource)(),
                (0, (0, parcelRequire("bmvW5")).issueMediaReadPermissionResource),
                (0, (0, parcelRequire("jdjBW")).issueMediaUserAuthResource),
                (0, (0, parcelRequire("9XjL6")).issueGiraDataResource),
                $6799e9dd8b372fc2$var$conditionalIssueGiraNonCriticalDataResource,
                (0, (0, parcelRequire("eqN9Q")).issueMediaUploadPermissionResource),
                (0, (0, parcelRequire("5CPDv")).issueForgeDataResource),
                (0, (0, parcelRequire("8ZUng")).issueViewRelayResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("gRzZD")).workspaceResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $6799e9dd8b372fc2$var$LazyIssuePage
            ],
            ufoName: 'issue-view',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
            },
            bifrost: {
                bundling: {
                    packageName: '@atlassian/jira-router-routes-issue-entries',
                    whichExportToUse: 'browseIssueRouteEntry'
                },
                enabled: true
            }
        }));
    const $6799e9dd8b372fc2$export$e275b3ca0c6ccb5e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fjoQ1")).browseIssueEmbedRoute), ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
            preloadOptions: {
                earlyChunks: [
                    'issue-app-early-entry'
                ]
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY),
            component: $6799e9dd8b372fc2$export$ef02bcc0eb1d9ded,
            skeleton: (0, (0, parcelRequire("c65JB")).IssueViewSkeleton),
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getModernIssueTransitionResources)(),
                (0, (0, parcelRequire("bmvW5")).issueMediaReadPermissionResource),
                (0, (0, parcelRequire("jdjBW")).issueMediaUserAuthResource),
                (0, (0, parcelRequire("9XjL6")).issueGiraDataResource),
                $6799e9dd8b372fc2$var$conditionalIssueGiraNonCriticalDataResource,
                (0, (0, parcelRequire("eqN9Q")).issueMediaUploadPermissionResource),
                (0, (0, parcelRequire("5CPDv")).issueForgeDataResource),
                (0, (0, parcelRequire("8ZUng")).issueViewRelayResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("gRzZD")).workspaceResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                $6799e9dd8b372fc2$var$conditionalSmartRepliesOptInStatusResources
            ],
            forPaint: [
                $6799e9dd8b372fc2$var$LazyIssuePage
            ],
            ufoName: 'issue-view-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
            },
            bifrost: {
                bundling: {
                    packageName: '@atlassian/jira-router-routes-issue-entries',
                    whichExportToUse: 'browseIssueEmbedRouteEntry'
                },
                enabled: true
            }
        }));
});
parcelRegister("ffza4", function(module, exports) {
    $parcel$export(module.exports, "LazyAtlassianNavigation", ()=>$772c987a24839dcf$export$4caed23aa0274abb);
    var $fDtbf;
    var $2SVPM;
    var $hPtZI;
    const $772c987a24839dcf$export$4caed23aa0274abb = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        const bundleReady = (parcelRequire("fAyVj"));
        if (!false) bundleReady.then(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return bundleReady;
    }, {
        moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
    });
});
parcelRegister("fAyVj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kV4Fy")
    ]).then(()=>parcelRequire('jC2al'));
});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';
parcelRegister("6e4Kt", function(module, exports) {
    $parcel$export(module.exports, "chromelessLayout", ()=>$c3106f352857c22e$export$17e73ed8c35891cb);
    var $1XrjK;
    const $c3106f352857c22e$export$17e73ed8c35891cb = (0, (0, parcelRequire("1XrjK")).createLayout)({
        isChromeless: true
    });
});
parcelRegister("1XrjK", function(module, exports) {
    $parcel$export(module.exports, "coalesce", ()=>$3b8b9d6fe762babb$export$6e5538615c060df7);
    $parcel$export(module.exports, "renderGlobalComponents", ()=>$3b8b9d6fe762babb$export$fc28c9563350e5b8);
    $parcel$export(module.exports, "createLayout", ()=>$3b8b9d6fe762babb$export$3dd437ade36ede40);
    $parcel$export(module.exports, "composeLayouts", ()=>$3b8b9d6fe762babb$export$6c041b39c370853f);
    $parcel$export(module.exports, "withProjectContext", ()=>$3b8b9d6fe762babb$export$e97a7da67a5b8ce4);
    var $5uXOq = parcelRequire("5uXOq");
    var $lpwtK;
    var $lfTZh;
    const $3b8b9d6fe762babb$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
    const $3b8b9d6fe762babb$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
            const { displayName: displayName, name: name } = Component;
            const key = $3b8b9d6fe762babb$export$6e5538615c060df7(displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(name) ?? i;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: key?.toString(),
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                key: key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null)));
        });
    const $3b8b9d6fe762babb$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
            isChromeless: isChromeless,
            globalComponents: Array.from(new Set(globalComponents)),
            rightSidebars: Array.from(new Set(rightSidebars))
        });
    const $3b8b9d6fe762babb$export$6c041b39c370853f = (...layouts)=>{
        if (layouts.length === 1) return $3b8b9d6fe762babb$export$3dd437ade36ede40(layouts[0]);
        const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
                isChromeless: isChromeless,
                globalComponents: [
                    ...l.globalComponents,
                    ...globalComponents
                ],
                rightSidebars: [
                    ...l.rightSidebars,
                    ...rightSidebars
                ]
            }), {
            globalComponents: [],
            rightSidebars: [],
            isChromeless: false
        });
        return $3b8b9d6fe762babb$export$3dd437ade36ede40(layout);
    };
    const $3b8b9d6fe762babb$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    const $3b8b9d6fe762babb$var$formatPrefix = (style, type)=>{
        if (!style && !type) return 'Empty';
        if (style === 'any' && type === 'any') return 'Any';
        const formattedStyle = $3b8b9d6fe762babb$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
        if (type === 'any') return formattedStyle;
        const formattedType = $3b8b9d6fe762babb$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
        if (style === 'any') return formattedType;
        return `${formattedStyle}${formattedType}`;
    };
    const $3b8b9d6fe762babb$export$e97a7da67a5b8ce4 = (Component, options)=>{
        const { project: expectedProject } = options;
        const ScopedComponent = ()=>{
            const { data: project, loading: loading } = (0, (0, parcelRequire("lpwtK")).useProject)();
            if (loading) return null;
            if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
        };
        const name = $3b8b9d6fe762babb$export$6e5538615c060df7(Component.displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(Component.name) ?? 'Component';
        const prefix = $3b8b9d6fe762babb$var$formatPrefix(expectedProject?.style, expectedProject?.type);
        ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
        return ScopedComponent;
    };
});
parcelRegister("lpwtK", function(module, exports) {
    $parcel$export(module.exports, "useProject", ()=>$f3d7644b5666677d$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bsuuc;
    var $1J3t1;
    const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)(customContext);
        const project = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("bsuuc")).extractData)(data), [
            data
        ]);
        return {
            data: project,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("bsuuc", function(module, exports) {
    $parcel$export(module.exports, "getStyle", ()=>$36c780ae7e3dc8c8$export$3d2f074408bd1b82);
    $parcel$export(module.exports, "extractData", ()=>$36c780ae7e3dc8c8$export$9df5fa0a366163d2);
    var $2vSU6;
    const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC;
    const $36c780ae7e3dc8c8$var$getProject = (project)=>({
            avatarUrl: project.avatarUrls['48x48'],
            id: Number(project.id),
            isSimplified: project.simplified,
            key: project.key,
            name: project.name,
            style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
            type: project.projectTypeKey
        });
    const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
        const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
        switch(projectType){
            case 'jira_work_management':
                return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
            case 'jira_software':
                return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
            case 'jira_service_management':
            case 'jira_customer_service':
                return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
            case 'jira_product_discovery':
                return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
            case null:
            default:
                return null;
        }
    };
});
parcelRegister("1J3t1", function(module, exports) {
    $parcel$export(module.exports, "useProjectSidebarNavigation", ()=>$bb292f58b8ec7804$export$5a85006c180fb373);
    $parcel$export(module.exports, "useProjectSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$2bed15cd7d167db5);
    $parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$a9d05fc2c1d94895);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$d48e3c3556894533);
    $parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", ()=>$bb292f58b8ec7804$export$24a781cd863077aa);
    $parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", ()=>$bb292f58b8ec7804$export$e16ecd2512eb0dc7);
    $parcel$export(module.exports, "useJiraSoftwareProjectNavigation", ()=>$bb292f58b8ec7804$export$68dc0ecbea8211d2);
    $parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", ()=>$bb292f58b8ec7804$export$5cf90b625d0e1248);
    $parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", ()=>$bb292f58b8ec7804$export$d63d92edebe543d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $b2pl3;
    var $6zFAI;
    var $gcI3W;
    var $loy04;
    var $ggg5j;
    var $324W5;
    var $2YP9W;
    var $727Q1;
    const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
        const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), customContext);
        const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
            navResponse
        ]);
        (0, (0, parcelRequire("727Q1")).useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
        return {
            data: memoizedResponse,
            loading: memoizedResponse != null ? false : loading,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraWorkManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraSoftwareNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
        const response = data?.jiraServiceManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraProductDiscoveryNavData || null;
        return {
            data: response,
            ...rest
        };
    };
});
parcelRegister("b2pl3", function(module, exports) {
    $parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", ()=>$565682b770797f58$export$fab84295e18e9246);
    var $1nb22;
    var $2M1hQ;
    var $jAGOQ;
    const $565682b770797f58$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $565682b770797f58$export$fab84295e18e9246 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
        getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("1nb22", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyId", ()=>$061afadfbcc74f44$export$1f7213d0f9054f06);
    const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
        const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
        const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
        return {
            projectKey: projectKey,
            projectId: projectId
        };
    };
});
parcelRegister("jAGOQ", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", ()=>$45e9310ad65e3e88$export$b15f9f5cf6db359e);
    var $eusud;
    const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
        if (projectKeyOrId == null) throw new Error('invalid identifier specified');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
    };
});
parcelRegister("eusud", function(module, exports) {
    $parcel$export(module.exports, "transformValidationErrorFromServer", ()=>$3637c0f7edbd2bb4$export$8e9baed7697e4959);
    $parcel$export(module.exports, "applyErrorHandling", ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff);
    $parcel$export(module.exports, "performGetRequest", ()=>$3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$3637c0f7edbd2bb4$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$3637c0f7edbd2bb4$export$8ef51cba9d28f819);
    $parcel$export(module.exports, "performPatchRequest", ()=>$3637c0f7edbd2bb4$export$52be6ab13d7e758d);
    $parcel$export(module.exports, "performGetRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$659b5ee69e6eb976);
    $parcel$export(module.exports, "performPutRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$d7b48b2904a5d812);
    $parcel$export(module.exports, "performPostRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$a5717cbee13f28b7);
    var $aDvGo;
    var $jQsty;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    var $6b2ko;
    var $iwPwz;
    const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
                field: field,
                error: fieldErrors[field]
            }));
    const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
        const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
        const fieldErrorsJson = json.errors ?? json.fieldErrors;
        const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
        return new (0, (0, parcelRequire("jJZqs")).ValidationError)(message, fieldErrors, statusCode, traceId, json);
    };
    const $3637c0f7edbd2bb4$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $3637c0f7edbd2bb4$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $3637c0f7edbd2bb4$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $3637c0f7edbd2bb4$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $3637c0f7edbd2bb4$var$handleNetworkErrors = (err)=>{
        if (err instanceof TypeError) throw new Error('Failed to fetch', {
            cause: err
        });
        throw err;
    };
    const $3637c0f7edbd2bb4$var$handleErrors = (response)=>{
        const traceId = (0, (0, parcelRequire("iwPwz")).getTraceId)(response);
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
            throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
        });
        if (!response.ok) {
            if (traceId !== undefined && traceId.length > 0) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, undefined, response);
        }
        return response;
    };
    const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
        const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
        const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, requestOptions)));
        if ((0, (0, parcelRequire("jQsty")).default)('platform_fetch_retries')) return executeRequest();
        return (0, (0, parcelRequire("6b2ko")).retryOnError)(executeRequest, {
            retryFunc: executeRequest,
            retryPredicate: retryPredicate,
            retryAttempts: retryAttempts,
            onRetry: onRetry
        });
    };
    const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        });
    const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        });
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("6b2ko", function(module, exports) {
    $parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", ()=>$6910b563ec955346$export$81189edc9b923717);
    $parcel$export(module.exports, "retryOnError", ()=>$6910b563ec955346$export$f859c88bfac2cf2c);
    const $6910b563ec955346$export$81189edc9b923717 = 1;
    const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
        const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
        const execute = async (getPromise, retryAttempt = 0)=>{
            try {
                return await getPromise();
            } catch (error) {
                const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
                if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                    onRetry && onRetry(error, retryAttempt + 1);
                    return execute(retryFunc, retryAttempt + 1);
                }
                throw error;
            }
        };
        return execute(initialPromiseGetter);
    };
});
parcelRegister("6zFAI", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", ()=>$ee61b377cbb3343f$export$b8c6e2666f12f4bb);
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", ()=>$ee61b377cbb3343f$export$a799c58e7bee6de4);
    var $4R6GH;
    var $3HwlS;
    var $1nb22;
    var $gNStA;
    var $2M1hQ;
    var $jAGOQ;
    const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const projectHomeAddonNavInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
            return projectHomeAddonNavInfo;
        },
        maxAge: 300000
    });
    const $ee61b377cbb3343f$export$a799c58e7bee6de4 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-nav-remove-resources')), $ee61b377cbb3343f$export$b8c6e2666f12f4bb);
});
parcelRegister("3HwlS", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4", ()=>$30254f1a9a5ebb1a$export$f1ce4aa22fe8768a);
    var $4R6GH;
    var $c0dQj;
    var $Z0r3L;
    var $ifO6r;
    var $9qXgw;
    const $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("ifO6r")).getWillShowNav4ForDogfooding)() || (0, (0, parcelRequire("9qXgw")).getWillShowNav4ForEap)() || (0, (0, parcelRequire("Z0r3L")).getWillShowNav4ForBeta)() || (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)());
});
parcelRegister("c0dQj", function(module, exports) {
    $parcel$export(module.exports, "isMobileAndInMVPExperiment", ()=>$7275e40842570ace$export$f29d7974ab92d702);
    $parcel$export(module.exports, "MobileWebExperimentExposure", ()=>$7275e40842570ace$export$b93f740e619fc842);
    var $bCdIp;
    var $6s1PB;
    var $4R6GH;
    const $7275e40842570ace$export$f29d7974ab92d702 = ()=>{
        const [mobileWebConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
        return ((0, (0, parcelRequire("4R6GH")).fg)('jira_mobile_web_mvp_2_feature_gate') && (0, (0, parcelRequire("bCdIp")).default)() && mobileWebConfig.get('isEnabled', false));
    };
    const $7275e40842570ace$export$b93f740e619fc842 = ()=>{
        const [, manuallyFireExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp_2');
        if ((0, (0, parcelRequire("bCdIp")).default)()) manuallyFireExposure();
        return null;
    };
});
parcelRegister("6s1PB", function(module, exports) {
    $parcel$export(module.exports, "expVal", ()=>$d0d3e1363a65fa96$export$9db1624a8af791a4);
    $parcel$export(module.exports, "expValEquals", ()=>$d0d3e1363a65fa96$export$45abdb3f977b5b14);
    $parcel$export(module.exports, "UNSAFE_noExposureExp", ()=>$d0d3e1363a65fa96$export$677f9fa2e1ae6fec);
    var $70qxv;
    var $aiwW2;
    var $40Gox;
    function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
        (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
        const value = (0, (0, parcelRequire("70qxv")).default).getExperimentValue(experimentName, param, defaultValue);
        (0, (0, parcelRequire("aiwW2")).addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
        return value;
    }
    function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
        return $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
    }
    class $d0d3e1363a65fa96$var$ExperimentConfig {
        constructor(experimentName, config){
            this._experimentName = experimentName;
            this._config = config;
        }
        get(key, defaultValue, typeGuard) {
            const value = this._config.get(key, defaultValue, typeGuard);
            (0, (0, parcelRequire("aiwW2")).addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
            return value;
        }
    }
    const $d0d3e1363a65fa96$var$cache = new Map();
    function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
        let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
        if (instance == null) {
            (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
            const config = (0, (0, parcelRequire("70qxv")).default).getExperiment(experimentName, {
                fireExperimentExposure: false
            });
            const fireExposure = ()=>(0, (0, parcelRequire("70qxv")).default).manuallyLogExperimentExposure(experimentName);
            instance = [
                new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
                fireExposure
            ];
            $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
        }
        return instance;
    }
});
parcelRegister("Z0r3L", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForBeta", ()=>$857b5c92d68cd7c3$export$f4f16573b5c2e67b);
    var $6s1PB;
    var $4R6GH;
    var $1MhR0;
    const $857b5c92d68cd7c3$export$f4f16573b5c2e67b = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_existing-customers') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_sandboxes') || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false);
});
parcelRegister("1MhR0", function(module, exports) {
    $parcel$export(module.exports, "getMetaBoolean", ()=>$039259847fa24143$export$9683360b0ae70629);
    $parcel$export(module.exports, "getIsNav4UserOptOut", ()=>$039259847fa24143$export$3fbfe0fdf05e0f9f);
    var $gJBT6 = parcelRequire("gJBT6");
    var $j8DrX;
    var $7qZOo;
    const $039259847fa24143$export$9683360b0ae70629 = (0, ($parcel$interopDefault($gJBT6)))((name)=>(0, (0, parcelRequire("j8DrX")).default)(`ajs-${name}`) === 'true');
    const $039259847fa24143$export$7d046765d192af80 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_ADMIN));
    const $039259847fa24143$export$ba89637357392be6 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_IN));
    const $039259847fa24143$export$3fbfe0fdf05e0f9f = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_OUT));
});
parcelRegister("7qZOo", function(module, exports) {
    $parcel$export(module.exports, "IS_ADMIN", ()=>$92928f70e02753a5$export$4261d5d429e288ec);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", ()=>$92928f70e02753a5$export$153ded4d539b820d);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", ()=>$92928f70e02753a5$export$9c962957701a4fe8);
    $parcel$export(module.exports, "NAV4_ROLLOUT_NONE", ()=>$92928f70e02753a5$export$3b602cac1f385c06);
    $parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", ()=>$92928f70e02753a5$export$e748a16828d2f61f);
    const $92928f70e02753a5$export$4261d5d429e288ec = 'is-admin';
    const $92928f70e02753a5$export$153ded4d539b820d = 'is-nav4-user-opt-in';
    const $92928f70e02753a5$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
    const $92928f70e02753a5$export$3b602cac1f385c06 = {
        stage: 'none'
    };
    const $92928f70e02753a5$export$e748a16828d2f61f = {
        stage: 'mobile'
    };
    const $92928f70e02753a5$export$9cd4b8dc5f7153b8 = {
        NONE: 'none',
        DOGFOODING: 'dogfooding',
        EAP: 'eap',
        BETA: 'beta',
        GA: 'ga'
    };
});
parcelRegister("ifO6r", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForDogfooding", ()=>$b6db23b0cddd1764$export$9ca0d92d31816d4f);
    var $4R6GH;
    var $1MhR0;
    const $b6db23b0cddd1764$export$9ca0d92d31816d4f = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')) return false;
        const phase1 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1');
        const phase2 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2');
        const phase3 = !(phase1 || phase2);
        return phase3 || phase2 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || phase1 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    };
});
parcelRegister("9qXgw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForEap", ()=>$77cd593041adc2b6$export$393f53ae320de085);
    var $4R6GH;
    var $1MhR0;
    const $77cd593041adc2b6$export$393f53ae320de085 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
});
parcelRegister("gNStA", function(module, exports) {
    $parcel$export(module.exports, "resourceWithCondition", ()=>$4fbc57fe7e788209$export$cac04afc5a06c544);
    $parcel$export(module.exports, "resourceWithCondition2", ()=>$4fbc57fe7e788209$export$78488a529a07cd46);
    $parcel$export(module.exports, "browserOnlyResourceWithCondition", ()=>$4fbc57fe7e788209$export$5284559c6d2f1a7b);
    var $kbVA4;
    const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
            get type () {
                return conditionGetter() ? resourceTrue.type : (0, (0, parcelRequire("kbVA4")).RESOURCE_TYPE_NOOP);
            },
            getKey: resourceTrue.getKey,
            get maxAge () {
                return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
            },
            getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
            maxCache: resourceTrue.maxCache,
            get isBrowserOnly () {
                return resourceTrue.isBrowserOnly;
            },
            get depends () {
                return resourceTrue.depends;
            },
            get skipBrowser () {
                return resourceTrue.skipBrowser;
            }
        };
    const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>resource && Object.defineProperties({}, {
            ...Object.getOwnPropertyDescriptors(resource),
            ...Object.getOwnPropertyDescriptors(amendments)
        });
    const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
        getKey: ()=>'DEGENERATE_KEY',
        getData: ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER
    }))=>itemTrue && Object.defineProperties({}, Object.fromEntries([
            ...Object.keys(itemTrue),
            ...Object.keys(itemFalse)
        ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
                key,
                {
                    configurable: false,
                    enumerable: true,
                    get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
                }
            ])));
    const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
            ...resource,
            get isBrowserOnly () {
                return !!conditionGetter();
            }
        };
});
parcelRegister("kbVA4", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NOOP", ()=>$513d12eeb22c04a1$export$eb37f5d331ea4de4);
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$513d12eeb22c04a1$export$5664a170ac5a9781);
    const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
    const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;
});
parcelRegister("gcI3W", function(module, exports) {
    $parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", ()=>$e60f9280597d4f0e$export$b662f3f877add30d);
    var $1nb22;
    var $2M1hQ;
    var $jAGOQ;
    const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e60f9280597d4f0e$export$b662f3f877add30d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("loy04", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$e4bf33528101348c);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$2d5a704ae6f6b050);
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $jAGOQ;
    const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
            return navInfo;
        },
        maxAge: 300000
    });
    const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);
});
parcelRegister("ggg5j", function(module, exports) {
    $parcel$export(module.exports, "getIdentifier", ()=>$3ec7290d9b237c27$export$adb27ddab077e944);
    $parcel$export(module.exports, "staticProjectSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$f2dfc0f7b2d92691);
    $parcel$export(module.exports, "useSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$b692cfadccf4e047);
    var $65Ltd;
    var $95bh0;
    var $8YTna;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $gDyED;
    const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
        if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
        }
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
    };
    const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
        if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
        return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
    };
    const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
        getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
        getData: async ({ match: match, query: query, route: { name: name } })=>{
            const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
            if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
            const navInfo = await (0, (0, parcelRequire("gDyED")).fetchProjectSidebarNavInfo)(scopeIdentifier);
            return navInfo;
        },
        maxAge: 300000
    });
    const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);
});
parcelRegister("65Ltd", function(module, exports) {
    $parcel$export(module.exports, "ROUTE_GROUPS_SUPPORT_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$dda94bb6f1904d59);
    $parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", ()=>$d90d8ce15e0e3233$export$1ba937db1fe6ef01);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$bbf08d4d25df5504);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", ()=>$d90d8ce15e0e3233$export$e3e759b7f50aaee1);
    $parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$89337611b52bc9a3);
    $parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", ()=>$d90d8ce15e0e3233$export$3d7937b12eb9e5d5);
    $parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$7a3d181d86fce9e6);
    $parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", ()=>$d90d8ce15e0e3233$export$7a22726acd7d6021);
    $parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", ()=>$d90d8ce15e0e3233$export$f3f4a9f53ba00861);
    $parcel$export(module.exports, "ROUTE_GROUPS_EOC", ()=>$d90d8ce15e0e3233$export$112d69653b2f1d8b);
    $parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", ()=>$d90d8ce15e0e3233$export$74e0426b66571086);
    $parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$c2e20e142c95c1ce);
    $parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$f8cea29bebf098c);
    $parcel$export(module.exports, "ROUTE_GROUPS_HOME", ()=>$d90d8ce15e0e3233$export$5801ef8dfc9a2f70);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", ()=>$d90d8ce15e0e3233$export$7246838143f848f3);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$54f96702980a2f87);
    $parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", ()=>$d90d8ce15e0e3233$export$5566db8fbd042fc4);
    $parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", ()=>$d90d8ce15e0e3233$export$656d0cc2c67b2708);
    $parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", ()=>$d90d8ce15e0e3233$export$bfdbcebc4c81b043);
    $parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$82021d71ad19e227);
    $parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", ()=>$d90d8ce15e0e3233$export$6f266218a6973848);
    $parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", ()=>$d90d8ce15e0e3233$export$a846fcaeeea8e0ff);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", ()=>$d90d8ce15e0e3233$export$6c87a9dff4e7a2de);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", ()=>$d90d8ce15e0e3233$export$ab79970dcfac06a1);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", ()=>$d90d8ce15e0e3233$export$d1a70f80bb22f18a);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$bd925e9fcb6ce37f);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$86509a1baabd62ee);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$98823ed9eedfc756);
    $parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", ()=>$d90d8ce15e0e3233$export$da8d13fe1ccd5c09);
    $parcel$export(module.exports, "ROUTE_GROUPS_SANDBOX", ()=>$d90d8ce15e0e3233$export$e46610825208f0d8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$78fb2f6176b7c6b8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$26efaec7a7a8b361);
    $parcel$export(module.exports, "ROUTE_NAMES_AGENT_STUDIO", ()=>$d90d8ce15e0e3233$export$89c26097a5edf8cb);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", ()=>$d90d8ce15e0e3233$export$88041353cc69458d);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$f88d57dcb03ba452);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$e8aa63af071c2da9);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$b114d0da2ebcff6c);
    $parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$29cc94b8cea5c920);
    $parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$4d1b45005cdcfb39);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", ()=>$d90d8ce15e0e3233$export$a42ea04fdf53eeaf);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", ()=>$d90d8ce15e0e3233$export$ca4c5f5b3e2daa18);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", ()=>$d90d8ce15e0e3233$export$d58a5411a2ac6260);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$24514ee19772b5af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", ()=>$d90d8ce15e0e3233$export$ec333dd1d6a8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", ()=>$d90d8ce15e0e3233$export$ed495fbad44791af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", ()=>$d90d8ce15e0e3233$export$5281552f8109b7c0);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", ()=>$d90d8ce15e0e3233$export$6e8473713ed4557a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", ()=>$d90d8ce15e0e3233$export$cbdd5c24d69b2cb1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$e7f012f402be01ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", ()=>$d90d8ce15e0e3233$export$b34d3882b42d660d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$ed869c60c6a56182);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", ()=>$d90d8ce15e0e3233$export$5013269f29c75b37);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$fc8b48319e993d43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", ()=>$d90d8ce15e0e3233$export$d6e60a2059f028d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$3d589aae17a00bc9);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$bd92ef03b23dd672);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", ()=>$d90d8ce15e0e3233$export$fa7fc44c718fc850);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$1dffaf831e01e2b4);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$5f8187412dd60f35);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$3d2c1c04d18f6c43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", ()=>$d90d8ce15e0e3233$export$cd22a5d8f560a1d8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$cad1b1aa5ce26bbc);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$ee073463b4144367);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", ()=>$d90d8ce15e0e3233$export$ea034943499772ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$19bc888bcf37d22d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$e0746183e11767fb);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", ()=>$d90d8ce15e0e3233$export$3e2d215ce157adc8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$8a8485bb05daf40b);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$a2799b01de5bb62);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", ()=>$d90d8ce15e0e3233$export$2d4f89c4b1ee3640);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$75609d3416c31f79);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$79793dc26e0b7b1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2eda7466fbfdef43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$417297669917ee1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$8c79f3309ac0737);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$ef71a22e7befd35c);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", ()=>$d90d8ce15e0e3233$export$62ba1e294f5007c1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$a4315324546ecc89);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$a653cf6d478b3df1);
    $parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$b0f268fe53a03e98);
    $parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$f4160b48e4ab8f39);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$608f359cf8b08d2e);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", ()=>$d90d8ce15e0e3233$export$8bfbf790fe89f8d3);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", ()=>$d90d8ce15e0e3233$export$d7011d1ed949f970);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$bd2506db44585db6);
    $parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$200fa5ad16f8c112);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", ()=>$d90d8ce15e0e3233$export$a296bb962bea95b5);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$b9960c143c0414eb);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$411171d2fcaefaea);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$ee104ed514f63003);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", ()=>$d90d8ce15e0e3233$export$9233f9ddcecd3062);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", ()=>$d90d8ce15e0e3233$export$b3240ec044a6c70f);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", ()=>$d90d8ce15e0e3233$export$2463c779e12367e3);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", ()=>$d90d8ce15e0e3233$export$dd3e5187eae2abe9);
    $parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", ()=>$d90d8ce15e0e3233$export$38ca7e07048a5bfd);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$48749e87cc44a5a5);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$21c230ef79df9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$d2d813dd057a8352);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$54ed2374d14a7e88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$58368fe796f5ecb4);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", ()=>$d90d8ce15e0e3233$export$bbb4032f8f259109);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$5b17b30c2dd69cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", ()=>$d90d8ce15e0e3233$export$d18d0b9a9e85e59c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", ()=>$d90d8ce15e0e3233$export$5126a481501fc518);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$40e720d8c26e6804);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$dc8ac1f7e9373a32);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", ()=>$d90d8ce15e0e3233$export$8ca3e3f0326ba27f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", ()=>$d90d8ce15e0e3233$export$c3d17be12795c864);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", ()=>$d90d8ce15e0e3233$export$9cd1c70eda5cae15);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", ()=>$d90d8ce15e0e3233$export$99f769b27f537a72);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", ()=>$d90d8ce15e0e3233$export$5c5fe79d3f9ec214);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$901b974cf0954c88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$b2dd23a345bd5cb3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$8ae7cbc0a73f9351);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$8057ebe7fb7f7f8d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a22387b9744e62e3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$f6fefa9d2e5bbda1);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", ()=>$d90d8ce15e0e3233$export$e6de4aa6c719d2b);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", ()=>$d90d8ce15e0e3233$export$b195ada84b7e695f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", ()=>$d90d8ce15e0e3233$export$1800d32171b754a6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", ()=>$d90d8ce15e0e3233$export$d22a153bfcbaaaa0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a9a41c76994b6ae9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", ()=>$d90d8ce15e0e3233$export$5bd6f2569c3cfd5c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", ()=>$d90d8ce15e0e3233$export$dc70eff53ff26c70);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", ()=>$d90d8ce15e0e3233$export$1fe2ca96b360df19);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$1ff01e77517a80b0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$de3f8f3198f8213a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", ()=>$d90d8ce15e0e3233$export$b2cb569d360db382);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_SCHEDULES", ()=>$d90d8ce15e0e3233$export$a0d9033eb64fd80f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ESCALATIONS", ()=>$d90d8ce15e0e3233$export$4c2fd998d73d2b83);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", ()=>$d90d8ce15e0e3233$export$da985e953465731f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", ()=>$d90d8ce15e0e3233$export$b7eee2afd0a5c6b9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$9b6c84986db47d98);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$89276f76fdd700d6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$ea64769f19da8c95);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", ()=>$d90d8ce15e0e3233$export$4a584839d9a9eb6f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", ()=>$d90d8ce15e0e3233$export$27d27c817eeb97cc);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$9f533c13cfb48a8f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$6889e571e5aa6ba6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$bdd811277711c53d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$c7b51c0e8ad6f77a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$a348fc7f3b4cfe34);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a4eff769c94da831);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", ()=>$d90d8ce15e0e3233$export$7c928ca9c9822772);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", ()=>$d90d8ce15e0e3233$export$b48311a8f24f4b63);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", ()=>$d90d8ce15e0e3233$export$20649eac204f7661);
    $parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$62170875a111d729);
    $parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$2928f3d69e7ac609);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$259e18cafd820487);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$4b8f333757e638a4);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", ()=>$d90d8ce15e0e3233$export$ac4f65a14002f892);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", ()=>$d90d8ce15e0e3233$export$c73ddc4b44ccb359);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$7ad826b482229119);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", ()=>$d90d8ce15e0e3233$export$3df864df9b639033);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", ()=>$d90d8ce15e0e3233$export$7d67bf4077ebe18d);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$d025408d02e64fb9);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", ()=>$d90d8ce15e0e3233$export$5ff797dfd5df551f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", ()=>$d90d8ce15e0e3233$export$8a66ba1da5efa2c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$eadf5aff28def565);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", ()=>$d90d8ce15e0e3233$export$8f9c045e8fd449b7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$1bf439327974644b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", ()=>$d90d8ce15e0e3233$export$e2a9d163770d0d46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$21b497c57bcd299a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$df5ca261227a6052);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", ()=>$d90d8ce15e0e3233$export$9f2f4303259b8508);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", ()=>$d90d8ce15e0e3233$export$7fd53fe07eecc273);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", ()=>$d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$e05a6c9e9b9b0c48);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$f9759b206b651b1f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$7a337a2687b5d5e3);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", ()=>$d90d8ce15e0e3233$export$a41998c1a3572e41);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$2c9fe9e6005a9c36);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", ()=>$d90d8ce15e0e3233$export$5d8d82ff1de3586e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", ()=>$d90d8ce15e0e3233$export$8a0ed100d885c17c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$1c7041445acf79e8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$e4712523d95125f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$7401274ad357ff94);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$6984b21077857555);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", ()=>$d90d8ce15e0e3233$export$5a2dae98f768aedf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", ()=>$d90d8ce15e0e3233$export$5eef1c6eb1388ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", ()=>$d90d8ce15e0e3233$export$69bcf2c26d45e030);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$ba1417cf5de80f81);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", ()=>$d90d8ce15e0e3233$export$fdcfcb2e2eb16afd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", ()=>$d90d8ce15e0e3233$export$5d3e6bffd6b5abfe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", ()=>$d90d8ce15e0e3233$export$5c676bbb7e3aae9e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$8bb013ced097489a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$e384ae6a87fadedd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", ()=>$d90d8ce15e0e3233$export$8f55a911c4bd95bf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", ()=>$d90d8ce15e0e3233$export$d7b98892cb31fba5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", ()=>$d90d8ce15e0e3233$export$8be4b203f526b2cd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", ()=>$d90d8ce15e0e3233$export$df09947903c514c4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", ()=>$d90d8ce15e0e3233$export$cf4a57a81e0bfbca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", ()=>$d90d8ce15e0e3233$export$bc64365bbb09c05e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", ()=>$d90d8ce15e0e3233$export$5b12571311ebe766);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", ()=>$d90d8ce15e0e3233$export$56dc46fe1de63994);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", ()=>$d90d8ce15e0e3233$export$65af0e5a36d4b4e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", ()=>$d90d8ce15e0e3233$export$dec448f9d2e50c90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$9ff4144e1dcf9fa4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$8aab6fb9a62dda95);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$9f804a2650117f51);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", ()=>$d90d8ce15e0e3233$export$7dd4b916600f670);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", ()=>$d90d8ce15e0e3233$export$c1b40a8a70c0aafa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", ()=>$d90d8ce15e0e3233$export$ff10d812380db045);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$8deeffdf8dfed878);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$561687f2fa9b9cc9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", ()=>$d90d8ce15e0e3233$export$691d30818c14141c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", ()=>$d90d8ce15e0e3233$export$8fa58495105f8fb0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", ()=>$d90d8ce15e0e3233$export$8304c57494d82ffd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", ()=>$d90d8ce15e0e3233$export$353609deec72a2ba);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$1cb56e4c132ac8fd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", ()=>$d90d8ce15e0e3233$export$5fe3eec0a6bda09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", ()=>$d90d8ce15e0e3233$export$12b56880d6fb7ac7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", ()=>$d90d8ce15e0e3233$export$9986e8be82998857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", ()=>$d90d8ce15e0e3233$export$3280ec16231916af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$54885d105d1e2b37);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$f34d87c870f3bf43);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$4108ebf71e36e461);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$d42ec33a6e69686e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", ()=>$d90d8ce15e0e3233$export$8d2cfabd01e2feaa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$d0fe3726dffeca80);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", ()=>$d90d8ce15e0e3233$export$b4aa4b2b8fb7267a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", ()=>$d90d8ce15e0e3233$export$3743711165f5dd4f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", ()=>$d90d8ce15e0e3233$export$5df6f81deab9567c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$a03360d8b616ef34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$336e54edc189df7f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$53572e9a81205523);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", ()=>$d90d8ce15e0e3233$export$b71f2ef452117a2a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", ()=>$d90d8ce15e0e3233$export$f79745fee583cd62);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", ()=>$d90d8ce15e0e3233$export$2281663e19f399c1);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", ()=>$d90d8ce15e0e3233$export$38c52d8c5e5dad29);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", ()=>$d90d8ce15e0e3233$export$10babc3f11b4e6e2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", ()=>$d90d8ce15e0e3233$export$adf2f51c41b4e22a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", ()=>$d90d8ce15e0e3233$export$11b217754d4c7d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", ()=>$d90d8ce15e0e3233$export$3414f0d81f1c11d);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", ()=>$d90d8ce15e0e3233$export$5574c73a9a5878ca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", ()=>$d90d8ce15e0e3233$export$cb2626c385b72992);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$fa7aa7cabc3ec459);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", ()=>$d90d8ce15e0e3233$export$8b0450672651ef67);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$ef510a15f840e437);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$bc159fa4984a907f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$47bfbce13af95d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", ()=>$d90d8ce15e0e3233$export$c8cb78e94cd3f83c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", ()=>$d90d8ce15e0e3233$export$4496279df22177be);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$afdfef5d17c56988);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$ac9b4b1136300033);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", ()=>$d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$c56f5509b93eba68);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$dd9462e97e11637a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$11f8c53e10f63cfb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$758ad3ad6916c9f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", ()=>$d90d8ce15e0e3233$export$9d65a754315eb617);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$564b665f6ca740dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", ()=>$d90d8ce15e0e3233$export$256fc89c38c1b9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", ()=>$d90d8ce15e0e3233$export$ddeae77164bfac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", ()=>$d90d8ce15e0e3233$export$fa2b355372963545);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$45511e437e54fa02);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", ()=>$d90d8ce15e0e3233$export$ad76895f03f27a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", ()=>$d90d8ce15e0e3233$export$1c291d65a59b1636);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$d9bb14d665bfeea5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b44cb3da7b8f857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", ()=>$d90d8ce15e0e3233$export$9ca6a09e1518d3bb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", ()=>$d90d8ce15e0e3233$export$4c211b3188348679);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", ()=>$d90d8ce15e0e3233$export$24757bb1837e33af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", ()=>$d90d8ce15e0e3233$export$95b5d0bd29a3a076);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", ()=>$d90d8ce15e0e3233$export$d55d4330b58683da);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", ()=>$d90d8ce15e0e3233$export$f4d5833f0b40a26b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", ()=>$d90d8ce15e0e3233$export$c78577545f514ca8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$253eb3db7152d010);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", ()=>$d90d8ce15e0e3233$export$16b4392a63a3eacf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", ()=>$d90d8ce15e0e3233$export$b2d5a7bc804ed9c9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", ()=>$d90d8ce15e0e3233$export$f870832f94ca5009);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b3a1b2e8e954dc2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", ()=>$d90d8ce15e0e3233$export$15603150075c3d64);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", ()=>$d90d8ce15e0e3233$export$92536fe760c41862);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", ()=>$d90d8ce15e0e3233$export$3f4d05032349dae0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", ()=>$d90d8ce15e0e3233$export$8ff94a2e5f98315f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", ()=>$d90d8ce15e0e3233$export$c906c6946fef5d99);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", ()=>$d90d8ce15e0e3233$export$a1916b723e186494);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$5070b4c974017f28);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", ()=>$d90d8ce15e0e3233$export$bee7f9f93cb74124);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", ()=>$d90d8ce15e0e3233$export$efe4008073ab3b69);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", ()=>$d90d8ce15e0e3233$export$9e40228f1c62d4d9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", ()=>$d90d8ce15e0e3233$export$223f8094878fea34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$2f589c572415c043);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", ()=>$d90d8ce15e0e3233$export$8cc394a1f5ca4ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", ()=>$d90d8ce15e0e3233$export$a11311cd333dae90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", ()=>$d90d8ce15e0e3233$export$2b2f159267202dcc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", ()=>$d90d8ce15e0e3233$export$c5a6874288d2e609);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", ()=>$d90d8ce15e0e3233$export$55dd30b027c838fe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$aee9c7dbf672403c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", ()=>$d90d8ce15e0e3233$export$75f2fbd33e76028e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", ()=>$d90d8ce15e0e3233$export$ca57c3dfefb2c826);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$8f2e6f133c022a59);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", ()=>$d90d8ce15e0e3233$export$bcd741cf5a35ece8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", ()=>$d90d8ce15e0e3233$export$bfd8ab4625d5c275);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", ()=>$d90d8ce15e0e3233$export$750a33c4058af733);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", ()=>$d90d8ce15e0e3233$export$1b66c7594340363f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", ()=>$d90d8ce15e0e3233$export$fe2fa966509db649);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", ()=>$d90d8ce15e0e3233$export$373b97e8d136f558);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", ()=>$d90d8ce15e0e3233$export$64909bb6f2181592);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", ()=>$d90d8ce15e0e3233$export$53d6ade2eaa2ae84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", ()=>$d90d8ce15e0e3233$export$e49d7a1ddf301d09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", ()=>$d90d8ce15e0e3233$export$9469cfde1d14fcac);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", ()=>$d90d8ce15e0e3233$export$be2e231547dca6dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", ()=>$d90d8ce15e0e3233$export$ad6f28bbfe57d0a0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", ()=>$d90d8ce15e0e3233$export$2fb73d5c1c0e7186);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", ()=>$d90d8ce15e0e3233$export$46b4f43d6ece38fc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", ()=>$d90d8ce15e0e3233$export$49d1c20d84d46735);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", ()=>$d90d8ce15e0e3233$export$265062715b11a1ef);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", ()=>$d90d8ce15e0e3233$export$e9f5eae9444c9b46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", ()=>$d90d8ce15e0e3233$export$e19bf9459d6eba56);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", ()=>$d90d8ce15e0e3233$export$40097704c31872d8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$dcdf0405aa7e2078);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", ()=>$d90d8ce15e0e3233$export$fb75113636566d39);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", ()=>$d90d8ce15e0e3233$export$e27baa0c7747e67f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", ()=>$d90d8ce15e0e3233$export$40d189100899f572);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$341933b279728599);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ae4b815061537207);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_ACCESS", ()=>$d90d8ce15e0e3233$export$e4fb7ce0fc5e3a75);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", ()=>$d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", ()=>$d90d8ce15e0e3233$export$bee46016693b19dc);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS", ()=>$d90d8ce15e0e3233$export$ca253bc3d237c17f);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT", ()=>$d90d8ce15e0e3233$export$a4cba48257cb118a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", ()=>$d90d8ce15e0e3233$export$2e90ab5aa3463c0d);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$c39a25878c902e0a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS", ()=>$d90d8ce15e0e3233$export$6eaa6ce8101f6468);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", ()=>$d90d8ce15e0e3233$export$d70320ae3b4d9e43);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", ()=>$d90d8ce15e0e3233$export$b2b57cde1fa39bf5);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE", ()=>$d90d8ce15e0e3233$export$e8e3b3a04b70a016);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", ()=>$d90d8ce15e0e3233$export$1a3116351e4f3550);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", ()=>$d90d8ce15e0e3233$export$6e2629d41c380b47);
    $parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", ()=>$d90d8ce15e0e3233$export$ced38e55e6d33a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$d61d16755cb40ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", ()=>$d90d8ce15e0e3233$export$bb6392f1b2e80781);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", ()=>$d90d8ce15e0e3233$export$6fd25e722e91a0d8);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$18f32f825e7a5a6f);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", ()=>$d90d8ce15e0e3233$export$b17f22f274f4cd5e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", ()=>$d90d8ce15e0e3233$export$285854ec33f7cc);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", ()=>$d90d8ce15e0e3233$export$77cf9c44bbdaa05b);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", ()=>$d90d8ce15e0e3233$export$d6f1b92110a16f2a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", ()=>$d90d8ce15e0e3233$export$fea47b97c6086336);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", ()=>$d90d8ce15e0e3233$export$264d0a2b60d052cd);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", ()=>$d90d8ce15e0e3233$export$991ba0c465b48539);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", ()=>$d90d8ce15e0e3233$export$904b472d57dee40d);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", ()=>$d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", ()=>$d90d8ce15e0e3233$export$8cfdaccf43a32440);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", ()=>$d90d8ce15e0e3233$export$37bd400c00057d64);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", ()=>$d90d8ce15e0e3233$export$eb66bd587b5f093d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", ()=>$d90d8ce15e0e3233$export$521baa72494c2a67);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$ca255c93be51d5bc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$51e45f736a60769b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", ()=>$d90d8ce15e0e3233$export$e64c3c8f45d7eb28);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", ()=>$d90d8ce15e0e3233$export$5475ba822739444a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", ()=>$d90d8ce15e0e3233$export$8483f5c57513e386);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", ()=>$d90d8ce15e0e3233$export$93c4d1960660bdb3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", ()=>$d90d8ce15e0e3233$export$a5421dcc88027406);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", ()=>$d90d8ce15e0e3233$export$81d5ef2e5cb06446);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", ()=>$d90d8ce15e0e3233$export$77f5621cd10b53c5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", ()=>$d90d8ce15e0e3233$export$41008c2b014795bf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3001841111579cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", ()=>$d90d8ce15e0e3233$export$28dc2fac9c08502e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", ()=>$d90d8ce15e0e3233$export$4487dfcd6dce7088);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", ()=>$d90d8ce15e0e3233$export$c344587fa7092e8c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", ()=>$d90d8ce15e0e3233$export$3fbd487079a23c0f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$d6822df31c37b21a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", ()=>$d90d8ce15e0e3233$export$d39bcac6fced7707);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", ()=>$d90d8ce15e0e3233$export$da975f212e8a3e43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", ()=>$d90d8ce15e0e3233$export$6e6feddeb62a0825);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", ()=>$d90d8ce15e0e3233$export$d7df906c2ffbeab4);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", ()=>$d90d8ce15e0e3233$export$c71836085985a7d3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", ()=>$d90d8ce15e0e3233$export$a17a19a9de903839);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", ()=>$d90d8ce15e0e3233$export$e66c1e847a52ebb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", ()=>$d90d8ce15e0e3233$export$f0254c80025ed0fc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", ()=>$d90d8ce15e0e3233$export$1d4a64220d5b474d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", ()=>$d90d8ce15e0e3233$export$8af215d394bc18c1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", ()=>$d90d8ce15e0e3233$export$b6b536a795b08b39);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", ()=>$d90d8ce15e0e3233$export$59cde094247fca1a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", ()=>$d90d8ce15e0e3233$export$d27bf19e22921164);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", ()=>$d90d8ce15e0e3233$export$3467807847c0a87d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$1996eeee6a067f1c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", ()=>$d90d8ce15e0e3233$export$ec7cb9394e8994c9);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", ()=>$d90d8ce15e0e3233$export$f01730982626c4af);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", ()=>$d90d8ce15e0e3233$export$9d1758ddc1563e90);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", ()=>$d90d8ce15e0e3233$export$ecff223feb9d08be);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$487bc26cddb34312);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$118290072826cd87);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", ()=>$d90d8ce15e0e3233$export$e5994b7b1acebe82);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$84b0e53f785e02cf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$d58992a667105ce8);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$bb1cea2d23743f65);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$76dac5f55ab3705e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$a7c4adb03bc6e997);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2dc565d0b2334780);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", ()=>$d90d8ce15e0e3233$export$28687a1181a7676f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$2e74a7026073fa54);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$58fdfc78d176c564);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", ()=>$d90d8ce15e0e3233$export$cb8548f16119b181);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$66e3f6af203a567f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", ()=>$d90d8ce15e0e3233$export$658e7e21f1c7b69b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", ()=>$d90d8ce15e0e3233$export$1fa628a4527d424c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$c2989c5c00f9f64b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$2d21e5416485b195);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", ()=>$d90d8ce15e0e3233$export$e514491aa85dd54a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", ()=>$d90d8ce15e0e3233$export$d9662297242bfcb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", ()=>$d90d8ce15e0e3233$export$2a53516b15393945);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", ()=>$d90d8ce15e0e3233$export$62e00190aa938a43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", ()=>$d90d8ce15e0e3233$export$22a3924a6eab79ab);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", ()=>$d90d8ce15e0e3233$export$677cf3d89d18bb74);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", ()=>$d90d8ce15e0e3233$export$7eef86163449ad98);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", ()=>$d90d8ce15e0e3233$export$8f56061e1403fa5a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", ()=>$d90d8ce15e0e3233$export$adeb429de8df1e02);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", ()=>$d90d8ce15e0e3233$export$931d6222073b5708);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", ()=>$d90d8ce15e0e3233$export$2106f1ac8ba807e1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", ()=>$d90d8ce15e0e3233$export$36678521a86f620b);
    $parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", ()=>$d90d8ce15e0e3233$export$55248356780fc584);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", ()=>$d90d8ce15e0e3233$export$cd84c5a333c8d16a);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", ()=>$d90d8ce15e0e3233$export$624af6f61b05f55);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", ()=>$d90d8ce15e0e3233$export$2ed9525182145b82);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", ()=>$d90d8ce15e0e3233$export$7fb2b42fc4e7df8b);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", ()=>$d90d8ce15e0e3233$export$fa962db82ae571b2);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", ()=>$d90d8ce15e0e3233$export$e145bf76b1aef705);
    $parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", ()=>$d90d8ce15e0e3233$export$8febbfb647e4c8b9);
    $parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", ()=>$d90d8ce15e0e3233$export$4b34f3d336f4ccd2);
    $parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", ()=>$d90d8ce15e0e3233$export$a979a5c1f5e3631c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$ffcbf91dfadffd0);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", ()=>$d90d8ce15e0e3233$export$1807a39cc63b856c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$2be8d3c6fedd5276);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$6268da7263eb670d);
    $parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$93bd4a896a0fc581);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", ()=>$d90d8ce15e0e3233$export$2b9b1bfb538ab810);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", ()=>$d90d8ce15e0e3233$export$d1217085321b2648);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", ()=>$d90d8ce15e0e3233$export$39624171b7c8a10a);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", ()=>$d90d8ce15e0e3233$export$1654cd6813e90e6b);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$33059cd02df2febd);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", ()=>$d90d8ce15e0e3233$export$1d746ff2bc48ceb4);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", ()=>$d90d8ce15e0e3233$export$145c578104a45fd2);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", ()=>$d90d8ce15e0e3233$export$a51df1bc877c58e5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", ()=>$d90d8ce15e0e3233$export$45208fff8de46880);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", ()=>$d90d8ce15e0e3233$export$c710a35d40378fa5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", ()=>$d90d8ce15e0e3233$export$15d6b93ff5273ce3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", ()=>$d90d8ce15e0e3233$export$e26f2863c7ccd504);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", ()=>$d90d8ce15e0e3233$export$496da9aa0fe819ff);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", ()=>$d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$53ce69fb34f6d286);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", ()=>$d90d8ce15e0e3233$export$b6e861786143eb1b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", ()=>$d90d8ce15e0e3233$export$f7e3d3b413c017e1);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", ()=>$d90d8ce15e0e3233$export$b84d34b8175abde5);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", ()=>$d90d8ce15e0e3233$export$50e4e3e5231fb74f);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", ()=>$d90d8ce15e0e3233$export$39d913ae557ba8f3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a2d9bcceac584c93);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$eb2e5f1608ec8b32);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ac90b948c53bf58);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$bb5665894498893f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT", ()=>$d90d8ce15e0e3233$export$dd4c319b26f01664);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$a934caa57ac0ac0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$25a4e6c77f91c259);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", ()=>$d90d8ce15e0e3233$export$2a9a9bab313fd713);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$82ad2da638fc34d8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$ff67cffdbd881a41);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", ()=>$d90d8ce15e0e3233$export$c41c7d73df3fc08c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL", ()=>$d90d8ce15e0e3233$export$f07fd5696f888ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$ff1365ce4d652337);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", ()=>$d90d8ce15e0e3233$export$79b30013cbfdee04);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", ()=>$d90d8ce15e0e3233$export$33c2dcc7c7abc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", ()=>$d90d8ce15e0e3233$export$a6ef20aa08a533b1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", ()=>$d90d8ce15e0e3233$export$5908e15483da8a45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", ()=>$d90d8ce15e0e3233$export$a3812f6f4e60d897);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$3c8c119f40a061a9);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", ()=>$d90d8ce15e0e3233$export$47e034646abefdb2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", ()=>$d90d8ce15e0e3233$export$f36f4cf8b17f250f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$841e880a0d425b3e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", ()=>$d90d8ce15e0e3233$export$1fde4a6e7df24a97);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$69335bf8b709edc7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$946b472f7559a889);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", ()=>$d90d8ce15e0e3233$export$373fdf6888021ed0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$d6a5f13a3d30923c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", ()=>$d90d8ce15e0e3233$export$adfff93b0b015409);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", ()=>$d90d8ce15e0e3233$export$404de4ddea701cff);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$596e1f6f6f4997b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$d610a17dff3a01fa);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$284db5107f3db516);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", ()=>$d90d8ce15e0e3233$export$fbce46826eefc586);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", ()=>$d90d8ce15e0e3233$export$c86b29c76317ac6f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$3160b86e1b5dc391);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$690c0080c930fca);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", ()=>$d90d8ce15e0e3233$export$171ba8c33c05c4ef);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$e2f2c23286c3255c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$5a262d40e10207a1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$ab790cb87175797e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$db780b39656c673a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", ()=>$d90d8ce15e0e3233$export$a77cb4dafc511d3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$253fd82874264ee4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", ()=>$d90d8ce15e0e3233$export$eaf9ab4ec0c25813);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$574bcdf6b73fcf1f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", ()=>$d90d8ce15e0e3233$export$a14853dfff8da872);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba8fd0e6db8d3e08);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$1c74da1e52e6d212);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$d416059b17fe7d4e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", ()=>$d90d8ce15e0e3233$export$d5a3a037d2760bb7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", ()=>$d90d8ce15e0e3233$export$eb187d42a7448d45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", ()=>$d90d8ce15e0e3233$export$688de32d31fc70f5);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$13d770f8814d480a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$3a628f9376166ffb);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$649dafa225625f30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$dbfe76dd37018b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$20db7bb9d1bd8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$a1fa8e6e125780ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$fc6b949fd2bc782d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$c940f866ac7760a0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$184d4979f6f9fe7e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$959f50de166cc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$b13b8c8bb4e30a75);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", ()=>$d90d8ce15e0e3233$export$40d6fc2b9a4f09d2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$cc1af211e3feda50);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3873539001f5aed7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", ()=>$d90d8ce15e0e3233$export$89fcbafce559080b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", ()=>$d90d8ce15e0e3233$export$c3f05da9e4e13249);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", ()=>$d90d8ce15e0e3233$export$619694ab37142384);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", ()=>$d90d8ce15e0e3233$export$cb89b516b9cf418b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", ()=>$d90d8ce15e0e3233$export$50680f54e95bb859);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$194c2b4da7e38757);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", ()=>$d90d8ce15e0e3233$export$962d838817f090f8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", ()=>$d90d8ce15e0e3233$export$eacbdb340a470309);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", ()=>$d90d8ce15e0e3233$export$6a7782d87a21425d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", ()=>$d90d8ce15e0e3233$export$c2f56336162e799e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba419378ad70624e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$62f38c589a73d386);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", ()=>$d90d8ce15e0e3233$export$77c8066c0822f152);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", ()=>$d90d8ce15e0e3233$export$90900ebfa6f48861);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$93ff02c205edd1a8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$db7f5d93be70ee30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$432229516b7f82da);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$8f554d4ef9f084c0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", ()=>$d90d8ce15e0e3233$export$6b2b99b0055772a3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$83c7a51057be6264);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", ()=>$d90d8ce15e0e3233$export$46706d786aab3829);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", ()=>$d90d8ce15e0e3233$export$b690025ef7e3cf6c);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", ()=>$d90d8ce15e0e3233$export$ea48cc6bf1183d11);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", ()=>$d90d8ce15e0e3233$export$930e4881302bbd54);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$375801b708576466);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", ()=>$d90d8ce15e0e3233$export$5b1e8463bd590143);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$1606662a398a24be);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$c5b19a37e49ceb28);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", ()=>$d90d8ce15e0e3233$export$c46680afe70295f3);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", ()=>$d90d8ce15e0e3233$export$831fc7eba98b58c9);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", ()=>$d90d8ce15e0e3233$export$4061c0c586f3b7c8);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", ()=>$d90d8ce15e0e3233$export$99e0abd8ba1de289);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", ()=>$d90d8ce15e0e3233$export$cd96a6a0cc4831ab);
    $parcel$export(module.exports, "ROUTE_NAMES_ROVO_DEMAND_TESTS", ()=>$d90d8ce15e0e3233$export$36e61e70347174cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SANDBOX_BUNDLER", ()=>$d90d8ce15e0e3233$export$3bddd65f2541c4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", ()=>$d90d8ce15e0e3233$export$db1b3d2fee80859);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$b0f3f3214ab1b150);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", ()=>$d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", ()=>$d90d8ce15e0e3233$export$8c8f03e75b6708ac);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", ()=>$d90d8ce15e0e3233$export$3c3d8caf61c9aa0c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", ()=>$d90d8ce15e0e3233$export$f9cc808094ce0ddd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$9bde4a0b155f2972);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", ()=>$d90d8ce15e0e3233$export$a52f5ffbbe135078);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$e6773bf0fbccdb9c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$8e3dd8487a7b65bd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$258b44fcc29a5961);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", ()=>$d90d8ce15e0e3233$export$ea1146ebce07be6d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$53731240ce2d3b76);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$956eb40834ddee22);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", ()=>$d90d8ce15e0e3233$export$9057470ebf41169);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", ()=>$d90d8ce15e0e3233$export$c42e107c5275b36);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", ()=>$d90d8ce15e0e3233$export$3e7c6a54a9d2267a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", ()=>$d90d8ce15e0e3233$export$c3e2697b35a149c4);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", ()=>$d90d8ce15e0e3233$export$288c7dd61dd0c291);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$37161a981d69c891);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$cfe61aa92a4d585d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ed512ab4c81669c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$37a9bdd8513f462d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$f01162415f3a2ee3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", ()=>$d90d8ce15e0e3233$export$860dd13b1e836ed8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", ()=>$d90d8ce15e0e3233$export$5eaf1dce55090ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", ()=>$d90d8ce15e0e3233$export$1fe309e7cdbd1c1);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", ()=>$d90d8ce15e0e3233$export$fcd9750494ff0236);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", ()=>$d90d8ce15e0e3233$export$ad856b38e93b93b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", ()=>$d90d8ce15e0e3233$export$a833209ca71d2e56);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", ()=>$d90d8ce15e0e3233$export$829d1776460a6ad3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", ()=>$d90d8ce15e0e3233$export$d30ab2da08d8b7b9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", ()=>$d90d8ce15e0e3233$export$3c71889849aeaa08);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", ()=>$d90d8ce15e0e3233$export$354bf2df81f6ffb0);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", ()=>$d90d8ce15e0e3233$export$f8880b461acd270d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$876055c0ede2f8df);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", ()=>$d90d8ce15e0e3233$export$bf493c66e34711c8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", ()=>$d90d8ce15e0e3233$export$212f6e2c7c2a53bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$7c28c6e8d8a6545);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", ()=>$d90d8ce15e0e3233$export$8d55b6ef2cd92f8c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$f7fbe9a4717b7a50);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", ()=>$d90d8ce15e0e3233$export$8c800f176d079d28);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", ()=>$d90d8ce15e0e3233$export$1c5fbcbfc0923176);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$59644e5d8d69a016);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", ()=>$d90d8ce15e0e3233$export$c7074ebe0ca83f98);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", ()=>$d90d8ce15e0e3233$export$2b4737953287a354);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", ()=>$d90d8ce15e0e3233$export$e7a8d6d534c5e2fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$5dcba309e2bfa88b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", ()=>$d90d8ce15e0e3233$export$2d961b0101f8733e);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", ()=>$d90d8ce15e0e3233$export$195fe2558f1a8591);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", ()=>$d90d8ce15e0e3233$export$1b3cf68be370a45b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$45c35381e5da2232);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", ()=>$d90d8ce15e0e3233$export$d479ba53b9bf65a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", ()=>$d90d8ce15e0e3233$export$ccd12890649c59cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", ()=>$d90d8ce15e0e3233$export$8c84064031188e80);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$46c6fef035fbe8ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", ()=>$d90d8ce15e0e3233$export$6fb23ec5a12d5c24);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", ()=>$d90d8ce15e0e3233$export$156b2dfbd87d576f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", ()=>$d90d8ce15e0e3233$export$6961f1ed0407cb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$ba284efd679bf637);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", ()=>$d90d8ce15e0e3233$export$e48a3df597407767);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", ()=>$d90d8ce15e0e3233$export$c73718d4a6efea1d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", ()=>$d90d8ce15e0e3233$export$ed454783ba1bacb9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$48f6285d4729ca9d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", ()=>$d90d8ce15e0e3233$export$8066418cead2d2ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", ()=>$d90d8ce15e0e3233$export$b3db7857ac710a89);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$d574810e3edad044);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", ()=>$d90d8ce15e0e3233$export$be4b2ffade787316);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", ()=>$d90d8ce15e0e3233$export$3caf79b5f4be02d7);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", ()=>$d90d8ce15e0e3233$export$29bc361328055683);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", ()=>$d90d8ce15e0e3233$export$a4a5a333fe874d97);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", ()=>$d90d8ce15e0e3233$export$2193b681ac1ae132);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$f1bfd5b3918619a9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$a4c4f7898d6b914a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", ()=>$d90d8ce15e0e3233$export$6cffae90b9277bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$17e76ebd53424ed5);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", ()=>$d90d8ce15e0e3233$export$b1329dc26a81a277);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", ()=>$d90d8ce15e0e3233$export$e1cba0bfe330f5c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", ()=>$d90d8ce15e0e3233$export$8e68c55c334de101);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", ()=>$d90d8ce15e0e3233$export$5cb7cfba189a0240);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$d28aab4a6d6f1d0d);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$1cf56e2d6c4edb35);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", ()=>$d90d8ce15e0e3233$export$27c1770584d7e3fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", ()=>$d90d8ce15e0e3233$export$22e0ebdea08537f7);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", ()=>$d90d8ce15e0e3233$export$4db732436e4edfaf);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$e832418dbed0717e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", ()=>$d90d8ce15e0e3233$export$ee09be798f0e4471);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", ()=>$d90d8ce15e0e3233$export$653bf90ae3578f21);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", ()=>$d90d8ce15e0e3233$export$9da4125a0c62444d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", ()=>$d90d8ce15e0e3233$export$fbcc0fd9b402bb12);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$e74fe5bd41e23fbd);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", ()=>$d90d8ce15e0e3233$export$1a93e63ddbe4aa06);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", ()=>$d90d8ce15e0e3233$export$3b6dbbe49882589d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", ()=>$d90d8ce15e0e3233$export$eb01394789016fd4);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", ()=>$d90d8ce15e0e3233$export$f17f4523583fa8e5);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$eaa4d6eec75a6778);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", ()=>$d90d8ce15e0e3233$export$dcc96e4abbdc0d39);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", ()=>$d90d8ce15e0e3233$export$9eaf39ba5a56c72a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$495be3320b67814a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$25752eb5bb5e3d32);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", ()=>$d90d8ce15e0e3233$export$f116716aedb35e10);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", ()=>$d90d8ce15e0e3233$export$36fffb6b49d9f31d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", ()=>$d90d8ce15e0e3233$export$a6d07be4ff318f84);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$a9a43f1114df1ad9);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$3a4c7a521a900b4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", ()=>$d90d8ce15e0e3233$export$9dcf51a9040a4fd6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", ()=>$d90d8ce15e0e3233$export$a74f9f6bd0d4fb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", ()=>$d90d8ce15e0e3233$export$f8cb86acf6b74661);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", ()=>$d90d8ce15e0e3233$export$2d3d850c64058bfb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", ()=>$d90d8ce15e0e3233$export$af6b51164f66908b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$12efc96fc9c9fb34);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", ()=>$d90d8ce15e0e3233$export$6ab1901e04e623ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", ()=>$d90d8ce15e0e3233$export$bccc7d0812737c4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$458fb992f2637a20);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9c9c64f68ba51e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$50264cbc90a39f19);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", ()=>$d90d8ce15e0e3233$export$b9d0cbe0888fa72e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", ()=>$d90d8ce15e0e3233$export$b8045610416fa8ca);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", ()=>$d90d8ce15e0e3233$export$8e80136ad13099e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", ()=>$d90d8ce15e0e3233$export$b5fe44c0bc324494);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$7a4f52d9060a20d2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$d6a9e4695952522e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", ()=>$d90d8ce15e0e3233$export$deab88d0814c564b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", ()=>$d90d8ce15e0e3233$export$906faff110f898ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$ab3f2a34a3b0db87);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$4ed84a2011fdc400);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", ()=>$d90d8ce15e0e3233$export$f7b286b39bf6051b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$6c4337c0332c8c7f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$e7c78887745b2326);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", ()=>$d90d8ce15e0e3233$export$3805e4f07dca7584);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", ()=>$d90d8ce15e0e3233$export$f77254983320e888);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", ()=>$d90d8ce15e0e3233$export$2e784832f1c6bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$7f97fa79520a4c5b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$9e53cdb1ac02195c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED", ()=>$d90d8ce15e0e3233$export$58bd507904dc221c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", ()=>$d90d8ce15e0e3233$export$7a821e22be2c2f14);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", ()=>$d90d8ce15e0e3233$export$ca8966ef80bfafc6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", ()=>$d90d8ce15e0e3233$export$e7423156dba31a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", ()=>$d90d8ce15e0e3233$export$cba7e383b2409c7b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", ()=>$d90d8ce15e0e3233$export$d5378fb71d5242c0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$4b16b72c72da8833);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", ()=>$d90d8ce15e0e3233$export$10114d78cefb1f53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", ()=>$d90d8ce15e0e3233$export$92fe23ed30100817);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", ()=>$d90d8ce15e0e3233$export$e824495554c83069);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$8df2e9efdd625a44);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", ()=>$d90d8ce15e0e3233$export$aeb4d3006e298033);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", ()=>$d90d8ce15e0e3233$export$e15d3c40985c4b53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", ()=>$d90d8ce15e0e3233$export$1d8c84454fd2d571);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", ()=>$d90d8ce15e0e3233$export$db61a12efb59745c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", ()=>$d90d8ce15e0e3233$export$2da67fb5bd6bc2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", ()=>$d90d8ce15e0e3233$export$182e0167fd960de6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d9e2484ee02e7da);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$b7fff19fd89b617f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", ()=>$d90d8ce15e0e3233$export$ea23f150f64e8a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", ()=>$d90d8ce15e0e3233$export$116338bd93f78ad0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$c9cd65a78227cf18);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", ()=>$d90d8ce15e0e3233$export$d75d93e5d44182cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", ()=>$d90d8ce15e0e3233$export$cc3027ae3767801);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", ()=>$d90d8ce15e0e3233$export$3492ce83b8884e0e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", ()=>$d90d8ce15e0e3233$export$b4798b7e62733393);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", ()=>$d90d8ce15e0e3233$export$388685c701d6e0d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", ()=>$d90d8ce15e0e3233$export$5ff4d2d4257ea2b0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", ()=>$d90d8ce15e0e3233$export$fa83895c1eac55e7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", ()=>$d90d8ce15e0e3233$export$5c82bb95a06a1846);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", ()=>$d90d8ce15e0e3233$export$c725b9c7e11dd69e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", ()=>$d90d8ce15e0e3233$export$90594f89c675ba05);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", ()=>$d90d8ce15e0e3233$export$ae0d999dd2bdd59b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", ()=>$d90d8ce15e0e3233$export$296115eb5b7129d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", ()=>$d90d8ce15e0e3233$export$17574f41c3925d64);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", ()=>$d90d8ce15e0e3233$export$955692fbfe35fc16);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", ()=>$d90d8ce15e0e3233$export$30af3a767b8ad2d8);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", ()=>$d90d8ce15e0e3233$export$f47d664298c2c2f0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d1ed852d9885250);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC", ()=>$d90d8ce15e0e3233$export$312796fc15876480);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", ()=>$d90d8ce15e0e3233$export$1714b5ad9b672bc7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9634bf15518a3a1);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", ()=>$d90d8ce15e0e3233$export$3b5eb3ea8cbeeed);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED", ()=>$d90d8ce15e0e3233$export$118bb1785acc3d0b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$c29d90ae9a4b648e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", ()=>$d90d8ce15e0e3233$export$8f2717a951373c25);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$831acb5098f5706d);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$d218cda46c433fe1);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$61147168ac2833f9);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$9fe0117c0fd486a8);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$a49474778d15635d);
    $parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", ()=>$d90d8ce15e0e3233$export$af3296e54e7fb362);
    $parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", ()=>$d90d8ce15e0e3233$export$281f2e01ee9e4977);
    const $d90d8ce15e0e3233$export$dda94bb6f1904d59 = 'support-center-settings';
    const $d90d8ce15e0e3233$export$1ba937db1fe6ef01 = 'archive-issues';
    const $d90d8ce15e0e3233$export$3fd002e197e83a30 = 'arj-settings';
    const $d90d8ce15e0e3233$export$bbf08d4d25df5504 = 'classic-business';
    const $d90d8ce15e0e3233$export$e3e759b7f50aaee1 = 'classic-software';
    const $d90d8ce15e0e3233$export$89337611b52bc9a3 = 'components';
    const $d90d8ce15e0e3233$export$3d7937b12eb9e5d5 = 'connect';
    const $d90d8ce15e0e3233$export$7a3d181d86fce9e6 = 'dashboard';
    const $d90d8ce15e0e3233$export$294c878a3842c859 = 'dashboards';
    const $d90d8ce15e0e3233$export$7a22726acd7d6021 = 'devops';
    const $d90d8ce15e0e3233$export$f3f4a9f53ba00861 = 'directories';
    const $d90d8ce15e0e3233$export$112d69653b2f1d8b = 'eoc';
    const $d90d8ce15e0e3233$export$74e0426b66571086 = 'errors';
    const $d90d8ce15e0e3233$export$c2e20e142c95c1ce = 'global-settings';
    const $d90d8ce15e0e3233$export$f8cea29bebf098c = 'helpcenter-settings';
    const $d90d8ce15e0e3233$export$5801ef8dfc9a2f70 = 'home';
    const $d90d8ce15e0e3233$export$7246838143f848f3 = 'issue';
    const $d90d8ce15e0e3233$export$54f96702980a2f87 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$5566db8fbd042fc4 = 'legacy';
    const $d90d8ce15e0e3233$export$20344ad17b5fca86 = 'legacy-jsd-settings';
    const $d90d8ce15e0e3233$export$656d0cc2c67b2708 = 'marketplace';
    const $d90d8ce15e0e3233$export$bfdbcebc4c81b043 = 'people-profiles';
    const $d90d8ce15e0e3233$export$82021d71ad19e227 = 'personal-settings';
    const $d90d8ce15e0e3233$export$6f266218a6973848 = 'plan-settings';
    const $d90d8ce15e0e3233$export$a846fcaeeea8e0ff = 'polaris';
    const $d90d8ce15e0e3233$export$6c87a9dff4e7a2de = 'proforma';
    const $d90d8ce15e0e3233$export$ab79970dcfac06a1 = 'project-settings-classic';
    const $d90d8ce15e0e3233$export$d1a70f80bb22f18a = 'project-settings-core';
    const $d90d8ce15e0e3233$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
    const $d90d8ce15e0e3233$export$86509a1baabd62ee = 'project-settings-software';
    const $d90d8ce15e0e3233$export$98823ed9eedfc756 = 'project-settings-software-boards';
    const $d90d8ce15e0e3233$export$da8d13fe1ccd5c09 = 'redirects';
    const $d90d8ce15e0e3233$export$e46610825208f0d8 = 'sandbox';
    const $d90d8ce15e0e3233$export$78fb2f6176b7c6b8 = 'servicedesk';
    const $d90d8ce15e0e3233$export$d4a2a2e87da2135a = 'services';
    const $d90d8ce15e0e3233$export$26efaec7a7a8b361 = 'software';
    const $d90d8ce15e0e3233$export$db781fb68c08f7e2 = 'versions';
    const $d90d8ce15e0e3233$export$89c26097a5edf8cb = 'agent-studio';
    const $d90d8ce15e0e3233$export$88041353cc69458d = 'archived-issues-directory';
    const $d90d8ce15e0e3233$export$f88d57dcb03ba452 = 'archived-plans-directory';
    const $d90d8ce15e0e3233$export$e8aa63af071c2da9 = 'archived-projects-directory';
    const $d90d8ce15e0e3233$export$b114d0da2ebcff6c = 'archived-project-direct-link';
    const $d90d8ce15e0e3233$export$29cc94b8cea5c920 = 'boards-directory';
    const $d90d8ce15e0e3233$export$4d1b45005cdcfb39 = 'browse-project-redirect';
    const $d90d8ce15e0e3233$export$a42ea04fdf53eeaf = 'next-gen-business-board';
    const $d90d8ce15e0e3233$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
    const $d90d8ce15e0e3233$export$d58a5411a2ac6260 = 'next-gen-business-reports';
    const $d90d8ce15e0e3233$export$24514ee19772b5af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-onboarding-get-started`;
    const $d90d8ce15e0e3233$export$ec333dd1d6a8b38 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-calendar`;
    const $d90d8ce15e0e3233$export$ed495fbad44791af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-redirect`;
    const $d90d8ce15e0e3233$export$5281552f8109b7c0 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-summary`;
    const $d90d8ce15e0e3233$export$6e8473713ed4557a = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-timeline`;
    const $d90d8ce15e0e3233$export$cbdd5c24d69b2cb1 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-approvals`;
    const $d90d8ce15e0e3233$export$e7f012f402be01ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-attachments`;
    const $d90d8ce15e0e3233$export$b34d3882b42d660d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board`;
    const $d90d8ce15e0e3233$export$ed869c60c6a56182 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board-embed`;
    const $d90d8ce15e0e3233$export$5013269f29c75b37 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar`;
    const $d90d8ce15e0e3233$export$fc8b48319e993d43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar-embed`;
    const $d90d8ce15e0e3233$export$40903feb5b038923 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-files`;
    const $d90d8ce15e0e3233$export$d6e60a2059f028d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form`;
    const $d90d8ce15e0e3233$export$3d589aae17a00bc9 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-builder`;
    const $d90d8ce15e0e3233$export$bd92ef03b23dd672 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit`;
    const $d90d8ce15e0e3233$export$fa7fc44c718fc850 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit-embed`;
    const $d90d8ce15e0e3233$export$1dffaf831e01e2b4 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list`;
    const $d90d8ce15e0e3233$export$5f8187412dd60f35 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list-embed`;
    const $d90d8ce15e0e3233$export$3d2c1c04d18f6c43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-sample-onboarding`;
    const $d90d8ce15e0e3233$export$cd22a5d8f560a1d8 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-shortcut`;
    const $d90d8ce15e0e3233$export$cad1b1aa5ce26bbc = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary`;
    const $d90d8ce15e0e3233$export$ee073463b4144367 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary-embed`;
    const $d90d8ce15e0e3233$export$ea034943499772ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline`;
    const $d90d8ce15e0e3233$export$19bc888bcf37d22d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline-embed`;
    const $d90d8ce15e0e3233$export$e0746183e11767fb = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-redirect`;
    const $d90d8ce15e0e3233$export$3e2d215ce157adc8 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-code`;
    const $d90d8ce15e0e3233$export$8a8485bb05daf40b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a2799b01de5bb62 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-data-classifications`;
    const $d90d8ce15e0e3233$export$1bc2b66dcb07293a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$2d4f89c4b1ee3640 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-features`;
    const $d90d8ce15e0e3233$export$75609d3416c31f79 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-issue-layout`;
    const $d90d8ce15e0e3233$export$79793dc26e0b7b1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$2eda7466fbfdef43 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$417297669917ee1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$8c79f3309ac0737 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications`;
    const $d90d8ce15e0e3233$export$ef71a22e7befd35c = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$62ba1e294f5007c1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-edit-forms`;
    const $d90d8ce15e0e3233$export$a4315324546ecc89 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a653cf6d478b3df1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-company-managed`;
    const $d90d8ce15e0e3233$export$b0f268fe53a03e98 = 'compass-product-settings';
    const $d90d8ce15e0e3233$export$f4160b48e4ab8f39 = 'confluence-product-settings';
    const $d90d8ce15e0e3233$export$608f359cf8b08d2e = 'connect-general';
    const $d90d8ce15e0e3233$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
    const $d90d8ce15e0e3233$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
    const $d90d8ce15e0e3233$export$bd2506db44585db6 = 'connect-project';
    const $d90d8ce15e0e3233$export$200fa5ad16f8c112 = 'create-project';
    const $d90d8ce15e0e3233$export$21702f145fe1bbb0 = 'customer-service-accounts';
    const $d90d8ce15e0e3233$export$a296bb962bea95b5 = 'dashboard';
    const $d90d8ce15e0e3233$export$b9960c143c0414eb = 'dashboards-directory';
    const $d90d8ce15e0e3233$export$411171d2fcaefaea = 'dashboards-directory-secure';
    const $d90d8ce15e0e3233$export$ee104ed514f63003 = 'dashboard-edit';
    const $d90d8ce15e0e3233$export$9233f9ddcecd3062 = 'dashboard-selected';
    const $d90d8ce15e0e3233$export$b3240ec044a6c70f = 'dashboard-view';
    const $d90d8ce15e0e3233$export$2463c779e12367e3 = 'dashboard-view-embed';
    const $d90d8ce15e0e3233$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
    const $d90d8ce15e0e3233$export$38ca7e07048a5bfd = 'devops-connected-project';
    const $d90d8ce15e0e3233$export$a9044bbb0247378d = 'eoc-alerts';
    const $d90d8ce15e0e3233$export$ae7376e552380ac0 = 'eoc-alert-detail';
    const $d90d8ce15e0e3233$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$54ed2374d14a7e88 = 'eoc-api-key-management';
    const $d90d8ce15e0e3233$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
    const $d90d8ce15e0e3233$export$bbb4032f8f259109 = 'eoc-automations';
    const $d90d8ce15e0e3233$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
    const $d90d8ce15e0e3233$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
    const $d90d8ce15e0e3233$export$5126a481501fc518 = 'eoc-global-alert-detail';
    const $d90d8ce15e0e3233$export$40e720d8c26e6804 = 'eoc-global-group-detail';
    const $d90d8ce15e0e3233$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
    const $d90d8ce15e0e3233$export$8ca3e3f0326ba27f = 'eoc-global-reports';
    const $d90d8ce15e0e3233$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
    const $d90d8ce15e0e3233$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
    const $d90d8ce15e0e3233$export$99f769b27f537a72 = 'eoc-incoming-call';
    const $d90d8ce15e0e3233$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
    const $d90d8ce15e0e3233$export$901b974cf0954c88 = 'eoc-integrations';
    const $d90d8ce15e0e3233$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
    const $d90d8ce15e0e3233$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
    const $d90d8ce15e0e3233$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
    const $d90d8ce15e0e3233$export$a22387b9744e62e3 = 'eoc-integration-log';
    const $d90d8ce15e0e3233$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
    const $d90d8ce15e0e3233$export$e6de4aa6c719d2b = 'eoc-on-call';
    const $d90d8ce15e0e3233$export$b195ada84b7e695f = `${$d90d8ce15e0e3233$export$e6de4aa6c719d2b}-redirect`;
    const $d90d8ce15e0e3233$export$1800d32171b754a6 = 'eoc-overview';
    const $d90d8ce15e0e3233$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
    const $d90d8ce15e0e3233$export$a9a41c76994b6ae9 = 'eoc-permissions';
    const $d90d8ce15e0e3233$export$5bd6f2569c3cfd5c = 'eoc-policies';
    const $d90d8ce15e0e3233$export$dc70eff53ff26c70 = 'eoc-reports';
    const $d90d8ce15e0e3233$export$1fe2ca96b360df19 = 'eoc-reports-team';
    const $d90d8ce15e0e3233$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
    const $d90d8ce15e0e3233$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
    const $d90d8ce15e0e3233$export$a0d9033eb64fd80f = 'eoc-schedules';
    const $d90d8ce15e0e3233$export$4c2fd998d73d2b83 = 'eoc-global-escalations';
    const $d90d8ce15e0e3233$export$c4531cbbea51b6a1 = 'eoc-settings';
    const $d90d8ce15e0e3233$export$da985e953465731f = 'eoc-team-alerts';
    const $d90d8ce15e0e3233$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
    const $d90d8ce15e0e3233$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
    const $d90d8ce15e0e3233$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
    const $d90d8ce15e0e3233$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
    const $d90d8ce15e0e3233$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
    const $d90d8ce15e0e3233$export$bdd811277711c53d = 'eoc-team-integration-create';
    const $d90d8ce15e0e3233$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
    const $d90d8ce15e0e3233$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
    const $d90d8ce15e0e3233$export$a4eff769c94da831 = 'eoc-team-integration-log';
    const $d90d8ce15e0e3233$export$7c928ca9c9822772 = 'eoc-team-policies';
    const $d90d8ce15e0e3233$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
    const $d90d8ce15e0e3233$export$20649eac204f7661 = 'eoc-who-is-on-call';
    const $d90d8ce15e0e3233$export$62170875a111d729 = 'errors-not-found';
    const $d90d8ce15e0e3233$export$2928f3d69e7ac609 = 'external-import';
    const $d90d8ce15e0e3233$export$259e18cafd820487 = 'filters-directory';
    const $d90d8ce15e0e3233$export$4b8f333757e638a4 = 'filters-directory-secure';
    const $d90d8ce15e0e3233$export$ac4f65a14002f892 = 'forge-spa-admin';
    const $d90d8ce15e0e3233$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
    const $d90d8ce15e0e3233$export$7ad826b482229119 = 'forge-spa-field-context-config';
    const $d90d8ce15e0e3233$export$3df864df9b639033 = 'forge-spa-global';
    const $d90d8ce15e0e3233$export$7d67bf4077ebe18d = 'forge-spa-project';
    const $d90d8ce15e0e3233$export$d025408d02e64fb9 = 'forge-spa-personal-settings';
    const $d90d8ce15e0e3233$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
    const $d90d8ce15e0e3233$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
    const $d90d8ce15e0e3233$export$eadf5aff28def565 = 'global-issue-navigator';
    const $d90d8ce15e0e3233$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
    const $d90d8ce15e0e3233$export$1bf439327974644b = 'global-mail-settings';
    const $d90d8ce15e0e3233$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
    const $d90d8ce15e0e3233$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
    const $d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
    const $d90d8ce15e0e3233$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
    const $d90d8ce15e0e3233$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
    const $d90d8ce15e0e3233$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
    const $d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
    const $d90d8ce15e0e3233$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
    const $d90d8ce15e0e3233$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
    const $d90d8ce15e0e3233$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
    const $d90d8ce15e0e3233$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
    const $d90d8ce15e0e3233$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
    const $d90d8ce15e0e3233$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
    const $d90d8ce15e0e3233$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
    const $d90d8ce15e0e3233$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
    const $d90d8ce15e0e3233$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
    const $d90d8ce15e0e3233$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
    const $d90d8ce15e0e3233$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
    const $d90d8ce15e0e3233$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
    const $d90d8ce15e0e3233$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
    const $d90d8ce15e0e3233$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
    const $d90d8ce15e0e3233$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
    const $d90d8ce15e0e3233$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
    const $d90d8ce15e0e3233$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
    const $d90d8ce15e0e3233$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
    const $d90d8ce15e0e3233$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
    const $d90d8ce15e0e3233$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
    const $d90d8ce15e0e3233$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
    const $d90d8ce15e0e3233$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
    const $d90d8ce15e0e3233$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
    const $d90d8ce15e0e3233$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
    const $d90d8ce15e0e3233$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
    const $d90d8ce15e0e3233$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
    const $d90d8ce15e0e3233$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
    const $d90d8ce15e0e3233$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
    const $d90d8ce15e0e3233$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
    const $d90d8ce15e0e3233$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
    const $d90d8ce15e0e3233$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
    const $d90d8ce15e0e3233$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
    const $d90d8ce15e0e3233$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
    const $d90d8ce15e0e3233$export$7dd4b916600f670 = 'global-settings-issues-priorities';
    const $d90d8ce15e0e3233$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
    const $d90d8ce15e0e3233$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
    const $d90d8ce15e0e3233$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
    const $d90d8ce15e0e3233$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
    const $d90d8ce15e0e3233$export$691d30818c14141c = 'global-settings-issues-resolutions';
    const $d90d8ce15e0e3233$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
    const $d90d8ce15e0e3233$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
    const $d90d8ce15e0e3233$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
    const $d90d8ce15e0e3233$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
    const $d90d8ce15e0e3233$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
    const $d90d8ce15e0e3233$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
    const $d90d8ce15e0e3233$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
    const $d90d8ce15e0e3233$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
    const $d90d8ce15e0e3233$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
    const $d90d8ce15e0e3233$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
    const $d90d8ce15e0e3233$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
    const $d90d8ce15e0e3233$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
    const $d90d8ce15e0e3233$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
    const $d90d8ce15e0e3233$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
    const $d90d8ce15e0e3233$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
    const $d90d8ce15e0e3233$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
    const $d90d8ce15e0e3233$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
    const $d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
    const $d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
    const $d90d8ce15e0e3233$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
    const $d90d8ce15e0e3233$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
    const $d90d8ce15e0e3233$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
    const $d90d8ce15e0e3233$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
    const $d90d8ce15e0e3233$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
    const $d90d8ce15e0e3233$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
    const $d90d8ce15e0e3233$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
    const $d90d8ce15e0e3233$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
    const $d90d8ce15e0e3233$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
    const $d90d8ce15e0e3233$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
    const $d90d8ce15e0e3233$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
    const $d90d8ce15e0e3233$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
    const $d90d8ce15e0e3233$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
    const $d90d8ce15e0e3233$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
    const $d90d8ce15e0e3233$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
    const $d90d8ce15e0e3233$export$ef510a15f840e437 = 'global-settings-issues-types-view';
    const $d90d8ce15e0e3233$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
    const $d90d8ce15e0e3233$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
    const $d90d8ce15e0e3233$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
    const $d90d8ce15e0e3233$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
    const $d90d8ce15e0e3233$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
    const $d90d8ce15e0e3233$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
    const $d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
    const $d90d8ce15e0e3233$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
    const $d90d8ce15e0e3233$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
    const $d90d8ce15e0e3233$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
    const $d90d8ce15e0e3233$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
    const $d90d8ce15e0e3233$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
    const $d90d8ce15e0e3233$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
    const $d90d8ce15e0e3233$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
    const $d90d8ce15e0e3233$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
    const $d90d8ce15e0e3233$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
    const $d90d8ce15e0e3233$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
    const $d90d8ce15e0e3233$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
    const $d90d8ce15e0e3233$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
    const $d90d8ce15e0e3233$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
    const $d90d8ce15e0e3233$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
    const $d90d8ce15e0e3233$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
    const $d90d8ce15e0e3233$export$4c211b3188348679 = 'global-settings-performance-custom-field';
    const $d90d8ce15e0e3233$export$24757bb1837e33af = 'global-settings-performance-issue';
    const $d90d8ce15e0e3233$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
    const $d90d8ce15e0e3233$export$d55d4330b58683da = 'global-settings-performance-overview';
    const $d90d8ce15e0e3233$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
    const $d90d8ce15e0e3233$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
    const $d90d8ce15e0e3233$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
    const $d90d8ce15e0e3233$export$16b4392a63a3eacf = 'global-settings-products-applinks';
    const $d90d8ce15e0e3233$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
    const $d90d8ce15e0e3233$export$f870832f94ca5009 = 'global-settings-products-sdmail';
    const $d90d8ce15e0e3233$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
    const $d90d8ce15e0e3233$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
    const $d90d8ce15e0e3233$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
    const $d90d8ce15e0e3233$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
    const $d90d8ce15e0e3233$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
    const $d90d8ce15e0e3233$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
    const $d90d8ce15e0e3233$export$a1916b723e186494 = 'global-settings-system-helper-permission';
    const $d90d8ce15e0e3233$export$5070b4c974017f28 = 'global-settings-system-attachments';
    const $d90d8ce15e0e3233$export$bee7f9f93cb74124 = 'global-settings-system-events';
    const $d90d8ce15e0e3233$export$efe4008073ab3b69 = 'global-settings-system-events-add';
    const $d90d8ce15e0e3233$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
    const $d90d8ce15e0e3233$export$223f8094878fea34 = 'global-settings-system-events-edit';
    const $d90d8ce15e0e3233$export$2f589c572415c043 = 'global-settings-system-lexorank';
    const $d90d8ce15e0e3233$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
    const $d90d8ce15e0e3233$export$a11311cd333dae90 = 'global-settings-system-webhooks';
    const $d90d8ce15e0e3233$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
    const $d90d8ce15e0e3233$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
    const $d90d8ce15e0e3233$export$55dd30b027c838fe = 'global-settings-system-application-edit';
    const $d90d8ce15e0e3233$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
    const $d90d8ce15e0e3233$export$75f2fbd33e76028e = 'global-settings-system-export';
    const $d90d8ce15e0e3233$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
    const $d90d8ce15e0e3233$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
    const $d90d8ce15e0e3233$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
    const $d90d8ce15e0e3233$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
    const $d90d8ce15e0e3233$export$750a33c4058af733 = 'global-settings-system-import-trello';
    const $d90d8ce15e0e3233$export$1b66c7594340363f = 'global-settings-system-collectors';
    const $d90d8ce15e0e3233$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
    const $d90d8ce15e0e3233$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
    const $d90d8ce15e0e3233$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
    const $d90d8ce15e0e3233$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
    const $d90d8ce15e0e3233$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
    const $d90d8ce15e0e3233$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
    const $d90d8ce15e0e3233$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
    const $d90d8ce15e0e3233$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
    const $d90d8ce15e0e3233$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
    const $d90d8ce15e0e3233$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
    const $d90d8ce15e0e3233$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
    const $d90d8ce15e0e3233$export$265062715b11a1ef = 'global-settings-system-roles-usage';
    const $d90d8ce15e0e3233$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
    const $d90d8ce15e0e3233$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
    const $d90d8ce15e0e3233$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
    const $d90d8ce15e0e3233$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
    const $d90d8ce15e0e3233$export$fb75113636566d39 = 'global-settings-system-look';
    const $d90d8ce15e0e3233$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
    const $d90d8ce15e0e3233$export$40d189100899f572 = 'global-settings-system-default-settings';
    const $d90d8ce15e0e3233$export$341933b279728599 = $d90d8ce15e0e3233$export$f8cea29bebf098c;
    const $d90d8ce15e0e3233$export$ae4b815061537207 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-notifications`;
    const $d90d8ce15e0e3233$export$e4fb7ce0fc5e3a75 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-access`;
    const $d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-email`;
    const $d90d8ce15e0e3233$export$bee46016693b19dc = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-kb`;
    const $d90d8ce15e0e3233$export$ca253bc3d237c17f = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-forms`;
    const $d90d8ce15e0e3233$export$a4cba48257cb118a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-form-edit`;
    const $d90d8ce15e0e3233$export$2e90ab5aa3463c0d = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-web-portal`;
    const $d90d8ce15e0e3233$export$c39a25878c902e0a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-unassigned-ticket-types-config`;
    const $d90d8ce15e0e3233$export$6eaa6ce8101f6468 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-unassigned-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
    const $d90d8ce15e0e3233$export$b2b57cde1fa39bf5 = 'home-redirect';
    const $d90d8ce15e0e3233$export$e8e3b3a04b70a016 = 'issue';
    const $d90d8ce15e0e3233$export$1a3116351e4f3550 = 'issue-create-embed';
    const $d90d8ce15e0e3233$export$6e2629d41c380b47 = 'issue-embed';
    const $d90d8ce15e0e3233$export$ced38e55e6d33a4e = 'jira-search';
    const $d90d8ce15e0e3233$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
    const $d90d8ce15e0e3233$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
    const $d90d8ce15e0e3233$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
    const $d90d8ce15e0e3233$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
    const $d90d8ce15e0e3233$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
    const $d90d8ce15e0e3233$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
    const $d90d8ce15e0e3233$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
    const $d90d8ce15e0e3233$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
    const $d90d8ce15e0e3233$export$fea47b97c6086336 = 'knowledge-hub-drafts';
    const $d90d8ce15e0e3233$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
    const $d90d8ce15e0e3233$export$991ba0c465b48539 = 'knowledge-hub-landing';
    const $d90d8ce15e0e3233$export$904b472d57dee40d = 'knowledge-hub-search';
    const $d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
    const $d90d8ce15e0e3233$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
    const $d90d8ce15e0e3233$export$37bd400c00057d64 = 'legacy-all-reports';
    const $d90d8ce15e0e3233$export$eb66bd587b5f093d = 'legacy-backlog';
    const $d90d8ce15e0e3233$export$521baa72494c2a67 = 'legacy-board';
    const $d90d8ce15e0e3233$export$ca255c93be51d5bc = 'legacy-connect-general';
    const $d90d8ce15e0e3233$export$51e45f736a60769b = 'legacy-connect-project';
    const $d90d8ce15e0e3233$export$2da88c0583f7fff0 = 'legacy-core-reports';
    const $d90d8ce15e0e3233$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
    const $d90d8ce15e0e3233$export$5475ba822739444a = 'legacy-fallback';
    const $d90d8ce15e0e3233$export$8483f5c57513e386 = 'legacy-gin';
    const $d90d8ce15e0e3233$export$93c4d1960660bdb3 = 'legacy-gin-issue';
    const $d90d8ce15e0e3233$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
    const $d90d8ce15e0e3233$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
    const $d90d8ce15e0e3233$export$bf4001a5c23bef67 = 'legacy-issue';
    const $d90d8ce15e0e3233$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
    const $d90d8ce15e0e3233$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
    const $d90d8ce15e0e3233$export$41008c2b014795bf = 'legacy-jsd-getting-started';
    const $d90d8ce15e0e3233$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
    const $d90d8ce15e0e3233$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
    const $d90d8ce15e0e3233$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
    const $d90d8ce15e0e3233$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
    const $d90d8ce15e0e3233$export$3fbd487079a23c0f = 'legacy-jsd-reports';
    const $d90d8ce15e0e3233$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
    const $d90d8ce15e0e3233$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
    const $d90d8ce15e0e3233$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
    const $d90d8ce15e0e3233$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
    const $d90d8ce15e0e3233$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
    const $d90d8ce15e0e3233$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
    const $d90d8ce15e0e3233$export$c71836085985a7d3 = 'legacy-pin';
    const $d90d8ce15e0e3233$export$a17a19a9de903839 = 'legacy-project-releases';
    const $d90d8ce15e0e3233$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
    const $d90d8ce15e0e3233$export$f0254c80025ed0fc = 'legacy-project-releases-note';
    const $d90d8ce15e0e3233$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
    const $d90d8ce15e0e3233$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
    const $d90d8ce15e0e3233$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
    const $d90d8ce15e0e3233$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
    const $d90d8ce15e0e3233$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
    const $d90d8ce15e0e3233$export$3467807847c0a87d = 'legacy-project-settings-config';
    const $d90d8ce15e0e3233$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
    const $d90d8ce15e0e3233$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
    const $d90d8ce15e0e3233$export$f01730982626c4af = 'legacy-project-settings-dev';
    const $d90d8ce15e0e3233$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
    const $d90d8ce15e0e3233$export$ecff223feb9d08be = 'legacy-project-settings-fields';
    const $d90d8ce15e0e3233$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
    const $d90d8ce15e0e3233$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
    const $d90d8ce15e0e3233$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
    const $d90d8ce15e0e3233$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
    const $d90d8ce15e0e3233$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
    const $d90d8ce15e0e3233$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
    const $d90d8ce15e0e3233$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
    const $d90d8ce15e0e3233$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
    const $d90d8ce15e0e3233$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
    const $d90d8ce15e0e3233$export$28687a1181a7676f = 'legacy-project-settings-people';
    const $d90d8ce15e0e3233$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
    const $d90d8ce15e0e3233$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
    const $d90d8ce15e0e3233$export$cb8548f16119b181 = 'legacy-project-settings-screens';
    const $d90d8ce15e0e3233$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
    const $d90d8ce15e0e3233$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
    const $d90d8ce15e0e3233$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
    const $d90d8ce15e0e3233$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
    const $d90d8ce15e0e3233$export$2d21e5416485b195 = 'legacy-redirect';
    const $d90d8ce15e0e3233$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
    const $d90d8ce15e0e3233$export$d9662297242bfcb5 = 'legacy-reports-configure';
    const $d90d8ce15e0e3233$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
    const $d90d8ce15e0e3233$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
    const $d90d8ce15e0e3233$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
    const $d90d8ce15e0e3233$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
    const $d90d8ce15e0e3233$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
    const $d90d8ce15e0e3233$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
    const $d90d8ce15e0e3233$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
    const $d90d8ce15e0e3233$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
    const $d90d8ce15e0e3233$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
    const $d90d8ce15e0e3233$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
    const $d90d8ce15e0e3233$export$55248356780fc584 = 'login-embed';
    const $d90d8ce15e0e3233$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
    const $d90d8ce15e0e3233$export$624af6f61b05f55 = 'addons-emcee-public';
    const $d90d8ce15e0e3233$export$2ed9525182145b82 = 'marketplace-app-requests';
    const $d90d8ce15e0e3233$export$7fb2b42fc4e7df8b = 'marketplace-index';
    const $d90d8ce15e0e3233$export$fa962db82ae571b2 = 'global-settings-addons-upm';
    const $d90d8ce15e0e3233$export$e145bf76b1aef705 = 'marketplace-promotions';
    const $d90d8ce15e0e3233$export$8febbfb647e4c8b9 = 'notification-logs';
    const $d90d8ce15e0e3233$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
    const $d90d8ce15e0e3233$export$a979a5c1f5e3631c = 'people-index';
    const $d90d8ce15e0e3233$export$ffcbf91dfadffd0 = 'personal-settings';
    const $d90d8ce15e0e3233$export$1807a39cc63b856c = 'personal-settings-general';
    const $d90d8ce15e0e3233$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
    const $d90d8ce15e0e3233$export$6268da7263eb670d = 'personal-settings-ops-notifications';
    const $d90d8ce15e0e3233$export$93bd4a896a0fc581 = 'plans-directory';
    const $d90d8ce15e0e3233$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
    const $d90d8ce15e0e3233$export$d1217085321b2648 = 'project-settings-playbooks-list';
    const $d90d8ce15e0e3233$export$39624171b7c8a10a = 'polaris-collections';
    const $d90d8ce15e0e3233$export$1654cd6813e90e6b = 'polaris-ideas';
    const $d90d8ce15e0e3233$export$33059cd02df2febd = 'polaris-insights';
    const $d90d8ce15e0e3233$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
    const $d90d8ce15e0e3233$export$145c578104a45fd2 = 'polaris-plays';
    const $d90d8ce15e0e3233$export$a51df1bc877c58e5 = 'polaris-rooms';
    const $d90d8ce15e0e3233$export$45208fff8de46880 = 'polaris-settings-access';
    const $d90d8ce15e0e3233$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
    const $d90d8ce15e0e3233$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
    const $d90d8ce15e0e3233$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
    const $d90d8ce15e0e3233$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
    const $d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
    const $d90d8ce15e0e3233$export$53ce69fb34f6d286 = 'products-jsm-configuration';
    const $d90d8ce15e0e3233$export$b6e861786143eb1b = 'products-jsm-customer-access';
    const $d90d8ce15e0e3233$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
    const $d90d8ce15e0e3233$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
    const $d90d8ce15e0e3233$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
    const $d90d8ce15e0e3233$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
    const $d90d8ce15e0e3233$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
    const $d90d8ce15e0e3233$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
    const $d90d8ce15e0e3233$export$9ac90b948c53bf58 = 'products-jsw-configuration';
    const $d90d8ce15e0e3233$export$bb5665894498893f = 'products-jsw-storage-management';
    const $d90d8ce15e0e3233$export$dd4c319b26f01664 = 'proforma-export';
    const $d90d8ce15e0e3233$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$f07fd5696f888ae = 'proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$ff1365ce4d652337 = 'projects-directory';
    const $d90d8ce15e0e3233$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
    const $d90d8ce15e0e3233$export$33c2dcc7c7abc45e = 'projects-directory-manage';
    const $d90d8ce15e0e3233$export$a6ef20aa08a533b1 = 'projects-redirect';
    const $d90d8ce15e0e3233$export$5908e15483da8a45 = 'project-components';
    const $d90d8ce15e0e3233$export$a3812f6f4e60d897 = 'project-directory-redirect';
    const $d90d8ce15e0e3233$export$3c8c119f40a061a9 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$47e034646abefdb2 = 'issue-navigator-classic';
    const $d90d8ce15e0e3233$export$f36f4cf8b17f250f = 'issue-navigator-core';
    const $d90d8ce15e0e3233$export$841e880a0d425b3e = 'project-not-found';
    const $d90d8ce15e0e3233$export$1fde4a6e7df24a97 = 'project-pages';
    const $d90d8ce15e0e3233$export$69335bf8b709edc7 = 'project-settings-automation';
    const $d90d8ce15e0e3233$export$946b472f7559a889 = 'project-settings-components';
    const $d90d8ce15e0e3233$export$373fdf6888021ed0 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access`;
    const $d90d8ce15e0e3233$export$d6a5f13a3d30923c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access-redirect`;
    const $d90d8ce15e0e3233$export$adfff93b0b015409 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-approvals`;
    const $d90d8ce15e0e3233$export$404de4ddea701cff = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps`;
    const $d90d8ce15e0e3233$export$596e1f6f6f4997b2 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps-fields`;
    const $d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-automation`;
    const $d90d8ce15e0e3233$export$d610a17dff3a01fa = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-data-classifications`;
    const $d90d8ce15e0e3233$export$284db5107f3db516 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-redirect`;
    const $d90d8ce15e0e3233$export$fbce46826eefc586 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-details`;
    const $d90d8ce15e0e3233$export$c86b29c76317ac6f = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-fields`;
    const $d90d8ce15e0e3233$export$3160b86e1b5dc391 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-forge-apps`;
    const $d90d8ce15e0e3233$export$690c0080c930fca = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes`;
    const $d90d8ce15e0e3233$export$171ba8c33c05c4ef = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes-workflow`;
    const $d90d8ce15e0e3233$export$e2f2c23286c3255c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications`;
    const $d90d8ce15e0e3233$export$5a262d40e10207a1 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$ab790cb87175797e = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$db780b39656c673a = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
    const $d90d8ce15e0e3233$export$a77cb4dafc511d3 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$253fd82874264ee4 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-forge-apps`;
    const $d90d8ce15e0e3233$export$eaf9ab4ec0c25813 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-forge`;
    const $d90d8ce15e0e3233$export$574bcdf6b73fcf1f = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-apps-fields`;
    const $d90d8ce15e0e3233$export$a14853dfff8da872 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-chat`;
    const $d90d8ce15e0e3233$export$ba8fd0e6db8d3e08 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-notifications`;
    const $d90d8ce15e0e3233$export$1c74da1e52e6d212 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-permissions`;
    const $d90d8ce15e0e3233$export$d416059b17fe7d4e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-email`;
    const $d90d8ce15e0e3233$export$d5a3a037d2760bb7 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-widget`;
    const $d90d8ce15e0e3233$export$eb187d42a7448d45 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
    const $d90d8ce15e0e3233$export$688de32d31fc70f5 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-details`;
    const $d90d8ce15e0e3233$export$13d770f8814d480a = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-forge-apps`;
    const $d90d8ce15e0e3233$export$3a628f9376166ffb = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
    const $d90d8ce15e0e3233$export$649dafa225625f30 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$dbfe76dd37018b2 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications`;
    const $d90d8ce15e0e3233$export$20db7bb9d1bd8b38 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$a1fa8e6e125780ae = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notification-email`;
    const $d90d8ce15e0e3233$export$fc6b949fd2bc782d = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-portal-settings`;
    const $d90d8ce15e0e3233$export$c940f866ac7760a0 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-types-config`;
    const $d90d8ce15e0e3233$export$184d4979f6f9fe7e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$959f50de166cc45e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
    const $d90d8ce15e0e3233$export$b13b8c8bb4e30a75 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
    const $d90d8ce15e0e3233$export$cc1af211e3feda50 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-fields`;
    const $d90d8ce15e0e3233$export$3873539001f5aed7 = 'project-settings-software-automation';
    const $d90d8ce15e0e3233$export$89fcbafce559080b = 'project-settings-software-boards-card';
    const $d90d8ce15e0e3233$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
    const $d90d8ce15e0e3233$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
    const $d90d8ce15e0e3233$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
    const $d90d8ce15e0e3233$export$50680f54e95bb859 = 'project-settings-software-boards-features';
    const $d90d8ce15e0e3233$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
    const $d90d8ce15e0e3233$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
    const $d90d8ce15e0e3233$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
    const $d90d8ce15e0e3233$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
    const $d90d8ce15e0e3233$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
    const $d90d8ce15e0e3233$export$ba419378ad70624e = 'project-settings-software-data-classifications';
    const $d90d8ce15e0e3233$export$62f38c589a73d386 = 'project-settings-software-details';
    const $d90d8ce15e0e3233$export$77c8066c0822f152 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-fields`;
    const $d90d8ce15e0e3233$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
    const $d90d8ce15e0e3233$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
    const $d90d8ce15e0e3233$export$db7f5d93be70ee30 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications`;
    const $d90d8ce15e0e3233$export$432229516b7f82da = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
    const $d90d8ce15e0e3233$export$6b2b99b0055772a3 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$83c7a51057be6264 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-team-managed`;
    const $d90d8ce15e0e3233$export$46706d786aab3829 = 'project-settings-versions';
    const $d90d8ce15e0e3233$export$b690025ef7e3cf6c = 'project-versions';
    const $d90d8ce15e0e3233$export$ea48cc6bf1183d11 = 'rapidboard';
    const $d90d8ce15e0e3233$export$930e4881302bbd54 = 'rapidboard-backlog';
    const $d90d8ce15e0e3233$export$375801b708576466 = 'rapidboard-backlog-embed';
    const $d90d8ce15e0e3233$export$5b1e8463bd590143 = 'rapidboard-board';
    const $d90d8ce15e0e3233$export$1606662a398a24be = 'rapidboard-board-embed';
    const $d90d8ce15e0e3233$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
    const $d90d8ce15e0e3233$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
    const $d90d8ce15e0e3233$export$c46680afe70295f3 = 'rapidboard-report';
    const $d90d8ce15e0e3233$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
    const $d90d8ce15e0e3233$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
    const $d90d8ce15e0e3233$export$99e0abd8ba1de289 = 'rapidboard-user-board';
    const $d90d8ce15e0e3233$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
    const $d90d8ce15e0e3233$export$36e61e70347174cc = 'rovo-demand-tests';
    const $d90d8ce15e0e3233$export$3bddd65f2541c4d = 'sandbox-bundler';
    const $d90d8ce15e0e3233$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
    const $d90d8ce15e0e3233$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
    const $d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
    const $d90d8ce15e0e3233$export$8c8f03e75b6708ac = 'servicedesk-calendar';
    const $d90d8ce15e0e3233$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
    const $d90d8ce15e0e3233$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
    const $d90d8ce15e0e3233$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
    const $d90d8ce15e0e3233$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
    const $d90d8ce15e0e3233$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
    const $d90d8ce15e0e3233$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
    const $d90d8ce15e0e3233$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
    const $d90d8ce15e0e3233$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$37a9bdd8513f462d = 'servicedesk-connect-project';
    const $d90d8ce15e0e3233$export$f01162415f3a2ee3 = 'servicedesk-create-project';
    const $d90d8ce15e0e3233$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
    const $d90d8ce15e0e3233$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
    const $d90d8ce15e0e3233$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
    const $d90d8ce15e0e3233$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
    const $d90d8ce15e0e3233$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
    const $d90d8ce15e0e3233$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
    const $d90d8ce15e0e3233$export$829d1776460a6ad3 = 'servicedesk-incidents';
    const $d90d8ce15e0e3233$export$d30ab2da08d8b7b9 = 'servicedesk-index';
    const $d90d8ce15e0e3233$export$3c71889849aeaa08 = 'servicedesk-issue';
    const $d90d8ce15e0e3233$export$354bf2df81f6ffb0 = 'servicedesk-issues';
    const $d90d8ce15e0e3233$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
    const $d90d8ce15e0e3233$export$876055c0ede2f8df = 'servicedesk-automation';
    const $d90d8ce15e0e3233$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
    const $d90d8ce15e0e3233$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
    const $d90d8ce15e0e3233$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
    const $d90d8ce15e0e3233$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
    const $d90d8ce15e0e3233$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
    const $d90d8ce15e0e3233$export$8c800f176d079d28 = 'servicedesk-organization-details';
    const $d90d8ce15e0e3233$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
    const $d90d8ce15e0e3233$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
    const $d90d8ce15e0e3233$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
    const $d90d8ce15e0e3233$export$2b4737953287a354 = 'servicedesk-practice-issue';
    const $d90d8ce15e0e3233$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
    const $d90d8ce15e0e3233$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
    const $d90d8ce15e0e3233$export$2d961b0101f8733e = 'servicedesk-practice-new';
    const $d90d8ce15e0e3233$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
    const $d90d8ce15e0e3233$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
    const $d90d8ce15e0e3233$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
    const $d90d8ce15e0e3233$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
    const $d90d8ce15e0e3233$export$ccd12890649c59cc = 'servicedesk-queues-issue';
    const $d90d8ce15e0e3233$export$8c84064031188e80 = 'servicedesk-queues-landing';
    const $d90d8ce15e0e3233$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
    const $d90d8ce15e0e3233$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
    const $d90d8ce15e0e3233$export$156b2dfbd87d576f = 'servicedesk-redirect';
    const $d90d8ce15e0e3233$export$6961f1ed0407cb26 = 'servicedesk-reports';
    const $d90d8ce15e0e3233$export$ba284efd679bf637 = 'servicedesk-reports-custom';
    const $d90d8ce15e0e3233$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
    const $d90d8ce15e0e3233$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
    const $d90d8ce15e0e3233$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
    const $d90d8ce15e0e3233$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
    const $d90d8ce15e0e3233$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
    const $d90d8ce15e0e3233$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
    const $d90d8ce15e0e3233$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
    const $d90d8ce15e0e3233$export$be4b2ffade787316 = 'servicedesk-reports-summary';
    const $d90d8ce15e0e3233$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
    const $d90d8ce15e0e3233$export$29bc361328055683 = 'servicedesk-reports-workload';
    const $d90d8ce15e0e3233$export$a4a5a333fe874d97 = 'servicedesk-services';
    const $d90d8ce15e0e3233$export$2193b681ac1ae132 = 'servicedesk-services-new';
    const $d90d8ce15e0e3233$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
    const $d90d8ce15e0e3233$export$a4c4f7898d6b914a = 'servicedesk-service-details';
    const $d90d8ce15e0e3233$export$6cffae90b9277bb = 'servicedesk-service-details-new';
    const $d90d8ce15e0e3233$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
    const $d90d8ce15e0e3233$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
    const $d90d8ce15e0e3233$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
    const $d90d8ce15e0e3233$export$8e68c55c334de101 = 'servicedesk-sla-settings';
    const $d90d8ce15e0e3233$export$5cb7cfba189a0240 = 'service-hub-services';
    const $d90d8ce15e0e3233$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
    const $d90d8ce15e0e3233$export$1cf56e2d6c4edb35 = 'global-automation';
    const $d90d8ce15e0e3233$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
    const $d90d8ce15e0e3233$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
    const $d90d8ce15e0e3233$export$4db732436e4edfaf = 'recommendations';
    const $d90d8ce15e0e3233$export$e832418dbed0717e = 'view-custom-fields';
    const $d90d8ce15e0e3233$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
    const $d90d8ce15e0e3233$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
    const $d90d8ce15e0e3233$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
    const $d90d8ce15e0e3233$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
    const $d90d8ce15e0e3233$export$e74fe5bd41e23fbd = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies`;
    const $d90d8ce15e0e3233$export$1a93e63ddbe4aa06 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies-redirect`;
    const $d90d8ce15e0e3233$export$3b6dbbe49882589d = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-financial-year`;
    const $d90d8ce15e0e3233$export$eb01394789016fd4 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits`;
    const $d90d8ce15e0e3233$export$f17f4523583fa8e5 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits-redirect`;
    const $d90d8ce15e0e3233$export$eaa4d6eec75a6778 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions`;
    const $d90d8ce15e0e3233$export$dcc96e4abbdc0d39 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions-redirect`;
    const $d90d8ce15e0e3233$export$9eaf39ba5a56c72a = 'software-backlog';
    const $d90d8ce15e0e3233$export$495be3320b67814a = 'software-backlog-embed';
    const $d90d8ce15e0e3233$export$25752eb5bb5e3d32 = 'software-boards';
    const $d90d8ce15e0e3233$export$f116716aedb35e10 = 'software-boards-embed';
    const $d90d8ce15e0e3233$export$36fffb6b49d9f31d = 'software-calendar';
    const $d90d8ce15e0e3233$export$a6d07be4ff318f84 = 'software-calendar-classic';
    const $d90d8ce15e0e3233$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
    const $d90d8ce15e0e3233$export$3a4c7a521a900b4d = 'software-calendar-embed';
    const $d90d8ce15e0e3233$export$9dcf51a9040a4fd6 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
    const $d90d8ce15e0e3233$export$a74f9f6bd0d4fb26 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
    const $d90d8ce15e0e3233$export$f8cb86acf6b74661 = 'software-code';
    const $d90d8ce15e0e3233$export$2d3d850c64058bfb = 'software-code-classic';
    const $d90d8ce15e0e3233$export$af6b51164f66908b = 'software-deployments';
    const $d90d8ce15e0e3233$export$12efc96fc9c9fb34 = 'software-deployments-classic';
    const $d90d8ce15e0e3233$export$6ab1901e04e623ba = 'software-form';
    const $d90d8ce15e0e3233$export$bccc7d0812737c4e = 'software-form-classic';
    const $d90d8ce15e0e3233$export$458fb992f2637a20 = 'software-form-builder';
    const $d90d8ce15e0e3233$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
    const $d90d8ce15e0e3233$export$50264cbc90a39f19 = 'software-form-submit';
    const $d90d8ce15e0e3233$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
    const $d90d8ce15e0e3233$export$b8045610416fa8ca = 'software-goals';
    const $d90d8ce15e0e3233$export$8e80136ad13099e3 = 'software-goals-classic';
    const $d90d8ce15e0e3233$export$b5fe44c0bc324494 = 'software-incidents';
    const $d90d8ce15e0e3233$export$7a4f52d9060a20d2 = 'software-incidents-classic';
    const $d90d8ce15e0e3233$export$d6a9e4695952522e = 'software-issue-navigator';
    const $d90d8ce15e0e3233$export$deab88d0814c564b = 'software-list';
    const $d90d8ce15e0e3233$export$906faff110f898ef = 'software-list-classic';
    const $d90d8ce15e0e3233$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
    const $d90d8ce15e0e3233$export$4ed84a2011fdc400 = 'software-list-embed';
    const $d90d8ce15e0e3233$export$f7b286b39bf6051b = 'software-nextgen-redirect';
    const $d90d8ce15e0e3233$export$6c4337c0332c8c7f = 'software-onboarding';
    const $d90d8ce15e0e3233$export$e7c78887745b2326 = 'software-onboarding-get-started';
    const $d90d8ce15e0e3233$export$3805e4f07dca7584 = 'software-periscope';
    const $d90d8ce15e0e3233$export$f77254983320e888 = 'software-periscope-classic';
    const $d90d8ce15e0e3233$export$2e784832f1c6bb = 'software-plan-calendar';
    const $d90d8ce15e0e3233$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
    const $d90d8ce15e0e3233$export$9e53cdb1ac02195c = 'software-plan-dependencies';
    const $d90d8ce15e0e3233$export$58bd507904dc221c = 'software-plan-dependencies-embed';
    const $d90d8ce15e0e3233$export$7a821e22be2c2f14 = 'software-plan-increment';
    const $d90d8ce15e0e3233$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
    const $d90d8ce15e0e3233$export$e7423156dba31a7c = 'software-plan-increments';
    const $d90d8ce15e0e3233$export$cba7e383b2409c7b = 'software-plan-releases';
    const $d90d8ce15e0e3233$export$d5378fb71d5242c0 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-auto-scheduler`;
    const $d90d8ce15e0e3233$export$4b16b72c72da8833 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-custom-fields`;
    const $d90d8ce15e0e3233$export$10114d78cefb1f53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-exclusion-rules`;
    const $d90d8ce15e0e3233$export$92fe23ed30100817 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-find-your-issue`;
    const $d90d8ce15e0e3233$export$e824495554c83069 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-issue-sources`;
    const $d90d8ce15e0e3233$export$8df2e9efdd625a44 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-permissions`;
    const $d90d8ce15e0e3233$export$aeb4d3006e298033 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-plan-info`;
    const $d90d8ce15e0e3233$export$e15d3c40985c4b53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-program-boards`;
    const $d90d8ce15e0e3233$export$1d8c84454fd2d571 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-removed-issues`;
    const $d90d8ce15e0e3233$export$db61a12efb59745c = `${$d90d8ce15e0e3233$export$6f266218a6973848}-saved-views`;
    const $d90d8ce15e0e3233$export$2da67fb5bd6bc2ee = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scenarios`;
    const $d90d8ce15e0e3233$export$182e0167fd960de6 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scheduling`;
    const $d90d8ce15e0e3233$export$2d9e2484ee02e7da = 'software-plan-summary';
    const $d90d8ce15e0e3233$export$b7fff19fd89b617f = 'software-plan-summary-embed';
    const $d90d8ce15e0e3233$export$ea23f150f64e8a4e = 'software-plan-teams';
    const $d90d8ce15e0e3233$export$116338bd93f78ad0 = 'software-plan-timeline';
    const $d90d8ce15e0e3233$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
    const $d90d8ce15e0e3233$export$d75d93e5d44182cc = 'software-release-notes';
    const $d90d8ce15e0e3233$export$cc3027ae3767801 = 'software-reports';
    const $d90d8ce15e0e3233$export$3492ce83b8884e0e = 'software-reports-burndown';
    const $d90d8ce15e0e3233$export$b4798b7e62733393 = 'software-reports-burnup';
    const $d90d8ce15e0e3233$export$388685c701d6e0d3 = 'software-reports-control';
    const $d90d8ce15e0e3233$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
    const $d90d8ce15e0e3233$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
    const $d90d8ce15e0e3233$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
    const $d90d8ce15e0e3233$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
    const $d90d8ce15e0e3233$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
    const $d90d8ce15e0e3233$export$ae0d999dd2bdd59b = 'software-reports-velocity';
    const $d90d8ce15e0e3233$export$296115eb5b7129d3 = 'software-roadmap';
    const $d90d8ce15e0e3233$export$17574f41c3925d64 = 'software-roadmap-classic';
    const $d90d8ce15e0e3233$export$955692fbfe35fc16 = 'software-roadmap-redirect';
    const $d90d8ce15e0e3233$export$30af3a767b8ad2d8 = 'software-security';
    const $d90d8ce15e0e3233$export$f47d664298c2c2f0 = 'software-security-classic';
    const $d90d8ce15e0e3233$export$2d1ed852d9885250 = 'software-summary';
    const $d90d8ce15e0e3233$export$312796fc15876480 = 'software-summary-classic';
    const $d90d8ce15e0e3233$export$a16645495fb1d5ef = 'software-staffing';
    const $d90d8ce15e0e3233$export$1714b5ad9b672bc7 = 'software-timeline';
    const $d90d8ce15e0e3233$export$c9634bf15518a3a1 = 'software-timeline-classic';
    const $d90d8ce15e0e3233$export$3b5eb3ea8cbeeed = 'software-version-detail';
    const $d90d8ce15e0e3233$export$118bb1785acc3d0b = 'software-version-detail-embed';
    const $d90d8ce15e0e3233$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
    const $d90d8ce15e0e3233$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
    const $d90d8ce15e0e3233$export$831acb5098f5706d = 'system-configuration-general';
    const $d90d8ce15e0e3233$export$d218cda46c433fe1 = 'system-dashboard-edit';
    const $d90d8ce15e0e3233$export$61147168ac2833f9 = 'trashed-plan-direct-link';
    const $d90d8ce15e0e3233$export$9fe0117c0fd486a8 = 'trash-plans-directory';
    const $d90d8ce15e0e3233$export$a49474778d15635d = 'trash-projects-directory';
    const $d90d8ce15e0e3233$export$af3296e54e7fb362 = 'user-segmentation';
    const $d90d8ce15e0e3233$export$281f2e01ee9e4977 = 'your-work';
});
parcelRegister("95bh0", function(module, exports) {
    $parcel$export(module.exports, "getScopeIdentifier", ()=>$4cc145d0cf66273c$export$68278f7cf66944f9);
    const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
        const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
        let identifierType = null;
        if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
        else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
        else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
        return {
            identifierValue: identifierValue,
            identifierType: identifierType
        };
    };
});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';
parcelRegister("8YTna", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$f7f12dfb24bc320d$export$557c2f222778cea6);
    const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];
});
parcelRegister("gDyED", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarNavInfo", ()=>$b6d61a4c2e3b518c$export$8a51470472777e11);
    var $eusud;
    const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
        if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
        let queryParam = '';
        switch(identifierType){
            case 'boardId':
                queryParam = `boardId=${identifierValue}`;
                break;
            case 'projectKey':
            case 'projectId':
                queryParam = `projectIdOrKey=${identifierValue}`;
                break;
            default:
                break;
        }
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
    };
});
parcelRegister("324W5", function(module, exports) {
    $parcel$export(module.exports, "useResourceWithCustomRouterContext", ()=>$0c2698427b7aacc1$export$61dad767cf446185);
    var $e5wyW;
    var $4R6GH;
    var $jNUyg;
    var $2YP9W;
    var $geWXd;
    const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
        name: 'DUMMY_ROUTE_NAME',
        path: '/projects/:projectKey/dummyroute'
    };
    const $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
        let useResourceArgCustomContext;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
                routerContext: (0, (0, parcelRequire("jNUyg")).createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const resourceResponse = (0, (0, parcelRequire("2YP9W")).useResource)(resource, useResourceArgCustomContext);
        (0, (0, parcelRequire("geWXd")).useInitFetchResource)(resourceResponse, !customRouterContext);
        return resourceResponse;
    };
    function $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
        let resourceOptions;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
                routerContext: (0, (0, parcelRequire("jNUyg")).createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const { shouldPrefetch: shouldPrefetch } = options;
        const resourceResponse = (0, (0, parcelRequire("2YP9W")).useResource)(resource, resourceOptions);
        (0, (0, parcelRequire("geWXd")).usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
        return resourceResponse;
    }
    const $0c2698427b7aacc1$export$61dad767cf446185 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_useinitresource_data_bug'), $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions, $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld);
});
parcelRegister("e5wyW", function(module, exports) {
    $parcel$export(module.exports, "functionWithCondition", ()=>$12199147dc0ae1fa$export$af3c0e82a18fc057);
    $parcel$export(module.exports, "functionUnionWithCondition", ()=>$12199147dc0ae1fa$export$c41c28c1d883fcd5);
    function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
        const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
        return fnWithCondition;
    }
    function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
        return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
    }
});
parcelRegister("geWXd", function(module, exports) {
    $parcel$export(module.exports, "useInitFetchResource", ()=>$b632b0c18495344b$export$5b98692301d8680);
    $parcel$export(module.exports, "usePrefetchableResource", ()=>$b632b0c18495344b$export$99f17ace416cfe75);
    var $5uXOq = parcelRequire("5uXOq");
    const $b632b0c18495344b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
        (0, $5uXOq.useEffect)(()=>{
            if (skipInitFetch) return;
            if (!data && !loading && !error && refresh) refresh();
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            refresh: refresh,
            ...rest
        };
    };
    function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
        (0, $5uXOq.useEffect)(()=>{
            if (!shouldPrefetch) return;
            if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
        }, []);
    }
});
parcelRegister("727Q1", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", ()=>$5300bc04c6e3c00f$export$780174995da89d60);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $ggg5j;
    var $jNUyg;
    var $2YP9W;
    var $doZTA;
    const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
    const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, (0, parcelRequire("jNUyg")).createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/:projectKey/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                projectKey: projectKey
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, (0, parcelRequire("jNUyg")).createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                boardId: `${boardId}`
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
        const [{ match: match, query: query, route: { name: name } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const isOnBoardBasedRoute = (0, (0, parcelRequire("ggg5j")).getIdentifier)(name, match, query)?.identifierType === 'boardId';
        const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
        const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
        const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
        const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
        const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
        (0, $5uXOq.useEffect)(()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        }, [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ]);
    };
});
parcelRegister("e2ctp", function(module, exports) {
    $parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", ()=>$f36666704bcc2bab$export$137d6d169f402a59);
    $parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", ()=>$f36666704bcc2bab$export$ad16a91905cefb0a);
    const $f36666704bcc2bab$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
    const $f36666704bcc2bab$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
    const $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
    const $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
    const $f36666704bcc2bab$export$137d6d169f402a59 = [
        $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX
    ];
    const $f36666704bcc2bab$export$ad16a91905cefb0a = [
        $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$COMMON_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX,
        $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX
    ];
});
parcelRegister("gyYxw", function(module, exports) {
    $parcel$export(module.exports, "genericProjectLayout", ()=>$177735c975452188$export$85dad8e9886563f6);
    var $18N1t;
    var $1XrjK;
    var $6Z2mh;
    var $e7bC3;
    var $9Y3Lc;
    const $177735c975452188$export$85dad8e9886563f6 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("18N1t")).coreProjectLayout), (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("9Y3Lc")).userBoardLayout));
});
parcelRegister("18N1t", function(module, exports) {
    $parcel$export(module.exports, "coreProjectLayout", ()=>$32b20434a17da609$export$3c06ced9943ca671);
    var $1Du13;
    var $1XrjK;
    const $32b20434a17da609$export$3c06ced9943ca671 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
});
parcelRegister("1Du13", function(module, exports) {
    $parcel$export(module.exports, "projectLayout", ()=>$08491b76212b7395$export$204149bac601d20c);
    var $fpzhz;
    var $1XrjK;
    var $hPtZI;
    var $hMrxB;
    const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: 'any'
            }
        });
    const $08491b76212b7395$var$ProjectTrackers = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("8bzg2")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
    });
    const $08491b76212b7395$var$ProjectFavicon = ()=>{
        (0, (0, parcelRequire("hMrxB")).useProjectFavicon)();
        return null;
    };
    const $08491b76212b7395$var$rightSidebars = ()=>[];
    const $08491b76212b7395$var$globalComponents = [
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
        $08491b76212b7395$var$withAnyProjectContext((0, (0, parcelRequire("fpzhz")).ProjectRouteListener))
    ];
    const $08491b76212b7395$export$204149bac601d20c = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: $08491b76212b7395$var$globalComponents,
        rightSidebars: $08491b76212b7395$var$rightSidebars()
    });
});
parcelRegister("fpzhz", function(module, exports) {
    $parcel$export(module.exports, "ProjectRouteListener", ()=>$a96b9050ddfb05f9$export$159f09d701320911);
    var $5uXOq = parcelRequire("5uXOq");
    var $dxCvy;
    var $itmJb;
    var $2YP9W;
    var $hVf1M;
    const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
        const isSiteAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: data, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (isSiteAdmin) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: true
            });
            else if (data != null) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: data.isProjectAdmin
            });
            else (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: loading,
                isProjectAdmin: null
            });
        }, [
            data,
            loading,
            isSiteAdmin
        ]);
        (0, $5uXOq.useEffect)(()=>()=>(0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                    loading: false,
                    isProjectAdmin: null
                }), []);
        return null;
    };
});
parcelRegister("dxCvy", function(module, exports) {
    $parcel$export(module.exports, "projectContextResource", ()=>$fb0493b5a465ed74$export$27ad0d75c619be68);
    $parcel$export(module.exports, "projectContextResourceWithCache", ()=>$fb0493b5a465ed74$export$d75816e37af81473);
    var $1nb22;
    var $2M1hQ;
    const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("2VAeN"));
    const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return projectKey || projectId;
        },
        getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
        maxAge: 1800000
    });
    const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;
});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';
parcelRegister("2VAeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7UkBG").then(()=>parcelRequire('fsLhR'));
});
parcelRegister("itmJb", function(module, exports) {
    $parcel$export(module.exports, "useIsAdmin", ()=>$dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);
    var $9OXo1;
    const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAdmin || false;
    };
});
parcelRegister("hVf1M", function(module, exports) {
    $parcel$export(module.exports, "getIsProjectAdmin", ()=>$d8c128d9b214e073$export$34ff06260ad17f2b);
    $parcel$export(module.exports, "setIsProjectAdmin", ()=>$d8c128d9b214e073$export$d53e6d79d3fa5f31);
    let $d8c128d9b214e073$var$projectAdmin = null;
    const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
        if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
        if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
        return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
    };
    const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
        $d8c128d9b214e073$var$projectAdmin = projectAdminState;
    };
});
parcelRegister("hMrxB", function(module, exports) {
    $parcel$export(module.exports, "useProjectFavicon", ()=>$6ee68e956a566e2d$export$32abcb1f939de016);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $lpwtK;
    const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const iconEle = document.querySelector("link[rel='shortcut icon']");
        const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
            iconEle
        ]);
        const enabled = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-favicon-use-projecticon') === 'true', []);
        (0, $5uXOq.useEffect)(()=>{
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }, [
            project,
            iconEle,
            defaultFavicon,
            enabled
        ]);
    };
});
parcelRegister("8bzg2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gw9ua").then(()=>parcelRequire('8DuT4'));
});
parcelRegister("6Z2mh", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectLayout", ()=>$0836cf39cca1e468$export$e321cb31c875d1ba);
    $parcel$export(module.exports, "rightSidebarsLayout", ()=>$0836cf39cca1e468$export$820f9bb834280408);
    var $2vSU6;
    var $2BrOV;
    var $i90UH;
    var $1Du13;
    var $1XrjK;
    var $ln7rs;
    var $hPtZI;
    const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $0836cf39cca1e468$var$ProjectBuilder = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("hxOZ9")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/index.tsx"
    });
    const $0836cf39cca1e468$var$Onboarding = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("hqzS2")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
    });
    const $0836cf39cca1e468$var$RightSidebars = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("dyNBT")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {
        globalComponents: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
            $0836cf39cca1e468$var$withServiceProjectContext((0, (0, parcelRequire("i90UH")).AsyncJsmCustomDomainChangeBoardingFlag)),
            $0836cf39cca1e468$var$ProjectBuilder
        ],
        rightSidebars: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
        ]
    });
    const $0836cf39cca1e468$export$820f9bb834280408 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        rightSidebars: [
            $0836cf39cca1e468$var$RightSidebars
        ]
    });
});
parcelRegister("2BrOV", function(module, exports) {
    $parcel$export(module.exports, "globalLayout", ()=>$6d4ecb0834e594e8$export$929cb72e7acb7fd9);
    var $1XrjK;
    const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
    const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
    });
});
parcelRegister("i90UH", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", ()=>$3ba5f01428db990d$export$b1ef5e3da6e1959d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $hPtZI;
    const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("fPVwK")), {
        moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
    });
    const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-jsm-custom-domain-change-boarding-flag",
            packageName: "jira-help-center-custom-domain-change-boarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-custom-domain-change-boarding-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));
});
parcelRegister("fPVwK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("fgCot")
    ]).then(()=>parcelRequire('9d42Z'));
});
parcelRegister("ln7rs", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", ()=>$f6f2168537ade4c7$export$2562b2d784eadc10);
    var $5uXOq = parcelRequire("5uXOq");
    var $4YIAU;
    var $1XrjK;
    var $hPtZI;
    const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
        const ScopedComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YIAU")).default), {
                hasServiceDeskAccess: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null));
        const name = (0, (0, parcelRequire("1XrjK")).coalesce)(Component.displayName) ?? (0, (0, parcelRequire("1XrjK")).coalesce)(Component.name) ?? 'Component';
        ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
        return ScopedComponent;
    };
    const $f6f2168537ade4c7$var$Onboarding = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("d2WEB")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
    });
    const $f6f2168537ade4c7$var$RightSidebars = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("aGrqC")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/index.tsx"
    });
    const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
        ],
        rightSidebars: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
        ]
    });
});
parcelRegister("4YIAU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d82237ab91dce08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $1Yett;
    const $8d82237ab91dce08$var$AppPermissionsCheck = (props)=>{
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
            if ((0, (0, parcelRequire("1Yett")).isDevelopmentEnv)()) console.warn('AppPermissionsCheck should have defined at least one of access prop');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    $8d82237ab91dce08$var$AppPermissionsCheck.defaultProps = {
        hasCoreAccess: undefined,
        hasSoftwareAccess: undefined,
        hasServiceDeskAccess: undefined
    };
    var $8d82237ab91dce08$export$2e2bcd8739ae039 = $8d82237ab91dce08$var$AppPermissionsCheck;
});
parcelRegister("1Yett", function(module, exports) {
    $parcel$export(module.exports, "isDevelopmentEnv", ()=>$7b47955f7b675219$export$48e5fb80244b95c5);
    const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;
});
parcelRegister("d2WEB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lBhEF")
    ]).then(()=>parcelRequire('fY1ne'));
});
parcelRegister("aGrqC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("jlA2G")
    ]).then(()=>parcelRequire('lBfZ6'));
});
parcelRegister("hxOZ9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("b77bX")
    ]).then(()=>parcelRequire('fT1Vy'));
});
parcelRegister("hqzS2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eZivQ")
    ]).then(()=>parcelRequire('dOvA3'));
});
parcelRegister("dyNBT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8Ww2s")
    ]).then(()=>parcelRequire('4D7Qi'));
});
parcelRegister("e7bC3", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareProjectLayout", ()=>$43d4c7537a1fee65$export$3791efdd32024063);
    $parcel$export(module.exports, "softwareProjectLayout", ()=>$43d4c7537a1fee65$export$9a918616afa3328c);
    $parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$ada52b1309832862);
    $parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$6c1958653c44ba37);
    $parcel$export(module.exports, "softwareProjectLayoutCode", ()=>$43d4c7537a1fee65$export$ab7e607e8441dc61);
    var $2vSU6;
    var $1Du13;
    var $1XrjK;
    var $hPtZI;
    const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)
            }
        });
    const $43d4c7537a1fee65$var$Onboarding = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("iIRH3")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
    });
    const $43d4c7537a1fee65$var$OnboardingCode = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("nvZ7o")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/index.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebars = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("9Md0O")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebarsCode = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("eDMeh")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/index.tsx"
    });
    const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
    const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
    const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
    ];
    const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
    ];
    const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {});
    const $43d4c7537a1fee65$export$3791efdd32024063 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$9a918616afa3328c = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$ada52b1309832862 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboardingCode
        ]
    });
});
parcelRegister("iIRH3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5zn1B")
    ]).then(()=>parcelRequire('67mQl'));
});
parcelRegister("nvZ7o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9CFKR")
    ]).then(()=>parcelRequire('c0mAV'));
});
parcelRegister("9Md0O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("29qdR")
    ]).then(()=>parcelRequire('fHATI'));
});
parcelRegister("eDMeh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8pyxb")
    ]).then(()=>parcelRequire('3YyXe'));
});
parcelRegister("9Y3Lc", function(module, exports) {
    $parcel$export(module.exports, "userBoardLayout", ()=>$1760a1663e36faa5$export$7092b4ee86ae0b71);
    var $1XrjK;
    const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, (0, parcelRequire("1XrjK")).createLayout)();
});
parcelRegister("g5RGc", function(module, exports) {
    $parcel$export(module.exports, "fullPageIssuePreloadLayout", ()=>$59d96d961d806fee$export$98e337c40eb151da);
    $parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", ()=>$59d96d961d806fee$export$7b113174a456921a);
    var $1XrjK;
    var $lGGIs;
    var $hPtZI;
    var $lODMY;
    var $5DQxU;
    const $59d96d961d806fee$var$LazyIssuePage = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("f1yBu"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
    });
    const $59d96d961d806fee$var$AsyncIssueAppComponent = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(0, (0, parcelRequire("lGGIs")).markAsBentoBundleReady)((parcelRequire("jO7eF"))), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $59d96d961d806fee$var$imports = {
        fullPage: ()=>$59d96d961d806fee$var$LazyIssuePage.preload(),
        embedded: ()=>$59d96d961d806fee$var$AsyncIssueAppComponent.preload()
    };
    const $59d96d961d806fee$var$PrefetchCBBResourcesComponent = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("4NxWn")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
    });
    let $59d96d961d806fee$var$serverIssuePreloadIdentifier = '';
    if (!false && window.SPA_STATE?.serverIssuePreload) {
        const importSupplier = $59d96d961d806fee$var$imports[window.SPA_STATE.serverIssuePreload];
        importSupplier && importSupplier();
    }
    const $59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
    const $59d96d961d806fee$var$useParamsSelector = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>({
            query: state.query,
            params: state.match.params
        }));
    const $59d96d961d806fee$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
            const { query: query, params: params } = $59d96d961d806fee$var$useParamsSelector();
            if (!preloadContract || preloadContract.some((preloadingMatch)=>(!preloadingMatch.query || (0, (0, parcelRequire("5DQxU")).default)(preloadingMatch.query, query)) && (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
                if (!false) preloadSupplier();
                if (false) $59d96d961d806fee$var$serverIssuePreloadIdentifier = identifier;
                else performance.mark($59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK);
            }
            return null;
        };
    const $59d96d961d806fee$export$f55e6973062dc859 = ()=>$59d96d961d806fee$var$serverIssuePreloadIdentifier;
    const $59d96d961d806fee$var$FullPageIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('fullPage', $59d96d961d806fee$var$imports.fullPage);
    $59d96d961d806fee$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
    const $59d96d961d806fee$export$98e337c40eb151da = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $59d96d961d806fee$var$FullPageIssuePreloadComponent,
            $59d96d961d806fee$var$PrefetchCBBResourcesComponent
        ]
    });
    const $59d96d961d806fee$export$7b113174a456921a = (preloadContract)=>{
        const EmbeddedIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('embedded', $59d96d961d806fee$var$imports.embedded, preloadContract);
        EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
        return (0, (0, parcelRequire("1XrjK")).createLayout)({
            globalComponents: [
                EmbeddedIssuePreloadComponent
            ]
        });
    };
});
parcelRegister("lGGIs", function(module, exports) {
    $parcel$export(module.exports, "markAsBentoBundleReady", ()=>$7671cdebcdce4d73$export$d9ff0b3329728986);
    var $fDtbf;
    var $2SVPM;
    let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
    const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
            $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
                break;
            }
        });
        return importedBundle;
    };
});
parcelRegister("f1yBu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4GOBq")
    ]).then(()=>parcelRequire('kW74N'));
});
parcelRegister("jO7eF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("4NxWn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c6aDa").then(()=>parcelRequire('4n6tJ'));
});
parcelRegister("1FeCu", function(module, exports) {
    $parcel$export(module.exports, "smartRepliesOptInStatusResources", ()=>$420bb98aaad6bbf4$export$d9a3116994d66cfc);
    $parcel$export(module.exports, "useSmartRepliesPreferencesResources", ()=>$420bb98aaad6bbf4$export$8d607fdbd07ed6ca);
    var $dJl1T;
    var $jcw0u;
    var $aHuqL;
    var $2M1hQ;
    var $2YP9W;
    const $420bb98aaad6bbf4$export$d9a3116994d66cfc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $258f696a148ea88e$export$ea895d05049da93c),
        getKey: ()=>(0, $258f696a148ea88e$export$92a8ee31fa2d5df3),
        getData: async ()=>{
            let smartRepliesOptInStatus = null;
            try {
                smartRepliesOptInStatus = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $258f696a148ea88e$export$92a8ee31fa2d5df3));
            } catch (error) {
                if (error.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $258f696a148ea88e$export$92a8ee31fa2d5df3), (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b), error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'smartRepliesOptInStatusResources',
                        packageName: (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b),
                        teamName: 'jira-warepil'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                smartRepliesOptInStatus: smartRepliesOptInStatus
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $420bb98aaad6bbf4$export$8d607fdbd07ed6ca = ()=>{
        const { data: data, refresh: refresh, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)($420bb98aaad6bbf4$export$d9a3116994d66cfc);
        return {
            isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
            loading: loading,
            refreshData: refresh
        };
    };
});
parcelRegister("aHuqL", function(module, exports) {
    $parcel$export(module.exports, "userPreferenceAPI", ()=>$0f87ed1c6d708024$export$4f7929ca6b50a436);
    var $eusud;
    const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
    const $0f87ed1c6d708024$var$get = async (key)=>{
        try {
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)($0f87ed1c6d708024$var$url(key));
            return result?.value;
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            throw error;
        }
    };
    const $0f87ed1c6d708024$var$set = (key, value)=>(0, (0, parcelRequire("eusud")).performPutRequest)($0f87ed1c6d708024$var$url(key), {
            body: JSON.stringify({
                value: value
            })
        });
    const $0f87ed1c6d708024$var$remove = (key)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)($0f87ed1c6d708024$var$url(key));
    const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
        get: $0f87ed1c6d708024$var$get,
        set: $0f87ed1c6d708024$var$set,
        remove: $0f87ed1c6d708024$var$remove
    };
});
const $258f696a148ea88e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $258f696a148ea88e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $258f696a148ea88e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';
parcelRegister("7DqiA", function(module, exports) {
    $parcel$export(module.exports, "EmbedModeContext", ()=>$208612f70b1dde3d$export$5eb07b3c7c0b0771);
    $parcel$export(module.exports, "EmbedModeProvider", ()=>$208612f70b1dde3d$export$9daaf42d62e1c430);
    var $5uXOq = parcelRequire("5uXOq");
    const $208612f70b1dde3d$export$5eb07b3c7c0b0771 = (0, $5uXOq.createContext)(false);
    const { Provider: $208612f70b1dde3d$var$Provider } = $208612f70b1dde3d$export$5eb07b3c7c0b0771;
    const $208612f70b1dde3d$var$handleEmbedLinkClick = (e)=>{
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') eventTarget.target = '_blank';
    };
    const $208612f70b1dde3d$var$DarkModeMonolithStyleOverride = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, white)"};
                    }
                `
            }
        });
    const $208612f70b1dde3d$export$9daaf42d62e1c430 = ({ children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick, true);
            return ()=>{
                window.removeEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$DarkModeMonolithStyleOverride, null), (0, ($parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$Provider, {
            value: true
        }, children));
    };
});
parcelRegister("lmyls", function(module, exports) {
    $parcel$export(module.exports, "ADDON_ID", ()=>$ee51d260cb059727$export$6c4866a933650d1d);
    $parcel$export(module.exports, "MENU_ID", ()=>$ee51d260cb059727$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$ee51d260cb059727$export$adf978edbdfaf080);
    const $ee51d260cb059727$export$6c4866a933650d1d = {
        DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
    };
    const $ee51d260cb059727$export$d4cd258d01c03112 = {
        ADDONS: 'ADDONS',
        APP_SWITCHER: 'APP_SWITCHER',
        DASHBOARDS: 'DASHBOARDS',
        FILTERS: 'FILTERS',
        HELP: 'HELP',
        HOME: 'HOME',
        INSIGHT: 'INSIGHT',
        NOTIFICATIONS: 'NOTIFICATIONS',
        PEOPLE: 'PEOPLE',
        PLANS: 'PLANS',
        PROFILE: 'PROFILE',
        PROJECTS: 'PROJECTS',
        ROADMAPS: 'ROADMAPS',
        SEARCH: 'SEARCH',
        SERVICE_HUB: 'SERVICE_HUB',
        SETTINGS: 'SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
    const $ee51d260cb059727$export$adf978edbdfaf080 = {
        BOARD_SETTINGS: 'BOARD_SETTINGS',
        GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
        GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
        GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
        GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
        GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        PLAN_SETTINGS: 'PLAN_SETTINGS',
        PROJECT_SETTINGS: 'PROJECT_SETTINGS'
    };
});
const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';
parcelRegister("5bkvv", function(module, exports) {
    $parcel$export(module.exports, "forgeAdminModuleV1Resource", ()=>$3d515a0fe8e87c81$export$168ac1f97221e90b);
    $parcel$export(module.exports, "forgeAdminModuleV2Resource", ()=>$3d515a0fe8e87c81$export$536a08360f048bac);
    $parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", ()=>$3d515a0fe8e87c81$export$dcc98f4b36ce9223);
    $parcel$export(module.exports, "forgeProjectModuleV1Resource", ()=>$3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    $parcel$export(module.exports, "forgeProjectModuleV2Resource", ()=>$3d515a0fe8e87c81$export$1a17680eb0746291);
    $parcel$export(module.exports, "forgeProjectModuleResource", ()=>$3d515a0fe8e87c81$export$72db683c2914a65e);
    $parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", ()=>$3d515a0fe8e87c81$export$9f19b684a7493211);
    $parcel$export(module.exports, "forgeBacklogModuleResource", ()=>$3d515a0fe8e87c81$export$7523db37432ba090);
    $parcel$export(module.exports, "forgeBoardModuleResource", ()=>$3d515a0fe8e87c81$export$cfd99f451b423d3a);
    $parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", ()=>$3d515a0fe8e87c81$export$8a5aed164e925eb6);
    $parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", ()=>$3d515a0fe8e87c81$export$ec3265610584f9ce);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", ()=>$3d515a0fe8e87c81$export$fa67d109c2a45864);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", ()=>$3d515a0fe8e87c81$export$23c2bb87c561c9db);
    $parcel$export(module.exports, "forgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$7a928d209faf75f);
    $parcel$export(module.exports, "useForgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$e81e11bbc3239153);
    $parcel$export(module.exports, "forgeGlobalModuleV1Resource", ()=>$3d515a0fe8e87c81$export$60e774d0427b56fc);
    $parcel$export(module.exports, "forgeGlobalModuleV2Resource", ()=>$3d515a0fe8e87c81$export$75f594fe5ce76af);
    $parcel$export(module.exports, "getNavigationForgeGlobalPageResources", ()=>$3d515a0fe8e87c81$export$80b2f91dabb3dd65);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", ()=>$3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", ()=>$3d515a0fe8e87c81$export$d2d6bc2f3bd0f942);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", ()=>$3d515a0fe8e87c81$export$ebf5369e4dcfad00);
    $parcel$export(module.exports, "forgeCustomFieldTypeResource", ()=>$3d515a0fe8e87c81$export$e6be2f0ca0849869);
    var $8O7FC;
    var $4R6GH;
    var $k2DRb;
    var $5vSAE;
    var $iVaKa;
    var $3HwlS;
    var $dK8AG;
    var $gNStA;
    var $2M1hQ;
    var $2YP9W;
    var $47m5i;
    var $1yLrr;
    const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
        const isModuleWithAccessNarrowing = [
            (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(moduleName);
        const projectIdOrKey = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(params);
        if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
            projectIdOrKey: projectIdOrKey
        };
        return null;
    };
    const $3d515a0fe8e87c81$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            const { match: params } = route;
            const dataClassification = $3d515a0fe8e87c81$export$eb46cc3d7c1a6649(params, moduleName);
            const contextIds = typeof createContextIds === 'function' && createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }) || undefined;
            return (0, (0, parcelRequire("47m5i")).fetchForgeModule)({
                cloudId: cloudId,
                moduleName: moduleName,
                dataClassification: dataClassification,
                shouldReturnANExtensions: shouldReturnANExtensions,
                contextIds: contextIds,
                locale: locale
            });
        };
    const $3d515a0fe8e87c81$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
    const $3d515a0fe8e87c81$export$168ac1f97221e90b = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$536a08360f048bac = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).adminPageFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeAdminModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$536a08360f048bac, $3d515a0fe8e87c81$export$168ac1f97221e90b);
    const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
            $3d515a0fe8e87c81$var$forgeAdminModuleResource
        ];
    const $3d515a0fe8e87c81$export$ad95e2d07d6fa1a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$1a17680eb0746291 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$1a17680eb0746291, $3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    const $3d515a0fe8e87c81$export$9f19b684a7493211 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-nav-remove-resources')), $3d515a0fe8e87c81$export$72db683c2914a65e);
    const $3d515a0fe8e87c81$export$88e58f509f84795a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_BACKLOG_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).BACKLOG_ACTION_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).BACKLOG_ACTION_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$7523db37432ba090 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$88e58f509f84795a);
    const $3d515a0fe8e87c81$export$21d6f142a9a5af9d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_BOARD_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).BOARD_ACTION_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).BOARD_ACTION_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$cfd99f451b423d3a = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$21d6f142a9a5af9d);
    const $3d515a0fe8e87c81$export$72583833ca0600c0 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PERSONAL_SETTINGS_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PERSONAL_SETTINGS_PAGE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PERSONAL_SETTINGS_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$8a5aed164e925eb6 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$72583833ca0600c0);
    const $3d515a0fe8e87c81$export$ec3265610584f9ce = ()=>[
            $3d515a0fe8e87c81$export$8a5aed164e925eb6
        ];
    const $3d515a0fe8e87c81$export$fa67d109c2a45864 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$23c2bb87c561c9db = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$23c2bb87c561c9db, $3d515a0fe8e87c81$export$fa67d109c2a45864);
    const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
    const $3d515a0fe8e87c81$export$60e774d0427b56fc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$75f594fe5ce76af = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeGlobalModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$75f594fe5ce76af, $3d515a0fe8e87c81$export$60e774d0427b56fc);
    const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
            $3d515a0fe8e87c81$var$forgeGlobalModuleResource
        ];
    const $3d515a0fe8e87c81$export$b555dc3ff28ae9cc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942, $3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
        getKey: ()=>'extensions',
        getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, activationId: activationId, locale: locale } })=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                types: [
                    (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION)
            }).then((modules)=>modules[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE]) : (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION), $3d515a0fe8e87c81$var$createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }), locale).then((modules)=>modules.extensions.jiraCustomFieldType),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
        return filter(modules).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title));
    }
});
parcelRegister("8O7FC", function(module, exports) {
    $parcel$export(module.exports, "alphabeticalSort", ()=>$7c4745a46edf6307$export$89a1f01f2a7cb2a1);
    var $dJl1T;
    const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
        if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
            numeric: true,
            caseFirst: 'upper'
        });
        const typeOfA = a === null ? 'null' : typeof a;
        const typeOfB = b === null ? 'null' : typeof b;
        const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
        return 1;
    };
});
parcelRegister("k2DRb", function(module, exports) {
    $parcel$export(module.exports, "STAGING_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$71acbd662c478c42);
    $parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$978072fd3fd149);
    $parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", ()=>$e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
    $parcel$export(module.exports, "BACKLOG_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$516a8fb49ad5d50e);
    $parcel$export(module.exports, "BOARD_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$6cc3a1f2111dee11);
    $parcel$export(module.exports, "ISSUE_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
    $parcel$export(module.exports, "ISSUE_GLANCE_MODULE", ()=>$e80aa4d4aac5b0dc$export$259bab989b0129d0);
    $parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", ()=>$e80aa4d4aac5b0dc$export$75f224942f595e13);
    $parcel$export(module.exports, "ISSUE_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$ba0968f9752844);
    $parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$7e2136b4285d29f5);
    $parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", ()=>$e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
    $parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$9069d4b945c3d532);
    $parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", ()=>$e80aa4d4aac5b0dc$export$811b7f067a43b422);
    $parcel$export(module.exports, "CUSTOM_FIELD_MODULE", ()=>$e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
    $parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
    $parcel$export(module.exports, "ADMIN_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
    $parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58);
    $parcel$export(module.exports, "PROJECT_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$151b03356f566603);
    $parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
    $parcel$export(module.exports, "GLOBAL_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
    $parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$353acf28daa75c79);
    $parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", ()=>$e80aa4d4aac5b0dc$export$25627f012b21b0b9);
    $parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", ()=>$e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
    $parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", ()=>$e80aa4d4aac5b0dc$export$a7186e5a73395db4);
    $parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
    $parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$8af4cb794979f60d);
    $parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$5592ab836d562168);
    $parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$842eb4236828ac9);
    $parcel$export(module.exports, "SUPPORTED_MODULES", ()=>$e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
    $parcel$export(module.exports, "ENTRY_POINT_EDIT", ()=>$e80aa4d4aac5b0dc$export$2b8aeda236486576);
    $parcel$export(module.exports, "ENTRY_POINT_VIEW", ()=>$e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
    $parcel$export(module.exports, "ENTRY_POINT_CREATE", ()=>$e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
    $parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", ()=>$e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
    $parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", ()=>$e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
    $parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", ()=>$e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", ()=>$e80aa4d4aac5b0dc$export$8e96118a698216cb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", ()=>$e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", ()=>$e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
    $parcel$export(module.exports, "SOURCE_UNKNOWN", ()=>$e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
    $parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", ()=>$e80aa4d4aac5b0dc$export$61d882aa7aba51c);
    $parcel$export(module.exports, "SOURCE_ISSUE_VIEW", ()=>$e80aa4d4aac5b0dc$export$46cb92762d68a048);
    $parcel$export(module.exports, "SOURCE_NAVIGATION", ()=>$e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
    $parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", ()=>$e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
    $parcel$export(module.exports, "SOURCE_ROUTER", ()=>$e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
    $parcel$export(module.exports, "SOURCE_LEGACY", ()=>$e80aa4d4aac5b0dc$export$ac11ee191d09688f);
    $parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", ()=>$e80aa4d4aac5b0dc$export$4346e4e240c84319);
    $parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", ()=>$e80aa4d4aac5b0dc$export$d719bb340dc354e4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", ()=>$e80aa4d4aac5b0dc$export$4b6228758e800433);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", ()=>$e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", ()=>$e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
    $parcel$export(module.exports, "getEmptyExtensionsObject", ()=>$e80aa4d4aac5b0dc$export$218a328f66b86f7d);
    $parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$3193d714ab54ee26);
    $parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$df7774a415710cce);
    $parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$51ab2784839ce348);
    const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
    const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
    const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
    const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
    const $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e = 'jira:backlogAction';
    const $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11 = 'jira:boardAction';
    const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
    const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
    const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
    const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
    const $e80aa4d4aac5b0dc$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
    const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
    const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
    const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
    const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
    const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
    const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
    const $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
    const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
    const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
    const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
    const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
    const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
    const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
    const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
    const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
    const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
    const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
    const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
    const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
        $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e,
        $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11,
        $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
        $e80aa4d4aac5b0dc$export$259bab989b0129d0,
        $e80aa4d4aac5b0dc$export$75f224942f595e13,
        $e80aa4d4aac5b0dc$export$7e2136b4285d29f5,
        $e80aa4d4aac5b0dc$export$ba0968f9752844,
        $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
        $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
        $e80aa4d4aac5b0dc$export$811b7f067a43b422,
        $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
        $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
        $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
        $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58,
        $e80aa4d4aac5b0dc$export$151b03356f566603,
        $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
        $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
        $e80aa4d4aac5b0dc$export$353acf28daa75c79,
        $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
        $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
        $e80aa4d4aac5b0dc$export$5592ab836d562168,
        $e80aa4d4aac5b0dc$export$842eb4236828ac9,
        $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
        $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
        $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
    ];
    const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
    const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
    const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
    const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
    const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
    const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
    const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
    const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
    const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
    const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
    const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
    const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
    const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
    const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
    const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
    const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
    const $e80aa4d4aac5b0dc$export$6d00582aa947900f = 'workflow-list';
    const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
    const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
    const $e80aa4d4aac5b0dc$export$bf75cf7720bd8fde = 'transition-view';
    const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
    const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
    const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
    const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
        jiraBacklogAction: [],
        jiraBoardAction: [],
        jiraIssueAction: [],
        jiraIssueContext: [],
        jiraIssueGlance: [],
        jiraIssuePanel: [],
        jiraIssueNavigatorAction: [],
        jiraIssueActivity: [],
        jiraIssueViewBackgroundScript: [],
        jiraCustomField: [],
        jiraCustomFieldType: [],
        jiraUiModifications: [],
        jiraAdminPage: [],
        jiraGlobalPage: [],
        jiraPersonalSettingsPage: [],
        jiraProjectPage: [],
        jiraProjectSettingsPage: [],
        jiraDashboardBackgroundScript: [],
        jiraDashboardGadget: [],
        jiraServiceManagementQueuePage: [],
        jiraServiceManagementOrganizationPanel: [],
        jiraServiceManagementAssetsImportType: [],
        jiraWorkflowValidator: [],
        jiraWorkflowCondition: [],
        jiraWorkflowPostFunction: []
    };
    const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
        ...$e80aa4d4aac5b0dc$export$a48dade1864725a
    };
    const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
            ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
        });
    const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
    const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
    const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;
});
parcelRegister("5vSAE", function(module, exports) {
    $parcel$export(module.exports, "fetchModules", ()=>$f16089506a319d17$export$24d8e11b15325c53);
    var $gPjkL;
    var $iF2Fb;
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $5yJb9;
    var $gPjkL;
    var $d5W4H;
    var $dyPNS;
    var $829Wu;
    const $f16089506a319d17$export$24d8e11b15325c53 = async (params)=>{
        const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN) } = params;
        if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModulesV2)({
            cloudId: cloudId,
            isAnonymous: isAnonymous
        })) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
        try {
            const extensions = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fetch_modules_v2_track_graphql_errors') ? $f16089506a319d17$export$9f9fdbce0829073d(params) : $f16089506a319d17$export$8ff66c70be1c563a(params));
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source);
            return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error
            });
            if ($f16089506a319d17$export$458cbcb6374269d2.includes(errorType)) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
            throw error;
        }
    };
    function $f16089506a319d17$export$8ff66c70be1c563a(props) {
        const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
        if (types.length === 0) throw new Error('No modules to fetch provided');
        return (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("iF2Fb")).default), {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes
        }).toPromise().then((response)=>{
            return (response.jira.forge.extensions.concat());
        });
    }
    function $f16089506a319d17$export$9f9fdbce0829073d(props) {
        const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
        if (types.length === 0) throw new Error('No modules to fetch provided');
        const operationName = (0, (0, parcelRequire("gPjkL")).default).params.name;
        const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, (0, parcelRequire("829Wu")).trackGraphQLErrors)(operationName);
        let extensions;
        return new Promise((resolve, reject)=>{
            const subscription = (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("gPjkL")).default), {
                cloudId: cloudId,
                context: context,
                types: types,
                includeHidden: includeHidden,
                includeScopes: includeScopes
            }).subscribe({
                next: (response)=>{
                    stopGraphQLErrorTracking();
                    extensions = response.jira?.forge?.extensions?.concat() || null;
                },
                error: (error)=>{
                    stopGraphQLErrorTracking();
                    reject(error);
                    subscription.unsubscribe();
                },
                complete: ()=>{
                    const graphQLError = getGraphQLError();
                    if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                    else resolve(extensions || []);
                    subscription.unsubscribe();
                }
            });
        });
    }
    const $f16089506a319d17$export$458cbcb6374269d2 = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
});
parcelRegister("gPjkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13cd104237d48c31$export$2e2bcd8739ae039);
    const $13cd104237d48c31$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeScopes"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }, v5 = {
            "kind": "ScalarField",
            "name": "type"
        }, v6 = [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "context",
                                        "variableName": "context"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeHidden",
                                        "variableName": "includeHidden"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "types",
                                        "variableName": "types"
                                    }
                                ],
                                "concreteType": "JiraForgeExtension",
                                "kind": "LinkedField",
                                "name": "extensions",
                                "plural": true,
                                "selections": [
                                    {
                                        "condition": "includeHidden",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hiddenBy"
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "includeScopes",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "scopes"
                                            }
                                        ]
                                    },
                                    v5,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "environmentId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "environmentKey"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "environmentType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "installationId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "appVersion"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "consentUrl"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "properties"
                                    },
                                    {
                                        "concreteType": "JiraForgeAppEgressDeclaration",
                                        "kind": "LinkedField",
                                        "name": "egress",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "addresses"
                                            },
                                            v5
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraForgeExtensionLicense",
                                        "kind": "LinkedField",
                                        "name": "license",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "active"
                                            },
                                            v5,
                                            {
                                                "kind": "ScalarField",
                                                "name": "supportEntitlementNumber"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "trialEndDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "subscriptionEndDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEvaluation"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "billingPeriod"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "ccpEntitlementId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "ccpEntitlementSlug"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "capabilitySet"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "fetchModulesV2Query",
                "selections": v6,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v2,
                    v3
                ],
                "kind": "Operation",
                "name": "fetchModulesV2Query",
                "selections": v6
            },
            "params": {
                "id": "7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05",
                "metadata": {},
                "name": "fetchModulesV2Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $13cd104237d48c31$var$node.hash = "d4447f6e3aeb1f24abb3040ce32ed32e";
    var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;
});
parcelRegister("iF2Fb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b58deea83e036a3b$export$2e2bcd8739ae039);
    const $b58deea83e036a3b$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeScopes"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }, v5 = {
            "kind": "ScalarField",
            "name": "type"
        }, v6 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "condition": "includeHidden",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hiddenBy"
                        }
                    ]
                },
                {
                    "condition": "includeScopes",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "scopes"
                        }
                    ]
                },
                v5,
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "properties"
                },
                {
                    "concreteType": "JiraForgeAppEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        v5
                    ]
                },
                {
                    "concreteType": "JiraForgeExtensionLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        v5,
                        {
                            "kind": "ScalarField",
                            "name": "supportEntitlementNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        }
                    ]
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "fetchModulesV2WithRequiredFieldsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraForgeQuery",
                                        "kind": "LinkedField",
                                        "name": "forge",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v6,
                                                "action": "THROW",
                                                "path": "jira.forge.extensions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.forge"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v2,
                    v3
                ],
                "kind": "Operation",
                "name": "fetchModulesV2WithRequiredFieldsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraForgeQuery",
                                "kind": "LinkedField",
                                "name": "forge",
                                "plural": false,
                                "selections": [
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "14dc2e0bf3b401ce840b3e1a223d47e96fdc3b6a996d26622c4f4d27d10b5289",
                "metadata": {},
                "name": "fetchModulesV2WithRequiredFieldsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $b58deea83e036a3b$var$node.hash = "ec5d4710082629da1d1b34e6e1bbd55b";
    var $b58deea83e036a3b$export$2e2bcd8739ae039 = $b58deea83e036a3b$var$node;
});
parcelRegister("bPtOr", function(module, exports) {
    $parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", ()=>$e4bddb38a31390d9$export$23de3198bfe70090);
    $parcel$export(module.exports, "FAILED_TO_FETCH", ()=>$e4bddb38a31390d9$export$f52aa41ccd776f01);
    $parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", ()=>$e4bddb38a31390d9$export$31d2ab0be67934f0);
    $parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", ()=>$e4bddb38a31390d9$export$89a175d4190df42e);
    $parcel$export(module.exports, "userConsentErrorRegex", ()=>$e4bddb38a31390d9$export$dddade71b333c01d);
    $parcel$export(module.exports, "getErrorType", ()=>$e4bddb38a31390d9$export$e19f9f08a6d79fd2);
    var $fZneA;
    var $bvblX;
    var $7NJFp;
    const $e4bddb38a31390d9$var$commonErrors = {
        MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
        OPERATION_ABORTED: 'The operation was aborted. ',
        CANCELLED: 'cancelled',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        TIMEOUT: 'The request timed out.',
        AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
        GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
        GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
    };
    const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
    const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
    const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
    const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
    const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
    const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
    const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
        if ((0, (0, parcelRequire("7NJFp")).isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
        const KNOWN_NETWORK_ERRORS = [
            'Failed to fetch dynamically imported module',
            'error loading dynamically imported module',
            'Importing a module script failed'
        ];
        const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
        return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
    };
    const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
        if (_error == null) return 'NULL_OR_UNDEFINED';
        const error = _error;
        const message = String(error instanceof Error ? error.message : error).trim();
        const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
        if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
        const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
        if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
        const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
        const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
        if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
        const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
        if (serverErrorRegex.test(message)) {
            const match = message.match(serverErrorRegex);
            const statusCode = match ? match[1] : 'NO_STATUS_CODE';
            return `ERROR_SERVER_RESPONSE_${statusCode}`;
        }
        const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
        if (aggGiraServerErrorRegex.test(message)) {
            const match = message.match(aggGiraServerErrorRegex);
            const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
            return `AGG_GIRA_ERROR_${statusCode}`;
        }
        if (error instanceof (0, (0, parcelRequire("bvblX")).TrackedGraphQLError)) {
            if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $e4bddb38a31390d9$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
            return 'TRACKED_GRAPHQL_ERROR';
        }
        const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
        const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
        if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
        if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
        const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
        if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
        if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
        const appValueFunction = new RegExp("The app's value function failed", 'i');
        const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
        const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
        const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
        const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
        if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
        const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
        if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
        const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
        if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
        if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
        if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
        if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
        if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
        const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        if (entry) return entry[0];
        if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
        return 'OTHER';
    };
});
parcelRegister("bvblX", function(module, exports) {
    $parcel$export(module.exports, "TrackedGraphQLError", ()=>$b1b2278e9c04b70b$export$f2062ad173e74c75);
    class $b1b2278e9c04b70b$export$f2062ad173e74c75 extends Error {
        constructor(errorMessage, errors, traceIds){
            super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
            this.errors = errors;
            this.traceId = traceIds?.[0];
            this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
            this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
        }
    }
});
parcelRegister("dYScp", function(module, exports) {
    $parcel$export(module.exports, "measureExecutionTimeMetrics", ()=>$d79aabebae5ffeb3$export$a859f6866f4653e0);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $hBuqR;
    var $8kVg1;
    const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
        const concurrentId = (0, ($parcel$interopDefault($7Jxgt)))();
        const shouldSendTimeMetric = Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE);
        if ((0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).cancel();
            throw error;
        }
        else try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).cancel();
            throw error;
        }
    };
});
parcelRegister("hBuqR", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME_GASV3", ()=>$bbc089ab376d4a7b$export$f892f621fb508154);
    $parcel$export(module.exports, "MODULE_TYPE_TRIGGER", ()=>$bbc089ab376d4a7b$export$ed63b053e04e26df);
    $parcel$export(module.exports, "MODULE_TYPE_EXTENSION", ()=>$bbc089ab376d4a7b$export$725bacc669333eef);
    $parcel$export(module.exports, "FORGE_SAMPLING_RATE", ()=>$bbc089ab376d4a7b$export$d920cee73ec094d0);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$bbc089ab376d4a7b$export$f048d91ccaf92408);
    $parcel$export(module.exports, "UI_ACTIONS", ()=>$bbc089ab376d4a7b$export$2b7367f125154866);
    $parcel$export(module.exports, "OPERATIONAL_ACTIONS", ()=>$bbc089ab376d4a7b$export$42bcca5cae2ce90b);
    $parcel$export(module.exports, "TRACK_ACTIONS", ()=>$bbc089ab376d4a7b$export$2af0438304d7c4b2);
    const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
    const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
    const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
    const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
    const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
    const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
        FORGE_MODULES: {
            FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
            LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
        },
        REAL_TIME_ISSUE_EVENTS: {
            INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
        },
        MARKS: {
            TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
            TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
        }
    };
    const $bbc089ab376d4a7b$export$2b7367f125154866 = {
        CLICKED: 'clicked',
        SELECTED: 'selected',
        CANCELED: 'canceled',
        ACTION_CLICKED: 'action clicked',
        COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
        REMOVE_CLICKED: 'remove clicked'
    };
    const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
        FAILED: 'failed',
        INITIALIZED: 'initialized',
        EDIT_FAILED: 'edit failed',
        ACTION_FAILED: 'action failed',
        SAVE_FAILED: 'save failed',
        REMOVE_FAILED: 'remove failed',
        UPDATE_FAILED: 'update failed'
    };
    const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
        EDITED: 'edited',
        SAVED: 'saved',
        REMOVED: 'removed',
        ACTION_SUCCEED: 'action succeed',
        UPDATE_SUCCEED: 'update succeed'
    };
});
parcelRegister("8kVg1", function(module, exports) {
    $parcel$export(module.exports, "forgeModulesFetchTime", ()=>$f1fed22795d0c676$export$cd129f3639657eae);
    $parcel$export(module.exports, "forgeModulesConcurrentFetchTime", ()=>$f1fed22795d0c676$export$c3d8833fbea3e976);
    $parcel$export(module.exports, "forgeModulesConcurrentLoadTime", ()=>$f1fed22795d0c676$export$292f3b557281044f);
    $parcel$export(module.exports, "realTimeIssueEventInvokeTime", ()=>$f1fed22795d0c676$export$89ace7e2bb7d7685);
    $parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", ()=>$f1fed22795d0c676$export$94f65f3b2556df23);
    $parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", ()=>$f1fed22795d0c676$export$116d5e25caf0018d);
    $parcel$export(module.exports, "customFieldPageSegmentLoadMetric", ()=>$f1fed22795d0c676$export$3bd38623c2543fc0);
    $parcel$export(module.exports, "customFieldInteractionMetric", ()=>$f1fed22795d0c676$export$a318f99472db73c8);
    var $cHBMC;
    var $6RCeq;
    var $hNAhd;
    var $d3cxT;
    var $hBuqR;
    const $f1fed22795d0c676$export$cd129f3639657eae = (0, (0, parcelRequire("cHBMC")).metrics).custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, (0, parcelRequire("cHBMC")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$292f3b557281044f = (0, (0, parcelRequire("cHBMC")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
    });
    const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, (0, parcelRequire("d3cxT")).UFOExperience)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
        type: (0, (0, parcelRequire("hNAhd")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).InlineResult
    });
    async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
        if (false || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).length > 0 || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).length > 0) return fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(startMark);
        const result = await fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(endMark);
        return result;
    }
    const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
        additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: cleanStart,
                        cleanEnd: undefined
                    })),
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: undefined,
                        cleanEnd: cleanEnd
                    }))
            ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
            metric.mark(name, startTime);
            if (cleanStart || cleanEnd) (0, (0, parcelRequire("6RCeq")).default).clearMarks(name);
        });
    };
    const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, (0, parcelRequire("cHBMC")).metrics).pageSegmentLoad({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings,
                {
                    key: 'tti',
                    startMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_START,
                    endMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_END
                }
            ]
        });
    const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, (0, parcelRequire("cHBMC")).metrics).interaction({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings
            ]
        });
});
parcelRegister("bOLUk", function(module, exports) {
    $parcel$export(module.exports, "fireInitializationFetchFinishedEvent", ()=>$2f4555f4bd0f0eef$export$132ca822850e455f);
    $parcel$export(module.exports, "fireInitializationFetchFailedEvent", ()=>$2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
    $parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", ()=>$2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
    $parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", ()=>$2f4555f4bd0f0eef$export$b274c658390b491b);
    var $4R6GH;
    var $6yg2S;
    var $8uOa6;
    const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
        STARTED: 'started',
        FINISHED: 'finished',
        FAILED: 'failed'
    };
    const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, (0, parcelRequire("6yg2S")).toEventId)('issueViewInitialization');
    const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, (0, parcelRequire("6yg2S")).toEventId)('fetchModulesInitialization');
    const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
});
parcelRegister("6yg2S", function(module, exports) {
    $parcel$export(module.exports, "toEventId", ()=>$cb46d7d052e3d68d$export$75e84ef5a3771f9a);
    const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;
});
parcelRegister("8uOa6", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$73635d33815c9f98$export$a1fb57756f0de62b);
    $parcel$export(module.exports, "fireUiEvent", ()=>$73635d33815c9f98$export$bed7f228c94e5f2a);
    $parcel$export(module.exports, "fireTrackEvent", ()=>$73635d33815c9f98$export$574d2f19a52d67ca);
    $parcel$export(module.exports, "fireInitializationEvent", ()=>$73635d33815c9f98$export$390a62413962e4f0);
    var $fjcgS;
    var $hBuqR;
    var $6MtPV;
    var $7yD9b;
    var $eGXs2;
    const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: source = 'unknownSource', action: action, attributes: attributes })=>({
            actionSubject: `${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${id}`,
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes),
            source: source,
            action: action
        });
    const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)()).getInstance();
    const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
            $73635d33815c9f98$export$a1fb57756f0de62b(action, {
                id: id,
                attributes: attributes,
                source: source
            }),
            attributes?.error && (0, (0, parcelRequire("7yD9b")).logError)((0, (0, parcelRequire("7yD9b")).ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, (0, parcelRequire("eGXs2")).isSynthetic)().toString()}, id=${id}, source=${(0, (0, parcelRequire("6MtPV")).parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
        ]);
});
parcelRegister("6MtPV", function(module, exports) {
    $parcel$export(module.exports, "parseSource", ()=>$31dca5b0e1651a2f$export$e98201ef9a88ba70);
    $parcel$export(module.exports, "createAttributes", ()=>$31dca5b0e1651a2f$export$c7c9603a6b1fd815);
    var $84Tib = parcelRequire("84Tib");
    var $9uiWt;
    var $bPtOr;
    var $eGXs2;
    const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
    const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
            ...error,
            stack: error.stack,
            message: error?.message
        });
    const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
        const attributes = {
            isSynthetic: (0, (0, parcelRequire("eGXs2")).isSynthetic)(),
            isOverridingFragments: (0, (0, parcelRequire("9uiWt")).isOverridingFragments)(),
            isSSR: false
        };
        if (rawAttributes) {
            const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
            if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
            if (error) {
                attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
                attributes.errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            }
            if ((0, ($parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
        }
        return {
            ...rawAttributes,
            ...attributes
        };
    };
});
parcelRegister("9uiWt", function(module, exports) {
    $parcel$export(module.exports, "isOverridingFragments", ()=>$c677f4c9cc5e982f$export$1d1321d2b374d697);
    const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
});
parcelRegister("eGXs2", function(module, exports) {
    $parcel$export(module.exports, "isSynthetic", ()=>$58ae13ec31f88266$export$947749d756ccb0a);
    var $4R6GH;
    var $j8DrX;
    const $58ae13ec31f88266$export$947749d756ccb0a = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('forge_ui_synthetic_check');
});
parcelRegister("7yD9b", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_UTIL", ()=>$187fc325525eefe3$export$d1e4f308040bb0d5);
    $parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", ()=>$187fc325525eefe3$export$36f315a5c6daf40b);
    $parcel$export(module.exports, "logError", ()=>$187fc325525eefe3$export$58da9968c3170cb1);
    var $dJl1T;
    var $hBuqR;
    const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
    const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
    const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
    const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
        [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.analytics`,
        [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
        [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
    };
    const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
    };
});
parcelRegister("5yJb9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    var $aWXMn;
    let $0dfb67cb8d2ba29a$var$relayEnvironment;
    function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
        if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
            const environmentConfig = (0, (0, parcelRequire("aWXMn")).getRelayEnvironmentConfig)();
            $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
        }
        return $0dfb67cb8d2ba29a$var$relayEnvironment;
    }
});
parcelRegister("aWXMn", function(module, exports) {
    $parcel$export(module.exports, "getRelayEnvironmentConfig", ()=>$eb7981c11bea2531$export$a451c85db2d1cda3);
    var $4XQuR;
    var $d89yU;
    var $hk5bM;
    const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, (0, parcelRequire("hk5bM")).getDefaultRelayEnvironmentConfig)({
            network: (0, (0, parcelRequire("d89yU")).getNetwork)(),
            log: (0, (0, parcelRequire("4XQuR")).default),
            requiredFieldLogger: (0, parcelRequire("4XQuR")).requiredFieldLogger
        });
});
parcelRegister("4XQuR", function(module, exports) {
    $parcel$export(module.exports, "requiredFieldLogger", ()=>$50b0aa0805b37d6d$export$1ab8b98d209afe85);
    $parcel$export(module.exports, "default", ()=>$50b0aa0805b37d6d$export$2e2bcd8739ae039);
    var $iNl9c;
    var $dJl1T;
    var $jQsty;
    const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
    const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
    const $50b0aa0805b37d6d$var$requests = {};
    const $50b0aa0805b37d6d$var$queries = {};
    const $50b0aa0805b37d6d$var$resources = {};
    const $50b0aa0805b37d6d$var$executes = {};
    const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000;
    const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
            kind: event.kind,
            owner: event.owner,
            fieldPath: event.fieldPath,
            message: event.kind === 'relay_resolver.error' ? event.error?.message : null
        });
    };
    const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
        if (resp.data === undefined) return 0;
        try {
            return JSON.stringify(resp.data).length;
        } catch (e) {
            return 0;
        }
    };
    function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
        if ((0, (0, parcelRequire("jQsty")).default)('relay_log')) return;
        switch(event.name){
            case 'network.start':
                {
                    const networkStart = performance.now();
                    const { networkRequestId: networkRequestId } = event;
                    const { name: name } = event.params;
                    const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                    if (requestInfo == null) {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: networkStart,
                            networkStart: networkStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                            delete $50b0aa0805b37d6d$var$queries[name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    } else requestInfo.networkStart = networkStart;
                    break;
                }
            case 'network.next':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (requestInfo != null) {
                        const { response: response } = event;
                        const addFlush = (resp)=>{
                            if (resp.data !== null) {
                                const res = resp;
                                const flush = {
                                    label: res.label != null ? res.label : 'root',
                                    time: performance.now(),
                                    size: $50b0aa0805b37d6d$var$getResponseSize(res)
                                };
                                requestInfo.flushes?.push(flush);
                            }
                        };
                        Array.isArray(response) ? response.forEach(addFlush) : addFlush(response);
                    }
                    break;
                }
            case 'network.error':
                {
                    const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (info != null) info.error = event.error;
                    break;
                }
            case 'network.info':
                break;
            case 'network.complete':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    const networkComplete = performance.now();
                    if (requestInfo != null) {
                        const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                        requestInfo.size = size;
                        requestInfo.networkComplete = networkComplete;
                        requestInfo.flushes = [];
                        (0, (0, parcelRequire("iNl9c")).addSpanToAll)('relay', requestInfo.name, [
                            {
                                name: 'network'
                            }
                        ], requestInfo.start, requestInfo.networkComplete, size);
                    }
                    break;
                }
            case 'network.unsubscribe':
                break;
            case 'suspense.fragment':
                break;
            case 'suspense.query':
                break;
            case 'queryresource.fetch':
                {
                    const { node: node } = event.operation.root;
                    const fetchStart = performance.now();
                    if (node.name != null) {
                        const { name: name } = node;
                        const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                        if (requestInfo != null) {
                            requestInfo.fetchStart = fetchStart;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                        } else {
                            const newRequestInfo = {
                                name: name,
                                flushes: [],
                                start: fetchStart,
                                fetchStart: fetchStart
                            };
                            $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                            setTimeout(()=>{
                                delete $50b0aa0805b37d6d$var$queries[node.name];
                            }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                        }
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    break;
                }
            case 'queryresource.retain':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                    if (requestInfo != null && event.profilerContext != null) {
                        requestInfo.end = performance.now();
                        const context = event.profilerContext;
                        context?.retainQuery?.(requestInfo);
                    }
                    break;
                }
            case 'execute.start':
                $50b0aa0805b37d6d$var$executes[event.executeId] = {
                    name: event.params.name,
                    kind: event.params.operationKind,
                    start: performance.now(),
                    duration: 0
                };
                break;
            case 'execute.next':
                $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
                break;
            case 'execute.async.module':
                break;
            case 'execute.flight.payload_deserialize':
                break;
            case 'execute.error':
                delete $50b0aa0805b37d6d$var$executes[event.executeId];
                break;
            case 'execute.complete':
                {
                    const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                    if (op != null) {
                        op.end = performance.now();
                        delete $50b0aa0805b37d6d$var$executes[event.executeId];
                    }
                    break;
                }
            case 'store.publish':
                break;
            case 'store.snapshot':
                break;
            case 'store.restore':
                break;
            case 'store.gc':
                break;
            case 'store.notify.start':
                break;
            case 'store.notify.complete':
                break;
            case 'store.notify.subscription':
                break;
            case 'entrypoint.root.consume':
                break;
            default:
                break;
        }
    }
});
parcelRegister("d89yU", function(module, exports) {
    $parcel$export(module.exports, "getNetwork", ()=>$7997274d03790a98$export$7de4970ebfd8206d);
    var $eiowN = parcelRequire("eiowN");
    var $gIJXH;
    var $k1TrK;
    var $fwvto;
    const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
        if ((0, (0, parcelRequire("fwvto")).isSSR)()) (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch));
        return (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch), (0, (0, parcelRequire("k1TrK")).subscribe));
    };
});
parcelRegister("gIJXH", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);
    var $hGgHi = parcelRequire("hGgHi");
    var $1UikQ = parcelRequire("1UikQ");
    var $eiowN = parcelRequire("eiowN");
    var $kzQRc;
    var $lPqEZ;
    var $aDvGo;
    var $jJZqs;
    var $eusud;
    var $6b2ko;
    var $4tcSU;
    var $5a0Nh;
    var $gwtGO;
    var $kipqU;
    var $7pVV3;
    var $ajjqZ;
    var $fGa3b;
    var $5smup;
    var $7dbuH;
    var $lKFKm;
    var $7isEg;
    let $2963ed038d5e3581$var$redirecting = false;
    const $2963ed038d5e3581$var$redirect = ()=>{
        const identity = (0, (0, parcelRequire("kzQRc")).getATLContextDomain)('id');
        const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
        window.location.href = redirectUrl;
    };
    const $2963ed038d5e3581$var$blocklist = [
        'issueAggQuery'
    ];
    const $2963ed038d5e3581$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
        if (operationKind === 'query') return 0, (0, parcelRequire("6b2ko")).RETRY_ATTEMPTS_LIMIT;
        return 0;
    };
    const $2963ed038d5e3581$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
        if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') return extensions.gateway.request_id;
        return undefined;
    };
    const $2963ed038d5e3581$var$generateOptions = (options = {})=>{
        const csrfToken = !false ? (0, (0, parcelRequire("4tcSU")).default)() : undefined;
        const csrfTokenHeader = (0, ($parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
            'atl-xsrf-token': csrfToken
        };
        return (0, ($parcel$interopDefault($1UikQ)))({}, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }, {
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(','),
                ...csrfTokenHeader
            }
        });
    };
    const $2963ed038d5e3581$var$checkAuthentication = ()=>{
        if (!false && !$2963ed038d5e3581$var$redirecting) {
            const heartbeatService = (0, (0, parcelRequire("lPqEZ")).getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $2963ed038d5e3581$var$redirect();
                $2963ed038d5e3581$var$redirecting = true;
            }
        }
    };
    const $2963ed038d5e3581$export$7bfea3c3d460ecd8 = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) return [
            502,
            503,
            504
        ].includes(error.statusCode);
        return false;
    };
    const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
        $2963ed038d5e3581$var$checkAuthentication();
        if ($2963ed038d5e3581$var$redirecting) return (0, $eiowN.Observable).from(new Promise(()=>{}));
        const { name: queryName, operationKind: operationKind } = request;
        const earlyScriptPromise = !false && (0, (0, parcelRequire("ajjqZ")).claimEarlyScriptPromise)((0, (0, parcelRequire("ajjqZ")).getEarlyScriptPromiseKey)(request, variables)) || undefined;
        const loggingMetadata = {
            queryName: queryName,
            operationKind: operationKind
        };
        const loggingAndMetrics = (0, (0, parcelRequire("7isEg")).getLoggingAndMetricsHelper)(loggingMetadata);
        return (0, $eiowN.Observable).create((sink)=>{
            try {
                const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
                const endpoint = (0, (0, parcelRequire("5smup")).getAggEndpoint)(request, cacheConfig);
                const body = (0, (0, parcelRequire("5smup")).getRequestBody)(request, variables);
                let ssrCache = null;
                if (!false && requestID != null) ssrCache = (0, (0, parcelRequire("7pVV3")).QueryResponseCache).get(requestID, variables);
                if (!false && !(0, ($parcel$interopDefault($hGgHi)))(ssrCache)) {
                    sink.next(ssrCache);
                    if (requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).delete(requestID, variables);
                    sink.complete();
                    return;
                }
                const wrappedEarlyScriptPromise = earlyScriptPromise && (0, (0, parcelRequire("6b2ko")).retryOnError)(()=>(0, (0, parcelRequire("eusud")).applyErrorHandling)(earlyScriptPromise), {
                    retryFunc: ()=>(0, (0, parcelRequire("eusud")).performPostRequest)(endpoint, $2963ed038d5e3581$var$generateOptions({
                            body: body
                        })),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                });
                const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, (0, parcelRequire("eusud")).performPostRequestWithRetry)(endpoint, {
                    ...$2963ed038d5e3581$var$generateOptions({
                        body: body
                    }),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: (error, attempt)=>{
                        loggingAndMetrics.logErrorRetry(error, attempt);
                    }
                }));
                promise.then((response)=>{
                    (0, (0, parcelRequire("7dbuH")).addTraceId)(queryName, $2963ed038d5e3581$var$getTraceIdFromExtensions(response));
                    (0, (0, parcelRequire("fGa3b")).putExtensions)(queryName, response.extensions);
                    const errors = response.errors || undefined;
                    if (errors != null) {
                        const requestId = response?.extensions?.gateway?.request_id;
                        if (!$2963ed038d5e3581$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                        (0, (0, parcelRequire("5a0Nh")).captureErrors)(errors, {
                            operationName: queryName,
                            requestId: requestId
                        });
                        if ((0, (0, parcelRequire("5a0Nh")).isUnauthenticated)(errors)) {
                            (0, (0, parcelRequire("lKFKm")).showUnauthenticatedFlag)(queryName);
                            return;
                        }
                    }
                    if (response.data && (response.data.jira === null || response.data.customerService === null)) response.data = null;
                    if (false && requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                    sink.next(response);
                    sink.complete();
                }).catch((error)=>{
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                });
                if (requestID != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).set(requestID, promise);
            } catch (error) {
                loggingAndMetrics.logError(error);
                sink.error(error);
            }
        });
    };
});
parcelRegister("5a0Nh", function(module, exports) {
    $parcel$export(module.exports, "startCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$c211170518c6d0f6);
    $parcel$export(module.exports, "stopCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$e0491a0d974dadfa);
    $parcel$export(module.exports, "captureErrors", ()=>$cf86a52470c84b66$export$7a973c0ff390eb47);
    $parcel$export(module.exports, "isUnauthenticated", ()=>$cf86a52470c84b66$export$1724ecfee73c4768);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $cf86a52470c84b66$var$errorCollector = new Map();
    const $cf86a52470c84b66$export$da396ad2a542b095 = 120000;
    const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
        setTimeout(()=>{
            $cf86a52470c84b66$var$errorCollector.delete(key);
        }, $cf86a52470c84b66$export$da396ad2a542b095);
    };
    const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, ($parcel$interopDefault($7Jxgt))).v4())=>{
        $cf86a52470c84b66$var$errorCollector.set(key, []);
        $cf86a52470c84b66$var$scheduleCleanup(key);
        return key;
    };
    const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
        const errors = $cf86a52470c84b66$var$errorCollector.get(key);
        $cf86a52470c84b66$var$errorCollector.delete(key);
        return errors || [];
    };
    const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
        if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
            $cf86a52470c84b66$var$errorCollector.set(key, [
                ...value,
                {
                    errors: errors,
                    meta: meta
                }
            ]);
        });
    };
    const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
        if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
        return false;
    };
});
parcelRegister("gwtGO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1019e315ad42f34a$export$2e2bcd8739ae039);
    var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
        'ariGraph',
        'boardCardMove',
        'deleteCard',
        'JiraJqlBuilder',
        'SoftwareCardTypeTransitions',
        'jira-releases-v0',
        'JiraDevOps',
        'JiraDevOpsProviders',
        'createCustomFilter',
        'updateCustomFilter',
        'deleteCustomFilter',
        'customFilters',
        'PermissionScheme',
        'JiraIssue',
        'projectStyle',
        'startSprintPrototype',
        'AddIssuesToFixVersion',
        'JiraVersionResult',
        'JiraIssueConnectionJql',
        'JiraFieldOptionSearching',
        'JiraIssueFieldMutations',
        'JiraIssueDevInfoDetails',
        'JiraIssueDevSummaryCache',
        'JiraVersionWarningConfig',
        'JiraReleaseNotesConfiguration',
        'JiraUpdateReleaseNotesConfiguration',
        'ReleaseNotes',
        'ReleaseNotesOptions',
        'DeploymentsFeaturePrecondition',
        'UpdateVersionWarningConfig',
        'UpdateVersionName',
        'UpdateVersionDescription',
        'UpdateVersionStartDate',
        'UpdateVersionReleaseDate',
        'VersionsForProject',
        'RelatedWork',
        'SuggestedRelatedWorkCategories',
        'setIssueMediaVisibility',
        'toggleBoardFeature',
        'DevOpsProvider',
        'DevOpsSummarisedDeployments',
        'JiraProject',
        'DevOpsSummarisedEntities',
        'RoadmapsMutation',
        'RoadmapsQuery',
        'JiraApplicationProperties',
        'JiraIssueSearch',
        'JiraFilter',
        'featureGroups',
        'setBoardEstimationType',
        'devOps',
        'softwareBoards',
        'name',
        'AddRelatedWorkToVersion',
        'RemoveRelatedWorkFromVersion',
        'admins',
        'canAdministerBoard',
        'jql',
        'globalCardCreateAdditionalFields',
        'GlobalTimeTrackingSettings',
        'ReleaseNotesOptions',
        'search-experience',
        'MoveOrRemoveIssuesToFixVersion',
        'compass-beta',
        'JiraIssueSearchStatus',
        'Townsquare',
        'JiraNavigationItems',
        'JiraVersionsForProjects',
        'columnConfigs'
    ];
});
parcelRegister("kipqU", function(module, exports) {
    $parcel$export(module.exports, "QueryPromisesMap", ()=>$f428f7f15822f637$export$607b80f5bc6e396d);
    const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
});
parcelRegister("7pVV3", function(module, exports) {
    $parcel$export(module.exports, "QueryResponseCache", ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $eiowN = parcelRequire("eiowN");
    var $dJl1T;
    var $4R6GH;
    var $jJZqs;
    var $kizcd;
    function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
        return JSON.stringify((0, $eiowN.stableCopy)({
            queryID: queryID,
            variables: variables
        }));
    }
    function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
        return JSON.parse(cacheKey).queryID;
    }
    const $675c7f0a9d659efe$export$da2711d74cd28aed = [
        'fetchModulesV2Query',
        'fetchModulesV2WithRequiredFieldsQuery'
    ];
    class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
        constructor({ cacheName: cacheName, size: size, ttl: ttl }){
            super({
                size: size,
                ttl: ttl
            });
            let cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
            if (!false && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) cachedData = window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
            this.cacheName = cacheName;
            this.requestMetadata = new Map(cachedData.requestMetadata);
            this._responses = new Map(cachedData.responses);
            if (!false) setTimeout(()=>{
                this.logUnusedPayloadErrors();
                this.requestMetadata.clear();
                this._responses.clear();
            }, 60000);
        }
        logUnusedPayloadErrors() {
            const loggedQueries = new Set();
            this._responses.forEach((response, key)=>{
                const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
                const metadata = this.requestMetadata.get(queryID);
                const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                    queryName: 'unknown',
                    operationKind: 'unknown'
                };
                if (!loggedQueries.has(queryName) && !$675c7f0a9d659efe$export$da2711d74cd28aed.includes(queryName)) {
                    loggedQueries.add(queryName);
                    const error = new (0, (0, parcelRequire("kizcd")).UnusedRelayResponseError)(queryID);
                    const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'statusCode'
                    ], null);
                    const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                        message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                        errorType: errorType,
                        statusCode: statusCode,
                        queryName: queryName,
                        operationKind: operationKind,
                        errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                            'name'
                        ], null)
                    });
                }
            });
        }
        setWithMetadata(queryID, variables, payload, metadata) {
            this.requestMetadata.set(queryID, metadata);
            this.set(queryID, variables, payload);
        }
        delete(queryID, variables) {
            const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
            return this._responses.delete(cacheKey);
        }
        serialize() {
            return {
                [this.cacheName]: {
                    requestMetadata: Array.from(this.requestMetadata.entries()),
                    responses: Array.from(this._responses.entries())
                }
            };
        }
    }
    const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
    const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d.serialize();
});
parcelRegister("kizcd", function(module, exports) {
    $parcel$export(module.exports, "UnusedRelayResponseError", ()=>$f174935352f053b0$export$8431e42d062de453);
    class $f174935352f053b0$export$8431e42d062de453 extends Error {
        constructor(queryID){
            super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
        }
    }
});
parcelRegister("ajjqZ", function(module, exports) {
    $parcel$export(module.exports, "getEarlyScriptPromiseKey", ()=>$383b599fde987e1e$export$1102c06c7da91223);
    $parcel$export(module.exports, "claimEarlyScriptPromise", ()=>$383b599fde987e1e$export$828ac0325bce4536);
    $parcel$export(module.exports, "putEarlyScriptPromise", ()=>$383b599fde987e1e$export$e1336d32be02faf4);
    $parcel$export(module.exports, "earlyFetch", ()=>$383b599fde987e1e$export$5b55058781674413);
    var $6ui18;
    var $l83Uu;
    var $eKonk;
    var $5smup;
    const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
    const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
    const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
    const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
        if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
        const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
        const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
        return `${params.name}|${String(queryId)}|${serializedVariables}`;
    };
    const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
        const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
        if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
        return result;
    };
    const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
        if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
    };
    const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
        (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:start');
        const endpoint = (0, (0, parcelRequire("5smup")).getAggEndpoint)(compiledQuery.params);
        const body = (0, (0, parcelRequire("5smup")).getRequestBody)(compiledQuery.params, variables);
        const capabilityHeader = (0, (0, parcelRequire("eKonk")).getEnhancedCapabilityHeader)(capability ?? null);
        $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
            credentials: 'same-origin',
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'Content-Type': 'application/json',
                Accept: 'application/json,text/javascript,*/*',
                'X-ExperimentalApi': experimentalApis.join(','),
                ...(0, (0, parcelRequire("6ui18")).getActiveTraceHttpRequestHeaders)(endpoint),
                ...capabilityHeader ? {
                    [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
                } : {}
            },
            method: 'POST',
            body: body
        }).then((response)=>{
            (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:end');
            return response;
        }));
    };
});
parcelRegister("l83Uu", function(module, exports) {
    $parcel$export(module.exports, "setMark", ()=>$ef655a7b07a35675$export$f7a1fb90d8604165);
    $parcel$export(module.exports, "getTraceId", ()=>$ef655a7b07a35675$export$e88cb5bfb57ce9c4);
    const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
        if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
        performance.mark(mark);
    };
    const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
    const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
    const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);
});
parcelRegister("lKFKm", function(module, exports) {
    $parcel$export(module.exports, "showUnauthenticatedFlag", ()=>$42cb6e1c2fdc593e$export$758fcc357484571e);
    var $pa9q9;
    var $fjcgS;
    var $8iiwm;
    const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
    const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendTrackEvent({
                action: 'showed',
                actionSubject: 'unauthorizedFlag',
                attributes: {
                    operation: operationName
                },
                source: 'jiraRelayFetch'
            });
        });
    };
    const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
        (0, (0, parcelRequire("pa9q9")).showFlag)({
            type: 'error',
            title: (0, (0, parcelRequire("8iiwm")).default).title,
            description: (0, (0, parcelRequire("8iiwm")).default).description,
            actions: [
                {
                    content: (0, (0, parcelRequire("8iiwm")).default).login,
                    onClick: $42cb6e1c2fdc593e$var$reloadPage
                }
            ]
        });
        $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
    };
});
parcelRegister("pa9q9", function(module, exports) {
    $parcel$export(module.exports, "showFlag", ()=>$00ff685527f9e8c1$export$e12b2cc6b75b006b);
    $parcel$export(module.exports, "dismissFlag", ()=>$00ff685527f9e8c1$export$900a08a292ad23cd);
    $parcel$export(module.exports, "flagService", ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0);
    $parcel$export(module.exports, "useFlagsService", ()=>$00ff685527f9e8c1$export$eee61a1aafe3884);
    $parcel$export(module.exports, "useFlagService", ()=>$00ff685527f9e8c1$export$dc4f8132c3090b32);
    $parcel$export(module.exports, "isDismissFlag", ()=>$00ff685527f9e8c1$export$14b1864d9cf0809f);
    $parcel$export(module.exports, "isFlagComponent", ()=>$00ff685527f9e8c1$export$d84ce5adcee46025);
    $parcel$export(module.exports, "isBatchAction", ()=>$00ff685527f9e8c1$export$c126d8b307b8ab86);
    var $fHfPB;
    var $gEdnQ;
    var $01A9Z;
    var $7HGHK;
    const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, (0, parcelRequire("gEdnQ")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, (0, parcelRequire("fHfPB")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
        $00ff685527f9e8c1$export$900a08a292ad23cd((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
    };
    const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, (0, parcelRequire("01A9Z")).store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
    const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
    };
    const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
            showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
            dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
            hasFlag: $00ff685527f9e8c1$var$hasFlag
        });
    const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
    const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND);
    const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
    const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
    const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
    const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);
});
parcelRegister("fHfPB", function(module, exports) {
    $parcel$export(module.exports, "dismissFlag", ()=>$8eb241d1a1f5d9b7$export$900a08a292ad23cd);
    $parcel$export(module.exports, "default", ()=>$8eb241d1a1f5d9b7$export$2e2bcd8739ae039);
    var $d6YjM;
    var $7HGHK;
    const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
            command: (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND),
            id: flagId
        });
    var $8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
            dispatch((0, (0, parcelRequire("d6YjM")).dismissFlagAction)(action.id));
        };
});
parcelRegister("d6YjM", function(module, exports) {
    $parcel$export(module.exports, "SHOW", ()=>$07f19e2fef34903b$export$9d04158a25ce4cd);
    $parcel$export(module.exports, "show", ()=>$07f19e2fef34903b$export$57bf213be019eeb0);
    $parcel$export(module.exports, "DISMISS_INSTANCE", ()=>$07f19e2fef34903b$export$b31a07d2e6382678);
    $parcel$export(module.exports, "dismiss", ()=>$07f19e2fef34903b$export$abf286bbe7073aba);
    $parcel$export(module.exports, "DISMISS_FLAG", ()=>$07f19e2fef34903b$export$1eb56620df104bf);
    $parcel$export(module.exports, "dismissFlagAction", ()=>$07f19e2fef34903b$export$4818b3c52448050d);
    $parcel$export(module.exports, "RESET", ()=>$07f19e2fef34903b$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$07f19e2fef34903b$export$aad8462122ac592b);
    const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
    const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
            type: $07f19e2fef34903b$export$9d04158a25ce4cd,
            payload: payload
        });
    const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
    const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
            type: $07f19e2fef34903b$export$b31a07d2e6382678,
            payload: payload
        });
    const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
    const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
            type: $07f19e2fef34903b$export$1eb56620df104bf,
            payload: payload
        });
    const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
    const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
            type: $07f19e2fef34903b$export$4a991c87e640ef77
        });
});
parcelRegister("7HGHK", function(module, exports) {
    $parcel$export(module.exports, "DISMISS_COMMAND", ()=>$9deb2cdefe93babb$export$e705274c5e156b93);
    $parcel$export(module.exports, "toFlagId", ()=>$9deb2cdefe93babb$export$8184bc29de2aea90);
    $parcel$export(module.exports, "fromFlagId", ()=>$9deb2cdefe93babb$export$188cdb77b72629d7);
    const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
    const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
    const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();
});
parcelRegister("gEdnQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c019df33694ffbe1$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    var $7HGHK;
    var $c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
            if (typeof flag === 'function') {
                dispatch((0, (0, parcelRequire("d6YjM")).show)(flag));
                return undefined;
            }
            const flagId = flag.id || (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt))).v4());
            const newFlag = {
                ...flag,
                id: flagId
            };
            dispatch((0, (0, parcelRequire("d6YjM")).show)(newFlag));
            return flagId;
        };
});
parcelRegister("01A9Z", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$5787309a6ab0ba9c$export$6f57813fe9f31bf9);
    var $imvpl;
    const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("imvpl")).createStore)();
});
parcelRegister("imvpl", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$6bbcd4b408b9a94e$export$f51a9068ac82ea43);
    var $F2Mxm;
    var $gG398;
    const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'flags',
            rootReducer: (0, parcelRequire("gG398")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("F2Mxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fca77440264e922e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $aB8eX = parcelRequire("aB8eX");
    var $e1AU2 = parcelRequire("e1AU2");
    var $iGv2H;
    var $hkadP;
    var $i9gPl;
    var $fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
        const actionListenerMiddleware = new (0, (0, parcelRequire("i9gPl")).default)();
        middlewares.push(actionListenerMiddleware.perform);
        if ((0, (0, parcelRequire("iGv2H")).debugEnabled)('redux-logger')) {
            const { logger: logger } = (parcelRequire("korqb"));
            middlewares.push(logger);
        }
        if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
            dependencies: rootEpicDependencies
        } : undefined));
        const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, (0, parcelRequire("hkadP")).default)({
            name: appName,
            serialize: {
                replacer: (key, value)=>{
                    if ((0, $5uXOq.isValidElement)(value)) {
                        if (value.type && value.type.displayName) return `React Element <${value.type.displayName}>`;
                        return 'React Element';
                    }
                    if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                    return value;
                }
            }
        })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
        store.addActionListener = actionListenerMiddleware.add;
        store.removeActionListener = actionListenerMiddleware.remove;
        return store;
    };
});
parcelRegister("iGv2H", function(module, exports) {
    $parcel$export(module.exports, "debugEnabled", ()=>$a4079cece44c0fab$export$342c99cc1e9bc5c6);
    const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);
});
parcelRegister("hkadP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$607c98afd3082218$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
        const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        const config = {
            ...devtoolsConfig
        };
        if (config.name != null && config.instanceId == null) config.instanceId = config.name;
        return 0, $3f2cs.compose;
    };
});
parcelRegister("i9gPl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$330df53c22ed8aaf$export$2e2bcd8739ae039);
    class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
        constructor(){
            this.listeners = [];
            this.add = (listener)=>{
                this.listeners.push(listener);
            };
            this.remove = (listener)=>{
                this.listeners = this.listeners.filter((l)=>l !== listener);
            };
            this.perform = (api)=>(next)=>(action)=>{
                        const result = next(action);
                        this.listeners.forEach((listener)=>listener(action, api.getState()));
                        return result;
                    };
        }
    }
});
parcelRegister("gG398", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1feeabef4760da78$export$2e2bcd8739ae039);
    var $ifg6x = parcelRequire("ifg6x");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    const $1feeabef4760da78$var$defaultState = {
        flags: []
    };
    var $1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("d6YjM")).SHOW:
                {
                    const [lowPriorityFlags, highPriorityFlags] = (0, ($parcel$interopDefault($ifg6x)))([
                        {
                            id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                            flag: action.payload
                        },
                        ...state.flags
                    ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                    const flags = [
                        ...highPriorityFlags,
                        ...lowPriorityFlags
                    ];
                    return {
                        ...state,
                        flags: flags
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_INSTANCE:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_FLAG:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>{
                            if (flagInstance.flag.id) return flagInstance.flag.id !== id;
                            return true;
                        })
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).RESET:
                return $1feeabef4760da78$var$defaultState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("8iiwm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7ec0f26423b786$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "relay-fetch.services.error-flags.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "relay-fetch.services.error-flags.description",
            "defaultMessage": "Looks like you've been signed out. Try logging in again. "
        },
        login: {
            "id": "relay-fetch.services.error-flags.login",
            "defaultMessage": "Log in"
        }
    });
});
parcelRegister("7isEg", function(module, exports) {
    $parcel$export(module.exports, "getLoggingAndMetricsHelper", ()=>$6c554999a424d172$export$726e1df8186bb981);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $hGgHi = parcelRequire("hGgHi");
    var $dJl1T;
    var $jJZqs;
    const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
    const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
        const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
        return {
            logNonBreakingErrors: (errors, requestId)=>{
                if (false || (0, ($parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
                errors.forEach((error)=>{
                    error && (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                        queryName: queryName,
                        operationKind: operationKind,
                        errorType: 'graphql',
                        message: error.message,
                        requestId: requestId
                    });
                });
            },
            logError: (error)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            },
            logErrorRetry: (error, retryAttempt)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null),
                    retryAttempt: retryAttempt
                });
            }
        };
    };
});
parcelRegister("k1TrK", function(module, exports) {
    $parcel$export(module.exports, "subscribe", ()=>$4ced6779db298dc0$export$ec068583843480e7);
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $lWhTC;
    var $1Uhm6;
    var $cfDZ3;
    const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
            const client = (0, (0, parcelRequire("lWhTC")).getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id
                }
            };
            let requestId;
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    const aggRequestId = value?.extensions?.agg?.request_id;
                    requestId = aggRequestId ?? requestId;
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, (0, parcelRequire("1Uhm6")).getSinkError)(sinkError);
                    const attributes = {
                        operationName: operationName,
                        requestId: requestId,
                        userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                    };
                    sink.error(errorInfo);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'subscription',
                            packageName: 'jiraRelaySubscription',
                            teamName: 'uip-graphql'
                        },
                        error: errorInfo,
                        attributes: attributes,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        });
});
parcelRegister("lWhTC", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$2a46eca1e9133707$export$6bb76d6eba7e258c);
    var $4U1PW;
    var $jQsty;
    var $gwtGO;
    var $hoQbP;
    let $2a46eca1e9133707$var$client;
    const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
        if ((0, (0, parcelRequire("hoQbP")).isSSR)() || (0, (0, parcelRequire("jQsty")).default)('graphql_subscriptions')) return null;
        if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, (0, parcelRequire("4U1PW")).createClient)({
            url: (0, (0, parcelRequire("hoQbP")).getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
            retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(',')
            }
        });
        return $2a46eca1e9133707$var$client;
    };
    const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
        $2a46eca1e9133707$var$client = null;
    };
});
const $37d1b046897e548f$export$8b012b965402e06a = 580000;
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000;
parcelRegister("hoQbP", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$9e6d9986231c3fe5$export$48d7c418edadb60c);
    $parcel$export(module.exports, "getAggSubscriptionEndpoint", ()=>$9e6d9986231c3fe5$export$29a72e89601dfc59);
    const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
    const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
});
parcelRegister("1Uhm6", function(module, exports) {
    $parcel$export(module.exports, "getSinkError", ()=>$db2d4e9951ebaa0f$export$ece4736473c28965);
    const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
        let errorInfo;
        if (Array.isArray(error)) [errorInfo] = error;
        else if (error instanceof Error) errorInfo = error;
        else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
        else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
        else errorInfo = new Error(`Unknown sink error: ${error}`);
        return errorInfo;
    };
});
parcelRegister("fwvto", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$c5bf640417859136$export$48d7c418edadb60c);
    const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;
});
parcelRegister("d5W4H", function(module, exports) {
    $parcel$export(module.exports, "canFetchForgeModules", ()=>$f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
    $parcel$export(module.exports, "canFetchForgeModulesV2", ()=>$f4d6ea2b45e6b20f$export$8d182bef16e04eb0);
    var $4Pf62;
    const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ()=>{
        const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
    const $f4d6ea2b45e6b20f$export$8d182bef16e04eb0 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
});
parcelRegister("dyPNS", function(module, exports) {
    $parcel$export(module.exports, "toMappedExtensions", ()=>$12d1a959cf63073a$export$e073e0c0d1c23345);
    function $12d1a959cf63073a$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
        const result = Object.fromEntries(requestedModules.map((type)=>[
                type,
                []
            ]));
        returnedExtensions.forEach((extension)=>{
            result[extension.type]?.push(extension);
        });
        return result;
    }
});
parcelRegister("829Wu", function(module, exports) {
    $parcel$export(module.exports, "trackGraphQLErrors", ()=>$c9a2f92573d2ebfa$export$a5c00ff206a4c88b);
    var $bvblX;
    var $5a0Nh;
    var $7dbuH;
    function $c9a2f92573d2ebfa$export$a5c00ff206a4c88b(operationName) {
        const queryId = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
        (0, (0, parcelRequire("7dbuH")).startCapturingTraceIds)(operationName);
        return {
            stopGraphQLErrorTracking: ()=>(0, (0, parcelRequire("7dbuH")).stopCapturingTraceIds)(operationName),
            getGraphQLError: ()=>$c9a2f92573d2ebfa$var$getGraphQLError(queryId, operationName)
        };
    }
    function $c9a2f92573d2ebfa$var$getGraphQLError(key, operationName) {
        const errors = (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
        if (errors.length) return new (0, (0, parcelRequire("bvblX")).TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, (0, parcelRequire("7dbuH")).getTraceIds)(operationName));
        return undefined;
    }
});
parcelRegister("iVaKa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b1a9656c7bb4ee4$export$2e2bcd8739ae039);
    var $e4eHl = parcelRequire("e4eHl");
    var $fn8B5 = parcelRequire("fn8B5");
    var $cuHs1 = parcelRequire("cuHs1");
    var $1UikQ = parcelRequire("1UikQ");
    var $4R6GH;
    var $eusud;
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $d5W4H;
    var $1MlDe;
    var $lG6pQ;
    var $ioGTN;
    var $dnsCJ;
    var $eIGUr;
    const $1b1a9656c7bb4ee4$var$moduleToVariableKey = (module)=>(0, ($parcel$interopDefault($e4eHl)))(module);
    const $1b1a9656c7bb4ee4$export$3361e9be8093ddcc = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key));
        return (0, ($parcel$interopDefault($1UikQ)))(groupedExtensionsWithMappedKeys, (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
    };
    const $1b1a9656c7bb4ee4$export$44097e02a91cd11a = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($1UikQ)))((0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key)), (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
        const filteredOutDuplicatedExtensions = (0, (0, parcelRequire("1MlDe")).filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
        const allowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        const accessNarrowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
            const allowedExtensionsMap = new Map();
            const accessNarrowedExtensionsMap = new Map();
            module.forEach((moduleItem)=>{
                if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
                else allowedExtensionsMap.set(moduleItem.id, moduleItem);
            });
            allowedExtensions[key] = [
                ...allowedExtensionsMap.values()
            ];
            accessNarrowedExtensions[key] = [
                ...accessNarrowedExtensionsMap.values()
            ];
        });
        return {
            extensions: allowedExtensions,
            accessNarrowedExtensions: accessNarrowedExtensions
        };
    };
    const $1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
    const $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
        if (modules.length === 0) throw new Error('No modules to fetch provided');
        const { data: data, errors: errors, extensions: extensions } = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(async ()=>{
            const dataClassificationTags = await (0, (0, parcelRequire("lG6pQ")).getDataClassification)(dataClassification, source);
            const includeConfig = extras?.include || {};
            const query = (0, (0, parcelRequire("eIGUr")).buildForgeQuery)(includeConfig);
            const variables = {
                contextIds: contextIds || [
                    `ari:cloud:jira::site/${cloudId}`
                ],
                extensionsFilter: [
                    {
                        type: 'EXTENSION_TYPE',
                        value: modules
                    }
                ],
                dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
                locale: (0, (0, parcelRequire("4R6GH")).fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
            };
            return (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: variables
                }),
                method: 'POST'
            });
        });
        const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromExtensions)({
            extensions: extensions
        });
        if (errors) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
        if (!data) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No data returned', traceId, errors);
        if (data.extensionContexts.length < 1) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No extensionContext returned', traceId, errors);
        return {
            data: data,
            traceId: traceId
        };
    };
    var $1b1a9656c7bb4ee4$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN), contextIds, locale)=>{
        try {
            if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModules)()) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            const { data: data, traceId: traceId } = await $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source, {
                traceId: traceId
            });
            return $1b1a9656c7bb4ee4$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromError)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error,
                traceId: traceId
            });
            if ($1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            throw error;
        }
    };
});
parcelRegister("1MlDe", function(module, exports) {
    $parcel$export(module.exports, "filterOutDuplicatedExtensions", ()=>$11a6461020d3329a$export$e0393e97f15a28a5);
    var $lbWm4 = parcelRequire("lbWm4");
    var $k2DRb;
    const $11a6461020d3329a$export$e0393e97f15a28a5 = (modules)=>{
        const filteredModules = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        (0, ($parcel$interopDefault($lbWm4)))(modules, (module, propName)=>{
            const moduleExtensions = new Map();
            (0, ($parcel$interopDefault($lbWm4)))(module, (moduleItem)=>{
                const moduleExtension = moduleExtensions.get(moduleItem.id);
                const appVersion = moduleItem?.appVersion || '0.0.0';
                const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
                if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
            });
            filteredModules[propName] = [
                ...moduleExtensions.values()
            ];
        });
        return filteredModules;
    };
});
parcelRegister("lG6pQ", function(module, exports) {
    $parcel$export(module.exports, "getDataClassification", ()=>$013c8a0b6d7ef450$export$1635afa94064952c);
    var $eusud;
    var $bPtOr;
    var $bOLUk;
    var $dqtU7;
    var $6P5IG;
    const $013c8a0b6d7ef450$var$handleError = (err, source)=>{
        const errorMessage = err instanceof Error ? err.message : String(err);
        const error = Error(`Data classification request failed: ${errorMessage}`);
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        if (errorType === (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)) throw error;
        (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        return [];
    };
    async function $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    async function $013c8a0b6d7ef450$var$getDataClassificationProject(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    const $013c8a0b6d7ef450$export$1635afa94064952c = async (props, source)=>{
        if (props !== null) {
            if ((0, (0, parcelRequire("dqtU7")).hasPrefetchedData)(props)) return props.tags;
            if ((0, (0, parcelRequire("dqtU7")).hasProjectIdOrKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationProject(props, source);
                return tags;
            }
            if ((0, (0, parcelRequire("dqtU7")).hasIssueKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source);
                return tags;
            }
        }
        return [];
    };
});
parcelRegister("dqtU7", function(module, exports) {
    $parcel$export(module.exports, "hasPrefetchedData", ()=>$3920146879a40338$export$c19d255b92c7c2da);
    $parcel$export(module.exports, "hasProjectIdOrKey", ()=>$3920146879a40338$export$494434246e5dea0d);
    $parcel$export(module.exports, "hasIssueKey", ()=>$3920146879a40338$export$b1490cfc7a90c75b);
    var $8LQ84 = parcelRequire("8LQ84");
    const $3920146879a40338$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, ($parcel$interopDefault($8LQ84)))(props.tags);
    const $3920146879a40338$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
    const $3920146879a40338$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;
});
parcelRegister("6P5IG", function(module, exports) {
    $parcel$export(module.exports, "TTL", ()=>$ca591e08be1a6f54$export$6ebb1381174e92a7);
    $parcel$export(module.exports, "issueKeyPrefix", ()=>$ca591e08be1a6f54$export$a040db2850f159b0);
    $parcel$export(module.exports, "projectKeyPrefix", ()=>$ca591e08be1a6f54$export$df256a06d24ff906);
    $parcel$export(module.exports, "DataClassificationTagsCache", ()=>$ca591e08be1a6f54$export$b7adc37405b5ff0d);
    const $ca591e08be1a6f54$export$6ebb1381174e92a7 = 60000;
    const $ca591e08be1a6f54$export$a040db2850f159b0 = 'issue';
    const $ca591e08be1a6f54$export$df256a06d24ff906 = 'project';
    const $ca591e08be1a6f54$export$b7adc37405b5ff0d = new Map();
});
parcelRegister("ioGTN", function(module, exports) {
    $parcel$export(module.exports, "ForgeFetchError", ()=>$03e8a2344fd340fa$export$2e3b53e53bafa);
    class $03e8a2344fd340fa$export$2e3b53e53bafa extends Error {
        constructor(message, traceId, errors){
            super(message);
            this.name = $03e8a2344fd340fa$export$2e3b53e53bafa.name;
            this.traceId = traceId;
            this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, $03e8a2344fd340fa$export$2e3b53e53bafa);
        }
    }
});
parcelRegister("dnsCJ", function(module, exports) {
    $parcel$export(module.exports, "getTraceIdFromExtensions", ()=>$06cecb1cf20a09b8$export$eefb7f54c3b07211);
    $parcel$export(module.exports, "getTraceIdFromError", ()=>$06cecb1cf20a09b8$export$9955d05ba83067ba);
    var $jJZqs;
    var $ioGTN;
    const $06cecb1cf20a09b8$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
        const traceId = extensions?.gateway?.request_id;
        if (traceId && typeof traceId === 'string') return traceId;
        return undefined;
    };
    const $06cecb1cf20a09b8$export$9955d05ba83067ba = (error)=>{
        if (error instanceof (0, (0, parcelRequire("ioGTN")).ForgeFetchError) || error instanceof (0, (0, parcelRequire("jJZqs")).default)) return error.traceId;
        return undefined;
    };
});
parcelRegister("eIGUr", function(module, exports) {
    $parcel$export(module.exports, "buildForgeQuery", ()=>$5112ddb3344b355d$export$497b2dc04db7bd76);
    const $5112ddb3344b355d$export$497b2dc04db7bd76 = (include)=>{
        const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
        const scopesField = include.scopes === true ? 'scopes' : '';
        const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
        capabilitySet
    }`;
        return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
    };
});
parcelRegister("dK8AG", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyOrId", ()=>$9ffe1ab8f180b628$export$43cde151f667c69e);
    $parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", ()=>$9ffe1ab8f180b628$export$b87af5b274141bd6);
    var $1nb22;
    const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, match.query);
        return projectKey || projectId || '';
    };
    const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
});
parcelRegister("47m5i", function(module, exports) {
    $parcel$export(module.exports, "fetchForgeModule", ()=>$9024d8f047e9df37$export$e1683e15cedb5f17);
    var $e4eHl = parcelRequire("e4eHl");
    var $8O7FC;
    var $k2DRb;
    var $iVaKa;
    var $g5X3G;
    var $gLloR;
    const $9024d8f047e9df37$var$dataClassificatedModulesConfig = {
        names: new Set(),
        request: Promise.resolve({})
    };
    const $9024d8f047e9df37$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
        $9024d8f047e9df37$var$dataClassificatedModulesConfig.names.add(moduleName);
        await new Promise((resolve)=>setTimeout(resolve, 0));
        const moduleNamesToFetch = Array.from($9024d8f047e9df37$var$dataClassificatedModulesConfig.names);
        let extensions = [];
        let accessNarrowedExtensions = [];
        if (moduleNamesToFetch.length > 0) {
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.names = new Set();
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.request = (0, (0, parcelRequire("iVaKa")).default)((0, (0, parcelRequire("g5X3G")).toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
        }
        const result = await $9024d8f047e9df37$var$dataClassificatedModulesConfig.request;
        extensions = result.extensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        const getExtensionsFilter = (fullPageModuleName)=>{
            switch(fullPageModuleName){
                case 0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE:
                    return 0, (0, parcelRequire("gLloR")).adminPageFilter;
                default:
                    return 0, (0, parcelRequire("gLloR")).uniqueExtensionsFilter;
            }
        };
        return {
            extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title)),
            accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title))
        };
    };
});
parcelRegister("gLloR", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$11790a142fe832e3$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$11790a142fe832e3$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $11790a142fe832e3$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $11790a142fe832e3$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        const adminExtensions = extensions;
        return [
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("e0AC8", function(module, exports) {
    $parcel$export(module.exports, "parseExtensionId", ()=>$d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
    $parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", ()=>$d4c89d40e0b3eaac$export$a92b17288693d366);
    const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
        const [, appId, envId] = extensionId.split('/');
        return {
            appId: appId,
            envId: envId
        };
    };
    const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');
});
parcelRegister("1yLrr", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$8bb90f56b7c2b78a$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        return [
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("iEUaw", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarShortcutsResource", ()=>$681ca3c44ff39b04$export$4847c29b4786b3b4);
    var $1nb22;
    var $2M1hQ;
    var $bskkv;
    const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
        getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const shortcuts = await (0, (0, parcelRequire("bskkv")).fetchShortcuts)(projectKeyOrId);
            return shortcuts;
        },
        maxAge: 300000
    });
});
parcelRegister("bskkv", function(module, exports) {
    $parcel$export(module.exports, "fetchShortcuts", ()=>$b1e90e13aab5fe84$export$49d696bf2525d700);
    var $jcw0u;
    var $7f4tk;
    const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
        try {
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchProjectShortcuts',
                packageName: 'jiraNavigationAppsResources'
            });
            throw error;
        }
    };
});
parcelRegister("hBv66", function(module, exports) {
    $parcel$export(module.exports, "genericProjectSidebars", ()=>$0b920001492d0ef4$export$d88d2d25355bc89a);
    $parcel$export(module.exports, "classicBoardSidebars", ()=>$0b920001492d0ef4$export$c04daf123cec1f1e);
    $parcel$export(module.exports, "genericConnectSidebars", ()=>$0b920001492d0ef4$export$844d342b575ead35);
    var $cin8p;
    var $dmKXV;
    var $iHiHz;
    var $cOg46;
    var $koWFd;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    const $0b920001492d0ef4$export$d88d2d25355bc89a = [
        (0, (0, parcelRequire("dmKXV")).default),
        (0, (0, parcelRequire("koWFd")).default),
        (0, (0, parcelRequire("h0bZU")).default),
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$c04daf123cec1f1e = [
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$844d342b575ead35 = [
        ...$0b920001492d0ef4$export$d88d2d25355bc89a,
        (0, (0, parcelRequire("cin8p")).default),
        (0, (0, parcelRequire("iHiHz")).default),
        (0, (0, parcelRequire("cOg46")).default)
    ];
});
parcelRegister("cin8p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760a63d3e4200cc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("bxwfY")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
    });
    const $760a63d3e4200cc2$var$ConnectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "connect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
    $760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
    var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;
});
parcelRegister("dZQxE", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$e39fc1e1d73100a0$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $5e7oM;
    var $azzrO;
    var $lfTZh;
    var $5Hj3V;
    var $acDan;
    var $lGo7j;
    const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
        const onFail = (0, (0, parcelRequire("acDan")).useSidebarFail)();
        const onSuccess = (0, (0, parcelRequire("acDan")).useSidebarSuccess)();
        const onError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
            else onFail(location, error);
        }, [
            onFail,
            onSuccess
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
            id: id,
            packageName: "jiraSpaAppsSidebarCommon",
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "nav-sidebar",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            })
        }, children));
    };
});
parcelRegister("5e7oM", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", ()=>$83022b592d1d8567$export$6635720e40ea7a7a);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", ()=>$83022b592d1d8567$export$1d3c3cb357af0e86);
    $parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", ()=>$83022b592d1d8567$export$e7a14fa81b3c6488);
    $parcel$export(module.exports, "NAVIGATION_TOP_MARKS", ()=>$83022b592d1d8567$export$ad760bb9734bf93f);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", ()=>$83022b592d1d8567$export$1d10ee0c85c3cb21);
    const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
    const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
    const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
    const $83022b592d1d8567$export$ad760bb9734bf93f = {
        renderStart: 'navigation-top.render.start',
        renderEnd: 'navigation-top.render.end',
        renderSsrStart: 'navigation-top.render.ssr.start',
        renderSsrEnd: 'navigation-top.render.ssr.end',
        bundleLoadStart: 'navigation-top.bundle-load.start'
    };
    const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
        renderAttempt: 'navigation-sidebar.render.attempt',
        renderStart: 'navigation-sidebar.render.start',
        renderEnd: 'navigation-sidebar.render.end',
        renderSsrStart: 'navigation-sidebar.render.ssr.start',
        renderSsrEnd: 'navigation-sidebar.render.ssr.end',
        loadStart: 'navigation-sidebar.load.start',
        loadEnd: 'navigation-sidebar.load.end'
    };
});
parcelRegister("azzrO", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", ()=>$4d07bc740e316cc0$export$8df02628d98cae7e);
    $parcel$export(module.exports, "pageSegmentStore", ()=>$4d07bc740e316cc0$export$26cadbe0bcaabcde);
    $parcel$export(module.exports, "useNavPerformanceMetrics", ()=>$4d07bc740e316cc0$export$906025848d54198d);
    $parcel$export(module.exports, "NavTopPerformanceMark", ()=>$4d07bc740e316cc0$export$b7f4caa65b0906fc);
    $parcel$export(module.exports, "NavTopSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$2c4a101f2cde4fc2);
    $parcel$export(module.exports, "NavTopPerformanceReport", ()=>$4d07bc740e316cc0$export$c64b31449a6177d);
    $parcel$export(module.exports, "NavSidebarPerformanceMark", ()=>$4d07bc740e316cc0$export$35b2aeea5cbc963e);
    $parcel$export(module.exports, "NavSidebarSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$14f711a2cb6a655a);
    $parcel$export(module.exports, "NavSidebarPerformanceReport", ()=>$4d07bc740e316cc0$export$a018e347341b3640);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $cHBMC;
    var $cfDZ3;
    var $5M3R9;
    var $5e7oM;
    const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, (0, parcelRequire("cHBMC")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME),
            timings: [
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'bundle-load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$8df02628d98cae7e = {
        ADDONS: (0, (0, parcelRequire("cHBMC")).metrics).interaction({
            key: 'navigation-top.addons-dropdown-opened'
        })
    };
    const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, (0, parcelRequire("cHBMC")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME),
            timings: [
                {
                    key: 'renderAttempt',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
                },
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
        const segmentConstructors = {
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
        };
        const segments = {};
        return {
            getSegment: (key)=>{
                if (!segments[key]) {
                    if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                    segments[key] = segmentConstructors[key]();
                }
                return segments[key];
            }
        };
    })();
    const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME))=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
        if (!false && !startedRef.current) {
            segment && segment.startFromPageLoad();
            startedRef.current = true;
        }
        return (0, $5uXOq.useMemo)(()=>Object.assign(segment, {
                markSSR: (metricKey)=>{
                    const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                    if (window.SPA_STATE) {
                        const { startTime: startTime = 0, duration: duration = 0 } = (0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("5M3R9")).getRenderTraceFromSSRGlobal)(), [
                            'traces',
                            `render/${tmpSsrMetricKey}`
                        ]) || {};
                        const markTime = startTime + duration;
                        markTime && markTime > 0 && segment.mark(metricKey, markTime);
                    }
                }
            }), [
            segment
        ]);
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), []);
        return null;
    };
    const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: tmpSsrMetricKey
        }) : null;
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>{
            navSegment.stop({
                customData: {
                    ...customData,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                }
            });
            navSegment.clear();
        }, []);
        return null;
    };
    const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
});
parcelRegister("5M3R9", function(module, exports) {
    $parcel$export(module.exports, "RenderTracerMark", ()=>$ca67b9a5090b457c$export$54c89059bb435049);
    $parcel$export(module.exports, "getRenderTraceFromSSRGlobal", ()=>$ca67b9a5090b457c$export$345f21b0287f67e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Csk1 = parcelRequire("6Csk1");
    var $9XE6b = parcelRequire("9XE6b");
    var $jR67t;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ca67b9a5090b457c$var$initialState = {
        start: undefined,
        traces: {}
    };
    let $ca67b9a5090b457c$var$currentTraces = {};
    const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
    const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
        if ($ca67b9a5090b457c$var$currentTraces[key]) return;
        $ca67b9a5090b457c$var$currentTraces[key] = {
            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
        };
    };
    const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
        if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
        $ca67b9a5090b457c$var$currentTraces[key].duration = (0, (0, parcelRequire("jR67t")).performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
    };
    const $ca67b9a5090b457c$var$actions = {
        startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                if (traces[key]) return;
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            startTime: time
                        }
                    })
                });
            },
        endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                const trace = traces[key] || {
                    startTime: 0
                };
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            ...trace,
                            duration: time - trace.startTime
                        }
                    })
                });
                $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
            }
    };
    const $ca67b9a5090b457c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'jira-render-tracer',
        initialState: $ca67b9a5090b457c$var$initialState,
        actions: $ca67b9a5090b457c$var$actions
    });
    const $ca67b9a5090b457c$var$RenderTracerActions = (0, (0, parcelRequire("51nlc")).createSubscriber)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$export$719a95758870be58 = (0, (0, parcelRequire("3sQ5x")).createHook)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, (0, parcelRequire("gg7kZ")).createContainer)($ca67b9a5090b457c$var$Store, {
        onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
                setState({
                    start: startTime,
                    traces: {
                        [startKey]: {
                            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
                        }
                    }
                });
            }
    });
    const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
            startKey: startKey,
            startTime: startTime
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
            traceKey: startKey,
            type: "end"
        }));
    const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
            if (type === 'start') startTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            else if (type === 'end') endTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            return null;
        });
    const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
            [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
                data: {
                    traces: traces,
                    routeName: appName
                }
            }
        });
    const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, ($parcel$interopDefault($9XE6b)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
            (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
            'data'
        ], {});
});
parcelRegister("jR67t", function(module, exports) {
    $parcel$export(module.exports, "performance", ()=>$c026bc7061377d6e$export$f2d2284f5fec51f8);
    const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
    class $c026bc7061377d6e$export$9a0dbed22cbf63be {
        start() {
            if (false) this.startAt = $c026bc7061377d6e$var$now();
        }
        now() {
            if (false) return $c026bc7061377d6e$var$now() - this.startAt;
            return $c026bc7061377d6e$var$now();
        }
        constructor(){
            this.startAt = $c026bc7061377d6e$var$now();
        }
    }
    const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();
});
const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';
parcelRegister("5Hj3V", function(module, exports) {
    $parcel$export(module.exports, "SidebarErrorBoundary", ()=>$c3958cf153a091e2$export$62853c5766dad0c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $cfDZ3;
    var $kqzba;
    const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                ...props.extraEventData,
                userLocation: userLocation
            }), [
            props.extraEventData,
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqzba")).Fallback), {
                error: error
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            ...props,
            extraEventData: extraEventData,
            fallback: fallback
        });
    };
});
parcelRegister("kqzba", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$790c5d1c3d335eca$export$fb8d7f40caaeea67);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hgYNN;
    var $kobfu;
    var $koVbs;
    var $evbHg = parcelRequire("evbHg");
    var $h8OaL;
    const $790c5d1c3d335eca$var$styles = {
        wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
        error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
        image: "_4t3i12am"
    };
    const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
        const { error: error } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.wrapper
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            alt: "",
            src: (0, ($parcel$interopDefault($evbHg))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.image
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgYNN")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.error
            ])
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("evbHg", function(module, exports) {
    module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();
});
parcelRegister("h8OaL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7c8a71ff5065c1e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("acDan", function(module, exports) {
    $parcel$export(module.exports, "SidebarStart", ()=>$b5a3a4467dac2130$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarRenderStart", ()=>$b5a3a4467dac2130$export$ba19e3624956e66);
    $parcel$export(module.exports, "SidebarReady", ()=>$b5a3a4467dac2130$export$a06ecbbe5820282);
    $parcel$export(module.exports, "useSidebarFail", ()=>$b5a3a4467dac2130$export$661ed14c8f75da9f);
    $parcel$export(module.exports, "useSidebarSuccess", ()=>$b5a3a4467dac2130$export$ddb17534fdfb7dc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $5e7oM;
    var $azzrO;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $4QcD9;
    var $6jY6G;
    var $8zOmE;
    var $95EVP;
    var $6IzHB;
    var $doZTA;
    var $kvHKs;
    const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, (0, parcelRequire("4QcD9")).createValueController)('sidebar-id');
    const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
        experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
        attributes: {
            sidebar: 'v3'
        }
    };
    const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
        const [{ route: route, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experienceId: pageId,
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
            analyticsSource: 'Sidebar'
        });
        (0, $5uXOq.useMemo)(()=>{
            if (route.isRedirect ?? false) return;
            onStartExperience();
            startRef.current = Date.now();
        }, [
            route,
            match
        ]);
        return null;
    };
    const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart
        });
    const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
        const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const onSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
        (0, $5uXOq.useEffect)(()=>{
            setSidebarId(id);
            return ()=>setSidebarId();
        }, [
            setSidebarId,
            id
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (route.isRedirect ?? false) return;
            onSuccess();
        }, [
            onSuccess,
            route
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            window.__POLLINATOR__ = {
                ...window.__POLLINATOR__,
                routeName: routeName
            };
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            routeName
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                route: routeName,
                sidebarId: id
            }), [
            routeName,
            id
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceReport), {
            customData: customData
        }));
    };
    const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE)
        });
        return (0, $5uXOq.useCallback)((location, error)=>{
            onFail(location, error);
        }, [
            onFail
        ]);
    };
    const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
});
parcelRegister("93jKl", function(module, exports) {
    $parcel$export(module.exports, "useExperienceFail", ()=>$e2626e1ab0692489$export$606da7704d8eaf06);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZneA;
    var $7NJFp;
    var $l9g16;
    const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
            const { current: current } = self;
            if ((0, (0, parcelRequire("7NJFp")).isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return;
            current.experienceTracker.fail({
                name: current.name,
                error: error,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes,
                    location: location
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("l9g16", function(module, exports) {
    $parcel$export(module.exports, "useExperienceContext", ()=>$79f23c22d88dd8d5$export$be8ec22ac9208049);
    var $5uXOq = parcelRequire("5uXOq");
    var $6XbhC;
    const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("6XbhC")).ExperienceTrackerContext));
        return context;
    };
});
parcelRegister("kaHBi", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$e1187df33c58b997$export$675e0d25df38d426);
    $parcel$export(module.exports, "ExperienceStart", ()=>$e1187df33c58b997$export$f20b867e738a222c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
        const self = (0, $5uXOq.useRef)({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            experienceTracker: experienceTracker,
            disableSli: disableSli,
            userLocation: userLocation,
            collect: collect
        });
        self.current.experienceId = experienceId;
        self.current.experience = experience;
        self.current.timeout = timeout;
        self.current.analyticsSource = analyticsSource;
        self.current.application = application;
        self.current.edition = edition;
        self.current.experienceTracker = experienceTracker;
        self.current.userLocation = userLocation;
        self.current.collect = collect;
        return (0, $5uXOq.useCallback)(()=>{
            const { current: current } = self;
            current.experienceTracker.start({
                id: current.experienceId,
                name: current.experience,
                timeout: current.timeout,
                attributes: {
                    analyticsSource: current.analyticsSource,
                    experience: current.experience,
                    experienceId: current.experienceId,
                    application: current.application,
                    edition: current.edition,
                    disableSli: current.disableSli,
                    userLocation: current.userLocation
                },
                collect: current.collect,
                onSuccess: ()=>undefined
            });
        }, [
            self
        ]);
    };
    const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
        const onStart = $e1187df33c58b997$export$675e0d25df38d426({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            disableSli: disableSli,
            collect: collect
        });
        (0, $5uXOq.useMemo)(()=>{
            onStart();
        }, [
            onStart,
            experienceId,
            experience,
            timeout,
            analyticsSource,
            application,
            edition,
            disableSli,
            collect
        ]);
        return null;
    };
});
parcelRegister("6jY6G", function(module, exports) {
    $parcel$export(module.exports, "useCurrentRoute", ()=>$dda4cada2257eb1d$export$c4b7ea2942f2d0e);
    $parcel$export(module.exports, "useRouteByName", ()=>$dda4cada2257eb1d$export$d69a946e2d0a1c12);
    $parcel$export(module.exports, "usePreviousRouterState", ()=>$dda4cada2257eb1d$export$1e5fb68306bd0b92);
    var $lODMY;
    var $doZTA;
    var $cfDZ3;
    const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route);
    const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state, routeName)=>state.routes.find(({ name: name })=>name === routeName) ?? null);
    const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
            name: name,
            path: path,
            query: query,
            exact: exact
        });
    const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
        (0, (0, parcelRequire("doZTA")).useRouter)();
        return (0, (0, parcelRequire("cfDZ3")).getPreviousRouterState)();
    };
});
parcelRegister("3bQtK", function(module, exports) {
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
    const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const self = (0, $5uXOq.useRef)({
            experience: experience,
            attributes: attributes,
            experienceTracker: experienceTracker,
            route: route
        });
        self.current.route = route;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        self.current.experience = experience;
        return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
            const { current: current } = self;
            if (current.route && current.route.isRedirect === true) return;
            current.experienceTracker.succeed({
                name: current.experience,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
    const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
            experience: experience,
            attributes: attributes
        });
        (0, $5uXOq.useEffect)(()=>{
            onExperienceSuccess();
        }, [
            attributes,
            onExperienceSuccess
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (false) onExperienceSuccess();
        }, [
            onExperienceSuccess
        ]);
        return null;
    };
});
parcelRegister("4QcD9", function(module, exports) {
    $parcel$export(module.exports, "createValueController", ()=>$3f293f209341d999$export$ff0ab9dd4ceb4a93);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
        const actions = {
            setValue: (value)=>({ setState: setState })=>setState({
                        value: value
                    })
        };
        const initialState = {
            value: defaultValue
        };
        const store = (0, (0, parcelRequire("iXqE5")).createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const ValueContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)(store);
        const selector = (state)=>state.value;
        const useValueInternal = (0, (0, parcelRequire("3sQ5x")).createHook)(store, {
            selector: selector
        });
        const useValue = ()=>{
            const [value, { setValue: setValue }] = useValueInternal();
            return [
                value,
                setValue
            ];
        };
        return {
            ValueContainer: ValueContainer,
            useValue: useValue
        };
    };
});
parcelRegister("6IzHB", function(module, exports) {
    $parcel$export(module.exports, "usePageId", ()=>$57184c749af08735$export$3434ba5eadb360dc);
    var $3sQ5x;
    var $7w9eZ;
    const $57184c749af08735$var$useSweetStatePageId = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: (state)=>state.currentPage.uuid
    });
    const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
        const [pageId] = $57184c749af08735$var$useSweetStatePageId();
        return pageId;
    };
});
parcelRegister("7w9eZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85db42238a8acf29$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $iXqE5;
    var $6Bj8c;
    const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
        transitionCheckTimestamp: -1,
        currentPage: {
            uuid: false ? '' : (0, ($parcel$interopDefault($7Jxgt))).v4(),
            startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
            apps: {},
            userLocation: ''
        },
        visitedPages: [],
        navigation: {
            isCollapsed: false,
            viewId: 'noView',
            viewType: '',
            projectType: null,
            isInitialEventSent: false,
            pageId: null,
            nextViewId: ''
        }
    };
    const $85db42238a8acf29$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'spa-state',
        initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("6Bj8c"))
    });
    var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;
});
parcelRegister("6Bj8c", function(module, exports) {
    $parcel$export(module.exports, "setAppStart", ()=>(parcelRequire("fI6Pg")).setAppStart);
    $parcel$export(module.exports, "setAppReady", ()=>(parcelRequire("fI6Pg")).setAppReady);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>(parcelRequire("fI6Pg")).setAppStartWithAppId);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setAppReadyWithAppId);
    $parcel$export(module.exports, "setAppErrorReady", ()=>(parcelRequire("fI6Pg")).setAppErrorReady);
    $parcel$export(module.exports, "setTimeoutReady", ()=>(parcelRequire("fI6Pg")).setTimeoutReady);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
    $parcel$export(module.exports, "resetCurrentPage", ()=>(parcelRequire("fI6Pg")).resetCurrentPage);
    $parcel$export(module.exports, "setResourceMetrics", ()=>(parcelRequire("fI6Pg")).setResourceMetrics);
    var $fI6Pg;
});
parcelRegister("fI6Pg", function(module, exports) {
    $parcel$export(module.exports, "resetCurrentPage", ()=>$4a986cd3487bf863$export$5639685a1fb81722);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>$4a986cd3487bf863$export$8a98548dad2fa97b);
    $parcel$export(module.exports, "setTimeoutReady", ()=>$4a986cd3487bf863$export$b9cc4378ea785421);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>$4a986cd3487bf863$export$9d528722f2ff2999);
    $parcel$export(module.exports, "setAppStart", ()=>$4a986cd3487bf863$export$71192061050856ad);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>$4a986cd3487bf863$export$6a25429a42d30f9a);
    $parcel$export(module.exports, "setAppReady", ()=>$4a986cd3487bf863$export$fc59cc4ed9bba7cd);
    $parcel$export(module.exports, "setAppErrorReady", ()=>$4a986cd3487bf863$export$aff63c1e41443b6a);
    $parcel$export(module.exports, "setResourceMetrics", ()=>$4a986cd3487bf863$export$8ad155d489dcf34d);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $hpxZY;
    var $19hl5;
    var $cfDZ3;
    var $5GhjE;
    const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
    const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            performance.mark('resetCurrentPage');
            (0, (0, parcelRequire("19hl5")).browserMetrics).startPageLoad({
                isInitial: false
            });
            (0, (0, parcelRequire("hpxZY")).default)(nextRouteUfoName, nextRouteName);
            (0, (0, parcelRequire("5GhjE")).GlobalPageLoadExperience).abort({
                force: true
            });
            (0, (0, parcelRequire("5GhjE")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
                currentPage: {
                    uuid: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                    apps: {},
                    startTime: Date.now(),
                    userLocation: ''
                },
                visitedPages: [
                    ...currentState.visitedPages,
                    {
                        ...currentState.currentPage
                    }
                ],
                transitionCheckTimestamp: 0
            });
        };
    const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
                const apps = {
                    ...currentPage.apps
                };
                if (apps[appId] && apps[appId].expectingTimeout) {
                    const updatedPage = {
                        ...currentPage,
                        apps: {
                            ...apps,
                            [appId]: {
                                ...apps[appId],
                                timeoutTime: timeoutTime,
                                expectingTimeout: 0
                            }
                        }
                    };
                    setState({
                        currentPage: updatedPage
                    });
                }
            }
        };
    const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
        };
    const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
                const timeoutId = setTimeout(()=>{
                    dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
                }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
                const updatedPage = {
                    ...currentPage,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)(),
                    apps: {
                        ...currentPage.apps,
                        [appId]: {
                            startTime: startTime,
                            expectingTimeout: timeoutId
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
        };
    const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
                const apps = {
                    ...currentPage.apps
                };
                clearTimeout(currentPage.apps[appId].expectingTimeout);
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            endTime: endTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
        };
    const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        'error-page': {
                            endTime: Date.now()
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                currentPage: {
                    ...currentState.currentPage,
                    resources: [
                        ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                        resourceMetrics
                    ]
                }
            });
        };
});
parcelRegister("kvHKs", function(module, exports) {
    $parcel$export(module.exports, "REPO_TYPE", ()=>$f1419662a60c783a$export$399c7e6858236b4);
    $parcel$export(module.exports, "LINK_TYPE", ()=>$f1419662a60c783a$export$58125ce2bb1c3378);
    $parcel$export(module.exports, "EMOJI_REGEX", ()=>$f1419662a60c783a$export$c79ed2783644934c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", ()=>$f1419662a60c783a$export$25ae65041c800c9);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", ()=>$f1419662a60c783a$export$e03c9beea817d44b);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", ()=>$f1419662a60c783a$export$3d575bdf28c0d17c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", ()=>$f1419662a60c783a$export$af84baced6970a17);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", ()=>$f1419662a60c783a$export$c767f253046b1ea7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", ()=>$f1419662a60c783a$export$265b9384cc2dfbd4);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$2de77b357e71c7a7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$7de7abb92169d6c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$fd7df8bd7600c65c);
    $parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", ()=>$f1419662a60c783a$export$dde074e512e80dff);
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$f1419662a60c783a$export$1f70a76cb421b107);
    $parcel$export(module.exports, "SIDEBAR_EXPERIENCE", ()=>$f1419662a60c783a$export$71aaf2625ee54d10);
    $parcel$export(module.exports, "staticLegacyIds", ()=>$f1419662a60c783a$export$f57650e6e7be03dc);
    const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
    const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
    const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
    const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
    const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
    const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
    const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
    const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
    const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
    const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
    const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
    const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
    const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
    const $f1419662a60c783a$export$1f70a76cb421b107 = {
        REPORTS_ADDONS: 'sd-reports-addons'
    };
    const $f1419662a60c783a$export$83016cff6318a5dd = Object.freeze({
        CODE_TAB: 'CODE_TAB',
        ONCALL_TAB: 'ONCALL_TAB',
        PAGES_TAB: 'PAGES_TAB'
    });
    const $f1419662a60c783a$export$f371b4c263b142af = {
        [$f1419662a60c783a$export$83016cff6318a5dd.CODE_TAB]: 'code',
        [$f1419662a60c783a$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
        [$f1419662a60c783a$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
    };
    const $f1419662a60c783a$export$b66c40cadee12a0b = 'project/agility/index';
    const $f1419662a60c783a$export$6f454e69bce3a691 = 'project/business/index';
    const $f1419662a60c783a$export$3a0f7f7a8a0b306b = 'project/ops/index';
    const $f1419662a60c783a$export$1346c9aa3cbb477d = 'project/software/index';
    const $f1419662a60c783a$export$4598dd67943205cf = 'project/software/issues';
    const $f1419662a60c783a$export$8f36e85c5afae5 = 'project/software/reports';
    const $f1419662a60c783a$export$8151e5564c0016a1 = 'attachments';
    const $f1419662a60c783a$export$4acd0d06a25e56b5 = 'eventtypes';
    const $f1419662a60c783a$export$211ab01804585e09 = 'webhooks-admin';
    const $f1419662a60c783a$export$294b9ab8545a9f36 = 'services';
    const $f1419662a60c783a$export$665efe695022359b = 'greenhopper-lexorank-manage';
    const $f1419662a60c783a$export$47fbefc73055eb9d = 'admin-helper-admin-section';
    const $f1419662a60c783a$export$76e6bd729450de52 = 'advanced_section';
    const $f1419662a60c783a$export$ac928a90c0d3daa8 = 'collectors';
    const $f1419662a60c783a$export$309ac0136b7d5dfa = 'dark_features';
    const $f1419662a60c783a$export$998f1706a6ca29b = 'general_configuration';
    const $f1419662a60c783a$export$e9af81a594543847 = 'import_export_section';
    const $f1419662a60c783a$export$bbf19cc23216c6b = 'mail_section';
    const $f1419662a60c783a$export$693dd06b18660b78 = 'security_section';
    const $f1419662a60c783a$export$c6d1221ea0bce75e = 'shared_section';
    const $f1419662a60c783a$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
    const $f1419662a60c783a$export$af156d8e27fc5458 = 'user_interface';
    const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
    const $f1419662a60c783a$export$f57650e6e7be03dc = [
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ];
});
parcelRegister("lGo7j", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$0c703bf4651638aa$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $le2LN;
    var $cZXEh;
    var $5tOuG;
    const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("le2LN")).default), {
            name: "sidebar-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), {
            hasIcon: isFull
        }))));
    const $0c703bf4651638aa$var$BackgroundedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tem _1yt4s5g3",
                __cmplp.className
            ])
        });
    });
    const $0c703bf4651638aa$var$HeadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41k9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cZXEh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3362fd95950b516a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $Hi7fY;
    var $1WrCb;
    var $6onh1;
    const $3362fd95950b516a$var$Section = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)();
        if (!shouldRender) return props.children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Hi7fY")).default), {
            ...props,
            ref: ref,
            overrides: {
                HeadingItem: {
                    cssFn: (0, (0, parcelRequire("1WrCb")).sectionHeaderSpacingStyles)
                }
            }
        });
    });
    var $3362fd95950b516a$export$2e2bcd8739ae039 = $3362fd95950b516a$var$Section;
});
parcelRegister("1WrCb", function(module, exports) {
    $parcel$export(module.exports, "overrideStyleFunction", ()=>$69939ee3e2647300$export$505cedac1a39aacf);
    $parcel$export(module.exports, "baseSideNavItemStyle", ()=>$69939ee3e2647300$export$aed216a85ec468ac);
    $parcel$export(module.exports, "sectionHeaderSpacingStyles", ()=>$69939ee3e2647300$export$a5c27bed78cfecb9);
    const $69939ee3e2647300$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
        return (state)=>{
            return [
                baseStyle(state),
                newStyle(state)
            ];
        };
    };
    const $69939ee3e2647300$var$defaultStyles = {
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`
        },
        '&:active': {
            color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`
        }
    };
    const $69939ee3e2647300$var$selectedStyles = {
        backgroundColor: `var(--ds-background-selected, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
        ':visited': {
            color: `var(--ds-text-selected, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`
        }
    };
    const $69939ee3e2647300$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
        return {
            paddingBlock: "var(--ds-space-100, 8px)",
            paddingInline: "var(--ds-space-100, 8px)",
            borderRadius: "var(--ds-border-radius, 3px)",
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            ...!isDisabled && !isSelected && $69939ee3e2647300$var$defaultStyles,
            ...!isDisabled && isSelected && $69939ee3e2647300$var$selectedStyles,
            ['& [data-item-elem-before]']: {
                height: '1.5rem',
                width: '1.5rem'
            }
        };
    };
    const $69939ee3e2647300$export$a5c27bed78cfecb9 = ()=>{
        return {
            paddingInline: "var(--ds-space-100, 8px)"
        };
    };
});
var $5e0c0d4e15efb4a6$exports = {};
$parcel$export($5e0c0d4e15efb4a6$exports, "R50", ()=>$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd);
$parcel$export($5e0c0d4e15efb4a6$exports, "R75", ()=>$5e0c0d4e15efb4a6$export$b34b069eff244586);
$parcel$export($5e0c0d4e15efb4a6$exports, "R100", ()=>$5e0c0d4e15efb4a6$export$be802dd0d8b57f35);
$parcel$export($5e0c0d4e15efb4a6$exports, "R200", ()=>$5e0c0d4e15efb4a6$export$60847d42f9da92a6);
$parcel$export($5e0c0d4e15efb4a6$exports, "R300", ()=>$5e0c0d4e15efb4a6$export$4a7404f376229999);
$parcel$export($5e0c0d4e15efb4a6$exports, "R400", ()=>$5e0c0d4e15efb4a6$export$2010d0fb4295b346);
$parcel$export($5e0c0d4e15efb4a6$exports, "R500", ()=>$5e0c0d4e15efb4a6$export$2837b5a1a71d5c02);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y50", ()=>$5e0c0d4e15efb4a6$export$8d9596b529bbb9cf);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y75", ()=>$5e0c0d4e15efb4a6$export$41060a744ab0b7ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y100", ()=>$5e0c0d4e15efb4a6$export$1cc05bbbf340e559);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y200", ()=>$5e0c0d4e15efb4a6$export$5aae31392d72caaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y300", ()=>$5e0c0d4e15efb4a6$export$c6930421db9fa514);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y400", ()=>$5e0c0d4e15efb4a6$export$59619663aa6500fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y500", ()=>$5e0c0d4e15efb4a6$export$874739ea9e379ab6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G50", ()=>$5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G75", ()=>$5e0c0d4e15efb4a6$export$69a3bf21b9686c2b);
$parcel$export($5e0c0d4e15efb4a6$exports, "G100", ()=>$5e0c0d4e15efb4a6$export$afbce1382ec95f73);
$parcel$export($5e0c0d4e15efb4a6$exports, "G200", ()=>$5e0c0d4e15efb4a6$export$747d86715d4175de);
$parcel$export($5e0c0d4e15efb4a6$exports, "G300", ()=>$5e0c0d4e15efb4a6$export$940e1f69e873f202);
$parcel$export($5e0c0d4e15efb4a6$exports, "G400", ()=>$5e0c0d4e15efb4a6$export$a49394138f7b8e85);
$parcel$export($5e0c0d4e15efb4a6$exports, "G500", ()=>$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "B50", ()=>$5e0c0d4e15efb4a6$export$226de0355ed012f8);
$parcel$export($5e0c0d4e15efb4a6$exports, "B75", ()=>$5e0c0d4e15efb4a6$export$8c13c2ee36917869);
$parcel$export($5e0c0d4e15efb4a6$exports, "B100", ()=>$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a);
$parcel$export($5e0c0d4e15efb4a6$exports, "B200", ()=>$5e0c0d4e15efb4a6$export$215b7063051591f1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B300", ()=>$5e0c0d4e15efb4a6$export$e62e8919cca44969);
$parcel$export($5e0c0d4e15efb4a6$exports, "B400", ()=>$5e0c0d4e15efb4a6$export$b3de0ae08da2ce64);
$parcel$export($5e0c0d4e15efb4a6$exports, "B500", ()=>$5e0c0d4e15efb4a6$export$a6ee3d71bc067634);
$parcel$export($5e0c0d4e15efb4a6$exports, "B600", ()=>$5e0c0d4e15efb4a6$export$67f15409e87642a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B700", ()=>$5e0c0d4e15efb4a6$export$f0539dbc42dbb067);
$parcel$export($5e0c0d4e15efb4a6$exports, "P50", ()=>$5e0c0d4e15efb4a6$export$363e4475840015bb);
$parcel$export($5e0c0d4e15efb4a6$exports, "P75", ()=>$5e0c0d4e15efb4a6$export$4b0a4417ed59760f);
$parcel$export($5e0c0d4e15efb4a6$exports, "P100", ()=>$5e0c0d4e15efb4a6$export$6011520a64d9a187);
$parcel$export($5e0c0d4e15efb4a6$exports, "P200", ()=>$5e0c0d4e15efb4a6$export$a7175d4e9206bc80);
$parcel$export($5e0c0d4e15efb4a6$exports, "P300", ()=>$5e0c0d4e15efb4a6$export$b48405b95304b5a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "P400", ()=>$5e0c0d4e15efb4a6$export$c71e4279dd54a18d);
$parcel$export($5e0c0d4e15efb4a6$exports, "P500", ()=>$5e0c0d4e15efb4a6$export$147899de772240ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "T50", ()=>$5e0c0d4e15efb4a6$export$2cf711fe14c66f06);
$parcel$export($5e0c0d4e15efb4a6$exports, "T75", ()=>$5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c);
$parcel$export($5e0c0d4e15efb4a6$exports, "T100", ()=>$5e0c0d4e15efb4a6$export$776c9c497ef08533);
$parcel$export($5e0c0d4e15efb4a6$exports, "T200", ()=>$5e0c0d4e15efb4a6$export$69cb3ca10c1e330e);
$parcel$export($5e0c0d4e15efb4a6$exports, "T300", ()=>$5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b);
$parcel$export($5e0c0d4e15efb4a6$exports, "T400", ()=>$5e0c0d4e15efb4a6$export$7c835c78b6fcdef8);
$parcel$export($5e0c0d4e15efb4a6$exports, "T500", ()=>$5e0c0d4e15efb4a6$export$6036577f95c3877e);
$parcel$export($5e0c0d4e15efb4a6$exports, "N0", ()=>$5e0c0d4e15efb4a6$export$29a4f05edc054374);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10", ()=>$5e0c0d4e15efb4a6$export$e655ef011c4aa1a2);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20", ()=>$5e0c0d4e15efb4a6$export$9fdfb749e33cdf97);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30", ()=>$5e0c0d4e15efb4a6$export$3e51e8f1440314ba);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40", ()=>$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50", ()=>$5e0c0d4e15efb4a6$export$8754fc7e6d8b3000);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60", ()=>$5e0c0d4e15efb4a6$export$c2e91cbeada39b8b);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70", ()=>$5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80", ()=>$5e0c0d4e15efb4a6$export$eaa8c8a70ac22806);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90", ()=>$5e0c0d4e15efb4a6$export$7c87d337fb91a97d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100", ()=>$5e0c0d4e15efb4a6$export$d6447c357493214f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200", ()=>$5e0c0d4e15efb4a6$export$f563ee71e9ee74cd);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300", ()=>$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400", ()=>$5e0c0d4e15efb4a6$export$eece5f492e429f08);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500", ()=>$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600", ()=>$5e0c0d4e15efb4a6$export$7090862dc3038a9f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700", ()=>$5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800", ()=>$5e0c0d4e15efb4a6$export$7d61b15e0da132af);
$parcel$export($5e0c0d4e15efb4a6$exports, "N900", ()=>$5e0c0d4e15efb4a6$export$fbda843f0a27fe96);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10A", ()=>$5e0c0d4e15efb4a6$export$791e57b27ca738ef);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20A", ()=>$5e0c0d4e15efb4a6$export$8d43898f60b96a82);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30A", ()=>$5e0c0d4e15efb4a6$export$920c0d5c49070351);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40A", ()=>$5e0c0d4e15efb4a6$export$46987b49aab6d1a8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50A", ()=>$5e0c0d4e15efb4a6$export$7d3359664e8bb0e5);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60A", ()=>$5e0c0d4e15efb4a6$export$d2d3bedfb276cac0);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70A", ()=>$5e0c0d4e15efb4a6$export$6e5e7499ff054f6d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80A", ()=>$5e0c0d4e15efb4a6$export$59264b346c877fa7);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90A", ()=>$5e0c0d4e15efb4a6$export$d092757d7c64925c);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100A", ()=>$5e0c0d4e15efb4a6$export$486ab785e4bac3c6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200A", ()=>$5e0c0d4e15efb4a6$export$fba592bbc6419fea);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300A", ()=>$5e0c0d4e15efb4a6$export$13609db0e6812ab8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400A", ()=>$5e0c0d4e15efb4a6$export$fbae4efaa892d883);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500A", ()=>$5e0c0d4e15efb4a6$export$f13946d26f440ce6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600A", ()=>$5e0c0d4e15efb4a6$export$19f58225ac52a306);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700A", ()=>$5e0c0d4e15efb4a6$export$6384f09da70e7b62);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800A", ()=>$5e0c0d4e15efb4a6$export$d0dccc730683edc2);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN900", ()=>$5e0c0d4e15efb4a6$export$2f6319cf7d736c2a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800", ()=>$5e0c0d4e15efb4a6$export$95126bc8884d6634);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700", ()=>$5e0c0d4e15efb4a6$export$8338d8c35d44ff1);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600", ()=>$5e0c0d4e15efb4a6$export$5368d76ae4fbbda7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500", ()=>$5e0c0d4e15efb4a6$export$9f0a771d16ec8d36);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400", ()=>$5e0c0d4e15efb4a6$export$abcf8c38338b4aa5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300", ()=>$5e0c0d4e15efb4a6$export$97e81faa16a182c7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200", ()=>$5e0c0d4e15efb4a6$export$bfe21c59123ecf33);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100", ()=>$5e0c0d4e15efb4a6$export$ee82aa2ea6a1558);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90", ()=>$5e0c0d4e15efb4a6$export$682927c6ed76be02);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80", ()=>$5e0c0d4e15efb4a6$export$91fd9994c5be9757);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70", ()=>$5e0c0d4e15efb4a6$export$d281fbfe3cff2df6);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60", ()=>$5e0c0d4e15efb4a6$export$3902c91d8b98a753);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50", ()=>$5e0c0d4e15efb4a6$export$8e8133c1ba5845b5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40", ()=>$5e0c0d4e15efb4a6$export$33ff357f6620b39);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30", ()=>$5e0c0d4e15efb4a6$export$633847cf062b69e0);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20", ()=>$5e0c0d4e15efb4a6$export$9776a6e503bdbf76);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10", ()=>$5e0c0d4e15efb4a6$export$6c813d5160dff5db);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN0", ()=>$5e0c0d4e15efb4a6$export$3d4f271a500072a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800A", ()=>$5e0c0d4e15efb4a6$export$fe151285c22759ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700A", ()=>$5e0c0d4e15efb4a6$export$a101c6190d0da34);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600A", ()=>$5e0c0d4e15efb4a6$export$4b16f52932fda51);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500A", ()=>$5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400A", ()=>$5e0c0d4e15efb4a6$export$9209c179316d1751);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300A", ()=>$5e0c0d4e15efb4a6$export$88f55133f636c8dd);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200A", ()=>$5e0c0d4e15efb4a6$export$51126f85d1009512);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100A", ()=>$5e0c0d4e15efb4a6$export$a069b547bd23af78);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90A", ()=>$5e0c0d4e15efb4a6$export$40cce05af3b2600a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80A", ()=>$5e0c0d4e15efb4a6$export$b78942185925a0d);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70A", ()=>$5e0c0d4e15efb4a6$export$e058fb44b8eaafca);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60A", ()=>$5e0c0d4e15efb4a6$export$92b0b8de26920c18);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50A", ()=>$5e0c0d4e15efb4a6$export$67564f7459d3fc9e);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40A", ()=>$5e0c0d4e15efb4a6$export$77868e1ca884ffa3);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30A", ()=>$5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20A", ()=>$5e0c0d4e15efb4a6$export$f2a0acaab9972c70);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10A", ()=>$5e0c0d4e15efb4a6$export$9ab70e67d6475361);
$parcel$export($5e0c0d4e15efb4a6$exports, "T30", ()=>$5e0c0d4e15efb4a6$export$d2adc5dedf09fced);
$parcel$export($5e0c0d4e15efb4a6$exports, "L50", ()=>$5e0c0d4e15efb4a6$export$f51762073d2bb381);
$parcel$export($5e0c0d4e15efb4a6$exports, "L75", ()=>$5e0c0d4e15efb4a6$export$95e26d54def96891);
const $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd = '#FFEBE6';
const $5e0c0d4e15efb4a6$export$b34b069eff244586 = '#FFBDAD';
const $5e0c0d4e15efb4a6$export$be802dd0d8b57f35 = '#FF8F73';
const $5e0c0d4e15efb4a6$export$60847d42f9da92a6 = '#FF7452';
const $5e0c0d4e15efb4a6$export$4a7404f376229999 = '#FF5630';
const $5e0c0d4e15efb4a6$export$2010d0fb4295b346 = '#DE350B';
const $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02 = '#BF2600';
const $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf = '#FFFAE6';
const $5e0c0d4e15efb4a6$export$41060a744ab0b7ae = '#FFF0B3';
const $5e0c0d4e15efb4a6$export$1cc05bbbf340e559 = '#FFE380';
const $5e0c0d4e15efb4a6$export$5aae31392d72caaa = '#FFC400';
const $5e0c0d4e15efb4a6$export$c6930421db9fa514 = '#FFAB00';
const $5e0c0d4e15efb4a6$export$59619663aa6500fb = '#FF991F';
const $5e0c0d4e15efb4a6$export$874739ea9e379ab6 = '#FF8B00';
const $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b = '#ABF5D1';
const $5e0c0d4e15efb4a6$export$afbce1382ec95f73 = '#79F2C0';
const $5e0c0d4e15efb4a6$export$747d86715d4175de = '#57D9A3';
const $5e0c0d4e15efb4a6$export$940e1f69e873f202 = '#36B37E';
const $5e0c0d4e15efb4a6$export$a49394138f7b8e85 = '#00875A';
const $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb = '#006644';
const $5e0c0d4e15efb4a6$export$226de0355ed012f8 = '#DEEBFF';
const $5e0c0d4e15efb4a6$export$8c13c2ee36917869 = '#B3D4FF';
const $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5e0c0d4e15efb4a6$export$215b7063051591f1 = '#2684FF';
const $5e0c0d4e15efb4a6$export$e62e8919cca44969 = '#0065FF';
const $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64 = '#0052CC';
const $5e0c0d4e15efb4a6$export$a6ee3d71bc067634 = '#0747A6';
const $5e0c0d4e15efb4a6$export$67f15409e87642a1 = '#669DF1';
const $5e0c0d4e15efb4a6$export$f0539dbc42dbb067 = '#8FB8F6';
const $5e0c0d4e15efb4a6$export$363e4475840015bb = '#EAE6FF';
const $5e0c0d4e15efb4a6$export$4b0a4417ed59760f = '#C0B6F2';
const $5e0c0d4e15efb4a6$export$6011520a64d9a187 = '#998DD9';
const $5e0c0d4e15efb4a6$export$a7175d4e9206bc80 = '#8777D9';
const $5e0c0d4e15efb4a6$export$b48405b95304b5a1 = '#6554C0';
const $5e0c0d4e15efb4a6$export$c71e4279dd54a18d = '#5243AA';
const $5e0c0d4e15efb4a6$export$147899de772240ec = '#403294';
const $5e0c0d4e15efb4a6$export$2cf711fe14c66f06 = '#E6FCFF';
const $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5e0c0d4e15efb4a6$export$776c9c497ef08533 = '#79E2F2';
const $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e = '#00C7E6';
const $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b = '#00B8D9';
const $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8 = '#00A3BF';
const $5e0c0d4e15efb4a6$export$6036577f95c3877e = '#008DA6';
const $5e0c0d4e15efb4a6$export$29a4f05edc054374 = '#FFFFFF';
const $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5e0c0d4e15efb4a6$export$3e51e8f1440314ba = '#EBECF0';
const $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb = '#DFE1E6';
const $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b = '#B3BAC5';
const $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806 = '#97A0AF';
const $5e0c0d4e15efb4a6$export$7c87d337fb91a97d = '#8993A4';
const $5e0c0d4e15efb4a6$export$d6447c357493214f = '#7A869A';
const $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd = '#6B778C';
const $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1 = '#5E6C84';
const $5e0c0d4e15efb4a6$export$eece5f492e429f08 = '#505F79';
const $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae = '#42526E';
const $5e0c0d4e15efb4a6$export$7090862dc3038a9f = '#344563';
const $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa = '#253858';
const $5e0c0d4e15efb4a6$export$7d61b15e0da132af = '#172B4D';
const $5e0c0d4e15efb4a6$export$fbda843f0a27fe96 = '#091E42';
const $5e0c0d4e15efb4a6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5e0c0d4e15efb4a6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5e0c0d4e15efb4a6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5e0c0d4e15efb4a6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5e0c0d4e15efb4a6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5e0c0d4e15efb4a6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5e0c0d4e15efb4a6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5e0c0d4e15efb4a6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5e0c0d4e15efb4a6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5e0c0d4e15efb4a6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5e0c0d4e15efb4a6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5e0c0d4e15efb4a6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5e0c0d4e15efb4a6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5e0c0d4e15efb4a6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a = '#E6EDFA';
const $5e0c0d4e15efb4a6$export$95126bc8884d6634 = '#DCE5F5';
const $5e0c0d4e15efb4a6$export$8338d8c35d44ff1 = '#CED9EB';
const $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5e0c0d4e15efb4a6$export$97e81faa16a182c7 = '#8C9CB8';
const $5e0c0d4e15efb4a6$export$bfe21c59123ecf33 = '#7988A3';
const $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558 = '#67758F';
const $5e0c0d4e15efb4a6$export$682927c6ed76be02 = '#56637A';
const $5e0c0d4e15efb4a6$export$91fd9994c5be9757 = '#455166';
const $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6 = '#3B475C';
const $5e0c0d4e15efb4a6$export$3902c91d8b98a753 = '#313D52';
const $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5 = '#283447';
const $5e0c0d4e15efb4a6$export$33ff357f6620b39 = '#202B3D';
const $5e0c0d4e15efb4a6$export$633847cf062b69e0 = '#1B2638';
const $5e0c0d4e15efb4a6$export$9776a6e503bdbf76 = '#121A29';
const $5e0c0d4e15efb4a6$export$6c813d5160dff5db = '#0E1624';
const $5e0c0d4e15efb4a6$export$3d4f271a500072a = '#0D1424';
const $5e0c0d4e15efb4a6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5e0c0d4e15efb4a6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5e0c0d4e15efb4a6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5e0c0d4e15efb4a6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5e0c0d4e15efb4a6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5e0c0d4e15efb4a6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5e0c0d4e15efb4a6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5e0c0d4e15efb4a6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5e0c0d4e15efb4a6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5e0c0d4e15efb4a6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5e0c0d4e15efb4a6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5e0c0d4e15efb4a6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5e0c0d4e15efb4a6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5e0c0d4e15efb4a6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5e0c0d4e15efb4a6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5e0c0d4e15efb4a6$export$d2adc5dedf09fced = '#292A2E';
const $5e0c0d4e15efb4a6$export$f51762073d2bb381 = '#94C748';
const $5e0c0d4e15efb4a6$export$95e26d54def96891 = '#B3DF72';
parcelRegister("5tOuG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$480b8b26c423ed9b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8STCT;
    var $1WrCb;
    var $6onh1;
    const $480b8b26c423ed9b$var$SkeletonItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8STCT")).default), {
            cssFn: ()=>({
                    ...(0, (0, parcelRequire("1WrCb")).sectionHeaderSpacingStyles)(),
                    '&&::before': {
                        height: '1.5rem',
                        marginRight: "var(--ds-space-200, 16px)",
                        width: '1.5rem'
                    }
                }),
            ...props
        });
    };
    var $480b8b26c423ed9b$export$2e2bcd8739ae039 = $480b8b26c423ed9b$var$SkeletonItem;
});
parcelRegister("gbGmI", function(module, exports) {
    $parcel$export(module.exports, "setPerformanceMarkLoadStart", ()=>$46c186c6902de7dc$export$4166241bf9111f66);
    $parcel$export(module.exports, "setPerformanceMarkLoadEnd", ()=>$46c186c6902de7dc$export$edbd543f308bbef5);
    var $5e7oM;
    var $azzrO;
    const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart);
    };
    const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd);
    };
});
parcelRegister("bxwfY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("a8u2l")
    ]).then(()=>parcelRequire('caET0'));
});
parcelRegister("dmKXV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac63d95d52d9688b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("6RP79")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
    });
    const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "coreProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
    var $ac63d95d52d9688b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);
});
parcelRegister("6RP79", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bpTJC")
    ]).then(()=>parcelRequire('8rIQt'));
});
parcelRegister("iHiHz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$883820dc444dc59c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("6xFyF")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
    });
    const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
    $883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
    var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;
});
parcelRegister("6xFyF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3EO4A")
    ]).then(()=>parcelRequire('kO26e'));
});
parcelRegister("cOg46", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18dc7dd640caeb91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("jjusI")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
    });
    const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
    $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
    var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;
});
parcelRegister("jjusI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("gQZpl")
    ]).then(()=>parcelRequire('6Pefo'));
});
parcelRegister("koWFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73e9a7a50d60fc40$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("lsLuI")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
    });
    const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "softwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar, null)));
    $73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
    var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;
});
parcelRegister("lsLuI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4OI1j")
    ]).then(()=>parcelRequire('4WgKv'));
});
parcelRegister("h0bZU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca3f1b5dd616f02b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $ca3f1b5dd616f02b$export$5b9febabdab63fba = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("icdgh")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
    });
    const $ca3f1b5dd616f02b$var$ServicedeskSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$5b9febabdab63fba, null)));
    $ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
    var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;
});
parcelRegister("icdgh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aOxtZ")
    ]).then(()=>parcelRequire('eufGV'));
});
parcelRegister("9s3j1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed71aad279526f75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("68Yoa")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
    });
    const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "classicSoftwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar, null)));
    $ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
    var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;
});
parcelRegister("68Yoa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXBFn")
    ]).then(()=>parcelRequire('dydBa'));
});
parcelRegister("2IHt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8627747b0236ab96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $8627747b0236ab96$var$LazyUserSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("j9Afm")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
    });
    const $8627747b0236ab96$var$UserSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "user"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
    $8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
    var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;
});
parcelRegister("j9Afm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("36IoX")
    ]).then(()=>parcelRequire('3AQ56'));
});
parcelRegister("93Yeu", function(module, exports) {
    $parcel$export(module.exports, "useProjectKey", ()=>$5f0f9360597cdbd8$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useProjectContextActions", ()=>$5f0f9360597cdbd8$export$bd73624ca941f105);
    $parcel$export(module.exports, "useProjectType", ()=>$5f0f9360597cdbd8$export$6de29d851c914935);
    $parcel$export(module.exports, "useProjectContext", ()=>$5f0f9360597cdbd8$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useApplication", ()=>$5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
    $parcel$export(module.exports, "useEdition", ()=>$5f0f9360597cdbd8$export$d56c02945cf5a9e5);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$5f0f9360597cdbd8$export$524ef4f6102ed540);
    $parcel$export(module.exports, "useIsClassicProject", ()=>$5f0f9360597cdbd8$export$e2cf96f40a8867ce);
    $parcel$export(module.exports, "useProjectId", ()=>$5f0f9360597cdbd8$export$16d1475ed6c26568);
    $parcel$export(module.exports, "useProjectStatus", ()=>$5f0f9360597cdbd8$export$30f16f2782a4113b);
    $parcel$export(module.exports, "useProjectConfiguration", ()=>$5f0f9360597cdbd8$export$af19ad68b52fa1a6);
    $parcel$export(module.exports, "useProjectIssueTypes", ()=>$5f0f9360597cdbd8$export$80bef597b440cf71);
    var $5uXOq = parcelRequire("5uXOq");
    var $efvDm;
    var $ldyPw;
    var $g5X3G;
    var $9OXo1;
    var $buby4;
    var $1daUm;
    const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
        const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, (0, parcelRequire("buby4")).useProjectContextActionStore)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectContext: setProjectContext,
                mergeProjectProperty: mergeProjectProperty
            }), [
            setProjectContext,
            mergeProjectProperty
        ]);
        return [
            null,
            actions
        ];
    };
    const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
        const [projectType] = (0, (0, parcelRequire("buby4")).useProjectContextProjectTypeStore)({
            projectKey: projectKey
        });
        return projectType;
    };
    const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext;
    };
    const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        if (projectType === undefined) {
            if (failSafely) return undefined;
            throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
        }
        return (0, (0, parcelRequire("efvDm")).getApplicationForProject)(projectType);
    };
    const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
        const { appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
        if (!application) return undefined;
        return (0, (0, parcelRequire("ldyPw")).getEdition)(application, appEditions);
    };
    const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.isSimplified || false;
    };
    const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return !projectContext?.isSimplified;
    };
    const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectId;
    };
    const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
        const [projectContext] = (0, (0, parcelRequire("buby4")).useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectStatus;
    };
    const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
        const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
        const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
        return (0, (0, parcelRequire("1daUm")).getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        });
    };
    const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
        const [projectName] = (0, (0, parcelRequire("buby4")).useProjectContextProjectNameStore)({
            projectKey: projectKey
        });
        return projectName;
    };
    const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
        const [issueTypes] = (0, (0, parcelRequire("buby4")).useProjectContextIssueTypesStore)({
            projectKey: projectKey
        });
        return issueTypes;
    };
});
parcelRegister("buby4", function(module, exports) {
    $parcel$export(module.exports, "useProjectContextActionStore", ()=>$42c27dedc1310bb2$export$9afb89c1fe103bbe);
    $parcel$export(module.exports, "useProjectContextStore", ()=>$42c27dedc1310bb2$export$8b09478b33186ec);
    $parcel$export(module.exports, "useProjectContextProjectTypeStore", ()=>$42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
    $parcel$export(module.exports, "useProjectContextProjectNameStore", ()=>$42c27dedc1310bb2$export$9469fde70658518);
    $parcel$export(module.exports, "useProjectContextIssueTypesStore", ()=>$42c27dedc1310bb2$export$f73e9904779f6be5);
    var $3sQ5x;
    var $iXqE5;
    var $aDpiK;
    const $42c27dedc1310bb2$var$initialState = {};
    const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'project-context',
        initialState: $42c27dedc1310bb2$var$initialState,
        actions: (0, parcelRequire("aDpiK"))
    });
    const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
    const $42c27dedc1310bb2$export$8b09478b33186ec = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectContext
    });
    const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectType;
    };
    const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectType
    });
    const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectName;
    };
    const $42c27dedc1310bb2$export$9469fde70658518 = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getProjectName
    });
    const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
        const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.issueTypes;
    };
    const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, (0, parcelRequire("3sQ5x")).createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
        selector: $42c27dedc1310bb2$var$getIssueTypes
    });
});
parcelRegister("aDpiK", function(module, exports) {
    $parcel$export(module.exports, "setProjectContext", ()=>$ad16c28ce51d4ccf$export$d64151aab9ae5f09);
    $parcel$export(module.exports, "mergeProjectProperty", ()=>$ad16c28ce51d4ccf$export$78f1c6052937615f);
    const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
            setState({
                [key]: projectContext
            });
        };
    const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentProjectContext = currentState[key];
            const newProjectContext = {
                ...currentProjectContext,
                ...projectContext
            };
            setState({
                [key]: newProjectContext
            });
        };
});
parcelRegister("1daUm", function(module, exports) {
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$7afb7a15cd46bd62$export$902f6c5cc939598a);
    var $65mz3;
    var $2vSU6;
    const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
    const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SOFTWARE_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
                $7afb7a15cd46bd62$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).MOBILE_ISSUE,
            issueActions: []
        });
    const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $7afb7a15cd46bd62$export$381ce08838c53afa();
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $7afb7a15cd46bd62$export$db1115186532f6d5();
            default:
                return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        }
        return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    };
});
parcelRegister("65mz3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7178ba5d31d0f054$export$2e2bcd8739ae039);
    const $7178ba5d31d0f054$var$keys = {
        CONNECT_ISSUE: 'connect-issue',
        BITBUCKET_ISSUE: 'bitbucket-issue',
        CORE_ISSUE: 'core-issue',
        MOBILE_ISSUE: 'mobile-issue',
        SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
        SOFTWARE_ISSUE: 'software-issue',
        STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
        SERVICE_DESK: 'service-desk',
        EMPTY_APPLICATION_KEY: ''
    };
    var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;
});
parcelRegister("dAfqg", function(module, exports) {
    $parcel$export(module.exports, "useProjectContext", ()=>$0baaa0dcf730951a$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$0baaa0dcf730951a$export$524ef4f6102ed540);
    $parcel$export(module.exports, "ProjectContextProvider", ()=>$0baaa0dcf730951a$export$a85f6b5857d2176);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
        const { data: data, error: error, loading: loading, update: update, key: key } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache), customContext);
        const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
            update
        ]);
        return {
            data: data,
            error: error,
            loading: loading,
            updateCache: updateCache,
            key: key
        };
    };
    const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
        const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return data?.simplified || false;
    };
    const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
        const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return children(projectContext);
    };
});
parcelRegister("2G9Bk", function(module, exports) {
    $parcel$export(module.exports, "createEntry", ()=>$2b838b47862d019e$export$344b9c9ab5e66c9a);
    const $2b838b47862d019e$export$344b9c9ab5e66c9a = (baseRoute, opts)=>{
        baseRoute.lazyOpts = opts;
        return baseRoute;
    };
});
parcelRegister("lNicp", function(module, exports) {
    $parcel$export(module.exports, "getBusinessProjectResources", ()=>$492115de1a4c9f28$export$20e8c2951e444b08);
    $parcel$export(module.exports, "getProjectViewResources", ()=>$492115de1a4c9f28$export$fcbe882e18ee4a35);
    $parcel$export(module.exports, "getOverviewViewResources", ()=>$492115de1a4c9f28$export$21c5527b459d56fe);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dAmbh;
    var $g4ZHz;
    var $1E3vT;
    var $iNzEe;
    var $jrO9m;
    var $l2N2a;
    var $9yEpR;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    const $492115de1a4c9f28$var$commonResources = [
        (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
        (0, (0, parcelRequire("iNzEe")).navigationResource)
    ];
    const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
            (0, (0, parcelRequire("1E3vT")).navigationItemsResource)
        ];
    const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("jrO9m")).overviewDetailsResource)
        ];
    const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
            ...$492115de1a4c9f28$export$20e8c2951e444b08(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
            ...$492115de1a4c9f28$export$46471673e66df5c1(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
});
parcelRegister("dAmbh", function(module, exports) {
    $parcel$export(module.exports, "configurationResource", ()=>$43ad736dfc62d10f$export$5c4ad441346dc154);
    $parcel$export(module.exports, "useRankField", ()=>$43ad736dfc62d10f$export$fffa1172af8de100);
    $parcel$export(module.exports, "useStartDateField", ()=>$43ad736dfc62d10f$export$bf78b0881400efef);
    $parcel$export(module.exports, "useIsLinkingEnabled", ()=>$43ad736dfc62d10f$export$76fc5a1eecec5a35);
    $parcel$export(module.exports, "useIsSubtasksEnabled", ()=>$43ad736dfc62d10f$export$dca58a051cb58f03);
    var $2M1hQ;
    var $2YP9W;
    var $58BMJ;
    const $43ad736dfc62d10f$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
    const $43ad736dfc62d10f$export$5c4ad441346dc154 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $43ad736dfc62d10f$var$RESOURCE_KEY,
        getKey: ()=>$43ad736dfc62d10f$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("58BMJ")).fetchConfiguration)(cloudId),
        maxAge: Infinity
    });
    const $43ad736dfc62d10f$export$b629b793d58e3884 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($43ad736dfc62d10f$export$5c4ad441346dc154);
    const $43ad736dfc62d10f$export$fffa1172af8de100 = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.rankField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$bf78b0881400efef = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.startDateField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$76fc5a1eecec5a35 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isLinkingEnabled ?? false;
    };
    const $43ad736dfc62d10f$export$dca58a051cb58f03 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isSubtasksEnabled ?? false;
    };
});
parcelRegister("58BMJ", function(module, exports) {
    $parcel$export(module.exports, "fetchConfiguration", ()=>$1cb1e84b048c3101$export$9911e92fcb5c83c0);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $lKH3S;
    const $1cb1e84b048c3101$export$9911e92fcb5c83c0 = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
                body: JSON.stringify({
                    query: (0, $5c0554031841947d$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            if (response.data == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return (0, (0, parcelRequire("lKH3S")).transformData)(response);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'configurationResource',
                    packageName: 'jiraRouterResourcesBusinessConfiguration',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
parcelRegister("jlq4V", function(module, exports) {
    $parcel$export(module.exports, "GraphQLErrors", ()=>$503bc83696833cc0$export$89c202e66b2de2b6);
    var $7hpBk = parcelRequire("7hpBk");
    var $8LQ84 = parcelRequire("8LQ84");
    const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
        let message = '';
        if ((0, ($parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
            const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += `${errorMessage}\n`;
        });
        message = message.replace(/\n$/, '');
        return message;
    };
    class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
        constructor(graphQLErrors){
            super();
            this.graphQLErrors = graphQLErrors != null ? (0, ($parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
            this.message = $503bc83696833cc0$var$generateErrorMessage(this);
            this.cause = this.graphQLErrors?.[0];
            this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
            this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
        }
    }
});
parcelRegister("7hpBk", function(module, exports) {
    var $8LQ84 = parcelRequire("8LQ84");
    function $54cdfac2bc83c2a9$var$castArray() {
        if (!arguments.length) return [];
        var value = arguments[0];
        return $8LQ84(value) ? value : [
            value
        ];
    }
    module.exports = $54cdfac2bc83c2a9$var$castArray;
});
const $5c0554031841947d$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
  }
}
`;
parcelRegister("lKH3S", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$0ad069c9956cd674$export$3ceb62baab058c6b);
    const $0ad069c9956cd674$export$3ceb62baab058c6b = (response)=>{
        let rankField = null;
        const rankFieldNode = response.data?.jira?.rankField;
        if (rankFieldNode != null) rankField = {
            id: rankFieldNode.fieldId,
            name: rankFieldNode.name
        };
        let startDateField = null;
        const startDateFieldNode = response.data?.jira?.startDateField;
        if (startDateFieldNode != null) startDateField = {
            id: startDateFieldNode.fieldId,
            name: startDateFieldNode.name
        };
        const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
        const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
        return {
            rankField: rankField,
            startDateField: startDateField,
            isLinkingEnabled: isLinkingEnabled,
            isSubtasksEnabled: isSubtasksEnabled
        };
    };
});
parcelRegister("g4ZHz", function(module, exports) {
    $parcel$export(module.exports, "fieldsResource", ()=>$410efef54f79d33f$export$8bca6c1954ae9308);
    $parcel$export(module.exports, "useFieldsResource", ()=>$410efef54f79d33f$export$c0cd85886917fe89);
    var $7q3cr;
    var $jlq4V;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $ljySl;
    var $kig09;
    const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
    const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
    };
    const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
    };
    const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
            if (match.params.overviewId) return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
                overviewAri: (0, (0, parcelRequire("7q3cr")).JiraProjectOverviewAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    overviewId: match.params.overviewId
                }).toString()
            });
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
                cloudId: cloudId,
                jqlContext: `project = '${projectIdOrKey}'`
            });
        },
        maxAge: 3600000
    });
    const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($410efef54f79d33f$export$8bca6c1954ae9308);
});
parcelRegister("7q3cr", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectOverviewAri", ()=>$566d717b3b39d3ba$export$714879003922a622);
    var $gPEvR;
    var $9KGzW;
    var $1C2Ux;
    var $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("gPEvR")).JiraProjectOverviewAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gPEvR")).JiraProjectOverviewAriResourceType),
        resourceIdSlug: "activation/{activationId}/{overviewId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
        }
    };
    var $566d717b3b39d3ba$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get overviewId() {
            return this._overviewId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.qualifier,
                platformQualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
                resourceType: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    overviewId: opts.overviewId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
            return new _JiraProjectOverviewAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
            return new _JiraProjectOverviewAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                overviewId: this.overviewId
            };
        }
    };
});
parcelRegister("gPEvR", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", ()=>$c410d5ca87dd2023$export$d68ef32d028cea3e);
    $parcel$export(module.exports, "JiraProjectOverviewAriResourceType", ()=>$c410d5ca87dd2023$export$491d1b3b0151dbc4);
    var $c410d5ca87dd2023$export$d68ef32d028cea3e = "jira", $c410d5ca87dd2023$export$491d1b3b0151dbc4 = "project-overview";
});
const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;
parcelRegister("ljySl", function(module, exports) {
    $parcel$export(module.exports, "fetchFields", ()=>$90e7c5e5920e8507$export$f3ddd735c360919);
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
    const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
        try {
            const promise = (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: $90e7c5e5920e8507$var$PAGE_SIZE,
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return await handler(promise);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fieldsResource',
                    packageName: 'jiraRouterResourcesBusinessFields',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
parcelRegister("kig09", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$3d209f684c72dca4$export$3ceb62baab058c6b);
    const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);
});
parcelRegister("1E3vT", function(module, exports) {
    $parcel$export(module.exports, "navigationItemsResource", ()=>$4f364072ed560b43$export$8446b129b5aba359);
    var $j5YhT;
    var $dJl1T;
    var $4R6GH;
    var $7uLIV;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $6SGt4;
    var $1nb22;
    var $gNStA;
    const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
    const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
            return '';
        }
    };
    const $4f364072ed560b43$export$38c041bf3215c084 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const { cloudId: cloudId } = tenantContext;
            const projectIdOrKey = projectKey || projectId;
            const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
            return {
                parameters: (0, (0, parcelRequire("6SGt4")).default),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                    isConsolidatedQuery: false,
                    containerNavigationInput: scopeId ? {
                        scopeId: scopeId
                    } : {
                        projectKeyQuery: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    },
                    useContainerNavigation: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    useNewProjectHeader: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    projectKey: projectKey,
                    projectAri: scopeId,
                    useProjectKey: Boolean(projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $4f364072ed560b43$export$8446b129b5aba359 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('blu-5473-consolidate-business-and-software-nav'), (0, (0, parcelRequire("7uLIV")).horizontalNavJiraResource), $4f364072ed560b43$export$38c041bf3215c084);
});
parcelRegister("7uLIV", function(module, exports) {
    $parcel$export(module.exports, "horizontalNavJiraResource", ()=>$1769860a1d0fe224$export$faeb8c89315e20da);
    var $1WQct;
    var $j5YhT;
    var $95bh0;
    var $dJl1T;
    var $eM91u;
    var $ao2h1;
    var $fw41V;
    var $8YTna;
    var $1nb22;
    const $1769860a1d0fe224$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.horizontal-nav-jira', 'Failed to get project ari');
            return '';
        }
    };
    const $1769860a1d0fe224$export$faeb8c89315e20da = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            let scope;
            const { cloudId: cloudId } = tenantContext;
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
            if (isTMPBoardRoute) scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
            else scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId,
                boardId: boardId
            });
            const boardAri = scope.identifierType === 'boardId' ? (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
                siteId: cloudId,
                boardId: String(match.params.boardId)
            }).toString() : null;
            const projectAri = $1769860a1d0fe224$var$getProjectAri(projectId, cloudId);
            const containerNavigationInput = boardAri || projectAri ? {
                scopeId: String(boardAri || projectAri)
            } : {
                projectKeyQuery: {
                    cloudId: cloudId,
                    projectKey: projectKey
                }
            };
            const boardAriTemp = boardId ? (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
                siteId: cloudId,
                boardId: boardId
            }).toString() : (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).create({
                siteId: cloudId,
                boardId: '0'
            }).toString();
            return {
                parameters: (0, (0, parcelRequire("fw41V")).default),
                variables: {
                    cloudId: cloudId,
                    projectKey: projectKey,
                    projectAri: projectAri,
                    projectIdOrKey: projectIdOrKey,
                    first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                    isConsolidatedQuery: true,
                    containerNavigationInput: containerNavigationInput,
                    boardId: boardAriTemp,
                    useProjectKey: Boolean(projectKey),
                    useProjectAri: Boolean(projectAri),
                    hasBoardId: Boolean(boardId),
                    isTMPBoardRoute: Boolean(isTMPBoardRoute)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("eM91u", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", ()=>$8ade7fd740dbd607$export$4653cda61a4943d6);
    $parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", ()=>$8ade7fd740dbd607$export$d1b9ea3245b6a5de);
    $parcel$export(module.exports, "TAB_HEIGHT", ()=>$8ade7fd740dbd607$export$d07bba395c9390f1);
    $parcel$export(module.exports, "TAB_HEIGHT_REFRESH", ()=>$8ade7fd740dbd607$export$7795e1ec8bf78852);
    $parcel$export(module.exports, "TAB_GAP", ()=>$8ade7fd740dbd607$export$b61e6f89a9db76de);
    const $8ade7fd740dbd607$export$4653cda61a4943d6 = 75;
    const $8ade7fd740dbd607$export$d1b9ea3245b6a5de = 2;
    const $8ade7fd740dbd607$export$d07bba395c9390f1 = 36;
    const $8ade7fd740dbd607$export$7795e1ec8bf78852 = 56;
    const $8ade7fd740dbd607$export$29911ec08ab2ca2d = 5;
    const $8ade7fd740dbd607$export$b61e6f89a9db76de = 12;
    const $8ade7fd740dbd607$export$7fd2e391116c6ef5 = 9;
    const $8ade7fd740dbd607$export$e1633e494d305bfb = 'MORE';
});
parcelRegister("ao2h1", function(module, exports) {
    $parcel$export(module.exports, "RELAY_RESOURCE_TYPE", ()=>$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
    $parcel$export(module.exports, "createRelayResource", ()=>$5f6ac21695ec30bb$export$1cc887c62079ea32);
    $parcel$export(module.exports, "useRelayResource", ()=>$5f6ac21695ec30bb$export$42ca7b248c7aaee);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $2M1hQ;
    var $2YP9W;
    var $7dbuH;
    const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $5f6ac21695ec30bb$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const query = parameters ?? await loadParameters?.();
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("7dbuH")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), parameters, variables || {}, options));
        if (false && queryReference.id != null) {
            const promise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            if (promise) return promise.then(()=>{
                (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("7dbuH")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            });
        }
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("7dbuH")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: (routerContext, customContext)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('blu-3813-improve-ssr-hydration-of-relay')) return $5f6ac21695ec30bb$var$getDataNew({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
                return $5f6ac21695ec30bb$var$getDataOld({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    loadParameters: loadParameters,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
        const { data: queryReference, loading: loading, promise: promise } = (0, (0, parcelRequire("2YP9W")).useResource)(resource);
        if (options?.suspendWhenLoading && loading) throw promise;
        return {
            queryReference: queryReference
        };
    };
});
parcelRegister("fw41V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$700289581fe4f1d4$export$2e2bcd8739ae039);
    const $700289581fe4f1d4$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "containerNavigationInput"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
            }
        ], v2 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canEdit"
                }
            ],
            "type": "JiraContainerNavigation"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiHorizontalNavJiraQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            v2
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.containerNavigation"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiHorizontalNavJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1e62394dd8824b945a355e927f327143a86142b7d143e9e80f5c1e78e8c1fc9b",
                "metadata": {},
                "name": "uiHorizontalNavJiraQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $700289581fe4f1d4$var$node.hash = "8c6299320fa1fa2dc0aff4a7311d91f0";
    var $700289581fe4f1d4$export$2e2bcd8739ae039 = $700289581fe4f1d4$var$node;
});
parcelRegister("6SGt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fed7f561d3a05da6$export$2e2bcd8739ae039);
    const $fed7f561d3a05da6$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConsolidatedQuery"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useNewProjectHeader"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v10 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v11 = [
            v10,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v12 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v13 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v14 = {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        }, v15 = {
            "kind": "ScalarField",
            "name": "name"
        }, v16 = {
            "condition": "useNewProjectHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectBoardHeader_horizontalNavHeader_projectFragment"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "projectHeader_horizontalNavHeader_projectFragment"
                }
            ]
        }, v17 = {
            "kind": "FragmentSpread",
            "name": "tabs_businessHorizontalNav_TabsContent_projectFragment"
        }, v18 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v19 = {
            "args": [
                v10
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                }
            ]
        }, v20 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v21 = [
            v10,
            v20,
            {
                "kind": "Variable",
                "name": "projectIdOrKey",
                "variableName": "projectIdOrKey"
            }
        ], v22 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v23 = {
            "kind": "ScalarField",
            "name": "id"
        }, v24 = {
            "kind": "ScalarField",
            "name": "label"
        }, v25 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v26 = {
            "kind": "ScalarField",
            "name": "url"
        }, v27 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v28 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v29 = [
            v28
        ], v30 = {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v22,
                v23,
                {
                    "kind": "ScalarField",
                    "name": "isDefault"
                },
                {
                    "kind": "ScalarField",
                    "name": "typeKey"
                },
                {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v24,
                {
                    "kind": "ScalarField",
                    "name": "canRemove"
                },
                {
                    "kind": "ScalarField",
                    "name": "canSetAsDefault"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                                v24,
                                {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        v24,
                                        v25,
                                        v26,
                                        v27
                                    ]
                                }
                            ]
                        },
                        v26,
                        v25,
                        v27,
                        {
                            "kind": "ScalarField",
                            "name": "appType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "envLabel"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v29,
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                        }
                    ],
                    "type": "JiraAppNavigationItem"
                },
                {
                    "condition": "isConsolidatedQuery",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": v29
                },
                v28
            ]
        }, v31 = [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v22,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ], v32 = {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": v31
        }, v33 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v34 = {
            "kind": "InlineFragment",
            "selections": [
                v23
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v35 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v36 = {
            "kind": "ScalarField",
            "name": "projectStyle"
        }, v37 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v38 = {
            "kind": "ScalarField",
            "name": "key"
        }, v39 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v40 = [
            v12,
            v13,
            v14,
            v15,
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            v23,
            {
                "condition": "useNewProjectHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v35,
                    v36,
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    {
                        "alias": "canEditProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v37,
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                    },
                    {
                        "alias": "canViewProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v37,
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                    },
                    v38,
                    {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                    },
                    {
                        "concreteType": "JiraBoardConnection",
                        "kind": "LinkedField",
                        "name": "boards",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraBoardEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraBoard",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v39,
                                            {
                                                "concreteType": "JiraFavouriteValue",
                                                "kind": "LinkedField",
                                                "name": "favouriteValue",
                                                "plural": false,
                                                "selections": [
                                                    v35,
                                                    v23
                                                ]
                                            },
                                            v33,
                                            v23,
                                            v28
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v28
                ]
            },
            {
                "condition": "isConsolidatedQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v36,
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v22,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39
                                ],
                                "type": "JiraBoard"
                            },
                            v34
                        ]
                    },
                    {
                        "condition": "isConsolidatedQuery",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v38
                        ]
                    }
                ]
            },
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v22,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v23
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v22,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v39,
                                    {
                                        "kind": "ScalarField",
                                        "name": "boardType"
                                    }
                                ],
                                "type": "JiraBoard"
                            },
                            v34
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9
                ],
                "kind": "Fragment",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "tabs_businessHorizontalNav_TabsContent_jiraQueryFragment"
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectDataByKey",
                                            "args": v11,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                v12,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v13,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataByKey.projectId"
                                                },
                                                v14,
                                                v15,
                                                v16,
                                                v17
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectDataById",
                                            "args": v18,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProject",
                                            "plural": false,
                                            "selections": [
                                                v12,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v13,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById.projectId"
                                                },
                                                v14,
                                                v15,
                                                v16,
                                                v17
                                            ]
                                        }
                                    ]
                                },
                                v19
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v5,
                    v2,
                    v3,
                    v1,
                    v7,
                    v6,
                    v4,
                    v9,
                    v8
                ],
                "kind": "Operation",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v19,
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "navigationItems",
                                        "args": v21,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmSavedViewsByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v30,
                                                    v22,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    }
                                                ]
                                            },
                                            v32,
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "alias": "navigationItems",
                                        "args": v21,
                                        "filters": [
                                            "cloudId",
                                            "projectIdOrKey"
                                        ],
                                        "handle": "connection",
                                        "key": "tabs_jiraNavigation__navigationItems",
                                        "kind": "LinkedHandle",
                                        "name": "jwmSavedViewsByProject"
                                    }
                                ]
                            },
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "input",
                                                "variableName": "containerNavigationInput"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraContainerNavigationResult"
                                            },
                                            v22,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v23,
                                                    v33,
                                                    {
                                                        "args": [
                                                            v20
                                                        ],
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    v30,
                                                                    v22
                                                                ]
                                                            },
                                                            v32
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v31,
                                                "type": "QueryError"
                                            },
                                            v34
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v11,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v40
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v18,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": v40
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6d49a582f38a072ccb9f12581830b939f48a2ab461d7881d3494c38c8f24651d",
                "metadata": {},
                "name": "projectNavigation_horizontalNavigationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $fed7f561d3a05da6$var$node.hash = "5f0fc5f96f73c473950545dece8490fe";
    var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;
});
parcelRegister("iNzEe", function(module, exports) {
    $parcel$export(module.exports, "navigationResource", ()=>$6b942b0827824c4b$export$62940941ee574cdc);
    $parcel$export(module.exports, "useNavigationResource", ()=>$6b942b0827824c4b$export$c17011c09e042a31);
    $parcel$export(module.exports, "useIsPremiumUserSeat", ()=>$6b942b0827824c4b$export$90749419e9042370);
    $parcel$export(module.exports, "useTriggerOverviewChangeboarding", ()=>$6b942b0827824c4b$export$30f6f0b00bf4f2f8);
    var $gccSB = parcelRequire("gccSB");
    var $j5YhT;
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $geiy6;
    const $6b942b0827824c4b$export$62940941ee574cdc = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'BUSINESS_NAVIGATION',
        getKey: ()=>'BUSINESS_NAVIGATION',
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return null;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (!(0, ($parcel$interopDefault($gccSB)))(projectKey)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
                cloudId: cloudId,
                projectKey: projectKey
            });
            if (!(0, ($parcel$interopDefault($gccSB)))(projectId)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
                cloudId: cloudId,
                projectId: (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: projectId
                }).toString()
            });
            return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
                cloudId: cloudId
            });
        },
        maxAge: Infinity
    });
    const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($6b942b0827824c4b$export$62940941ee574cdc);
    const $6b942b0827824c4b$export$90749419e9042370 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.isPremiumUserSeat);
    };
    const $6b942b0827824c4b$export$30f6f0b00bf4f2f8 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.showPlansOnboarding);
    };
});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
parcelRegister("geiy6", function(module, exports) {
    $parcel$export(module.exports, "fetchNavigation", ()=>$446f8b979bebb841$export$1fc5fff73d9a570c);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ifwpM;
    const $446f8b979bebb841$var$EMPTY_RESPONSE = {
        recents: [],
        favorites: [],
        hasMoreFavorite: false,
        overviews: [],
        overviewsError: null,
        isPremiumUserSeat: false,
        showPlansOnboarding: false,
        shouldHideOverviews: false
    };
    const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response.data?.jira?.navigation === undefined) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            let areOverviewsGone = false;
            if (Array.isArray(response.errors)) areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
            return (0, (0, parcelRequire("ifwpM")).transformData)(response.data.jira.navigation, areOverviewsGone);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesBusinessNavigation',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $446f8b979bebb841$var$EMPTY_RESPONSE;
    };
});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';
parcelRegister("ifwpM", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$9031e5290b70d3d6$export$3ceb62baab058c6b);
    var $6cG4N;
    var $027FQ;
    const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
    const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite,
            permissions: {
                viewIssues: node.viewIssues.canPerform
            },
            defaultView: node.defaultView?.typeKey?.toLowerCase()
        });
    const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
            id: node.id,
            name: node.name,
            theme: node?.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
        });
    const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
        if (navigation == null) return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
        let overviews = [];
        let overviewsError = null;
        const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
        if (isPremiumUserSeat) {
            if (navigation.overviews?.__typename === (0, (0, parcelRequire("027FQ")).OVERVIEWS_SUCCESS_RESPONSE_TYPE)) overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
            else overviewsError = navigation.overviews ?? new Error('Unknown overviews error');
        }
        let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
        const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
        const shouldHideOverviews = areOverviewsGone && !showPlansOnboarding;
        return {
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
            overviews: overviews,
            overviewsError: overviewsError,
            isPremiumUserSeat: isPremiumUserSeat,
            showPlansOnboarding: showPlansOnboarding,
            shouldHideOverviews: shouldHideOverviews
        };
    };
});
parcelRegister("6cG4N", function(module, exports) {
    $parcel$export(module.exports, "STAR_ICON_COLOR", ()=>$cd302866fea6f361$export$9e0962e0cb41695d);
    $parcel$export(module.exports, "Variables", ()=>$cd302866fea6f361$export$8bb9d79ea938efc9);
    $parcel$export(module.exports, "Tokens", ()=>$cd302866fea6f361$export$8e1e81ac145e31be);
    $parcel$export(module.exports, "BASE_THEME", ()=>$cd302866fea6f361$export$8a6e9b3370a0f87a);
    $parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$f286efa6bd1e8f9d);
    $parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$97cb21c6432e07e8);
    $parcel$export(module.exports, "GRADIENT_THEME", ()=>$cd302866fea6f361$export$b124f62a6aab972);
    $parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$9441e0d8f766c59a);
    $parcel$export(module.exports, "NO_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$4c351ec1dc290344);
    $parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", ()=>$cd302866fea6f361$export$34373eced7ee212e);
    $parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", ()=>$cd302866fea6f361$export$5ddfadab7b1e12c1);
    $parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$349e5dbeac874253);
    $parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$242b2d2213fedf27);
    $parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", ()=>$cd302866fea6f361$export$fe05a238062e2c3d);
    $parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$cab9d853866386f2);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$cd302866fea6f361$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", ()=>$cd302866fea6f361$export$8e357501548afe78);
    $parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$baaf8255c30ea280);
    $parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$d9035bc768f8226d);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$4810531e30462f89);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$1c0b806722927549);
    $parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$2af5673c2fa63c55);
    $parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$5771162cdeebfb85);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$a1626d6d785092a2);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$410e3d6221a052e);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$8588194807a0ca4b);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$254a8b23553b7df3);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$41cffad47189e5bd);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$ef343e01db40c562);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", ()=>$cd302866fea6f361$export$77cdace62a821419);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", ()=>$cd302866fea6f361$export$3efe68325dd9dc02);
    var $fHYEP;
    var $44v1T;
    const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
    const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
        BACKDROP_FILTER: '--project-backdrop-filter',
        COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
        COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
        COLOR_BACKGROUND_INPUT: '--project-background-input',
        COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
        COLOR_BACKGROUND_SELECTED: '--project-background-selected',
        COLOR_BORDER: '--project-color-border',
        COLOR_BORDER_INPUT: '--project-color-border-input',
        COLOR_BORDER_INVERSE: '--project-color-border-inverse',
        COLOR_BORDER_SELECTED: '--project-color-border-selected',
        COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
        COLOR_ICON_DANGER: '--project-color-icon-danger',
        COLOR_ICON_INFORMATION: '--project-color-icon-information',
        COLOR_ICON_SUCCESS: '--project-color-icon-success',
        COLOR_ICON_WARNING: '--project-color-icon-warning',
        COLOR_LINK: '--project-color-link',
        COLOR_LINK_PRESSED: '--project-color-link-pressed',
        COLOR_SKELETON: '--project-skeleton',
        COLOR_TEXT: '--project-color-text',
        COLOR_TEXT_DISABLED: '--project-color-text-disabled',
        COLOR_TEXT_INVERSE: '--project-color-text-inverse',
        COLOR_TEXT_SELECTED: '--project-color-text-selected',
        COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
        COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
        CONTENT_HEIGHT: '--project-content-height',
        CONTENT_WIDTH: '--project-content-width',
        ELEVATION_SURFACE: '--project-elevation-surface',
        ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
        ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
        WRAPPER_BACKGROUND: '--project-wrapper-background',
        WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
        WRAPPER_HEIGHT: '--project-wrapper-height',
        WRAPPER_PADDING: '--project-wrapper-padding',
        WRAPPER_WIDTH: '--project-wrapper-width'
    };
    const $cd302866fea6f361$export$8e1e81ac145e31be = {
        BACKDROP_FILTER: 'var(--project-backdrop-filter)',
        COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
        COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
        COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
        COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
        COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
        COLOR_BORDER: 'var(--project-color-border)',
        COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
        COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
        COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
        COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
        COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
        COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
        COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
        COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
        COLOR_LINK: 'var(--project-color-link)',
        COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
        COLOR_SKELETON: 'var(--project-skeleton)',
        COLOR_TEXT: 'var(--project-color-text)',
        COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
        COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
        COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
        COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
        COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
        CONTENT_HEIGHT: 'var(--project-content-height)',
        CONTENT_WIDTH: 'var(--project-content-width)',
        ELEVATION_SURFACE: 'var(--project-elevation-surface)',
        ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
        ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
        WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
        WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
        WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
        WRAPPER_PADDING: 'var(--project-wrapper-padding)',
        WRAPPER_WIDTH: 'var(--project-wrapper-width)'
    };
    const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
        'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
        'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
        'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
        'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
        'color.background.input': `var(--ds-background-input, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        'color.background.neutral': `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$exports).N30A})`,
        'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N40A})`,
        'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $5e0c0d4e15efb4a6$exports).N50A})`,
        'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N40A})`,
        'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $5e0c0d4e15efb4a6$exports).N50A})`,
        'color.background.selected': `var(--ds-background-selected, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        'color.elevation.surface': `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        'color.border': `var(--ds-border, ${(0, $5e0c0d4e15efb4a6$exports).N40A})`,
        'color.border.input': "var(--ds-border-input, #091E4224)",
        'color.border.inverse': `var(--ds-border-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        'color.border.selected': `var(--ds-border-selected, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        'color.icon.danger': `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R200})`,
        'color.icon.information': `var(--ds-icon-information, ${(0, $5e0c0d4e15efb4a6$exports).B200})`,
        'color.icon.success': `var(--ds-icon-success, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
        'color.icon.warning': `var(--ds-icon-warning, ${(0, $5e0c0d4e15efb4a6$exports).Y200})`,
        'color.link': "var(--ds-link, #0c66e4)",
        'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
        'color.skeleton': `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$exports).N20A})`,
        'color.text': `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$exports).N800})`,
        'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
        'color.text.inverse': `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        'color.text.selected': `var(--ds-text-selected, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        'color.text.subtle': `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
        'elevation.surface.contrast': 'transparent',
        'elevation.surface.contrast.bolder': 'transparent'
    };
    const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
        'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
        'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
        'color.background.input': 'rgba(255, 255, 255, 0.8)',
        'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.text.selected': `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`
    };
    const $cd302866fea6f361$export$97cb21c6432e07e8 = {
        'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
        'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
        'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
        'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
        'color.background.input': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
        'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
        'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
        'color.background.selected': 'rgba(255, 255, 255, 0.6)',
        'color.elevation.surface': '#172b4d',
        'color.border': 'rgba(255, 255, 255, 0.14)',
        'color.border.input': 'rgba(255, 255, 255, 0.3)',
        'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
        'color.border.selected': (0, $5e0c0d4e15efb4a6$exports).N0,
        'color.icon.danger': (0, $5e0c0d4e15efb4a6$exports).N0,
        'color.icon.information': (0, $5e0c0d4e15efb4a6$exports).N0,
        'color.icon.success': (0, $5e0c0d4e15efb4a6$exports).N0,
        'color.icon.warning': (0, $5e0c0d4e15efb4a6$exports).N0,
        'color.skeleton': 'rgba(255,255,255,0.08)',
        'color.text': (0, $5e0c0d4e15efb4a6$exports).N0,
        'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
        'color.text.inverse': '#172B4D',
        'color.text.selected': '#172B4D',
        'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
        'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
    };
    const $cd302866fea6f361$export$b124f62a6aab972 = {
        'color.link': '#CCE0FF',
        'color.link.pressed': '#E9F2FF'
    };
    const $cd302866fea6f361$export$9441e0d8f766c59a = {
        name: 'image',
        brightness: 'high',
        theme: {
            light: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
                'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
                'color.text.selected': `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
                'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
                'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$exports).N0})`
            },
            dark: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.background.input': 'rgba(34, 39, 43, 0.8)',
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.elevation.surface': '#172b4d',
                'color.border': 'rgba(255, 255, 255, 0.14)',
                'color.border.input': 'rgba(255, 255, 255, 0.3)',
                'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
                'color.icon.danger': (0, $5e0c0d4e15efb4a6$exports).N0,
                'color.icon.information': (0, $5e0c0d4e15efb4a6$exports).N0,
                'color.icon.success': (0, $5e0c0d4e15efb4a6$exports).N0,
                'color.icon.warning': (0, $5e0c0d4e15efb4a6$exports).N0,
                'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
                'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
                'color.skeleton': 'rgba(255,255,255,0.8)',
                'color.text': (0, $5e0c0d4e15efb4a6$exports).N0,
                'color.text.selected': "var(--ds-text-inverse, #1D2125)",
                'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
                'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
            }
        }
    };
    const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
        name: 'white'
    };
    const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
        name: 'light-purple'
    };
    const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
        name: 'light-blue'
    };
    const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
        name: 'light-teal'
    };
    const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
        name: 'light-green'
    };
    const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
        name: 'light-yellow'
    };
    const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
        name: 'light-red'
    };
    const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
        name: 'light-magenta'
    };
    const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
        name: 'light-orange'
    };
    const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
        name: 'dark'
    };
    const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
        name: 'purple'
    };
    const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
        name: 'blue'
    };
    const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
        name: 'teal'
    };
    const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
        name: 'green'
    };
    const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
        name: 'yellow'
    };
    const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
        name: 'red'
    };
    const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
        name: 'magenta'
    };
    const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
        name: 'orange'
    };
    const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
        name: 'darker-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
        name: 'darker-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
        name: 'darker-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
        name: 'darker-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
        name: 'darker-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
        name: 'darker-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
        name: 'darker-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
        name: 'darker-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
        name: 'darker-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darker-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
        name: 'darkest-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'darkest-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
        name: 'darkest-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
        name: 'darkest-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
        name: 'darkest-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
        name: 'darkest-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'darkest-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'darkest-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
        name: 'darkest-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darkest-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
        name: 'lightest-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F1F2F4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'lightest-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F3F0FF',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
        name: 'lightest-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E9F2FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
        name: 'lightest-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E7F9FF',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
        name: 'lightest-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCFFF1',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
        name: 'lightest-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#EFFFD6',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'lightest-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF7D6',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'lightest-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF3EB',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
        name: 'lightest-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECEB',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lightest-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECF8',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
        name: 'lighter-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCDFE4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
        name: 'lighter-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DFD8FD',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
        name: 'lighter-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#CCE0FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
        name: 'lighter-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#C6EDFB',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
        name: 'lighter-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#BAF3DB',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
        name: 'lighter-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#D3F1A7',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
        name: 'lighter-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F8E6A0',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
        name: 'lighter-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FEDEC8',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
        name: 'lighter-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFD5D2',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lighter-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FDD0EC',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$export$4c351ec1dc290344 = {
        name: 'no-background',
        brightness: 'high',
        theme: {
            light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
            dark: $cd302866fea6f361$export$8a6e9b3370a0f87a
        }
    };
    const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
        name: 'gradient-gray-to-black',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
        name: 'gradient-dark-to-medium-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
        name: 'gradient-light-to-dark-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
        name: 'gradient-blue-to-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
        name: 'gradient-purple-to-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
        name: 'gradient-magenta-to-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
        name: 'gradient-dark-to-light-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
        name: 'gradient-dark-to-light-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
        name: 'gradient-dark-green-to-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
        name: 'gradient-dark-to-medium-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            }
        }
    };
    const $cd302866fea6f361$export$34373eced7ee212e = [
        $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$5ddfadab7b1e12c1 = [
        $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$349e5dbeac874253 = [
        ...$cd302866fea6f361$export$5ddfadab7b1e12c1,
        $cd302866fea6f361$export$4c351ec1dc290344
    ];
    const $cd302866fea6f361$export$242b2d2213fedf27 = [
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
        $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
        $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
        $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
        $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
    ];
    const $cd302866fea6f361$export$8f118a95a310853a = [
        ...$cd302866fea6f361$export$242b2d2213fedf27,
        ...$cd302866fea6f361$export$349e5dbeac874253
    ];
    const $cd302866fea6f361$export$fe05a238062e2c3d = {
        white: $cd302866fea6f361$export$4c351ec1dc290344,
        'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
    };
    const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
    const $cd302866fea6f361$export$ed7cc0d417ee89e = '--jwm-banner-height';
    const $cd302866fea6f361$export$7009ab5fba189797 = `var(${$cd302866fea6f361$export$ed7cc0d417ee89e}, 0px)`;
    const $cd302866fea6f361$export$8e357501548afe78 = 24;
    const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
    const $cd302866fea6f361$export$d9035bc768f8226d = `calc(${$cd302866fea6f361$export$baaf8255c30ea280}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
    const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$2af5673c2fa63c55 = 126;
    const $cd302866fea6f361$export$5771162cdeebfb85 = `calc(${$cd302866fea6f361$export$2af5673c2fa63c55}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
    const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$8588194807a0ca4b = 146;
    const $cd302866fea6f361$export$254a8b23553b7df3 = `calc(${$cd302866fea6f361$export$8588194807a0ca4b}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$41cffad47189e5bd = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3})`;
    const $cd302866fea6f361$export$ef343e01db40c562 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH)}) !important`;
    const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;
});
parcelRegister("44v1T", function(module, exports) {
    $parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", ()=>$81918a2ef6db1f93$export$d60454526e2281af);
    var $fHYEP;
    const $81918a2ef6db1f93$export$d60454526e2281af = `(${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT)} + ${(0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT)})`;
});
parcelRegister("027FQ", function(module, exports) {
    $parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", ()=>$fd4c320fd9ec6c35$export$ddf2fc82885279d);
    const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
    const $fd4c320fd9ec6c35$export$39284f7325536558 = {
        ServiceDesk: 'SERVICE_DESK',
        Business: 'BUSINESS',
        Software: 'SOFTWARE'
    };
    const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
        TeamManagedProject: 'TEAM_MANAGED_PROJECT',
        CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
    };
});
parcelRegister("jrO9m", function(module, exports) {
    $parcel$export(module.exports, "overviewDetailsResource", ()=>$e1715b61e2fa96e9$export$cd57aa046b167312);
    $parcel$export(module.exports, "useOverview", ()=>$e1715b61e2fa96e9$export$626541a5c6f2cfa1);
    var $2M1hQ;
    var $2YP9W;
    var $hFi7P;
    const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
    const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
        getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
        getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, (0, parcelRequire("hFi7P")).fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
        maxAge: 3600000
    });
    const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);
});
parcelRegister("hFi7P", function(module, exports) {
    $parcel$export(module.exports, "fetchOverviewDetails", ()=>$692d3aa28ecf0a74$export$f0395142dbdd6c61);
    var $7q3cr;
    var $63wRx;
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $dpLxG;
    const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
        if (!overviewId) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("dpLxG")).QUERY),
                    variables: {
                        id: (0, (0, parcelRequire("7q3cr")).JiraProjectOverviewAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            overviewId: overviewId
                        }).toString()
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) return (0, (0, parcelRequire("63wRx")).mapOverviewFragment)(response.data.jira.overview);
            throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response?.data?.jira?.overview ?? response.errors);
        } catch (error) {
            if (error?.statusCode === 410) throw error;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'overviewDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return null;
    };
});
parcelRegister("63wRx", function(module, exports) {
    $parcel$export(module.exports, "mapOverviewFragment", ()=>$bc1a4d4cd369fa52$export$e79bf238de33eabb);
    const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
            const { node: node } = edge || {};
            if (node == null) return null;
            return {
                key: node.key,
                id: Number(node.projectId),
                avatarUrl: node.avatar?.large ?? '',
                name: node.name,
                type: node.projectType.toLowerCase(),
                isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
                isFavorite: node.isFavourite === true,
                permissions: {
                    assignIssues: false,
                    administerProject: node.administerProject.canPerform,
                    createIssues: node.createIssues.canPerform,
                    deleteIssues: node.deleteIssues.canPerform,
                    editIssues: node.editIssues.canPerform,
                    linkIssues: node.linkIssues.canPerform,
                    scheduleIssues: node.scheduleIssues.canPerform,
                    transitionIssues: node.transitionIssues?.canPerform === true,
                    viewIssues: node.viewIssues.canPerform
                }
            };
        }).filter((project)=>project);
    const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
        const { id: id, name: name, theme: theme, projects: projectsData } = overview;
        const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
        const unreachableProjectsCount = projectsData.edges.length - projects.length;
        return {
            id: id,
            name: name,
            theme: theme,
            projects: projects,
            unreachableProjectsCount: unreachableProjectsCount
        };
    };
});
parcelRegister("dpLxG", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$42259e945f9fd88b$export$2b91517d6d5b4365);
    const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;
});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;
const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';
parcelRegister("l2N2a", function(module, exports) {
    $parcel$export(module.exports, "projectDetailsResource", ()=>$a72df1053ff3c9a0$export$e541d9eb202b4972);
    $parcel$export(module.exports, "useProject", ()=>$a72df1053ff3c9a0$export$51b1383ef8844a7);
    $parcel$export(module.exports, "useMediaConfiguration", ()=>$a72df1053ff3c9a0$export$ab5cf8327e07f046);
    var $1nb22;
    var $2M1hQ;
    var $2YP9W;
    var $8s4PA;
    const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
    const $a72df1053ff3c9a0$export$e541d9eb202b4972 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("8s4PA")).fetchProjectDetails)(cloudId, projectKey, projectId);
        },
        maxAge: 3600000
    });
    const $a72df1053ff3c9a0$export$51b1383ef8844a7 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return {
            data: data?.currentProject ?? null,
            loading: loading,
            error: error
        };
    };
    const $a72df1053ff3c9a0$export$ab5cf8327e07f046 = ()=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return data?.media ?? null;
    };
});
parcelRegister("8s4PA", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectDetails", ()=>$3400333a67b09775$export$78aa221476efa1c6);
    var $j5YhT;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $2D9kr;
    const $3400333a67b09775$var$EMPTY_VALUE = {
        themeSetting: null,
        media: null
    };
    const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
        const projectIdOrKey = projectId || projectKey;
        if (!projectIdOrKey) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
                body: JSON.stringify({
                    query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        usingProjectKey: projectId == null,
                        projectId: projectId != null ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                            siteId: cloudId,
                            projectId: projectId
                        }).toString() : ''
                    }
                })
            });
            return (0, (0, parcelRequire("2D9kr")).transformData)(response.data, projectIdOrKey);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'projectDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessProjectDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return $3400333a67b09775$var$EMPTY_VALUE;
    };
});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  assignIssues: action(type: ASSIGN_ISSUES) {
    canPerform
  }
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;
parcelRegister("2D9kr", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$a9016a2d391e1663$export$3ceb62baab058c6b);
    const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            status: node.status,
            isSimplified: node.simplified,
            isFavorite: node.favorite === true,
            permissions: {
                assignIssues: node.assignIssues.canPerform,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                transitionIssues: node.transitionIssues.canPerform,
                viewIssues: node.viewIssues.canPerform
            }
        };
    };
    const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
        const theme = data?.jwmSidebar?.theme;
        if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
            type: 'color',
            value: theme.colorValue
        };
        if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
            type: 'color',
            value: theme.gradientValue
        };
        if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
            const { customBackground: customBackground } = theme;
            const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
            return {
                type: 'image',
                value: 'image',
                id: id,
                mediaApiFileId: mediaApiFileId,
                mediaReadToken: mediaReadToken,
                sourceType: sourceType,
                sourceIdentifier: sourceIdentifier,
                altText: altText
            };
        }
        return null;
    };
    const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
        const clientId = data?.jira?.mediaClientId;
        const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
        if (clientId == null || externalEndpointUrl == null) return null;
        return {
            clientId: clientId,
            externalEndpointUrl: externalEndpointUrl
        };
    };
    const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
            themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data),
            currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
            projectIdOrKey: projectIdOrKey,
            media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
        });
});
parcelRegister("9yEpR", function(module, exports) {
    $parcel$export(module.exports, "storageDetailsResource", ()=>$920f9d6e578a6c36$export$76c871115d0c70a1);
    $parcel$export(module.exports, "useStorageDetails", ()=>$920f9d6e578a6c36$export$8c295c187914aac1);
    var $2M1hQ;
    var $2YP9W;
    var $6Z2DE;
    const $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
    const $920f9d6e578a6c36$export$76c871115d0c70a1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getKey: ()=>$920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, (0, parcelRequire("6Z2DE")).fetchStorageDetails)(appEditions),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $920f9d6e578a6c36$export$8c295c187914aac1 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($920f9d6e578a6c36$export$76c871115d0c70a1);
});
parcelRegister("6Z2DE", function(module, exports) {
    $parcel$export(module.exports, "fetchStorageDetails", ()=>$6e4752d8c4202fab$export$576d1c3de6af9760);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ldyPw;
    const $6e4752d8c4202fab$export$576d1c3de6af9760 = async (appEditions)=>{
        try {
            if (appEditions?.core !== (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) return null;
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/latest?query', {
                body: JSON.stringify({
                    query: (0, $3d489d21cba189e7$export$2b91517d6d5b4365),
                    variables: {
                        productKey: 'jira-core'
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors != null) {
                const error = response.errors?.[0];
                const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
                if (!isClientError) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            }
            const usageLimit = response?.data?.attachmentStorage;
            if (usageLimit && usageLimit?.allowed) {
                const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
                return percentageUsed;
            }
            return null;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getStorageAmountService',
                    packageName: 'jiraRouterResourcesBusinessStorageDetails',
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $3d489d21cba189e7$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;
parcelRegister("3RJkv", function(module, exports) {
    $parcel$export(module.exports, "getModernIssueTransitionResources", ()=>$4f455891fb36bf50$export$e1afa08027b1e44b);
    $parcel$export(module.exports, "getNavigationResources", ()=>$4f455891fb36bf50$export$75cffd1aaecf4a2c);
    $parcel$export(module.exports, "getUserBoardNavigationResources", ()=>$4f455891fb36bf50$export$c57dc1ea7f76f91f);
    $parcel$export(module.exports, "getNavigationSidebarPlanResources", ()=>$4f455891fb36bf50$export$af2259a87f79645d);
    $parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", ()=>$4f455891fb36bf50$export$a103e99ad51f7bc3);
    $parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", ()=>$4f455891fb36bf50$export$808691f5a412afa3);
    var $5kYzp;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $7xTO3;
    var $c1N9v;
    var $loy04;
    var $2fwuR;
    var $fwzEJ;
    var $3HwlS;
    var $h9iZl;
    var $2eyDn;
    var $drGWM;
    var $kMiZJ;
    var $bHhiy;
    var $aA974;
    var $f5nIZ;
    var $hZhhj;
    var $9MiT2;
    var $fNOVA;
    var $14XJw;
    var $kJQXA;
    var $atU1t;
    var $c34Wf;
    var $eOlBz;
    var $3X1Xr;
    var $dxCvy;
    var $jSv1P;
    var $kkNtb;
    var $2Ql51;
    var $9vlEn;
    var $gNStA;
    const $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
            'OFF',
            'BY_DEFAULT_USER_OPT_IN',
            'BY_DEFAULT_USER_OPT_OUT'
        ]);
    const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
        const variation = $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation();
        return variation !== 'OFF';
    };
    const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('render_modern_global_issue_create_modal_experience'), (0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
    const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, (0, parcelRequire("fNOVA")).issueTransitionOptInStatusResource));
    const $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs'), (0, (0, parcelRequire("aA974")).gicSmartFieldsFeatureResource));
    const $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), (0, (0, parcelRequire("2eyDn")).consentBannerUserPreferencesResource));
    const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
            $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
            (0, (0, parcelRequire("9MiT2")).issueTransitionChangeboardingPreferencesResource)
        ];
    const $4f455891fb36bf50$var$dedupableConditionalResources = [
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4Resource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("fwzEJ")).topNav4UIStateResource))
    ];
    const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ()=>[
            (0, (0, parcelRequire("c34Wf")).navigationUiStateResource),
            (0, (0, parcelRequire("h9iZl")).navigationPlansVisibilityResource),
            (0, (0, parcelRequire("9vlEn")).userHomepageResource),
            $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
            (0, (0, parcelRequire("5kYzp")).announcementBannerSettingsV4Resource),
            $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource,
            ...$4f455891fb36bf50$var$dedupableConditionalResources,
            (0, (0, parcelRequire("14XJw")).organizationIdResource),
            (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
            ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
            (0, (0, parcelRequire("3X1Xr")).persistentIssueCreateModalViewResource),
            $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource,
            (0, (0, parcelRequire("hZhhj")).incomingMailServerExpiryStatusResource),
            (0, (0, parcelRequire("kkNtb")).rovoEntitlementResource),
            (0, (0, parcelRequire("jSv1P")).jpdRecommendationDismissedResource)
        ];
    const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
            (0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
            (0, (0, parcelRequire("c1N9v")).staticPlanSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
            (0, (0, parcelRequire("drGWM")).checkApiKeyManagementKeysResource)()
        ];
    const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
});
parcelRegister("5kYzp", function(module, exports) {
    $parcel$export(module.exports, "announcementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$8fbe7f8de07afffd);
    $parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$6fb72f4a0c177494);
    var $2M1hQ;
    var $2YP9W;
    var $4AdUG;
    var $2EmJy;
    var $9UEf0;
    const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("2EmJy")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("4AdUG")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
    const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);
});
parcelRegister("4AdUG", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$90a9ae99ea774144$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$90a9ae99ea774144$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/4/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                content: '',
                bgColor: 'grey',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Get',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
    const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/4/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Set',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
});
parcelRegister("2EmJy", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$02ac2f2e29fd92e6$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/3/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                message: '',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/3/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';
parcelRegister("9UEf0", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$0fff4d2d98ff5692$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$0fff4d2d98ff5692$export$adaa4cf7ef1b65be);
    var $89SaW;
    var $jcw0u;
    const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
    const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
        try {
            return accoundId != null ? (await (0, (0, parcelRequire("89SaW")).getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
        } catch (error) {
            if (error.statusCode === 404) return null;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
        try {
            return await (0, (0, parcelRequire("89SaW")).setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
                hashId: hashId
            }));
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
parcelRegister("89SaW", function(module, exports) {
    $parcel$export(module.exports, "getUserPropertiesUrl", ()=>$646571db30c23ce6$export$f474e53c8191800a);
    $parcel$export(module.exports, "setUserProperties", ()=>$646571db30c23ce6$export$d0e176862bf869b8);
    $parcel$export(module.exports, "getUserProperty", ()=>$646571db30c23ce6$export$b3126db2ef6e34ed);
    var $gHS8W;
    var $jJZqs;
    const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
    const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), {
            ...(0, (0, parcelRequire("gHS8W")).default),
            method: 'PUT',
            body: data
        });
    const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), (0, (0, parcelRequire("gHS8W")).default)).then((res)=>{
            if (res.status === 200) return res.json();
            return res.text().then((errResp)=>{
                throw new (0, (0, parcelRequire("jJZqs")).default)(res.status, errResp);
            });
        }).then((data)=>data.value);
});
parcelRegister("gHS8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c6318209de3901$export$2e2bcd8739ae039);
    const $33c6318209de3901$var$defaultOptions = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    var $33c6318209de3901$export$2e2bcd8739ae039 = $33c6318209de3901$var$defaultOptions;
});
parcelRegister("7xTO3", function(module, exports) {
    $parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", ()=>$7371ef5d04dd1248$export$5839dd8142de842e);
    var $dJl1T;
    var $8YTna;
    var $2M1hQ;
    var $55UpE;
    const $7371ef5d04dd1248$export$5839dd8142de842e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            try {
                const response = await (0, (0, parcelRequire("55UpE")).fetchUserBoardNavigationData)(boardId);
                return response;
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
                return null;
            }
        },
        maxAge: 300000
    });
});
parcelRegister("55UpE", function(module, exports) {
    $parcel$export(module.exports, "fetchUserBoardNavigationData", ()=>$e577b36e40c022cb$export$306fb49fca60b34);
    var $eusud;
    const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
    };
});
parcelRegister("c1N9v", function(module, exports) {
    $parcel$export(module.exports, "staticPlanSidebarNavigationResource", ()=>$4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
    var $2M1hQ;
    var $ijN6s;
    const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
        if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
        return 'none';
    };
    const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
        getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
        getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
            if (planId == null || scenarioId == null) return null;
            return (0, (0, parcelRequire("ijN6s")).fetchPlanSidebarNavInfo)(planId, scenarioId);
        },
        maxAge: 300000
    });
});
parcelRegister("ijN6s", function(module, exports) {
    $parcel$export(module.exports, "fetchPlanSidebarNavInfo", ()=>$b2d0559c1bc2bb35$export$a49729698cfc5310);
    var $eusud;
    const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
    const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
        if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
        if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
        return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
    };
});
parcelRegister("2fwuR", function(module, exports) {
    $parcel$export(module.exports, "sidebarNav4Resource", ()=>$692dbcae1edae2a1$export$7648dc6f76f4f83d);
    $parcel$export(module.exports, "sidebarNav4UiStateResource", ()=>$692dbcae1edae2a1$export$a46129bd512544d7);
    var $jhS4y;
    var $3Jbkp;
    var $fMcVX;
    var $ao2h1;
    var $2OeZv;
    var $fZBia;
    const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
    const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
            return {
                parameters: (0, (0, parcelRequire("2OeZv")).default),
                variables: {
                    cloudId: cloudId,
                    isAppsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)),
                    isDashboardsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)),
                    isFiltersExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)),
                    isPlansExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)),
                    isProjectsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)),
                    isOperationsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)),
                    isOverviewsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS))
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, (0, parcelRequire("fZBia")).default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("jhS4y", function(module, exports) {
    $parcel$export(module.exports, "CONFIGURABLE_MENU_ID", ()=>$d66e3a3484b422c6$export$7838b734e4cd5e8d);
    $parcel$export(module.exports, "ENTITY_ID", ()=>$d66e3a3484b422c6$export$103ff18fe29ee1b);
    $parcel$export(module.exports, "MENU_ID_APPS", ()=>$d66e3a3484b422c6$export$441cd608ea3204f4);
    $parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", ()=>$d66e3a3484b422c6$export$5baa9c2e3c3931c5);
    $parcel$export(module.exports, "MENU_ID_ASSETS", ()=>$d66e3a3484b422c6$export$75c65bfc98b3a6e1);
    $parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", ()=>$d66e3a3484b422c6$export$8a0af92d49f1d13d);
    $parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", ()=>$d66e3a3484b422c6$export$a09300d15acc958a);
    $parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$4d718fbd418eef5c);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS", ()=>$d66e3a3484b422c6$export$dd009509c2dabb5e);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$d3da0455b4200fb2);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$b9dd2b5309d19763);
    $parcel$export(module.exports, "MENU_ID_FILTERS", ()=>$d66e3a3484b422c6$export$3d81af172a8e3c57);
    $parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", ()=>$d66e3a3484b422c6$export$1e2599eaf0039a97);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$53d274d993c9d5b5);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$7661ea763be69cfa);
    $parcel$export(module.exports, "MENU_ID_GOALS", ()=>$d66e3a3484b422c6$export$47c6ce6a83a59eab);
    $parcel$export(module.exports, "MENU_ID_OPERATIONS", ()=>$d66e3a3484b422c6$export$ef89639b7d9c162a);
    $parcel$export(module.exports, "MENU_ID_OPS_ALERTS", ()=>$d66e3a3484b422c6$export$af4ab6d4e920522a);
    $parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", ()=>$d66e3a3484b422c6$export$25c40acb2c53a294);
    $parcel$export(module.exports, "MENU_ID_OPS_REPORTS", ()=>$d66e3a3484b422c6$export$c7d8892f1628b844);
    $parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", ()=>$d66e3a3484b422c6$export$bb19a52e3df99541);
    $parcel$export(module.exports, "MENU_ID_OVERVIEWS", ()=>$d66e3a3484b422c6$export$3bd12c092f8db11b);
    $parcel$export(module.exports, "MENU_ID_PLANS", ()=>$d66e3a3484b422c6$export$f2533da33c749933);
    $parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$8468c5b6648f4f1f);
    $parcel$export(module.exports, "MENU_ID_PROJECT_APPS", ()=>$d66e3a3484b422c6$export$fed17b4c0866b97d);
    $parcel$export(module.exports, "MENU_ID_PROJECTS", ()=>$d66e3a3484b422c6$export$9c5278bd360a285);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$85389c606bb641dd);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$4a1974b63c858e9c);
    $parcel$export(module.exports, "MENU_ID_RECENT", ()=>$d66e3a3484b422c6$export$692b796030a796f3);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS", ()=>$d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$7606c0134aabf3d7);
    $parcel$export(module.exports, "MENU_ID_STARRED", ()=>$d66e3a3484b422c6$export$5637ca42a4d77f32);
    $parcel$export(module.exports, "MENU_ID_TEAMS", ()=>$d66e3a3484b422c6$export$d4f6fcf571f9c50);
    $parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", ()=>$d66e3a3484b422c6$export$11fcdf33179ef88e);
    $parcel$export(module.exports, "MENU_ID_YOUR_WORK", ()=>$d66e3a3484b422c6$export$80dc576e446bdb6b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", ()=>$d66e3a3484b422c6$export$79c15668ed799a1b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", ()=>$d66e3a3484b422c6$export$e299bb06c4370c0d);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", ()=>$d66e3a3484b422c6$export$713b9b0a69a79cf9);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", ()=>$d66e3a3484b422c6$export$f1d9c0f27216aa1c);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", ()=>$d66e3a3484b422c6$export$45763fa331781074);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", ()=>$d66e3a3484b422c6$export$6ee20c845dbab3e3);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", ()=>$d66e3a3484b422c6$export$b3815dd180ce5e61);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", ()=>$d66e3a3484b422c6$export$100a1a639a0db980);
    const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
        APPS: 'jira.sidebar.apps',
        ASSETS: 'jira.sidebar.assets',
        DASHBOARDS: 'jira.sidebar.dashboards',
        FILTERS: 'jira.sidebar.filters',
        GOALS: 'jira.sidebar.goals',
        OPERATIONS: 'jira.sidebar.operations',
        OVERVIEWS: 'jira.sidebar.overviews',
        PLANS: 'jira.sidebar.plans',
        PROJECTS: 'jira.sidebar.projects',
        RECENT: 'jira.sidebar.recent',
        STARRED: 'jira.sidebar.starred',
        TEAMS: 'jira.sidebar.teams',
        ROADMAPS: 'jira.sidebar.roadmaps',
        CUSTOMER_SERVICE: 'jira.sidebar.customerService'
    };
    const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
        ALARM_QUEUE: (id)=>`alrm_${id}`,
        APP: (id)=>`app_${id}`,
        BOARD: (id)=>`boar_${id}`,
        DASHBOARD: (id)=>`dash_${id}`,
        FILTER: (id)=>`filt_${id}`,
        FORM: (id)=>`form_${id}`,
        OVERVIEW: (id)=>`over_${id}`,
        PLAN: (id)=>`plan_${id}`,
        PROJECT: (id)=>`proj_${id}`,
        PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
        PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
        PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
        PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
        PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
        PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
        PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
        PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
        PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
        PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
        PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
        PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
        PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
        PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
        PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
        PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
        ROADMAP: (id)=>`roadmap_${id}`,
        QUEUE: (id)=>`queu_${id}`
    };
    const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
    const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
    const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
    const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
    const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
    const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
    const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
    const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
    const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
    const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
    const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
    const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
    const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
    const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
    const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
    const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
    const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
    const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
    const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
    const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
    const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
    const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
    const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
    const $d66e3a3484b422c6$export$e682260eda678e61 = 'proj-dir';
    const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
    const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
    const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
    const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
    const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
    const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
    const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
    const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
    const $d66e3a3484b422c6$export$11fcdf33179ef88e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
    const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
    const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
    const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
    const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
    const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
    const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
    const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
    const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
    const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';
});
parcelRegister("3Jbkp", function(module, exports) {
    $parcel$export(module.exports, "getInitialSelectedPath", ()=>$e52131b0b61339d3$export$39f409bc5f59c5e);
    var $bxYf9 = parcelRequire("bxYf9");
    var $7Ckoi;
    const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, ($parcel$interopDefault($bxYf9)))((0, (0, parcelRequire("7Ckoi")).routeToSelectedPath));
});
parcelRegister("7Ckoi", function(module, exports) {
    $parcel$export(module.exports, "routeToSelectedPath", ()=>$551cdf5d088747a1$export$a92474c098a1fd13);
    var $4R6GH;
    var $fBDpl;
    var $ezq2z;
    var $j3mSh;
    var $1RoZ2;
    var $hdJn1;
    var $2m3Yb;
    var $3weqe;
    var $c6hlO;
    var $3lNyZ;
    var $8bXrC;
    var $eReVn;
    function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
        const routeName = routeContext.route.name;
        if ((0, (0, parcelRequire("2m3Yb")).topLevelConverter).routes.has(routeName)) return (0, (0, parcelRequire("2m3Yb")).topLevelConverter).convert(routeContext);
        if ((0, (0, parcelRequire("fBDpl")).appsConverter).routes.has(routeName)) return (0, (0, parcelRequire("fBDpl")).appsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("ezq2z")).assetsConverter).routes.has(routeName)) return (0, (0, parcelRequire("ezq2z")).assetsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("j3mSh")).dashboardsConverter).routes.has(routeName)) return (0, (0, parcelRequire("j3mSh")).dashboardsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("1RoZ2")).filtersConverter).routes.has(routeName)) return (0, (0, parcelRequire("1RoZ2")).filtersConverter).convert(routeContext);
        if ((0, (0, parcelRequire("hdJn1")).operationsConverter).routes.has(routeName)) return (0, (0, parcelRequire("hdJn1")).operationsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("c6hlO")).plansConverter).routes.has(routeName)) return (0, (0, parcelRequire("c6hlO")).plansConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3lNyZ")).projectsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3lNyZ")).projectsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("8bXrC")).roadmapsConverter).routes.has(routeName)) return (0, (0, parcelRequire("8bXrC")).roadmapsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) {
            if ((0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).convert(routeContext);
        }
        return [];
    }
});
parcelRegister("fBDpl", function(module, exports) {
    $parcel$export(module.exports, "appsConverter", ()=>$55a8ac7f9c56fb94$export$d017a63045c88c47);
    var $65Ltd;
    var $jhS4y;
    const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT)
    ];
    const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PERSONAL_SETTINGS)
    ];
    const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
        ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
        ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
    ]);
    function $55a8ac7f9c56fb94$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_APP_MARKETPLACE_DISCOVER));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PERSONAL_SETTINGS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
                path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(match.url.replace(/\/$/, '')));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
                {
                    const { projectKey: projectKey } = match.params;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
                {
                    const { projectKey: projectKey } = query;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            default:
                break;
        }
        return path;
    }
    const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
        routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
        convert: $55a8ac7f9c56fb94$var$convert
    };
});
parcelRegister("ezq2z", function(module, exports) {
    $parcel$export(module.exports, "assetsConverter", ()=>$bdd6509d07f3cefb$export$6cfeba0849032a84);
    var $65Ltd;
    var $jhS4y;
    const $bdd6509d07f3cefb$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
    ]);
    function $bdd6509d07f3cefb$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_REPORTS));
                break;
            default:
                break;
        }
        return path;
    }
    const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
        routes: $bdd6509d07f3cefb$var$routes,
        convert: $bdd6509d07f3cefb$var$convert
    };
});
parcelRegister("j3mSh", function(module, exports) {
    $parcel$export(module.exports, "dashboardsConverter", ()=>$257dabfdf8711aa2$export$6468819b4be328b1);
    var $65Ltd;
    var $jhS4y;
    const $257dabfdf8711aa2$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)
    ]);
    function $257dabfdf8711aa2$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD:
                query.dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(query.dashboardId));
                break;
            default:
                {
                    const dashboardId = match.params.dashboardId;
                    if (dashboardId === 'last-visited') path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                    else dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(dashboardId));
                    break;
                }
        }
        return path;
    }
    const $257dabfdf8711aa2$export$6468819b4be328b1 = {
        routes: $257dabfdf8711aa2$var$routes,
        convert: $257dabfdf8711aa2$var$convert
    };
});
parcelRegister("1RoZ2", function(module, exports) {
    $parcel$export(module.exports, "filtersConverter", ()=>$c2ae3b230f933dc6$export$6e91331b5debb7c8);
    var $65Ltd;
    var $jhS4y;
    const $c2ae3b230f933dc6$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
    ]);
    function $c2ae3b230f933dc6$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query, match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    else if (match.params?.issueKey) {
                        const [projectKey] = (match.params?.issueKey || '').split('-');
                        return [
                            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                            (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey)
                        ];
                    }
                    break;
                }
            default:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId === undefined) path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_SEARCH));
                    else path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    break;
                }
        }
        return path;
    }
    const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
        routes: $c2ae3b230f933dc6$var$routes,
        convert: $c2ae3b230f933dc6$var$convert
    };
});
parcelRegister("hdJn1", function(module, exports) {
    $parcel$export(module.exports, "operationsConverter", ()=>$9b181cf5d70a46b3$export$7fc92455d5020e1);
    var $65Ltd;
    var $jhS4y;
    const $9b181cf5d70a46b3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ESCALATIONS)
    ]);
    function $9b181cf5d70a46b3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ON_CALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
                {
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS));
                    const { query: alarmQueue = '', view: view } = query;
                    view && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(alarmQueue));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_REPORTS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_OVERVIEW));
                break;
            default:
                break;
        }
        return path;
    }
    const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
        routes: $9b181cf5d70a46b3$var$routes,
        convert: $9b181cf5d70a46b3$var$convert
    };
});
parcelRegister("2m3Yb", function(module, exports) {
    $parcel$export(module.exports, "topLevelConverter", ()=>$c60c27b55fbcd9c5$export$a33f2d74a674bf8a);
    var $65Ltd;
    var $jhS4y;
    const $c60c27b55fbcd9c5$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX)
    ]);
    function $c60c27b55fbcd9c5$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_YOUR_WORK));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS));
                break;
            default:
        }
        return path;
    }
    const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
        routes: $c60c27b55fbcd9c5$var$routes,
        convert: $c60c27b55fbcd9c5$var$convert
    };
});
parcelRegister("3weqe", function(module, exports) {
    $parcel$export(module.exports, "overviewsConverter", ()=>$b8a10fc0a37e731b$export$5469f6c6536ca9c5);
    var $65Ltd;
    var $jhS4y;
    const $b8a10fc0a37e731b$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
    ]);
    function $b8a10fc0a37e731b$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)
        ];
        routeName;
        {
            const { overviewId: overviewId } = match.params;
            overviewId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).OVERVIEW(overviewId));
        }
        return path;
    }
    const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
        routes: $b8a10fc0a37e731b$var$routes,
        convert: $b8a10fc0a37e731b$var$convert
    };
});
parcelRegister("c6hlO", function(module, exports) {
    $parcel$export(module.exports, "plansConverter", ()=>$a783e1b6f52291a3$export$3bde637b58016d1);
    var $65Ltd;
    var $jhS4y;
    const $a783e1b6f52291a3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
    ]);
    function $a783e1b6f52291a3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
                break;
            default:
                {
                    const { planId: planId } = match.params;
                    planId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PLAN(planId));
                }
        }
        return path;
    }
    const $a783e1b6f52291a3$export$3bde637b58016d1 = {
        routes: $a783e1b6f52291a3$var$routes,
        convert: $a783e1b6f52291a3$var$convert
    };
});
parcelRegister("3lNyZ", function(module, exports) {
    $parcel$export(module.exports, "projectsConverter", ()=>$6eaade1a69d23d1d$export$c41b724886e5872b);
    var $65Ltd;
    var $jhS4y;
    const $6eaade1a69d23d1d$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
    ]);
    function $6eaade1a69d23d1d$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING:
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
                {
                    const { projectKey: projectKey, appId: appId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECT_APPS));
                    appId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(appId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SUMMARY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS:
                {
                    const { projectKey: projectKey, boardId: boardId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_REPORTS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                {
                    const { projectKey: projectKey } = match.params;
                    const filterId = query.filter || query.filterId;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    if (projectKey && filterId) {
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_FILTERS(projectKey));
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                    }
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
                {
                    const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && practiceType && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
                {
                    const { projectKey: projectKey, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_QUEUES(projectKey));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SERVICES(projectKey));
                    break;
                }
            default:
                {
                    const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    formId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FORM(formId));
                }
        }
        return path;
    }
    const $6eaade1a69d23d1d$export$c41b724886e5872b = {
        routes: $6eaade1a69d23d1d$var$routes,
        convert: $6eaade1a69d23d1d$var$convert
    };
});
parcelRegister("8bXrC", function(module, exports) {
    $parcel$export(module.exports, "roadmapsConverter", ()=>$8c39d6aa787bb969$export$5761942b1e0c2dd0);
    var $65Ltd;
    var $jhS4y;
    const $8c39d6aa787bb969$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS)
    ]);
    function $8c39d6aa787bb969$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS:
                {
                    const collectionId = match.params.collectionUUID;
                    if (collectionId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ROADMAP(collectionId));
                    else path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS_VIEW_ALL));
                    break;
                }
            default:
        }
        return path;
    }
    const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
        routes: $8c39d6aa787bb969$var$routes,
        convert: $8c39d6aa787bb969$var$convert
    };
});
parcelRegister("eReVn", function(module, exports) {
    $parcel$export(module.exports, "serviceManagementProjectSettingsConverter", ()=>$59806d8088c642c3$export$dd307ede503fe0e);
    var $65Ltd;
    var $7HDop;
    var $9ujoJ;
    var $buwAo;
    var $knvrl;
    var $1upsT;
    var $cARMJ;
    var $hXPqO;
    var $hj1rS;
    var $6QV1R;
    var $c7Cuy;
    var $fCKoM;
    var $k3pgS;
    var $5AlVM;
    var $e9ygf;
    var $bHuHZ;
    var $hllBd;
    var $kEqE6;
    var $6MVjO;
    var $5lhuE;
    var $6pNsO;
    var $iMriO;
    var $f8kSl;
    var $6oHQj;
    var $dDinN;
    var $htcbK;
    var $gIHTV;
    var $jol6L;
    var $9sAYT;
    var $jJkuR;
    var $kuaoc;
    var $ieCBx;
    var $6t7hJ;
    var $f4T09;
    var $jpwsu;
    var $hewRX;
    var $k3the;
    var $jZoZG;
    var $j1kdz;
    var $jhS4y;
    const $59806d8088c642c3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        (0, (0, parcelRequire("knvrl")).routeGroupsProjectSettingsLegacyAutomationRoute).name,
        (0, (0, parcelRequire("1upsT")).routeGroupsProjectSettingsServicedeskAccessRoute).name,
        (0, (0, parcelRequire("6QV1R")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
        (0, (0, parcelRequire("e9ygf")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
        (0, (0, parcelRequire("kEqE6")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
        (0, (0, parcelRequire("6MVjO")).routeGroupsProjectSettingsServicedeskFieldsRoute).name,
        (0, (0, parcelRequire("dDinN")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
        (0, (0, parcelRequire("htcbK")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name,
        (0, (0, parcelRequire("k3pgS")).routeGroupsProjectSettingsServicedeskChatRoute).name,
        (0, (0, parcelRequire("bHuHZ")).routeGroupsProjectSettingsServicedeskEmailRoute).name,
        (0, (0, parcelRequire("hllBd")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
        (0, (0, parcelRequire("6oHQj")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
        (0, (0, parcelRequire("gIHTV")).routeGroupsProjectSettingsServicedeskWidgetRoute).name,
        (0, (0, parcelRequire("hXPqO")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
        (0, (0, parcelRequire("5lhuE")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
        (0, (0, parcelRequire("5AlVM")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
        (0, (0, parcelRequire("jol6L")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("hj1rS")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
        (0, (0, parcelRequire("fCKoM")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
        (0, (0, parcelRequire("9sAYT")).virtualAgentConversationsRoute).name,
        (0, (0, parcelRequire("jJkuR")).virtualAgentIntentsRoute).name,
        (0, (0, parcelRequire("kuaoc")).virtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("ieCBx")).virtualAgentStandardFlowsRoute).name,
        (0, (0, parcelRequire("9ujoJ")).projectSettingsServicedeskNotificationsEmailRoute).name,
        (0, (0, parcelRequire("buwAo")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
        (0, (0, parcelRequire("f8kSl")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
        (0, (0, parcelRequire("cARMJ")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
        (0, (0, parcelRequire("6t7hJ")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("f4T09")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("jpwsu")).routeGroupsProjectSettingsServicedeskKbRoute).name,
        (0, (0, parcelRequire("k3the")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("jZoZG")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("j1kdz")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
        (0, (0, parcelRequire("iMriO")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
        (0, (0, parcelRequire("c7Cuy")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
        (0, (0, parcelRequire("7HDop")).projectSettingsServicedeskAutomationRoute).name,
        (0, (0, parcelRequire("hewRX")).servicedeskSlaSettingsRoute).name,
        (0, (0, parcelRequire("6pNsO")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
    ]);
    function $59806d8088c642c3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
            case (0, (0, parcelRequire("1upsT")).routeGroupsProjectSettingsServicedeskAccessRoute).name:
            case (0, (0, parcelRequire("e9ygf")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
            case (0, (0, parcelRequire("6QV1R")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_ACCESS));
                break;
            case (0, (0, parcelRequire("htcbK")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name:
            case (0, (0, parcelRequire("jZoZG")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
                break;
            case (0, (0, parcelRequire("k3the")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
            case (0, (0, parcelRequire("dDinN")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
            case (0, (0, parcelRequire("j1kdz")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
            case (0, (0, parcelRequire("hewRX")).servicedeskSlaSettingsRoute).name:
            case (0, (0, parcelRequire("kEqE6")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
            case (0, (0, parcelRequire("iMriO")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
            case (0, (0, parcelRequire("6MVjO")).routeGroupsProjectSettingsServicedeskFieldsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
            case (0, (0, parcelRequire("knvrl")).routeGroupsProjectSettingsLegacyAutomationRoute).name:
            case (0, (0, parcelRequire("7HDop")).projectSettingsServicedeskAutomationRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_AUTOMATION));
                break;
            case (0, (0, parcelRequire("6oHQj")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
            case (0, (0, parcelRequire("c7Cuy")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
            case (0, (0, parcelRequire("bHuHZ")).routeGroupsProjectSettingsServicedeskEmailRoute).name:
            case (0, (0, parcelRequire("k3pgS")).routeGroupsProjectSettingsServicedeskChatRoute).name:
            case (0, (0, parcelRequire("gIHTV")).routeGroupsProjectSettingsServicedeskWidgetRoute).name:
            case (0, (0, parcelRequire("jpwsu")).routeGroupsProjectSettingsServicedeskKbRoute).name:
            case (0, (0, parcelRequire("hllBd")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
            case (0, (0, parcelRequire("hj1rS")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
            case (0, (0, parcelRequire("fCKoM")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
            case (0, (0, parcelRequire("jol6L")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
            case (0, (0, parcelRequire("jJkuR")).virtualAgentIntentsRoute).name:
            case (0, (0, parcelRequire("ieCBx")).virtualAgentStandardFlowsRoute).name:
            case (0, (0, parcelRequire("9sAYT")).virtualAgentConversationsRoute).name:
            case (0, (0, parcelRequire("kuaoc")).virtualAgentSettingsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
                break;
            case (0, (0, parcelRequire("hXPqO")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
            case (0, (0, parcelRequire("5lhuE")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_OPERATIONS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
            case (0, (0, parcelRequire("6t7hJ")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("f8kSl")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
            case (0, (0, parcelRequire("f4T09")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("9ujoJ")).projectSettingsServicedeskNotificationsEmailRoute).name:
            case (0, (0, parcelRequire("buwAo")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
            case (0, (0, parcelRequire("6pNsO")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_NOTIFICATIONS));
                break;
            case (0, (0, parcelRequire("5AlVM")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
            case (0, (0, parcelRequire("cARMJ")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_APPS));
                break;
            default:
                break;
        }
        return path;
    }
    const $59806d8088c642c3$export$dd307ede503fe0e = {
        routes: $59806d8088c642c3$var$routes,
        convert: $59806d8088c642c3$var$convert
    };
});
parcelRegister("7HDop", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", ()=>$a850596cfe5a4de7$export$1a2228d5e07202a0);
    var $65Ltd;
    var $fFv0O;
    const $a850596cfe5a4de7$export$1a2228d5e07202a0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/automate`
    };
});
parcelRegister("fFv0O", function(module, exports) {
    $parcel$export(module.exports, "getJsmProjectSettingsUrl", ()=>$b31415be17178b2c$export$b7cec47cdf9c76f1);
    $parcel$export(module.exports, "jsmProjectSettingsUrl", ()=>$b31415be17178b2c$export$c629540cad20d48);
    const $b31415be17178b2c$export$5575497f0592ee94 = 'servicedesk';
    const $b31415be17178b2c$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$b31415be17178b2c$export$5575497f0592ee94}/projects/${projectKey || ':projectKey'}/settings`;
    const $b31415be17178b2c$export$c629540cad20d48 = $b31415be17178b2c$export$b7cec47cdf9c76f1();
});
parcelRegister("9ujoJ", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", ()=>$0bae5d3040b6efcd$export$1f37a1aff4f594af);
    var $65Ltd;
    var $fFv0O;
    const $0bae5d3040b6efcd$export$1f37a1aff4f594af = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notification-email`,
        exact: true
    };
});
parcelRegister("buwAo", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", ()=>$a41537dc6d61dc3d$export$40539cb16771014e);
    var $65Ltd;
    var $fFv0O;
    const $a41537dc6d61dc3d$export$40539cb16771014e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notifications/notification-email`,
        exact: true
    };
});
parcelRegister("knvrl", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", ()=>$2e8d72e888be5e69$export$abc6508b4dce2d9b);
    var $65Ltd;
    var $fFv0O;
    const $2e8d72e888be5e69$export$abc6508b4dce2d9b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/automation`,
        exact: true
    };
});
parcelRegister("1upsT", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", ()=>$d1b7cbe53df6cfdd$export$f7e149bf217bbb2c);
    var $65Ltd;
    var $fFv0O;
    const $d1b7cbe53df6cfdd$export$f7e149bf217bbb2c = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/access`,
        exact: true
    };
});
parcelRegister("cARMJ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", ()=>$bd3d99d74534c3dc$export$e382068c2b8a7b9f);
    var $65Ltd;
    var $fFv0O;
    const $bd3d99d74534c3dc$export$e382068c2b8a7b9f = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/apps/app-fields`,
        exact: true
    };
});
parcelRegister("hXPqO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", ()=>$4f076959804fd438$export$10089d339d8e30d1);
    var $65Ltd;
    var $fFv0O;
    const $4f076959804fd438$export$10089d339d8e30d1 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/change-management`,
        exact: true
    };
});
parcelRegister("hj1rS", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", ()=>$4341c271b95d7fc4$export$8e2543080acfc7c2);
    var $65Ltd;
    var $fFv0O;
    const $4341c271b95d7fc4$export$8e2543080acfc7c2 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/chat`,
        exact: true
    };
});
parcelRegister("6QV1R", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", ()=>$a451b0b54b384e55$export$e184fa302b6981b6);
    var $65Ltd;
    var $fFv0O;
    const $a451b0b54b384e55$export$e184fa302b6981b6 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/customer-permissions`,
        exact: true
    };
});
parcelRegister("c7Cuy", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", ()=>$a85341672714267c$export$394d5ca6ce9e5949);
    var $65Ltd;
    var $fFv0O;
    const $a85341672714267c$export$394d5ca6ce9e5949 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/portal-settings`,
        exact: true
    };
});
parcelRegister("fCKoM", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", ()=>$f0656f46d1b254a7$export$fe54e02c94ff5613);
    var $65Ltd;
    var $fFv0O;
    const $f0656f46d1b254a7$export$fe54e02c94ff5613 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/channels/widget`,
        exact: true
    };
});
parcelRegister("k3pgS", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", ()=>$50fc73683d1ea5cf$export$3a3e70b8651d8d57);
    var $65Ltd;
    var $fFv0O;
    const $50fc73683d1ea5cf$export$3a3e70b8651d8d57 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/chat`,
        exact: true
    };
});
parcelRegister("5AlVM", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", ()=>$bc33d5c523e4a706$export$3ab501c22b91462b);
    var $65Ltd;
    var $fFv0O;
    const $bc33d5c523e4a706$export$3ab501c22b91462b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/apps`,
        exact: true
    };
});
parcelRegister("e9ygf", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", ()=>$cbb732a2fe1a233f$export$dd22cfc45fe86c35);
    var $65Ltd;
    var $fFv0O;
    const $cbb732a2fe1a233f$export$dd22cfc45fe86c35 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/customer-permissions`,
        exact: true
    };
});
parcelRegister("bHuHZ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", ()=>$370b0a2ea8de3100$export$d29fa1140db9296d);
    var $65Ltd;
    var $fFv0O;
    const $370b0a2ea8de3100$export$d29fa1140db9296d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/email`,
        exact: true
    };
});
parcelRegister("hllBd", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", ()=>$89b8c48cda692359$export$d0198d2da30de212);
    var $65Ltd;
    var $fFv0O;
    const $89b8c48cda692359$export$d0198d2da30de212 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/external-links`,
        exact: true
    };
});
parcelRegister("kEqE6", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", ()=>$637247174e022f86$export$cd46cad965f517e2);
    var $65Ltd;
    var $fFv0O;
    const $637247174e022f86$export$cd46cad965f517e2 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/feedback-settings`
    };
});
parcelRegister("6MVjO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", ()=>$9a67d1911e679919$export$87914ccacd42ab35);
    var $65Ltd;
    var $fFv0O;
    const $9a67d1911e679919$export$87914ccacd42ab35 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/fields`,
        exact: true
    };
});
parcelRegister("5lhuE", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", ()=>$0126764fb1c62a7a$export$ff20eaee6cf19401);
    var $65Ltd;
    var $fFv0O;
    const $0126764fb1c62a7a$export$ff20eaee6cf19401 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/incident-management`,
        exact: true
    };
});
parcelRegister("6pNsO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", ()=>$1f8f0e8b1243d49b$export$4ef3eecacde57780);
    var $65Ltd;
    var $fFv0O;
    const $1f8f0e8b1243d49b$export$4ef3eecacde57780 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/internal-notifications`
    };
});
parcelRegister("iMriO", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", ()=>$4f8fe6be3c4832c3$export$666cdeccf1f430a6);
    var $65Ltd;
    var $fFv0O;
    const $4f8fe6be3c4832c3$export$666cdeccf1f430a6 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/issuetypes/:issueTypeId?`,
        exact: true
    };
});
parcelRegister("f8kSl", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", ()=>$e9c423a6409f74f5$export$e6f711e47860f891);
    var $65Ltd;
    var $fFv0O;
    const $e9c423a6409f74f5$export$e6f711e47860f891 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/notifications/internal-notifications`
    };
});
parcelRegister("6oHQj", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", ()=>$ba2f5c799cade0df$export$e856498dc02e46e8);
    var $65Ltd;
    var $fFv0O;
    const $ba2f5c799cade0df$export$e856498dc02e46e8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/portal-settings/:subPath(portal-groups)?`,
        exact: true
    };
});
parcelRegister("dDinN", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", ()=>$8d02cc755c143227$export$f919d82b98f9257a);
    var $65Ltd;
    var $fFv0O;
    const $8d02cc755c143227$export$f919d82b98f9257a = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/forms`,
        exact: true
    };
});
parcelRegister("htcbK", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory", ()=>$5b3ec787db522b65$export$60b14f135c03f9c7);
    var $65Ltd;
    var $fFv0O;
    const $5b3ec787db522b65$export$60b14f135c03f9c7 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/request-types/category/:practice`,
        exact: true
    };
});
parcelRegister("gIHTV", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", ()=>$dcd5265395e9ce2e$export$164572fb58075291);
    var $65Ltd;
    var $fFv0O;
    const $dcd5265395e9ce2e$export$164572fb58075291 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/widget`,
        exact: true
    };
});
parcelRegister("jol6L", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", ()=>$0b7f80951fa212fe$export$680ccfe6e5af63a8);
    var $65Ltd;
    var $fFv0O;
    const $0b7f80951fa212fe$export$680ccfe6e5af63a8 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent`,
        exact: true
    };
});
parcelRegister("9sAYT", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentConversationsRoute", ()=>$411142b46ae04f14$export$837f003bb6f40f9);
    var $65Ltd;
    var $fFv0O;
    const $411142b46ae04f14$export$837f003bb6f40f9 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/conversations`,
        exact: true
    };
});
parcelRegister("jJkuR", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentIntentsRoute", ()=>$0338de7d8107d11d$export$1e70273fc2a407f5);
    var $65Ltd;
    var $fFv0O;
    const $0338de7d8107d11d$export$1e70273fc2a407f5 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/intents`,
        exact: true
    };
});
parcelRegister("kuaoc", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentSettingsRoute", ()=>$bc551cda135ca5dc$export$80422a49e17dfd6b);
    var $65Ltd;
    var $fFv0O;
    const $bc551cda135ca5dc$export$80422a49e17dfd6b = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/settings`,
        exact: true
    };
});
parcelRegister("ieCBx", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentStandardFlowsRoute", ()=>$b2e651b968a46995$export$f45c942ecfcc5682);
    var $65Ltd;
    var $fFv0O;
    const $b2e651b968a46995$export$f45c942ecfcc5682 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
        path: `${(0, (0, parcelRequire("fFv0O")).jsmProjectSettingsUrl)}/virtual-agent/standard-flows`,
        exact: true
    };
});
parcelRegister("6t7hJ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", ()=>$b044870715f195c9$export$7fc567ce6cdc6b52);
    var $65Ltd;
    var $7h0Ka;
    const $b044870715f195c9$export$7fc567ce6cdc6b52 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
        path: `${(0, (0, parcelRequire("7h0Ka")).projectSettingsUrl)((0, (0, parcelRequire("7h0Ka")).SERVICE_DESK_PRODUCT))}/customer-notifications`
    };
});
parcelRegister("7h0Ka", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$31520c4854f633ad$export$5575497f0592ee94);
    $parcel$export(module.exports, "projectSettingsUrl", ()=>$31520c4854f633ad$export$5132c64eefe46250);
    const $31520c4854f633ad$export$5575497f0592ee94 = 'servicedesk';
    const $31520c4854f633ad$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
});
parcelRegister("f4T09", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", ()=>$088e43233c871db8$export$688d2c8abd7b3661);
    var $65Ltd;
    var $7h0Ka;
    const $088e43233c871db8$export$688d2c8abd7b3661 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
        path: `${(0, (0, parcelRequire("7h0Ka")).projectSettingsUrl)((0, (0, parcelRequire("7h0Ka")).SERVICE_DESK_PRODUCT))}/notifications/customer-notifications`
    };
});
parcelRegister("jpwsu", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", ()=>$c6a2b8c452ec83e7$export$8855316927afaed1);
    var $65Ltd;
    var $kJto6;
    const $c6a2b8c452ec83e7$export$8855316927afaed1 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
        path: `${(0, (0, parcelRequire("kJto6")).projectSettingsUrl)((0, (0, parcelRequire("kJto6")).SERVICE_DESK_PRODUCT))}/confluence-kb`,
        exact: true
    };
});
parcelRegister("kJto6", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$dc6b55290d887514$export$5575497f0592ee94);
    $parcel$export(module.exports, "projectSettingsUrl", ()=>$dc6b55290d887514$export$5132c64eefe46250);
    const $dc6b55290d887514$export$5575497f0592ee94 = 'servicedesk';
    const $dc6b55290d887514$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
});
parcelRegister("hewRX", function(module, exports) {
    $parcel$export(module.exports, "servicedeskSlaSettingsRoute", ()=>$e50829694a27cbc2$export$bfbf66468910573e);
    var $65Ltd;
    const $e50829694a27cbc2$export$bfbf66468910573e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
    };
});
parcelRegister("k3the", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", ()=>$92bd89e52eb8855f$export$1eebd582a7db1c90);
    var $65Ltd;
    const $92bd89e52eb8855f$export$1eebd582a7db1c90 = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
        path: `/jira/${(0, $c537a1906485aaa6$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types`
    };
});
const $c537a1906485aaa6$export$5575497f0592ee94 = 'servicedesk';
parcelRegister("jZoZG", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", ()=>$5ac461fd134ed29c$export$cd0f363eecbc2379);
    var $65Ltd;
    const $5ac461fd134ed29c$export$cd0f363eecbc2379 = {
        exact: true,
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
        path: `/jira/${(0, $c537a1906485aaa6$export$5575497f0592ee94)}/projects/:projectKey/settings/request-types/unassigned`
    };
});
parcelRegister("j1kdz", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", ()=>$ab54ce032aaceb6d$export$ad30542ae2fd7196);
    var $65Ltd;
    const $ab54ce032aaceb6d$export$ad30542ae2fd7196 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
        path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
        exact: true
    };
});
parcelRegister("fMcVX", function(module, exports) {
    $parcel$export(module.exports, "isSelectedPath", ()=>$ad785f9726254880$export$cdcd6885320eec31);
    var $lhMtU;
    function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
        const next = (menuId)=>{
            return (0, (0, parcelRequire("lhMtU")).isMenuIdList)(menuId) ? (0, (0, parcelRequire("lhMtU")).toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
        };
        if (args.length === 0) return next;
        return next(args[0]);
    }
});
parcelRegister("lhMtU", function(module, exports) {
    $parcel$export(module.exports, "toMenuIdFromMenuIdList", ()=>$dc9d941dfadd4b5a$export$253323efd0c41e72);
    $parcel$export(module.exports, "isMenuIdList", ()=>$dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
    $parcel$export(module.exports, "toMenuIdList", ()=>$dc9d941dfadd4b5a$export$d8e017f58178e379);
    const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   ';
    function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
        return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
    function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
        return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
    }
    function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
        return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
});
parcelRegister("2OeZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70949048397986dd$export$2e2bcd8739ae039);
    const $70949048397986dd$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isAppsExpanded"
        }, v2 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDashboardsExpanded"
        }, v3 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isFiltersExpanded"
        }, v4 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOperationsExpanded"
        }, v5 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOverviewsExpanded"
        }, v6 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPlansExpanded"
        }, v7 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isProjectsExpanded"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v12 = {
            "kind": "ScalarField",
            "name": "label"
        }, v13 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v14 = {
            "kind": "ScalarField",
            "name": "url"
        }, v15 = {
            "order": "DESC"
        }, v16 = {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v20 = {
            "kind": "InlineFragment",
            "selections": [
                v8
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v21 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v22 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v23 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v24 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            v18,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            v19,
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v20
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v8
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v23,
                            {
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v20
                ]
            }
        ], v25 = {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }, v26 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v27 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v11,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v8
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v29 = {
            "kind": "ScalarField",
            "name": "title"
        }, v30 = {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                v19,
                v8
            ]
        }, v31 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            v29,
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            v30,
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v8
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    v20
                ]
            }
        ], v32 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            v29,
                            v30
                        ],
                        "type": "JiraDashboard"
                    },
                    v20
                ]
            }
        ], v33 = [
            v8,
            v18,
            {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ConfigurableMenuItems"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v6,
                    v7,
                    v4,
                    v5
                ],
                "kind": "Operation",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudID",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "navKey",
                                        "value": "NAV_SIDEBAR"
                                    }
                                ],
                                "concreteType": "JiraUserNavigationConfiguration",
                                "kind": "LinkedField",
                                "name": "userNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigurableNavigationItem",
                                        "kind": "LinkedField",
                                        "name": "navItems",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "menuId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isVisible"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v9,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "condition": "isAppsExpanded",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "globalAppNavigationItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v12,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "envLabel"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v13,
                                                                    {
                                                                        "concreteType": "JiraAppSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "sections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v12,
                                                                                    v14,
                                                                                    v13
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "settingsUrl"
                                                                    },
                                                                    v14
                                                                ],
                                                                "type": "JiraAppNavigationItem"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v10,
                                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                "kind": "LinkedField",
                                "name": "jwmOverviews",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v10,
                                "concreteType": "JiraAdvancedRoadmapsNavigation",
                                "kind": "LinkedField",
                                "name": "advancedRoadmapsNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasEditPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasCreateSamplePlanPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasGlobalPlansAdminPermissions"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "includeArchivedProjects": false,
                                                    "sort": v15,
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentProjects",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "includeArchivedProjects": false
                                                }
                                            },
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PROJECT"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementLicensing",
                                        "kind": "LinkedField",
                                        "name": "jwmLicensing",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentUserSeatEdition"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "GrowthRecQuery",
                                "kind": "LinkedField",
                                "name": "growthRecommendations",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "fields": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "product",
                                                        "value": "jira"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "tenantId",
                                                        "variableName": "cloudId"
                                                    },
                                                    {
                                                        "kind": "Literal",
                                                        "name": "useCase",
                                                        "value": "jiraProjectMenuRecommendations"
                                                    }
                                                ],
                                                "kind": "ObjectValue",
                                                "name": "context"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 2
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "recommendations",
                                        "plural": false,
                                        "selections": [
                                            v11,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": true,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "entityId"
                                                                    }
                                                                ],
                                                                "type": "GrowthRecJiraTemplateRecommendation"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "GrowthRecRecommendations"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isFiltersExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteFilters",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "FILTER"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    v18,
                                                                    v8,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentFilters",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "FILTER"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v18,
                                                                            v8,
                                                                            v19,
                                                                            v27,
                                                                            v28
                                                                        ],
                                                                        "type": "JiraFilter",
                                                                        "abstractKey": "__isJiraFilter"
                                                                    }
                                                                ],
                                                                "type": "JiraCustomFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraSystemFilterConnection",
                                        "kind": "LinkedField",
                                        "name": "systemFilters",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilterEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraSystemFilter",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v26,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v18,
                                                                    v11,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isPlansExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouritePlans",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "PLAN"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentPlans",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PLAN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isDashboardsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "dashboardFavourites",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "DASHBOARD"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "dashboardRecents",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "DASHBOARD"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOperationsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "OpsgenieQuery",
                                "kind": "LinkedField",
                                "name": "opsgenie",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "OpsgenieSavedSearches",
                                        "kind": "LinkedField",
                                        "name": "savedSearches",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "sharedWithMe",
                                                "plural": true,
                                                "selections": v33
                                            },
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "createdByMe",
                                                "plural": true,
                                                "selections": v33
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOverviewsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmOverviews",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraWorkManagementGiraOverview",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "faa97c300a02a1c211a1d8fb98b94ee77ff42830e6a0ae5e214e0115a18e635a",
                "metadata": {},
                "name": "L1MenuItemsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $70949048397986dd$var$node.hash = "3924b1f11b61ac6cf33dddcea40b965b";
    var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;
});
parcelRegister("fZBia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c8513a288fea00$export$2e2bcd8739ae039);
    const $79c8513a288fea00$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "leftSidebarWidth"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.leftSidebarWidth"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
                "metadata": {},
                "name": "sidebarSelectorQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $79c8513a288fea00$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
    var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;
});
parcelRegister("fwzEJ", function(module, exports) {
    $parcel$export(module.exports, "topNav4UIStateResource", ()=>$92bcd9e21d74460f$export$2d81c2e40eea9fba);
    var $ao2h1;
    var $9ZLcT;
    const $92bcd9e21d74460f$export$2d81c2e40eea9fba = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, (0, parcelRequire("9ZLcT")).default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("9ZLcT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b5c5aa00eda199b$export$2e2bcd8739ae039);
    const $3b5c5aa00eda199b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "AtlaskitAtlassianNavigationNav4UIQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Profile"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "AtlaskitAtlassianNavigationNav4UIQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "AuthenticationContext",
                        "kind": "LinkedField",
                        "name": "me",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    },
                                    v3
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a2ee613e496049f542ad423691c1955453d0e307763b1d389f0f5008b024eb83",
                "metadata": {},
                "name": "AtlaskitAtlassianNavigationNav4UIQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $3b5c5aa00eda199b$var$node.hash = "53566dec28c1571bc52a10d224ea82eb";
    var $3b5c5aa00eda199b$export$2e2bcd8739ae039 = $3b5c5aa00eda199b$var$node;
});
parcelRegister("h9iZl", function(module, exports) {
    $parcel$export(module.exports, "navigationPlansVisibilityResource", ()=>$66eb980ebca35ddf$export$fa475a9581133779);
    $parcel$export(module.exports, "useNavigationPlansVisibility", ()=>$66eb980ebca35ddf$export$4524245d4e74edb2);
    $parcel$export(module.exports, "useNavigationViewPlansPermission", ()=>$66eb980ebca35ddf$export$98eef08fd4586a4);
    $parcel$export(module.exports, "useNavigationEditPlansPermission", ()=>$66eb980ebca35ddf$export$525db876ed776e0d);
    $parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", ()=>$66eb980ebca35ddf$export$54805a2120a31ad0);
    var $dJl1T;
    var $7f4tk;
    var $2M1hQ;
    var $2YP9W;
    const $66eb980ebca35ddf$export$fa475a9581133779 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return false;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
                return response;
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
            }
            return false;
        },
        maxAge: Infinity
    });
    const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isVisible = false;
        if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
        return [
            isVisible
        ];
    };
    const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let hasEditOrViewPermissions = false;
        if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
        return [
            hasEditOrViewPermissions
        ];
    };
    const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let canEditPlans = false;
        if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
        return canEditPlans;
    };
    const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isAdvancedRoadmapsTrial = false;
        if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
        return isAdvancedRoadmapsTrial;
    };
});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';
parcelRegister("2eyDn", function(module, exports) {
    $parcel$export(module.exports, "consentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$785c22104b6f2285);
    $parcel$export(module.exports, "useConsentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$5bc7e83e85567fb4);
    var $aNX8l;
    var $3TzYp;
    var $4R6GH;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
        getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
        getData: async ()=>{
            const consentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("aNX8l")).ATLASSIAN_CONSENT_COOKIE_KEY));
            const fallbackConsentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("aNX8l")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-browser-storage-bump-3')) {
                if (consentToken) return {
                    consentToken: consentToken,
                    fallbackConsentToken: fallbackConsentToken
                };
            } else {
                const currentLocale = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("aNX8l")).ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
                if (consentToken && currentLocale) return {
                    consentToken: consentToken,
                    currentLocale: currentLocale,
                    fallbackConsentToken: fallbackConsentToken
                };
            }
            const data = await (0, (0, parcelRequire("eusud")).performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
            return data;
        },
        maxAge: 900000,
        isBrowserOnly: true
    });
    const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($7912ae5bd04d670f$export$785c22104b6f2285);
});
parcelRegister("aNX8l", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$10d7db8e1a856fd8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$435de28e5b000487);
    $parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$4b17acc0e875ba2a);
    $parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$f57af01b64fc97b8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$23a1e02c3c0b0d08);
    $parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$37073d560ecebada);
    $parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", ()=>$52e1a85ccaaaa95c$export$5dc0026db06844f3);
    $parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", ()=>$52e1a85ccaaaa95c$export$b28b5d760fe14a21);
    $parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", ()=>$52e1a85ccaaaa95c$export$4a12f9e99971760a);
    $parcel$export(module.exports, "DEFAULT_PREFERENCES", ()=>$52e1a85ccaaaa95c$export$f0fd1d13ec1d48f2);
    $parcel$export(module.exports, "V001_SCHEMA_KEY", ()=>$52e1a85ccaaaa95c$export$f95182b7aa141c57);
    $parcel$export(module.exports, "V002_SCHEMA_KEY", ()=>$52e1a85ccaaaa95c$export$1f25427b34f9c405);
    $parcel$export(module.exports, "V003_SCHEMA_KEY", ()=>$52e1a85ccaaaa95c$export$31deaeaebce525bb);
    var $5mg3z;
    const $52e1a85ccaaaa95c$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
    const $52e1a85ccaaaa95c$export$435de28e5b000487 = 'atl-bsc-consent-token';
    const $52e1a85ccaaaa95c$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
    const $52e1a85ccaaaa95c$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
    const $52e1a85ccaaaa95c$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
    const $52e1a85ccaaaa95c$export$37073d560ecebada = 'atl-testing-consents';
    const $52e1a85ccaaaa95c$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
    const $52e1a85ccaaaa95c$export$b28b5d760fe14a21 = {
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]: true,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]: true,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]: true,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]: true
    };
    const $52e1a85ccaaaa95c$export$4a12f9e99971760a = {
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]: false,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]: false,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]: false,
        [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]: false
    };
    const $52e1a85ccaaaa95c$export$f0fd1d13ec1d48f2 = {
        ...$52e1a85ccaaaa95c$export$4a12f9e99971760a,
        [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentsAreDefault]: true,
        [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).UserIsAuthenticated]: false,
        [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable]: true
    };
    const $52e1a85ccaaaa95c$export$f95182b7aa141c57 = '001';
    const $52e1a85ccaaaa95c$export$1f25427b34f9c405 = '002';
    const $52e1a85ccaaaa95c$export$31deaeaebce525bb = '003';
});
const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';
parcelRegister("drGWM", function(module, exports) {
    $parcel$export(module.exports, "checkApiKeyManagementKeysResource", ()=>$ea67ffb8a72e0299$export$b16eaa5246afc9b6);
    var $6GHRr;
    var $3H5ry;
    var $2M1hQ;
    const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
        if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
    };
    const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
            getKey: ()=>'check-api-key-management-keys',
            getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
                const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
                const isTransitioning = (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfo);
                return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
            },
            maxAge: Infinity,
            isBrowserOnly: true,
            depends: [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]
        });
});
parcelRegister("3H5ry", function(module, exports) {
    $parcel$export(module.exports, "checkShouldUseJSM", ()=>$bc03080c674ccba2$export$5e0f3a0d8463fa21);
    $parcel$export(module.exports, "checkIsTransitioning", ()=>$bc03080c674ccba2$export$d2f281fd4bf10855);
    $parcel$export(module.exports, "checkIsConsolidated", ()=>$bc03080c674ccba2$export$57f75aebff17dd1e);
    $parcel$export(module.exports, "checkIsTransitioned", ()=>$bc03080c674ccba2$export$b6461b23ee0e1471);
    $parcel$export(module.exports, "checkIsTransitionEligible", ()=>$bc03080c674ccba2$export$24040115cac5fdc3);
    $parcel$export(module.exports, "checkShouldAccessUnlockOperations", ()=>$bc03080c674ccba2$export$cd227238525e8d57);
    $parcel$export(module.exports, "checkIsOpsAdmin", ()=>$bc03080c674ccba2$export$66a96ac2f07f6730);
    var $bgC2H;
    const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING;
    };
    const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED;
    };
    const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
    };
    const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
    };
    const $bc03080c674ccba2$export$66a96ac2f07f6730 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
    };
});
parcelRegister("bgC2H", function(module, exports) {
    $parcel$export(module.exports, "ConsolidationState", ()=>$927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
    const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
        NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
        TRANSITIONING: 'TRANSITIONING',
        TRANSITIONED: 'TRANSITIONED',
        CONSOLIDATED: 'CONSOLIDATED'
    };
});
const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';
const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';
const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';
parcelRegister("kMiZJ", function(module, exports) {
    $parcel$export(module.exports, "consolidationUserStateResource", ()=>$1e0457dbe68ab17d$export$4b870505c49999ef);
    var $jcw0u;
    var $2M1hQ;
    var $9QTNT;
    const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
    const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
        getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, (0, parcelRequire("9QTNT")).getOgConsolidationUserState)(accountId).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'consolidationUserStateResource',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }),
        maxAge: Infinity
    });
});
parcelRegister("9QTNT", function(module, exports) {
    $parcel$export(module.exports, "getOgConsolidationUserState", ()=>$1a9945d1ee35f024$export$df7594d56c9ebe57);
    var $89SaW;
    var $jcw0u;
    var $jJZqs;
    var $iXaZ3;
    const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
        if (!accountId) return Promise.resolve((0, (0, parcelRequire("iXaZ3")).ERROR_CONSOLIDATION_USER_STATE));
        return (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
            if (!val || typeof val !== 'object') {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getUserProperty',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: new (0, (0, parcelRequire("jJZqs")).ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            }
            if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key)))
            };
            if (!Object.keys((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...val
            };
            return val;
        }).catch((error)=>{
            if (error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.statusCode === 404) return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            throw error;
        });
    };
});
parcelRegister("iXaZ3", function(module, exports) {
    $parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", ()=>$58f10b27bad0d860$export$1980758e2622af02);
    $parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$51d9907e9d716d);
    $parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$23da4710c3a29eae);
    const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
    const $58f10b27bad0d860$export$51d9907e9d716d = {
        isPromotionBannerDismissed: false,
        isWelcomeModalDisplayed: false,
        isTransitionHomeHidden: false,
        isTransitionBannerDismissed: false,
        isBroadcastWidgetDismissed: false,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: false
    };
    const $58f10b27bad0d860$export$23da4710c3a29eae = {
        isPromotionBannerDismissed: true,
        isWelcomeModalDisplayed: true,
        isTransitionHomeHidden: true,
        isTransitionBannerDismissed: true,
        isBroadcastWidgetDismissed: true,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: true
    };
});
parcelRegister("bHhiy", function(module, exports) {
    $parcel$export(module.exports, "getConsolidationStateResource", ()=>$cd33a435a46904ef$export$a6cf5054d4f9f5dd);
    var $6GHRr;
    var $co1wz;
    var $4R6GH;
    var $2M1hQ;
    var $bgC2H;
    const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, appPermissions)=>{
        let url = (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
        if (cloudId) url = `${url}/${cloudId}`;
        else throw new Error('No tenant info exists.');
        if ((0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update')) {
            if (!atlassianAccountId) throw new Error('No atlassian account id exists.');
            url = `${url}/${atlassianAccountId}`;
        }
        let promise;
        if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
            promise = new Promise((resolve)=>{
                resolve({
                    consolidationState: (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? {
                        isAdmin: false
                    } : {}
                });
            });
            return promise;
        }
        if (false) promise = (0, (0, parcelRequire("6GHRr")).eocFetch)(url, {
            exactUrl: true,
            headers: {
                'x-ssr-service-name': (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
            }
        });
        else {
            const clientUrl = (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
            promise = (0, (0, parcelRequire("6GHRr")).eocFetch)(clientUrl).then(({ data: data })=>data);
        }
        if ((0, (0, parcelRequire("co1wz")).ff)('eoc-tenant-info-hook_dq6ke')) return promise;
        return promise.then((response)=>response.consolidationState);
    };
    const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
            getKey: ()=>'tenantInformation',
            getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, appPermissions),
            maxAge: Infinity,
            isBrowserOnly: forceBrowser
        });
});
parcelRegister("aA974", function(module, exports) {
    $parcel$export(module.exports, "gicSmartFieldsFeatureResource", ()=>$d18db694553f5610$export$ee94bb1f59b07e35);
    $parcel$export(module.exports, "useIsSmartFieldsOptIn", ()=>$d18db694553f5610$export$3870b1ff1b155c73);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $aHuqL;
    var $2M1hQ;
    var $2YP9W;
    const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
        getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                const data = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
                if (!data) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                return data;
            } catch (error) {
                if (error.statusCode === 404) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'gicSmartFieldsFeatureResource',
                        packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                        teamName: 'deliveroo'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
        const { data: data, update: update, loading: loading } = (0, (0, parcelRequire("2YP9W")).useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
        const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
        const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
        const currentDismissedGicOnboarding = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false : undefined;
        const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    hasUserDismissedReadMore: true,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? previousData?.hasUserDismissedGicOnboarding ? {
                        hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                    } : {
                        hasUserDismissedGicOnboarding: false
                    } : {}
                }));
        }, [
            update
        ]);
        const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    ...previousData?.hasUserDismissedReadMore ? {
                        hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                    } : {
                        hasUserDismissedReadMore: false
                    },
                    hasUserDismissedGicOnboarding: true
                }));
        }, [
            update
        ]);
        return {
            isSmartFieldsOptIn: loading ? null : currentOptInStatus,
            isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
            isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
            dismissReadMore: dismissReadMore,
            dismissGicOnboarding: dismissGicOnboarding,
            loading: loading
        };
    };
});
const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key';
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';
parcelRegister("f5nIZ", function(module, exports) {
    $parcel$export(module.exports, "gicOptInStatusResources", ()=>$1dd3138bca6cac05$export$14c89b6b6a261524);
    var $dJl1T;
    var $eusud;
    var $2M1hQ;
    const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
        getKey: ()=>'gic_optin_status',
        getData: async ()=>{
            let gicOptInStatus = null;
            try {
                gicOptInStatus = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
            } catch (e) {
                if (e.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
            }
            return {
                gicOptInStatus: gicOptInStatus ?? {
                    isEnabled: false
                }
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';
parcelRegister("hZhhj", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RESPONSE", ()=>$0f1ada479bbc578a$export$32d9db53927095d3);
    $parcel$export(module.exports, "incomingMailServerExpiryStatusResource", ()=>$0f1ada479bbc578a$export$369caf52ed1ad2b1);
    $parcel$export(module.exports, "useIncomingMailExpiryStatus", ()=>$0f1ada479bbc578a$export$283aa034b7d4e2a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
    const $0f1ada479bbc578a$export$32d9db53927095d3 = {
        isAdmin: false,
        showBanner: true,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
        getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
        getData: async ()=>{
            let incomingMailServerExpiryStatus = null;
            try {
                incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'incomingMailServerExpiryStatus',
                        packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                        teamName: 'maverick'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
            };
        },
        maxAge: 3600000
    });
    const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, (0, parcelRequire("2YP9W")).useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
        const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
            if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
            return $0f1ada479bbc578a$export$32d9db53927095d3;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.incomingMailServerExpiryStatus) {
                setResponseStatusGet('success');
                setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.incomingMailServerExpiryStatus
        ]);
        return {
            responseStatus: responseStatusGet,
            state: incomingMailServerExpiryStatus
        };
    };
});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';
parcelRegister("9MiT2", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", ()=>$2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    $parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", ()=>$2d6f7831c4394a60$export$e21c345b2538e96e);
    var $5uXOq = parcelRequire("5uXOq");
    var $561FV = parcelRequire("561FV");
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    var $erLlC;
    const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("erLlC")).RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
        getKey: ()=>(0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
        getData: async ()=>{
            let modalViewCount = 0;
            try {
                const apiResult = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    if (!(0, ($parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                        const error = new Error('Invalid preference value');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'issueTransitionChangeboardingPreferencesResource',
                                packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                    return {
                        numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                        benefitsModal: {
                            isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                            nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                        }
                    };
                }
                if (typeof apiResult !== 'object' || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } else {
                    modalViewCount = Number(apiResult.value);
                    return {
                        numberOfTimesUserHasSeenChangeboarding: modalViewCount
                    };
                }
            } catch (error) {
                if (error.statusCode === 404) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                        numberOfTimesUserHasSeenChangeboarding: 0,
                        benefitsModal: {
                            isDisabled: false,
                            nextDateToShowBenefitsModal: null
                        }
                    };
                    return {
                        numberOfTimesUserHasSeenChangeboarding: 0
                    };
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                numberOfTimesUserHasSeenChangeboarding: modalViewCount,
                benefitsModal: {
                    isDisabled: true,
                    nextDateToShowBenefitsModal: null
                }
            };
        }
    });
    const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
        const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
            return 0, (0, parcelRequire("erLlC")).USER_SEEN_CARDINALITY_UNKNOWN;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            const body = typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal') ? {
                value: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled,
                    nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
                }
            } : {
                value: updates
            };
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                    body: JSON.stringify(body)
                });
                setResponseStatusPut('success');
                let updateData;
                if (typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                    benefitsModal: {
                        isDisabled: updates?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                };
                if (typeof updates === 'number') updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates
                };
                update(()=>updateData);
                response = 'success';
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference({
                    numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                    benefitsModal: {
                        isDisabled: data?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                });
                return;
            }
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.numberOfTimesUserHasSeenChangeboarding,
            data?.benefitsModal?.isDisabled,
            data?.benefitsModal?.nextDateToShowBenefitsModal
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionChangeboardingPreference
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTranstitionChangeboardingPreferences
            }
        };
    };
});
parcelRegister("erLlC", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", ()=>$ca7314633d486db1$export$d66d4b761db3d20f);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", ()=>$ca7314633d486db1$export$79fd70b908f71ddd);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", ()=>$ca7314633d486db1$export$e5007258addba8aa);
    $parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", ()=>$ca7314633d486db1$export$91880069e7e73b18);
    $parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", ()=>$ca7314633d486db1$export$9ccdfd91f2512a27);
    const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
    const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
    const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
    const $ca7314633d486db1$export$91880069e7e73b18 = -1;
    const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;
});
parcelRegister("fNOVA", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionOptInStatusResource", ()=>$cf959888902c771b$export$5fbcf4d7a6d9c477);
    $parcel$export(module.exports, "useIssueTransitionLabsOptIn", ()=>$cf959888902c771b$export$bc11d4816053db5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1WqFo;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    var $dO2g2;
    const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
    const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
        getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
        getData: async ()=>{
            let issueTransitionOptInStatus = null;
            const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("1WqFo")).isFedRamp)();
            const isModernITSRenderEnabled = (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') || (0, (0, parcelRequire("1WqFo")).isFedRamp)();
            if (!isModernITSRenderEnabled) return {
                issueTransitionOptInStatus: {
                    isEnabled: false,
                    expiryTime: -1
                }
            };
            if (isModernIssueTransitionSRBCohort) return {
                issueTransitionOptInStatus: {
                    isEnabled: true
                }
            };
            try {
                issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'issueTransitionOptInStatusResource',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, (0, parcelRequire("dO2g2")).default)()
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, (0, parcelRequire("eusud")).performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
            body: JSON.stringify(payload)
        });
    const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
        const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
            if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
            return (0, (0, parcelRequire("dO2g2")).default)();
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            try {
                const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
                setResponseStatusPut('success');
                update(()=>({
                        issueTransitionOptInStatus: updatedPreferences
                    }));
                response = 'success';
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err,
                    meta: {
                        id: 'issueTransitionOptInStatusUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.issueTransitionOptInStatus) {
                setResponseStatusGet('success');
                setIssueTransitionOptInState(data.issueTransitionOptInStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.issueTransitionOptInStatus
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionLabsOptInState
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTransitionOptInStatus
            }
        };
    };
});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;
parcelRegister("dO2g2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa107364a5021d3$export$2e2bcd8739ae039);
    var $1WqFo;
    var $co1wz;
    var $4R6GH;
    const $8fa107364a5021d3$var$FF_POSSIBLE_VALUES = [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ];
    const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
        const isModernITSRenderEnabled = (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') || (0, (0, parcelRequire("1WqFo")).isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            isEnabled: false,
            expiryTime: -1
        };
        const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("1WqFo")).isFedRamp)();
        if (isModernIssueTransitionSRBCohort) return {
            isEnabled: true
        };
        const isExplicitlyUseTurnedOff = (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $8fa107364a5021d3$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
        return isExplicitlyUseTurnedOff ? {
            isEnabled: false,
            expiryTime: -1
        } : {
            isEnabled: true
        };
    };
    var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;
});
parcelRegister("kJQXA", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", ()=>$273ba0463e1e3cac$export$fa191d7d71460a98);
    var $4Pf62;
    var $eusud;
    var $2M1hQ;
    const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
        getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
        getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
            const defaultValue = {
                enabled: true
            };
            if (!licensedProducts || !licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
            const { enabled: enabled } = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
            return {
                enabled: enabled
            };
        },
        maxAge: Infinity
    });
});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';
parcelRegister("atU1t", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarGlobalResource", ()=>$587727b78e9bd173$export$44e7ad3c66a3f25f);
    var $3NIpU;
    var $1nb22;
    var $2M1hQ;
    const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || projectId || '__state';
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { baseUrl: baseUrl } = tenantContext;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const scope = {
                projectKey: projectKey,
                projectId: projectId
            };
            const response = await (0, (0, parcelRequire("3NIpU")).fetchSidebarConfig)(baseUrl, scope, false);
            return {
                response: response,
                scope: scope
            };
        },
        maxAge: 300000
    });
});
parcelRegister("3NIpU", function(module, exports) {
    $parcel$export(module.exports, "fetchSidebarConfig", ()=>$8ba40d865239bafe$export$d1d13c4b972a22f1);
    var $dJl1T;
    var $7f4tk;
    const $8ba40d865239bafe$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';
    const $8ba40d865239bafe$var$fetchUsingProtobuf = async (url)=>{
        try {
            const fetchProtobuf = await (parcelRequire("aOyKS"));
            if (!fetchProtobuf) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
            return fetchProtobuf.default(url);
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
            throw err;
        }
    };
    const $8ba40d865239bafe$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
        const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
        const params = {
            exclude: [
                'webItems.reports',
                'webItems.home',
                'webItems.gin',
                exclude
            ].filter(Boolean).join(',')
        };
        let path = '';
        if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
        else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
        else if (identifierValue != null) path = `project/${identifierValue}`;
        else {
            path = 'product';
            const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
            const projectIdOrKey = projectId || projectKey;
            if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
        }
        const queryString = [
            new URLSearchParams(params).toString(),
            queryParams
        ].filter(Boolean).join('&');
        return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
    };
    const $8ba40d865239bafe$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
        if (isServer) {
            const protoUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
            return $8ba40d865239bafe$var$fetchUsingProtobuf(protoUrl);
        }
        const sidebarUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
        return (0, (0, parcelRequire("7f4tk")).default)(sidebarUrl);
    };
});
parcelRegister("aOyKS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7erVk").then(()=>parcelRequire('g4I8Z'));
});
const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';
parcelRegister("c34Wf", function(module, exports) {
    $parcel$export(module.exports, "navigationUiStateResource", ()=>$976a0f933d5d0ba8$export$14c178691841b423);
    var $8QpSo;
    var $2M1hQ;
    var $kJPyG;
    const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, (0, parcelRequire("8QpSo")).default)((atlassianAccountId)=>(0, (0, parcelRequire("kJPyG")).getNavigationUiState)({
            tenantContext: {
                atlassianAccountId: atlassianAccountId
            }
        }));
    const $976a0f933d5d0ba8$export$14c178691841b423 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'RESOURCE_TYPE_NAVIGATION_UI',
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
        maxAge: Infinity
    });
});
parcelRegister("kJPyG", function(module, exports) {
    $parcel$export(module.exports, "getNavigationUiState", ()=>$a5efaf793a61ef5e$export$29999268b070c9bd);
    var $89SaW;
    var $1yqku;
    const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
        const { atlassianAccountId: accountId } = tenantContext;
        let uiState = await (0, (0, parcelRequire("1yqku")).queryLocalStorage)();
        if (uiState || !accountId) return uiState;
        try {
            uiState = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
            (0, (0, parcelRequire("1yqku")).updateLocalStorageData)(uiState);
        } catch (e) {}
        return uiState;
    };
});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';
parcelRegister("1yqku", function(module, exports) {
    $parcel$export(module.exports, "queryLocalStorage", ()=>$fa4273588466a1c1$export$e192dcb908272d5);
    $parcel$export(module.exports, "updateLocalStorageData", ()=>$fa4273588466a1c1$export$ec13c725e067146a);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
        return {
            setItem: (0, ($parcel$interopDefault($8Rkzz))),
            getItem: (0, ($parcel$interopDefault($8Rkzz)))
        };
    };
    const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        const item = localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        if (!false && item) try {
            return JSON.parse(item);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
        }
    };
    const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
            const item = $fa4273588466a1c1$var$queryLocalStorageSync();
            resolve(item);
        });
    const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    };
});
parcelRegister("eOlBz", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", ()=>$4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
    $parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", ()=>$4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
    $parcel$export(module.exports, "useNewIssueViewLockedInStatus", ()=>$4e2e5fcdbf62dfaf$export$3b09097f2a423abd);
    var $2M1hQ;
    var $2YP9W;
    const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
        getKey: ()=>'newIssueViewTransitionLockingStatus',
        getDataLoader: ()=>(parcelRequire("l81Mv")),
        maxAge: Number.MAX_VALUE
    });
    const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';
parcelRegister("l81Mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bDo1N").then(()=>parcelRequire('2RVA3'));
});
parcelRegister("3X1Xr", function(module, exports) {
    $parcel$export(module.exports, "persistentIssueCreateModalViewResource", ()=>$950f2f2a5a65ba3f$export$266a039a005e8314);
    var $2M1hQ;
    const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("cptV5")),
        maxAge: Number.MAX_VALUE
    });
});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';
parcelRegister("cptV5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Kt13").then(()=>parcelRequire('8FYIq'));
});
parcelRegister("jSv1P", function(module, exports) {
    $parcel$export(module.exports, "jpdRecommendationDismissedResource", ()=>$8af94dc1eb7513b5$export$5db7c4562b672f52);
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $3HwlS;
    var $gNStA;
    var $2M1hQ;
    const $8af94dc1eb7513b5$export$5db7c4562b672f52 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('hot-113350-move-resources-to-rrr'), (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $2ffc5f2215c16253$export$6f0555de4f60e84e),
        getKey: ()=>(0, $2ffc5f2215c16253$export$7e7d7930e22ba39f),
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return {
                    hasDismissed: true
                };
                const accountId = tenantContext.atlassianAccountId;
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
                return {
                    hasDismissed: response
                };
            } catch (error) {
                const initialValueNeverSet = error.statusCode === 404;
                if (initialValueNeverSet) return {
                    hasDismissed: false
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $2ffc5f2215c16253$export$7f111648ca05f056),
                        packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasDismissed: true
            };
        },
        maxAge: Number.MAX_VALUE
    }));
});
const $2ffc5f2215c16253$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2ffc5f2215c16253$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2ffc5f2215c16253$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesRecommendationsDismissedJpd';
const $2ffc5f2215c16253$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';
parcelRegister("kkNtb", function(module, exports) {
    $parcel$export(module.exports, "rovoEntitlementResource", ()=>$10274390833bf523$export$a0974cf24d16bc5d);
    $parcel$export(module.exports, "useRovoEntitlementResource", ()=>$10274390833bf523$export$b9cee3799212b85a);
    var $jcw0u;
    var $eusud;
    var $2M1hQ;
    var $2YP9W;
    const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
    const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            isRovoEnabled: null
        };
    };
    const $10274390833bf523$export$a0974cf24d16bc5d = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
        maxAge: Infinity
    });
    const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($10274390833bf523$export$a0974cf24d16bc5d);
});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;
parcelRegister("2Ql51", function(module, exports) {
    $parcel$export(module.exports, "themePreferenceResource", ()=>$14feb59df5995657$export$e5a423d1eb1cf1d0);
    $parcel$export(module.exports, "useThemePreference", ()=>$14feb59df5995657$export$3416635c8aeb5bab);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $95EVP;
    var $2M1hQ;
    var $2YP9W;
    var $Y0b1l;
    const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7QoEx"));
    const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'RESOURCE_THEME_PREFERENCE',
        getKey: ()=>'state',
        getDataLoader: $14feb59df5995657$var$getDataLoader,
        maxAge: 300000
    });
    const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
        const { data: data, update: updateThemePreferenceResource } = (0, (0, parcelRequire("2YP9W")).useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
            const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            const analyticsEvent = createAnalyticsEvent({
                action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
                actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                newPreference: next,
                oldPreference: current,
                OStheme: OStheme
            });
        }, [
            createAnalyticsEvent
        ]);
        const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
            updateThemePreferenceResource(()=>({
                    theme: theme
                }));
            if (data?.theme !== theme) {
                fireThemeAnalytics(data?.theme, theme);
                await (0, (0, parcelRequire("Y0b1l")).setThemePreference)(theme);
            }
        }, [
            data?.theme,
            updateThemePreferenceResource,
            fireThemeAnalytics
        ]);
        return {
            theme: data?.theme,
            setTheme: setTheme
        };
    };
});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';
parcelRegister("Y0b1l", function(module, exports) {
    $parcel$export(module.exports, "setThemePreference", ()=>$fb319b2ef1da4e47$export$a6b84eebd33787e2);
    $parcel$export(module.exports, "getThemePreference", ()=>$fb319b2ef1da4e47$export$2f7a12048d96237);
    var $b9op4;
    var $jcw0u;
    var $aHuqL;
    const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'put',
                    errName: String(error.name),
                    statusCode: error.statusCode,
                    param: `to:${theme}`
                }
            });
        });
        return promise;
    };
    const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'get',
                    errName: String(error.name),
                    statusCode: error.statusCode
                }
            });
        });
        promise.then((theme)=>{
            if (theme && !(0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: new Error('Unrecognized theme!'),
                attributes: {
                    op: 'get',
                    theme: theme,
                    errName: 'unrecognized value!'
                }
            });
        });
        const theme = await promise;
        return theme && (0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme) ? theme : undefined;
    };
});
parcelRegister("b9op4", function(module, exports) {
    $parcel$export(module.exports, "ThemeOptions", ()=>$a1d11c8212b90b3e$export$abe7936539cefefe);
    $parcel$export(module.exports, "DEFAULT_THEME", ()=>$a1d11c8212b90b3e$export$2faeed762aac6741);
    const $a1d11c8212b90b3e$export$abe7936539cefefe = [
        'light',
        'dark',
        'auto'
    ];
    const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';
});
parcelRegister("7QoEx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5DvFw")
    ]).then(()=>parcelRequire('jyeNt'));
});
parcelRegister("9vlEn", function(module, exports) {
    $parcel$export(module.exports, "userHomepageResource", ()=>$ea929e6a42e03883$export$16320dd0d1e6c145);
    var $eusud;
    var $2M1hQ;
    const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
            const { homepagePreference: homepagePreference } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
            return {
                homepagePreference: homepagePreference
            };
        },
        maxAge: Infinity
    });
});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';
parcelRegister("aFVvc", function(module, exports) {
    $parcel$export(module.exports, "projectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$f6c05eaea53ab4ae);
    $parcel$export(module.exports, "useProjectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$2bd0d3b374549a68);
    var $2M1hQ;
    var $2YP9W;
    const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("axsKz"));
    const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
        getKey: ()=>'state',
        getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
        maxAge: Infinity
    });
    const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);
});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';
parcelRegister("axsKz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bqWWL").then(()=>parcelRequire('5Yzmr'));
});
parcelRegister("7GnDe", function(module, exports) {
    $parcel$export(module.exports, "incidentsInitialPageChecksResource", ()=>$08a008dcde68e650$export$b2b94ce8ba590cc8);
    $parcel$export(module.exports, "incidentsCustomFieldIdResource", ()=>$08a008dcde68e650$export$e81d7afef87ae597);
    $parcel$export(module.exports, "incidentExperimentTraitResource", ()=>$08a008dcde68e650$export$31c6945718067be3);
    $parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", ()=>$08a008dcde68e650$export$6fc19cf1d90e9453);
    $parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", ()=>$08a008dcde68e650$export$2e6b9e6402ff1d9b);
    var $4R6GH;
    var $3HwlS;
    var $gNStA;
    var $2M1hQ;
    const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("1Y6Un"))
    });
    const $08a008dcde68e650$export$e81d7afef87ae597 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("7F1l2"))
    });
    const $08a008dcde68e650$export$31c6945718067be3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
        getKey: ()=>'incident_experiment_traits',
        getDataLoader: ()=>(parcelRequire("7I42N")),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $08a008dcde68e650$export$6fc19cf1d90e9453 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && ((0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-remove-incidents-resource') || (0, (0, parcelRequire("4R6GH")).fg)('perf-push-big-components-nav-remove-resources'))), $08a008dcde68e650$export$31c6945718067be3);
    const $08a008dcde68e650$export$2e6b9e6402ff1d9b = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('blu-5573-remove-incident-resouce')), $08a008dcde68e650$export$31c6945718067be3);
});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';
parcelRegister("1Y6Un", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jEfvB").then(()=>parcelRequire('8lQN4'));
});
parcelRegister("7F1l2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8rk6s").then(()=>parcelRequire('i0mY9'));
});
parcelRegister("7I42N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ajWVH").then(()=>parcelRequire('iwLnj'));
});
parcelRegister("8ZUng", function(module, exports) {
    $parcel$export(module.exports, "issueViewRelayResource", ()=>$e05b8d0e5bf08042$export$55131006e6699c0a);
    $parcel$export(module.exports, "useIssueViewRelayRouteResource", ()=>$e05b8d0e5bf08042$export$252bdba8c8e5f066);
    var $3Mzpf;
    var $k3PbQ;
    var $6yLM4;
    var $ao2h1;
    var $la3vp;
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    const $e05b8d0e5bf08042$var$getDataLoader = ()=>(parcelRequire("3fjvV"));
    const $e05b8d0e5bf08042$export$5ce473a762cc813e = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_AGG_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getDataLoader: $e05b8d0e5bf08042$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("5XgeZ")).MIN_MAX_AGE),
        isBrowserOnly: true
    }));
    const $e05b8d0e5bf08042$export$55131006e6699c0a = (0, (0, parcelRequire("5XgeZ")).createRelayResourceDeprecated)({
        type: 'ISSUE_RELAY_DATA',
        isBrowserOnly: true,
        captureErrors: true,
        captureTraceIds: !false,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const { match: match } = routerContext;
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            const siteAri = (0, (0, parcelRequire("3Mzpf")).JiraSiteAri).create({
                siteId: cloudId
            }).toString();
            const projectKey = issueKey ? (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey) : '';
            const queryVariables = {
                cloudId: cloudId,
                issueKey: issueKey || '',
                projectKey: projectKey,
                siteAri: siteAri
            };
            return {
                parameters: (0, (0, parcelRequire("la3vp")).default),
                variables: {
                    ...queryVariables,
                    ...(0, (0, parcelRequire("6yLM4")).getMainIssueViewAggQueryVariables)()
                },
                keyVariables: {
                    ...queryVariables,
                    ...(0, (0, parcelRequire("6yLM4")).getMainIssueViewAggQueryFeatureFlagVariables)()
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $e05b8d0e5bf08042$export$252bdba8c8e5f066 = (options)=>(0, (0, parcelRequire("ao2h1")).useRelayResource)($e05b8d0e5bf08042$export$55131006e6699c0a, options);
});
parcelRegister("3Mzpf", function(module, exports) {
    $parcel$export(module.exports, "JiraSiteAri", ()=>$2c1151bb17cb172c$export$6c0f81f222d09301);
    var $gQC3n;
    var $9KGzW;
    var $1C2Ux;
    var $2c1151bb17cb172c$var$jiraSiteAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^$"),
        resourceOwner: (0, (0, parcelRequire("gQC3n")).JiraSiteAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gQC3n")).JiraSiteAriResourceType),
        resourceIdSlug: "{siteId}",
        resourceIdSegmentFormats: {
            siteId: /[a-zA-Z0-9_\-.]{1,255}/
        }
    };
    var $2c1151bb17cb172c$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.resourceIdSegmentValues.siteId;
        }
        get siteId() {
            return this._siteId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.qualifier,
                platformQualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.platformQualifier,
                cloudId: void 0,
                resourceOwner: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceOwner,
                resourceType: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceType,
                resourceId: `${opts.siteId}`,
                resourceIdSegmentValues: {
                    siteId: opts.siteId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
            return new _JiraSiteAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
            return new _JiraSiteAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId
            };
        }
    };
});
parcelRegister("gQC3n", function(module, exports) {
    $parcel$export(module.exports, "JiraSiteAriResourceOwner", ()=>$032a4e897fcecef5$export$b7d590981b504412);
    $parcel$export(module.exports, "JiraSiteAriResourceType", ()=>$032a4e897fcecef5$export$886165a991f21644);
    var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";
});
parcelRegister("k3PbQ", function(module, exports) {
    $parcel$export(module.exports, "extractProjectKey", ()=>$bfdd97e245e93328$export$f1a2e4721b127828);
    var $g5X3G;
    const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
});
parcelRegister("6yLM4", function(module, exports) {
    $parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", ()=>$bbb83ac7c9853fc8$export$3dd406718c5846c6);
    $parcel$export(module.exports, "getMainIssueViewAggQueryVariables", ()=>$bbb83ac7c9853fc8$export$5896c8dc13246fe2);
    var $f9Owr;
    var $4R6GH;
    var $6tI1D;
    const $bbb83ac7c9853fc8$var$_unused = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jiv-19486-allow-fg-usage-in-early-scripts');
    const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
            isCompassComponentsEnabled: (0, (0, parcelRequire("f9Owr")).ff)('compass-components-in-jira-components_xw42u', false),
            giraAGGMigrationCommentsFlag: (0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') || (0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check'),
            jsmSentimentCustomFieldFlag: true,
            isJPDPanelEnabled: (0, (0, parcelRequire("f9Owr")).ff)('polaris.jpd-panel-in-issue-view', false),
            issueViewRelayPriorityFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-priority_ri9vi', false),
            issueViewRelayAssigneeFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-assignee-ld', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-reporter_jfzs2', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-user', false),
            issueViewRelayNumberFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-number_q0em4', false),
            issueViewRelaySprintFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-sprint_jozpu', false),
            issueViewRelayAttachmentsFlag: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-view-attachments-'),
            issueViewRelaySingleLineTextFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text_in6w6', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text-message', false),
            issueViewRelayDateFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-date_ptj72', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false),
            issueViewRelayParentFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false),
            issueViewRelayProjectFieldFlag: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-project-select'),
            issueViewRelayDateTimeFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-date-time_eaqd2', false),
            issueViewRelayMetadataFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-metadata_d42b0', false),
            issueViewDesignsPanelFlag: (0, (0, parcelRequire("4R6GH")).fg)('make_designs_panel_in_issue_view_synchronous'),
            isJPDDeliveryLinkTypeFilteringEnabled: (0, (0, parcelRequire("f9Owr")).ff)('polaris.jpd-panel-in-issue-view', false),
            issueViewImproveIssueDropdownFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false) && (0, (0, parcelRequire("f9Owr")).getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
                'OLD',
                'NEW',
                'CHECK',
                'CHECK_RETURN_NEW'
            ]) !== 'NEW',
            issueViewIsAiEnabledOnProject: (0, (0, parcelRequire("f9Owr")).getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
                'OLD',
                'NEW',
                'CHECK',
                'CHECK_RETURN_NEW'
            ]) === 'NEW',
            issueViewRelayUrlFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-url_ob8uu', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-assignee-ld', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-reporter_jfzs2', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-user', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n', false),
            issueViewRelaySummaryFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-summary_eog1v', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-original-estimate_eb4wv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-single-line-text-message', false),
            issueViewRelayColorFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-color_wrbay', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-people', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-approvers', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-votes_nsbqd', false),
            issueViewRelayHeaders: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-parent_5p1ac', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-security-level_7y5uv', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-votes_nsbqd'),
            issueViewRelayPeopleAndApproversFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-people', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-approvers', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-components-select_prpz1', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-team-field-next_nctbt', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-user', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-participants', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-user', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-participants', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-request-participants_itocm', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-request-participants_itocm', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-resolution_86iya', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-multi-group-picker', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider: (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-group-picker-sg'),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-resolution_86iya', false) || (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c', false),
            issueViewRelayTimeTrackingFieldFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-radio_6gqb3', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-issue-restrictions_yudid', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-generic-1_f0cfz', false),
            customFieldConfigurationFlag: (0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-generic-1_f0cfz', false),
            __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone1experimentrelayprovider: (0, (0, parcelRequire("4R6GH")).fg)('thor_colourful_single_select_milestone1_gate'),
            isPinFieldConfigurabilityEnabled: (0, (0, parcelRequire("4R6GH")).fg)('pin_fields_ga') || (0, (0, parcelRequire("f9Owr")).ff)('pin_field_exp_launch_darkly_flag_ef4mc'),
            jcsIssueLayoutEapFlag: (0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap')
        });
    const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = ()=>({
            ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
            ...$bbb83ac7c9853fc8$export$afa6e4ae995b8926()
        });
    const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>({
            commentTargetId: (0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') || (0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') ? (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS)) || null : null
        });
});
parcelRegister("6tI1D", function(module, exports) {
    $parcel$export(module.exports, "COMMENTS", ()=>$ac458c74e4b12b29$export$4cab9dfa8fc858f4);
    $parcel$export(module.exports, "WORKLOG", ()=>$ac458c74e4b12b29$export$df36fc05622c402);
    $parcel$export(module.exports, "getAllUrlParams", ()=>$ac458c74e4b12b29$export$dca91ad250f6b082);
    $parcel$export(module.exports, "getPermalinkId", ()=>$ac458c74e4b12b29$export$bf42dbba4c31080e);
    var $gKZoD;
    var $dJl1T;
    const $ac458c74e4b12b29$export$b18d061fc042df1a = {
        COMMENTS: 'focusedCommentId',
        WORKLOG: 'focusedWorklogId'
    };
    const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
    const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
    const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        let queryString = window.location.search.slice(1);
        const obj = {};
        if (queryString) {
            queryString = queryString.split('#')[0];
            const arr = queryString.split('&');
            for(let i = 0; i < arr.length; i += 1){
                const a = arr[i].split('=');
                const paramName = a[0];
                try {
                    const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                    obj[paramName] = paramValue;
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
                }
            }
        }
        return obj;
    };
    const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
        if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
        const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
        return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
    };
});
parcelRegister("la3vp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d1e3365ed212162$export$2e2bcd8739ae039);
    var $asT4T;
    var $hBTVA;
    var $9OzGv;
    var $33qJ8;
    var $h6nNu;
    var $5pSyb;
    var $cKVMM;
    var $5mEVc;
    var $ef20f;
    var $84KW9;
    var $3wM25;
    var $ipyFC;
    var $kT0rw;
    var $d6bux;
    var $bdIYk;
    var $hjJTo;
    var $jDqgH;
    var $iwPkC;
    var $krohK;
    var $6NR1m;
    var $3E2yq;
    var $6sYK2;
    var $fmbEw;
    var $hSNvs;
    var $qPPmw;
    var $8Y9hN;
    var $4yni1;
    var $ejqaS;
    var $eXeEx;
    var $lWBBz;
    const $7d1e3365ed212162$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b11b8f834b3388439a0809aafd4140907de3be0b8d6207ac66a1760ef2b53bc0",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "issueByKey",
                            "attachments"
                        ]
                    }
                ]
            },
            "name": "mainIssueAggQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, (0, parcelRequire("d6bux")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, (0, parcelRequire("8Y9hN")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, (0, parcelRequire("9OzGv")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider": (0, (0, parcelRequire("33qJ8")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, (0, parcelRequire("kT0rw")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider": (0, (0, parcelRequire("3wM25")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, (0, parcelRequire("5pSyb")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, (0, parcelRequire("84KW9")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider": (0, (0, parcelRequire("qPPmw")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider": (0, (0, parcelRequire("hjJTo")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, (0, parcelRequire("6NR1m")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider": (0, (0, parcelRequire("ipyFC")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider": (0, (0, parcelRequire("iwPkC")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider": (0, (0, parcelRequire("bdIYk")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider": (0, (0, parcelRequire("asT4T")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, (0, parcelRequire("h6nNu")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider": (0, (0, parcelRequire("6sYK2")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, (0, parcelRequire("hBTVA")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider": (0, (0, parcelRequire("jDqgH")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider": (0, (0, parcelRequire("4yni1")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone1experimentrelayprovider": (0, (0, parcelRequire("lWBBz")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, (0, parcelRequire("cKVMM")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, (0, parcelRequire("eXeEx")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, (0, parcelRequire("3E2yq")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, (0, parcelRequire("ejqaS")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, (0, parcelRequire("5mEVc")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, (0, parcelRequire("ef20f")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, (0, parcelRequire("krohK")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, (0, parcelRequire("hSNvs")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, (0, parcelRequire("fmbEw")).default)
            }
        }
    };
    var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;
});
parcelRegister("asT4T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$587bfe0115b03c48$export$2e2bcd8739ae039);
    var $co1wz;
    var $587bfe0115b03c48$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-approvers');
        }
    };
});
parcelRegister("hBTVA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$317518afb86d429d$export$2e2bcd8739ae039);
    var $co1wz;
    var $317518afb86d429d$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-assignee-ld');
        }
    };
});
parcelRegister("9OzGv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68a7d680b4f7aa31$export$2e2bcd8739ae039);
    var $co1wz;
    var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-checkbox-select_ytl5n');
        }
    };
});
parcelRegister("33qJ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a066af595fad6e31$export$2e2bcd8739ae039);
    var $co1wz;
    var $a066af595fad6e31$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-components-select_prpz1');
        }
    };
});
parcelRegister("h6nNu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ea05c28112074d6$export$2e2bcd8739ae039);
    var $co1wz;
    const $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-generic-1_f0cfz');
        }
    };
    var $4ea05c28112074d6$export$2e2bcd8739ae039 = $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled;
});
parcelRegister("5pSyb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46b71e3be8dfea7a$export$2e2bcd8739ae039);
    var $4R6GH;
    var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('relay-migration-issue-fields-group-picker-sg');
        }
    };
});
parcelRegister("cKVMM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7153ac791d0f4b40$export$2e2bcd8739ae039);
    var $co1wz;
    var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd');
        }
    };
});
parcelRegister("5mEVc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dba981d8b012adb8$export$2e2bcd8739ae039);
    var $co1wz;
    var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-restrictions_yudid');
        }
    };
});
parcelRegister("ef20f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dac75eea754d44b$export$2e2bcd8739ae039);
    var $co1wz;
    var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt');
        }
    };
});
parcelRegister("84KW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c1aa824cd21c11$export$2e2bcd8739ae039);
    var $co1wz;
    var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-group-picker');
        }
    };
});
parcelRegister("3wM25", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4f763f7ab8915ff$export$2e2bcd8739ae039);
    var $co1wz;
    var $b4f763f7ab8915ff$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm');
        }
    };
});
parcelRegister("ipyFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de9ca17802c9cba7$export$2e2bcd8739ae039);
    var $co1wz;
    var $de9ca17802c9cba7$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-multi-user') || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-participants');
        }
    };
});
parcelRegister("kT0rw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cdff8c37120a188$export$2e2bcd8739ae039);
    var $co1wz;
    var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-original-estimate_eb4wv');
        }
    };
});
parcelRegister("d6bux", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d9e6f2a33f8172f$export$2e2bcd8739ae039);
    var $co1wz;
    var $4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-parent_5p1ac');
        }
    };
});
parcelRegister("bdIYk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3216c683ee81b04$export$2e2bcd8739ae039);
    var $co1wz;
    var $d3216c683ee81b04$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-people');
        }
    };
});
parcelRegister("hjJTo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8a929bbaac9d588$export$2e2bcd8739ae039);
    var $co1wz;
    var $c8a929bbaac9d588$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-radio_6gqb3');
        }
    };
});
parcelRegister("jDqgH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$144d769a6379ff4e$export$2e2bcd8739ae039);
    var $co1wz;
    var $144d769a6379ff4e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-reporter_jfzs2');
        }
    };
});
parcelRegister("iwPkC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb870d58c524b581$export$2e2bcd8739ae039);
    var $co1wz;
    var $cb870d58c524b581$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm');
        }
    };
});
parcelRegister("krohK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ee92d752c596813$export$2e2bcd8739ae039);
    var $co1wz;
    var $7ee92d752c596813$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya');
        }
    };
});
parcelRegister("6NR1m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$851058f7192cd7ee$export$2e2bcd8739ae039);
    var $co1wz;
    var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-issue-multi-line-text_w69oo');
        }
    };
});
parcelRegister("3E2yq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$847675c0acc8db9e$export$2e2bcd8739ae039);
    var $co1wz;
    var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-security-level_7y5uv');
        }
    };
});
parcelRegister("6sYK2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab91eec7ddbe8f3e$export$2e2bcd8739ae039);
    var $co1wz;
    var $ab91eec7ddbe8f3e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-single-line-text-message');
        }
    };
});
parcelRegister("fmbEw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afb9a48dda30cc33$export$2e2bcd8739ae039);
    var $co1wz;
    var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-resolution_86iya', false) || (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c', false);
        }
    };
});
parcelRegister("hSNvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efddcea96d8714d0$export$2e2bcd8739ae039);
    var $co1wz;
    var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c');
        }
    };
});
parcelRegister("qPPmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0786657423f5409$export$2e2bcd8739ae039);
    var $co1wz;
    var $e0786657423f5409$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-team-field-next_nctbt');
        }
    };
});
parcelRegister("8Y9hN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb6d2edf34e99bba$export$2e2bcd8739ae039);
    var $co1wz;
    var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-time-tracking_eefh0');
        }
    };
});
parcelRegister("4yni1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5243bedb3fa46125$export$2e2bcd8739ae039);
    var $co1wz;
    var $5243bedb3fa46125$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-user');
        }
    };
});
parcelRegister("ejqaS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7323747132cbc58$export$2e2bcd8739ae039);
    var $co1wz;
    var $c7323747132cbc58$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-votes_nsbqd');
        }
    };
});
parcelRegister("eXeEx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acfad9d58e7d968c$export$2e2bcd8739ae039);
    var $co1wz;
    var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-watchers_iqhn4');
        }
    };
});
parcelRegister("lWBBz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$545f86f6cc4b6952$export$2e2bcd8739ae039);
    var $4R6GH;
    var $545f86f6cc4b6952$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('thor_colourful_single_select_milestone1_gate');
        }
    };
});
parcelRegister("2Yhep", function(module, exports) {
    $parcel$export(module.exports, "getIssueKey", ()=>$05d1e79edcc0dc56$export$4a030f6192bebe03);
    const $05d1e79edcc0dc56$export$4a030f6192bebe03 = (match)=>{
        const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
        return fromMatch;
    };
});
parcelRegister("5XgeZ", function(module, exports) {
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$36d3fb93786ec5e2$export$5664a170ac5a9781);
    $parcel$export(module.exports, "withResourceEarlyData", ()=>$36d3fb93786ec5e2$export$22da5fb8c8200986);
    $parcel$export(module.exports, "createRelayResourceDeprecated", ()=>$36d3fb93786ec5e2$export$2e279339bedcd427);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $2M1hQ;
    var $7dbuH;
    const $36d3fb93786ec5e2$export$5664a170ac5a9781 = 5000;
    const $36d3fb93786ec5e2$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
        const getData = (...args)=>{
            performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
            if (!false && type in window) {
                const promise = window[type];
                delete window[type];
                getDataLoader && promise.then(getDataLoader);
                return promise;
            }
            if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
            return next && next(...args);
        };
        return {
            ...rest,
            type: type,
            getData: getData
        };
    };
    const $36d3fb93786ec5e2$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $36d3fb93786ec5e2$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, (0, parcelRequire("2M1hQ")).createResource)({
            type: `${$36d3fb93786ec5e2$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
                const variables = (0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') || (0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') ? keyVariables || queryVariables : queryVariables;
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: async (routerContext, customContext)=>{
                const measureName = `relay_resource_get_data:${type}`;
                const startMark = `relay_resource_get_data:${type}:start`;
                const endMark = `relay_resource_get_data:${type}:end`;
                (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
                const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
                const query = parameters ?? await loadParameters?.();
                const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
                if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
                if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                    (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                });
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("7dbuH")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $36d3fb93786ec5e2$export$2e279339bedcd427 = $36d3fb93786ec5e2$var$createRelayResourceImpl;
});
parcelRegister("3fjvV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aT8lA").then(()=>parcelRequire('jj7my'));
});
parcelRegister("5CPDv", function(module, exports) {
    $parcel$export(module.exports, "issueForgeDataResource", ()=>$82acf7aa3865e452$export$e28b79684fb81535);
    var $2Yhep;
    var $2M1hQ;
    var $jj8CY;
    const $82acf7aa3865e452$export$e28b79684fb81535 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'ISSUE_FORGE_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("jj8CY")).default)(...args),
        isBrowserOnly: true
    });
});
parcelRegister("jj8CY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a39eb6eca9b1263$export$2e2bcd8739ae039);
    var $4R6GH;
    var $hpuF5;
    var $iR3GG;
    var $2Yhep;
    var $3a39eb6eca9b1263$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const { cloudId: cloudId, activationId: activationId, isAnonymous: isAnonymous, locale: locale } = tenantContext;
            const data = (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? await (0, (0, parcelRequire("hpuF5")).fetchIssueForgeDataV2)(cloudId, issueKey, isAnonymous) : await (0, (0, parcelRequire("hpuF5")).fetchIssueForgeDataV1)(cloudId, issueKey, activationId, locale);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.forge.getData',
                message: 'An error was thrown while prefetching issue Forge data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("hpuF5", function(module, exports) {
    $parcel$export(module.exports, "fetchIssueForgeDataV1", ()=>$b0a1cdd28321d25a$export$e286ab7be9b90b73);
    $parcel$export(module.exports, "fetchIssueForgeDataV2", ()=>$b0a1cdd28321d25a$export$2a07b9ab3de7be30);
    var $k2DRb;
    var $5cmSg;
    var $5vSAE;
    var $iVaKa;
    var $7kNct;
    const $b0a1cdd28321d25a$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
    const $b0a1cdd28321d25a$export$e286ab7be9b90b73 = async (cloudId, issueKey, activationId, locale)=>{
        const modulesToFetch = [
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
        ];
        const contextIds = [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
        const result = await (0, (0, parcelRequire("iVaKa")).default)(cloudId, modulesToFetch, {
            issueKey: issueKey
        }, {
            include: {
                scopes: true
            }
        }, (0, (0, parcelRequire("k2DRb")).SOURCE_ISSUE_VIEW), contextIds, locale);
        const { extensions: extensions, accessNarrowedExtensions: accessNarrowedExtensions } = result;
        const mappedResult = {
            issueAction: extensions.jiraIssueAction || [],
            issueGlance: extensions.jiraIssueGlance || [],
            issueContext: extensions.jiraIssueContext || [],
            issuePanel: extensions.jiraIssuePanel || [],
            issueActivity: extensions.jiraIssueActivity || [],
            customField: extensions.jiraCustomField || [],
            customFieldType: extensions.jiraCustomFieldType || [],
            issueViewBackgroundScript: extensions.jiraIssueViewBackgroundScript || [],
            uiModifications: extensions.jiraUiModifications || [],
            blockedExtensions: {
                issueAction: accessNarrowedExtensions.jiraIssueAction || [],
                issueGlance: accessNarrowedExtensions.jiraIssueGlance || [],
                issueContext: accessNarrowedExtensions.jiraIssueContext || [],
                issuePanel: accessNarrowedExtensions.jiraIssuePanel || [],
                issueActivity: accessNarrowedExtensions.jiraIssueActivity || [],
                customField: accessNarrowedExtensions.jiraCustomField || [],
                customFieldType: accessNarrowedExtensions.jiraCustomFieldType || [],
                issueViewBackgroundScript: accessNarrowedExtensions.jiraIssueViewBackgroundScript || [],
                uiModifications: accessNarrowedExtensions.jiraUiModifications || []
            }
        };
        return (0, (0, parcelRequire("7kNct")).dedupeContextAndGlance)(mappedResult);
    };
    const $b0a1cdd28321d25a$export$2a07b9ab3de7be30 = async (cloudId, issueKey, isAnonymous)=>{
        const extensions = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
                (0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
                (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
            ],
            context: {
                issueKey: issueKey
            },
            includeHidden: true,
            includeScopes: true,
            source: (0, (0, parcelRequire("k2DRb")).SOURCE_ISSUE_VIEW)
        });
        const getFilteredExtensions = (filterFn)=>({
                issueAction: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE].filter(filterFn),
                issueGlance: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE].filter(filterFn),
                issueContext: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE].filter(filterFn),
                issuePanel: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE].filter(filterFn),
                issueActivity: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE].filter(filterFn),
                customField: extensions[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE].filter(filterFn),
                customFieldType: extensions[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE].filter(filterFn),
                issueViewBackgroundScript: extensions[0, (0, parcelRequire("k2DRb")).ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE].filter(filterFn),
                uiModifications: extensions[0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE].filter(filterFn)
            });
        const mappedResult = {
            ...getFilteredExtensions((extension)=>!(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)(extension)),
            blockedExtensions: {
                ...getFilteredExtensions((extension)=>(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)(extension))
            }
        };
        return (0, (0, parcelRequire("7kNct")).dedupeContextAndGlance)(mappedResult);
    };
});
parcelRegister("5cmSg", function(module, exports) {
    $parcel$export(module.exports, "isExtensionVisible", ()=>$30771269db74e480$export$41e48b53c2cc2013);
    $parcel$export(module.exports, "isExtensionHidden", ()=>$30771269db74e480$export$3f5b3e61d567ef3);
    $parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", ()=>$30771269db74e480$export$5c38dfa9d1f96e61);
    $parcel$export(module.exports, "isExtensionHiddenByDisplayConditions", ()=>$30771269db74e480$export$3cc53b8cca25d64);
    const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
    const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
    const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
    const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';
});
parcelRegister("7kNct", function(module, exports) {
    $parcel$export(module.exports, "dedupeContextAndGlance", ()=>$4e352c29f229bbb8$export$17503ba1adfac304);
    const $4e352c29f229bbb8$export$17503ba1adfac304 = (forgeData)=>{
        const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
        const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
        return {
            ...forgeData,
            issueGlance: newGlanceItems
        };
    };
});
parcelRegister("iR3GG", function(module, exports) {
    $parcel$export(module.exports, "createResourceError", ()=>$d895341acba1e817$export$13487d18466bc8a5);
    var $dJl1T;
    class $d895341acba1e817$var$ResourceErrorClass extends Error {
        constructor(message, options){
            super(message);
            this.name = options.name || 'ResourceError';
            this.skipSentry = options.skipSentry;
        }
    }
    const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, errorOverride)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(component, message, errorOverride);
        if (errorOverride) return errorOverride;
        return new $d895341acba1e817$var$ResourceErrorClass(message, {
            name: name,
            skipSentry: skipSentry
        });
    };
});
parcelRegister("9XjL6", function(module, exports) {
    $parcel$export(module.exports, "issueGiraDataResource", ()=>$94d751405759debc$export$37badecd288c49f4);
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    var $1UEZY;
    const $94d751405759debc$export$37badecd288c49f4 = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_GIRA_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("1UEZY")).default)(...args),
        isBrowserOnly: true
    }));
});
parcelRegister("1UEZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48e4146cd1317713$export$2e2bcd8739ae039);
    var $ePyEO;
    var $iR3GG;
    var $2Yhep;
    var $48e4146cd1317713$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const { baseUrl: baseUrl } = tenantContext;
            const data = await (0, (0, parcelRequire("ePyEO")).default)(baseUrl, issueKey);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.gira.getData',
                message: 'An error was thrown while prefetching issue gira data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("ePyEO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef212fbaef309294$export$2e2bcd8739ae039);
    var $cHBMC;
    var $k3PbQ;
    var $fqpdr;
    var $9kbEN;
    var $iBOrg;
    const $ef212fbaef309294$var$ISSUE_GIRA_DATA = 'issue-gira-data';
    const $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric = (0, (0, parcelRequire("cHBMC")).metrics).custom({
        key: $ef212fbaef309294$var$ISSUE_GIRA_DATA
    });
    var $ef212fbaef309294$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
        const projectKey = (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey);
        const variables = {
            issueKey: issueKey,
            projectKey: projectKey
        };
        const payload = {
            query: (0, (0, parcelRequire("fqpdr")).buildIssueQuery)(),
            variables: variables,
            operationName: (0, (0, parcelRequire("fqpdr")).ISSUE_VIEW_INTERACTIVE_QUERY)
        };
        if ((0, (0, parcelRequire("9kbEN")).isInSample)()) $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.start();
        try {
            const response = await (0, (0, parcelRequire("iBOrg")).getClient)(baseUrl).query(payload);
            const issueId = response.data?.viewIssue?.issueId;
            $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.stop({
                customData: issueId ? {
                    issueId: issueId
                } : null
            });
            return response;
        } catch (error) {
            $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.cancel();
            throw error;
        }
    };
});
parcelRegister("fqpdr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", ()=>$3789cf83eed10ddd$export$1780a132c0453fee);
    $parcel$export(module.exports, "getGiraUrl", ()=>$3789cf83eed10ddd$export$aefb19023b2eda55);
    $parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", ()=>$3789cf83eed10ddd$export$79eba9bf6dc9960d);
    $parcel$export(module.exports, "buildIssueQuery", ()=>$3789cf83eed10ddd$export$222ae9aca08830f0);
    $parcel$export(module.exports, "getGiraRequestOptions", ()=>$3789cf83eed10ddd$export$e1542dc7ff749de8);
    var $96nmc;
    var $EJMEI;
    var $8TkIN;
    var $e2Vt6;
    var $92ECu;
    var $6QL4r;
    var $5Pqa3;
    var $b1RJj;
    var $1HCMp;
    var $8JI9I;
    var $kNriQ;
    var $cRP2d;
    const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
    const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
    const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $3789cf83eed10ddd$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${(0, (0, parcelRequire("EJMEI")).default)({
            maxResults: (0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD),
            startAt: 0,
            orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
            commentAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD)),
            hydrateData: false
        })}
        ${(0, (0, parcelRequire("cRP2d")).default)({
            startAt: 0,
            worklogAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_WORKLOGS_TO_LOAD))
        })}
        ${(0, (0, parcelRequire("e2Vt6")).getEcosystemQuery)()}
        ${(0, (0, parcelRequire("8TkIN")).getContentPanelsQuery)()}
        ${(0, (0, parcelRequire("e2Vt6")).getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, (0, parcelRequire("5Pqa3")).getContainersByTypeQuery)()}
        ${(0, (0, parcelRequire("kNriQ")).getRemoteLinksQuery)()}
    }
`;
    const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
    const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
    const $3789cf83eed10ddd$export$222ae9aca08830f0 = ()=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, (0, parcelRequire("b1RJj")).default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery()}
        ${(0, (0, parcelRequire("6QL4r")).getJiraSettingsQuery)()}
        ${(0, (0, parcelRequire("1HCMp")).default)()}
        ${(0, (0, parcelRequire("8JI9I")).default)()}
    }

`;
    const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
        const payload = {
            operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
            query: $3789cf83eed10ddd$export$222ae9aca08830f0(),
            variables: {
                issueKey: issueKey,
                projectKey: projectKey
            }
        };
        return {
            method: 'POST',
            body: JSON.stringify(payload)
        };
    };
});
parcelRegister("96nmc", function(module, exports) {
    $parcel$export(module.exports, "appendOperationQuery", ()=>$8119dcf59ebfcad5$export$69694c3add0f6058);
    const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';
});
parcelRegister("EJMEI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01ae9b8d951a6992$export$2e2bcd8739ae039);
    var $4R6GH;
    var $6tI1D;
    var $9F91P;
    var $01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true })=>{
        const commentPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS));
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
        const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
        const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
        const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') && !(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') && !hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
        return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("9F91P", function(module, exports) {
    $parcel$export(module.exports, "isJsmTimelineEnabled", ()=>$38d603c6864a4cb1$export$575e1bf822db15b5);
    var $f9Owr;
    const $38d603c6864a4cb1$export$575e1bf822db15b5 = ()=>(0, (0, parcelRequire("f9Owr")).ff)('jsm-timelines-phase-2_70gja', false);
});
parcelRegister("8TkIN", function(module, exports) {
    $parcel$export(module.exports, "getContentPanelsQuery", ()=>$09fdc8c72c341092$export$e6f14eac549b679d);
    const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
    const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;
});
parcelRegister("e2Vt6", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$1771eed42c62eeca$export$edefef8c65e08bd2);
    $parcel$export(module.exports, "getLegacyRightWebPanelsQuery", ()=>$1771eed42c62eeca$export$92c9a3dc7076af51);
    var $f9Owr;
    const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
    const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, (0, parcelRequire("f9Owr")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
    const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;
});
parcelRegister("92ECu", function(module, exports) {
    $parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", ()=>$9387aa2a419a55f9$export$c46d621c29194aa4);
    $parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", ()=>$9387aa2a419a55f9$export$b2e398ce246f55b3);
    $parcel$export(module.exports, "gqlTagGira", ()=>$9387aa2a419a55f9$export$aeae6fc40846cf9f);
    const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
    const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
    const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
    const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
    const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
});
parcelRegister("6QL4r", function(module, exports) {
    $parcel$export(module.exports, "getJiraSettingsQuery", ()=>$10470e592ba8e782$export$191f50c0f86b85ec);
    const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
    const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
    const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
});
parcelRegister("5Pqa3", function(module, exports) {
    $parcel$export(module.exports, "getContainersByTypeQuery", ()=>$85e2f5a62f1697d1$export$63131b2831854cc);
    const $85e2f5a62f1697d1$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
});
parcelRegister("b1RJj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42429f0fa15c54ae$export$2e2bcd8739ae039);
    var $9wuCE;
    var $42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, (0, parcelRequire("9wuCE")).getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
});
parcelRegister("9wuCE", function(module, exports) {
    $parcel$export(module.exports, "getMaxTokenLength", ()=>$ebb491dcc11e8362$export$e40f2acaf1a50b00);
    const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
    const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;
});
parcelRegister("1HCMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea17df757c74c46$export$2e2bcd8739ae039);
    var $co1wz;
    const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
            'ADMINISTER_PROJECTS',
            'ASSIGN_ISSUES',
            'EDIT_ISSUES',
            'SCHEDULE_ISSUES',
            'ADD_COMMENTS',
            'DELETE_ALL_COMMENTS',
            'DELETE_OWN_COMMENTS',
            'EDIT_ALL_COMMENTS',
            'EDIT_OWN_COMMENTS',
            'CREATE_ISSUES',
            'DELETE_ISSUES',
            'MOVE_ISSUES',
            'MODIFY_REPORTER',
            'CREATE_ATTACHMENTS',
            'DELETE_ALL_ATTACHMENTS',
            'DELETE_OWN_ATTACHMENTS',
            'WORK_ON_ISSUES',
            'ASSIGNABLE_USER',
            'LINK_ISSUES',
            'VIEW_VOTERS_AND_WATCHERS',
            'MANAGE_WATCHERS',
            'EDIT_ALL_WORKLOGS',
            'EDIT_OWN_WORKLOGS',
            'DELETE_ALL_WORKLOGS',
            'DELETE_OWN_WORKLOGS',
            'VIEW_DEV_TOOLS',
            'SERVICEDESK_AGENT',
            'RESOLVE_ISSUES',
            'CLONE_ISSUE'
        ];
    const $0ea17df757c74c46$export$f5ff20e9116b53bc = ()=>{
        const permissionKeysForArchival = [
            'ARCHIVE_ISSUES',
            'UNARCHIVE_ISSUES'
        ];
        const permissionKeys = $0ea17df757c74c46$export$9fc40cb6f3529ef();
        if (!(0, (0, parcelRequire("co1wz")).ff)('issue-unarchival_wdpb9')) return permissionKeys;
        return [
            ...permissionKeys,
            ...permissionKeysForArchival
        ];
    };
    var $0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$f5ff20e9116b53bc().join('","')}"]) {
        key
        havePermission
    }
`;
});
parcelRegister("8JI9I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2232e63ddd04bbb1$export$2e2bcd8739ae039);
    var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
});
parcelRegister("kNriQ", function(module, exports) {
    $parcel$export(module.exports, "getRemoteLinksQuery", ()=>$e19ca26272d1dd4d$export$6bbc6b72b0b57f25);
    const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;
});
parcelRegister("cRP2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$354b7c85b873ab44$export$2e2bcd8739ae039);
    var $6tI1D;
    var $354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const worklogPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).WORKLOG));
        if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
        const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
        const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
        return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("9kbEN", function(module, exports) {
    $parcel$export(module.exports, "isInSample", ()=>$b9c2013a86366ec0$export$a994c91d08ead5ff);
    const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;
});
const $670519621927ccc4$export$9fc1f2d681a9e609 = 100;
parcelRegister("iBOrg", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$3d6ab2890da8f9df$export$6bb76d6eba7e258c);
    var $7f4tk;
    var $fqpdr;
    const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
            query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("fqpdr")).getGiraUrl)(baseUrl, operationName), {
                    method: 'POST',
                    body: JSON.stringify({
                        query: query,
                        variables: variables,
                        operationName: operationName
                    }),
                    signal: signal
                })
        });
    let $3d6ab2890da8f9df$var$client;
    const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
        if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
        return $3d6ab2890da8f9df$var$client;
    };
});
parcelRegister("lCj8l", function(module, exports) {
    $parcel$export(module.exports, "issueGiraNonCriticalDataResource", ()=>$74422abbcf73f635$export$2d81f7bddf10f49e);
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    var $cvOMs;
    const $74422abbcf73f635$export$2d81f7bddf10f49e = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: (...args)=>(0, (0, parcelRequire("cvOMs")).default)(...args),
        isBrowserOnly: true
    }));
});
parcelRegister("cvOMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07364a38d1410c3f$export$2e2bcd8739ae039);
    var $1O6Hj;
    var $iR3GG;
    var $2Yhep;
    var $07364a38d1410c3f$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
        const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const data = await (0, (0, parcelRequire("1O6Hj")).fetchIssueGiraNonCriticalData)(issueKey);
            return data;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.issue-view.gira-non-critical.getData',
                message: 'An error was thrown while prefetching issue gira non critical data',
                name: 'ResourceError'
            }, error);
        }
    };
});
parcelRegister("1O6Hj", function(module, exports) {
    $parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", ()=>$6bf108f87308d37b$export$f382deefb24f95ae);
    $parcel$export(module.exports, "fetchIssueGiraNonCriticalData", ()=>$6bf108f87308d37b$export$58a9221a6c5306db);
    var $jJZqs;
    var $c6dax;
    var $gXz4p;
    var $iBOrg;
    const $6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
        const errorMessageItem = errorMessage != null ? {
            errorMessage: errorMessage
        } : {};
        const traceIdItem = traceId != null ? {
            traceId: traceId
        } : {};
        return {
            experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
            wasExperienceSuccesful: wasExperienceSuccessful,
            analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
            additionalAttributes: {
                method: 'GET',
                ...errorMessageItem,
                ...traceIdItem
            },
            application: null,
            edition: null
        };
    };
    const $6bf108f87308d37b$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)($6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription({
            wasExperienceSuccessful: wasExperienceSuccessful,
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.message != null ? {
                errorMessage: error.message
            } : {},
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.traceId != null ? {
                traceId: error.traceId
            } : {},
            isEarlyFetch: isEarlyFetch
        }));
    };
    const $6bf108f87308d37b$export$58a9221a6c5306db = async (issueKey)=>{
        const variables = {
            issueKey: issueKey
        };
        const payload = {
            query: (0, (0, parcelRequire("c6dax")).buildNonCriticalGiraQuery)(),
            variables: variables,
            operationName: (0, (0, parcelRequire("c6dax")).ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
        };
        try {
            const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query(payload);
            $6bf108f87308d37b$export$f382deefb24f95ae({
                wasExperienceSuccessful: true,
                isEarlyFetch: false
            });
            return response;
        } catch (error) {
            $6bf108f87308d37b$export$f382deefb24f95ae({
                wasExperienceSuccessful: false,
                isEarlyFetch: false,
                error: error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : undefined
            });
            throw error;
        }
    };
});
parcelRegister("c6dax", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", ()=>$b74efd74d6a135cc$export$857f1602ca5b9d99);
    $parcel$export(module.exports, "buildNonCriticalGiraQuery", ()=>$b74efd74d6a135cc$export$df3c3aa9d6d3f431);
    $parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", ()=>$b74efd74d6a135cc$export$555194bfc9159fa3);
    var $jzVvW;
    const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
    const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, (0, parcelRequire("jzVvW")).getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
    const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
            method: 'POST',
            body: JSON.stringify({
                operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
                query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
});
parcelRegister("jzVvW", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$8b485783ca3ced28$export$edefef8c65e08bd2);
    const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;
});
parcelRegister("gXz4p", function(module, exports) {
    $parcel$export(module.exports, "sendExperienceAnalytics", ()=>$b28eb6b892a8c2f7$export$4a95ada1b8228562);
    var $1UikQ = parcelRequire("1UikQ");
    var $aiwW2;
    var $hh0bW;
    var $j8DrX;
    const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
        const additionalContext = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        const region = (0, (0, parcelRequire("j8DrX")).default)('ajs-region');
        Object.assign(additionalContext, {
            shard: shard,
            region: region
        });
        const enabledFeatureFlags = Object.fromEntries([
            ...(0, (0, parcelRequire("aiwW2")).allFeatureFlagsAccessed)
        ].filter(([, value])=>value));
        Object.assign(additionalContext, {
            enabledFeatureFlags: enabledFeatureFlags
        });
        const synthetics = {
            additionalAttributes: {
                synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
                ...additionalContext
            }
        };
        (0, ($parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
        (0, (0, parcelRequire("hh0bW")).default)(experienceDescription);
    }
});
parcelRegister("hh0bW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8a1e19e7613048$export$2e2bcd8739ae039);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6c8a1e19e7613048$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
        if (action !== undefined) return action;
        return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
    };
    const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                ...location ? {
                    reason: location
                } : {},
                ...field ? {
                    field: field
                } : {},
                ...typeof hasEdit === 'boolean' ? {
                    hasEdit: hasEdit
                } : {},
                analyticsSource: analyticsSource,
                application: $6c8a1e19e7613048$var$transformApplication(application),
                edition: $6c8a1e19e7613048$var$transformEdition(edition)
            }
        });
    var $6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
});
parcelRegister("bmvW5", function(module, exports) {
    $parcel$export(module.exports, "issueMediaReadPermissionResource", ()=>$2368cab4ab12a1eb$export$3b5744f70b49a5c4);
    var $2M1hQ;
    var $5XgeZ;
    const $2368cab4ab12a1eb$export$3b5744f70b49a5c4 = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_READ_PERM',
        getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
        getData: ()=>null,
        isBrowserOnly: true
    }));
});
parcelRegister("eqN9Q", function(module, exports) {
    $parcel$export(module.exports, "issueMediaUploadPermissionResource", ()=>$018bbab5966993b0$export$80c2a5c658bd9e1e);
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    const $018bbab5966993b0$export$80c2a5c658bd9e1e = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_UPLOAD_PERM',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: ()=>null,
        isBrowserOnly: true
    }));
});
parcelRegister("jdjBW", function(module, exports) {
    $parcel$export(module.exports, "issueMediaUserAuthResource", ()=>$c6e148d80f21d036$export$48db4eb29e9be72c);
    var $2Yhep;
    var $2M1hQ;
    var $5XgeZ;
    const $c6e148d80f21d036$export$48db4eb29e9be72c = (0, (0, parcelRequire("2M1hQ")).createResource)((0, (0, parcelRequire("5XgeZ")).withResourceEarlyData)({
        type: 'ISSUE_MEDIA_USER_AUTH',
        getKey: ({ match: match })=>{
            const issueKey = (0, (0, parcelRequire("2Yhep")).getIssueKey)(match);
            return issueKey || '';
        },
        getData: ()=>null,
        isBrowserOnly: true
    }));
});
parcelRegister("1aAOt", function(module, exports) {
    $parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", ()=>$3095ecb31c5b9ef2$export$d08a9fee651d30b2);
    var $2M1hQ;
    const $3095ecb31c5b9ef2$var$getDataLoader = ()=>(parcelRequire("hPMz6"));
    const $3095ecb31c5b9ef2$export$ec991c565cf31550 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $2e493fb3532188a0$export$23978b67a6b2068f),
        getKey: ()=>'state',
        getDataLoader: $3095ecb31c5b9ef2$var$getDataLoader,
        maxAge: 1800000
    });
    const $3095ecb31c5b9ef2$export$d08a9fee651d30b2 = ()=>[];
});
const $2e493fb3532188a0$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';
parcelRegister("hPMz6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fsHbN").then(()=>parcelRequire('8OVUQ'));
});
parcelRegister("1WlLE", function(module, exports) {
    $parcel$export(module.exports, "queuesNavigationItems", ()=>$c68314f43531feff$export$4fed8be571897bef);
    $parcel$export(module.exports, "priorityGroupResource", ()=>$c68314f43531feff$export$1f9ab301771fe42e);
    $parcel$export(module.exports, "issueListSsrResource", ()=>$c68314f43531feff$export$3d03cbaac8581e65);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $2M1hQ;
    var $8w6CZ;
    const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("dxxie"));
    const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("jyy5p"));
    const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("9mhm7"));
    const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, ($parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
    const $c68314f43531feff$export$4fed8be571897bef = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS)
    });
    const $c68314f43531feff$export$1f9ab301771fe42e = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS),
        isBrowserOnly: true
    });
    const $c68314f43531feff$export$3d03cbaac8581e65 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
        getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
        getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
        maxAge: 0,
        skipBrowser: true
    });
});
parcelRegister("8w6CZ", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", ()=>$a4c66eaf20e13a4d$export$a401e6d6b205c72b);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", ()=>$a4c66eaf20e13a4d$export$2064262c540606ba);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", ()=>$a4c66eaf20e13a4d$export$2733615da5b906f0);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$a4c66eaf20e13a4d$export$5a00268156ea5027);
    const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
    const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
    const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
    const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;
});
parcelRegister("dxxie", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("fYHqp")
    ]).then(()=>parcelRequire('lini2'));
});
parcelRegister("jyy5p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2mLKW").then(()=>parcelRequire('etJR3'));
});
parcelRegister("9mhm7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jmkWj").then(()=>parcelRequire('bmzqI'));
});
parcelRegister("fjoQ1", function(module, exports) {
    $parcel$export(module.exports, "browseIssueEmbedRoute", ()=>$1c5f13cdd9ba8bf4$export$240aeec71c480594);
    var $65Ltd;
    const $1c5f13cdd9ba8bf4$export$240aeec71c480594 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED),
        path: '/browse/:issueKey(\\w+-\\d+)/embed'
    };
});
parcelRegister("fw7Rx", function(module, exports) {
    $parcel$export(module.exports, "browseIssueRoute", ()=>$b546ef0893c1765d$export$2c9c7e50a88e588b);
    var $65Ltd;
    const $b546ef0893c1765d$export$2c9c7e50a88e588b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
        query: [
            'filter?!=(.*)',
            'jql?!=(.*)'
        ]
    };
});
parcelRegister("gRzZD", function(module, exports) {
    $parcel$export(module.exports, "workspaceResource", ()=>$d68afc54033ea939$export$2f02c3f971168d17);
    var $2M1hQ;
    var $ahEft;
    const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
    const $d68afc54033ea939$export$2f02c3f971168d17 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
        getKey: ()=>'state',
        getData: async (_, routerContext)=>{
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(_, routerContext);
            return workspaceId;
        },
        maxAge: Infinity
    });
});
parcelRegister("ahEft", function(module, exports) {
    $parcel$export(module.exports, "isPremiumInstance", ()=>$b8bed038f2dce149$export$abb609d3bcbb74f6);
    $parcel$export(module.exports, "isLicensedPremiumUser", ()=>$b8bed038f2dce149$export$d7b4c32773b1c643);
    $parcel$export(module.exports, "default", ()=>$b8bed038f2dce149$export$2e2bcd8739ae039);
    var $dJl1T;
    var $4VpwK;
    var $ktP1V;
    var $5Ny9E;
    var $ldyPw;
    const $b8bed038f2dce149$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
    const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
        const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
        const isPremium = serviceDeskAppEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
        return isPremium;
    };
    const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
        const { appPermissions: appPermissions } = tenantContext;
        const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
        const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
        return isPremium && isLicensedUser;
    };
    const $b8bed038f2dce149$var$transformResponse = (response)=>{
        const ids = response.results ?? [];
        return ids.length ? (0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(ids[0].id) : null;
    };
    const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)()) return null;
        return (0, (0, parcelRequire("4VpwK")).performCmdbGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
            return null;
        });
    };
    var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;
});
parcelRegister("4VpwK", function(module, exports) {
    $parcel$export(module.exports, "performCmdbGetRequest", ()=>$270bf98960acb19c$export$a252413f43ec7247);
    $parcel$export(module.exports, "performCmdbPostRequest", ()=>$270bf98960acb19c$export$d68a9f67166d25a2);
    $parcel$export(module.exports, "performCmdbPutRequest", ()=>$270bf98960acb19c$export$326b7407f501f98b);
    $parcel$export(module.exports, "performCmdbDeleteRequest", ()=>$270bf98960acb19c$export$b198eb14f22c12e6);
    var $aDvGo;
    var $4R6GH;
    var $eusud;
    const $270bf98960acb19c$export$d5e211a0106aa636 = {
        'X-Request-Source': 'cmdb-frontend'
    };
    const $270bf98960acb19c$export$a252413f43ec7247 = (url, options)=>(0, (0, parcelRequire("eusud")).performGetRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$d68a9f67166d25a2 = (url, options)=>(0, (0, parcelRequire("eusud")).performPostRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$326b7407f501f98b = (url, options)=>(0, (0, parcelRequire("eusud")).performPutRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$b198eb14f22c12e6 = (url, options)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(options));
    const $270bf98960acb19c$export$235b7fc70b9fc359 = (options)=>(0, (0, parcelRequire("4R6GH")).fg)('fly-2529-cmdb-client-send-request-source-header') ? {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options,
            headers: {
                ...(0, (0, parcelRequire("aDvGo")).default).headers,
                ...options?.headers,
                ...$270bf98960acb19c$export$d5e211a0106aa636
            }
        } : options;
});
parcelRegister("ktP1V", function(module, exports) {
    $parcel$export(module.exports, "isCMDBEnabledInEnvironment", ()=>$84a32a7226f836c4$export$6dbfb62369f79a64);
    var $1WqFo;
    const $84a32a7226f836c4$export$6dbfb62369f79a64 = ()=>!(0, (0, parcelRequire("1WqFo")).isFedRamp)();
});
parcelRegister("5Ny9E", function(module, exports) {
    $parcel$export(module.exports, "toSchemaId", ()=>$a330a4171d28d64c$export$d577b7f3b832f656);
    $parcel$export(module.exports, "toCmdbObjectId", ()=>$a330a4171d28d64c$export$1ba342595bc7be13);
    $parcel$export(module.exports, "toCmdbObjectTypeId", ()=>$a330a4171d28d64c$export$b46e25afa2bab6a);
    $parcel$export(module.exports, "toObjectCommentId", ()=>$a330a4171d28d64c$export$ece2917434bb0a8c);
    $parcel$export(module.exports, "toWorkspaceId", ()=>$a330a4171d28d64c$export$d002b8d7821b6b59);
    $parcel$export(module.exports, "toObjectTypeAttributeId", ()=>$a330a4171d28d64c$export$cfd92c18cee8add7);
    const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
    const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
    const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
    const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
    const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
    const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;
});
parcelRegister("c65JB", function(module, exports) {
    $parcel$export(module.exports, "IssueViewSkeleton", ()=>$10d0ed34bb3215dd$export$49addbcdecb6e6ff);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iMqhh;
    var $gnABE;
    var $gERis = parcelRequire("gERis");
    const $10d0ed34bb3215dd$var$fullpageStyles = null;
    const $10d0ed34bb3215dd$var$modalStyles = null;
    const $10d0ed34bb3215dd$var$customSpacingStyles = null;
    const $10d0ed34bb3215dd$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
        const customCss = [
            $10d0ed34bb3215dd$var$customSpacingStyles,
            isEmbedView !== true && isModalView !== true ? $10d0ed34bb3215dd$var$fullpageStyles : null,
            isModalView === true ? $10d0ed34bb3215dd$var$modalStyles : null
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMqhh")).CompactModeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gERis))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
                isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
                isModalView === true && "_19pk10j7"
            ])
        }));
    };
});
parcelRegister("iMqhh", function(module, exports) {
    $parcel$export(module.exports, "CompactModeContext", ()=>$db79d17d45755de5$export$37eeac5cc5245b18);
    $parcel$export(module.exports, "CompactModeProvider", ()=>$db79d17d45755de5$export$10cf42790e523b8e);
    $parcel$export(module.exports, "CompactModeConsumer", ()=>$db79d17d45755de5$export$20feb77b5b617e44);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8kj45;
    var $doZTA;
    var $hhMVP;
    const $db79d17d45755de5$export$37eeac5cc5245b18 = (0, $5uXOq.createContext)(false);
    const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
    const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
    const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
    function $db79d17d45755de5$var$useRouteKey() {
        const [routeState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { match: { path: path, params: params } } = routeState;
        const hasIssueKey = params?.issueKey !== undefined;
        return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
    }
    const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
        const key = $db79d17d45755de5$var$useRouteKey();
        (0, (0, parcelRequire("hhMVP")).invalidateCacheIfRouteChanged)(key);
        let defaultState = (0, (0, parcelRequire("hhMVP")).getCachedIsCompactValue)(key);
        if (defaultState === undefined) {
            defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
            (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(defaultState, key);
        }
        const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8kj45")).ContainerQueryObserver), {
            query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
            onChange: (state)=>{
                (0, (0, parcelRequire("hhMVP")).setCachedIsCompactValue)(state, key);
                setIsCompact(state);
            },
            defaultState: defaultState
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
            value: isCompact
        }, children));
    };
    const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
    const $db79d17d45755de5$var$StyledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;
parcelRegister("8kj45", function(module, exports) {
    $parcel$export(module.exports, "ContainerQueryObserver", ()=>$ed10e3c030ea0408$export$e9574287678b8467);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ed10e3c030ea0408$var$QueryContext = (0, $5uXOq.createContext)(undefined);
    let $ed10e3c030ea0408$var$currentIdSeed = 0;
    function $ed10e3c030ea0408$var$generateAttributeValue() {
        return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
    }
    function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
        const [active, setActive] = (0, $5uXOq.useState)(defaultState);
        const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
            onChange?.(isContainerQueryActive);
            setActive(isContainerQueryActive);
        }, [
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
            value: active
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
            query: query,
            notifyIntersectionStatusChanged: handleQueryStatusChange
        }), children);
    }
    function $ed10e3c030ea0408$export$b66a67697973e01() {
        const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
        if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
        return currentState;
    }
    function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
        const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
        const spanRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const queryStatusChangedCallback = (entries)=>{
                if (!containerRef.current || containerRef.current.clientWidth === 0) return;
                if (entries.length > 0) {
                    const isContainerQueryActive = entries[0].isIntersecting;
                    if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
                }
            };
            const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
            const spanElement = spanRef.current;
            spanElement && intersectionObserver.observe(spanElement);
            return ()=>{
                spanElement && intersectionObserver.unobserve(spanElement);
                intersectionObserver.disconnect();
            };
        }, [
            currentState,
            handleChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
            ref: containerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            type: "text/css"
        }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ref: spanRef,
            "data-container-query-indicator-id": attributeValue
        }));
    }
    const $ed10e3c030ea0408$var$ContainerToBeQueried = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hhMVP", function(module, exports) {
    $parcel$export(module.exports, "getCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$c47621d55d10906c);
    $parcel$export(module.exports, "setCachedIsCompactValue", ()=>$cd61c7d28b4f2500$export$568b2dd75c2027b4);
    $parcel$export(module.exports, "invalidateCacheIfRouteChanged", ()=>$cd61c7d28b4f2500$export$a81477a3594bcaab);
    const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
    let $cd61c7d28b4f2500$var$previousRouteKey;
    function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
        return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
    }
    function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
        $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
    }
    function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
        if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
            $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
            delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
        }
    }
});
parcelRegister("gnABE", function(module, exports) {
    $parcel$export(module.exports, "AppSkeletonImage", ()=>$93b95cd5afe27e51$export$45b107c5dc7b51a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $le2LN;
    var $koVbs;
    var $d0Ozr;
    const $93b95cd5afe27e51$var$skeletonImageStyles = null;
    const $93b95cd5afe27e51$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("le2LN")).default), {
            name: "app-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($93b95cd5afe27e51$var$SkeletonWrapper, {
            style: containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: src,
            alt: `${formatMessage((0, (0, parcelRequire("d0Ozr")).default).loading)}...`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
                className
            ])
        })));
    };
    const $93b95cd5afe27e51$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d0Ozr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6abc81adadf77f72$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loading: {
            "id": "skeletons.common.loading",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("gERis", function(module, exports) {
    module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();
});
parcelRegister("5j7Th", function(module, exports) {
    $parcel$export(module.exports, "LazyPage", ()=>$63937a96c08aaddb$export$a18c9c3dd309b8e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $lfTZh;
    var $6jY6G;
    var $7LpuY;
    var $dZw8H;
    const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
    const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
    const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const Skeleton = route.skeleton || (shouldShowSpinner ? (0, (0, parcelRequire("kb4zh")).default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page_redirect",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null))));
    };
});
parcelRegister("kb4zh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26967b2e10d397c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $le2LN;
    var $9MjbF;
    function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("le2LN")).default), {
            name: "legacy-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MjbF")).default), {
            size: "large",
            testId: testId
        }))));
    }
    const $c26967b2e10d397c$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $c26967b2e10d397c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7LpuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c62dfc18679e80c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $bNvU3;
    var $7N30e;
    var $6b6Tk;
    var $8Qrwl;
    var $hXKq5;
    class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { children: children, pageId: pageId } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Qrwl")).default).Provider, {
                value: {
                    pageId: pageId,
                    onReady: this.onReady,
                    onCustomMark: this.onCustomMark
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: this.onStart,
                args: [
                    pageId
                ]
            }), children));
        }
        constructor(...args){
            super(...args), this.customMarks = [], this.onStart = ()=>{
                (0, (0, parcelRequire("kUU4G")).default)((0, $ce556f125dee8174$export$56940a9488e85199));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
            }, this.onCustomMark = (markName)=>{
                (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)(markName));
                this.customMarks.push(markName);
            }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
                metric.stop({
                    customData: extra
                });
                if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
            };
        }
    }
});
parcelRegister("kUU4G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb4d2f8b5a69f79$export$2e2bcd8739ae039);
    var $6RCeq;
    var $6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
        if ((0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).getEntries && (0, (0, parcelRequire("6RCeq")).default).clearMarks) return (0, (0, parcelRequire("6RCeq")).default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
            (0, (0, parcelRequire("6RCeq")).default).clearMarks(mark.name);
            return mark;
        });
        return [];
    };
});
parcelRegister("bNvU3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c14e3adf575574$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    class $96c14e3adf575574$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        shouldComponentUpdate(nextProps) {
            return !(0, ($parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
        }
        componentDidUpdate() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $96c14e3adf575574$export$2e2bcd8739ae039 = $96c14e3adf575574$var$OpTrigger;
});
parcelRegister("7N30e", function(module, exports) {
    $parcel$export(module.exports, "stopLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$a928755af449867);
    $parcel$export(module.exports, "startLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$8bb8df5a93e9525);
    $parcel$export(module.exports, "default", ()=>$5d68e3874efadecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $3vBBc;
    var $fjcgS;
    var $lsa9q;
    var $6b6Tk;
    const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
    let $5d68e3874efadecb$var$stopDelayTimeout;
    let $5d68e3874efadecb$var$lastDelayActionPromise = (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
    const $5d68e3874efadecb$export$a928755af449867 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) return client;
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(false);
            client.stopLowPriorityEventDelay();
            return client;
        });
    };
    const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) {
                (0, (0, parcelRequire("kUU4G")).default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
            }
            client.startLowPriorityEventDelay();
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(true);
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
            return client;
        });
    };
    const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
    const $5d68e3874efadecb$var$EventDelayController = ()=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!loadedState.hasLoaded && (0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;
});
parcelRegister("3vBBc", function(module, exports) {
    $parcel$export(module.exports, "setEventDelayActive", ()=>$63f3b8c0745d0500$export$9a4add6d6ddcc1a);
    $parcel$export(module.exports, "isEventDelayActive", ()=>$63f3b8c0745d0500$export$3536b0184fa98d19);
    let $63f3b8c0745d0500$var$eventDelayActive = false;
    const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
        $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
    };
    const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;
});
parcelRegister("lsa9q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f20cb56a66aca22$export$2e2bcd8739ae039);
    var $3sQ5x;
    var $7w9eZ;
    const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        const determineHasLoaded = ()=>{
            if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
            return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
        };
        const hasLoaded = determineHasLoaded();
        return {
            hasLoaded: hasLoaded
        };
    };
    const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
    });
    var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;
});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';
const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("8Qrwl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87d05828c384551$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
    var $d87d05828c384551$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);
});
parcelRegister("hXKq5", function(module, exports) {
    $parcel$export(module.exports, "getPrefixedMarkName", ()=>$f6cddc52a08e036c$export$c8f0e9837e7e9425);
    const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;
});
parcelRegister("dZw8H", function(module, exports) {
    $parcel$export(module.exports, "SpaStateContainer", ()=>$b1cd152eb196251c$export$e9a92b877fe80e80);
    $parcel$export(module.exports, "SpaStateAppStart", ()=>$b1cd152eb196251c$export$d18dd27183a635c);
    $parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", ()=>$b1cd152eb196251c$export$95a2912d76fb5433);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$b1cd152eb196251c$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$b1cd152eb196251c$export$41e70078eeddaddc);
    $parcel$export(module.exports, "SpaStatePageErrorReady", ()=>$b1cd152eb196251c$export$2583aa269898885c);
    $parcel$export(module.exports, "getSpaStateLastUserLocation", ()=>$b1cd152eb196251c$export$6e9ab893e97cccef);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $lODMY;
    var $gg7kZ;
    var $3sQ5x;
    var $bKpgX;
    var $4oDnX;
    var $7w9eZ;
    const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("7w9eZ")).default));
    const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, (0, parcelRequire("4oDnX")).useSpaState)();
        (0, $5uXOq.useMemo)(()=>{
            startRef.current = Date.now();
        }, [
            visitedPages
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStart(startRef.current);
        }, [
            setAppStart,
            visitedPages
        ]);
        return null;
    };
    const $b1cd152eb196251c$var$useRouterMatchSelector = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.match);
    const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: ({ visitedPages: visitedPages })=>visitedPages.length
    });
    const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
        const match = $b1cd152eb196251c$var$useRouterMatchSelector();
        const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
            visitedPagesLength: count,
            onSetAppStart: setAppStart,
            match: match
        });
    };
    const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady
            }));
    const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady,
                args: comparer
            }));
    const $b1cd152eb196251c$export$2583aa269898885c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppErrorReady
            }));
    class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
            const matchHasChanged = props.match !== state.match;
            const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
            if (setAppStart) props.onSetAppStart(Date.now());
            if (setAppStart || !visitedPageLengthHasChanged) return {
                started: true,
                visitedPagesLength: props.visitedPagesLength,
                match: props.match
            };
            return state;
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args), this.state = {
                visitedPagesLength: 0,
                started: false,
                match: null
            };
        }
    }
    const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
        const { visitedPages: visitedPages } = (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore((0, (0, parcelRequire("7w9eZ")).default)).storeState.getState();
        return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
    };
});
parcelRegister("4oDnX", function(module, exports) {
    $parcel$export(module.exports, "SpaStateSubscriber", ()=>$363cd3235a9267e4$export$fd52daf2a3c1ec68);
    $parcel$export(module.exports, "SpaStateActionsSubscriber", ()=>$363cd3235a9267e4$export$3dfa91988c213fbc);
    $parcel$export(module.exports, "useSpaState", ()=>$363cd3235a9267e4$export$a57865516f6345d1);
    $parcel$export(module.exports, "useSpaStateActions", ()=>$363cd3235a9267e4$export$b134752525935b78);
    var $3sQ5x;
    var $51nlc;
    var $7w9eZ;
    const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
    const $363cd3235a9267e4$export$a57865516f6345d1 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$b134752525935b78 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
});
parcelRegister("ghGCX", function(module, exports) {
    $parcel$export(module.exports, "legacyRedirectRouteEntry", ()=>$c46fefae40525649$export$27f123cb9320355);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $7v7WP;
    var $3mK2k;
    const $c46fefae40525649$var$RedirectComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3mK2k")).default), null);
    const $c46fefae40525649$export$27f123cb9320355 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7v7WP")).legacyRedirectRoute), ()=>({
            component: $c46fefae40525649$var$RedirectComponent,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [],
            isRedirect: true,
            canTransitionIn: ()=>false,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("7v7WP", function(module, exports) {
    $parcel$export(module.exports, "legacyRedirectRoute", ()=>$5ce80937ea4d4231$export$176ff76c3ba7c4ce);
    var $65Ltd;
    const $5ce80937ea4d4231$export$176ff76c3ba7c4ce = {
        path: '',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REDIRECT),
        exact: false
    };
});
parcelRegister("3mK2k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1513009dd97e8af4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $fpTxz;
    var $dMnMc;
    var $dJl1T;
    var $34Vv8;
    var $j8DrX;
    var $8zOmE;
    var $1bQGJ;
    var $883db;
    const $1513009dd97e8af4$var$THRESHOLD = 30000;
    const $1513009dd97e8af4$var$getScopeType = (scope)=>{
        switch(scope.identifierType){
            case 'boardId':
                return 'board';
            case 'projectId':
            case 'projectKey':
                return scope.pageType === 'settings' ? 'projectSettings' : 'project';
            default:
                return '';
        }
    };
    class $1513009dd97e8af4$export$836fe1ef2cfde075 extends (0, $5uXOq.Component) {
        componentDidMount() {
            (0, (0, parcelRequire("gKZoD")).di)(sessionStorage, window);
            const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
            const lastRedirectTime = Number(sessionStorage.getItem(redirectPathname));
            if (!lastRedirectTime) sessionStorage.setItem(redirectPathname, Date.now().toString());
            else if (Date.now() - lastRedirectTime < $1513009dd97e8af4$var$THRESHOLD) {
                const scopeData = (0, (0, parcelRequire("dMnMc")).default)(window.location.href, (0, (0, parcelRequire("j8DrX")).default));
                const scope = $1513009dd97e8af4$var$getScopeType(scopeData);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                    scope: scope
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'entered'
                }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                    scope: scope
                });
                flagService.showFlag((0, (0, parcelRequire("883db")).errorFlag)());
                sessionStorage.removeItem(redirectPathname);
                return;
            } else sessionStorage.removeItem(redirectPathname);
            window.location.assign(redirectPathname + search);
        }
        render() {
            return null;
        }
    }
    var $1513009dd97e8af4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)((0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("fpTxz")).default)()($1513009dd97e8af4$export$836fe1ef2cfde075)));
});
parcelRegister("dMnMc", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$fe24052863a91d57$export$557c2f222778cea6);
    $parcel$export(module.exports, "default", ()=>$fe24052863a91d57$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    var $95bh0;
    var $556I0;
    var $5PyNy;
    var $79s9E;
    const $fe24052863a91d57$var$projectScopeDataMap = {
        routes: [
            /[&?]projectKey=(\w+)/i,
            /\/projects\/(\w+)/i,
            /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
            /\/plugins\/servlet\/project-config\/(\w+)/i,
            /\/servicedesk\/admin\/(\w+)/i,
            /\/browse\/(\w+)\/?(\?.*)?$/i
        ],
        meta: [
            'ghx-project-key',
            'projectKey',
            'ajs-project-key'
        ]
    };
    const $fe24052863a91d57$var$getProjectId = (url)=>{
        const projectIdRoutes = [
            /[&?]selectedProjectId=(\w+)/i,
            /[&?]pid=(\w+)/i,
            /[&?]projectId=(\w+)/i,
            /[&?]project\.id=(\w+)/i
        ];
        return projectIdRoutes.reduce((foundId, route)=>{
            if (foundId) return foundId;
            const match = url.match(route);
            if (match != null) {
                const [, projectId] = match;
                if (projectId) return projectId;
            }
            return null;
        }, null);
    };
    const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
        let projectKey = null;
        $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
            const value = getMeta(tagName);
            if (value && projectKey == null) projectKey = value;
        });
        $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
            const match = url.match(route);
            if (match != null && projectKey == null) [, projectKey] = match;
        });
        return projectKey || undefined;
    };
    const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
        try {
            const parsed = (0, ($parcel$interopDefault($aZsz6)))(url, true);
            let boardId = parsed.query ? parsed.query.rapidView : null;
            if (boardId == null) {
                const match = url.match(/\/boards\/(\d+)/i);
                boardId = match ? match[1] : null;
            }
            return boardId;
        } catch (err) {
            return null;
        }
    };
    const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, (0, parcelRequire("556I0")).default).some((regex)=>regex.test(url)) || (0, (0, parcelRequire("5PyNy")).default).some((regex)=>regex.test(url));
    const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
        const isProject = ()=>{
            const routes = [
                /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
                /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
                /\/secure\/ReleaseNote.jspa.+projectId/i,
                /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
            ];
            return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
                getMeta: getMeta,
                url: url
            }) || routes.some((regex)=>regex.test(url));
        };
        return projectKey || projectId && isProject();
    };
    const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, (0, parcelRequire("79s9E")).default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        });
    const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
        if ($fe24052863a91d57$var$isProjectSettingsPage({
            getMeta: getMeta,
            url: url
        })) return 'settings';
        const decorator = getMeta('decorator');
        const isSettings = getMeta('is-settings-page') === 'true';
        return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
    };
    var $fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
        const extractedData = {};
        const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
        if (boardId) extractedData.boardId = boardId;
        const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
        if (projectKey) extractedData.projectKey = projectKey;
        const projectId = $fe24052863a91d57$var$getProjectId(url);
        if (projectId) extractedData.projectId = projectId;
        const isProject = $fe24052863a91d57$var$isProjectPage({
            getMeta: getMeta,
            projectId: projectId,
            projectKey: projectKey,
            url: url
        });
        extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
        const identifier = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            boardId: boardId,
            projectKey: projectKey,
            projectId: isProject ? projectId : null
        });
        return {
            ...extractedData,
            ...identifier
        };
    };
});
parcelRegister("556I0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
    var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
    ];
});
parcelRegister("5PyNy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d489e15712c5e17$export$2e2bcd8739ae039);
    var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
    ];
});
parcelRegister("79s9E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efe7a2022eaf0f59$export$2e2bcd8739ae039);
    var $5PyNy;
    const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
        /\/plugins\/servlet\/project-config/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
        /\/plugins\/servlet\/project-config\/.+\/fields/i,
        /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
        /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
        /\/plugins\/servlet\/project-config\/.+\/notifications/i,
        /\/plugins\/servlet\/project-config\/.+\/permissions/i,
        /\/plugins\/servlet\/project-config\/.+\/screens/i,
        /\/plugins\/servlet\/project-config\/.+\/workflows/i,
        /\/project\/DeleteProject!default\.jspa/i,
        /\/secure\/project\/EditProject!default\.jspa/i,
        /\/secure\/AddCollector/i,
        /\/secure\/InsertCollectorHelp/i,
        /\/ViewCollector!default\.jspa\?projectKey=/i,
        /\/ViewCollectors!default\.jspa\?projectKey=/i,
        /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
        /\/InstallHipChat\.jspa\?projectKey=/i,
        /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
    ];
    var $efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
        ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
        /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
        ...(0, (0, parcelRequire("5PyNy")).default),
        /\/servicedesk\/admin\/(\w+)/i,
        /\/projects\/\w+\/settings(\/\w+)*/i
    ];
});
parcelRegister("34Vv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$827c4d80e4d41b48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                flagService: (0, (0, parcelRequire("pa9q9")).flagService)
            });
    };
    var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;
});
parcelRegister("883db", function(module, exports) {
    $parcel$export(module.exports, "errorFlag", ()=>$d8474afc40da2ee0$export$b9a7f1ebeaa76953);
    var $dGrvr;
    const $d8474afc40da2ee0$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            title: (0, (0, parcelRequire("dGrvr")).messages).title,
            description: (0, (0, parcelRequire("dGrvr")).messages).description,
            actions: [
                {
                    content: (0, (0, parcelRequire("dGrvr")).messages).goHome,
                    onClick: ()=>window.location.assign('/')
                }
            ]
        });
});
parcelRegister("dGrvr", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1d710f8117ed7a9a$export$defe85febe8b728c);
    var $7VHMR;
    const $1d710f8117ed7a9a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "redirect.legacy-routing.flags.error.title",
            "defaultMessage": "We can't find the page you're looking for"
        },
        description: {
            "id": "redirect.legacy-routing.flags.error.description",
            "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
        },
        goHome: {
            "id": "redirect.legacy-routing.flags.error.go-home",
            "defaultMessage": "Go to the homepage"
        }
    });
});
parcelRegister("gGB8S", function(module, exports) {
    $parcel$export(module.exports, "startJiraSpa", ()=>$2f70583cb46f9994$export$f71867a5b2484020);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3NMrl = parcelRequire("3NMrl");
    var $kUr4d = parcelRequire("kUr4d");
    var $cgkki;
    var $9X2lg;
    var $1qZQE;
    var $hpxZY;
    var $8luMn;
    var $19hl5;
    var $k4NnA;
    var $aTq2A;
    var $87OsA;
    parcelRequire("2YzDH");
    var $x9xyg;
    var $4Pf62;
    var $frBVt;
    var $7CMCs;
    var $6s1PB;
    var $7bkFJ;
    var $4R6GH;
    var $fz3fB;
    var $kZBXc;
    var $cfDZ3;
    var $6jY6G;
    var $5eQ1m;
    var $81ezV;
    var $b7awD;
    var $d1K1f;
    var $2SVPM;
    var $fGcGc;
    var $bShz7;
    var $lbyb6;
    var $5HG6S;
    var $29g8C;
    var $kKlrY;
    var $l8ruj;
    var $3qHVS;
    var $dYcrb;
    var $6MBHi;
    var $2Gs5h;
    var $lVJAU;
    var $lODMY;
    var $5GhjE;
    var $2ChuC = parcelRequire("2ChuC");
    (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_LOADED');
    window.__SPA__ = true;
    (0, (0, parcelRequire("dYcrb")).LooselyLazy).init({
        mode: (0, (0, parcelRequire("6MBHi")).MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    const $2f70583cb46f9994$var$tenantContext = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
    (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/language-pack.start');
    var $hWnRN = parcelRequire("hWnRN");
    (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/language-pack.end');
    const { locale: $2f70583cb46f9994$var$locale } = $2f70583cb46f9994$var$tenantContext;
    const $2f70583cb46f9994$var$superbatchInit = ()=>{
        window.DeferScripts = {
            deferState: 'done'
        };
        document.body && document.body.classList.remove('deferred');
    };
    const $2f70583cb46f9994$var$globalSettingsArgs = {
        navigation: false,
        upflow: false
    };
    const $2f70583cb46f9994$var$InstallGlobalComponentsOnce = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, $2ChuC.default).installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))($2f70583cb46f9994$var$globalSettingsArgs, [
                'flags',
                'navigation',
                'renderNavigation'
            ]));
            (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
        }, []);
        return null;
    };
    const $2f70583cb46f9994$var$updateCapability = (capability)=>{
        (0, (0, parcelRequire("87OsA")).setCapability)(capability);
        if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
        else window.AJS?.$?.ajaxSetup({
            headers: {
                [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
            }
        });
    };
    const $2f70583cb46f9994$var$CapabilityTrackerConnector = ({ routes: routes })=>{
        const { registerBlock: registerBlock } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        registerBlock((nextLocation)=>{
            const nextMatchObject = (0, (0, parcelRequire("2Gs5h")).default)(routes, nextLocation.pathname, nextLocation.search, '');
            $2f70583cb46f9994$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
            return true;
        });
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        $2f70583cb46f9994$var$updateCapability(route.meta?.capability || null);
        return null;
    };
    const $2f70583cb46f9994$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav')) (0, (0, parcelRequire("9X2lg")).collectSSRPlaceholderDimensions)(document, window);
        (0, (0, parcelRequire("kKlrY")).default)();
        (0, (0, parcelRequire("aTq2A")).initBrowserMetrics3)();
        (0, (0, parcelRequire("7bkFJ")).initPlatformFeatureFlags)((0, (0, parcelRequire("3qHVS")).visualRefreshResolverOverride));
        (0, (0, parcelRequire("fGcGc")).addInitialPageLoadTimings)();
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
        (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/setup.start');
        const routes = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
        const history = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, (0, parcelRequire("lbyb6")).default)(routes));
        const initRoute = (0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
            const matchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(routes, window.location.pathname, window.location.search);
            (0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
            return matchedRoute;
        });
        if (initRoute != null) {
            const ufoName = (0, (0, parcelRequire("cgkki")).default)(initRoute.route);
            (0, (0, parcelRequire("1qZQE")).default)(ufoName, initRoute.route.name);
        }
        const BrowserMetricsConnector = ()=>{
            const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
            (0, (0, parcelRequire("19hl5")).browserMetrics).setRoute(route.name);
            (0, (0, parcelRequire("hpxZY")).useUFOTransitionCompleter)();
            (0, (0, parcelRequire("5GhjE")).GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
            return null;
        };
        (0, (0, parcelRequire("5GhjE")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
        const routerProps = {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: window.SPA_STATE,
            resourceContext: (0, (0, parcelRequire("5HG6S")).getSpaRouterContext)({
                tenantContext: $2f70583cb46f9994$var$tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, (0, parcelRequire("bShz7")).setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload && component.preload());
            }
        };
        let SpaClientRouter;
        if (typeof loadLazyRoutes === 'function') {
            const useRouterRoutes = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.routes);
            SpaClientRouter = ({ children: children })=>{
                const actions = (0, (0, parcelRequire("lODMY")).useRouterStoreActions)();
                const currentRoutes = useRouterRoutes();
                (0, $5uXOq.useEffect)(()=>{
                    let isCancelled = false;
                    const loadRoutes = async ()=>{
                        if (!isCancelled) {
                            const getLazyRoutes = await loadLazyRoutes();
                            await actions.setRoutes(getLazyRoutes());
                        }
                    };
                    loadRoutes();
                    return ()=>{
                        isCancelled = true;
                    };
                }, [
                    actions
                ]);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), routerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                    id: "spa-main.client-router",
                    packageName: "jiraEntry",
                    fallback: "unmount",
                    teamName: "delorean-spa"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                    routes: currentRoutes
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d1K1f")).default), null)), children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).NonCritical), {
                    id: "spa-main.client-router.non-critical",
                    teamName: "delorean-spa"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
            };
        } else SpaClientRouter = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), routerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                routes: routes
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d1K1f")).default), null)), children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
        const App = ({ placeholders: placeholders })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                name: "jira-spa"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholderContext).Provider, {
                value: placeholders
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZBXc")).Spa), {
                baseUrl: "",
                locale: $2f70583cb46f9994$var$locale,
                messages: $hWnRN,
                Router: SpaClientRouter,
                initRoute: initRoute,
                routes: routes,
                routerLinkComponent: (0, (0, parcelRequire("81ezV")).JiraRouterLinkConfiguration)
            }))));
        window.__NAV_VERSION__ = '3.0.0';
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
        (0, (0, parcelRequire("x9xyg")).setMark)('_jira-spa/spa-shell.start');
        const container = document.getElementById('jira-frontend');
        if (container) {
            (0, (0, parcelRequire("8luMn")).getVCObserver)().setSSRElement(container);
            (0, (0, parcelRequire("8luMn")).getVCObserver)().setReactRootRenderStart();
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    (0, (0, parcelRequire("8luMn")).getVCObserver)().setReactRootRenderStop();
                });
            });
            const placeholders = (0, (0, parcelRequire("frBVt")).getPlaceholdersFromHTML)();
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-concurrent-root-jira-spa') && true) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement(App, {
                placeholders: placeholders
            }), container);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-concurrent-root-jira-spa')) {
                const root = (0, $kUr4d.createRoot)(container);
                root.render((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, (0, parcelRequire("4R6GH")).fg)('concurrent-rendering-change-advisory') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29g8C")).ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null));
            }
        }
        (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        setTimeout(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
        });
        if ((0, (0, parcelRequire("6s1PB")).expVal)('uip_preprod_slow', 'value', 0) > 0) {
            (0, (0, parcelRequire("x9xyg")).setMark)('slow-start');
            const end = performance.now() + (0, (0, parcelRequire("6s1PB")).expVal)('uip_preprod_slow', 'value', 0);
            while(performance.now() < end);
            (0, (0, parcelRequire("x9xyg")).setMark)('slow-stop');
        }
        (0, $2ChuC.default).installHighPriorityApps((0, ($parcel$interopDefault($3NMrl)))($2f70583cb46f9994$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $2f70583cb46f9994$var$superbatchInit();
        return null;
    };
    const $2f70583cb46f9994$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
        return $2f70583cb46f9994$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, (0, parcelRequire("k4NnA")).reportBootstrapError)(reason));
    };
});
parcelRegister("fr1K2", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $7MmCC = parcelRequire("7MmCC");
    var $ftdKz = parcelRequire("ftdKz");
    var $etAYC = parcelRequire("etAYC");
    var $4NkAS = parcelRequire("4NkAS");
    var $b2dLE = parcelRequire("b2dLE");
    var $9SRAA = parcelRequire("9SRAA");
    var $7GWAt = parcelRequire("7GWAt");
    var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
    var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
        var result = {};
        if (object == null) return result;
        var isDeep = false;
        paths = $1nIHN(paths, function(path) {
            path = $etAYC(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
        });
        $4NkAS(object, $7GWAt(object), result);
        if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
        var length = paths.length;
        while(length--)$ftdKz(result, paths[length]);
        return result;
    });
    module.exports = $b3caba7e25e0a917$var$omit;
});
parcelRegister("ftdKz", function(module, exports) {
    var $etAYC = parcelRequire("etAYC");
    var $hYfgW = parcelRequire("hYfgW");
    var $8lSJl = parcelRequire("8lSJl");
    var $gzebZ = parcelRequire("gzebZ");
    function $b4343aeaece186b7$var$baseUnset(object, path) {
        path = $etAYC(path, object);
        object = $8lSJl(object, path);
        return object == null || delete object[$gzebZ($hYfgW(path))];
    }
    module.exports = $b4343aeaece186b7$var$baseUnset;
});
parcelRegister("8lSJl", function(module, exports) {
    var $fTwLR = parcelRequire("fTwLR");
    var $dM3Z8 = parcelRequire("dM3Z8");
    function $614abd39878e1d90$var$parent(object, path) {
        return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
    }
    module.exports = $614abd39878e1d90$var$parent;
});
parcelRegister("b2dLE", function(module, exports) {
    var $1QOns = parcelRequire("1QOns");
    function $808a8f8fca7f9ff7$var$customOmitClone(value) {
        return $1QOns(value) ? undefined : value;
    }
    module.exports = $808a8f8fca7f9ff7$var$customOmitClone;
});
parcelRegister("3NMrl", function(module, exports) {
    var $i2e26 = parcelRequire("i2e26");
    var $9SRAA = parcelRequire("9SRAA");
    var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
        return object == null ? {} : $i2e26(object, paths);
    });
    module.exports = $2c4b85df1af41471$var$pick;
});
parcelRegister("i2e26", function(module, exports) {
    var $4gaCO = parcelRequire("4gaCO");
    var $fh9gH = parcelRequire("fh9gH");
    function $d2134c8f0f8064b1$var$basePick(object, paths) {
        return $4gaCO(object, paths, function(value, path) {
            return $fh9gH(object, path);
        });
    }
    module.exports = $d2134c8f0f8064b1$var$basePick;
});
parcelRegister("kUr4d", function(module, exports) {
    $parcel$export(module.exports, "createRoot", ()=>$f38e08888af96a1f$export$882461b6382ed46c, (v)=>$f38e08888af96a1f$export$882461b6382ed46c = v);
    $parcel$export(module.exports, "hydrateRoot", ()=>$f38e08888af96a1f$export$757ceba2d55c277e, (v)=>$f38e08888af96a1f$export$757ceba2d55c277e = v);
    var $f38e08888af96a1f$export$882461b6382ed46c;
    var $f38e08888af96a1f$export$757ceba2d55c277e;
    'use strict';
    var $7nsd3 = parcelRequire("7nsd3");
    var $f38e08888af96a1f$var$i;
    $f38e08888af96a1f$export$882461b6382ed46c = $7nsd3.createRoot;
    $f38e08888af96a1f$export$757ceba2d55c277e = $7nsd3.hydrateRoot;
});
parcelRegister("cgkki", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$604d94fb26d2d27f$export$2e2bcd8739ae039);
    function $604d94fb26d2d27f$export$2e2bcd8739ae039(route) {
        if (route.ufoName != null) return route.ufoName;
        return route.name;
    }
});
parcelRegister("9X2lg", function(module, exports) {
    $parcel$export(module.exports, "collectSSRPlaceholderDimensions", ()=>$124dc2b2e19e1fc3$export$aee7516e57289027);
    function $124dc2b2e19e1fc3$export$aee7516e57289027(document, window) {
        const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
        ssrPlaceholders.forEach((elem)=>{
            const placeholderId = elem.getAttribute('data-ssr-placeholder');
            const boundingClient = elem.getBoundingClientRect();
            if (placeholderId) {
                window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
                window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
            }
        });
    }
});
parcelRegister("1qZQE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d3e5ef09bf7c5fc$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "updatePageloadName", ()=>$0d3e5ef09bf7c5fc$export$d0f99433cd4f4028);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $fseZC;
    var $9HC2N;
    var $6ui18;
    var $20wDi;
    var $iNl9c;
    var $ibksR;
    const $0d3e5ef09bf7c5fc$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
    function $0d3e5ef09bf7c5fc$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
        const activeInteraction = (0, (0, parcelRequire("iNl9c")).getActiveInteraction)();
        if (activeInteraction && !ufoName) return;
        (0, (0, parcelRequire("ibksR")).default).current = routeName || null;
        const rate = ufoName ? (0, (0, parcelRequire("9HC2N")).getInteractionRate)(ufoName, 'page_load') : 1;
        const enabledBySamplingRate = (0, (0, parcelRequire("fseZC")).default)(rate);
        if (enabledBySamplingRate && !activeInteraction) {
            const newId = (0, $7Jxgt.v4)();
            (0, (0, parcelRequire("20wDi")).DefaultInteractionID).current = newId;
            (0, (0, parcelRequire("iNl9c")).addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, (0, parcelRequire("6ui18")).getActiveTrace)());
            if (!ufoName) (0, (0, parcelRequire("iNl9c")).addHoldByID)(newId, [], $0d3e5ef09bf7c5fc$var$AWAITING_PAGELOAD_NAME, $0d3e5ef09bf7c5fc$var$AWAITING_PAGELOAD_NAME, true);
        } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') (0, (0, parcelRequire("iNl9c")).abort)(activeInteraction.id, 'excluded_by_sampling');
        else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
            (0, (0, parcelRequire("iNl9c")).updatePageLoadInteractionName)(ufoName, routeName);
            (0, (0, parcelRequire("iNl9c")).removeHoldByID)(activeInteraction.id, $0d3e5ef09bf7c5fc$var$AWAITING_PAGELOAD_NAME);
        }
    }
    function $0d3e5ef09bf7c5fc$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
        const interaction = (0, (0, parcelRequire("iNl9c")).getActiveInteraction)();
        if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
        if (ufoName) {
            const rate = (0, (0, parcelRequire("9HC2N")).getInteractionRate)(ufoName, 'page_load');
            (0, (0, parcelRequire("iNl9c")).updatePageLoadInteractionName)(ufoName, routeName);
            if ((0, (0, parcelRequire("fseZC")).default)(rate)) (0, (0, parcelRequire("ibksR")).default).current = ufoName;
            else (0, (0, parcelRequire("iNl9c")).abort)(interaction.id, 'excluded_by_sampling');
        }
        (0, (0, parcelRequire("iNl9c")).removeHoldByID)(interaction.id, $0d3e5ef09bf7c5fc$var$AWAITING_PAGELOAD_NAME);
    }
});
parcelRegister("k4NnA", function(module, exports) {
    $parcel$export(module.exports, "reportBootstrapError", ()=>$6a69127f0604feb0$export$a5c16644a2d3c205);
    var $kuiU5;
    var $hh0bW;
    var $jpY8v;
    var $4Pf62;
    var $jcw0u;
    var $8ApFP;
    const $6a69127f0604feb0$export$649804097de83b3b = [
        {
            browser: 'Chrome',
            browserVersion: '116.0.0',
            errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
        }
    ];
    const $6a69127f0604feb0$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, (0, parcelRequire("jpY8v")).getBrowser)().name === filterCriteria.browser : true;
    const $6a69127f0604feb0$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, (0, parcelRequire("jpY8v")).getBrowser)().version === filterCriteria.browserVersion : true;
    const $6a69127f0604feb0$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
    const $6a69127f0604feb0$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
        try {
            const conditionCheckers = [
                $6a69127f0604feb0$var$checkBrowserCondition,
                $6a69127f0604feb0$var$checkBrowserVersionCondition,
                $6a69127f0604feb0$var$checkErrorMessageCondition
            ];
            return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
        } catch (e) {
            return true;
        }
    };
    const $6a69127f0604feb0$export$a5c16644a2d3c205 = async (error)=>{
        const tenantContextData = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        (0, (0, parcelRequire("kuiU5")).default)(tenantContextData);
        if ($6a69127f0604feb0$export$a66ce4bea8340820(error, $6a69127f0604feb0$export$649804097de83b3b)) (0, (0, parcelRequire("hh0bW")).default)({
            analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
            experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
            wasExperienceSuccesful: false,
            location: (0, $9ccbd88c704da1ef$export$7dfef0177e883b05),
            application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
            edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
            additionalAttributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        });
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: 'jiraBootstrapSlaReporter',
                id: 'bootstrap-failure',
                teamName: 'magma'
            },
            error: error,
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        });
        throw error;
    };
});
const $9ccbd88c704da1ef$export$c9e16a15d65437 = 'navigationNext';
const $9ccbd88c704da1ef$export$b1534bc11f201efd = 'jiraPageContainer';
const $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7 = null;
const $9ccbd88c704da1ef$export$aa6008fe0169b864 = null;
const $9ccbd88c704da1ef$export$39418a21fbb51487 = null;
const $9ccbd88c704da1ef$export$7dfef0177e883b05 = 'entry.jira-spa';
const $9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $9ccbd88c704da1ef$export$7114284ca03133ee = `_${$9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK}.end`;
const $9ccbd88c704da1ef$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $9ccbd88c704da1ef$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $9ccbd88c704da1ef$export$e2bc63118050de32 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.start`;
const $9ccbd88c704da1ef$export$59f83d43fe209319 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.end`;
const $9ccbd88c704da1ef$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $9ccbd88c704da1ef$export$c20831be6f780cb5 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.start`;
const $9ccbd88c704da1ef$export$398df1bca49f9884 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.end`;
const $9ccbd88c704da1ef$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $9ccbd88c704da1ef$export$3c2d8af5c7577fe7 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.start`;
const $9ccbd88c704da1ef$export$aac77afee74c49d0 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.end`;
const $9ccbd88c704da1ef$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $9ccbd88c704da1ef$export$16e7ead3a8b5c366 = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.start`;
const $9ccbd88c704da1ef$export$c389f0b50840d5ca = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.end`;
parcelRegister("8ApFP", function(module, exports) {
    $parcel$export(module.exports, "routeAnalyticsAttributes", ()=>$a83c9e8eeb3d40c2$export$c71778b3a4356b04);
    var $cfDZ3;
    var $hVf1M;
    const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
        routeName: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getRouteName)
        },
        userLocation: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getUserLocation)
        },
        previousSubProduct: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getPreviousSubProduct)
        },
        isProjectAdmin: {
            enumerable: true,
            get: (0, (0, parcelRequire("hVf1M")).getIsProjectAdmin)
        }
    });
});
parcelRegister("2YzDH", function(module, exports) {
    var $jOqMN;
    if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
        (parcelRequire("c4xqm"));
        const isDevMode = false;
        (0, (0, parcelRequire("jOqMN")).default).devtools = isDevMode && (()=>({
                serialize: {
                    replacer: (key, value)=>value instanceof HTMLElement ? {
                            data: {
                                tagName: value.tagName,
                                className: value.className,
                                id: value.id,
                                __SANITIZED__: true
                            },
                            __serializedType__: 'HTMLElement'
                        } : value
                }
            }));
        (0, (0, parcelRequire("jOqMN")).default).batchUpdates = !false;
        Object.freeze((0, (0, parcelRequire("jOqMN")).default));
        $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
    }
});
parcelRegister("c4xqm", function(module, exports) {
    const $8c9fc9207ef34a1a$var$style = document.createElement('style');
    $8c9fc9207ef34a1a$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
    document.querySelector('head').appendChild($8c9fc9207ef34a1a$var$style);
});
parcelRegister("frBVt", function(module, exports) {
    $parcel$export(module.exports, "getPlaceholdersFromHTML", ()=>$126443352ff757de$export$9e9f35acc3af3a9a);
    $parcel$export(module.exports, "EntryPointPlaceholderContext", ()=>$126443352ff757de$export$b5b377bb81310c48);
    $parcel$export(module.exports, "EntryPointPlaceholder", ()=>$126443352ff757de$export$db2828f683d11042);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    function $126443352ff757de$export$9e9f35acc3af3a9a() {
        const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
        return new Map(Array.from(placeholders, (el)=>[
                el.dataset.epPlaceholderId,
                el.innerHTML
            ]));
    }
    const $126443352ff757de$export$b5b377bb81310c48 = (0, $5uXOq.createContext)(new Map());
    function $126443352ff757de$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
        const { root: root } = entryPoint;
        const hasMounted = (0, $5uXOq.useRef)(false);
        const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
        const ssrFallback = placeholders.get(name);
        const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: ssrFallback
            },
            "data-ep-placeholder-id": name
        }));
        const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
        lastOriginalFallback.current = originalFallback;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (hasMounted.current && placeholders.has(name)) {
                placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            }
        }, [
            entryPoint,
            name,
            placeholders,
            setFallback
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onComplete = ()=>{
                if (placeholders.has(name)) placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            };
            const unsubscribe = root.onComplete(onComplete, onComplete);
            return ()=>{
                unsubscribe();
                onComplete();
            };
        }, [
            name,
            placeholders,
            root
        ]);
        (0, $5uXOq.useEffect)(()=>{
            hasMounted.current = true;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: fallback,
            name: name,
            ...placeholderProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-ep-placeholder-id": name
        }, children));
    }
});
parcelRegister("7bkFJ", function(module, exports) {
    $parcel$export(module.exports, "initPlatformFeatureFlags", ()=>$fef4d3d4b4c51b47$export$2d291317456ada16);
    var $294ns;
    var $4R6GH;
    var $co1wz;
    const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('fix_jira_ssr_platform_ff_oxim4')) (0, (0, parcelRequire("294ns")).setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, (0, parcelRequire("4R6GH")).fg)(flagKey) || (0, (0, parcelRequire("co1wz")).ff)(flagKey));
    };
});
parcelRegister("fz3fB", function(module, exports) {
    $parcel$export(module.exports, "NonCritical", ()=>$a1827329dcbac5c8$export$20fd89b1bf707b1a);
    $parcel$export(module.exports, "default", ()=>$a1827329dcbac5c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $6yXtV;
    const $a1827329dcbac5c8$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (timerThreshold != null) setTimeout(()=>{
                setHasThresholdTimerExpired(true);
            }, timerThreshold);
        }, [
            timerThreshold
        ]);
        if (!isFirstRun || isReady || hasThresholdTimerExpired) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$export$83d969795398ec56, props));
    const $a1827329dcbac5c8$var$NonCriticalComponent = (props)=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        if (!isFirstRun || isReady) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$var$NonCriticalComponent, props));
    var $a1827329dcbac5c8$export$2e2bcd8739ae039 = $a1827329dcbac5c8$var$NonCriticalComponent;
});
parcelRegister("6yXtV", function(module, exports) {
    $parcel$export(module.exports, "useSpaStatePageReady", ()=>$44de65c7edb80809$export$ea2491906b753456);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$44de65c7edb80809$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$44de65c7edb80809$export$41e70078eeddaddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3sQ5x;
    var $4oDnX;
    var $7w9eZ;
    const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        return {
            isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
        };
    };
    const $44de65c7edb80809$export$ea2491906b753456 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $44de65c7edb80809$export$e6897aa59ee7aee5
    });
    const $44de65c7edb80809$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady
            }));
    const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady,
                args: comparer
            }));
});
parcelRegister("kZBXc", function(module, exports) {
    $parcel$export(module.exports, "Spa", ()=>$454974e68bcf078d$export$6d4069f4b64f7492);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $2SVPM;
    var $erCTW;
    var $erjJQ;
    const $454974e68bcf078d$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$21473105c510aacc), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), (0, $9ccbd88c704da1ef$export$7114284ca03133ee), true, true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erCTW")).PageContainer), {
            baseUrl: baseUrl,
            id: false ? 'jira.entry.ssr' : 'spa',
            locale: locale,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$7114284ca03133ee),
            onSet: pageContainerPerformanceTiming
        }), isPrewarming !== true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erjJQ")).Content), {
            initRoute: initRoute,
            routes: routes
        }));
    };
});
parcelRegister("gAeCk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5368db3a32c0eb20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $x9xyg;
    const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
        const renderRef = (0, $5uXOq.useRef)(false);
        if (!renderRef.current) {
            renderRef.current = true;
            (0, (0, parcelRequire("x9xyg")).setMark)(metricKey);
            onSet && onSet();
        }
        return null;
    };
    var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;
});
parcelRegister("erCTW", function(module, exports) {
    $parcel$export(module.exports, "PageContainer", ()=>$a81b2dc7c8e9cabb$export$5f86df0ee0a255b5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $gAeCk;
    var $7CMCs;
    var $7XYc4;
    var $14V0U;
    var $g7crU;
    var $jHXUj;
    var $aKiiD;
    var $cPiXk;
    var $3HwlS;
    var $iqLcb;
    var $16YKp;
    var $cOwuh;
    var $iXVV6;
    var $3Uek9;
    var $6ncxj;
    var $2SVPM;
    var $gmCnE;
    var $kc9FZ;
    var $6DLIs;
    var $62C9r;
    var $4s15Z;
    var $eF0qp;
    var $gxCm0;
    var $lvpKt;
    var $8Ceqd;
    const $a81b2dc7c8e9cabb$var$mainWrapperStyles = {
        root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
        themed: "_11q7mmei _11q31r52"
    };
    const $a81b2dc7c8e9cabb$var$ROOT_TEST_ID = 'page-layout.root';
    const $a81b2dc7c8e9cabb$var$MAIN_TEST_ID = 'page-layout.main';
    const $a81b2dc7c8e9cabb$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
        const [isFullscreen] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const { hasTheming: hasTheming } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, (0, parcelRequire("16YKp")).useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
        }, []);
        const mainWrapper = (content)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Main), {
                isFixed: true,
                testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
                    hasTheming && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
                ])
            }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), content));
        const showBanner = !isChromeless && !isFullscreen;
        const showTopNav = !isChromeless && !isFullscreen;
        const showSidebar = !isChromeless && !isFullscreen;
        const showHorizontalNav = !isChromeless;
        const showRightSidebar = !isChromeless && !isFullscreen;
        const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ceqd")).ThemeSetter), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DLIs")).GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).PageLayout), {
            skipLinksLabel: "",
            testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
        }, showBanner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "banner",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmCnE")).Banner), null)), showTopNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "top-nav",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxCm0")).TopNav), null)), showSidebar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF0qp")).Sidebar), null)), mainWrapper((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showHorizontalNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62C9r")).HorizontalNav), null), children)), showRightSidebar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4s15Z")).RightSidebar), null)), showLayoutRemoteStateUpdater && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "jiraPageContainerV2",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXUj")).LayoutRemoteStateUpdater), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kc9FZ")).GlobalComponents), {
            sharedGlobalComponents: (0, (0, parcelRequire("6ncxj")).sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKiiD")).GlobalBottomRightCornerContainer), null))));
    };
    const $a81b2dc7c8e9cabb$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, (0, parcelRequire("16YKp")).useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
        }, []);
        let contentChildren = isJsmPackagingUpdatesEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (HorizontalNavComponent != null) contentChildren = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62C9r")).HorizontalNavWrapper), {
            navComponent: HorizontalNavComponent
        }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOwuh")).BannerJsmPackagingUpdateAsync), null), children);
        const panelContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvpKt")).FullHeight), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).PageLayout), {
            skipLinksLabel: ""
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "banner",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmCnE")).Banner), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "top-nav",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxCm0")).TopNav), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).LeftPanel), {
            width: 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Content), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF0qp")).Sidebar), null)), contentChildren, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4s15Z")).RightSidebar), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            packageName: "page-container",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXUj")).LayoutRemoteStateUpdater), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kc9FZ")).GlobalComponents), {
            sharedGlobalComponents: (0, (0, parcelRequire("6ncxj")).sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKiiD")).GlobalBottomRightCornerContainer), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ceqd")).ThemeSetter), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DLIs")).GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, panelContent)));
    };
    const $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $a81b2dc7c8e9cabb$var$PageContainerNew, $a81b2dc7c8e9cabb$var$PageContainerOld);
});
parcelRegister("14V0U", function(module, exports) {
    $parcel$export(module.exports, "useIsChromeless", ()=>$96950c90e73fdad9$export$c88b74884f5222ba);
    var $3sQ5x;
    var $5e5zm;
    const $96950c90e73fdad9$export$c88b74884f5222ba = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.isChromeless
    });
});
parcelRegister("5e5zm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$0c99a19d69d506cf$export$539e68c09584883a);
    $parcel$export(module.exports, "layoutStore", ()=>$0c99a19d69d506cf$export$b8cdfd44cddaf07);
    $parcel$export(module.exports, "useLayoutStoreActions", ()=>$0c99a19d69d506cf$export$6136bc3b9858cff4);
    $parcel$export(module.exports, "useDetailPanelWidth", ()=>$0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
    $parcel$export(module.exports, "useDetailPanelActions", ()=>$0c99a19d69d506cf$export$99e05a60cac05e86);
    var $3sQ5x;
    var $iXqE5;
    var $8CM3x;
    const $0c99a19d69d506cf$export$539e68c09584883a = 240;
    const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
    const $0c99a19d69d506cf$var$initialState = {
        isChromeless: false,
        isFullscreen: false,
        banner: {
            height: 0,
            activeBanner: null
        },
        topNavigation: {
            isVisible: true
        },
        leftPanel: {
            isVisible: true,
            width: 0
        },
        rightPanel: {
            isVisible: true,
            width: 0
        },
        bottomRightCorner: {
            container: undefined,
            portals: []
        },
        content: {
            leftSidebar: {
                width: $0c99a19d69d506cf$export$539e68c09584883a,
                isCollapsed: true,
                isVisible: true,
                isFlyoutOpen: false
            },
            rightSidebar: {
                stackState: []
            }
        }
    };
    const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $0c99a19d69d506cf$var$initialState,
        actions: (0, parcelRequire("8CM3x")).actions,
        name: 'JiraLayoutStore'
    });
    const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, (0, parcelRequire("3sQ5x")).createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
        selector: null
    });
    const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'detailPanelWidth',
        initialState: {
            width: 0
        },
        actions: {
            setWidth: (value)=>({ setState: setState })=>{
                    setState({
                        width: value
                    });
                }
        }
    });
    const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, (0, parcelRequire("3sQ5x")).createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
    const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
});
parcelRegister("8CM3x", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$939ad82f8ddcb8d9$export$e324594224ef24da);
    var $4oU0I;
    var $flhve;
    var $f5TQt;
    var $hPsAX;
    var $gqQUV;
    var $byk51;
    const $939ad82f8ddcb8d9$export$e324594224ef24da = {
        setIsChromeless: (0, parcelRequire("f5TQt")).setIsChromeless,
        setIsFullscreen: (0, parcelRequire("hPsAX")).setIsFullscreen,
        showBanner: (0, parcelRequire("4oU0I")).showBanner,
        dismissCurrentBanner: (0, parcelRequire("4oU0I")).dismissCurrentBanner,
        setLeftSidebarState: (0, parcelRequire("gqQUV")).setLeftSidebarState,
        setRightSidebarState: (0, parcelRequire("byk51")).setRightSidebarState,
        openRightSidebar: (0, parcelRequire("byk51")).openRightSidebar,
        closeRightSidebar: (0, parcelRequire("byk51")).closeRightSidebar,
        closeAllRightSidebar: (0, parcelRequire("byk51")).closeAllRightSidebar,
        closeCurrentRightSidebar: (0, parcelRequire("byk51")).closeCurrentRightSidebar,
        minimiseRightSidebar: (0, parcelRequire("byk51")).minimiseRightSidebar,
        registerBottomRightCornerContainer: (0, parcelRequire("flhve")).registerBottomRightCornerContainer,
        insertBottomRightCornerPortal: (0, parcelRequire("flhve")).insertBottomRightCornerPortal,
        removeBottomRightCornerPortal: (0, parcelRequire("flhve")).removeBottomRightCornerPortal
    };
});
parcelRegister("4oU0I", function(module, exports) {
    $parcel$export(module.exports, "showBanner", ()=>$820929f36789bf81$export$f5c0eb035ef26e87);
    $parcel$export(module.exports, "dismissCurrentBanner", ()=>$820929f36789bf81$export$a45bccc0cc9ac424);
    const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
            setState({
                banner: newState
            });
        };
    const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
            dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
                height: 0,
                activeBanner: null
            }));
        };
});
parcelRegister("flhve", function(module, exports) {
    $parcel$export(module.exports, "registerBottomRightCornerContainer", ()=>$560ff4740e75fa9e$export$2992ecf780497763);
    $parcel$export(module.exports, "insertBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$3ed25a6bee272520);
    $parcel$export(module.exports, "removeBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$928bf7e228ce06d2);
    const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    container: ref ?? undefined
                }
            });
        };
    const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            const sorted = [
                item,
                ...portals
            ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
            const index = sorted.findIndex((portal)=>portal.id === item.id);
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: sorted
                }
            });
            return index;
        };
    const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: portals.filter((portal)=>portal.id !== id)
                }
            });
        };
});
parcelRegister("f5TQt", function(module, exports) {
    $parcel$export(module.exports, "setIsChromeless", ()=>$0389a2d5715d1f25$export$1998c4816ad37edb);
    const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
            setState({
                isChromeless: isChromeless
            });
        };
});
parcelRegister("hPsAX", function(module, exports) {
    $parcel$export(module.exports, "setIsFullscreen", ()=>$e3c9e6899dc6b3f0$export$9c73b2f282069160);
    const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
            setState({
                isFullscreen: isFullscreen
            });
        };
});
parcelRegister("gqQUV", function(module, exports) {
    $parcel$export(module.exports, "setLeftSidebarState", ()=>$54ca906cbb882b25$export$3e0fd2d894ef83c8);
    const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    leftSidebar: {
                        ...content.leftSidebar,
                        ...newState
                    }
                }
            });
        };
});
parcelRegister("byk51", function(module, exports) {
    $parcel$export(module.exports, "selectCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$57758d0cfaeec2c);
    $parcel$export(module.exports, "setRightSidebarState", ()=>$4dabd377b098e1a2$export$f5584170a8c1db02);
    $parcel$export(module.exports, "closeAllRightSidebar", ()=>$4dabd377b098e1a2$export$d91a6e55d52aa3e9);
    $parcel$export(module.exports, "closeCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$a9a5075d3d1b2165);
    $parcel$export(module.exports, "closeRightSidebar", ()=>$4dabd377b098e1a2$export$d7149233c76efb32);
    $parcel$export(module.exports, "minimiseRightSidebar", ()=>$4dabd377b098e1a2$export$4eedf7fa26a2749a);
    $parcel$export(module.exports, "openRightSidebar", ()=>$4dabd377b098e1a2$export$c8dafe074328c4ca);
    var $ajpes = parcelRequire("ajpes");
    const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
        const arrayCopy = [
            ...array
        ];
        const f = arrayCopy.splice(oldIndex, 1)[0];
        arrayCopy.splice(newIndex, 0, f);
        return arrayCopy;
    };
    const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
        const visited = {};
        return stackState.filter((item)=>{
            if (visited[item.panelId]) return false;
            visited[item.panelId] = true;
            return true;
        });
    };
    const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
        if (state.stackState.length === 1) return state.stackState[0];
        return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
    };
    const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: []
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            if (!currentStack.length) return;
            const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
            if (!currentRightSidebar) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.filter((item)=>item.panelId !== panelId)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.map((item)=>{
                            if (item.panelId !== panelId) return item;
                            return {
                                ...item,
                                isMinimised: true
                            };
                        })
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
                ...content.rightSidebar.stackState.map((item)=>{
                    if (item.panelId === panelId) return {
                        ...item,
                        isMinimised: isMinimised,
                        width: width
                    };
                    return item;
                })
            ] : [];
            const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
            if (matchedPanelIndex >= 0) {
                const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
                tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
                tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
                const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
                newRightSidebarStackStateValue[nextIdx].width = width;
                setState({
                    content: {
                        ...content,
                        rightSidebar: {
                            stackState: newRightSidebarStackStateValue
                        }
                    }
                });
                return;
            }
            const newRightSidebarStackStateValue = toTop ? [
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                },
                ...tempRightSidebarStackStateValue
            ] : [
                ...tempRightSidebarStackStateValue,
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                }
            ];
            if ((0, ($parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
        };
});
parcelRegister("g7crU", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$aa937e51388f56fd$export$d397eccea5f37b0a);
    var $3sQ5x;
    var $5e5zm;
    const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.isFullscreen
    });
});
parcelRegister("jHXUj", function(module, exports) {
    $parcel$export(module.exports, "LayoutRemoteStateUpdater", ()=>$89937a782c6cb988$export$b9f3a70460995c32);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $7XYc4;
    var $3HwlS;
    var $iqLcb;
    var $c34Wf;
    var $90yGq;
    var $2YP9W;
    var $5e5zm;
    var $gPQRI;
    var $hsmeR;
    var $2TwSO;
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld = ()=>{
        const { leftSidebarState: leftSidebarState } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
        const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, (0, parcelRequire("5e5zm")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
        const rightSidebarState = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c34Wf")).navigationUiStateResource));
        const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
        (0, $5uXOq.useEffect)(()=>{
            if (!isLayoutStateReady) return;
            if (error) return;
            setLeftSidebarState({
                width: resolvedLeftSidebarWidth,
                isCollapsed: isCollapsed,
                isFlyoutOpen: isFlyoutOpen,
                isVisible: true
            });
        }, [
            error,
            isCollapsed,
            isFlyoutOpen,
            isLayoutStateReady,
            resolvedLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const updateData = (0, $5uXOq.useCallback)(async ()=>{
            if (loading) return;
            if (error) return;
            if (!isLayoutStateReady) return;
            const remoteData = {
                ...data,
                leftSidebar: {
                    width: resolvedLeftSidebarWidth,
                    isCollapsed: isLeftSidebarCollapsed
                },
                rightSidebar: rightSidebarState
            };
            if (accountId) try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: 'updateServerLayoutState',
                        packageName: 'jiraLayoutController',
                        teamName: 'magma'
                    }
                });
            }
        }, [
            accountId,
            data,
            error,
            isLayoutStateReady,
            isLeftSidebarCollapsed,
            loading,
            resolvedLeftSidebarWidth,
            rightSidebarState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateData();
        }, [
            isLeftSidebarCollapsed,
            resolvedLeftSidebarWidth,
            updateData
        ]);
        return null;
    };
    const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const leftSidebar = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useRightSidebarState)();
        const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
        const leftSidebarWidth = leftSidebar.width;
        (0, $5uXOq.useEffect)(()=>{
            if (!accountId) return;
            (0, (0, parcelRequire("2TwSO")).setRemoteLayoutState)({
                accountId: accountId,
                state: {
                    rightSidebar: rightSidebar,
                    leftSidebar: {
                        isCollapsed: isLeftSidebarCollapsed,
                        width: leftSidebarWidth
                    }
                }
            });
        }, [
            accountId,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            rightSidebar
        ]);
        return null;
    };
    const $89937a782c6cb988$export$b9f3a70460995c32 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld);
});
parcelRegister("iqLcb", function(module, exports) {
    $parcel$export(module.exports, "PageLayout", ()=>$3d7d84f3bc65155e$export$6d1402fb58384e4f);
    $parcel$export(module.exports, "Banner", ()=>$3d7d84f3bc65155e$export$3b4e64e77073e307);
    $parcel$export(module.exports, "TopNavigation", ()=>$3d7d84f3bc65155e$export$8a421bddecb2bf5b);
    $parcel$export(module.exports, "LeftPanel", ()=>$3d7d84f3bc65155e$export$110709f040143804);
    $parcel$export(module.exports, "LeftSidebarWithoutResize", ()=>$3d7d84f3bc65155e$export$43ae342508cf8cc9);
    $parcel$export(module.exports, "LeftSidebar", ()=>$3d7d84f3bc65155e$export$3cabf771c4f2de);
    $parcel$export(module.exports, "Main", ()=>$3d7d84f3bc65155e$export$861edd1ccea2f746);
    $parcel$export(module.exports, "Content", ()=>$3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "RightSidebar", ()=>$3d7d84f3bc65155e$export$84d58c19c21f637f);
    $parcel$export(module.exports, "RightPanel", ()=>$3d7d84f3bc65155e$export$364a989a35814102);
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$3d7d84f3bc65155e$export$94561f6055639ef7);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$3d7d84f3bc65155e$export$10c7104037a7af62);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", ()=>$3d7d84f3bc65155e$export$991ef8098f87814a);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$e95b388ca8c92019);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$2ab8b83eed76656c);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$ac017575d43f5da);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", ()=>$3d7d84f3bc65155e$export$d697087c06fd5e25);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cfCYJ;
    var $fHYEP;
    var $8uxcu;
    var $lPKVQ;
    var $9HvD6;
    var $1xtlh;
    var $8T5bc;
    var $igz9V;
    var $9800U;
    var $lHa8m;
    var $1IJrV;
    var $cVRge;
    var $jEQgO;
    var $4R6GH;
    var $3HwlS;
    var $lX64V;
    var $fIr6F;
    var $jL8aY;
    var $gFfbI;
    var $gN1lH;
    var $a2MWg;
    var $7CyGM;
    function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN1lH")).Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("igz9V")).default), props);
    }
    function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fIr6F")).Banner), {
            UNSAFE_height: props.height,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cfCYJ")).default), props);
    }
    function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CyGM")).TopBar), {
            UNSAFE_height: props.height,
            testId: props.testId,
            UNSAFE_theme: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_theming') ? props.theme : undefined
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IJrV")).default), props);
    }
    function $3d7d84f3bc65155e$export$110709f040143804(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lPKVQ")).default), props);
    }
    function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a2MWg")).SideNav), {
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xtlh")).default), props);
    }
    function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a2MWg")).SideNav), {
            defaultCollapsed: props.collapsedState === 'collapsed',
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9HvD6")).default), props);
    }
    function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jL8aY")).Main), {
            isFixed: props.isFixed,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8T5bc")).default), props);
    }
    function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? props.children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8uxcu")).default), props);
    }
    function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lX64V")).Aside), {
            isFixed: props.isFixed,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lHa8m")).default), props);
    }
    function $3d7d84f3bc65155e$export$364a989a35814102(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFfbI")).Panel), {
            xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9800U")).default), props);
    }
    const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("cVRge")).useCustomSkipLink)(id, title, index);
    const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("jEQgO")).useLeftSidebarFlyoutLock)();
    const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        collapseLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        leftSidebarState: {
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        },
        setLeftSidebarState: (0, ($parcel$interopDefault($8Rkzz))),
        toggleLeftSidebar: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : (0, (0, parcelRequire("jEQgO")).usePageLayoutResize)();
    const $3d7d84f3bc65155e$var$rightPanelStyles = {
        root: "_bfhk1bhr"
    };
    const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT);
    const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT);
});
parcelRegister("90yGq", function(module, exports) {
    $parcel$export(module.exports, "useAccountId", ()=>$903db0de2618ef6c$export$e72033e0f5baa3e);
    var $9OXo1;
    const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.atlassianAccountId || null;
    };
});
parcelRegister("gPQRI", function(module, exports) {
    $parcel$export(module.exports, "useLeftSidebarState", ()=>$b19712b3cdd78134$export$610d81e163a897b3);
    $parcel$export(module.exports, "useLeftSidebarController", ()=>$b19712b3cdd78134$export$900f29014a48fb23);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqLcb;
    var $3sQ5x;
    var $5e5zm;
    const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.content.leftSidebar,
                shouldRender: !state.isChromeless
            })
    });
    const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
        const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
        return leftSidebar;
    };
    const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
        const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        return (0, $5uXOq.useMemo)(()=>({
                collapseLeftSidebar: collapseLeftSidebar,
                expandLeftSidebar: expandLeftSidebar
            }), [
            collapseLeftSidebar,
            expandLeftSidebar
        ]);
    };
});
parcelRegister("hsmeR", function(module, exports) {
    $parcel$export(module.exports, "useActiveRightSidebarState", ()=>$39a48ee662f10943$export$ba763ab7661c3103);
    $parcel$export(module.exports, "useRightSidebarState", ()=>$39a48ee662f10943$export$d1828e7f46a4960b);
    $parcel$export(module.exports, "useRightSidebarController", ()=>$39a48ee662f10943$export$ebe5e907fb0bb63a);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $byk51;
    var $5e5zm;
    const $39a48ee662f10943$var$useActiveRightSidebar = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>{
            const rightSidebarState = (0, (0, parcelRequire("byk51")).selectCurrentRightSidebar)(state.content.rightSidebar);
            if (!rightSidebarState) return null;
            return {
                ...rightSidebarState,
                shouldRender: !state.isChromeless
            };
        }
    });
    const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
        const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
        return rightSidebar;
    };
    const $39a48ee662f10943$var$useRightSidebar = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.content.rightSidebar
    });
    const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
        const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
        return rightSidebarState;
    };
    const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
        const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        return (0, $5uXOq.useMemo)(()=>({
                setRightSidebarState: setRightSidebarState,
                closeRightSidebar: closeRightSidebar,
                openRightSidebar: openRightSidebar,
                closeCurrentRightSidebar: closeCurrentRightSidebar,
                closeAllRightSidebar: closeAllRightSidebar,
                minimiseRightSidebar: minimiseRightSidebar
            }), [
            closeAllRightSidebar,
            closeCurrentRightSidebar,
            closeRightSidebar,
            openRightSidebar,
            setRightSidebarState,
            minimiseRightSidebar
        ]);
    };
});
parcelRegister("2TwSO", function(module, exports) {
    $parcel$export(module.exports, "setRemoteLayoutState", ()=>$9d3e8b8a199ea341$export$ad53b565e6cd4261);
    var $89SaW;
    var $jcw0u;
    async function $9d3e8b8a199ea341$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
        try {
            await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(state));
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'jfp-team'
                }
            });
        }
    }
});
parcelRegister("aKiiD", function(module, exports) {
    $parcel$export(module.exports, "GlobalBottomRightCornerContainer", ()=>$1ca472b9239dbdd7$export$715c8d5890c054bb);
    $parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", ()=>$1ca472b9239dbdd7$export$1e86e3484191597c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $l8ruj;
    var $hvrWv;
    var $hsmeR;
    var $5e5zm;
    function $1ca472b9239dbdd7$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
        const [{ width: width }] = (0, (0, parcelRequire("5e5zm")).useDetailPanelWidth)();
        const rightSidebar = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
        const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$var$StyledContainer, {
            ref: registerBottomRightCornerContainer,
            "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
            style: {
                right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
                bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
            }
        });
    }
    const $1ca472b9239dbdd7$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bottom-right-corner-container",
            packageName: "jira-bottom-right-corner-controller"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$e112b78171de7a6, {
            bottomOffset: bottomOffset,
            rightOffset: rightOffset
        }));
    const $1ca472b9239dbdd7$export$1e86e3484191597c = ({ children: children })=>{
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "global-bottom-right-corner"
        }, container && children, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$715c8d5890c054bb, null));
    };
    const $1ca472b9239dbdd7$var$StyledContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
                __cmplp.className
            ])
        });
    });
    $1ca472b9239dbdd7$var$StyledContainer.displayName = 'StyledContainer';
});
parcelRegister("l8ruj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6056b4460d0127e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $80cnJ;
    var $iNl9c;
    var $77kYm;
    var $7UTZj;
    function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
        const interactionContext = (0, (0, parcelRequire("80cnJ")).useInteractionContext)();
        const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
                getInteractionContext: ()=>interactionContext,
                wrapPrepareQueryResource (cb) {
                    return cb();
                },
                retainQuery (info) {
                    this.getInteractionContext().retainQuery(info);
                }
            }), [
            interactionContext
        ]);
        const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
            const moduleLoadingRequests = {};
            return {
                current: {
                    getInteractionContext () {
                        return interactionContext;
                    },
                    onPreload (moduleId, _priority) {
                        this.getInteractionContext().addPreload((0, (0, parcelRequire("iNl9c")).extractModuleName)(moduleId), performance.now());
                    },
                    onLoadStart (info) {
                        const timeoutId = setTimeout(()=>{
                            delete moduleLoadingRequests[info.identifier];
                        }, 30000);
                        const request = {
                            start: performance.now(),
                            timeoutId: timeoutId
                        };
                        moduleLoadingRequests[info.identifier] = request;
                    },
                    onLoadComplete (info) {
                        const request = moduleLoadingRequests[info.identifier];
                        if (request) {
                            clearTimeout(request.timeoutId);
                            delete moduleLoadingRequests[info.identifier];
                            this.getInteractionContext()?.addLoad((0, (0, parcelRequire("iNl9c")).extractModuleName)(info.identifier), request.start, performance.now());
                        }
                    },
                    placeholderFallBackMounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                    },
                    placeholderFallBackUnmounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                    }
                }
            };
        }, [
            interactionContext
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
            value: relayProfilerContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UTZj")).ProfilerContext).Provider, {
            value: reactLooselyLazyContext
        }, children));
    }
    function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77kYm")).default), {
            name: segmentName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
    }
});
parcelRegister("hvrWv", function(module, exports) {
    $parcel$export(module.exports, "useBottomRightCornerContainer", ()=>$4dcd4c0b25ba3fd4$export$84542488b6b6c309);
    $parcel$export(module.exports, "useBottomRightCornerActions", ()=>$4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
    var $3sQ5x;
    var $5e5zm;
    const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.bottomRightCorner.container
    });
    const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)((0, (0, parcelRequire("5e5zm")).layoutStore));
});
parcelRegister("cPiXk", function(module, exports) {
    $parcel$export(module.exports, "useHorizontalNavComponent", ()=>$2edc33969f533189$export$205771a0e64e4c7c);
    var $l71WK;
    var $2vSU6;
    var $65Ltd;
    var $4R6GH;
    var $14V0U;
    var $3HwlS;
    var $6jY6G;
    var $dAfqg;
    var $c1mlA;
    var $5PD5h;
    var $lODMY;
    const $2edc33969f533189$export$965942f8308cd740 = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>(0, (0, parcelRequire("c1mlA")).BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
    const $2edc33969f533189$export$205771a0e64e4c7c = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: projectData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const hasBoardSettingsPageQueryParam = $2edc33969f533189$export$965942f8308cd740();
        if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
            const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
            if (isChromeless) return null;
        }
        if (route.navigation?.horizontal == null) return null;
        if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return null;
            switch(projectData?.projectType){
                case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                    return 0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav;
                default:
                    return null;
            }
        }
        if (route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE) && hasBoardSettingsPageQueryParam && (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk')) return null;
        if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectData?.projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return 0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav;
                return null;
            default:
                return null;
        }
        if ('onlyShowHorizontalOnNav4' in route.navigation && route.navigation.onlyShowHorizontalOnNav4) return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? route.navigation.horizontal : null;
        if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
            case 'jsm_views_of_work_phase_1':
                return (0, (0, parcelRequire("4R6GH")).fg)('jsm_views_of_work_phase_1') ? route.navigation.horizontal : null;
            default:
                {
                    const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                    return exhaustiveCheck;
                }
        }
        return route.navigation.horizontal;
    };
});
parcelRegister("l71WK", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalProjectNav", ()=>$7e6dac351b79a914$export$862dd1c0126bb181);
    $parcel$export(module.exports, "AsyncHorizontalOverviewNav", ()=>$7e6dac351b79a914$export$beabdf5c49f01377);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("1ZV7M")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
    });
    const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));
    const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("lgttv")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
    });
    const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));
});
parcelRegister("1ZV7M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4RRJO")
    ]).then(()=>parcelRequire('bwmXM'));
});
parcelRegister("lgttv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hTo1l")
    ]).then(()=>parcelRequire('bNzBR'));
});
parcelRegister("c1mlA", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", ()=>$4c8f71f257051803$export$128e24da52662cdd);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", ()=>$4c8f71f257051803$export$efdecbe4c9f1cd2c);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", ()=>$4c8f71f257051803$export$1154ed64d0d99951);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", ()=>$4c8f71f257051803$export$7cadd2a48a9ff918);
    $parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", ()=>$4c8f71f257051803$export$a546b6d48878ce6f);
    $parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", ()=>$4c8f71f257051803$export$8cc83ae2b6885e0);
    $parcel$export(module.exports, "boardSettingsQueryConfigParamValues", ()=>$4c8f71f257051803$export$a9ebdab56bd9c0c3);
    $parcel$export(module.exports, "SETTINGS_CONFIG", ()=>$4c8f71f257051803$export$2a56ee2f9c41b5a7);
    $parcel$export(module.exports, "EDIT_BOARD_CONFIG", ()=>$4c8f71f257051803$export$b893894941c14e43);
    $parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", ()=>$4c8f71f257051803$export$d14d5a7c294329c5);
    $parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", ()=>$4c8f71f257051803$export$1e63b013f0e45de0);
    $parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", ()=>$4c8f71f257051803$export$68030ac1ea4abd4c);
    $parcel$export(module.exports, "BACKLOG_FEATURE_KEY", ()=>$4c8f71f257051803$export$e1671d3447ddd5ad);
    $parcel$export(module.exports, "SPRINTS_FEATURE_KEY", ()=>$4c8f71f257051803$export$46efc2c8d8106cff);
    $parcel$export(module.exports, "FEATURE_ENABLED_STATUS", ()=>$4c8f71f257051803$export$a1046f102eae498);
    const $4c8f71f257051803$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
    const $4c8f71f257051803$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
    const $4c8f71f257051803$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
    const $4c8f71f257051803$export$7cadd2a48a9ff918 = `${$4c8f71f257051803$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
    const $4c8f71f257051803$export$a546b6d48878ce6f = 'Epic';
    const $4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
        'cardColors',
        'cardLayout',
        'columns',
        'default',
        'estimation',
        'filter',
        'swimlanes',
        'time',
        'timelineConfig',
        'quickFilters',
        'dateFields'
    ];
    const $4c8f71f257051803$export$8cc83ae2b6885e0 = new Set($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
    const $4c8f71f257051803$export$a9ebdab56bd9c0c3 = Object.fromEntries($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
            key,
            key
        ]));
    const $4c8f71f257051803$export$2a56ee2f9c41b5a7 = {
        default: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        filter: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        columns: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.columns,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        swimlanes: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.swimlanes,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        quickFilters: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.quickFilters,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardColors: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardColors,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardLayout: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardLayout,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        estimation: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.estimation,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: false
        },
        time: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.time,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        timelineConfig: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.timelineConfig,
            jsmAllowed: false,
            userLocatedBoardAllowed: false,
            kanbanAllowed: true
        },
        dateFields: {
            configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.dateFields,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        }
    };
    const $4c8f71f257051803$export$773ca4f5fb67778b = 60000;
    const $4c8f71f257051803$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
    const $4c8f71f257051803$export$d14d5a7c294329c5 = 'ADMINISTER_PARENT_PROJECT';
    const $4c8f71f257051803$export$1e63b013f0e45de0 = 'USER_PICKER';
    const $4c8f71f257051803$export$68030ac1ea4abd4c = 'ADMINISTER';
    const $4c8f71f257051803$export$e1671d3447ddd5ad = 'BACKLOG';
    const $4c8f71f257051803$export$46efc2c8d8106cff = 'SPRINTS';
    const $4c8f71f257051803$export$a1046f102eae498 = 'ENABLED';
    const $4c8f71f257051803$export$450e5ddc9f1ff901 = 'DISABLED';
});
parcelRegister("5PD5h", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", ()=>$a816ddf70513a004$export$128d5d79815580ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("j4PFg")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
    });
    const $a816ddf70513a004$export$128d5d79815580ca = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav, null));
});
parcelRegister("j4PFg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("djQ7G")
    ]).then(()=>parcelRequire('1f09g'));
});
parcelRegister("16YKp", function(module, exports) {
    $parcel$export(module.exports, "useBannerJsmPackagingUpdates", ()=>$32df9c26e8c82916$export$a0dde3f151a99607);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4R6GH;
    var $6jY6G;
    var $dAfqg;
    var $gzrJT;
    var $90yGq;
    var $l2Uy7;
    const $32df9c26e8c82916$export$a0dde3f151a99607 = ()=>{
        const currentRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const isServiceProject = project?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("l2Uy7")).isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
            isServiceProject,
            currentRoute.path
        ]);
        const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, (0, parcelRequire("gzrJT")).useJsmRepackagingAnnouncementResource)(accountId);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isInJsmBoundary && shouldShow && (0, (0, parcelRequire("4R6GH")).fg)('jsm-packaging-pricing-changes-announcement'),
                dismissAnnouncement: dismissAnnouncement
            }), [
            dismissAnnouncement,
            isInJsmBoundary,
            shouldShow
        ]);
    };
});
parcelRegister("gzrJT", function(module, exports) {
    $parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", ()=>$e073f4ec0b653e88$export$47d5fef12f2d184b);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $2M1hQ;
    var $2YP9W;
    var $hj0lE;
    const $e073f4ec0b653e88$var$getDataLoader = ()=>(parcelRequire("fjlZb"));
    const $e073f4ec0b653e88$export$750cb6ed3dfc6a3 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'JSM_REPACKAGING_ANNOUNCEMENT',
        getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
        getDataLoader: $e073f4ec0b653e88$var$getDataLoader,
        maxAge: Infinity
    });
    const $e073f4ec0b653e88$export$47d5fef12f2d184b = (accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)($e073f4ec0b653e88$export$750cb6ed3dfc6a3);
        const loadingRef = (0, $5uXOq.useRef)(false);
        const errorRef = (0, $5uXOq.useRef)();
        const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
        errorRef.current = userPropertiesError || error;
        const dismissAnnouncement = (0, $5uXOq.useCallback)(()=>{
            const announcementDismissState = {
                shouldShow: false
            };
            update(()=>({
                    announcementDismissState: announcementDismissState
                }));
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("hj0lE")).JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
        }, [
            accountId,
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (errorRef.current || loading || !data || !accountId) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            const { announcementDismissState: announcementDismissState } = data;
            if (!announcementDismissState) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            return {
                ...announcementDismissState,
                dismissAnnouncement: dismissAnnouncement
            };
        }, [
            loading,
            data,
            accountId,
            dismissAnnouncement
        ]);
    };
});
parcelRegister("hj0lE", function(module, exports) {
    $parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", ()=>$4bad9f9efc7d29c0$export$d2137827dc00e559);
    $parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", ()=>$4bad9f9efc7d29c0$export$341176bfdf8c92);
    const $4bad9f9efc7d29c0$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
    const $4bad9f9efc7d29c0$export$341176bfdf8c92 = {
        shouldShow: true
    };
});
parcelRegister("fjlZb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("37oAo").then(()=>parcelRequire('lGYvJ'));
});
parcelRegister("l2Uy7", function(module, exports) {
    $parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", ()=>$257d172b6cc842a0$export$c28a66ae6d31a34b);
    const $257d172b6cc842a0$var$jsmGlobalSettingsPages = [
        '/jira/settings/products/jira-service-management-configuration',
        '/jira/settings/products/jira-service-management-email-requests',
        '/jira/settings/products/servicedesk/customer-access',
        '/jira/settings/products/servicedesk/authentication',
        '/jira/settings/products/servicedesk/organizations',
        '/jira/settings/products/jira-service-management-incident-management-tools',
        '/jira/settings/products/jira-service-management-compliance',
        '/jira/settings/products/servicedesk/feature-usage'
    ];
    const $257d172b6cc842a0$var$eocGlobalSettingsPages = [
        '/jira/settings/products/ops/roles',
        '/jira/settings/products/ops/role-assignment',
        '/jira/settings/products/ops/role-based-notifications',
        '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        '/jira/settings/products/ops/integrations',
        '/jira/settings/products/ops/syncs',
        '/jira/settings/products/ops/policies',
        '/jira/settings/products/ops/maintenance',
        '/jira/settings/products/ops/escalation-policies',
        '/jira/settings/products/ops/incoming-call',
        '/jira/settings/products/ops/jira-service-management-audit-logs',
        '/jira/settings/products/ops/reports'
    ];
    const $257d172b6cc842a0$var$isJsmGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$jsmGlobalSettingsPages.includes(route);
    const $257d172b6cc842a0$var$isEocGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$eocGlobalSettingsPages.includes(route);
    const $257d172b6cc842a0$export$c28a66ae6d31a34b = (route)=>$257d172b6cc842a0$var$isJsmGlobalSettingsPage(route) || $257d172b6cc842a0$var$isEocGlobalSettingsPage(route);
});
parcelRegister("cOwuh", function(module, exports) {
    $parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", ()=>$5589b5a823eb55d2$export$76c6ab35aee49900);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $5589b5a823eb55d2$var$BannerTransition = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("boNJG")).then((module)=>module.BannerJsmPackagingUpdate), {
        moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
    });
    const $5589b5a823eb55d2$export$76c6ab35aee49900 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-banner-jsm-packaging-updates",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5589b5a823eb55d2$var$BannerTransition, null));
});
parcelRegister("boNJG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3lSYe").then(()=>parcelRequire('kuFA7'));
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("3Uek9", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$241dc29db19bb69f$export$18084206b9430153);
    var $l71WK;
    var $65Ltd;
    var $8iyFV;
    var $cPiXk;
    var $3HwlS;
    var $6jY6G;
    var $5PD5h;
    const $241dc29db19bb69f$export$18084206b9430153 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        const isBusinessRouteGroup = route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS);
        const hasProjectViewNavigation = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans);
        const hasTheming = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav) || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE) : hasProjectViewNavigation;
        const isInset = hasTheming && !isBusinessRouteGroup;
        return {
            isInset: isInset,
            hasTheming: hasTheming,
            hasProjectViewNavigation: hasProjectViewNavigation
        };
    };
});
parcelRegister("8iyFV", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalNavPlans", ()=>$ee88d7a7192b9e04$export$84e1a5f003939496);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $ee88d7a7192b9e04$var$LazyHorizontalPlansNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("k63f8")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
    });
    const $ee88d7a7192b9e04$export$84e1a5f003939496 = ({ store: store })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-plans-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ee88d7a7192b9e04$var$LazyHorizontalPlansNav, {
            store: store
        }));
});
parcelRegister("k63f8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gnY34")),
        $6fhBS("dsiAd"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("aqH3P")
    ]).then(()=>parcelRequire('fYibJ'));
});
parcelRegister("aMHR6", function(module, exports) {
    "use strict";
    var $g1Pp8 = parcelRequire("g1Pp8");
    module.exports = $g1Pp8(function(bundle) {
        return new Promise(function(resolve, reject) {
            var existingLinks = document.getElementsByTagName('link');
            if ([].concat(existingLinks).some(function isCurrentBundle(link) {
                return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
            })) {
                resolve();
                return;
            }
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = bundle;
            link.onerror = function(e) {
                link.onerror = link.onload = null;
                link.remove();
                reject(e);
            };
            link.onload = function() {
                link.onerror = link.onload = null;
                resolve();
            };
            document.getElementsByTagName('head')[0].appendChild(link);
        });
    });
});
parcelRegister("g1Pp8", function(module, exports) {
    "use strict";
    var $bab49d2fea43af49$var$cachedBundles = {};
    var $bab49d2fea43af49$var$cachedPreloads = {};
    var $bab49d2fea43af49$var$cachedPrefetches = {};
    function $bab49d2fea43af49$var$getCache(type) {
        switch(type){
            case 'preload':
                return $bab49d2fea43af49$var$cachedPreloads;
            case 'prefetch':
                return $bab49d2fea43af49$var$cachedPrefetches;
            default:
                return $bab49d2fea43af49$var$cachedBundles;
        }
    }
    module.exports = function(loader, type) {
        return function(bundle) {
            var cache = $bab49d2fea43af49$var$getCache(type);
            if (cache[bundle]) return cache[bundle];
            return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
                delete cache[bundle];
                throw e;
            });
        };
    };
});
parcelRegister("6ncxj", function(module, exports) {
    $parcel$export(module.exports, "sharedLayout", ()=>$1b12ea52aa3c0323$export$5f4dc7c98070d93e);
    var $5uXOq = parcelRequire("5uXOq");
    var $doxsH;
    var $2vSU6;
    var $8JIza;
    var $gmGW3;
    var $8NA5p;
    var $7kqCT;
    var $7jo2g;
    var $7XluA;
    var $4mO32;
    var $7N30e;
    var $6s1PB;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $3lMZZ;
    var $7Lkcv;
    var $9YvQF;
    var $km1Z8;
    var $e1ETT;
    var $aqDVH;
    var $lpwtK;
    var $jElqQ;
    var $kKa8l;
    var $bmetd;
    var $izgL1;
    var $lyCmi;
    var $1XrjK;
    var $kgLzl;
    var $dYRe6;
    var $koeKL;
    var $9yehD;
    var $dz0Q5;
    var $kXv2J;
    var $4p6rw;
    var $hPtZI;
    var $ec3NH;
    var $lDu2T;
    var $jnXgM;
    const $1b12ea52aa3c0323$var$isPendoIntegrationEnabled = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira-frontend-pendo-analytics_s6sj5');
    const $1b12ea52aa3c0323$var$Global = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("EgodS")), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
    });
    const $1b12ea52aa3c0323$var$Navigation = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("aQHAS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
    });
    const $1b12ea52aa3c0323$var$Trackers = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("i1RfD")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
    });
    const $1b12ea52aa3c0323$var$RemoteActions = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("iRWz9")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
    });
    const $1b12ea52aa3c0323$var$AfterPaintIssuePreEval = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("D2tCn")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/index.tsx"
    });
    const $1b12ea52aa3c0323$var$AsyncBrowserStorageControlsInit = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("lGCVr")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
    });
    const $1b12ea52aa3c0323$var$runtimeProps = {};
    const $1b12ea52aa3c0323$var$entryPointParams = {};
    const $1b12ea52aa3c0323$export$70b554b486395223 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kXv2J")).upgradeOnboardingExperimentEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.upgradeOnboardingExperiment",
            packageName: "issue-view",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        });
    };
    const $1b12ea52aa3c0323$export$3859d35c5447350b = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kgLzl")).rovoVideoModalEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.rovoVideoPlayer",
            packageName: "rovo-video-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        });
    };
    const $1b12ea52aa3c0323$export$3211958f96133af8 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aqDVH")).jiraLossAversionModalEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraLossAversion",
            packageName: "jira-loss-aversion-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        });
    };
    const $1b12ea52aa3c0323$export$39abefd31dfea2bd = ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectId = String(project?.id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yehD")).AsyncTrialSprintBoardModalEntryPoint), {
            currentProjectId: projectId
        });
    };
    const $1b12ea52aa3c0323$export$bb0d8fff645668ce = ()=>{
        const cloudID = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type) || null;
        const productKey = (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const deferEditionModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudID,
                productKey: productKey
            }), [
            cloudID,
            productKey
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7kqCT")).jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
        const onComplete = (0, $5uXOq.useCallback)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NA5p")).AsyncDeferEditionEPCheckWrapper), {
            onComplete: onComplete
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "growth.jiraDeferEditionModal",
            packageName: "jira-defer-edition-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
        }));
    };
    const $1b12ea52aa3c0323$var$DeferEditionModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('cross-flow-defer-edition-communication-gate', $1b12ea52aa3c0323$export$bb0d8fff645668ce, ()=>null);
    const $1b12ea52aa3c0323$var$DeferRovoVideoModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('rovo_video_player_gate', $1b12ea52aa3c0323$export$3859d35c5447350b, ()=>null);
    const $1b12ea52aa3c0323$var$DeferJiraLossAversionModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_loss_aversion_standard_shared_layout_gate', $1b12ea52aa3c0323$export$3211958f96133af8, ()=>null);
    const $1b12ea52aa3c0323$var$DeferTrialSprintBoardModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw-trial-sprint-board-modal-gate', $1b12ea52aa3c0323$export$39abefd31dfea2bd, ()=>null);
    const $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, (0, parcelRequire("lyCmi")).AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
    $1b12ea52aa3c0323$var$DeferEditionModal.displayName = 'DeferEditionModal';
    $1b12ea52aa3c0323$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
    $1b12ea52aa3c0323$var$DeferJiraLossAversionModal.displayName = 'DeferJiraLossAversionModal';
    $1b12ea52aa3c0323$var$DeferTrialSprintBoardModal.displayName = 'DeferTrialSprintBoardModal';
    $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
    const $1b12ea52aa3c0323$var$sharedGlobalComponents = [
        ...false ? [] : [
            (0, (0, parcelRequire("kKa8l")).MatchedRouteListener),
            (0, (0, parcelRequire("bmetd")).PreviousRouterStateListener),
            (0, (0, parcelRequire("lDu2T")).LoadingPhaseManager),
            (0, (0, parcelRequire("3lMZZ")).LoadingBarUIController),
            (0, (0, parcelRequire("doxsH")).default),
            (0, (0, parcelRequire("ec3NH")).BreadcrumbAdapter),
            (0, (0, parcelRequire("izgL1")).default),
            (0, (0, parcelRequire("jElqQ")).PageDwellAnalyticsListener),
            (0, (0, parcelRequire("km1Z8")).ImperativeAPI),
            (0, (0, parcelRequire("jnXgM")).TrackClicksBeforeTTI),
            (0, (0, parcelRequire("dYRe6")).default),
            (0, (0, parcelRequire("dz0Q5")).AsyncUpflowIframeComponent),
            (0, (0, parcelRequire("4p6rw")).JiraHeritageLoader),
            $1b12ea52aa3c0323$var$AsyncBrowserStorageControlsInit,
            ...$1b12ea52aa3c0323$var$isPendoIntegrationEnabled() ? [
                (0, (0, parcelRequire("8JIza")).AsyncPendoAnalyticsWrapper)
            ] : [],
            (0, (0, parcelRequire("7N30e")).default),
            $1b12ea52aa3c0323$var$RemoteActions,
            (0, (0, parcelRequire("e1ETT")).AsyncLockScreenExperimentSharedWrapper),
            (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_upgrade_onboarding'), $1b12ea52aa3c0323$export$70b554b486395223, ()=>null),
            $1b12ea52aa3c0323$var$DeferEditionModal,
            $1b12ea52aa3c0323$var$DeferRovoVideoModal,
            $1b12ea52aa3c0323$var$DeferJiraLossAversionModal,
            $1b12ea52aa3c0323$var$DeferTrialSprintBoardModal,
            (0, (0, parcelRequire("7jo2g")).AsyncEndOfTrialMessageSharedWrapper),
            $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal
        ],
        $1b12ea52aa3c0323$var$Global,
        $1b12ea52aa3c0323$var$Navigation,
        $1b12ea52aa3c0323$var$Trackers,
        $1b12ea52aa3c0323$var$AfterPaintIssuePreEval
    ];
    const $1b12ea52aa3c0323$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9YvQF")).SafeEmbeddedConfluencePanel), null) : null;
    };
    const $1b12ea52aa3c0323$export$5f4dc7c98070d93e = (0, (0, parcelRequire("1XrjK")).createLayout)({
        rightSidebars: [
            (0, (0, parcelRequire("7Lkcv")).SafeHelpPanel),
            (0, (0, parcelRequire("gmGW3")).SafeConversationAssistantPanel),
            $1b12ea52aa3c0323$var$SafeEmbeddedConfluencePanelWithExperiments
        ],
        globalComponents: $1b12ea52aa3c0323$var$sharedGlobalComponents
    });
});
parcelRegister("doxsH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$899e926f09852ef7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $90yGq;
    var $1NZBJ;
    const $899e926f09852ef7$var$CacheRegistry = ()=>{
        const accountIdLoggedInUser = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1NZBJ")).default).set(accountIdLoggedInUser ?? 'anonymous');
        }, [
            accountIdLoggedInUser
        ]);
        return null;
    };
    var $899e926f09852ef7$export$2e2bcd8739ae039 = $899e926f09852ef7$var$CacheRegistry;
});
parcelRegister("1NZBJ", function(module, exports) {
    $parcel$export(module.exports, "CACHE_PREFIX", ()=>$e0fd77b45718946f$export$69ca515e4489d790);
    $parcel$export(module.exports, "scopeGuard", ()=>$e0fd77b45718946f$export$653cd03438bb0386);
    $parcel$export(module.exports, "default", ()=>$e0fd77b45718946f$export$2e2bcd8739ae039);
    var $bSSG7;
    let $e0fd77b45718946f$var$resolveCachePromise;
    const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
        $e0fd77b45718946f$var$resolveCachePromise = resolve;
    });
    const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
    const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
    const $e0fd77b45718946f$var$TIMEOUT = 10000;
    const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
        let id;
        const timeout = new Promise((resolve, reject)=>{
            id = setTimeout(()=>{
                const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
                storage.clearAll();
                reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
            }, ms);
        });
        return Promise.race([
            promise,
            timeout
        ]).then((result)=>{
            clearTimeout(id);
            return result;
        });
    };
    const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
    const $e0fd77b45718946f$var$config = {
        devTools: false,
        scopes: {
            prev: null,
            current: null
        },
        set (scopeKey) {
            const storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
            if (this.scopes.prev === null && this.scopes.current === null) {
                if (scopeKeyInStorage) {
                    this.scopes.prev = scopeKeyInStorage;
                    this.scopes.current = scopeKeyInStorage;
                }
            }
            if (this.scopes.current !== scopeKey) {
                if (this.scopes.current !== null) storage.clearAll();
                this.scopes.prev = this.scopes.current;
                this.scopes.current = scopeKey;
                storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
            }
            $e0fd77b45718946f$var$resolveCachePromise();
        },
        get () {
            return this.scopes.current;
        }
    };
    var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;
});
parcelRegister("bSSG7", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageProvider", ()=>$63804f80e89e547d$export$697e65b1658f821b);
    $parcel$export(module.exports, "createLocalExpirableStorageProvider", ()=>$63804f80e89e547d$export$59acef2b3ab1df90);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $dEJQ9;
    const $63804f80e89e547d$export$697e65b1658f821b = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("dEJQ9")).makeLocalStore)()));
    const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("dEJQ9")).makeLocalExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("fNVZf", function(module, exports) {
    $parcel$export(module.exports, "plugins", ()=>$04caddce42518619$export$8b3ca321c77fdea6);
    $parcel$export(module.exports, "createStorageProvider", ()=>$04caddce42518619$export$8441605555fbd60c);
    var $fKgem = parcelRequire("fKgem");
    var $c7J1U;
    const $04caddce42518619$export$8b3ca321c77fdea6 = [
        (0, ($parcel$interopDefault($fKgem))),
        (0, (0, parcelRequire("c7J1U")).default)
    ];
    const $04caddce42518619$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);
});
parcelRegister("c7J1U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99d922a6a243a194$export$2e2bcd8739ae039);
    var $jcw0u;
    var $cuNKJ;
    function $99d922a6a243a194$var$cleanUpPlugin() {
        const self = this;
        const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, (0, parcelRequire("cuNKJ")).NAMESPACE));
        function set(superFn, key, val) {
            try {
                if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.set(key, Date.now());
                superFn();
            } catch (e) {
                if (e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'browserLocalStorageFullError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            namespace: self._namespacePrefix
                        },
                        error: e,
                        skipSentry: true
                    });
                    if (self.cleanWhenFull()) self.set(superFn, key, val);
                } else {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'storageCleanupPluginError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            isLegacyFunction: false
                        },
                        error: e
                    });
                    throw e;
                }
            }
        }
        function remove(superFn, key) {
            if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.remove(key);
            return superFn();
        }
        function getTotalCount() {
            let count = 0;
            self.each(()=>{
                count += 1;
            });
            return count;
        }
        function cleanWhenFull(superFn, minAge = (0, (0, parcelRequire("cuNKJ")).FOUR_WEEKS)) {
            const currTime = Date.now();
            const numKeysBefore = self.getTotalCount();
            self.each((_value, key)=>{
                const created = !self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE)) ? timestamps.get(key) : null;
                if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
            });
            const itemsRemovedCount = numKeysBefore - self.getTotalCount();
            if (!itemsRemovedCount && minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK) >= (0, (0, parcelRequire("cuNKJ")).ONE_WEEK)) return self.cleanWhenFull(minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK));
            return itemsRemovedCount === 0;
        }
        return {
            set: set,
            remove: remove,
            cleanWhenFull: cleanWhenFull,
            getTotalCount: getTotalCount
        };
    }
    var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;
});
parcelRegister("cuNKJ", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE", ()=>$d21613ddd27d5bbf$export$6aad947bda0f3f46);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$d21613ddd27d5bbf$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "FOUR_WEEKS", ()=>$d21613ddd27d5bbf$export$6e952fa7d47190cf);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$da99ebca8f453abd);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$ea28dfd9333cda2d);
    const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
    const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
    const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
    const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
    const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;
});
parcelRegister("dEJQ9", function(module, exports) {
    $parcel$export(module.exports, "makeLocalStore", ()=>$dcae70c06981fc99$export$b2631085fe8db7af);
    $parcel$export(module.exports, "makeLocalExpirableStore", ()=>$dcae70c06981fc99$export$cf816b43e73de947);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $4Zgux = parcelRequire("4Zgux");
    var $2NjNT = parcelRequire("2NjNT");
    var $fNVZf;
    const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
parcelRegister("8JIza", function(module, exports) {
    $parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", ()=>$5adeefc5ea77d534$export$1c388e7c464f3699);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $hPtZI;
    const $5adeefc5ea77d534$var$AsyncPendoAnalytics = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("hd4ok")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
        moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
    });
    const $5adeefc5ea77d534$export$1c388e7c464f3699 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: "martech",
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5adeefc5ea77d534$var$AsyncPendoAnalytics, null)));
});
parcelRegister("hd4ok", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4sJqf").then(()=>parcelRequire('8bI7u'));
});
parcelRegister("gmGW3", function(module, exports) {
    $parcel$export(module.exports, "SafeConversationAssistantPanel", ()=>$836bcaaba692e6c5$export$453401d0b697d2db);
    var $5uXOq = parcelRequire("5uXOq");
    var $H9XvI = parcelRequire("H9XvI");
    var $7CMCs;
    var $hsmeR;
    var $95EVP;
    var $2vgok;
    const $836bcaaba692e6c5$var$PanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const panelId = rightSidebarCurrentState?.panelId;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $15bb9f18ac59c51b$export$dffb4ed44e20ea9a)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                    createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'aiMatePanel',
                        source: 'AIMate',
                        tags: [
                            'atlaskit',
                            'aiMate'
                        ]
                    }).fire((0, $H9XvI.FabricChannel).aiMate);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            createAnalyticsEvent,
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, $15bb9f18ac59c51b$export$dffb4ed44e20ea9a)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vgok")).JiraConversationAssistant), {
            onClosePanel: closeCurrentRightSidebar
        });
    };
    const $836bcaaba692e6c5$export$453401d0b697d2db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-conversation-assistant-panel",
            packageName: "jiraConversationAssistant"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($836bcaaba692e6c5$var$PanelInLayout, null));
});
const $15bb9f18ac59c51b$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $15bb9f18ac59c51b$export$64aee74ba59709e5 = 439;
const $15bb9f18ac59c51b$export$1c07393c5bb1bc27 = 439;
const $15bb9f18ac59c51b$export$aa3478deee7adbeb = 350;
const $15bb9f18ac59c51b$export$21e515a86cd1733b = 'Chat';
parcelRegister("2vgok", function(module, exports) {
    $parcel$export(module.exports, "JiraConversationAssistant", ()=>$2321abcc17b38bef$export$da8473714271a41d);
    var $5uXOq = parcelRequire("5uXOq");
    var $294ns;
    var $6T4rd;
    var $jJ1Sb;
    var $3khFH;
    var $8JtYZ;
    var $co1wz;
    var $4R6GH;
    var $j8DrX;
    var $hsmeR;
    var $8zOmE;
    var $95EVP;
    var $14XJw;
    var $fY39E;
    var $koeKL;
    const $2321abcc17b38bef$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
    const $2321abcc17b38bef$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const isSyntheticTenant = (0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant');
        let baseUrl = '/gateway/api/assist';
        if ((0, (0, parcelRequire("co1wz")).ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
        else if ((0, (0, parcelRequire("294ns")).getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
        const config = (0, $5uXOq.useMemo)(()=>({
                displaySubmitFlag: true,
                siteId: cloudId,
                activationId: activationId,
                product: 'jira',
                orgId: orgId,
                experienceId: 'ai-mate',
                assistanceServiceConfig: {
                    headers: isSyntheticTenant ? {
                        [$2321abcc17b38bef$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                    } : {},
                    baseUrl: baseUrl
                }
            }), [
            cloudId,
            activationId,
            orgId,
            isSyntheticTenant,
            baseUrl
        ]);
        const handleResizeComplete = (0, $5uXOq.useCallback)((width)=>{
            openRightSidebar((0, $15bb9f18ac59c51b$export$dffb4ed44e20ea9a), width);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'aiMatePanel'
            }));
        }, [
            openRightSidebar,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8JtYZ")).ResizeWrapper), {
            onResizeComplete: handleResizeComplete
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $2321abcc17b38bef$var$conversationAssistantWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3khFH")).default), {
            testId: "conversation-assistant.ui.conversation-assistant",
            onCloseChat: onClosePanel,
            config: config
        })));
    };
    const $2321abcc17b38bef$var$conversationAssistantWrapperStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        width: '100%'
    });
});
parcelRegister("3khFH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c0e9076e367da23$export$2e2bcd8739ae039);
    var $4qBtX = parcelRequire("4qBtX");
    var $9c0e9076e367da23$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("f5VyL")),
        loading: ()=>null
    });
});
parcelRegister("4qBtX", function(module, exports) {
    "use strict";
    var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
    var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
    function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
        if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
        return getModuleIds().every(function(moduleId) {
            return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
        });
    }
    function $3396aa4dae68f4b9$var$load(loader) {
        var promise = loader();
        var state = {
            loading: true,
            loaded: null,
            error: null
        };
        state.promise = promise.then(function(loaded) {
            state.loading = false;
            state.loaded = loaded;
            return loaded;
        }).catch(function(err) {
            state.loading = false;
            state.error = err;
            throw err;
        });
        return state;
    }
    function $3396aa4dae68f4b9$var$loadMap(obj) {
        var state = {
            loading: false,
            loaded: {},
            error: null
        };
        var promises = [];
        try {
            Object.keys(obj).forEach(function(key) {
                var result = $3396aa4dae68f4b9$var$load(obj[key]);
                if (!result.loading) {
                    state.loaded[key] = result.loaded;
                    state.error = result.error;
                } else state.loading = true;
                promises.push(result.promise);
                result.promise.then(function(res) {
                    state.loaded[key] = res;
                }).catch(function(err) {
                    state.error = err;
                });
            });
        } catch (err) {
            state.error = err;
        }
        state.promise = Promise.all(promises).then(function(res) {
            state.loading = false;
            return res;
        }).catch(function(err) {
            state.loading = false;
            throw err;
        });
        return state;
    }
    function $3396aa4dae68f4b9$var$resolve(obj) {
        return obj && obj.__esModule ? obj.default : obj;
    }
    function $3396aa4dae68f4b9$var$render(loaded, props) {
        return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
    }
    function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
        var _class, _temp;
        if (!options.loading) throw new Error("react-loadable requires a `loading` component");
        var opts = Object.assign({
            loader: null,
            loading: null,
            delay: 200,
            timeout: null,
            render: $3396aa4dae68f4b9$var$render,
            webpack: null,
            modules: null
        }, options);
        var res = null;
        function init() {
            if (!res) res = loadFn(opts.loader);
            return res.promise;
        }
        $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
        if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
            if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
        });
        return _temp = _class = function(_React$Component) {
            $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
            function LoadableComponent(props) {
                $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
                var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
                _this.retry = function() {
                    _this.setState({
                        error: null,
                        loading: true,
                        timedOut: false
                    });
                    res = loadFn(opts.loader);
                    _this._loadModule();
                };
                init();
                _this.state = {
                    error: res.error,
                    pastDelay: false,
                    timedOut: false,
                    loading: res.loading,
                    loaded: res.loaded
                };
                return _this;
            }
            LoadableComponent.preload = function preload() {
                return init();
            };
            LoadableComponent.prototype.componentWillMount = function componentWillMount() {
                this._mounted = true;
                this._loadModule();
            };
            LoadableComponent.prototype._loadModule = function _loadModule() {
                var _this2 = this;
                if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                    _this2.context.loadable.report(moduleName);
                });
                if (!res.loading) return;
                if (typeof opts.delay === "number") {
                    if (opts.delay === 0) this.setState({
                        pastDelay: true
                    });
                    else this._delay = setTimeout(function() {
                        _this2.setState({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
                if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                    _this2.setState({
                        timedOut: true
                    });
                }, opts.timeout);
                var update = function update() {
                    if (!_this2._mounted) return;
                    _this2.setState({
                        error: res.error,
                        loaded: res.loaded,
                        loading: res.loading
                    });
                    _this2._clearTimeouts();
                };
                res.promise.then(function() {
                    update();
                }).catch(function(err) {
                    update();
                });
            };
            LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
                this._mounted = false;
                this._clearTimeouts();
            };
            LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            };
            LoadableComponent.prototype.render = function render() {
                if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                    isLoading: this.state.loading,
                    pastDelay: this.state.pastDelay,
                    timedOut: this.state.timedOut,
                    error: this.state.error,
                    retry: this.retry
                });
                else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
                else return null;
            };
            return LoadableComponent;
        }($5uXOq.Component), _class.contextTypes = {
            loadable: (0, parcelRequire("8rCP3")).shape({
                report: (0, parcelRequire("8rCP3")).func.isRequired
            })
        }, _temp;
    }
    function $3396aa4dae68f4b9$var$Loadable(opts) {
        return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
    }
    function $3396aa4dae68f4b9$var$LoadableMap(opts) {
        if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
        return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
    }
    $3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
    var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
        $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
        function Capture() {
            $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
            return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
        }
        Capture.prototype.getChildContext = function getChildContext() {
            return {
                loadable: {
                    report: this.props.report
                }
            };
        };
        Capture.prototype.render = function render() {
            return $5uXOq.Children.only(this.props.children);
        };
        return Capture;
    }($5uXOq.Component);
    $3396aa4dae68f4b9$var$Capture.propTypes = {
        report: (0, parcelRequire("8rCP3")).func.isRequired
    };
    $3396aa4dae68f4b9$var$Capture.childContextTypes = {
        loadable: (0, parcelRequire("8rCP3")).shape({
            report: (0, parcelRequire("8rCP3")).func.isRequired
        }).isRequired
    };
    $3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
    function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
        var promises = [];
        while(initializers.length){
            var init = initializers.pop();
            promises.push(init());
        }
        return Promise.all(promises).then(function() {
            if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
        });
    }
    $3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
        return new Promise(function(resolve, reject) {
            $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
        });
    };
    $3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
        return new Promise(function(resolve, reject) {
            $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
        });
    };
    module.exports = $3396aa4dae68f4b9$var$Loadable;
});
parcelRegister("f5VyL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9OXuh")
    ]).then(()=>parcelRequire('7vx7Y'));
});
parcelRegister("8JtYZ", function(module, exports) {
    $parcel$export(module.exports, "ResizeWrapper", ()=>$d6744ce8d684b10d$export$c7990a6594835e51);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $fHYEP;
    var $6T4rd;
    var $jJ1Sb;
    const $d6744ce8d684b10d$var$rootStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        right: 'space.0',
        display: 'flex',
        position: 'fixed',
        height: `calc(100vh - ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT)} - ${(0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT)})`
    });
    const $d6744ce8d684b10d$var$handleStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        cursor: 'ew-resize',
        userSelect: 'none',
        position: 'absolute',
        top: 'space.200',
        bottom: 'space.0',
        left: 'space.0',
        width: '24px',
        borderTopLeftRadius: 'border.radius.200',
        transition: 'border 0.2s ease-in-out',
        borderLeft: '2px solid transparent',
        ':hover': {
            borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
        }
    });
    const $d6744ce8d684b10d$var$handleSpacerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        width: '24px',
        position: 'absolute',
        display: 'block',
        left: '-24px',
        top: 'space.0',
        bottom: 'space.0'
    });
    const $d6744ce8d684b10d$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $15bb9f18ac59c51b$export$64aee74ba59709e5), minWidth: minWidth = (0, $15bb9f18ac59c51b$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
        const [width, setWidth] = (0, $5uXOq.useState)(initialWidth);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const isDraggingRef = (0, $5uXOq.useRef)(false);
        const initialMousePositionRef = (0, $5uXOq.useRef)(0);
        const prevDistanceMovedRef = (0, $5uXOq.useRef)(0);
        const rafRef = (0, $5uXOq.useRef)(null);
        const getWrapperWidth = ()=>{
            return wrapperRef.current?.getBoundingClientRect()?.width || 0;
        };
        const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
            if (!isDraggingRef.current) return;
            const distanceMoved = event.clientX - initialMousePositionRef.current;
            let updatedWidth;
            const currentWidth = getWrapperWidth();
            if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
            prevDistanceMovedRef.current = distanceMoved;
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            rafRef.current = requestAnimationFrame(()=>{
                if (distanceMoved < 0) {
                    updatedWidth = currentWidth + Math.abs(distanceMoved);
                    if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
                } else {
                    updatedWidth = currentWidth - distanceMoved;
                    if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
                }
                setWidth(updatedWidth);
                initialMousePositionRef.current = event.clientX;
            });
        }, [
            maxWidth,
            minWidth
        ]);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            isDraggingRef.current = true;
            initialMousePositionRef.current = event.clientX;
        }, []);
        const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
            if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
            isDraggingRef.current = false;
        }, [
            onResizeComplete,
            width
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const mouseMoveHandler = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'mousemove',
                listener: handleMouseMove
            });
            const mouseUpHandler = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'mouseup',
                listener: handleMouseUp
            });
            return ()=>{
                mouseMoveHandler();
                mouseUpHandler();
                if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            };
        }, [
            handleMouseMove,
            handleMouseUp
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d6744ce8d684b10d$var$rootStyles,
            ref: wrapperRef,
            role: "presentation",
            testId: "panel-resize-wrapper",
            style: {
                width: width,
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            testId: "panel-resize-handle",
            onMouseDown: handleMouseDown,
            xcss: $d6744ce8d684b10d$var$handleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d6744ce8d684b10d$var$handleSpacerStyles
        })), children);
    };
});
parcelRegister("fY39E", function(module, exports) {
    $parcel$export(module.exports, "useActivationId", ()=>$d72c67677898c114$export$43686faa787c943);
    var $9OXo1;
    const $d72c67677898c114$export$43686faa787c943 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.activationId;
    };
});
parcelRegister("koeKL", function(module, exports) {
    $parcel$export(module.exports, "useCloudId", ()=>$559e3c14e9652b55$export$9da0f7c65f28ed16);
    var $9OXo1;
    const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.cloudId;
    };
});
parcelRegister("8NA5p", function(module, exports) {
    $parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", ()=>$2684c9c6a6fb887b$export$4fa5b26bccc7e3df);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $hPtZI;
    const $2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("9wiVM")).then(({ EPCheck: EPCheck })=>EPCheck), {
        ssr: false,
        moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
    });
    const $2684c9c6a6fb887b$export$4fa5b26bccc7e3df = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "defer-edition-ep-check-async",
            packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $ac4f2a72f86d65c9$export$d57b6b390e78d90f),
            id: "defer-edition-ep-check-async",
            packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck, props)));
});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
parcelRegister("9wiVM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bVgxH").then(()=>parcelRequire('1DysC'));
});
parcelRegister("7kqCT", function(module, exports) {
    $parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", ()=>$110a94ef04661997$export$51f384a783f47807);
    var $fiH7W;
    var $2Ftxm;
    var $ikgNX;
    const $110a94ef04661997$var$Fallback = ()=>null;
    const $110a94ef04661997$export$51f384a783f47807 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(async ()=>{
            if (!false) return (parcelRequire("bg8yu")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
            return $110a94ef04661997$var$Fallback;
        }, {
            moduleId: "fe342c6b"
        }),
        getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
                queries: {
                    deferEditionModal: {
                        parameters: (0, (0, parcelRequire("fiH7W")).default),
                        variables: {
                            cloudId: cloudId,
                            productKey: productKey
                        }
                    }
                }
            })
    });
});
parcelRegister("fiH7W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d18804309a0f9ffd$export$2e2bcd8739ae039);
    const $d18804309a0f9ffd$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
            "metadata": {},
            "name": "src_DeferEditionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d18804309a0f9ffd$export$2e2bcd8739ae039 = $d18804309a0f9ffd$var$node;
});
parcelRegister("bg8yu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hmyGT")
    ]).then(()=>parcelRequire('8IIKL'));
});
parcelRegister("7jo2g", function(module, exports) {
    $parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", ()=>$b603c0291b5c0134$export$ae154a7bf883999f);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $hPtZI;
    var $bZB1h;
    const $b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("kHnWt")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
        moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
    });
    const $b603c0291b5c0134$export$ae154a7bf883999f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "end-of-trial-message-shared-async",
            packageName: (0, (0, parcelRequire("bZB1h")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, (0, parcelRequire("bZB1h")).TEAM_NAME),
            id: "end-of-trial-message-shared-async",
            packageName: (0, (0, parcelRequire("bZB1h")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));
});
parcelRegister("bZB1h", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$25fa48d758254005$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$25fa48d758254005$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$25fa48d758254005$export$c7e6a6b283196232);
    $parcel$export(module.exports, "END_OF_TRIAL_MESSAGE_AUDIENCES", ()=>$25fa48d758254005$export$1986890201f1a80);
    var $2vSU6;
    const $25fa48d758254005$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
    const $25fa48d758254005$export$d57b6b390e78d90f = 'transmuters-growth';
    const $25fa48d758254005$export$c7e6a6b283196232 = '/gateway/api';
    const $25fa48d758254005$export$1986890201f1a80 = {
        [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: [
            'jpd_standard_end_of_trial_message_day_14',
            'jpd_standard_end_of_trial_message_day_13',
            'jpd_standard_end_of_trial_message_day_12',
            'jpd_standard_end_of_trial_message_day_11',
            'jpd_standard_end_of_trial_message_day_10',
            'jpd_standard_end_of_trial_message_day_9',
            'jpd_standard_end_of_trial_message_day_8',
            'jpd_standard_end_of_trial_message_day_7',
            'jpd_standard_end_of_trial_message_day_6',
            'jpd_standard_end_of_trial_message_day_5',
            'jpd_standard_end_of_trial_message_day_4',
            'jpd_standard_end_of_trial_message_day_3',
            'jpd_standard_end_of_trial_message_day_2',
            'jpd_standard_end_of_trial_message_day_1'
        ],
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: [
            'jsm_standard_end_of_trial_message_day_14',
            'jsm_standard_end_of_trial_message_day_13',
            'jsm_standard_end_of_trial_message_day_12',
            'jsm_standard_end_of_trial_message_day_11',
            'jsm_standard_end_of_trial_message_day_10',
            'jsm_standard_end_of_trial_message_day_9',
            'jsm_standard_end_of_trial_message_day_8',
            'jsm_standard_end_of_trial_message_day_7',
            'jsm_standard_end_of_trial_message_day_6',
            'jsm_standard_end_of_trial_message_day_5',
            'jsm_standard_end_of_trial_message_day_4',
            'jsm_standard_end_of_trial_message_day_3',
            'jsm_standard_end_of_trial_message_day_2',
            'jsm_standard_end_of_trial_message_day_1'
        ]
    };
});
parcelRegister("kHnWt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eXdJ6")
    ]).then(()=>parcelRequire('bOc3m'));
});
parcelRegister("7XluA", function(module, exports) {
    $parcel$export(module.exports, "JiraEntryPointContainer", ()=>$f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
    $parcel$export(module.exports, "NestedEntryPointContainer", ()=>$f4c300dcb0cbacff$export$54db9e88249c9162);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Bm0k;
    var $c5vfY;
    const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        return entryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            placeholderName: "jira-entry-point-container"
        }) : null;
    };
    const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer);
});
parcelRegister("8Bm0k", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointSubscription", ()=>$0458c70c3d6616bf$export$3cd1c81e13390c49);
    var $5uXOq = parcelRequire("5uXOq");
    const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
        const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subject.subscribe(setEntryPointReference);
            setEntryPointReference(subject.getValue());
            return unsubscribe;
        }, [
            subject
        ]);
        return entryPointReference;
    };
});
parcelRegister("c5vfY", function(module, exports) {
    $parcel$export(module.exports, "InternalEntryPointContainer", ()=>$df42b2d5b5551f77$export$5d4dc37edd8a3adb);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7CMCs;
    var $lfTZh;
    var $l8ruj;
    const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            teamName: teamName,
            attributes: errorAttributes,
            fallback: errorFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: placeholderName ?? packageName ?? 'internal-entry-point-container',
            fallback: fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: runtimeProps
        }))));
});
parcelRegister("4mO32", function(module, exports) {
    $parcel$export(module.exports, "useEntryPoint", ()=>$f8987436643ccece$export$338256068bc140fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $c8WsS;
    var $9CqsK;
    var $j1gA4;
    var $bzXq1;
    const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS))=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, (0, parcelRequire("j1gA4")).useEntryPointLoadManager)(entryPoint, entryPointParams);
        const { startMetric: startMetric, stopMetric: stopMetric } = (0, (0, parcelRequire("bzXq1")).useMetricLogger)(metric);
        const entryPointActions = (0, (0, parcelRequire("9CqsK")).useEntryPointActions)(loadActions, options, startMetric);
        return (0, $5uXOq.useMemo)(()=>({
                entryPointActions: entryPointActions,
                entryPointReferenceSubject: entryPointReferenceSubject,
                stopMetric: stopMetric
            }), [
            entryPointActions,
            entryPointReferenceSubject,
            stopMetric
        ]);
    };
});
parcelRegister("c8WsS", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_OPTIONS", ()=>$34664e57314d5c26$export$93ca5d3f8675ae4c);
    const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
        preloadMaxAge: 2000,
        timeToIntent: 200
    };
});
parcelRegister("9CqsK", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointActions", ()=>$7bc2afeacf23b901$export$90681c8c3a56f09a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jQsty;
    var $c8WsS;
    const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
    const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
        const preloadIntentTimeout = (0, $5uXOq.useRef)();
        const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
        const preloadLastRequested = (0, $5uXOq.useRef)(0);
        const cancelPreload = (0, $5uXOq.useCallback)(()=>{
            if (!(0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
                clearTimeout(preloadIntentTimeout.current);
                clearTimeout(preloadMaxAgeTimeout.current);
            }
        }, []);
        const load = (0, $5uXOq.useCallback)(()=>{
            cancelPreload();
            startMetric(preloadLastRequested.current);
            if (preloadLastRequested.current > 0) commitPreload();
            else loadEntryPoint();
            preloadLastRequested.current = 0;
        }, [
            cancelPreload,
            commitPreload,
            loadEntryPoint,
            startMetric
        ]);
        const preload = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
            cancelPreload();
            preloadIntentTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = Date.now();
                loadEntryPoint({
                    isPreload: true
                });
                preloadMaxAgeTimeout.current = setTimeout(()=>{
                    preloadLastRequested.current = 0;
                }, preloadMaxAge);
            }, timeToIntent);
        }, [
            cancelPreload,
            loadEntryPoint,
            preloadMaxAge,
            timeToIntent
        ]);
        (0, $5uXOq.useEffect)(()=>cancelPreload, [
            cancelPreload
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                cancelPreload: cancelPreload,
                load: load,
                preload: preload,
                unload: unloadEntryPoint
            }), [
            cancelPreload,
            load,
            preload,
            unloadEntryPoint
        ]);
    };
});
parcelRegister("j1gA4", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointLoadManager", ()=>$d6e83c6db8fa388b$export$bfae318f9651db2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fiv1r;
    var $iU8T2;
    const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const canLoad = (0, $5uXOq.useRef)(true);
        const timer = (0, $5uXOq.useRef)();
        const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
        const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, (0, parcelRequire("iU8T2")).useEntryPointReferenceSubject)();
        const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
            setEntryPointReference(nextEntryPointReference);
            timer.current = setTimeout(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, (0, parcelRequire("iU8T2")).removeAll)(currentQueue) : (0, (0, parcelRequire("iU8T2")).removeInactiveLoads)(currentQueue);
            }, 0);
        }, [
            setEntryPointReference
        ]);
        const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
            isPreload: false
        })=>{
            if (canLoad.current) {
                const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
                entryPointReferenceQueue.current.unshift({
                    value: reference,
                    isPreload: isPreload
                });
                if (isPreload) entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeRedundantPreloads)(entryPointReferenceQueue.current);
                else setNextUpdate(reference);
            }
        }, [
            entryPoint,
            entryPointParams,
            environmentProvider,
            setNextUpdate
        ]);
        const unload = (0, $5uXOq.useCallback)(()=>{
            setNextUpdate(null);
        }, [
            setNextUpdate
        ]);
        const commitPreload = (0, $5uXOq.useCallback)(()=>{
            const [firstItem] = entryPointReferenceQueue.current;
            if (firstItem?.isPreload) {
                firstItem.isPreload = false;
                setNextUpdate(firstItem.value);
            }
        }, [
            setNextUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearTimeout(timer.current);
                canLoad.current = false;
                entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeAll)(entryPointReferenceQueue.current);
            }, []);
        return {
            entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                    getValue: getValue,
                    subscribe: subscribe
                }), [
                getValue,
                subscribe
            ]),
            loadEntryPoint: load,
            unloadEntryPoint: unload,
            commitPreload: commitPreload
        };
    };
});
parcelRegister("fiv1r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41dee5a929ec50c3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useJiraRelayEnvironmentProvider", ()=>$41dee5a929ec50c3$export$83fb48644dee72f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
            environment: (0, (0, parcelRequire("5yJb9")).default)()
        }, children);
    }
    function $41dee5a929ec50c3$export$83fb48644dee72f0() {
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useMemo)(()=>({
                getEnvironment () {
                    return environment;
                }
            }), [
            environment
        ]);
    }
});
parcelRegister("iU8T2", function(module, exports) {
    $parcel$export(module.exports, "removeRedundantPreloads", ()=>$011b3d8d407c2901$export$a5b3b808f05fede2);
    $parcel$export(module.exports, "removeInactiveLoads", ()=>$011b3d8d407c2901$export$ae329fe3ea179cb4);
    $parcel$export(module.exports, "removeAll", ()=>$011b3d8d407c2901$export$1cfc7aad5cb1833b);
    $parcel$export(module.exports, "useEntryPointReferenceSubject", ()=>$011b3d8d407c2901$export$322c8997d351da6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
        const [, ...potentialRedundantItems] = queue;
        potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
            if (isPreload) value.dispose();
        });
        return queue.filter(({ value: value })=>!value.isDisposed);
    };
    const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
        if (queue.length === 0) return [];
        const [activeItem, ...redundantItems] = queue;
        redundantItems.forEach(({ value: value })=>{
            value.dispose();
        });
        return [
            activeItem
        ];
    };
    const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
        queue.forEach(({ value: value })=>{
            value.dispose();
        });
        return [];
    };
    const $011b3d8d407c2901$export$322c8997d351da6a = ()=>{
        const value = (0, $5uXOq.useRef)(null);
        const subscribers = (0, $5uXOq.useRef)();
        const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
            if (!subscribers.current) subscribers.current = new Set();
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current?.delete(subscriber);
            };
        }, []);
        const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
            value.current = entryPointReference;
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        }, []);
        const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                subscribers.current?.clear();
            }, []);
        return {
            getValue: getValue,
            setEntryPointReference: setEntryPointReference,
            subscribe: subscribe
        };
    };
});
parcelRegister("bzXq1", function(module, exports) {
    $parcel$export(module.exports, "useMetricLogger", ()=>$25198ca8fad8a13c$export$f291ec7cea728e1);
    var $5uXOq = parcelRequire("5uXOq");
    const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
        const preloadStartTime = (0, $5uXOq.useRef)(0);
        const loadStartTime = (0, $5uXOq.useRef)(0);
        const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
            if (metric) {
                metric.start();
                preloadStartTime.current = preloadTime;
                loadStartTime.current = Date.now();
            }
        }, [
            metric
        ]);
        const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
            if (metric) {
                const preloadData = preloadStartTime.current > 0 ? {
                    preloadToStartDuration: loadStartTime.current - preloadStartTime.current
                } : undefined;
                const metricData = preloadData || additionalCustomData ? {
                    customData: {
                        ...preloadData,
                        ...additionalCustomData
                    }
                } : undefined;
                metric.stop(metricData);
            }
        }, [
            metric
        ]);
        return {
            startMetric: startMetric,
            stopMetric: stopMetric
        };
    };
});
parcelRegister("3lMZZ", function(module, exports) {
    $parcel$export(module.exports, "LoadingBarUIController", ()=>$ade6fcbf7908cda7$export$39bdf67fc71ce8c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $d46Cs = parcelRequire("d46Cs");
    var $lsa9q;
    var $bVDE5;
    var $doZTA;
    var $04unK;
    var $cYUbO;
    const $ade6fcbf7908cda7$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            startLoading();
            return ()=>{
                resetLoading();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (loadedState.hasLoaded) finishLoading();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    const $ade6fcbf7908cda7$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
        const [actions, setActions] = (0, $5uXOq.useState)({});
        const sheetRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const loadingBarActions = (0, $d46Cs.createLoadingBarActionController)(sheetRef.current);
            setActions(loadingBarActions || {});
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            ref: sheetRef,
            dangerouslySetInnerHTML: {
                __html: `
                    ${(0, (0, parcelRequire("04unK")).LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, (0, parcelRequire("cYUbO")).generateLoadingBarStyles)(0, (0, (0, parcelRequire("04unK")).getLoadingBarColor)())}
                    }
                `
            }
        }), shouldRender && actions.START && (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: actions.START,
            resetLoading: actions.RESET,
            finishLoading: actions.FINISH
        }));
    };
    const $ade6fcbf7908cda7$export$e068deb20d61b035 = ()=>{
        let currentTransitionsCount = 0;
        let currentRouteIdentifier = '';
        let currentRouteMatch = '';
        let hasTransitioned = false;
        let key = 0;
        return (transitionsCount, routeIdentifier, routeMatch)=>{
            if (transitionsCount !== currentTransitionsCount) {
                currentTransitionsCount = transitionsCount;
                hasTransitioned = true;
            }
            if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
                currentRouteIdentifier = routeIdentifier;
                currentRouteMatch = routeMatch;
                if (hasTransitioned) {
                    hasTransitioned = false;
                    key = currentTransitionsCount;
                }
            }
            return key;
        };
    };
    const $ade6fcbf7908cda7$var$getUniqueTransitionKey = $ade6fcbf7908cda7$export$e068deb20d61b035();
    const $ade6fcbf7908cda7$export$39bdf67fc71ce8c8 = ()=>{
        const [routerState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ transitionsCount: transitionsCount }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const currentRoute = routerState.route && routerState.route.name;
        const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
        const shouldRender = (0, (0, parcelRequire("04unK")).getAllowedRoutes)().includes(currentRoute);
        const routeIdentifier = (0, $5uXOq.useMemo)(()=>$ade6fcbf7908cda7$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
            transitionsCount,
            currentRoute,
            routerState.match
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldRender && loaderFailedInSSR) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
        }, [
            loaderFailedInSSR
        ]);
        if (loaderFailedInSSR) return (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$var$LoadingBarUI, {
            shouldRender: shouldRender,
            routeIdentifier: routeIdentifier
        });
        if (shouldRender && window.JIRA_LOADING_BAR) return (0, ($parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: window.JIRA_LOADING_BAR.START,
            resetLoading: window.JIRA_LOADING_BAR.RESET,
            finishLoading: window.JIRA_LOADING_BAR.FINISH
        });
        return null;
    };
});
parcelRegister("d46Cs", function(module, exports) {
    $parcel$export(module.exports, "createLoadingBarActionController", ()=>$65545b2eb3978204$export$55d67d61d9d2ad3b);
    var $61WP1;
    const $65545b2eb3978204$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $65545b2eb3978204$export$899393f3e23f724b = 15000;
    const $65545b2eb3978204$export$7868b416d8929c55 = 40000;
    const $65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
    const $65545b2eb3978204$var$EXIT_ANIMATION_SPEED = 300;
    const $65545b2eb3978204$export$99d4e8974a739853 = ()=>(0, (0, parcelRequire("61WP1")).getMeta)('ajs-lf-navigation-highlightcolour') || $65545b2eb3978204$export$53d51cc6d57e44da;
    const $65545b2eb3978204$export$4fb8742b05de9693 = (duration)=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
    const $65545b2eb3978204$export$5a43e0f09174e553 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$65545b2eb3978204$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
    const $65545b2eb3978204$export$6beef8c645a63156 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
    const $65545b2eb3978204$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
    const $65545b2eb3978204$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
    const $65545b2eb3978204$var$browserFocusCheck = (action)=>{
        if (document && document.hidden) action();
        else requestAnimationFrame(()=>{
            action();
        });
    };
    const $65545b2eb3978204$export$55d67d61d9d2ad3b = (stylesheet)=>{
        const { sheet: sheet } = stylesheet || {};
        if (!sheet) return undefined;
        let isRunning = false;
        let isDelayed = false;
        let exitAnimationTimer;
        let delayedAnimationTimer;
        let timeoutTimer;
        return {
            START: (duration = $65545b2eb3978204$export$899393f3e23f724b)=>{
                if (isRunning) return;
                isRunning = true;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$4fb8742b05de9693(duration), sheet.cssRules.length);
                });
                delayedAnimationTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isDelayed = true;
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$610cb442736abf53(), sheet.cssRules.length);
                        sheet.insertRule($65545b2eb3978204$export$959e9e99fba397f1($65545b2eb3978204$export$99d4e8974a739853()), sheet.cssRules.length);
                    });
                }, $65545b2eb3978204$export$899393f3e23f724b);
                timeoutTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isRunning = false;
                    isDelayed = false;
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(delayedAnimationTimer);
                    clearTimeout(timeoutTimer);
                }, $65545b2eb3978204$export$7868b416d8929c55);
            },
            FINISH: ()=>{
                if (!isRunning) return;
                isRunning = false;
                if (isDelayed) {
                    isDelayed = false;
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    return;
                }
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$5a43e0f09174e553(), sheet.cssRules.length);
                });
                exitAnimationTimer = setTimeout(()=>{
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $65545b2eb3978204$var$browserFocusCheck(()=>{
                        sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                }, $65545b2eb3978204$var$EXIT_ANIMATION_SPEED + 500);
            },
            RESET: ()=>{
                isRunning = false;
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }
        };
    };
    const $65545b2eb3978204$var$setupLoadingBarActionController = ()=>{
        const LOADER_STYLESHEET_ID = 'loaderStylesheet';
        const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
        if (!styleSheet || !styleSheet.sheet) return;
        window.JIRA_LOADING_BAR = $65545b2eb3978204$export$55d67d61d9d2ad3b(styleSheet);
        if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) window.JIRA_LOADING_BAR.START();
    };
    $65545b2eb3978204$var$setupLoadingBarActionController();
});
parcelRegister("61WP1", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$22b3d998cd498e5f$export$c47913ca32a5c6f7);
    const $22b3d998cd498e5f$export$c47913ca32a5c6f7 = (name)=>{
        const node = document.querySelector(`meta[name="${name}"]`);
        const metaValue = node && node.getAttribute('content');
        return metaValue !== undefined ? metaValue : null;
    };
});
parcelRegister("bVDE5", function(module, exports) {
    $parcel$export(module.exports, "useSpaStateTransition", ()=>$1f866bb77da3c907$export$4d1974344641a2c9);
    $parcel$export(module.exports, "default", ()=>$1f866bb77da3c907$export$2e2bcd8739ae039);
    var $6RCeq;
    var $3sQ5x;
    var $51nlc;
    var $7w9eZ;
    const $1f866bb77da3c907$var$getNavigationStart = ()=>{
        const timestamp = (0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).timing && (0, (0, parcelRequire("6RCeq")).default).timing.navigationStart;
        return timestamp ? new Date(timestamp).toISOString() : undefined;
    };
    const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
        const appNamesToStr = (appNames)=>appNames.join('+') || '?';
        const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
        const currPage = appNamesToStr(collectAppNames(currentPage));
        return `${prevPage} > ${currPage}`;
    };
    const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        return currentPage.startTime;
    };
    const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
            isInitialRender: visitedPages.length === 0,
            transitionsCount: visitedPages.length,
            lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
            lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
            navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
            currentPageId: currentPage.uuid
        });
    const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        displayName: 'SpaStateTransitionStateSubscriber',
        selector: $1f866bb77da3c907$export$aea217a45095ce11
    });
    const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $1f866bb77da3c907$export$aea217a45095ce11
    });
    var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;
});
parcelRegister("04unK", function(module, exports) {
    $parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", ()=>$ac75ec265428b4c8$export$2a3dd4ccb7b0a764);
    $parcel$export(module.exports, "LOADER_STYLESHEET_ID", ()=>$ac75ec265428b4c8$export$79456f717d4431da);
    $parcel$export(module.exports, "getAllowedRoutes", ()=>$ac75ec265428b4c8$export$c82eb262b97a76f1);
    $parcel$export(module.exports, "getLoadingBarColor", ()=>$ac75ec265428b4c8$export$cf3a5ed89e041425);
    var $8QpSo;
    var $65Ltd;
    var $j8DrX;
    const $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)
    ];
    const $ac75ec265428b4c8$export$2a3dd4ccb7b0a764 = 'body::before';
    const $ac75ec265428b4c8$export$79456f717d4431da = 'loaderStylesheet';
    const $ac75ec265428b4c8$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $ac75ec265428b4c8$export$c82eb262b97a76f1 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const ALLOWED_ROUTES = $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES;
        return ALLOWED_ROUTES;
    });
    const $ac75ec265428b4c8$export$cf3a5ed89e041425 = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-lf-navigation-highlightcolour') || $ac75ec265428b4c8$export$53d51cc6d57e44da);
});
parcelRegister("cYUbO", function(module, exports) {
    $parcel$export(module.exports, "generateLoadingBarStyles", ()=>$e5278a73a699aa95$export$3036104bc81246b1);
    var $gwIPs;
    var $04unK;
    const $e5278a73a699aa95$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, (0, parcelRequire("gwIPs")).layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
    const $e5278a73a699aa95$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, (0, parcelRequire("04unK")).LOADER_STYLESHEET_ID}>
            ${0, (0, parcelRequire("04unK")).LOADER_STYLES_CSS_SELECTOR} {${$e5278a73a699aa95$export$3036104bc81246b1(initialProgressValue, (0, (0, parcelRequire("04unK")).getLoadingBarColor)())}}
        </style>`;
});
parcelRegister("gwIPs", function(module, exports) {
    $parcel$export(module.exports, "gridSize", ()=>$80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
    $parcel$export(module.exports, "borderRadius", ()=>$80d528dbc2b11cbc$export$7a57f79000377ca2);
    $parcel$export(module.exports, "fontSize", ()=>$80d528dbc2b11cbc$export$85e3c3ca0c6fb93);
    $parcel$export(module.exports, "fontFamily", ()=>$80d528dbc2b11cbc$export$a5975749f0374264);
    $parcel$export(module.exports, "codeFontFamily", ()=>$80d528dbc2b11cbc$export$356129969ee49c55);
    $parcel$export(module.exports, "contentHorizontalSpacing", ()=>$80d528dbc2b11cbc$export$22dec01f2c854397);
    $parcel$export(module.exports, "layers", ()=>$80d528dbc2b11cbc$export$7be255094ccdc533);
    $parcel$export(module.exports, "layout", ()=>$80d528dbc2b11cbc$export$b3219800bda33a1f);
    var $dtXUS;
    const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = (0, (0, parcelRequire("dtXUS")).gridSize)();
    const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, (0, parcelRequire("dtXUS")).borderRadius)();
    const $80d528dbc2b11cbc$export$85e3c3ca0c6fb93 = (0, (0, parcelRequire("dtXUS")).fontSize)();
    const $80d528dbc2b11cbc$export$a5975749f0374264 = (0, (0, parcelRequire("dtXUS")).fontFamily)();
    const $80d528dbc2b11cbc$export$356129969ee49c55 = (0, (0, parcelRequire("dtXUS")).codeFontFamily)();
    const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
    const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
    const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
        banner: (0, (0, parcelRequire("dtXUS")).layers).navigation(),
        card: (0, (0, parcelRequire("dtXUS")).layers).card(),
        dialog: (0, (0, parcelRequire("dtXUS")).layers).dialog(),
        navigation: (0, (0, parcelRequire("dtXUS")).layers).navigation(),
        leftSidebar: (0, (0, parcelRequire("dtXUS")).layers).navigation() - 1,
        rightSidebar: (0, (0, parcelRequire("dtXUS")).layers).navigation() - 1,
        layer: (0, (0, parcelRequire("dtXUS")).layers).layer(),
        blanket: (0, (0, parcelRequire("dtXUS")).layers).blanket(),
        modal: (0, (0, parcelRequire("dtXUS")).layers).modal(),
        flag: (0, (0, parcelRequire("dtXUS")).layers).flag(),
        spotlight: (0, (0, parcelRequire("dtXUS")).layers).spotlight(),
        tooltip: (0, (0, parcelRequire("dtXUS")).layers).tooltip(),
        mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
    };
    const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
        issueIconSize: $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 * 2
    };
});
parcelRegister("7Lkcv", function(module, exports) {
    $parcel$export(module.exports, "SafeHelpPanel", ()=>$70a8cef9c47c5a71$export$cd2ada2fb14048fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $7CMCs;
    var $6BNJk;
    var $kspz4;
    var $7dTw7;
    var $1SVH7;
    var $hsmeR;
    var $90yGq;
    const $70a8cef9c47c5a71$var$HelpPanel = ()=>{
        const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, (0, parcelRequire("kspz4")).useHelpPanel)();
        const { closeRightSidebar: closeRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            const restoreReleaseNotesNotifications = async ()=>{
                if (accountId) try {
                    const { helpPanel: userPropertiesHelpPanelValue } = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf));
                    setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
                } catch (err) {
                    setReleaseNotesNotifications(0);
                }
                else setReleaseNotesNotifications(0);
            };
            restoreReleaseNotesNotifications();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7dTw7")).RemoteStateUpdater), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1SVH7")).LazyHelpPanel), {
            isOpen: !rightSidebarCurrentState?.isCollapsed,
            navigationData: navigationData,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            releaseNotesNotificationsSetter: setReleaseNotesNotifications,
            hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
            onCloseHelpPanel: closeRightSidebar
        }));
    };
    const $70a8cef9c47c5a71$var$HelpPanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanel, null);
    };
    const $70a8cef9c47c5a71$export$cd2ada2fb14048fc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-help-panel",
            packageName: "@atlassian/jira-help-panel-right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanelInLayout, null));
});
parcelRegister("6BNJk", function(module, exports) {
    $parcel$export(module.exports, "HELP_PANEL_VERSION", ()=>$20386d7da4313ff0$export$c43c7444da662fa1);
    $parcel$export(module.exports, "HELP_PANEL_ID", ()=>$20386d7da4313ff0$export$e99efa3985fa3c26);
    $parcel$export(module.exports, "HELP_PANEL_WIDTH", ()=>$20386d7da4313ff0$export$23aa6670f346c214);
    var $gwIPs;
    const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
    const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
    const $20386d7da4313ff0$export$23aa6670f346c214 = (0, (0, parcelRequire("gwIPs")).gridSize) * 46;
});
parcelRegister("kspz4", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanel", ()=>$aee6103177ce0723$export$3fe94d66377a53b8);
    $parcel$export(module.exports, "useHelpPanelActions", ()=>$aee6103177ce0723$export$c61f56f4797e22db);
    var $3sQ5x;
    var $51nlc;
    var $jgGDm;
    const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("jgGDm")).default));
    const $aee6103177ce0723$export$c61f56f4797e22db = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("jgGDm")).default), {
        selector: null
    });
    const $aee6103177ce0723$export$513717a84f55db1a = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelSubscriber'
    });
    const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelActionsSubscriber',
        selector: null
    });
});
parcelRegister("jgGDm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$465615692863cce9$export$2e2bcd8739ae039);
    var $eNf8a;
    var $iXqE5;
    var $958ua;
    const $465615692863cce9$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $465615692863cce9$var$initialState = {
        navigationData: {
            articleId: {
                id: '',
                type: 'HELP_ARTICLE'
            },
            history: $465615692863cce9$var$iphStorage.get('history') || []
        },
        releaseNotesNotifications: 100
    };
    var $465615692863cce9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'help-panel',
        initialState: $465615692863cce9$var$initialState,
        actions: (0, parcelRequire("958ua"))
    });
});
parcelRegister("eNf8a", function(module, exports) {
    $parcel$export(module.exports, "createSessionStorageProvider", ()=>$b98f887ad675a269$export$a922b987e648d2fa);
    $parcel$export(module.exports, "createSessionExpirableStorageProvider", ()=>$b98f887ad675a269$export$e0a2e9a062c6a695);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $j9Vq5;
    const $b98f887ad675a269$export$a922b987e648d2fa = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("j9Vq5")).makeSessionStore)()));
    const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("j9Vq5")).makeSessionExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("j9Vq5", function(module, exports) {
    $parcel$export(module.exports, "makeSessionStore", ()=>$93ac2abe604287b3$export$fb690882d627b3b5);
    $parcel$export(module.exports, "makeSessionExpirableStore", ()=>$93ac2abe604287b3$export$a8f626c8ded9a06c);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $2NjNT = parcelRequire("2NjNT");
    var $c74za = parcelRequire("c74za");
    var $fNVZf;
    const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
parcelRegister("958ua", function(module, exports) {
    $parcel$export(module.exports, "setNavigationData", ()=>$177ac56c5a5bf49e$export$ab1b80f40ca898ed);
    $parcel$export(module.exports, "setReleaseNotesNotifications", ()=>$177ac56c5a5bf49e$export$cdabe01d01a8da1e);
    var $eNf8a;
    const $177ac56c5a5bf49e$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                navigationData: {
                    articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                    history: navigationData.history ? navigationData.history : currentState.navigationData.history
                }
            });
            $177ac56c5a5bf49e$var$iphStorage.set('history', []);
        };
    const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
            setState({
                releaseNotesNotifications: releaseNotesNotifications
            });
        };
});
const $0971f751295a2324$export$783d7c02e3a0cbf = 'help_panel_ui_state';
parcelRegister("7dTw7", function(module, exports) {
    $parcel$export(module.exports, "RemoteStateUpdater", ()=>$52205ad66fbf5dd9$export$3db011870dd4330f);
    var $5uXOq = parcelRequire("5uXOq");
    var $laWvb;
    var $89SaW;
    var $jcw0u;
    var $90yGq;
    var $kspz4;
    const $52205ad66fbf5dd9$var$DEBOUNCE_TIME = 1000;
    const $52205ad66fbf5dd9$export$3db011870dd4330f = ()=>{
        const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, (0, parcelRequire("kspz4")).useHelpPanel)();
        const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $5uXOq.useState)(releaseNotesNotifications);
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [debouncedUpdateData] = (0, (0, parcelRequire("laWvb")).default)(async (newReleaseNotesNotifications)=>{
            const remoteData = {
                helpPanel: {
                    releaseNotesNotifications: newReleaseNotesNotifications
                }
            };
            if (accountId) try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: 'updateServerHelpPanelState',
                        packageName: 'jiraHelpPanelServices',
                        teamName: 'self-help-experiences'
                    }
                });
            }
        }, $52205ad66fbf5dd9$var$DEBOUNCE_TIME);
        (0, $5uXOq.useEffect)(()=>{
            if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
                setReleaseNotesNotificationsTemp(releaseNotesNotifications);
                debouncedUpdateData(releaseNotesNotifications);
            }
        }, [
            debouncedUpdateData,
            releaseNotesNotifications,
            releaseNotesNotificationsTemp
        ]);
        return null;
    };
});
parcelRegister("laWvb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
        if (options === void 0) options = {};
        var maxWait = options.maxWait;
        var maxWaitHandler = (0, $5uXOq.useRef)(null);
        var maxWaitArgs = (0, $5uXOq.useRef)([]);
        var leading = options.leading;
        var trailing = options.trailing === undefined ? true : options.trailing;
        var leadingCall = (0, $5uXOq.useRef)(false);
        var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
        var isComponentUnmounted = (0, $5uXOq.useRef)(false);
        var debouncedFunction = (0, $5uXOq.useRef)(callback);
        debouncedFunction.current = callback;
        var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
            clearTimeout(functionTimeoutHandler.current);
            clearTimeout(maxWaitHandler.current);
            maxWaitHandler.current = null;
            maxWaitArgs.current = [];
            functionTimeoutHandler.current = null;
            leadingCall.current = false;
        }, []);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                isComponentUnmounted.current = true;
            };
        }, []);
        var debouncedCallback = (0, $5uXOq.useCallback)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            maxWaitArgs.current = args;
            clearTimeout(functionTimeoutHandler.current);
            if (leadingCall.current) leadingCall.current = false;
            if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
                debouncedFunction.current.apply(debouncedFunction, args);
                leadingCall.current = true;
            }
            functionTimeoutHandler.current = setTimeout(function() {
                var shouldCallFunction = true;
                if (leading && leadingCall.current) shouldCallFunction = false;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
            }, delay);
            if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
                var args = maxWaitArgs.current;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
            }, maxWait);
        }, [
            maxWait,
            delay,
            cancelDebouncedCallback,
            leading,
            trailing
        ]);
        var callPending = (0, $5uXOq.useCallback)(function() {
            if (!functionTimeoutHandler.current) return;
            debouncedFunction.current.apply(null, maxWaitArgs.current);
            cancelDebouncedCallback();
        }, [
            cancelDebouncedCallback
        ]);
        return [
            debouncedCallback,
            cancelDebouncedCallback,
            callPending
        ];
    }
});
parcelRegister("1SVH7", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpPanel", ()=>$311d1a0e95633292$export$51c79455aef7d178);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $6s1PB;
    var $lfTZh;
    var $cYlk7;
    var $iXVV6;
    var $3qQLk;
    var $jVpMq;
    var $7rrMi;
    var $4RupH;
    const $311d1a0e95633292$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
        const user = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "help-panel",
            packageName: "jiraHelpPanel",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVpMq")).default), {
                    loadingArticle: articleId.id !== ''
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "root",
            packageName: "jiraHelpPanel",
            teamName: "self-help-experiences"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7rrMi")).SearchContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            tags: [
                'iph'
            ],
            sourceName: "jiraHelpPanel",
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            attributes: {
                searchService: (0, (0, parcelRequire("6s1PB")).expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false) ? 'help-aggregator' : 'algolia',
                routeGroup: routeGroup,
                routeName: routeName,
                userId: user?.data?.user?.accountId
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3qQLk")).LazyWait), {
            until: hasBeenRendered
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-lazy-help-panel",
            fallback: isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVpMq")).default), {
                loadingArticle: articleId.id !== ''
            }) : null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4RupH")).AsyncLazyHelpPanel), {
            navigationData: {
                articleId: articleId,
                history: history
            },
            releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            isOpen: isOpen,
            onCloseHelpPanel: onCloseHelpPanel,
            routeGroup: routeGroup,
            routeName: routeName
        })))))));
    };
});
parcelRegister("cYlk7", function(module, exports) {
    $parcel$export(module.exports, "useCurrentUser", ()=>$cdd4ab536fcf9459$export$3901076af3749fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    var $leRCk;
    const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    user: {
                        accountId: tenantContext.atlassianAccountId,
                        isAdmin: tenantContext.isAdmin,
                        isAnonymous: tenantContext.isAnonymous,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        locale: tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale),
                        siteAdminStatus: tenantContext.siteAdminStatus,
                        userFullname: tenantContext.userFullname || ''
                    }
                },
                loading: false,
                error: null
            }), [
            tenantContext.atlassianAccountId,
            tenantContext.isAdmin,
            tenantContext.isAnonymous,
            tenantContext.isSiteAdmin,
            tenantContext.locale,
            tenantContext.siteAdminStatus,
            tenantContext.userFullname
        ]);
    };
    const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
        const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        (0, $5uXOq.useEffect)(()=>{
            tenantContext.atlassianAccountId && fetch({
                params: {
                    accountId: tenantContext.atlassianAccountId
                }
            }, false);
        }, [
            fetch,
            tenantContext.atlassianAccountId
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    ...dataBasic,
                    user: {
                        ...dataBasic.user,
                        ...data
                    }
                },
                loading: loading,
                error: error
            }), [
            data,
            dataBasic,
            error,
            loading
        ]);
    };
    const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, (0, parcelRequire("9OXo1")).useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull();
    const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
        const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
        return children(result);
    };
});
parcelRegister("leRCk", function(module, exports) {
    $parcel$export(module.exports, "UserContainer", ()=>$46a581f1f6efe569$export$7ff085589970ee0a);
    $parcel$export(module.exports, "useUserSubscriber", ()=>$46a581f1f6efe569$export$4e61bbf568682a96);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $314C6;
    const $46a581f1f6efe569$var$initialState = {
        data: null,
        loading: false,
        error: null
    };
    const $46a581f1f6efe569$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'user',
        initialState: $46a581f1f6efe569$var$initialState,
        actions: (0, parcelRequire("314C6"))
    });
    const $46a581f1f6efe569$export$7ff085589970ee0a = (0, (0, parcelRequire("gg7kZ")).createContainer)($46a581f1f6efe569$var$Store);
    const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, (0, parcelRequire("3sQ5x")).createHook)($46a581f1f6efe569$var$Store);
});
parcelRegister("314C6", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
    var $iF3m5;
    const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!params || currentState.loading || currentState.data && !forceRefetch) return;
            setState({
                loading: true
            });
            try {
                const data = await (0, (0, parcelRequire("iF3m5")).fetchData)({
                    params: params,
                    header: header
                });
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                setState({
                    error: err,
                    loading: false
                });
            }
        };
});
parcelRegister("iF3m5", function(module, exports) {
    $parcel$export(module.exports, "fetchData", ()=>$d22d4c6d892f61f1$export$8134c072fddab6a5);
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    const $d22d4c6d892f61f1$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
        const queryParams = {
            ...params,
            expand: Object.keys(params.expand || {}).filter((key)=>params.expand && params.expand[key])
        };
        const query = (0, $ebyGx.stringify)(queryParams, {
            arrayFormat: 'none'
        });
        const queryString = query ? `?${query}` : '';
        const requestUrl = `/rest/api/2/user${queryString}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(requestUrl, header ? {
            headers: header
        } : {});
    };
});
parcelRegister("jVpMq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8bb188482996cb7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $5CrlE;
    const $b8bb188482996cb7$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CrlE")).HelpPanelContainerV2), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "img",
            "aria-label": "help panel loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-250, 20px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "90%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "70%"
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CrlE")).HelpPanelContainerV2), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-500, 40px)",
            marginTop: "var(--ds-space-100, 8px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleList, {
            role: "img"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })))));
    var $b8bb188482996cb7$export$2e2bcd8739ae039 = $b8bb188482996cb7$var$HelpPanelLoading;
    const $b8bb188482996cb7$var$LoadingContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$HeaderLoading = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$shimmer = null;
    const $b8bb188482996cb7$var$LoadingRectangle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_l7mdyr": (0, (0, parcelRequire("lD23V")).default)(__cmplp.contentHeight),
                "--_1fj4wta": (0, (0, parcelRequire("lD23V")).default)(__cmplp.marginTop),
                "--_7n1eiw": (0, (0, parcelRequire("lD23V")).default)(__cmplp.contentWidth)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
                __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
                __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
                __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$LoadignArticleList = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $b8bb188482996cb7$var$LoadignArticleListItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5CrlE", function(module, exports) {
    $parcel$export(module.exports, "HelpPanelContainer", ()=>$2dbd0534194918a8$export$37cd645d7678f7d4);
    $parcel$export(module.exports, "HelpPanelContainerV2", ()=>$2dbd0534194918a8$export$1df7e3ebfc4c9b06);
    $parcel$export(module.exports, "HelpPanelSectionMessageContainer", ()=>$2dbd0534194918a8$export$9f6251c714594f23);
    $parcel$export(module.exports, "HelpPanelContentContainer", ()=>$2dbd0534194918a8$export$1cdb922eed7271d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $2dbd0534194918a8$export$37cd645d7678f7d4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1kl71osx _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$1df7e3ebfc4c9b06 = (0, $5uXOq.forwardRef)(({ as: C = $2dbd0534194918a8$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1i8v _11q71bhr",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$9f6251c714594f23 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $2dbd0534194918a8$export$1cdb922eed7271d1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7rrMi", function(module, exports) {
    $parcel$export(module.exports, "useSearchContext", ()=>$c0047fc735c61769$export$67b98b1b880a048b);
    $parcel$export(module.exports, "SearchContextProvider", ()=>$c0047fc735c61769$export$6bd70292443463a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $jFLAi;
    const [$c0047fc735c61769$export$67b98b1b880a048b, $c0047fc735c61769$export$70af50e847ce290a] = (0, (0, parcelRequire("jFLAi")).createCtx)();
    const $c0047fc735c61769$export$6bd70292443463a4 = ({ children: children })=>{
        const [searchContext, setSearchContext] = (0, $5uXOq.useState)({});
        const addClickedArticleIds = (0, $5uXOq.useCallback)((query, clickedArticleId)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        clickedArticleIds: prev[query]?.clickedArticleIds ? [
                            ...prev[query].clickedArticleIds,
                            clickedArticleId
                        ] : [
                            clickedArticleId
                        ]
                    }
                }));
        }, []);
        const addFetchedArticleIds = (0, $5uXOq.useCallback)((query, fetchedArticles)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        fetchedArticleIds: fetchedArticles
                    }
                }));
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c0047fc735c61769$export$70af50e847ce290a, {
            value: {
                searchContext: searchContext,
                addClickedArticleIds: addClickedArticleIds,
                addFetchedArticleIds: addFetchedArticleIds
            }
        }, children);
    };
});
parcelRegister("jFLAi", function(module, exports) {
    $parcel$export(module.exports, "createCtx", ()=>$b612e461f4fc901f$export$d653a1a643c9a98c);
    var $5uXOq = parcelRequire("5uXOq");
    function $b612e461f4fc901f$export$d653a1a643c9a98c() {
        const ctx = (0, $5uXOq.createContext)(undefined);
        function useCtx() {
            const c = (0, $5uXOq.useContext)(ctx);
            if (!c) throw new Error('useCtx must be inside a Provider with a value');
            return c;
        }
        return [
            useCtx,
            ctx.Provider
        ];
    }
});
parcelRegister("4RupH", function(module, exports) {
    $parcel$export(module.exports, "AsyncLazyHelpPanel", ()=>$4ce54108d7c5ac07$export$7ff46d33d0f13518);
    var $hPtZI;
    const $4ce54108d7c5ac07$export$7ff46d33d0f13518 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9Y8nX")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
    });
});
parcelRegister("9Y8nX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("cBrFc")
    ]).then(()=>parcelRequire('jj3on'));
});
parcelRegister("9YvQF", function(module, exports) {
    $parcel$export(module.exports, "SafeEmbeddedConfluencePanel", ()=>$3e89344d89118823$export$2d901a489872dd0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $jJ1Sb;
    var $9KYrx;
    var $gXSrH;
    var $7CMCs;
    var $hsmeR;
    var $9V9QO;
    const $3e89344d89118823$var$DELAY = 310;
    const $3e89344d89118823$export$2db0a2e0275af8b8 = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const [{ panel: isOpen }] = (0, (0, parcelRequire("gXSrH")).useEmbeddedConfluenceSidePanel)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, (0, parcelRequire("9V9QO")).useEmbeddedPanelEntryPoint)();
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) entryPointActions?.load();
        }, [
            isOpen,
            entryPointActions,
            localPanelId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, $3e89344d89118823$var$DELAY);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $3e89344d89118823$var$panelStyles
        }, entryPoint);
    };
    const $3e89344d89118823$export$2d901a489872dd0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-embedded-confluence-panel",
            packageName: "jiraIssueCreateConfluenceContent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXSrH")).EmbeddedConfluenceSidepanelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3e89344d89118823$export$2db0a2e0275af8b8, null)));
    const $3e89344d89118823$var$panelStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        padding: 'space.100',
        height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
    });
});
parcelRegister("9KYrx", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceFeatureKeys", ()=>$e486b17128606747$export$746d4746bf07dd70);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", ()=>$e486b17128606747$export$6247c7e19b71f4e);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", ()=>$e486b17128606747$export$e34c4c923d934e7a);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", ()=>$e486b17128606747$export$ffe60197eb59ca73);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", ()=>$e486b17128606747$export$8d0c4a26241944b8);
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", ()=>$e486b17128606747$export$a497288e64e9a343);
    const $e486b17128606747$export$746d4746bf07dd70 = {
        ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
        SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
        CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
        CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
    };
    const $e486b17128606747$export$6247c7e19b71f4e = 'confluence-integration-controls';
    const $e486b17128606747$export$e34c4c923d934e7a = 'user-confluence-access';
    const $e486b17128606747$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
    const $e486b17128606747$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
    const $e486b17128606747$export$a497288e64e9a343 = 'embedded-confluence-panel-container';
});
parcelRegister("gXSrH", function(module, exports) {
    $parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", ()=>$27a5db923b3bcebb$export$a5c1c168018f0f16);
    $parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", ()=>$27a5db923b3bcebb$export$518aeea31a00450e);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $2gCtH;
    var $hsmeR;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $9KYrx;
    var $aQLD7;
    var $bvqNo;
    var $5labn;
    const $27a5db923b3bcebb$var$Container = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $27a5db923b3bcebb$var$DefaultStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        actions: (0, parcelRequire("aQLD7")).actions,
        containedBy: $27a5db923b3bcebb$var$Container,
        initialState: (0, parcelRequire("aQLD7")).initialState,
        name: (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $27a5db923b3bcebb$var$NonContainerStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        actions: (0, parcelRequire("aQLD7")).actions,
        initialState: (0, parcelRequire("aQLD7")).initialState,
        name: (0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $27a5db923b3bcebb$export$a5c1c168018f0f16 = ({ children: children })=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($27a5db923b3bcebb$var$Container, {
            scope: `embedded-confluence-sidepanel-${issueKey}`
        }, children);
    };
    const $27a5db923b3bcebb$var$defaultStoreHook = (0, (0, parcelRequire("3sQ5x")).createHook)($27a5db923b3bcebb$var$DefaultStore);
    const $27a5db923b3bcebb$var$nonContainerStoreHook = (0, (0, parcelRequire("3sQ5x")).createHook)($27a5db923b3bcebb$var$NonContainerStore);
    const $27a5db923b3bcebb$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
        const [embedConfluenceSidepanelConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
        const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState }] = isInExperiment ? $27a5db923b3bcebb$var$defaultStoreHook() : $27a5db923b3bcebb$var$nonContainerStoreHook();
        const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const openSidePanel = (0, $5uXOq.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
            const { initialWidth: initialWidth, displayType: displayType } = (0, (0, parcelRequire("5labn")).getDisplayInformation)();
            const shouldOpenPanel = displayType === (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL;
            if (shouldOpenPanel) {
                openSidePanelAction({
                    contentId: contentId,
                    contentType: contentType,
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    data: data,
                    displayType: displayType,
                    initialWidth: initialWidth,
                    hostname: hostname,
                    isDraft: isDraft,
                    isLive: isLive,
                    mode: mode,
                    onLinkPage: onLinkPage,
                    onPublish: onPublish,
                    shouldOpenModal: !shouldOpenPanel,
                    url: url,
                    title: title
                });
                openRightSidebar((0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
            } else openInModal();
        }, [
            embeddedConfluenceSource,
            openRightSidebar,
            openSidePanelAction
        ]);
        const closeSidePanel = (0, $5uXOq.useCallback)(()=>{
            closeRightSidebar((0, (0, parcelRequire("9KYrx")).EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
            closeSidePanelAction();
        }, [
            closeRightSidebar,
            closeSidePanelAction
        ]);
        return [
            state,
            {
                openSidePanel: openSidePanel,
                closeSidePanel: closeSidePanel,
                setDeferredSpaceData: setDeferredSpaceData,
                setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
                toggleExpandedState: toggleExpandedState,
                setIsDraftState: setIsDraftState
            }
        ];
    };
});
parcelRegister("2gCtH", function(module, exports) {
    $parcel$export(module.exports, "useChildIssuesLimit", ()=>$9e67f38435565e11$export$8d75f312eaa63aec);
    $parcel$export(module.exports, "useChildIssuesIssueLimitUrl", ()=>$9e67f38435565e11$export$65a59acd1ffc5bba);
    $parcel$export(module.exports, "useIsModal", ()=>$9e67f38435565e11$export$9ce8428ff198804a);
    $parcel$export(module.exports, "useIssueKey", ()=>$9e67f38435565e11$export$22108eca27445997);
    $parcel$export(module.exports, "useIssueId", ()=>$9e67f38435565e11$export$9df8176b5ffce5ab);
    $parcel$export(module.exports, "useIsArchived", ()=>$9e67f38435565e11$export$7cd1821433aafaee);
    $parcel$export(module.exports, "useIsClassifyEditEnabled", ()=>$9e67f38435565e11$export$b23b36ed5c42e920);
    $parcel$export(module.exports, "useProjectKey", ()=>$9e67f38435565e11$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useAnalyticsSource", ()=>$9e67f38435565e11$export$aad3917152559b87);
    $parcel$export(module.exports, "useIssueContextActions", ()=>$9e67f38435565e11$export$d6ec1293313f49ac);
    $parcel$export(module.exports, "useRapidViewMap", ()=>$9e67f38435565e11$export$4d204e800e4e0be7);
    $parcel$export(module.exports, "useEstimationStatistic", ()=>$9e67f38435565e11$export$5b20e30ee6db56e9);
    $parcel$export(module.exports, "useViewMode", ()=>$9e67f38435565e11$export$3a7c3e259b6adb93);
    $parcel$export(module.exports, "useBackButtonUrl", ()=>$9e67f38435565e11$export$cfe64a334903927c);
    $parcel$export(module.exports, "useIssueNavigatorData", ()=>$9e67f38435565e11$export$aa008a00bae7e7ab);
    $parcel$export(module.exports, "useOnIssueKeyChange", ()=>$9e67f38435565e11$export$52c975cf0b623556);
    $parcel$export(module.exports, "useRapidViewId", ()=>$9e67f38435565e11$export$b34d0ea0bf41fee);
    $parcel$export(module.exports, "useViewScreenId", ()=>$9e67f38435565e11$export$7c142b5701b4c3f9);
    $parcel$export(module.exports, "useHasSoftwareAccess", ()=>$9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
    $parcel$export(module.exports, "useIsFullPageIssueView", ()=>$9e67f38435565e11$export$2e131fc4108f9106);
    $parcel$export(module.exports, "useIsEmbedPageIssueView", ()=>$9e67f38435565e11$export$4596c26005fbb859);
    $parcel$export(module.exports, "useIsAiEnabledForIssue", ()=>$9e67f38435565e11$export$db5174c7538abe4b);
    $parcel$export(module.exports, "useIsJiraIssue", ()=>$9e67f38435565e11$export$cf5fc815f761fb4b);
    $parcel$export(module.exports, "useIsAiOptInEnabled", ()=>$9e67f38435565e11$export$b131d9f6da853161);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4Pf62;
    var $co1wz;
    var $e5wyW;
    var $93Yeu;
    var $g5X3G;
    var $ef5Xn;
    var $7trqb;
    var $hqBSi;
    var $koiRX;
    const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
        const [childIssuesLimit] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesLimit)();
        return childIssuesLimit;
    };
    const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
        const [childIssuesIssueLimitUrls] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreChildIssuesIssueLimitUrls)();
        return childIssuesIssueLimitUrls;
    };
    const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
        const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
        return childIssuesIssueLimitUrls?.[fieldId];
    };
    const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
        const [isModal] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsModal)();
        return isModal;
    };
    const $9e67f38435565e11$export$22108eca27445997 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return issueKey;
    };
    const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
        const [issueId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueId)();
        return issueId;
    };
    const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
        const [isArchived] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsArchived)();
        return isArchived;
    };
    const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
        const [isClassifyEditEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsClassifyEditEnabled)();
        return isClassifyEditEnabled;
    };
    const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
        const [issueKey] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueKey)();
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(issueKey.split('-')[0]);
    };
    const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
        const [analyticsSource] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreAnalyticsSource)();
        return analyticsSource;
    };
    const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
        const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setIssueContext: setIssueContext,
                mergeIssueContext: mergeIssueContext,
                getChildIssuesLimit: getChildIssuesLimit,
                getMaxTokenLength: getMaxTokenLength,
                getIsLoadedWithPage: getIsLoadedWithPage,
                getBackButtonUrl: getBackButtonUrl,
                getIsSpaEnabled: getIsSpaEnabled,
                getIssueKey: getIssueKey,
                setDetailViewAsModal: setDetailViewAsModal,
                setDetailViewAsSidebar: setDetailViewAsSidebar,
                resetDetailView: resetDetailView
            }), [
            setIssueContext,
            mergeIssueContext,
            getChildIssuesLimit,
            getMaxTokenLength,
            getIsLoadedWithPage,
            getBackButtonUrl,
            getIsSpaEnabled,
            getIssueKey,
            setDetailViewAsModal,
            setDetailViewAsSidebar,
            resetDetailView
        ]);
        return [
            undefined,
            actions
        ];
    };
    const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
        const [rapidViewMap] = (0, (0, parcelRequire("koiRX")).useIssueContextRapidViewMap)();
        return rapidViewMap;
    };
    const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
        const [maxTokenLength] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreMaxTokenLength)();
        return maxTokenLength;
    };
    const $9e67f38435565e11$export$b4199f923267161e = ()=>{
        const [isLoadedWithPage] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoadedWithPage)();
        return isLoadedWithPage;
    };
    const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
        const [estimationStatistic] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreEstimationStatistic)();
        return estimationStatistic;
    };
    const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
        const [isLoading] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsLoading)();
        return isLoading;
    };
    const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
        const [viewMode] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewMode)();
        return viewMode;
    };
    const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
        const [backButtonUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBackButtonUrl)();
        return backButtonUrl;
    };
    const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
        const [issueNavigatorData] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIssueNavigatorData)();
        return issueNavigatorData;
    };
    const $9e67f38435565e11$export$b49754504c41149f = ()=>{
        const [boardId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardId)();
        return boardId;
    };
    const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
        const [boardType] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreBoardType)();
        return boardType;
    };
    const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
        const [isSpaEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreIsSpaEnabled)();
        return isSpaEnabled;
    };
    const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
        const [loginRedirectUrl] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreLoginRedirctUrl)();
        return loginRedirectUrl;
    };
    const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
        const [onIssueKeyChange] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreOnIssueKeyChange)();
        return onIssueKeyChange;
    };
    const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
        const [rapidViewId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreRapidViewId)();
        return rapidViewId;
    };
    const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
        const [viewScreenId] = (0, (0, parcelRequire("koiRX")).useIssueContextStoreViewScreenId)();
        return viewScreenId;
    };
    const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const licenseStates = (0, (0, parcelRequire("7trqb")).useLicenseStates)();
        const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE);
        return licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
    };
    const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
    };
    const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
        const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
        return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
    };
    const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
        const [isAiEnabledForIssue] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiEnabledForIssue)();
        return isAiEnabledForIssue;
    };
    const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
        const issueKey = $9e67f38435565e11$export$22108eca27445997();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        return [
            (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT),
            (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
        ].some((type)=>type === projectType);
    };
    const $9e67f38435565e11$var$useIsAiOptInEnabledOld = ()=>{
        const [isAiOptInEnabled] = (0, (0, parcelRequire("koiRX")).useIssueContextIsAiOptInEnabled)();
        return isAiOptInEnabled;
    };
    const $9e67f38435565e11$export$b131d9f6da853161 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>{
        return (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
            'OLD',
            'NEW',
            'CHECK',
            'CHECK_RETURN_NEW'
        ]) === 'NEW';
    }, $9e67f38435565e11$export$db5174c7538abe4b, $9e67f38435565e11$var$useIsAiOptInEnabledOld);
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("7trqb", function(module, exports) {
    $parcel$export(module.exports, "useLicenseStates", ()=>$5fcaa3f734e9c444$export$268651a63abe408a);
    var $9OXo1;
    const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licenseStates;
    };
});
parcelRegister("hqBSi", function(module, exports) {
    $parcel$export(module.exports, "useLicensedProducts", ()=>$7564850c0894983d$export$54d534cc91e54850);
    var $9OXo1;
    const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.licensedProducts || {};
    };
});
parcelRegister("koiRX", function(module, exports) {
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", ()=>$35da250daae5206d$export$abdbea56d86b4aac);
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", ()=>$35da250daae5206d$export$326ff2b963d51c5c);
    $parcel$export(module.exports, "useIssueContextStoreIssueKey", ()=>$35da250daae5206d$export$44bcaaabb74e402b);
    $parcel$export(module.exports, "useIssueContextStoreIssueId", ()=>$35da250daae5206d$export$332dcee0cf9f4e45);
    $parcel$export(module.exports, "useIssueContextStoreIsArchived", ()=>$35da250daae5206d$export$c940355b1fc6e1c4);
    $parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", ()=>$35da250daae5206d$export$b9eebaa1da421997);
    $parcel$export(module.exports, "useIssueContextStoreIsModal", ()=>$35da250daae5206d$export$daa47fd600e43a32);
    $parcel$export(module.exports, "useIssueContextStoreViewScreenId", ()=>$35da250daae5206d$export$ba2e9546ab5ba6f);
    $parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", ()=>$35da250daae5206d$export$74d38d6c437efc1b);
    $parcel$export(module.exports, "useIssueContextRapidViewMap", ()=>$35da250daae5206d$export$2092528ee170d9e7);
    $parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", ()=>$35da250daae5206d$export$57898374e6239a5a);
    $parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", ()=>$35da250daae5206d$export$ff0264ec4c015dc1);
    $parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", ()=>$35da250daae5206d$export$6c8b81f6dca8c23d);
    $parcel$export(module.exports, "useIssueContextStoreIsLoading", ()=>$35da250daae5206d$export$fe7085456138f0fc);
    $parcel$export(module.exports, "useIssueContextStoreViewMode", ()=>$35da250daae5206d$export$c339e36468c12443);
    $parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", ()=>$35da250daae5206d$export$ef3bfa2642bb98cd);
    $parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", ()=>$35da250daae5206d$export$8accd063c74cd455);
    $parcel$export(module.exports, "useIssueContextStoreBoardId", ()=>$35da250daae5206d$export$e7edffc2a20027e7);
    $parcel$export(module.exports, "useIssueContextStoreBoardType", ()=>$35da250daae5206d$export$48aaa3a6bc2085d7);
    $parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", ()=>$35da250daae5206d$export$4a4b96bcf5166327);
    $parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", ()=>$35da250daae5206d$export$bbd8ba0180545556);
    $parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", ()=>$35da250daae5206d$export$aaa89627762c7d00);
    $parcel$export(module.exports, "useIssueContextStoreRapidViewId", ()=>$35da250daae5206d$export$796589b0ec52848a);
    $parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", ()=>$35da250daae5206d$export$7e70ee570119a0a7);
    $parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", ()=>$35da250daae5206d$export$455ae7fd9d68b157);
    $parcel$export(module.exports, "IssueContextContainer", ()=>$35da250daae5206d$export$93db6a8f3342dddf);
    $parcel$export(module.exports, "useIssueContextStoreActions", ()=>$35da250daae5206d$export$965360ae27fcae98);
    var $g5X3G;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $fMAcJ;
    var $iElCl;
    var $edJtc;
    const $35da250daae5206d$export$d4c72bab9d6cc13a = {
        childIssuesLimit: undefined,
        childIssuesIssueLimitUrls: undefined,
        issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(''),
        isArchived: false,
        isClassifyEditEnabled: false,
        isModal: false,
        maxTokenLength: 0,
        isLoadedWithPage: false,
        rapidViewMap: undefined,
        estimationStatistic: undefined,
        isLoading: false,
        viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)(),
        analyticsSource: undefined,
        backButtonUrl: undefined,
        issueNavigatorData: undefined,
        boardId: undefined,
        boardType: undefined,
        isSpaEnabled: false,
        loginRedirectUrl: undefined,
        onIssueKeyChange: undefined,
        rapidViewId: undefined,
        viewScreenId: undefined,
        isAiOptInEnabled: false,
        isAiEnabledForIssue: false
    };
    const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-context',
        initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("fMAcJ")).actions
    });
    const $35da250daae5206d$var$getIssueContext = (state)=>state;
    const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
    const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
    const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
    const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
    const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
    const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
    const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
    const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
    const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
    const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
    const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
    const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
    const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
    const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
    const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
    const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
    const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
    const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
    const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
    const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
    const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
    const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
    const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
    const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueContext
    });
    const $35da250daae5206d$export$abdbea56d86b4aac = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesLimit)
    });
    const $35da250daae5206d$export$326ff2b963d51c5c = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("iElCl")).getChildIssuesIssueLimitUrls)
    });
    const $35da250daae5206d$export$44bcaaabb74e402b = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueKey
    });
    const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueId
    });
    const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsArchived
    });
    const $35da250daae5206d$export$b9eebaa1da421997 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsClassifyEditEnabled
    });
    const $35da250daae5206d$export$daa47fd600e43a32 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsModal
    });
    const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewScreenId
    });
    const $35da250daae5206d$export$74d38d6c437efc1b = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getAnalyticsSource
    });
    const $35da250daae5206d$export$2092528ee170d9e7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewMap
    });
    const $35da250daae5206d$export$57898374e6239a5a = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getMaxTokenLength
    });
    const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoadedWithPage
    });
    const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getEstimationStatistic
    });
    const $35da250daae5206d$export$fe7085456138f0fc = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsLoading
    });
    const $35da250daae5206d$export$c339e36468c12443 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getViewMode
    });
    const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBackButtonUrl
    });
    const $35da250daae5206d$export$8accd063c74cd455 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIssueNavigatorData
    });
    const $35da250daae5206d$export$e7edffc2a20027e7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardId
    });
    const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getBoardType
    });
    const $35da250daae5206d$export$4a4b96bcf5166327 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsSpaEnabled
    });
    const $35da250daae5206d$export$bbd8ba0180545556 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getLoginRedirectUrl
    });
    const $35da250daae5206d$export$aaa89627762c7d00 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getOnIssueKeyChange
    });
    const $35da250daae5206d$export$796589b0ec52848a = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getRapidViewId
    });
    const $35da250daae5206d$export$7e70ee570119a0a7 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getIsAiOptInEnabled
    });
    const $35da250daae5206d$export$455ae7fd9d68b157 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: $35da250daae5206d$var$getisAiEnabledForIssue
    });
    const $35da250daae5206d$export$93db6a8f3342dddf = (0, (0, parcelRequire("gg7kZ")).createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
    const $35da250daae5206d$export$965360ae27fcae98 = (0, (0, parcelRequire("3sQ5x")).createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("fMAcJ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$043cabfbcc6107f0$export$e324594224ef24da);
    var $7l48d;
    var $iElCl;
    var $edJtc;
    const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
                ...issueContext,
                issueId: undefined,
                viewMode: issueContext.viewMode || getState().viewMode
            });
            else setState({
                ...issueContext,
                viewMode: issueContext.viewMode || getState().viewMode
            });
        };
    const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
                ...getState(),
                ...partialIssueContext,
                issueId: undefined
            });
            else setState({
                ...getState(),
                ...partialIssueContext
            });
        };
    const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, (0, parcelRequire("iElCl")).getChildIssuesLimit)(getState());
    const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
    const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
    const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
    const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
    const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
    const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
    const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'MODAL');
            setState({
                viewMode: 'MODAL'
            });
        };
    const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, (0, parcelRequire("7l48d")).localStorage).set((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
            setState({
                viewMode: 'SIDEBAR'
            });
        };
    const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
            setState({
                viewMode: (0, (0, parcelRequire("edJtc")).getViewModeFromLocalStorage)()
            });
        };
    const $043cabfbcc6107f0$export$e324594224ef24da = {
        setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
        mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
        getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
        getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
        getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
        getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
        getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
        getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
        getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
        setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
        setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
        resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
    };
});
parcelRegister("7l48d", function(module, exports) {
    $parcel$export(module.exports, "LOG_LOCATION", ()=>$e736233a6ed098e3$export$25a759e49d5049db);
    $parcel$export(module.exports, "localStorage", ()=>$e736233a6ed098e3$export$c2ed3351cac403d1);
    $parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", ()=>$e736233a6ed098e3$export$a13f7f627010bccd);
    var $bSSG7;
    const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
    const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_issue_view');
    const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';
});
parcelRegister("iElCl", function(module, exports) {
    $parcel$export(module.exports, "getChildIssuesLimit", ()=>$fde75c94a28741e3$export$89b6937a83edcaa6);
    $parcel$export(module.exports, "getChildIssuesIssueLimitUrls", ()=>$fde75c94a28741e3$export$8f43520910e8128c);
    var $dJl1T;
    var $7l48d;
    const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
    const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`${(0, (0, parcelRequire("7l48d")).LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
        return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
    };
    const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
    const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;
});
parcelRegister("edJtc", function(module, exports) {
    $parcel$export(module.exports, "getViewModeFromLocalStorage", ()=>$75ce4ce78f606e67$export$cae7c4c591dcc261);
    var $7l48d;
    const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>(0, (0, parcelRequire("7l48d")).localStorage).get((0, (0, parcelRequire("7l48d")).VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
});
parcelRegister("aQLD7", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "actions", ()=>$0ebe24e18a9cec5a$export$e324594224ef24da);
    var $btHaw;
    var $aWVkx;
    var $bvqNo;
    const $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a = {
        confluenceData: {
            contentId: '',
            contentUrl: '',
            contentData: null,
            mode: (0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            isDraft: false,
            isLive: false
        },
        contentActions: {},
        contentType: (0, (0, parcelRequire("bvqNo")).ConfluenceContentTypes).PAGE,
        embeddedConfluenceSource: '',
        displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL,
        panel: {
            initialWidth: 0,
            isOpen: false,
            isLoading: false,
            isExpanded: false
        },
        modal: {
            isOpen: false
        }
    };
    const $0ebe24e18a9cec5a$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
            setState({
                confluenceData: {
                    contentId: contentId,
                    contentUrl: url,
                    contentData: data,
                    hostname: hostname,
                    mode: mode,
                    isDraft: isDraft,
                    isLive: isLive,
                    title: title,
                    spaceKey: (0, (0, parcelRequire("aWVkx")).parseUrl)(url)?.spaceKey
                },
                contentActions: {
                    onLinkPage: onLinkPage,
                    onPublish: onPublish
                },
                embeddedConfluenceSource: embeddedConfluenceSource,
                contentType: contentType,
                displayType: displayType,
                panel: {
                    initialWidth: initialWidth,
                    isOpen: !shouldOpenModal,
                    isExpanded: isExpanded
                },
                modal: {
                    isOpen: shouldOpenModal
                }
            });
        };
    const $0ebe24e18a9cec5a$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
            setState($0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
        };
    const $0ebe24e18a9cec5a$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    deferredSpaceName: deferredSpaceName,
                    spaceKey: deferredSpaceKey || confluenceData.spaceKey
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
            const { panel: panel, ...prevState } = getState();
            setState({
                ...prevState,
                isDeferSpaceSelection: isDeferSpaceSelection,
                panel: {
                    ...panel,
                    isLoading: isLoading
                }
            });
        };
    const $0ebe24e18a9cec5a$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
            const { panel: panel, ...prevState } = getState();
            const isCurrentlyExpanded = panel.isExpanded;
            setState({
                panel: {
                    ...panel,
                    isExpanded: !isCurrentlyExpanded
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    isDraft: newIsDraftState
                },
                ...prevState
            });
        };
    const $0ebe24e18a9cec5a$export$e324594224ef24da = {
        closeSidePanel: $0ebe24e18a9cec5a$export$e81b26ab493ca52a,
        setDeferredSpaceData: $0ebe24e18a9cec5a$export$473e6cac57a0d506,
        openSidePanel: $0ebe24e18a9cec5a$export$aa5d06fef96639ba,
        setIsLoadingForDeferSpaceSelection: $0ebe24e18a9cec5a$export$db9852cd4946540a,
        toggleExpandedState: $0ebe24e18a9cec5a$export$b29d56f843007f2b,
        setIsDraftState: $0ebe24e18a9cec5a$export$5d0561abb73760f
    };
});
parcelRegister("btHaw", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", ()=>$00df1f27956b8e54$export$816ef638e478449a);
    var $00df1f27956b8e54$export$816ef638e478449a;
    (function(EMBEDDED_CONFLUENCE_MODE) {
        EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
        EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    })($00df1f27956b8e54$export$816ef638e478449a || ($00df1f27956b8e54$export$816ef638e478449a = {}));
});
parcelRegister("aWVkx", function(module, exports) {
    $parcel$export(module.exports, "parsePageProps", ()=>$e52064a714118f88$export$41eb0a358b69a9df);
    $parcel$export(module.exports, "parseUrl", ()=>$e52064a714118f88$export$7a5253c0f62e0150);
    var $6vAaw = parcelRequire("6vAaw");
    var $70VoX;
    var $Y2y4D;
    var $f4LKd;
    var $btHaw;
    var $8iYMC;
    function $e52064a714118f88$export$41eb0a358b69a9df(props) {
        let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
        const parsedAllowedFeatures = $e52064a714118f88$export$350c411f568eceb9(allowedFeatures);
        if (!url) return {
            contentId: contentId,
            hostname: hostname,
            parentProduct: parentProduct,
            spaceKey: spaceKey,
            protocol: 'https:',
            mode: mode ?? (0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const parsedProps = $e52064a714118f88$export$7a5253c0f62e0150(url);
        if (!parsedProps) return {
            hostname: hostname,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct,
            mode: mode,
            protocol: 'https:',
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const themeStateParsedObject = parsedProps.themeState ? (0, (0, parcelRequire("Y2y4D")).themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
        contentId = contentId || parsedProps.contentId;
        parentProduct = parentProduct || parsedProps.parentProduct;
        hostname = hostname || parsedProps.hostname || window.location.hostname;
        spaceKey = spaceKey || parsedProps.spaceKey;
        draftShareId = draftShareId || parsedProps.draftShareId;
        hash = hash || parsedProps.hash;
        themeState = themeState || themeStateParsedObject;
        let modeFromUrl;
        switch(parsedProps.route){
            case (0, (0, parcelRequire("8iYMC")).VIEW_PAGE).name:
            case (0, (0, parcelRequire("8iYMC")).VIEW_BLOG).name:
            case (0, (0, parcelRequire("8iYMC")).VIEW_BLOG_DATE_LEGACY).name:
                modeFromUrl = (0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
                break;
            case (0, (0, parcelRequire("8iYMC")).EDIT_PAGE_EMBED).name:
            case (0, (0, parcelRequire("8iYMC")).EDIT_PAGE_V2).name:
                modeFromUrl = (0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
        }
        return {
            allowedFeatures: $e52064a714118f88$export$350c411f568eceb9(allowedFeatures),
            contentId: contentId,
            draftShareId: draftShareId,
            hash: hash,
            hostname: hostname,
            mode: mode || modeFromUrl,
            parentProduct: parentProduct,
            protocol: parsedProps.protocol,
            spaceKey: spaceKey,
            themeState: themeState,
            ...passThroughProps
        };
    }
    function $e52064a714118f88$export$7a5253c0f62e0150(url) {
        if (!url) return null;
        const matchedRoute = $e52064a714118f88$var$findAndMatchRoute((0, (0, parcelRequire("8iYMC")).namedRoutes), url);
        if (!matchedRoute) return null;
        const { routeName: routeName, ...match } = matchedRoute;
        return {
            route: routeName,
            hostname: match.host,
            protocol: match.protocol,
            contentId: match.params.contentId || '',
            spaceKey: match.params.spaceKey || '',
            hash: match.hash,
            parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
            draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
            themeState: match.query.themeState
        };
    }
    function $e52064a714118f88$var$findAndMatchRoute(routes, url) {
        for (const routeName of Object.keys(routes)){
            const pattern = routes[routeName].pattern;
            const match = $e52064a714118f88$var$matchUrl(pattern, url);
            if (match) return {
                routeName: routeName,
                ...match
            };
        }
    }
    function $e52064a714118f88$var$matchUrl(pattern, url) {
        const parsed = (0, ($parcel$interopDefault($6vAaw))).parse(url, true);
        const pathname = parsed.pathname || '';
        let match = (0, (0, parcelRequire("70VoX")).default)(pathname, {
            path: pattern,
            exact: true
        });
        if (!match) match = (0, (0, parcelRequire("70VoX")).default)(`${pathname}${parsed.search}`, {
            path: pattern,
            exact: true
        });
        if (!match) return null;
        const decodedParams = {};
        if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
        return {
            url: url,
            protocol: parsed?.protocol || 'https:',
            host: parsed?.host || '',
            pathname: pathname,
            search: parsed.search || '',
            hash: parsed.hash || '',
            pattern: pattern,
            params: decodedParams,
            query: parsed.query || ''
        };
    }
    function $e52064a714118f88$export$350c411f568eceb9(allowedFeatures) {
        let parsedAllowedFeatures = {
            view: allowedFeatures?.view,
            edit: allowedFeatures?.edit
        };
        if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
            ...(0, (0, parcelRequire("f4LKd")).DEFAULT_ALLOWED_FEATURES).view,
            'edit'
        ];
        else if (Array.isArray(allowedFeatures?.view)) parsedAllowedFeatures.view = [
            ...allowedFeatures?.view,
            'edit'
        ];
        return parsedAllowedFeatures;
    }
});
parcelRegister("70VoX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51b50f39010f1f0a$export$2e2bcd8739ae039);
    var $d4Ora = parcelRequire("d4Ora");
    var $51b50f39010f1f0a$var$patternCache = {};
    var $51b50f39010f1f0a$var$cacheLimit = 10000;
    var $51b50f39010f1f0a$var$cacheCount = 0;
    var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
        var cacheKey = "" + options.end + options.strict + options.sensitive;
        var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
        if (cache[pattern]) return cache[pattern];
        var keys = [];
        var re = (0, ($parcel$interopDefault($d4Ora)))(pattern, keys, options);
        var compiledPattern = {
            re: re,
            keys: keys
        };
        if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
            cache[pattern] = compiledPattern;
            $51b50f39010f1f0a$var$cacheCount++;
        }
        return compiledPattern;
    };
    var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var parent = arguments[2];
        if (typeof options === "string") options = {
            path: options
        };
        var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
        if (path == null) return parent;
        var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), re = _compilePath.re, keys = _compilePath.keys;
        var match = re.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === "/" && url === "" ? "/" : url,
            isExact: isExact,
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    };
    var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;
});
parcelRegister("d4Ora", function(module, exports) {
    var $oJ7gO = parcelRequire("oJ7gO");
    module.exports = $9852c5da38ba91d1$var$pathToRegexp;
    module.exports.parse = $9852c5da38ba91d1$var$parse;
    module.exports.compile = $9852c5da38ba91d1$var$compile;
    module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
    module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
    var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
        '(\\\\.)',
        '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
    ].join('|'), 'g');
    function $9852c5da38ba91d1$var$parse(str, options) {
        var tokens = [];
        var key = 0;
        var index = 0;
        var path = '';
        var defaultDelimiter = options && options.delimiter || '/';
        var res;
        while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
            var m = res[0];
            var escaped = res[1];
            var offset = res.index;
            path += str.slice(index, offset);
            index = offset + m.length;
            if (escaped) {
                path += escaped[1];
                continue;
            }
            var next = str[index];
            var prefix = res[2];
            var name = res[3];
            var capture = res[4];
            var group = res[5];
            var modifier = res[6];
            var asterisk = res[7];
            if (path) {
                tokens.push(path);
                path = '';
            }
            var partial = prefix != null && next != null && next !== prefix;
            var repeat = modifier === '+' || modifier === '*';
            var optional = modifier === '?' || modifier === '*';
            var delimiter = prefix || defaultDelimiter;
            var pattern = capture || group;
            var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
            tokens.push({
                name: name || key++,
                prefix: prefix || '',
                delimiter: delimiter,
                optional: optional,
                repeat: repeat,
                partial: partial,
                asterisk: !!asterisk,
                pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
            });
        }
        if (index < str.length) path += str.substr(index);
        if (path) tokens.push(path);
        return tokens;
    }
    function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
        if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
        return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
    }
    function $9852c5da38ba91d1$var$compile(str, options) {
        return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
    }
    function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
        return encodeURI(str).replace(/[\/?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $9852c5da38ba91d1$var$encodeAsterisk(str) {
        return encodeURI(str).replace(/[?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
        var matches = new Array(tokens.length);
        for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
        return function(obj, opts) {
            var path = '';
            var data = obj || {};
            var options = opts || {};
            var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (typeof token === 'string') {
                    path += token;
                    continue;
                }
                var value = data[token.name];
                var segment;
                if (value == null) {
                    if (token.optional) {
                        if (token.partial) path += token.prefix;
                        continue;
                    } else throw new TypeError('Expected "' + token.name + '" to be defined');
                }
                if ($oJ7gO(value)) {
                    if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                    if (value.length === 0) {
                        if (token.optional) continue;
                        else throw new TypeError('Expected "' + token.name + '" to not be empty');
                    }
                    for(var j = 0; j < value.length; j++){
                        segment = encode(value[j]);
                        if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                        path += (j === 0 ? token.prefix : token.delimiter) + segment;
                    }
                    continue;
                }
                segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
                path += token.prefix + segment;
            }
            return path;
        };
    }
    function $9852c5da38ba91d1$var$escapeString(str) {
        return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
    }
    function $9852c5da38ba91d1$var$escapeGroup(group) {
        return group.replace(/([=!:$\/()])/g, '\\$1');
    }
    function $9852c5da38ba91d1$var$attachKeys(re, keys) {
        re.keys = keys;
        return re;
    }
    function $9852c5da38ba91d1$var$flags(options) {
        return options && options.sensitive ? '' : 'i';
    }
    function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
        var groups = path.source.match(/\((?!\?)/g);
        if (groups) for(var i = 0; i < groups.length; i++)keys.push({
            name: i,
            prefix: null,
            delimiter: null,
            optional: false,
            repeat: false,
            partial: false,
            asterisk: false,
            pattern: null
        });
        return $9852c5da38ba91d1$var$attachKeys(path, keys);
    }
    function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
        var parts = [];
        for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
        var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
        return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
    }
    function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
        return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
    }
    function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
        if (!$oJ7gO(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        var strict = options.strict;
        var end = options.end !== false;
        var route = '';
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
            else {
                var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
                var capture = '(?:' + token.pattern + ')';
                keys.push(token);
                if (token.repeat) capture += '(?:' + prefix + capture + ')*';
                if (token.optional) {
                    if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                    else capture = prefix + '(' + capture + ')?';
                } else capture = prefix + '(' + capture + ')';
                route += capture;
            }
        }
        var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
        var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
        if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
        if (end) route += '$';
        else route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
        return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
    }
    function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
        if (!$oJ7gO(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, keys);
        if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options);
        return $9852c5da38ba91d1$var$stringToRegexp(path, keys, options);
    }
});
parcelRegister("oJ7gO", function(module, exports) {
    module.exports = Array.isArray || function(arr) {
        return Object.prototype.toString.call(arr) == '[object Array]';
    };
});
parcelRegister("f4LKd", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", ()=>$8b2c28760d704b0d$export$a33327ada3a6ee4a);
    $parcel$export(module.exports, "getAllowedFeatures", ()=>$8b2c28760d704b0d$export$3207c60940c4a9b0);
    var $8C2Yz;
    var $btHaw;
    var $8b2c28760d704b0d$export$241b9888a4d565c9;
    (function(ALLOWED_FEATURES_TYPE) {
        ALLOWED_FEATURES_TYPE["VIEW"] = "view";
        ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
        ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    })($8b2c28760d704b0d$export$241b9888a4d565c9 || ($8b2c28760d704b0d$export$241b9888a4d565c9 = {}));
    const $8b2c28760d704b0d$export$a3fda3dcee62e1cc = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'delete',
            'edit',
            'inline-comments',
            'page-comments',
            'page-reactions',
            'sticky-header',
            'disable-login-flow',
            'disable-share',
            'non-licensed-share'
        ],
        edit: [
            'delete-draft',
            'disable-login-flow',
            'template-browser',
            'inline-comments'
        ],
        whiteboard: [
            'disable-login-flow',
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $8b2c28760d704b0d$export$a33327ada3a6ee4a = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'page-comments',
            'page-reactions',
            'inline-comments'
        ],
        edit: [
            'inline-comments'
        ],
        whiteboard: [
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $8b2c28760d704b0d$var$pageAllowedFeatures = {
        [(0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $8b2c28760d704b0d$export$a3fda3dcee62e1cc.edit,
        [(0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $8b2c28760d704b0d$export$a3fda3dcee62e1cc.view
    };
    const $8b2c28760d704b0d$var$blogPostAllowedFeatures = {
        [(0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $8b2c28760d704b0d$export$a3fda3dcee62e1cc.edit,
        [(0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $8b2c28760d704b0d$export$a3fda3dcee62e1cc.view
    };
    const $8b2c28760d704b0d$var$whiteboardAllowedFeatures = {
        [(0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $8b2c28760d704b0d$export$a3fda3dcee62e1cc.whiteboard,
        [(0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $8b2c28760d704b0d$export$a3fda3dcee62e1cc.whiteboard
    };
    const $8b2c28760d704b0d$var$contentTypeAllowedFeatures = {
        [(0, (0, parcelRequire("8C2Yz")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $8b2c28760d704b0d$var$pageAllowedFeatures,
        [(0, (0, parcelRequire("8C2Yz")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $8b2c28760d704b0d$var$blogPostAllowedFeatures,
        [(0, (0, parcelRequire("8C2Yz")).EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $8b2c28760d704b0d$var$whiteboardAllowedFeatures
    };
    const $8b2c28760d704b0d$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$8b2c28760d704b0d$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
});
parcelRegister("8C2Yz", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", ()=>$bb9e3252e224e19b$export$942a5fac9b8c9dc2);
    var $bb9e3252e224e19b$export$942a5fac9b8c9dc2;
    (function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    })($bb9e3252e224e19b$export$942a5fac9b8c9dc2 || ($bb9e3252e224e19b$export$942a5fac9b8c9dc2 = {}));
});
parcelRegister("8iYMC", function(module, exports) {
    $parcel$export(module.exports, "EDIT_PAGE_EMBED", ()=>$e137224378b149d7$export$e63a462ee45b57cf);
    $parcel$export(module.exports, "EDIT_PAGE_V2", ()=>$e137224378b149d7$export$7b1285e36c635f1f);
    $parcel$export(module.exports, "VIEW_PAGE", ()=>$e137224378b149d7$export$9257b5b55c8e2555);
    $parcel$export(module.exports, "VIEW_BLOG", ()=>$e137224378b149d7$export$91f49e7b30a9d34);
    $parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", ()=>$e137224378b149d7$export$bd2c9bb170b3681d);
    $parcel$export(module.exports, "namedRoutes", ()=>$e137224378b149d7$export$d4971375353d0454);
    $parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", ()=>$e137224378b149d7$export$5c59aa0922e65f1a);
    const $e137224378b149d7$export$e63a462ee45b57cf = {
        name: 'EDIT_PAGE_EMBED',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
    };
    const $e137224378b149d7$export$7b1285e36c635f1f = {
        name: 'EDIT_PAGE_V2',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
    };
    const $e137224378b149d7$export$65b723bb995d4fb6 = {
        name: 'SPACE_OVERVIEW',
        pattern: '/wiki/spaces/:spaceKey/overview'
    };
    const $e137224378b149d7$export$9257b5b55c8e2555 = {
        name: 'VIEW_PAGE',
        pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
    };
    const $e137224378b149d7$export$91f49e7b30a9d34 = {
        name: 'VIEW_BLOG',
        pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
    };
    const $e137224378b149d7$export$bd2c9bb170b3681d = {
        name: 'VIEW_BLOG_DATE_LEGACY',
        pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
    };
    const $e137224378b149d7$export$d4971375353d0454 = {
        EDIT_PAGE_EMBED: $e137224378b149d7$export$e63a462ee45b57cf,
        EDIT_PAGE_V2: $e137224378b149d7$export$7b1285e36c635f1f,
        SPACE_OVERVIEW: $e137224378b149d7$export$65b723bb995d4fb6,
        VIEW_PAGE: $e137224378b149d7$export$9257b5b55c8e2555,
        VIEW_BLOG: $e137224378b149d7$export$91f49e7b30a9d34,
        VIEW_BLOG_DATE_LEGACY: $e137224378b149d7$export$bd2c9bb170b3681d
    };
    const $e137224378b149d7$export$5c59aa0922e65f1a = {
        JSM_PORTAL: 'JSM-Portal',
        JSM: 'JSM',
        JSW: 'JSW',
        JWM: 'JWM'
    };
});
parcelRegister("bvqNo", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceContentTypes", ()=>$ea031aa9e3d5ef89$export$b39616d00ee96d40);
    $parcel$export(module.exports, "DisplayTypes", ()=>$ea031aa9e3d5ef89$export$c294d3f3727c1a0);
    const $ea031aa9e3d5ef89$export$b39616d00ee96d40 = {
        WHITEBOARD: 'whiteboard',
        PAGE: 'page'
    };
    const $ea031aa9e3d5ef89$export$c294d3f3727c1a0 = {
        MODAL: 'modal',
        PANEL: 'panel'
    };
});
parcelRegister("5labn", function(module, exports) {
    $parcel$export(module.exports, "getDisplayInformation", ()=>$e7deee7a3cbc4953$export$ee79869f97207574);
    var $btHaw;
    var $bvqNo;
    const $e7deee7a3cbc4953$export$37e31995727dc8d7 = 0.5;
    const $e7deee7a3cbc4953$export$ee79869f97207574 = ()=>{
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1024) return {
            initialWidth: screenWidth * $e7deee7a3cbc4953$export$37e31995727dc8d7,
            displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).PANEL
        };
        return {
            initialWidth: 0,
            displayType: (0, (0, parcelRequire("bvqNo")).DisplayTypes).MODAL
        };
    };
    const $e7deee7a3cbc4953$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
        if (mode === (0, (0, parcelRequire("btHaw")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) return contentUrl.replace('/pages/', '/pages/edit-embed/');
        if (isDraft) {
            let viewUrl = contentUrl.replace(/draftShareId=[^&]*[&]*/, '');
            const spaceName = viewUrl.match(/\/spaces\/(.*?)\/pages\//);
            if (spaceName) {
                viewUrl = viewUrl.replace('/pages/edit-embed/', '/pages/');
                viewUrl = viewUrl.replace(spaceName[1], spaceKey);
                if (viewUrl.endsWith('&')) viewUrl = viewUrl.slice(0, -1);
                if (viewUrl.endsWith('?')) viewUrl = viewUrl.slice(0, -1);
                return viewUrl;
            }
        }
        return contentUrl.replace('/pages/edit-embed/', '/pages/');
    };
});
parcelRegister("9V9QO", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPanelEntryPoint", ()=>$a6b6d10e82ec149e$export$75ef2f025ecbf1de);
    var $5uXOq = parcelRequire("5uXOq");
    var $disyi;
    var $aWVkx;
    var $gXSrH;
    var $7XluA;
    var $4mO32;
    var $koVbs;
    var $2POIy;
    var $iwjqc;
    var $4TSh0;
    var $fvjUj;
    const $a6b6d10e82ec149e$var$entryPointParams = {};
    const $a6b6d10e82ec149e$export$75ef2f025ecbf1de = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [state, actions] = (0, (0, parcelRequire("gXSrH")).useEmbeddedConfluenceSidePanel)();
        const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
        const parentProduct = (0, (0, parcelRequire("fvjUj")).useParentProduct)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("2POIy")).embeddedPanelEntrypoint), $a6b6d10e82ec149e$var$entryPointParams);
        const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
        const fireAnalyticsEvent = (0, (0, parcelRequire("4TSh0")).useEmbeddedPageTracking)();
        const themeState = (0, (0, parcelRequire("disyi")).default)();
        const contentHostname = (0, (0, parcelRequire("iwjqc")).setHostnameForContent)(contentUrl, hostname);
        const onContentAction = (0, $5uXOq.useCallback)((action, eventName)=>{
            fireAnalyticsEvent({
                action: action,
                eventName: eventName,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
        }, [
            fireAnalyticsEvent,
            embeddedConfluenceSourceForPanel
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: 'closeEmbeddedConfluencePanel',
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
            entryPointActions.unload();
            actions.closeSidePanel();
        }, [
            actions,
            fireAnalyticsEvent,
            entryPointActions,
            embeddedConfluenceSourceForPanel
        ]);
        const editAllowedFeatures = (0, $5uXOq.useMemo)(()=>[
                ...isDeferSpaceSelection ? [
                    'publish-modal'
                ] : [],
                'template-browser'
            ], [
            isDeferSpaceSelection
        ]);
        const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
        const shouldOpenPanel = isOpen && contentUrl;
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                locale: locale,
                hasFooterLogo: false,
                isDraft: isDraft,
                isLive: isLive,
                hostname: contentHostname,
                panelTitle: title,
                navigationPolicy: undefined,
                onClose: onClose,
                onContentAction: onContentAction,
                parentProduct: parentProduct,
                spaceKey: (0, (0, parcelRequire("aWVkx")).parseUrl)(contentUrl)?.spaceKey,
                themeState: themeState,
                url: contentUrl,
                mode: mode,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
                contentId: contentId,
                contentType: contentType,
                onPublish: actions.setDeferredSpaceData,
                allowedFeatures: {
                    view: [
                        'byline-contributors',
                        'byline-extensions',
                        'page-comments',
                        'page-reactions',
                        'inline-comments',
                        'non-licensed-share'
                    ],
                    ...shouldApplyEditFeatures && {
                        edit: editAllowedFeatures
                    }
                },
                linkConfluencePage: onLinkPage
            }), [
            actions.setDeferredSpaceData,
            contentId,
            contentType,
            contentUrl,
            editAllowedFeatures,
            embeddedConfluenceSourceForPanel,
            contentHostname,
            isDraft,
            isLive,
            locale,
            title,
            mode,
            onClose,
            onContentAction,
            onLinkPage,
            parentProduct,
            themeState,
            shouldApplyEditFeatures
        ]);
        return shouldOpenPanel ? {
            entryPointActions: entryPointActions,
            entryPoint: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "epPanelEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: runtimeProps
            })
        } : {
            ref: undefined,
            entryPoint: null
        };
    };
});
parcelRegister("2POIy", function(module, exports) {
    $parcel$export(module.exports, "embeddedPanelEntrypoint", ()=>$ae604dc9c27c8401$export$32561f984de7bece);
    var $2Ftxm;
    var $ikgNX;
    const $ae604dc9c27c8401$export$32561f984de7bece = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("eEEPC")), {
            moduleId: "293c24d0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eEEPC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("joESl")
    ]).then(()=>parcelRequire('k1Lui'));
});
parcelRegister("iwjqc", function(module, exports) {
    $parcel$export(module.exports, "createActivePageUrl", ()=>$5538d20fe7287eae$export$83c6318baef117fe);
    $parcel$export(module.exports, "getURLFromConfluencePageResponse", ()=>$5538d20fe7287eae$export$e87b28852220b5cd);
    $parcel$export(module.exports, "setHostnameForContent", ()=>$5538d20fe7287eae$export$8ccd4cc378896990);
    $parcel$export(module.exports, "constructUrlIfCustomDomain", ()=>$5538d20fe7287eae$export$a63ef4c6a1286e2a);
    $parcel$export(module.exports, "createLinkCreatePayload", ()=>$5538d20fe7287eae$export$af98278c506da0f4);
    var $gKZoD;
    var $Geeam;
    var $jg9TU;
    const $5538d20fe7287eae$export$f31b9480a5e4fdcf = (uri)=>{
        if (!uri || uri === '') return '';
        const matches = uri.match(/draftShareId=([^&])*/g);
        return matches ? matches[0].split('=')[1] : '';
    };
    const $5538d20fe7287eae$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
        if (!(url && spaceId && spaceKey)) return '';
        return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
    };
    const $5538d20fe7287eae$export$83c6318baef117fe = (createPayload)=>{
        const { data: data, url: url } = createPayload;
        const links = data?.links;
        const spaceKey = data?.spaceKey;
        const spaceId = data?.spaceId;
        const linkableUrl = $5538d20fe7287eae$export$be3b1ed3560ef0e6({
            url: url,
            spaceId: spaceId,
            spaceKey: spaceKey
        });
        if (data?.subType === 'live') return `${linkableUrl}`;
        return `${linkableUrl}?draftShareId=${$5538d20fe7287eae$export$f31b9480a5e4fdcf(links?.editui)}`;
    };
    const $5538d20fe7287eae$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
    const $5538d20fe7287eae$var$isUrlCustomDomain = (parentHost, url)=>{
        const hostname = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(url);
        return (0, (0, parcelRequire("jg9TU")).isCustomDomain)(parentHost) || hostname && (0, (0, parcelRequire("jg9TU")).isCustomDomain)(hostname);
    };
    const $5538d20fe7287eae$export$8ccd4cc378896990 = (url, hostname)=>{
        const parentHost = window?.location?.origin || '';
        const contentHost = hostname ?? (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(url);
        return $5538d20fe7287eae$var$isUrlCustomDomain(parentHost, url) ? (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(parentHost) : contentHost;
    };
    const $5538d20fe7287eae$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const currentHostname = window?.location?.origin || '';
        const hostnameFromUrl = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(originalDomain);
        const systemHostName = (0, (0, parcelRequire("Geeam")).getHostnameFromUrl)(systemConfluenceAppLinkUrl);
        if (systemHostName !== hostnameFromUrl && $5538d20fe7287eae$var$isUrlCustomDomain(currentHostname, originalDomain)) return $5538d20fe7287eae$export$e87b28852220b5cd({
            id: id,
            spaceKey: spaceKey,
            hostname: currentHostname
        });
        return originalUrl;
    };
    const $5538d20fe7287eae$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
            url: url,
            ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
            objectId: createResponse.id,
            objectType: 'page',
            data: {
                spaceId: space.spaceId,
                spaceKey: space.spaceKey,
                spaceName: space.spaceName,
                status: createResponse.status,
                subType: createResponse.subType,
                links: createResponse._links
            }
        });
});
parcelRegister("Geeam", function(module, exports) {
    $parcel$export(module.exports, "getHostnameFromUrl", ()=>$43eec760bfcb2d7e$export$280e79c794cf814e);
    var $cN3DC;
    const $43eec760bfcb2d7e$export$280e79c794cf814e = (url)=>(0, (0, parcelRequire("cN3DC")).isValidUrl)(url) ? new URL(url)?.hostname : '';
});
parcelRegister("cN3DC", function(module, exports) {
    $parcel$export(module.exports, "isValidUrl", ()=>$8759602a30c2f837$export$bef94a5618bf18bf);
    const $8759602a30c2f837$export$bef94a5618bf18bf = (urlString)=>{
        if (typeof urlString !== 'string') return false;
        try {
            return Boolean(new URL(urlString));
        } catch (e) {
            return false;
        }
    };
});
parcelRegister("jg9TU", function(module, exports) {
    $parcel$export(module.exports, "isCustomDomain", ()=>$cbdd6bc245553e48$export$97f4c254b641e719);
    const $cbdd6bc245553e48$var$atlassianDomains = [
        '.atlassian.com',
        '.atlassian.net',
        '.jira-dev.com',
        '.jira.com',
        '.atlassian-stg-fedm.net',
        '.atlassian-us-gov-mod.net',
        '.atlassian-us-gov-mod.com'
    ];
    const $cbdd6bc245553e48$export$97f4c254b641e719 = (hostname)=>!$cbdd6bc245553e48$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));
});
parcelRegister("4TSh0", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPageTracking", ()=>$391c3839ff18e3b3$export$9fcd107e4ed1de75);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gCtH;
    var $95EVP;
    var $9OXo1;
    var $kEkg3;
    var $gFmVN;
    const $391c3839ff18e3b3$export$9fcd107e4ed1de75 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const source = (0, (0, parcelRequire("2gCtH")).useAnalyticsSource)();
        const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject ?? `${eventName}`
            });
            const attributes = {
                parentProduct: (0, (0, parcelRequire("gFmVN")).getParentProduct)(projectType),
                tenantEditions: tenantContext?.appEditions,
                productEntitlementDetails: tenantContext?.productEntitlementDetails,
                embeddedConfluenceSource: embeddedConfluenceSource,
                jiraIssueSurfaceArea: source,
                userHasConfluenceAccess: userHasConfluenceAccess,
                tenantHasConfluence: tenantHasConfluence,
                crossJoinStatus: crossJoinStatus,
                originProduct: originProduct,
                requestedProduct: requestedProduct,
                isSiteAdmin: tenantContext?.isSiteAdmin,
                linkObjectType: linkObjectType,
                confluenceContentId: confluenceContentId
            };
            (0, (0, parcelRequire("kEkg3")).fireEmbeddedConfluenceAnalytics)({
                analyticsEvent: analyticsEvent,
                attributes: attributes,
                eventType: eventType,
                eventName: `${actionSubject ?? eventName} ${action}`
            });
        }, [
            source,
            tenantContext,
            createAnalyticsEvent
        ]);
        return trackEmbeddedConfluence;
    };
});
parcelRegister("kEkg3", function(module, exports) {
    $parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", ()=>$502082c06cc8bb17$export$864bc2da9014e8e9);
    var $8zOmE;
    const $502082c06cc8bb17$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
        switch(eventType){
            case 'ui':
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                break;
            case 'operational':
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            case 'track':
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            default:
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                break;
        }
    };
});
parcelRegister("gFmVN", function(module, exports) {
    $parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", ()=>$e40b1af8ddf646ed$export$b4e6d6efc113ca5);
    $parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", ()=>$e40b1af8ddf646ed$export$bf1e31028b579014);
    $parcel$export(module.exports, "ACCESS_DENIED_STATUSES", ()=>$e40b1af8ddf646ed$export$2fe5bb2d968b01fc);
    $parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", ()=>$e40b1af8ddf646ed$export$56360b096b4b4439);
    $parcel$export(module.exports, "getParentProduct", ()=>$e40b1af8ddf646ed$export$e873edb2560a07ef);
    var $2vSU6;
    const $e40b1af8ddf646ed$export$b4e6d6efc113ca5 = {
        ACCESS_GRANTED: 'ACCESS_GRANTED',
        ACCESS_EXISTS: 'ACCESS_EXISTS',
        DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
        DIRECT_ACCESS: 'DIRECT_ACCESS',
        FORBIDDEN: 'FORBIDDEN',
        PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
        REQUEST_ACCESS: 'REQUEST_ACCESS'
    };
    const $e40b1af8ddf646ed$export$bf1e31028b579014 = [
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_EXISTS,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_GRANTED,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
    ];
    const $e40b1af8ddf646ed$export$2fe5bb2d968b01fc = [
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.FORBIDDEN,
        $e40b1af8ddf646ed$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
    ];
    const $e40b1af8ddf646ed$export$56360b096b4b4439 = 'licence-exceeded';
    const $e40b1af8ddf646ed$export$e873edb2560a07ef = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 'JSM';
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return 'JSW';
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 'JWM';
            default:
                return 'JSW';
        }
    };
});
parcelRegister("fvjUj", function(module, exports) {
    $parcel$export(module.exports, "useParentProduct", ()=>$af9df26010027d57$export$1b09c6e3737c8eb7);
    var $dAfqg;
    var $gFmVN;
    const $af9df26010027d57$export$1b09c6e3737c8eb7 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const projectType = data?.projectType;
        return (0, (0, parcelRequire("gFmVN")).getParentProduct)(projectType);
    };
});
parcelRegister("km1Z8", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$b3ed488811f6683d$export$e2ad0ff52e7f8c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $axSKo;
    var $jH6yN;
    const $b3ed488811f6683d$export$e2ad0ff52e7f8c84 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("axSKo")).Consumer), null, ({ getManager: getManager })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jH6yN")).ImperativeAPI), {
                getItemManager: getManager
            }));
});
parcelRegister("axSKo", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$da7a6c3542bd9710$export$2881499e37b75b9a);
    $parcel$export(module.exports, "Consumer", ()=>$da7a6c3542bd9710$export$b3bffd4bb7da6b8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $fr1K2 = parcelRequire("fr1K2");
    var $itvk3;
    var $7KTvf;
    const $da7a6c3542bd9710$var$Context = (0, (0, parcelRequire("itvk3")).default)('ItemManagers');
    const $da7a6c3542bd9710$export$275138de3066e8b3 = 30000;
    class $da7a6c3542bd9710$export$2881499e37b75b9a extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($da7a6c3542bd9710$var$Context.Provider, {
                value: this.manager
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.state = {
                managers: {}
            }, this.getManager = (managerKey)=>{
                const { managers: managers } = this.state;
                const manager = managers[managerKey];
                if (manager) return manager;
                return new Promise((resolve, reject)=>{
                    const message = `Timeout. "${(0, (0, parcelRequire("7KTvf")).fromManagerKey)(managerKey)}" wasn't registered after ${$da7a6c3542bd9710$export$275138de3066e8b3}ms`;
                    const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $da7a6c3542bd9710$export$275138de3066e8b3);
                    const { pendingManagers: pendingManagers } = this;
                    pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                    pendingManagers[managerKey].push((methods)=>{
                        clearTimeout(rejectTimeoutId);
                        resolve(methods);
                    });
                });
            }, this.registerManager = (managerKey, methods)=>{
                this.setState((previousState)=>{
                    if (methods == null) return {
                        managers: (0, ($parcel$interopDefault($fr1K2)))(previousState.managers, managerKey)
                    };
                    const managerResolvers = this.pendingManagers[managerKey];
                    if (managerResolvers && managerResolvers.length) {
                        managerResolvers.forEach((resolve)=>resolve(methods));
                        managerResolvers.length = 0;
                    }
                    return {
                        managers: {
                            ...previousState.managers,
                            [managerKey]: Promise.resolve(methods)
                        }
                    };
                });
            }, this.pendingManagers = {}, this.manager = {
                getManager: this.getManager,
                registerManager: this.registerManager
            };
        }
    }
    const { Consumer: $da7a6c3542bd9710$export$b3bffd4bb7da6b8f } = $da7a6c3542bd9710$var$Context;
});
parcelRegister("itvk3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00b840b80ca03789$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $00b840b80ca03789$export$2e2bcd8739ae039 = (name)=>{
        const contextObjName = name || '';
        const defaultGetter = ()=>{
            throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
        };
        const Context = (0, $5uXOq.createContext)(defaultGetter);
        const ContextConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Context.Consumer, null, (getValue)=>{
                const value = getValue();
                return props.children(value);
            });
        const ContextProvider = ({ value: value, children: children })=>{
            const getValue = ()=>value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
                value: getValue
            }, children);
        };
        ContextProvider.displayName = `${contextObjName}SafeProvider`;
        ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
        return {
            Provider: ContextProvider,
            Consumer: ContextConsumer
        };
    };
});
parcelRegister("7KTvf", function(module, exports) {
    $parcel$export(module.exports, "fromManagerKey", ()=>$067bae373d6cebdd$export$fef172a673b3ef47);
    const $067bae373d6cebdd$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
    const $067bae373d6cebdd$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);
});
parcelRegister("jH6yN", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$5d8d26c2e79a214b$export$e2ad0ff52e7f8c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    var $dJl1T;
    var $7oGEb;
    var $1ADgn;
    var $gPQRI;
    var $1J3t1;
    var $jRCeJ;
    var $7KTvf;
    var $lVJAU;
    var $fTkzd;
    const $5d8d26c2e79a214b$var$ERROR_LOCATION = 'legacy.imperative-api';
    const $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
        const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { refresh: refresh } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const sidebarState = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const sidebarRef = (0, $5uXOq.useRef)(sidebarState);
        const refreshSidebarRef = (0, $5uXOq.useRef)(refresh);
        const imperativeAPIRef = (0, $5uXOq.useRef)({
            viewIds: (0, parcelRequire("fTkzd")).viewIds,
            itemIds: (0, parcelRequire("fTkzd")).itemIds,
            expand: expandLeftSidebar,
            collapse: collapseLeftSidebar,
            isCollapsed: ()=>sidebarRef.current.isCollapsed,
            onCollapse: ()=>undefined,
            onCollapseStart: ()=>undefined,
            onCollapseEnd: ()=>undefined,
            onExpand: ()=>undefined,
            onExpandStart: ()=>undefined,
            onExpandEnd: ()=>undefined,
            onItemClick: ()=>undefined,
            setView: ()=>undefined,
            updateActiveView: ()=>undefined,
            setProjectRootView: ()=>undefined,
            getActiveViewItems: ()=>[],
            isInProjectContext: ()=>false,
            updateContext: ()=>undefined,
            updateData: ()=>{
                refreshSidebarRef.current();
            },
            getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($5d8d26c2e79a214b$var$ERROR_LOCATION, `There was a problem getting "${(0, (0, parcelRequire("7KTvf")).fromManagerKey)(itemManagerKey)}" item manager`, e);
                    throw e;
                }),
            createBoard: ()=>{
                (0, (0, parcelRequire("1ADgn")).default)();
            },
            modalOpen: ()=>undefined,
            modalClose: ()=>undefined,
            navigate: (url)=>push(url)
        });
        sidebarRef.current = sidebarState;
        refreshSidebarRef.current = refresh;
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/navigation/bridge'
            }).then((bridge)=>{
                bridge(imperativeAPIRef.current);
            });
            (0, (0, parcelRequire("7oGEb")).provideNavigationApi)({
                navigate: push
            });
        }, [
            push
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRCeJ")).NavigationUIContainer), {
            isGlobal: true
        });
    };
});
parcelRegister("9B86Q", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeWeak", ()=>$61b2a5aa3a2a1160$export$3cefda82396756a1);
    var $ifVVd;
    let $61b2a5aa3a2a1160$var$pollingSingleton = null;
    const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
        const getter = $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, (0, parcelRequire("ifVVd")).createPollingCollection)((v)=>window.require(v), 100);
        $61b2a5aa3a2a1160$var$pollingSingleton = getter;
        return getter(name);
    };
});
parcelRegister("ifVVd", function(module, exports) {
    $parcel$export(module.exports, "createPollingCollection", ()=>$60e6b0d4bc46beac$export$f163446a982a8077);
    var $gKZoD;
    var $aePFs;
    const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
        (0, (0, parcelRequire("gKZoD")).di)(setTimeout);
        let isPolling = false;
        const deferredMap = new Map();
        const promiseMap = new Map();
        const evaluateForKey = (key)=>{
            let result;
            try {
                result = fn(key);
            } catch (error) {
                return;
            }
            const deferred = deferredMap.get(key);
            if (deferred instanceof (0, (0, parcelRequire("aePFs")).default)) {
                deferred.resolve(result);
                deferredMap.delete(key);
            }
        };
        const maybePoll = ()=>{
            if (!isPolling && deferredMap.size > 0) {
                isPolling = true;
                setTimeout(()=>{
                    isPolling = false;
                    [
                        ...deferredMap.keys()
                    ].forEach(evaluateForKey);
                    maybePoll();
                }, timeout);
            }
        };
        const getter = (key)=>{
            if (!promiseMap.has(key)) {
                const deferred = new (0, (0, parcelRequire("aePFs")).default)();
                const promise = deferred.then((v)=>v);
                deferredMap.set(key, deferred);
                promiseMap.set(key, promise);
                evaluateForKey(key);
                maybePoll();
            }
            return promiseMap.get(key);
        };
        return getter;
    };
});
parcelRegister("aePFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02f3c6551bf5b1ff$export$2e2bcd8739ae039);
    class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
        static resolve(v) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.resolve(v);
            return instance;
        }
        static reject(e) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.reject(e);
            return instance;
        }
        constructor(){
            const [fn] = Array.prototype.slice.call(arguments);
            const callbacks = [];
            super(fn ?? callbacks.push.bind(callbacks));
            this.#resolve = callbacks[0];
            this.#reject = callbacks[1];
        }
        #resolve;
        #reject;
        resolve(v) {
            this.#resolve?.(v);
        }
        reject(e) {
            this.#reject?.(e);
        }
    }
});
parcelRegister("7oGEb", function(module, exports) {
    $parcel$export(module.exports, "provideNavigationApi", ()=>$6e1dad164f29ee43$export$26d28e8849b2805f);
    $parcel$export(module.exports, "isInIframe", ()=>$6e1dad164f29ee43$export$9f140ed41af5108c);
    $parcel$export(module.exports, "canSpaTransition", ()=>$6e1dad164f29ee43$export$59e771495885068f);
    $parcel$export(module.exports, "getContainerApi", ()=>$6e1dad164f29ee43$export$91ed870fd8df2bcb);
    $parcel$export(module.exports, "getNavigationApi", ()=>$6e1dad164f29ee43$export$da4e5a44286a0dd0);
    let $6e1dad164f29ee43$var$containerApi = null;
    let $6e1dad164f29ee43$var$navigationApi = null;
    const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
        $6e1dad164f29ee43$var$containerApi = api;
    };
    const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
        $6e1dad164f29ee43$var$navigationApi = api;
    };
    const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
    const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
    const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
    const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
    const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
        $6e1dad164f29ee43$var$containerApi = null;
        $6e1dad164f29ee43$var$navigationApi = null;
    };
});
parcelRegister("1ADgn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a5ce13af6407cab$export$2e2bcd8739ae039);
    var $7T84i;
    const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
    var $7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
        const module = await (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: $7a5ce13af6407cab$var$amdModuleName,
            wrmKeys: [
                'wrc!com.pyxis.greenhopper.jira:gh-create-board'
            ]
        });
        return module.openCreateBoardModal();
    };
});
parcelRegister("7T84i", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeStrict", ()=>$89a95eb8b151782d$export$eba600d28decc4ac);
    var $c56lL;
    var $ig88W;
    var $fVOHM;
    var $fqWWz;
    const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        (0, (0, parcelRequire("c56lL")).saveStats)(name, wrmKeys);
        try {
            return window.require(name);
        } catch (error) {
            await (0, (0, parcelRequire("fVOHM")).loadWrmResources)({
                wrmKeys: wrmKeys,
                shouldLogError: shouldLogError
            });
            return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
                name: name,
                shouldLogError: shouldLogError
            });
        }
    };
});
parcelRegister("c56lL", function(module, exports) {
    $parcel$export(module.exports, "saveStats", ()=>$6c875a5034ae8433$export$9ea3ff7978093559);
    const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
        if (stats[resource] == null) stats[resource] = 1;
        else stats[resource] += 1;
    };
    const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
            requests: 0,
            amdModules: {},
            wrmKeys: {}
        });
    const $6c875a5034ae8433$var$initStats = ()=>{
        if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
            loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
        };
        else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
        return window.__WRM_INTERNAL_STATS__.loadBridge;
    };
    const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
    const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
        try {
            const stats = $6c875a5034ae8433$var$initStats();
            if ($6c875a5034ae8433$var$isPageInteractive()) return;
            stats.requests += 1;
            $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
            if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
            else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
        } catch (e) {}
    };
});
parcelRegister("ig88W", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeRace", ()=>$64f1dbae1ea314ee$export$20c32b4579d78b92);
    var $3GASE;
    var $9B86Q;
    var $fqWWz;
    const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>Promise.race([
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            }),
            new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, (0, parcelRequire("3GASE")).loadBridgeBail)({
                    name: name,
                    shouldLogError: shouldLogError
                }))
        ]);
});
parcelRegister("3GASE", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeBail", ()=>$e512b6cc4a8702e5$export$a036f92c2465504e);
    var $wRU6t;
    var $fqWWz;
    const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        try {
            return window.require(name);
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, (0, parcelRequire("wRU6t")).safeStringify)(error) ?? ''}`, {
                isSpa: __SPA__,
                name: name,
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error(`Unable to load bridge "${name}"`, {
                cause: error
            });
        }
    };
});
parcelRegister("wRU6t", function(module, exports) {
    $parcel$export(module.exports, "safeStringify", ()=>$7e2bd894031d4476$export$56831a8b9cb27763);
    const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
        if (!object) return '';
        if (object instanceof Error) return object.stack || object.message;
        return JSON.stringify(object, Object.getOwnPropertyNames(object));
    };
});
parcelRegister("fqWWz", function(module, exports) {
    $parcel$export(module.exports, "safeErrorWithoutCustomerData", ()=>$71bf66166926d1dc$export$f19a2d31722e3428);
    $parcel$export(module.exports, "MAX_RETRIES", ()=>$71bf66166926d1dc$export$1f86472c1374185a);
    $parcel$export(module.exports, "DEFAULT_TIMEOUT", ()=>$71bf66166926d1dc$export$7bd623b29ec8e1eb);
    $parcel$export(module.exports, "SHOULD_LOG_ERROR", ()=>$71bf66166926d1dc$export$37f20f0ff732fcd7);
    var $dJl1T;
    const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, (0, parcelRequire("dJl1T")).default);
    const $71bf66166926d1dc$export$1f86472c1374185a = 40;
    const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
    const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;
});
parcelRegister("fVOHM", function(module, exports) {
    $parcel$export(module.exports, "loadWrmResources", ()=>$0c0552c7bb135144$export$6cda16b6eff75f59);
    var $wRU6t;
    var $294PS;
    var $9B86Q;
    var $fqWWz;
    const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
        const isPrefetch = 'batchUrl' in options;
        let newWrmKeys = wrmKeys;
        try {
            const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
            const wrmRequireModule = await (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            });
            const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
            newWrmKeys = (0, (0, parcelRequire("294PS")).prependSuperBatchDepsOnce)(wrmKeys);
            if (isPrefetch) return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
            return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
                isSpa: __SPA__,
                wrmKeys: JSON.stringify(newWrmKeys),
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error('Unable to load wrm resource', {
                cause: error
            });
        }
    };
});
parcelRegister("294PS", function(module, exports) {
    $parcel$export(module.exports, "prependSuperBatchDepsOnce", ()=>$a437264dd6b89021$export$93d9db5fbabad1b0);
    var $1r4rO;
    let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
    const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
        const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
        const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
        const { pathname: pathname } = window.location;
        return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
    };
    const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
        if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
        $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
        return (0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies).concat(wrmKeys);
    };
});
parcelRegister("1r4rO", function(module, exports) {
    $parcel$export(module.exports, "jiraSuperBatchDependencies", ()=>$e87d6a02e2466ae8$export$f14a6b583ce9e077);
    const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner'
    ];
});
parcelRegister("jRCeJ", function(module, exports) {
    $parcel$export(module.exports, "NavigationUISubscriber", ()=>$54656242ba3a5025$export$d3dc1c18cfde5ddd);
    $parcel$export(module.exports, "NavigationUIContainer", ()=>$54656242ba3a5025$export$339ec9ca159ad81f);
    var $gg7kZ;
    var $51nlc;
    var $3h4uJ;
    const $54656242ba3a5025$export$d3dc1c18cfde5ddd = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("3h4uJ")).default), {
        displayName: 'NavigationUISubscriber',
        selector: null
    });
    const $54656242ba3a5025$export$339ec9ca159ad81f = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("3h4uJ")).default));
});
parcelRegister("3h4uJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ca73b0c81372577$export$2e2bcd8739ae039);
    var $iXqE5;
    var $8pFbi;
    const $8ca73b0c81372577$var$initialState = {
        collapseStart: new Set(),
        collapseEnd: new Set(),
        expandStart: new Set(),
        expandEnd: new Set()
    };
    var $8ca73b0c81372577$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'navigation-ui',
        initialState: $8ca73b0c81372577$var$initialState,
        actions: (0, parcelRequire("8pFbi")).default
    });
});
parcelRegister("8pFbi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c96738f03994c2c6$export$2e2bcd8739ae039);
    var $cIPJW;
    var $aUW0i;
    var $44KUn;
    var $5UAf7;
    const $c96738f03994c2c6$var$actions = {
        collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('collapseStart', cb)),
        collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('collapseStart', cb)),
        collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('collapseStart')),
        collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('collapseStart')),
        collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('collapseEnd', cb)),
        collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('collapseEnd', cb)),
        collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('collapseEnd')),
        collapseEndRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('collapseEnd', cb)),
        expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('expandStart', cb)),
        expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('expandStart', cb)),
        expandStartClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('expandStart')),
        expandStartRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('expandStart', cb)),
        expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('expandEnd', cb)),
        expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('expandEnd', cb)),
        expandEndClear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('expandEnd')),
        expandEndRun: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('expandEnd', cb)),
        clearAll: ()=>({ dispatch: dispatch })=>{
                dispatch($c96738f03994c2c6$var$actions.collapseStartClear());
                dispatch($c96738f03994c2c6$var$actions.collapseEndClear());
                dispatch($c96738f03994c2c6$var$actions.expandStartClear());
                dispatch($c96738f03994c2c6$var$actions.expandEndClear());
            }
    };
    var $c96738f03994c2c6$export$2e2bcd8739ae039 = $c96738f03994c2c6$var$actions;
});
parcelRegister("cIPJW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98a193bdf9026fb7$export$2e2bcd8739ae039);
    var $44KUn;
    var $98a193bdf9026fb7$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: new Set(getState()[key]).add(callback)
            });
            return ()=>dispatch((0, (0, parcelRequire("44KUn")).default)(key, callback));
        };
});
parcelRegister("44KUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cd1dd9b883bc2d4$export$2e2bcd8739ae039);
    var $4cd1dd9b883bc2d4$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
            if (!getState()[key]) return;
            const slice = new Set(getState()[key]);
            slice.delete(callback);
            setState({
                [key]: slice
            });
        };
});
parcelRegister("aUW0i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0765ad08a31511d2$export$2e2bcd8739ae039);
    var $0765ad08a31511d2$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>setState({
                [key]: new Set()
            });
});
parcelRegister("5UAf7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc474c9b594a3d77$export$2e2bcd8739ae039);
    var $dc474c9b594a3d77$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>(getState()[key] || new Set()).forEach((cb)=>cb(...args));
});
parcelRegister("fTkzd", function(module, exports) {
    $parcel$export(module.exports, "itemIds", ()=>$e0d97c8d376b70de$export$443ec49e59de3663);
    $parcel$export(module.exports, "viewIds", ()=>$e0d97c8d376b70de$export$8ee2fd038785d9dc);
    var $16J3A;
    const $e0d97c8d376b70de$var$ROOT = 'root/index';
    const $e0d97c8d376b70de$var$ISSUES = 'root/issues';
    const $e0d97c8d376b70de$var$DASHBOARDS = 'root/dashboards';
    const $e0d97c8d376b70de$var$PORTFOLIO = 'root/portfolio';
    const $e0d97c8d376b70de$var$WORK_SCRUM = 'work-scrum';
    const $e0d97c8d376b70de$var$PLAN_SCRUM = 'plan-scrum';
    const $e0d97c8d376b70de$var$WORK_KANBAN = 'work-kanban';
    const $e0d97c8d376b70de$var$PLAN_KANBAN = 'plan-kanban';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
    const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
    const $e0d97c8d376b70de$var$AGILITY = 'project/agility/index';
    const $e0d97c8d376b70de$var$BUSINESS = 'project/business/index';
    const $e0d97c8d376b70de$var$OPS = 'project/ops/index';
    const $e0d97c8d376b70de$var$SOFTWARE = 'project/software/index';
    const $e0d97c8d376b70de$var$SOFTWARE_ISSUES = 'project/software/issues';
    const $e0d97c8d376b70de$var$SOFTWARE_REPORTS = 'project/software/reports';
    const $e0d97c8d376b70de$var$USER = 'user/index';
    const $e0d97c8d376b70de$var$USER_REPORTS = 'user/reports';
    const $e0d97c8d376b70de$var$rootProjectViewIds = {
        AGILITY: $e0d97c8d376b70de$var$AGILITY,
        SERVICE_DESK: (0, parcelRequire("16J3A")).SERVICE_DESK,
        OPS: $e0d97c8d376b70de$var$OPS,
        BUSINESS: $e0d97c8d376b70de$var$BUSINESS,
        SOFTWARE: $e0d97c8d376b70de$var$SOFTWARE
    };
    const $e0d97c8d376b70de$var$rootViewIds = {
        ROOT: $e0d97c8d376b70de$var$ROOT,
        ISSUES: $e0d97c8d376b70de$var$ISSUES,
        DASHBOARDS: $e0d97c8d376b70de$var$DASHBOARDS,
        PORTFOLIO: $e0d97c8d376b70de$var$PORTFOLIO
    };
    const $e0d97c8d376b70de$export$443ec49e59de3663 = {
        WORK_SCRUM: $e0d97c8d376b70de$var$WORK_SCRUM,
        PLAN_SCRUM: $e0d97c8d376b70de$var$PLAN_SCRUM,
        WORK_KANBAN: $e0d97c8d376b70de$var$WORK_KANBAN,
        PLAN_KANBAN: $e0d97c8d376b70de$var$PLAN_KANBAN,
        PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
        ...(0, (0, parcelRequire("16J3A")).SERVICE_DESK_ITEMS)
    };
    const $e0d97c8d376b70de$export$8ee2fd038785d9dc = {
        ...$e0d97c8d376b70de$var$rootViewIds,
        ...$e0d97c8d376b70de$var$rootProjectViewIds,
        SOFTWARE_ISSUES: $e0d97c8d376b70de$var$SOFTWARE_ISSUES,
        SOFTWARE_REPORTS: $e0d97c8d376b70de$var$SOFTWARE_REPORTS,
        SERVICE_DESK_ISSUES: (0, parcelRequire("16J3A")).SERVICE_DESK_ISSUES,
        SERVICE_DESK_QUEUES: (0, parcelRequire("16J3A")).SERVICE_DESK_QUEUES,
        SERVICE_DESK_REPORTS: (0, parcelRequire("16J3A")).SERVICE_DESK_REPORTS,
        SERVICE_DESK_SETTINGS: (0, parcelRequire("16J3A")).SERVICE_DESK_SETTINGS,
        SERVICE_DESK_LANGUAGES: (0, parcelRequire("16J3A")).SERVICE_DESK_LANGUAGES,
        SERVICE_DESK_LEGACY_TICKET_TYPES: (0, parcelRequire("16J3A")).SERVICE_DESK_LEGACY_TICKET_TYPES,
        SERVICE_DESK_TRANSLATIONS: (0, parcelRequire("16J3A")).SERVICE_DESK_TRANSLATIONS,
        SERVICE_DESK_AUTOMATION_SUB_NAV: (0, parcelRequire("16J3A")).SERVICE_DESK_AUTOMATION_SUB_NAV,
        SERVICE_DESK_KNOWLEDGE_HUB: (0, parcelRequire("16J3A")).SERVICE_DESK_KNOWLEDGE_HUB,
        USER: $e0d97c8d376b70de$var$USER,
        USER_REPORTS: $e0d97c8d376b70de$var$USER_REPORTS
    };
});
parcelRegister("16J3A", function(module, exports) {
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$6fb2b1c825061655$export$1f70a76cb421b107);
    $parcel$export(module.exports, "HOME_ITEMS_IDS", ()=>$6fb2b1c825061655$export$9afbea2cbd37e16d);
    $parcel$export(module.exports, "PRACTICES_IDS", ()=>$6fb2b1c825061655$export$a37f4f7add086a3);
    $parcel$export(module.exports, "SERVICE_DESK_ITEMS", ()=>$6fb2b1c825061655$export$2108a7f32cd0bb12);
    $parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", ()=>$6fb2b1c825061655$export$712b4b205a2bcf1e);
    $parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", ()=>$6fb2b1c825061655$export$e2d46b728fe0a15a);
    $parcel$export(module.exports, "SERVICE_DESK", ()=>$6fb2b1c825061655$export$c8c1c8c3f8ddba61);
    $parcel$export(module.exports, "SERVICE_DESK_ISSUES", ()=>$6fb2b1c825061655$export$51fa1147c138a6ed);
    $parcel$export(module.exports, "SERVICE_DESK_QUEUES", ()=>$6fb2b1c825061655$export$456b3cfbf5e37bd8);
    $parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", ()=>$6fb2b1c825061655$export$9ccc8d85b210b219);
    $parcel$export(module.exports, "SERVICE_DESK_REPORTS", ()=>$6fb2b1c825061655$export$707771f2f7e60575);
    $parcel$export(module.exports, "SERVICE_DESK_SETTINGS", ()=>$6fb2b1c825061655$export$a87fc635598d2d50);
    $parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", ()=>$6fb2b1c825061655$export$b6bda26b77269209);
    $parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", ()=>$6fb2b1c825061655$export$776199f9e99c88e2);
    $parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", ()=>$6fb2b1c825061655$export$d70ba5c124463035);
    $parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", ()=>$6fb2b1c825061655$export$9a6deaa9c1af559f);
    const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
    const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
    const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
    const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
    const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
    const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
    const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
    const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
    const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
    const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
    const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
    const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
    const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
    const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
    const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
    const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
    const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
    const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
    const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
    const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
    const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
    const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
    const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
    const $6fb2b1c825061655$export$1f70a76cb421b107 = {
        REPORTS_CUSTOM: 'sd-reports-custom',
        REPORTS_ADDONS: 'sd-reports-addons',
        REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
        REPORTS_NAV_TEAM: 'sd-reports-nav-team',
        REPORTS_NAV_KB: 'sd-reports-nav-kb'
    };
    const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
        QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
        ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
        ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
        TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
        SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
        INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
        CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
        PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
        CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
        POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
        REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
        RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
        ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
        CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
        CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
        JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
        KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
        KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
        KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
        INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
        GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
        SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
        SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
        ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
        CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
    };
    const $6fb2b1c825061655$export$304aefafb7155b23 = {
        TOP_ACTIONS: 'knowledge-hub-top-actions',
        ALL_ARTICLES: 'knowledge-hub-all-articles',
        CATEGORIES: 'knowledge-hub-categories',
        CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
        BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
        ADD_CATEGORY: 'knowledge-hub-new-category',
        LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
    };
    const $6fb2b1c825061655$export$5fd6685a693e1064 = {
        DETAILS: 'details',
        PEOPLE: 'people',
        ITSM_FEATURES: 'itsm-features',
        SUMMARY: 'summary',
        DELETE_PROJECT: 'delete-project',
        ISSUE_TYPES: 'issue-types',
        FEATURES: 'features',
        REQUEST_TYPES: 'sd-request-types',
        TICKET_TYPES: 'sd-ticket-types',
        CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
        LANGUAGE_SUPPORT: 'sd-language-support',
        PORTAL_SETTINGS: 'sd-portal-settings',
        EMAIL_REQUESTS: 'sd-email-requests',
        CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
        PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
        PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
        PROJECT_ASSETS_AD: 'sd-project-assets-ad',
        SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
        KNOWLEDGE_BASE: 'sd-knowledge-base',
        SLAS: 'sd-slas',
        AUTOMATION: 'sd-automation',
        PLAYBOOKS: 'playbooks',
        JIRA_AUTOMATION: 'jira-automation',
        AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
        JSD_APP_DISCOVERY: 'sd-app-discovery',
        JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
        JSD_CHANGE_MANAGEMENT: 'sd-change-management',
        WORKFLOWS: 'workflows',
        SCREENS: 'screens',
        FIELDS: 'fields',
        VERSIONS: 'versions',
        COMPONENTS: 'components',
        PERMISSIONS: 'permissions',
        ISSUE_SECURITY: 'issue-security',
        NOTIFICATIONS: 'notifications',
        HIPCHAT: 'hipchat',
        ISSUE_COLLECTORS: 'issue-collectors'
    };
    const $6fb2b1c825061655$export$50b1b8fc419aca98 = {
        QUEUE_NEW: 'queue-new',
        QUEUE_MANAGE: 'queue-manage',
        QUEUES_ADDONS: 'sd-queues-addons',
        QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
        SD_QUEUES_CUSTOM: 'sd-queues-custom'
    };
    const $6fb2b1c825061655$export$a37f4f7add086a3 = {
        ADDITIONAL_ITEMS: 'sd-practices-additional-items',
        CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
        CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
        INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
        INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
    };
    const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
        SERVICE_DESK: {
            HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
            KNOWLEDGE_BASE: $6fb2b1c825061655$export$304aefafb7155b23,
            SETTINGS: $6fb2b1c825061655$export$5fd6685a693e1064,
            QUEUES: $6fb2b1c825061655$export$50b1b8fc419aca98,
            REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
        }
    };
    const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
        PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
        UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
    };
    const $6fb2b1c825061655$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
    const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
    const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
    const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
    const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
    const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
    const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
    const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
    const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
    const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
    const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
    const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';
});
parcelRegister("e1ETT", function(module, exports) {
    $parcel$export(module.exports, "AsyncLockScreenExperimentSharedWrapper", ()=>$82a7a36c9e8ee7c8$export$129bdc881130bc9);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $hPtZI;
    const $82a7a36c9e8ee7c8$var$AsyncLockScreenExperimentShared = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("l6gsK")).then(({ LockScreenExperimentShared: LockScreenExperimentShared })=>LockScreenExperimentShared), {
        moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment-shared/src/index.tsx"
    });
    function $82a7a36c9e8ee7c8$export$129bdc881130bc9() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "lock-screen-experiment-shared-async",
            packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $e113a6ff9475fdf6$export$d57b6b390e78d90f),
            id: "lock-screen-experiment-shared-async",
            packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($82a7a36c9e8ee7c8$var$AsyncLockScreenExperimentShared, null)));
    }
});
const $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $e113a6ff9475fdf6$export$d57b6b390e78d90f = 'transmuters-growth';
parcelRegister("l6gsK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3slCJ").then(()=>parcelRequire('0FUnI'));
});
parcelRegister("aqDVH", function(module, exports) {
    $parcel$export(module.exports, "jiraLossAversionModalEntryPoint", ()=>$5bb417d947b6f1f3$export$e224c255d72cf9b5);
    var $2Ftxm;
    var $ikgNX;
    const $5bb417d947b6f1f3$export$e224c255d72cf9b5 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(async ()=>(parcelRequire("hZJM8")).then(({ JiraLossAversionExperiment: JiraLossAversionExperiment })=>JiraLossAversionExperiment), {
            moduleId: "35d17363"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("hZJM8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eU8LY")
    ]).then(()=>parcelRequire('4VIPJ'));
});
parcelRegister("jElqQ", function(module, exports) {
    $parcel$export(module.exports, "PageDwellAnalyticsListener", ()=>$e847f78ebf17acd8$export$6cf89f098b551dad);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    var $6jY6G;
    var $8zOmE;
    var $95EVP;
    var $dAfqg;
    var $6yXtV;
    var $hMvRp;
    const $e847f78ebf17acd8$var$WAIT_DURATION = 5000;
    const $e847f78ebf17acd8$export$6cf89f098b551dad = ()=>{
        const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name;
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const isVisible = (0, (0, parcelRequire("hMvRp")).usePageVisibility)();
        const interval = (0, $5uXOq.useRef)(null);
        const { data: projectData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            setHasFired(false);
        }, [
            routeName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isReady) {
                interval.current = null;
                return;
            }
            if (isVisible && !hasFired) interval.current = setTimeout(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                    containerId: projectData?.projectId,
                    containerType: projectData?.projectType,
                    isLeftSidebarCollapsed: isLeftSidebarCollapsed
                });
                setHasFired(true);
            }, $e847f78ebf17acd8$var$WAIT_DURATION);
            return ()=>{
                interval.current = clearTimeout(interval.current);
            };
        }, [
            createAnalyticsEvent,
            hasFired,
            isReady,
            isVisible,
            routeName,
            projectData?.projectId,
            projectData?.projectType,
            isLeftSidebarCollapsed
        ]);
        return null;
    };
});
parcelRegister("hMvRp", function(module, exports) {
    $parcel$export(module.exports, "usePageVisibility", ()=>$124c6a08c4f63b4e$export$6c98eb2f12f4ec61);
    var $5uXOq = parcelRequire("5uXOq");
    var $laTox;
    const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, (0, parcelRequire("laTox")).isPageVisible)());
        (0, $5uXOq.useEffect)(()=>{
            const onVisibilityChange = ()=>setIsVisible((0, (0, parcelRequire("laTox")).isPageVisible)());
            document.addEventListener('visibilitychange', onVisibilityChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onVisibilityChange);
            };
        }, []);
        return isVisible;
    };
});
parcelRegister("laTox", function(module, exports) {
    $parcel$export(module.exports, "supportedVisiblityEvent", ()=>$845c75a1dcb2afb9$export$f7132cb36c80dad);
    $parcel$export(module.exports, "isPageVisible", ()=>$845c75a1dcb2afb9$export$ae4f9b990bc70f70);
    const $845c75a1dcb2afb9$var$visibilityMap = {
        hidden: 'visibilitychange',
        mozHidden: 'mozvisibilitychange',
        msHidden: 'msvisibilitychange',
        webkitHidden: 'webkitvisibilitychange'
    };
    const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find((key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
    const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
    const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];
});
parcelRegister("kKa8l", function(module, exports) {
    $parcel$export(module.exports, "MatchedRouteListener", ()=>$6e59b41cd017c405$export$c6d9204abc182c3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cfDZ3;
    var $doZTA;
    const $6e59b41cd017c405$export$c6d9204abc182c3b = ()=>{
        const [{ route: route, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(route, match), [
            route,
            match
        ]);
        return null;
    };
});
parcelRegister("bmetd", function(module, exports) {
    $parcel$export(module.exports, "PreviousRouterStateListener", ()=>$0b73f894404a9cc2$export$49e28489f2124002);
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $cfDZ3;
    var $jDDFr;
    const $0b73f894404a9cc2$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
        const previousRouterState = (0, (0, parcelRequire("1XJ20")).usePrevious)(routerState);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cfDZ3")).setPreviousRouterState)(previousRouterState ?? null);
        }, [
            previousRouterState
        ]);
        return null;
    };
    const $0b73f894404a9cc2$export$49e28489f2124002 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDDFr")).RouterSubscriber), null, (routerState)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0b73f894404a9cc2$export$3fd5ddd6b8e9a200, {
                routerState: routerState
            })));
    $0b73f894404a9cc2$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';
});
parcelRegister("1XJ20", function(module, exports) {
    $parcel$export(module.exports, "usePrevious", ()=>$011794d66b906d20$export$5cae361ad82dce8b);
    $parcel$export(module.exports, "usePreviousWithInitial", ()=>$011794d66b906d20$export$23fbbb2e62c4a911);
    var $5uXOq = parcelRequire("5uXOq");
    const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
        const ref = (0, $5uXOq.useRef)(value);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
});
parcelRegister("izgL1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c092f8fb0732f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $1u3Jv;
    var $7nE2n;
    var $iXVV6;
    var $5oFIy;
    var $5y0F0;
    var $jDDFr;
    var $gKKyW;
    const $33c092f8fb0732f9$var$QueryStringNotifier = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "querystringNotifications"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nE2n")).default), null, (flagService)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDDFr")).RouterSubscriber), null, ({ location: { search: search } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5y0F0")).RouterActions), null, ({ replace: replace })=>{
                    const { showFlag: showFlag, ...query } = (0, ($parcel$interopDefault($ebyGx))).parse(search);
                    if (!showFlag) return null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("gKKyW")).default)[showFlag] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                        eventName: "querystringNotification shown",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                        eventName: "querystringNotification notFound",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
                        op: ()=>{
                            if ((0, (0, parcelRequire("gKKyW")).default)[showFlag]) flagService.showFlag((0, (0, parcelRequire("gKKyW")).default)[showFlag]);
                            replace(`?${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`);
                        }
                    }));
                }))));
    var $33c092f8fb0732f9$export$2e2bcd8739ae039 = $33c092f8fb0732f9$var$QueryStringNotifier;
});
parcelRegister("1u3Jv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4400becd9e439df4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $4400becd9e439df4$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $4400becd9e439df4$export$2e2bcd8739ae039 = $4400becd9e439df4$var$OpTrigger;
});
parcelRegister("7nE2n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4855eee5a10070a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, (0, parcelRequire("pa9q9")).flagService)));
    var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;
});
parcelRegister("5oFIy", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$3ea3e1dfbcd8cda6$export$2ccf161b817b43b);
    var $5uXOq = parcelRequire("5uXOq");
    var $fpTxz;
    var $8zOmE;
    class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
            if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
            if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
            const eventNameSplit = eventName ? eventName.split(' ') : [];
            const action = actionProps || eventNameSplit[1];
            const actionSubject = actionSubjectProps || eventNameSplit[0];
            if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
            const actionSubjectId = actionSubjectIdProps || componentName;
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, (0, parcelRequire("8zOmE")).fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, (0, parcelRequire("fpTxz")).default)()($3ea3e1dfbcd8cda6$var$FireComponent);
    const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
        });
    const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
        });
    const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$12346a674644c156)
        });
    const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
parcelRegister("gKKyW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdf0672c10209bc$export$2e2bcd8739ae039);
    var $7HGHK;
    var $lVqGY;
    const $2fdf0672c10209bc$var$notificationMessages = {
        'jsw.board-not-found': {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jsw.board-not-found'),
            type: 'error',
            title: (0, (0, parcelRequire("lVqGY")).default).boardNotFound,
            description: (0, (0, parcelRequire("lVqGY")).default).boardNotFoundDescription
        },
        'jsw.project-not-found': {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jsw.project-not-found'),
            type: 'error',
            title: (0, (0, parcelRequire("lVqGY")).default).projectNotFound,
            description: (0, (0, parcelRequire("lVqGY")).default).projectNotFoundDescription
        }
    };
    var $2fdf0672c10209bc$export$2e2bcd8739ae039 = $2fdf0672c10209bc$var$notificationMessages;
});
parcelRegister("lVqGY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a629f5c887c4955a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a629f5c887c4955a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        boardNotFound: {
            "id": "query-string-notifier.common.board-not-found",
            "defaultMessage": "Board not found"
        },
        boardNotFoundDescription: {
            "id": "query-string-notifier.common.board-not-found-description",
            "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
        },
        projectNotFound: {
            "id": "query-string-notifier.common.project-not-found",
            "defaultMessage": "Project not found"
        },
        projectNotFoundDescription: {
            "id": "query-string-notifier.common.project-not-found-description",
            "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
        }
    });
    var $a629f5c887c4955a$export$2e2bcd8739ae039 = $a629f5c887c4955a$var$messages;
});
parcelRegister("lyCmi", function(module, exports) {
    $parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", ()=>$881dabfa53ffbc01$export$2a43717c77dd3a56);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $hPtZI;
    var $gnleF;
    const $881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("191Yr")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
        moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
    });
    const $881dabfa53ffbc01$export$2a43717c77dd3a56 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, (0, parcelRequire("gnleF")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, (0, parcelRequire("gnleF")).TEAM_NAME),
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, (0, parcelRequire("gnleF")).PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent, null)));
    };
});
parcelRegister("gnleF", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$3413b320036771c2$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$3413b320036771c2$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", ()=>$3413b320036771c2$export$48e1d3fa57b0a2d5);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$3413b320036771c2$export$c7e6a6b283196232);
    $parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", ()=>$3413b320036771c2$export$de9f5b160db96e26);
    const $3413b320036771c2$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
    const $3413b320036771c2$export$d57b6b390e78d90f = 'growth-tako';
    const $3413b320036771c2$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
    const $3413b320036771c2$export$c7e6a6b283196232 = '/gateway/api';
    const $3413b320036771c2$export$de9f5b160db96e26 = new Map([
        [
            5,
            'prj-grace-period-recc-standard-msg-1'
        ],
        [
            3,
            'prj-grace-period-recc-standard-msg-2'
        ],
        [
            1,
            'prj-grace-period-recc-standard-msg-3'
        ]
    ]);
});
parcelRegister("191Yr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aIcwu").then(()=>parcelRequire('hxssF'));
});
parcelRegister("kgLzl", function(module, exports) {
    $parcel$export(module.exports, "rovoVideoModalEntryPoint", ()=>$1c7272db9b45cdb2$export$2f67fedc6d5555a5);
    var $2Ftxm;
    var $ikgNX;
    const $1c7272db9b45cdb2$export$2f67fedc6d5555a5 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(async ()=>(parcelRequire("9qaNk")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
            moduleId: "3a307b00"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("9qaNk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("l4e09")
    ]).then(()=>parcelRequire('14875'));
});
parcelRegister("dYRe6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05aa88b82a329166$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $5oFIy;
    var $dxCvy;
    var $7tQej;
    var $2YP9W;
    var $doZTA;
    const $05aa88b82a329166$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), Redirect: Redirect = (0, (0, parcelRequire("7tQej")).Redirect), useResource: useResource = (0, (0, parcelRequire("2YP9W")).useResource), useRouter: useRouter = (0, (0, parcelRequire("doZTA")).useRouter) })=>{
        const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
        const projectKey = params.projectKey ?? query.projectKey;
        const { data: projectContext } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        if (!projectKey || !projectContext?.projectKey) return null;
        if (projectKey === projectContext.projectKey) return null;
        const search = {
            ...query,
            ...query.projectKey ? {
                projectKey: projectContext.projectKey
            } : {}
        };
        const queryString = (0, $aZsz6.qs).stringify(search, Object.entries(search).length > 0);
        const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
        const to = `${path}${queryString}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(FireOperationalAnalytics, {
            eventName: "ProjectKeyRedirect loaded",
            componentName: "ProjectKeyRedirect",
            attributes: {
                location: location,
                projectContext: projectContext
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: to
        }));
    };
    var $05aa88b82a329166$export$2e2bcd8739ae039 = $05aa88b82a329166$var$ProjectKeyRedirect;
});
parcelRegister("9yehD", function(module, exports) {
    $parcel$export(module.exports, "AsyncTrialSprintBoardModalEntryPoint", ()=>$03eb281d6ff9bb59$export$ba04f28d78ea7267);
    var $5uXOq = parcelRequire("5uXOq");
    var $ioD1B;
    var $eGLgs;
    var $ivDCs;
    var $4mO32;
    var $heNNl;
    var $7iJwP;
    var $koeKL;
    var $60gvu;
    var $j9wkq;
    const $03eb281d6ff9bb59$export$f1c59ccb370d6712 = ({ currentProjectId: currentProjectId })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const isNotTrialSprintBoardProject = (0, (0, parcelRequire("60gvu")).useIsNotTrialSprintBoardProject)(currentProjectId);
        const ctaLink = (0, (0, parcelRequire("60gvu")).useTrialSprintBoardCtaLink)();
        const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, (0, $90b4560f34ff7aba$export$c7e6a6b283196232)), [
            cloudId
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            coordinationClient.stop((0, $90b4560f34ff7aba$export$af60a7ae4202be66));
        }, [
            coordinationClient
        ]);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                ctaLink: ctaLink,
                onClose: onClose,
                coordinationClient: coordinationClient
            }), [
            ctaLink,
            coordinationClient,
            onClose
        ]);
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("j9wkq")).trialSprintBoardModalEntryPoint), entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            if (isNotTrialSprintBoardProject && ctaLink) {
                const conditionallyLoadEntryPoint = async ()=>{
                    const started = await coordinationClient.start((0, $90b4560f34ff7aba$export$af60a7ae4202be66));
                    if (started) entryPointActions.load();
                };
                conditionallyLoadEntryPoint();
            }
        }, [
            ctaLink,
            isNotTrialSprintBoardProject,
            coordinationClient,
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: coordinationClient.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            id: (0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5),
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
            teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
            errorFallback: "unmount",
            runtimeProps: runtimeProps,
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject
        }));
    };
    const $03eb281d6ff9bb59$export$ba04f28d78ea7267 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
            id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($03eb281d6ff9bb59$export$f1c59ccb370d6712, props)));
    };
});
parcelRegister("ioD1B", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerContextProvider", ()=>$c141e5ba3428702a$export$c3226151caaf2fbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    const $c141e5ba3428702a$var$choreographedStatusContextValue = {
        isAlreadyChoreographedAtAncestor: true
    };
    const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
        return shouldUseChoreographerContextProvider ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fG5AJ")).ChoreographedStatusContext).Provider, {
            value: $c141e5ba3428702a$var$choreographedStatusContextValue
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $8WQGU;
    var $1eUaI;
    var $3iMQo;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("8WQGU")).choreographerFactory)((0, (0, parcelRequire("3iMQo")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("1eUaI")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("3iMQo")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("eGLgs", function(module, exports) {
    $parcel$export(module.exports, "CoordinationClient", ()=>$754c27d37ccd1133$export$580a2294c917898c);
    $parcel$export(module.exports, "default", ()=>$754c27d37ccd1133$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bpIMA;
    var $dgHpW;
    var $aiddd;
    var $3iMQo;
    var $ioD1B;
    var $fG5AJ;
    var $10xFf;
    var $4Pf62;
    var $4R6GH;
    var $j8DrX;
    var $14XJw;
    var $7qPn9;
    const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    class $754c27d37ccd1133$export$580a2294c917898c extends (0, (0, parcelRequire("aiddd")).default) {
        constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
            const environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment'));
            const getEnvironmentType = (env)=>{
                if (env === 'prod') return (0, (0, parcelRequire("bpIMA")).envType).PROD;
                if (env === 'staging') return (0, (0, parcelRequire("bpIMA")).envType).STAGING;
                return (0, (0, parcelRequire("bpIMA")).envType).DEV;
            };
            const enableChoreographer = (0, (0, parcelRequire("10xFf")).shouldBeChoreographed)({
                messageType: messageType
            }) && !isAlreadyChoreographedAtAncestor;
            const coordinationOptions = {
                enableChoreographer: enableChoreographer,
                envType: getEnvironmentType(environment),
                additionalData: {
                    sourceProductId: (0, (0, parcelRequire("3iMQo")).ProductIds).JIRA
                }
            };
            super({
                cloudId: cloudId,
                stargateUrl: stargateUrl,
                orgId: orgId,
                isFedRAMPEnvironment: false,
                coordinationOptions: coordinationOptions
            });
            this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
            this.enableChoreographer = enableChoreographer;
            this.onMessageDisposition = onMessageDisposition;
            this.isDebugModeEnabled = (0, (0, parcelRequire("4R6GH")).fg)('ep-external-message-debug-mode');
        }
        async start(messageId) {
            if (this.isDebugModeEnabled) {
                const serverResponse = await super.start(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED);
                const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
                if (!shouldShowMessage) {
                    const didStop = await super.stop(messageId);
                    if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED);
                }
                return shouldShowMessage;
            }
            return this.shouldUseMockClient ? false : super.start(messageId).then((didStart)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED);
                return didStart;
            });
        }
        async stop(messageId) {
            return this.shouldUseMockClient ? true : super.stop(messageId).then((didStop)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED);
                return didStop;
            });
        }
    }
    function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const stargateUrl = '/gateway/api';
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
        const { fallback: fallback, messageId: messageId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: client.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dgHpW")).default), {
            client: client,
            fallback: fallback,
            messageId: messageId
        }, props.children));
    }
});
parcelRegister("10xFf", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$36201c75b4df20a7$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "environmentToEnvType", ()=>$36201c75b4df20a7$export$e2cf19200849be9e);
    var $bpIMA;
    var $t6tX9;
    function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
        return !!props?.messageType && (0, (0, parcelRequire("t6tX9")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    }
    function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("bpIMA")).envType).DEV;
            case 'staging':
                return (0, (0, parcelRequire("bpIMA")).envType).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("bpIMA")).envType).PROD;
            default:
                return (0, (0, parcelRequire("bpIMA")).envType).LOCAL;
        }
    }
});
parcelRegister("t6tX9", function(module, exports) {
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
    const $b5642a17fa90b00d$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
        $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
        $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
    ];
});
parcelRegister("ivDCs", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointContainer", ()=>$832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkDqR;
    var $8Bm0k;
    var $c5vfY;
    const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        const props = (0, $5uXOq.useMemo)(()=>({
                ...runtimeProps,
                onClose () {
                    runtimeProps.onClose?.();
                    unload();
                }
            }), [
            runtimeProps,
            unload
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkDqR")).default), null, entryPointReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            errorFallback: errorFallback || 'flag',
            placeholderName: "modal-entry-point-container",
            runtimeProps: props
        }));
    };
});
const $90b4560f34ff7aba$export$b8b9d90f9e5bd72b = '@atlassian/jira-trial-sprint-board';
const $90b4560f34ff7aba$export$d57b6b390e78d90f = 'growth-tako';
const $90b4560f34ff7aba$export$48e1d3fa57b0a2d5 = 'trialSprintBoard';
const $90b4560f34ff7aba$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';
const $90b4560f34ff7aba$export$af60a7ae4202be66 = 'prj-trial-sprint-board_message';
const $90b4560f34ff7aba$export$c7e6a6b283196232 = '/gateway/api';
parcelRegister("60gvu", function(module, exports) {
    $parcel$export(module.exports, "useCreateTrialSprintBoard", ()=>$bdbe1b0b24b673c2$export$22329068885bcc27);
    $parcel$export(module.exports, "useIsNotTrialSprintBoardProject", ()=>$bdbe1b0b24b673c2$export$8b329ff03fe43c53);
    $parcel$export(module.exports, "useTrialSprintBoardCtaLink", ()=>$bdbe1b0b24b673c2$export$a731bac57ab8049d);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $j5YhT;
    var $jX0pr;
    var $koeKL;
    var $giJBv;
    var $9mxBe;
    function $bdbe1b0b24b673c2$export$22329068885bcc27() {
        const isEligibleForExperiment = (0, (0, parcelRequire("giJBv")).useIsEligibleForTrialSprintBoard)();
        return ()=>{
            if (isEligibleForExperiment) (0, (0, parcelRequire("9mxBe")).createTrialSprintBoard)();
        };
    }
    const $bdbe1b0b24b673c2$export$dca4afd9682f517e = async (cloudId)=>{
        const siteTraits = await (0, (0, parcelRequire("jX0pr")).memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $90b4560f34ff7aba$export$cf8de4fabae858f0));
        if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
        return trialSprintBoardTrait.value;
    };
    const $bdbe1b0b24b673c2$export$5efe839f0f2e520e = async (cloudId, projectId)=>{
        const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
        return trialSprintBoardId === projectId;
    };
    const $bdbe1b0b24b673c2$export$3b897619e437256e = async (cloudId, relayEnvironment)=>{
        const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
        if (trialSprintBoardId === undefined) return false;
        const projectAri = (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
            siteId: cloudId,
            projectId: trialSprintBoardId
        }).toString();
        const { isProjectActive: isProjectActive } = await (0, (0, parcelRequire("9mxBe")).getTrialSprintBoardProjectData)(projectAri, relayEnvironment);
        return isProjectActive;
    };
    const $bdbe1b0b24b673c2$export$8220560e582c78bb = async (cloudId, relayEnvironment)=>{
        const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
        if (trialSprintBoardId === undefined) return undefined;
        const projectAri = (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
            siteId: cloudId,
            projectId: trialSprintBoardId
        }).toString();
        const { projectKey: projectKey, boardId: boardId } = await (0, (0, parcelRequire("9mxBe")).getTrialSprintBoardProjectData)(projectAri, relayEnvironment);
        if (projectKey === null || boardId === null) return undefined;
        const firstIssueKey = `${projectKey}-1`;
        const projectBoardWithIssueSelectedPath = `/jira/software/projects/${projectKey}/boards/${boardId}?selectedIssue=${firstIssueKey}`;
        return projectBoardWithIssueSelectedPath;
    };
    const $bdbe1b0b24b673c2$export$8b329ff03fe43c53 = (currentProjectId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [isNotTsbProject, setIsNotTsbProject] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            $bdbe1b0b24b673c2$export$5efe839f0f2e520e(cloudId, currentProjectId).then((isTsbProject)=>setIsNotTsbProject(!isTsbProject));
        }, [
            cloudId,
            currentProjectId
        ]);
        return isNotTsbProject;
    };
    const $bdbe1b0b24b673c2$export$a731bac57ab8049d = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
        const [ctaLink, setCtaLink] = (0, $5uXOq.useState)('');
        (0, $5uXOq.useEffect)(()=>{
            const getCtaLink = async ()=>{
                const isProjectAvailable = await $bdbe1b0b24b673c2$export$3b897619e437256e(cloudId, relayEnvironment);
                if (isProjectAvailable) {
                    const tsbIssuePath = await $bdbe1b0b24b673c2$export$8220560e582c78bb(cloudId, relayEnvironment);
                    if (tsbIssuePath !== undefined) setCtaLink(tsbIssuePath);
                }
            };
            getCtaLink();
        }, [
            cloudId,
            relayEnvironment
        ]);
        return ctaLink;
    };
});
parcelRegister("jX0pr", function(module, exports) {
    $parcel$export(module.exports, "memoizedFetchSitePersonalization", ()=>$7b32fa3ce5d65e32$export$671fb03be30194c3);
    $parcel$export(module.exports, "useSitePersonalization", ()=>$7b32fa3ce5d65e32$export$58982988039b926f);
    var $8QpSo;
    var $ld2hZ;
    var $7f4tk;
    const $7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
    const $7b32fa3ce5d65e32$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
        if (!cloudId) throw new Error('empty cloudId');
        const { attributes: attributes } = await (0, (0, parcelRequire("7f4tk")).default)($7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl(cloudId), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        return attributes;
    };
    const $7b32fa3ce5d65e32$export$671fb03be30194c3 = (0, (0, parcelRequire("8QpSo")).default)($7b32fa3ce5d65e32$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
    const $7b32fa3ce5d65e32$export$58982988039b926f = ()=>(0, (0, parcelRequire("ld2hZ")).useService)($7b32fa3ce5d65e32$export$671fb03be30194c3);
});
parcelRegister("ld2hZ", function(module, exports) {
    $parcel$export(module.exports, "useService", ()=>$b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
    $parcel$export(module.exports, "useLoadingStatusService", ()=>$b3ad55f76ff82cb6$export$c963713a27525aaf);
    var $5uXOq = parcelRequire("5uXOq");
    const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
        const [state, setState] = (0, $5uXOq.useState)({
            loading: false,
            data: undefined,
            error: undefined,
            ...initialState
        });
        const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
            setState({
                loading: true,
                error: undefined,
                data: undefined
            });
            try {
                const data = await request(requestData);
                setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
                return data;
            } catch (error) {
                setState({
                    loading: false,
                    error: error,
                    data: undefined
                });
                return undefined;
            }
        }, [
            request
        ]);
        return {
            ...state,
            fetch: fetch
        };
    };
    const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
        const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
        const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
        (0, $5uXOq.useEffect)(()=>{
            if (loading) setLoadingStatus('started');
            else if (error) setLoadingStatus('error');
            else if (data) setLoadingStatus('success');
        }, [
            data,
            loading,
            error
        ]);
        return {
            data: data,
            loadingStatus: loadingStatus,
            error: error,
            fetch: fetch
        };
    };
});
parcelRegister("giJBv", function(module, exports) {
    $parcel$export(module.exports, "useIsEligibleForTrialSprintBoard", ()=>$47804f028d4aa8cc$export$e6f5647df30a55f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dRVix;
    var $ldyPw;
    var $ef5Xn;
    var $k9JTq;
    var $7trqb;
    var $hqBSi;
    var $5oBMG;
    function $47804f028d4aa8cc$export$e6f5647df30a55f2() {
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const licenseStates = (0, (0, parcelRequire("7trqb")).useLicenseStates)();
        const productEntitlementDetails = (0, (0, parcelRequire("5oBMG")).useProductEntitlementDetails)();
        const jswAppEdition = appEditions.software;
        const hasActiveJswLicense = licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && licenseStates.software === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE) && Object.keys(licensedProducts).length === 1;
        const isOnPremiumJsw = jswAppEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
        const entitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
        const trialDaysLeft = (0, (0, parcelRequire("dRVix")).getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime) ?? 0;
        const isOnTrial = trialDaysLeft >= 0;
        return hasActiveJswLicense && isOnPremiumJsw && isOnTrial;
    }
});
parcelRegister("dRVix", function(module, exports) {
    $parcel$export(module.exports, "useIsJswUsingCcp", ()=>$9ce9420d6adb67d7$export$f8e1c288fefa6e7d);
    $parcel$export(module.exports, "useIsProductUsingCcp", ()=>$9ce9420d6adb67d7$export$b367e04990bbb76d);
    $parcel$export(module.exports, "useLoggedInPage", ()=>$9ce9420d6adb67d7$export$a7ca0608784708a1);
    $parcel$export(module.exports, "getTrialDaysLeft", ()=>$9ce9420d6adb67d7$export$954628993bf3188e);
    $parcel$export(module.exports, "isInGracePeriod", ()=>$9ce9420d6adb67d7$export$271517afaa0c15eb);
    var $kzQRc;
    var $2vSU6;
    var $cYlk7;
    var $9OXo1;
    function $9ce9420d6adb67d7$export$f8e1c288fefa6e7d() {
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        return jswEntitlement?.billingSourceSystem === 'CCP';
    }
    function $9ce9420d6adb67d7$export$b367e04990bbb76d(projectType) {
        const { productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const productKey = (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const productEntitlement = productEntitlementDetails?.[productKey];
        return productEntitlement?.billingSourceSystem === 'CCP';
    }
    function $9ce9420d6adb67d7$export$a7ca0608784708a1({ pageUrl: pageUrl }) {
        const { data: currentUserData } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const encodedPageUrl = encodeURIComponent(pageUrl);
        const encodedUserEmail = encodeURIComponent(currentUserData.user.emailAddress ?? '');
        return `https://${(0, (0, parcelRequire("kzQRc")).getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
    }
    const $9ce9420d6adb67d7$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
    const $9ce9420d6adb67d7$export$954628993bf3188e = (currentDate, trialEndTime)=>trialEndTime ? Math.ceil(($9ce9420d6adb67d7$export$9dbbf537dffaafc7(trialEndTime) - currentDate) / 86400000) : undefined;
    const $9ce9420d6adb67d7$export$271517afaa0c15eb = (currentDate, trialEndTime)=>{
        const trialDaysLeft = $9ce9420d6adb67d7$export$954628993bf3188e(currentDate, trialEndTime);
        return !trialDaysLeft || trialDaysLeft < 0;
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("k9JTq", function(module, exports) {
    $parcel$export(module.exports, "useAppEditions", ()=>$dde261c9da85268a$export$92ed15881fc090d7);
    var $9OXo1;
    const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appEditions;
    };
});
parcelRegister("5oBMG", function(module, exports) {
    $parcel$export(module.exports, "useProductEntitlementDetails", ()=>$3295ae4955475ae4$export$e02d6385b5d47f5d);
    var $9OXo1;
    const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.productEntitlementDetails || null;
    };
});
parcelRegister("9mxBe", function(module, exports) {
    $parcel$export(module.exports, "createTrialSprintBoard", ()=>$a543aaf7c0a4dacb$export$37cea344fdf9b6ed);
    $parcel$export(module.exports, "getTrialSprintBoardProjectData", ()=>$a543aaf7c0a4dacb$export$83e8cdb22fb8892d);
    var $530x5;
    var $eiowN = parcelRequire("eiowN");
    var $2vSU6;
    var $jcw0u;
    var $eusud;
    function $a543aaf7c0a4dacb$export$37cea344fdf9b6ed() {
        (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/trial-project/v1/create').catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'createTrialSprintBoard',
                    packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                    teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
                }
            });
        });
    }
    const $a543aaf7c0a4dacb$export$83e8cdb22fb8892d = async (projectAri, relayEnvironment)=>{
        const data = await (0, $eiowN.fetchQuery)(relayEnvironment, (0, (0, parcelRequire("530x5")).default), {
            projectAri: projectAri
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const project = data?.jira?.jiraProject;
        const isProjectActive = project?.status === (0, (0, parcelRequire("2vSU6")).JIRA_PROJECT_STATUS_ACTIVE);
        const projectKey = project?.key;
        const boardId = project?.boards?.edges?.[0]?.node?.boardId;
        if (!project || !projectKey || !boardId) (0, (0, parcelRequire("jcw0u")).default)({
            error: new Error('Could not retrieve all trial sprint board project data'),
            meta: {
                id: 'getTrialSprintBoardProjectData',
                packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
            },
            attributes: {
                activeStatusIsPresent: !!project?.status,
                projectKeyIsPresent: !!projectKey,
                boardId: boardId || null
            }
        });
        return {
            isProjectActive: isProjectActive,
            projectKey: projectKey ?? null,
            boardId: boardId ?? null
        };
    };
});
parcelRegister("530x5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56400afcfc79b920$export$2e2bcd8739ae039);
    const $56400afcfc79b920$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "status"
        }, v3 = {
            "kind": "ScalarField",
            "name": "key"
        }, v4 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "servicesTrialSprintBoardProjectDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "args": v4,
                                        "concreteType": "JiraBoardConnection",
                                        "kind": "LinkedField",
                                        "name": "boards",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraBoardEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraBoard",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "boards(first:1)"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "servicesTrialSprintBoardProjectDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "args": v4,
                                        "concreteType": "JiraBoardConnection",
                                        "kind": "LinkedField",
                                        "name": "boards",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraBoardEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraBoard",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            v6
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "boards(first:1)"
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1932382d2760a8f56b95470d5e7a694260755e9bfbffef22dc7eb910d386cabd",
                "metadata": {},
                "name": "servicesTrialSprintBoardProjectDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $56400afcfc79b920$var$node.hash = "2793f4acb36ace35bec2c93ab6ac60ef";
    var $56400afcfc79b920$export$2e2bcd8739ae039 = $56400afcfc79b920$var$node;
});
parcelRegister("j9wkq", function(module, exports) {
    $parcel$export(module.exports, "trialSprintBoardModalEntryPoint", ()=>$3261cdbb80ebb186$export$ee8e5ecce2602f9);
    var $2Ftxm;
    var $ikgNX;
    const $3261cdbb80ebb186$export$ee8e5ecce2602f9 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("apB5V")).then(({ TrialSprintBoardModalEntryPoint: TrialSprintBoardModalEntryPoint })=>TrialSprintBoardModalEntryPoint), {
            moduleId: "d60f0bc1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("apB5V", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cOnF4")
    ]).then(()=>parcelRequire('ejP4E'));
});
parcelRegister("dz0Q5", function(module, exports) {
    $parcel$export(module.exports, "AsyncUpflowIframeComponent", ()=>$aab5ccb109290e76$export$7f34679273a30171);
    var $hPtZI;
    const $aab5ccb109290e76$export$7f34679273a30171 = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("it3EE")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
        ssr: false,
        moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
    });
});
parcelRegister("it3EE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1umXM").then(()=>parcelRequire('f7aUi'));
});
parcelRegister("kXv2J", function(module, exports) {
    $parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", ()=>$49f1088be59356e0$export$94ad1b5fd850909f);
    var $2Ftxm;
    var $ikgNX;
    const $49f1088be59356e0$export$94ad1b5fd850909f = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(async ()=>(parcelRequire("eFKv8")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
            moduleId: "86e9ce71"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eFKv8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8f5Ah")
    ]).then(()=>parcelRequire('a48Ze'));
});
parcelRegister("4p6rw", function(module, exports) {
    $parcel$export(module.exports, "JiraHeritageLoader", ()=>$da151c89e6acf066$export$9499deca9933db5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cQZXC;
    var $1r4rO;
    var $7XYc4;
    var $4R6GH;
    var $6jY6G;
    var $6yXtV;
    var $4su49;
    var $kiABc;
    var $8Z3n8;
    const $da151c89e6acf066$var$JiraHeritageLoaderOld = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $5uXOq.useState)(false);
        (0, (0, parcelRequire("8Z3n8")).useWrmStatsEffects)();
        const loadJiraHeritageDependencies = (0, $5uXOq.useCallback)(()=>{
            setHasHeritageDownloaded(true);
            (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
                ...(0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies),
                ...(0, (0, parcelRequire("kiABc")).getJiraHeritageDependencies)()
            ]).then(()=>(0, (0, parcelRequire("cQZXC")).waitForHeritage)()?.resolve?.());
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
        }, [
            hasHeritageDownloaded,
            isReady,
            loadJiraHeritageDependencies,
            route
        ]);
        return null;
    };
    const $da151c89e6acf066$var$JiraHeritageLoaderNew = (0, $5uXOq.Fragment);
    const $da151c89e6acf066$export$9499deca9933db5b = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('no-wrm-heritage-loader'), $da151c89e6acf066$var$JiraHeritageLoaderNew, $da151c89e6acf066$var$JiraHeritageLoaderOld);
    $da151c89e6acf066$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';
});
parcelRegister("cQZXC", function(module, exports) {
    $parcel$export(module.exports, "waitForHeritage", ()=>$90def0f7a7aa11d6$export$c61060338d026f78);
    var $4R6GH;
    var $7aBP4;
    var $aePFs;
    const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
        if (false) return null;
        if (!__SPA__) return Promise.resolve();
        if (!window.__WAIT_FOR_HERITAGE__) {
            window.__WAIT_FOR_HERITAGE__ = new (0, (0, parcelRequire("aePFs")).default)();
            if ((0, (0, parcelRequire("4R6GH")).fg)('bifrost-gateway-tmp-no-wrm-via-ssr')) (0, (0, parcelRequire("7aBP4")).bootstrapWrmClient)().then(()=>{
                window.__WAIT_FOR_HERITAGE__.resolve();
            });
        }
        return window.__WAIT_FOR_HERITAGE__;
    };
});
parcelRegister("7aBP4", function(module, exports) {
    $parcel$export(module.exports, "bootstrapWrmClient", ()=>$f93199c7ae9c59d8$export$d001f71dd306cb0c);
    var $7f4tk;
    const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
    const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
        return (0, (0, parcelRequire("7f4tk")).default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
    };
    const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
        let element;
        if (resourceType === 'JAVASCRIPT') {
            element = globalThis.document?.createElement('script');
            element.setAttribute('crossorigin', '');
            element.setAttribute('src', url);
            element.setAttribute('data-client-bootstrapped', '');
            element.setAttribute('data-wrm-key', key);
            element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
        } else {
            element = globalThis.document?.createElement('link');
            element.setAttribute('crossorigin', '');
            element.setAttribute('href', url);
            element.setAttribute('rel', 'stylesheet');
            element.setAttribute('media', 'all');
            element.setAttribute('data-client-bootstrapped', '');
            element.setAttribute('data-wrm-key', key);
            element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
        }
        return element;
    };
    let $f93199c7ae9c59d8$var$hasWrmInitialised;
    const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
        const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
        return new Promise((resolve)=>{
            spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
                const WRM = globalThis.WRM = globalThis.WRM || {};
                WRM._unparsedData = data;
                WRM._unparsedErrors = errors;
                if (WRM._dataArrived) WRM._dataArrived();
                resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
                resolve();
            });
        });
    };
    const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
        if (false) return Promise.resolve();
        if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
        if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
        else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
        return $f93199c7ae9c59d8$var$hasWrmInitialised;
    };
});
parcelRegister("4su49", function(module, exports) {
    $parcel$export(module.exports, "asyncWrmRequire", ()=>$ae90ef6541667ecb$export$1024fe099ca05f05);
    $parcel$export(module.exports, "asyncWrmRequireWithPrefetch", ()=>$ae90ef6541667ecb$export$3ca0de203efa570e);
    var $8JNtu;
    var $5Ik5Y;
    const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, (0, parcelRequire("8JNtu")).wrmRequire)(resourcesToRequire);
    const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, (0, parcelRequire("5Ik5Y")).wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);
});
parcelRegister("8JNtu", function(module, exports) {
    $parcel$export(module.exports, "wrmRequire", ()=>$17e2d7d864398bad$export$cc9d8f51375ef66a);
    var $fVOHM;
    var $fqWWz;
    const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
});
parcelRegister("5Ik5Y", function(module, exports) {
    $parcel$export(module.exports, "wrmRequireWithPrefetch", ()=>$a1df1daee76d40f7$export$e53a5db19a39ed2f);
    var $fVOHM;
    var $fqWWz;
    const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError,
            batchUrl: batchUrl
        });
});
parcelRegister("kiABc", function(module, exports) {
    $parcel$export(module.exports, "getJiraHeritageDependencies", ()=>$0d81a9889d6c3d74$export$e8f6d7acd5817fa2);
    const $0d81a9889d6c3d74$export$e8f6d7acd5817fa2 = ()=>[
            'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
            'wrc!jira.webresources:key-commands',
            'wrc!jira.webresources:header',
            'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
            'wrc!jira.webresources:global-static',
            'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
            'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
            'wrc!com.atlassian.analytics.analytics-client:js-events',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
            'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
            'wrc!jira.webresources:spam-protection-flags',
            'wrc!com.atlassian.pas:pas-everypage-static',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
            'wrc!com.atlassian.auiplugin:dialog2',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
            'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
        ];
});
parcelRegister("8Z3n8", function(module, exports) {
    $parcel$export(module.exports, "useWrmStatsEffects", ()=>$b2fe1e724cbc12ec$export$7ff53723d9d2886d);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yXtV;
    var $bVDE5;
    const $b2fe1e724cbc12ec$export$7ff53723d9d2886d = ()=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [{ transitionsCount: transitionsCount }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        (0, $5uXOq.useEffect)(()=>{
            if (isReady && window.__WRM_INTERNAL_STATS__ && !window.__WRM_INTERNAL_STATS__.isPageInteractive) window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
        }, [
            isReady
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (transitionsCount > 0) window.__WRM_INTERNAL_STATS__ = {};
        }, [
            transitionsCount
        ]);
    };
});
parcelRegister("ec3NH", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbAdapter", ()=>$ea76f165da82af61$export$2255367d5c9162b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $67Adx;
    const $ea76f165da82af61$export$2255367d5c9162b3 = ()=>{
        const baseUrl = '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67Adx")).default), {
            baseUrl: baseUrl
        });
    };
});
parcelRegister("67Adx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fce4053be7c0ea3f$export$2e2bcd8739ae039);
    var $9sGI6;
    var $aYHuU;
    var $7GR7x;
    var $bQtVL;
    var $3XHss;
    var $1DFxi;
    var $fce4053be7c0ea3f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("aYHuU")).default), {
        LegacyApiBridge: (0, parcelRequire("7GR7x")).default,
        LegacyBreadcrumbConnector: (0, parcelRequire("bQtVL")).default,
        LegacyBreadcrumbState: (0, parcelRequire("1DFxi")).default,
        LegacyBreadcrumbRenderer: (0, parcelRequire("3XHss")).default
    });
});
parcelRegister("9sGI6", function(module, exports) {
    $parcel$export(module.exports, "getDisplayName", ()=>$0d4ebae82d1d47ab$export$be63e0664592e141);
    $parcel$export(module.exports, "default", ()=>$0d4ebae82d1d47ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
        if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
        if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
        return 'Component';
    };
    const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
        const WithInjectedProps = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...injectedProps,
                ...props
            });
        WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
        return WithInjectedProps;
    };
    var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;
});
parcelRegister("aYHuU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2640273d477c5ef9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jzjy1;
    var $heNNl;
    const $2640273d477c5ef9$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>(0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyApiBridge, {
                onInsertItem: api.insertItem,
                onRemoveItem: api.removeItem,
                onSetRenderTarget: api.setTargetElement
            }), state.targetElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
                id: "legacy-breadcrumb-adapter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbConnector, {
                legacyTrail: state.trail
            }), (0, ($parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbRenderer, {
                targetElement: state.targetElement
            }))));
    var $2640273d477c5ef9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('legacyBreadcrumbs', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($2640273d477c5ef9$var$LegacyBreadcrumbAdapter);
});
parcelRegister("jzjy1", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsSource", ()=>$578c443a5ba38dde$export$6890652a1aff7d1c);
    $parcel$export(module.exports, "AnalyticsSubject", ()=>$578c443a5ba38dde$export$ec9f54bd4341ceb);
    var $g6zRF;
    const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, (0, parcelRequire("g6zRF")).default)({
                source: `${name}${type}`
            })(WrappedComponent);
    const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, (0, parcelRequire("g6zRF")).default)({
                actionSubject: name,
                attributes: attributes
            })(WrappedComponent);
});
parcelRegister("7GR7x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1c2002ff619891e$export$2e2bcd8739ae039);
    var $1bJTy;
    var $9sGI6;
    var $hciGg;
    const $e1c2002ff619891e$var$analyticsEvents = {
        onInsertItemFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'insertItem'
                }
            }),
        onRemoveItemFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'removeItem'
                }
            }),
        onSetRenderTargetFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'render'
                }
            }),
        onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'onBreadCrumbsUpdate'
                }
            })
    };
    var $e1c2002ff619891e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("hciGg")).default), $e1c2002ff619891e$var$analyticsEvents);
});
parcelRegister("1bJTy", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalytics", ()=>$065c8ba87a790756$export$79f423cc3fd39762);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $jcw0u;
    var $gvRPW;
    var $i4iBk;
    const $065c8ba87a790756$var$isNotUndefined = (a)=>a !== undefined;
    const $065c8ba87a790756$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $065c8ba87a790756$var$isNotUndefined);
    };
    const $065c8ba87a790756$export$79f423cc3fd39762 = (event, payload)=>{
        try {
            event.update({
                ...$065c8ba87a790756$var$mapPayload(payload),
                analyticsType: (0, (0, parcelRequire("gvRPW")).OPERATIONAL_EVENT_TYPE)
            }).fire();
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                event: event,
                error: e,
                meta: {
                    id: 'fireOperationalAnalytics',
                    packageName: 'jiraAnalyticsWebReact',
                    teamName: 'legacy-jfp-team-do-not-use'
                }
            });
        }
    };
});
parcelRegister("i4iBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a364fe632bf506b$export$2e2bcd8739ae039);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
        const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
        return (0, ($parcel$interopDefault($9xWGk)))({
            tags: tags,
            containerId: containerId,
            containers: containers,
            containerType: containerType,
            objectId: objectId,
            objectType: objectType,
            attributes: attributes
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
});
parcelRegister("hciGg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060d1d7061b6e3c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    var $8oe80;
    var $c1YJb;
    class $060d1d7061b6e3c1$var$LegacyApiBridge extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
            (0, (0, parcelRequire("c1YJb")).default)({
                insertItem: onInsertItem,
                removeItem: onRemoveItem,
                render: onSetRenderTarget,
                onBreadCrumbsUpdate: onBreadCrumbsUpdate
            });
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args), this.onInsertItem = (item)=>{
                const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
                onInsertItemFired();
                onInsertItem(item);
            }, this.onRemoveItem = (itemId)=>{
                const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
                onRemoveItemFired();
                onRemoveItem(itemId);
            }, this.onSetRenderTarget = (element)=>{
                const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
                onSetRenderTargetFired();
                onSetRenderTarget(element);
            }, this.onBreadCrumbsUpdate = ()=>{
                const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
                onOnBreadCrumbsUpdateFired();
                return (0, $kVLXA.Observable).empty();
            };
        }
    }
    var $060d1d7061b6e3c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('legacyApiBridge', {
        onInsertItemFired: 'apiMethodCalled',
        onRemoveItemFired: 'apiMethodCalled',
        onSetRenderTargetFired: 'apiMethodCalled',
        onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
    })($060d1d7061b6e3c1$var$LegacyApiBridge);
});
parcelRegister("8oe80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd6b229cbb45328e$export$2e2bcd8739ae039);
    var $g6zRF;
    var $fpTxz;
    const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key]
                }
            }), {});
    function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
        return function(WrappedComponent) {
            return (0, (0, parcelRequire("g6zRF")).default)({
                componentName: componentName
            })((0, (0, parcelRequire("fpTxz")).default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
        };
    }
    var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;
});
parcelRegister("c1YJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8c3f644565eaafc$export$2e2bcd8739ae039);
    var $9B86Q;
    var $dJl1T;
    var $a8c3f644565eaafc$export$2e2bcd8739ae039 = (legacyAPI)=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
            name: 'jira/globalnavigator/breadcrumbs/bridge'
        }).then((bridge)=>{
            bridge(legacyAPI);
        }).catch((err)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
});
parcelRegister("bQtVL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c34ce41a7e16e82$export$2e2bcd8739ae039);
    var $9sGI6;
    var $c2D8L;
    var $btYLD;
    var $gEFwt;
    var $75PvK;
    var $7OPFF;
    var $5fGpW;
    var $2c34ce41a7e16e82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("7OPFF")).default), {
        Breadcrumb: (0, parcelRequire("c2D8L")).default,
        ProjectBreadcrumb: (0, parcelRequire("gEFwt")).default,
        BoardBreadcrumb: (0, parcelRequire("btYLD")).default,
        UserBreadcrumb: (0, parcelRequire("75PvK")).default,
        ContextProvider: (0, parcelRequire("5fGpW")).default
    });
});
parcelRegister("c2D8L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$904f5413e35195e5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $aIVNN;
    class $904f5413e35195e5$var$BreadcrumbOps extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.id = '';
            this.id = (0, ($parcel$interopDefault($7Jxgt))).v4();
            if (false) this.onPushBreadcrumb();
        }
        componentDidMount() {
            this.onPushBreadcrumb();
        }
        componentDidUpdate(prevProps) {
            const { breadcrumb: prevBreadcrumb } = prevProps;
            const { api: api, breadcrumb: breadcrumb } = this.props;
            if (!(0, ($parcel$interopDefault($ajpes)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        componentWillUnmount() {
            const { api: api } = this.props;
            api.popBreadcrumb();
        }
        onPushBreadcrumb() {
            const { api: api, breadcrumb: breadcrumb } = this.props;
            api.pushBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        render() {
            return null;
        }
    }
    const $904f5413e35195e5$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIVNN")).BreadcrumbActions), null, (__, actions)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($904f5413e35195e5$var$BreadcrumbOps, {
                api: actions,
                breadcrumb: breadcrumb
            }), children));
    $904f5413e35195e5$var$Breadcrumb.defaultProps = {
        children: null
    };
    var $904f5413e35195e5$export$2e2bcd8739ae039 = $904f5413e35195e5$var$Breadcrumb;
});
parcelRegister("aIVNN", function(module, exports) {
    $parcel$export(module.exports, "useBreadcrumbs", ()=>$446946e3e8bfa528$export$8cefe241bd876ca0);
    $parcel$export(module.exports, "BreadcrumbActions", ()=>$446946e3e8bfa528$export$9862c338ec0a6884);
    $parcel$export(module.exports, "BreadcrumbContainer", ()=>$446946e3e8bfa528$export$c7432936d9c50db7);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $446946e3e8bfa528$var$initialState = {
        trail: []
    };
    const $446946e3e8bfa528$export$e324594224ef24da = {
        pushBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: [
                        ...getState().trail,
                        breadcrumb
                    ]
                });
            },
        popBreadcrumb: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: getState().trail.slice(0, -1)
                });
            },
        updateBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
                setState({
                    trail: newTrail
                });
            }
    };
    const $446946e3e8bfa528$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $446946e3e8bfa528$var$initialState,
        actions: $446946e3e8bfa528$export$e324594224ef24da,
        name: 'BreadcrumbSweetState'
    });
    const $446946e3e8bfa528$var$_BreadcrumbSubscriber = (0, (0, parcelRequire("51nlc")).createSubscriber)($446946e3e8bfa528$var$Store);
    const $446946e3e8bfa528$export$8cefe241bd876ca0 = (0, (0, parcelRequire("3sQ5x")).createHook)($446946e3e8bfa528$var$Store);
    const $446946e3e8bfa528$export$9862c338ec0a6884 = (0, (0, parcelRequire("51nlc")).createSubscriber)($446946e3e8bfa528$var$Store, {
        selector: null
    });
    const $446946e3e8bfa528$export$c7432936d9c50db7 = (0, (0, parcelRequire("gg7kZ")).createContainer)($446946e3e8bfa528$var$Store);
});
parcelRegister("btYLD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97548d5fa76ccc5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $81ps3;
    const $97548d5fa76ccc5f$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
        const breadcrumb = {
            href: (0, (0, parcelRequire("81ps3")).createBoardUrl)(boardId),
            text: boardName,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: breadcrumb
        }, children);
    };
    $97548d5fa76ccc5f$var$BoardBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined
    };
    var $97548d5fa76ccc5f$export$2e2bcd8739ae039 = $97548d5fa76ccc5f$var$BoardBreadcrumb;
});
parcelRegister("81ps3", function(module, exports) {
    $parcel$export(module.exports, "createProjectUrl", ()=>$e04610b9d6540e69$export$1bdb1f038c5a2a90);
    $parcel$export(module.exports, "createProjectSettingsUrl", ()=>$e04610b9d6540e69$export$c435fcb42a65af32);
    $parcel$export(module.exports, "createBoardUrl", ()=>$e04610b9d6540e69$export$7037e05c8c7af6dc);
    var $02Psx;
    const $e04610b9d6540e69$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
    const $e04610b9d6540e69$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
        if (isSimplified) return (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)(projectType, projectKey);
        return `/projects/${projectKey}/settings`;
    };
    const $e04610b9d6540e69$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;
});
parcelRegister("02Psx", function(module, exports) {
    $parcel$export(module.exports, "getNextgenSettingsUrl", ()=>$a59737cd16881573$export$26432406821aa7bf);
    $parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", ()=>$a59737cd16881573$export$defee92e506aa306);
    $parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", ()=>$a59737cd16881573$export$9133e09a98a043dc);
    $parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", ()=>$a59737cd16881573$export$b0d20d18e0230e83);
    $parcel$export(module.exports, "getClassicJSWSettingsUrl", ()=>$a59737cd16881573$export$ff0a17aa36a000df);
    $parcel$export(module.exports, "getProjectSettingsDetailsUrl", ()=>$a59737cd16881573$export$16d52b9357bb73ab);
    $parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", ()=>$a59737cd16881573$export$d531a9788343348f);
    $parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$dad567762dae162e);
    $parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$8b304050f4836b59);
    var $2vSU6;
    var $3XO6n;
    var $gl0PU;
    var $1RLjE;
    const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
        const products = {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
        };
        const product = products[projectType];
        if (!product) {
            (0, (0, parcelRequire("1RLjE")).logError)((0, (0, parcelRequire("3XO6n")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('urls'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
            return `/projects/${projectKey}/settings`;
        }
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
        return `/jira/${product}/projects/${projectKey}/settings`;
    };
    const $a59737cd16881573$var$serializeBackLink = (backLink)=>{
        if (backLink == null) return '';
        const { url: url, title: title } = backLink;
        return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
    };
    const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    };
    const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
    };
    const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/automation`;
    const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
    const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
        const urlBase = projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
        return `${urlBase}/details`;
    };
    const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
});
parcelRegister("3XO6n", function(module, exports) {
    $parcel$export(module.exports, "TASK", ()=>$594ec5369f29a734$export$9355e489ad16f98e);
    $parcel$export(module.exports, "BUG", ()=>$594ec5369f29a734$export$bcf558c186108044);
    $parcel$export(module.exports, "STORY", ()=>$594ec5369f29a734$export$1ea39a3ae330045);
    $parcel$export(module.exports, "EPIC", ()=>$594ec5369f29a734$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "SUB_TASK", ()=>$594ec5369f29a734$export$a06f889861f6537d);
    $parcel$export(module.exports, "CUSTOM", ()=>$594ec5369f29a734$export$952581bc40160893);
    $parcel$export(module.exports, "TEMPLATES_WHITELIST", ()=>$594ec5369f29a734$export$dff1da4a9bab6d3e);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$594ec5369f29a734$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", ()=>$594ec5369f29a734$export$56eae1056efd4899);
    $parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", ()=>$594ec5369f29a734$export$ca61f05d869b2ea3);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", ()=>$594ec5369f29a734$export$2ec42920a0df6b9a);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", ()=>$594ec5369f29a734$export$40c10ba35ceb5c6b);
    $parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", ()=>$594ec5369f29a734$export$a11dccbf88784c62);
    $parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", ()=>$594ec5369f29a734$export$f35dc2e6deb1692e);
    $parcel$export(module.exports, "JIRA_APP_NAME", ()=>$594ec5369f29a734$export$ec5d0e43836cb3c7);
    $parcel$export(module.exports, "toPackageName", ()=>$594ec5369f29a734$export$f31a652635bd75fe);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$594ec5369f29a734$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", ()=>$594ec5369f29a734$export$a2231d79966e0ccc);
    $parcel$export(module.exports, "RADIO_FIELD_TYPE", ()=>$594ec5369f29a734$export$28a4bdf7d9b6f9);
    $parcel$export(module.exports, "USERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$9d758b3e8c6e0ed1);
    $parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b0e37d421e006913);
    $parcel$export(module.exports, "SELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$d77765147749db6b);
    $parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$42ef68d6bd555a8d);
    $parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$4db6eb15b3c529cf);
    $parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", ()=>$594ec5369f29a734$export$ee975373b7797e8a);
    $parcel$export(module.exports, "TEXT_FIELD_TYPE", ()=>$594ec5369f29a734$export$aa99342cc6a8ced5);
    $parcel$export(module.exports, "NUMBER_FIELD_TYPE", ()=>$594ec5369f29a734$export$6f327bf99e20320);
    $parcel$export(module.exports, "DATETIME_FIELD_TYPE", ()=>$594ec5369f29a734$export$dc64bdfdf9660a05);
    $parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e6d73ed745b9a04);
    $parcel$export(module.exports, "DATE_FIELD_TYPE", ()=>$594ec5369f29a734$export$d8b50f59220c7580);
    $parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$3a6f0a44478f1d2);
    $parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$68b76ef93df5a880);
    $parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e7773fccbeec45e6);
    $parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b45487b145c52a37);
    $parcel$export(module.exports, "VERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$48548129a6d117f5);
    $parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$722c271a9e11cb94);
    $parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", ()=>$594ec5369f29a734$export$33dbe2a903610aa1);
    $parcel$export(module.exports, "emptyTenantContext", ()=>$594ec5369f29a734$export$ac655f5b3ff7b929);
    var $lzeFL;
    var $5fc53;
    var $ldyPw;
    var $g5X3G;
    var $ef5Xn;
    var $7qPn9;
    var $5fc53;
    const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
    const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
    const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
    const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
    const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
    const $594ec5369f29a734$export$952581bc40160893 = 'custom';
    const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
        $594ec5369f29a734$export$9355e489ad16f98e,
        $594ec5369f29a734$export$bcf558c186108044,
        $594ec5369f29a734$export$1ea39a3ae330045,
        $594ec5369f29a734$export$3cb4a99a332e4186
    ];
    const $594ec5369f29a734$export$39cd48613b53ce2f = (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE);
    const $594ec5369f29a734$export$56eae1056efd4899 = (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE);
    const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE);
    const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
    const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
    const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
    const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
        $594ec5369f29a734$export$56eae1056efd4899,
        $594ec5369f29a734$export$39cd48613b53ce2f,
        $594ec5369f29a734$export$ca61f05d869b2ea3
    ];
    const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
    const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
    const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
    const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
    const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
    const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
    const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
    const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
    const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
    const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
    const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
    const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
    const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
    const $594ec5369f29a734$export$d77765147749db6b = 'select';
    const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
    const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
    const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
    const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
    const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
    const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
    const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
    const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
    const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
    const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
    const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
    const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
    const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
    const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
    const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
    const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
            appEditions: (0, (0, parcelRequire("ldyPw")).populateApplicationEditions)(),
            appPermissions: (0, (0, parcelRequire("7qPn9")).populateApplicationPermissions)(),
            applicationKey: null,
            areProductSuggestionsEnabled: false,
            appUpdatesAvailable: null,
            atlassianAccountId: null,
            baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
            cloudId: (0, (0, parcelRequire("g5X3G")).toCloudId)(''),
            activationId: (0, (0, parcelRequire("g5X3G")).toActivationId)(''),
            cloudName: (0, (0, parcelRequire("g5X3G")).toCloudName)(''),
            devopsProjectSignupSource: (0, (0, parcelRequire("g5X3G")).toDevopsProjectSignupSource)(''),
            environment: null,
            fabricActivityUrl: null,
            fabricNotificationLogUrl: null,
            fabricPfDirUrl: null,
            firstActivationDateMs: null,
            isAdmin: false,
            isAnonymous: false,
            isDevMode: false,
            isDevopsProjectCreationScenario: false,
            isMarketingOptOut: false,
            isSiteAdmin: false,
            languageTag: null,
            licenseStates: (0, (0, parcelRequire("ef5Xn")).populateApplicationLicenseStates)(),
            licensedProducts: {},
            locale: (0, (0, parcelRequire("lzeFL")).defaultLocale),
            loggedInUser: null,
            productCrossSellConfig: 'unknown',
            productEntitlementDetails: null,
            productPermissionGated: {
                core: false,
                software: false,
                serviceDesk: false,
                productDiscovery: false
            },
            siteAdminStatus: 'unknown',
            userFullname: null,
            xsrfToken: null,
            hasDlpEnabled: false,
            avpWorkspaceId: null
        });
});
parcelRegister("5fc53", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_LINK_SEARCH", ()=>$81f079589240b9b7$export$b144116dae474c88);
    $parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$bc917bc699b25f75);
    $parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", ()=>$81f079589240b9b7$export$5f26ca419fdffbe7);
    $parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$ce9bfd823c7e1a6d);
    $parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$346b72b1f7cd6d5a);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$b20fbcacd7942c2a);
    $parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", ()=>$81f079589240b9b7$export$a2e8554bffc61ece);
    $parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$f25cd4907cbb25b9);
    $parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5600354b43577e17);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$5dbc9917f72d0d2a);
    $parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$253649f07fb55948);
    $parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", ()=>$81f079589240b9b7$export$eb39592ba5247ee7);
    $parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", ()=>$81f079589240b9b7$export$f48a9be226105736);
    $parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$42e2e93fc721df5d);
    $parcel$export(module.exports, "APPROVALS_PANEL_TYPE", ()=>$81f079589240b9b7$export$7773375e72c953ed);
    $parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", ()=>$81f079589240b9b7$export$80ad0037098f3919);
    $parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", ()=>$81f079589240b9b7$export$6875c7efa3a5e380);
    $parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", ()=>$81f079589240b9b7$export$7c1a5c7d37b8f968);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$c5931a5d7dbfb40b);
    $parcel$export(module.exports, "BOOLEAN_GQL_FIELD", ()=>$81f079589240b9b7$export$c979d9c548c05133);
    $parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ff25e7412c4ae9c7);
    $parcel$export(module.exports, "CHECKBOX_GQL_FIELD", ()=>$81f079589240b9b7$export$16dbdf57e34e8d63);
    $parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$1bf8bec92e6e84df);
    $parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$c32f5d822fe5ea95);
    $parcel$export(module.exports, "CMDB_GQL_FIELD", ()=>$81f079589240b9b7$export$b0deb225eed90fbd);
    $parcel$export(module.exports, "COLOR_GQL_FIELD", ()=>$81f079589240b9b7$export$add3775cfea8fde3);
    $parcel$export(module.exports, "COMPONENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9631d4098abab3eb);
    $parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$ee42bc16c09ee564);
    $parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$fbcebbdce821f712);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$41dd2eb1f33d3042);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$f4e3e72a3be84e5b);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$d6738c8a6d1a735d);
    $parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$79a75502a3f0c4c4);
    $parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$ed2eabcf0931df31);
    $parcel$export(module.exports, "DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$1f17904e959f2f0b);
    $parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", ()=>$81f079589240b9b7$export$6d8da4497234455);
    $parcel$export(module.exports, "FLAG_GQL_FIELD", ()=>$81f079589240b9b7$export$9bcfac568e4fa59c);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", ()=>$81f079589240b9b7$export$dd84cd6c957c6f5e);
    $parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5cc7c39d7d1cf6d5);
    $parcel$export(module.exports, "LABEL_GQL_FIELD", ()=>$81f079589240b9b7$export$810709f0c5c2e9db);
    $parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$82cb6735134c23a2);
    $parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$85e04e9a3a81ee1);
    $parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$24c916a8a33ed20c);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$c049920d930c3b8a);
    $parcel$export(module.exports, "NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$3b6d7fc1833bf7da);
    $parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", ()=>$81f079589240b9b7$export$bd3e2fe853319c13);
    $parcel$export(module.exports, "PARENT_GQL_FIELD", ()=>$81f079589240b9b7$export$6dfd3fc78bc751a0);
    $parcel$export(module.exports, "PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$31aea7548807c6b5);
    $parcel$export(module.exports, "PRIORITY_GQL_FIELD", ()=>$81f079589240b9b7$export$e89fbbf3983c0219);
    $parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", ()=>$81f079589240b9b7$export$f5e2fb1022ff7912);
    $parcel$export(module.exports, "PROJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$12f54499c6252188);
    $parcel$export(module.exports, "RADIO_GQL_FIELD", ()=>$81f079589240b9b7$export$8e4293d806f435e0);
    $parcel$export(module.exports, "REPORTER_GQL_FIELD", ()=>$81f079589240b9b7$export$c69486dd643dfb69);
    $parcel$export(module.exports, "RESOLUTION_GQL_FIELD", ()=>$81f079589240b9b7$export$1e4faa0d6dc58a81);
    $parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$37f4daaa7b409554);
    $parcel$export(module.exports, "SECURITY_GQL_FIELD", ()=>$81f079589240b9b7$export$ca57cccd6d7bf97c);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$bea889616fd5bdab);
    $parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ab5cecc580898d1c);
    $parcel$export(module.exports, "SPRINT_GQL_FIELD", ()=>$81f079589240b9b7$export$bb63813d13e8eaf7);
    $parcel$export(module.exports, "STATUS_GQL_FIELD", ()=>$81f079589240b9b7$export$e40f819979b3881d);
    $parcel$export(module.exports, "TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$6c243704a22baffe);
    $parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", ()=>$81f079589240b9b7$export$6c32429bac235203);
    $parcel$export(module.exports, "TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$61b514b470cbbf07);
    $parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", ()=>$81f079589240b9b7$export$e4bcb1729da5683);
    $parcel$export(module.exports, "URL_GQL_FIELD", ()=>$81f079589240b9b7$export$37ccd11f08a93ccb);
    $parcel$export(module.exports, "USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$abf1bf8c1106ba7d);
    $parcel$export(module.exports, "VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$b55604041ae7179e);
    $parcel$export(module.exports, "VOTES_GQL_FIELD", ()=>$81f079589240b9b7$export$c8bf66d62e74cdd2);
    $parcel$export(module.exports, "WATCHES_GQL_FIELD", ()=>$81f079589240b9b7$export$aa815aaa741ae18);
    $parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", ()=>$81f079589240b9b7$export$e805f89b15d2abf4);
    $parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$5bfd36acd96f04c2);
    $parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", ()=>$81f079589240b9b7$export$695423a2bc8a9ac4);
    $parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", ()=>$81f079589240b9b7$export$d29b0ba0d80bc129);
    $parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", ()=>$81f079589240b9b7$export$ac6c7b30703608d6);
    $parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$478b546dccd33e1e);
    $parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", ()=>$81f079589240b9b7$export$f90c042e9eb983e7);
    $parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", ()=>$81f079589240b9b7$export$753ca4fb34ff3f2b);
    $parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$b7aed9efb4a9154b);
    $parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", ()=>$81f079589240b9b7$export$1763713d718f7ef0);
    $parcel$export(module.exports, "FORGE_USER_GQL_FIELD", ()=>$81f079589240b9b7$export$ebb0caa2a98dcf9e);
    $parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", ()=>$81f079589240b9b7$export$671131ba12d94144);
    $parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", ()=>$81f079589240b9b7$export$c48132adab502d6b);
    $parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", ()=>$81f079589240b9b7$export$6cd83226f31c7072);
    $parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$7de726bd6d97a9a7);
    $parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$8e4b538f77340a05);
    $parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", ()=>$81f079589240b9b7$export$10ba8c0d74470907);
    $parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", ()=>$81f079589240b9b7$export$1756bb4eff1cc3c6);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5876b4be3c4407b);
    $parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", ()=>$81f079589240b9b7$export$e7fe49e6f36c7154);
    $parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", ()=>$81f079589240b9b7$export$aeed3395a6bca18b);
    $parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9b725a1eafd02e4f);
    $parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", ()=>$81f079589240b9b7$export$699805cbca2c41d);
    $parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", ()=>$81f079589240b9b7$export$f658d5c0f0b5dbc2);
    $parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", ()=>$81f079589240b9b7$export$e469bcb2060000af);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$81f079589240b9b7$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "GOALS_GQL_FIELD", ()=>$81f079589240b9b7$export$bfcb1a91094f113a);
    $parcel$export(module.exports, "DURATION_GQL_FIELD", ()=>$81f079589240b9b7$export$db0bd6c04eb7d04a);
    $parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", ()=>$81f079589240b9b7$export$798d2f5814884447);
    $parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", ()=>$81f079589240b9b7$export$269d70c1b1c9fb80);
    $parcel$export(module.exports, "APPROVALS_CF_TYPE", ()=>$81f079589240b9b7$export$f0f17ef462331df4);
    $parcel$export(module.exports, "CATEGORY_TYPE", ()=>$81f079589240b9b7$export$3c7d8923295a5199);
    $parcel$export(module.exports, "PEOPLE_CF_TYPE", ()=>$81f079589240b9b7$export$fb431e758c9252df);
    $parcel$export(module.exports, "NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$c7faa96db185cfc6);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", ()=>$81f079589240b9b7$export$492b0fa4fe201a22);
    $parcel$export(module.exports, "URL_CF_TYPE", ()=>$81f079589240b9b7$export$60f0bd6e4b582fe6);
    $parcel$export(module.exports, "TEXT_CF_TYPE", ()=>$81f079589240b9b7$export$68c7e01d5460d298);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$81f079589240b9b7$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", ()=>$81f079589240b9b7$export$977db5973ce73e44);
    $parcel$export(module.exports, "LABELS_CF_TYPE", ()=>$81f079589240b9b7$export$ad4eb83f78528e13);
    $parcel$export(module.exports, "DATE_CF_TYPE", ()=>$81f079589240b9b7$export$ff745f432984005d);
    $parcel$export(module.exports, "DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$42d097f7b1622ef1);
    $parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", ()=>$81f079589240b9b7$export$65524be5675e57e6);
    $parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", ()=>$81f079589240b9b7$export$5280e5501a801dc0);
    $parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c5d13ea26562d57a);
    $parcel$export(module.exports, "SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$22ac48a51c014e4b);
    $parcel$export(module.exports, "EPIC_STATUS_TYPE", ()=>$81f079589240b9b7$export$6769c2c97b828e11);
    $parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$39866626496bbfc8);
    $parcel$export(module.exports, "VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$24382b4e8c58336b);
    $parcel$export(module.exports, "GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b075907882e80160);
    $parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b600addfa3355c57);
    $parcel$export(module.exports, "USER_CF_TYPE", ()=>$81f079589240b9b7$export$c491a4b98394028e);
    $parcel$export(module.exports, "MULTI_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5365f2d3fac5261a);
    $parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$cc8ffff49170b0f4);
    $parcel$export(module.exports, "FLAGGED_CF_TYPE", ()=>$81f079589240b9b7$export$b7178f601d7373f9);
    $parcel$export(module.exports, "TEAM_CF_TYPE", ()=>$81f079589240b9b7$export$eb1f1dca13a0f02d);
    $parcel$export(module.exports, "PARENT_CF_TYPE", ()=>$81f079589240b9b7$export$3e71e11f80203acb);
    $parcel$export(module.exports, "BASELINE_START_CF_TYPE", ()=>$81f079589240b9b7$export$d10d66823a65e688);
    $parcel$export(module.exports, "BASELINE_END_CF_TYPE", ()=>$81f079589240b9b7$export$dfc6da4a9963d5dc);
    $parcel$export(module.exports, "COLOR_CF_TYPE", ()=>$81f079589240b9b7$export$b4a1fbc1cf0059cf);
    $parcel$export(module.exports, "EPIC_COLOR_TYPE", ()=>$81f079589240b9b7$export$4838a8a8d62a64fd);
    $parcel$export(module.exports, "ASSETS_CF_TYPE", ()=>$81f079589240b9b7$export$ed2de20ab8b7ad3d);
    $parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", ()=>$81f079589240b9b7$export$b755e97dbfa92610);
    $parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$1be1ecd4dfc06fab);
    $parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", ()=>$81f079589240b9b7$export$34317c2d84a93553);
    $parcel$export(module.exports, "ORGANIZATION_CF_TYPE", ()=>$81f079589240b9b7$export$c1e26582406f77ec);
    $parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", ()=>$81f079589240b9b7$export$555b4f35f98a3210);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", ()=>$81f079589240b9b7$export$1f2859a3ef701a14);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$68f62eb762e4157f);
    $parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", ()=>$81f079589240b9b7$export$6da975fce1fbd38e);
    $parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", ()=>$81f079589240b9b7$export$c6dd874aae21e51f);
    $parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c3c9f8a8a8dc0b30);
    $parcel$export(module.exports, "RANK_CF_TYPE", ()=>$81f079589240b9b7$export$af89c0396aaf23e3);
    $parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$3b5a62bb34372404);
    $parcel$export(module.exports, "READ_ONLY_CF_TYPE", ()=>$81f079589240b9b7$export$247829aef464243f);
    $parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", ()=>$81f079589240b9b7$export$65a6076c0927d413);
    $parcel$export(module.exports, "RESPONDERS_CF_TYPE", ()=>$81f079589240b9b7$export$bcf83e1d934501c9);
    $parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", ()=>$81f079589240b9b7$export$ae0eeec12e90a01e);
    $parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23f6b40da18371a);
    $parcel$export(module.exports, "SENTIMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23cfbdf83daa90d);
    $parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", ()=>$81f079589240b9b7$export$21dda64db57e4883);
    $parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", ()=>$81f079589240b9b7$export$45700f3bf92a003a);
    $parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", ()=>$81f079589240b9b7$export$2d75b47d12efc812);
    $parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", ()=>$81f079589240b9b7$export$7b79405842547ccb);
    $parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", ()=>$81f079589240b9b7$export$96201d0ae03ca323);
    $parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$fc276d6ccf118a14);
    $parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", ()=>$81f079589240b9b7$export$8b0718167d092603);
    $parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", ()=>$81f079589240b9b7$export$904b40dd2afd17a2);
    $parcel$export(module.exports, "GOALS_CF_TYPE", ()=>$81f079589240b9b7$export$2bbb7f69c97ea279);
    $parcel$export(module.exports, "ASSIGNEE_TYPE", ()=>$81f079589240b9b7$export$fba8634fd401ba8b);
    $parcel$export(module.exports, "REPORTER_TYPE", ()=>$81f079589240b9b7$export$a91aea2438afcce8);
    $parcel$export(module.exports, "DUE_DATE_TYPE", ()=>$81f079589240b9b7$export$b159f8b8f27aae4c);
    $parcel$export(module.exports, "PRIORITY_TYPE", ()=>$81f079589240b9b7$export$34740f8d07d23ac0);
    $parcel$export(module.exports, "LABELS_TYPE", ()=>$81f079589240b9b7$export$43b6e33ec70f2272);
    $parcel$export(module.exports, "CREATED", ()=>$81f079589240b9b7$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$81f079589240b9b7$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "RESOLUTION_DATE", ()=>$81f079589240b9b7$export$6a052efb0b4ec5d2);
    $parcel$export(module.exports, "COMPONENTS_TYPE", ()=>$81f079589240b9b7$export$37abf56f13f61ec5);
    $parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", ()=>$81f079589240b9b7$export$aef0c22aecd16996);
    $parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", ()=>$81f079589240b9b7$export$cff5b6d1e7135679);
    $parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", ()=>$81f079589240b9b7$export$791007408faf42f4);
    $parcel$export(module.exports, "DEV_SUMMARY_TYPE", ()=>$81f079589240b9b7$export$827a1c600bac12a3);
    $parcel$export(module.exports, "RELEASES_TYPE", ()=>$81f079589240b9b7$export$e9ba671d077969f8);
    $parcel$export(module.exports, "SPRINT_TYPE", ()=>$81f079589240b9b7$export$3d37701ba6fb68ec);
    $parcel$export(module.exports, "STORY_POINTS_TYPE", ()=>$81f079589240b9b7$export$36fd22f47020f37b);
    $parcel$export(module.exports, "EPIC_TYPE", ()=>$81f079589240b9b7$export$9f2fedcd916d2a79);
    $parcel$export(module.exports, "EPIC_NAME_TYPE", ()=>$81f079589240b9b7$export$dfc63737b8c0150d);
    $parcel$export(module.exports, "FIX_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$a5c9f63aadcb220);
    $parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$94009605902e4fe5);
    $parcel$export(module.exports, "DESCRIPTION_TYPE", ()=>$81f079589240b9b7$export$5e7324042f1d6b31);
    $parcel$export(module.exports, "ENVIRONMENT_TYPE", ()=>$81f079589240b9b7$export$113281d03e6830ef);
    $parcel$export(module.exports, "WATCHES_TYPE", ()=>$81f079589240b9b7$export$5ff798870a3dffbf);
    $parcel$export(module.exports, "SUMMARY_TYPE", ()=>$81f079589240b9b7$export$907219511d14ba3d);
    $parcel$export(module.exports, "PROFORMA_FORMS", ()=>$81f079589240b9b7$export$d09aa6a4f3538063);
    $parcel$export(module.exports, "RESOLUTION_TYPE", ()=>$81f079589240b9b7$export$3aca8c91b58a42e2);
    $parcel$export(module.exports, "TIME_TRACKING_TYPE", ()=>$81f079589240b9b7$export$ccb5ffefbf8b987c);
    $parcel$export(module.exports, "TIME_ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$c8bedad98a5e7f5f);
    $parcel$export(module.exports, "STATUS_TYPE", ()=>$81f079589240b9b7$export$358267065be1e);
    $parcel$export(module.exports, "STATUS_CATEGORY_TYPE", ()=>$81f079589240b9b7$export$dcaa788c7ada56de);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$81f079589240b9b7$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_KEY_TYPE", ()=>$81f079589240b9b7$export$5e91047fe9955d0e);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$81f079589240b9b7$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$335851d83a79891);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$7b76bbcb87d41695);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$297b67ac63f09f72);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$ae87161126086be);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$6a88420fc2f6901d);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$ef1a0421bd42c0e4);
    $parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$dd695c8c5ab62f9d);
    $parcel$export(module.exports, "SLA_PANEL_TYPE", ()=>$81f079589240b9b7$export$7b3d247435a784fa);
    $parcel$export(module.exports, "LINKED_ALERTS_TYPE", ()=>$81f079589240b9b7$export$17b7080ed1fe8cfd);
    $parcel$export(module.exports, "CHAT_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$29fe745131dad7ba);
    $parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$9c245100c3091ec3);
    $parcel$export(module.exports, "ZOOM_MEETING_TYPE", ()=>$81f079589240b9b7$export$51eb15cea47a37ba);
    $parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", ()=>$81f079589240b9b7$export$c7ae0622b0bd5d56);
    $parcel$export(module.exports, "CONFERENCE_CALL_TYPE", ()=>$81f079589240b9b7$export$f7dcde9e9e88aff2);
    $parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", ()=>$81f079589240b9b7$export$b5358afda8ff335e);
    $parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", ()=>$81f079589240b9b7$export$63cf6f392da16c25);
    $parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", ()=>$81f079589240b9b7$export$22f61ccc2730431f);
    $parcel$export(module.exports, "SUBTASKS_TYPE", ()=>$81f079589240b9b7$export$8bbb446f57294715);
    $parcel$export(module.exports, "VOTES_TYPE", ()=>$81f079589240b9b7$export$34fcd7cb291a1e4d);
    $parcel$export(module.exports, "PARENT_TYPE", ()=>$81f079589240b9b7$export$5e93f2a57cc4ca3a);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$81f079589240b9b7$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "TIME_SPENT_TYPE", ()=>$81f079589240b9b7$export$ede0a4c20124ec85);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", ()=>$81f079589240b9b7$export$3eeb79d48fb5f667);
    $parcel$export(module.exports, "SENTIMENT_TYPE", ()=>$81f079589240b9b7$export$45e72c9a63ab61ab);
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$81f079589240b9b7$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$81f079589240b9b7$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", ()=>$81f079589240b9b7$export$84e5674890d55030);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE", ()=>$81f079589240b9b7$export$326a5522a485e43d);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", ()=>$81f079589240b9b7$export$c9f3f01e2c535302);
    $parcel$export(module.exports, "TEAM_TYPE", ()=>$81f079589240b9b7$export$66519f3bbff1796a);
    $parcel$export(module.exports, "ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$a4ee0bca77cc8463);
    $parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", ()=>$81f079589240b9b7$export$fed53408e89e0497);
    $parcel$export(module.exports, "TARGET_START_TYPE", ()=>$81f079589240b9b7$export$d53c26f9ce31f56b);
    $parcel$export(module.exports, "TARGET_END_TYPE", ()=>$81f079589240b9b7$export$48f82d653f85e459);
    $parcel$export(module.exports, "START_DATE_TYPE", ()=>$81f079589240b9b7$export$ea5a888f39f722c7);
    $parcel$export(module.exports, "COLOR_TYPE", ()=>$81f079589240b9b7$export$f245bbec12cc0e40);
    $parcel$export(module.exports, "ATTACHMENT_TYPE", ()=>$81f079589240b9b7$export$aed630b4b7114a59);
    $parcel$export(module.exports, "ISSUE_LINKS_TYPE", ()=>$81f079589240b9b7$export$b50c1a8fef07104);
    $parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", ()=>$81f079589240b9b7$export$ea3d72f4bb7738ba);
    $parcel$export(module.exports, "COMMENT_TYPE", ()=>$81f079589240b9b7$export$a4cab0124760d860);
    $parcel$export(module.exports, "WORK_LOG_TYPE", ()=>$81f079589240b9b7$export$734929aef118d7e2);
    $parcel$export(module.exports, "PARENT_FIELD_TYPE", ()=>$81f079589240b9b7$export$ffbacacb07c1d46d);
    $parcel$export(module.exports, "getLayoutFieldTypes", ()=>$81f079589240b9b7$export$3c3e26aadbfa2c32);
    var $8QpSo;
    var $4R6GH;
    const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
    const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
    const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
    const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
    const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
    const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
    const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option';
    const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
    const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
    const $81f079589240b9b7$export$5600354b43577e17 = 'user';
    const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
    const $81f079589240b9b7$export$253649f07fb55948 = 'object';
    const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
    const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
    const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
    const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues';
    const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
    const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
    const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
    const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
    const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
    const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
    const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
    const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
    const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
    const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
    const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
    const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
    const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
    const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
    const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
    const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
    const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
    const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
    const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
    const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
    const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
    const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
    const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
    const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
    const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
    const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
    const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
    const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
    const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
    const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
    const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
    const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
    const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
    const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
    const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
    const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
    const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
    const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
    const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
    const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
    const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
    const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
    const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
    const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
    const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
    const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
    const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
    const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
    const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
    const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
    const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
    const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
    const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
    const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
    const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
    const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
    const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
    const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
    const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
    const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
    const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
    const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
    const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
    const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
    const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
    const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
    const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
    const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
    const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
    const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
    const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
    const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
    const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
    const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
    const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
    const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
    const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
    const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
    const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
    const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
    const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
    const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
    const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
    const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
    const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
    const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
    const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
    const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
    const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
    const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
    const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
    const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
    const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
    const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
    const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
    const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
    const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
    const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
    const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
    const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
    const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
    const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
    const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
    const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
    const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
    const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
    const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
    const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
    const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
    const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
    const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
    const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
    const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
    const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
    const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
    const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
    const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
    const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
    const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
    const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
    const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
    const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
    const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
    const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
    const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
    const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
    const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
    const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
    const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
    const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
    const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
    const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
    const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
    const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
    const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
    const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
    const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
    const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
    const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
    const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
    const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
    const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
    const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
    const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
    const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
    const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
    const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
    const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
    const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
    const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
    const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
    const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
    const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
    const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
    const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
    const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
    const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
    const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
    const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
    const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
    const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
    const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
    const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
    const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
    const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
    const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
    const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
    const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
    const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
    const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
    const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
    const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
    const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
    const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
    const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
    const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
    const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
    const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
    const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
    const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
    const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
    const $81f079589240b9b7$export$358267065be1e = 'status';
    const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
    const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
    const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
    const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
    const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
    const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
    const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
    const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
    const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
    const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
    const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
    const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
    const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
    const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
    const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
    const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
    const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
    const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
    const $81f079589240b9b7$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
    const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
    const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
    const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
    const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
    const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
    const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
    const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue';
    const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
    const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
    const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
    const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
    const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
    const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
    const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
    const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
    const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
    const $81f079589240b9b7$export$326a5522a485e43d = 'security';
    const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
    const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
    const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
    const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
    const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
    const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
    const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
    const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
    const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
    const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
    const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
    const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
    const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
    const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
    const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
    const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
    const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
    const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
    const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
    const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
    const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
    const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
        const types = {
            ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
            DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
            PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
            REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
            DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
            LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
            COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
            SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
            STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
            TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
            FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
            AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
            TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
            TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
            ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
            DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
            APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
            KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
            SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
            LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
            CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
            MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
            ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
            MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
            CONFERENCE_CALL_TYPE: $81f079589240b9b7$export$f7dcde9e9e88aff2,
            ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
            RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
            MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
            COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
            EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
            RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
            BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
            BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
            LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
            TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
            MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
            PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
            URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
            NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
            STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
            SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
            EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
            MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
            ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
            FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
            ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
            ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
            ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
            FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
            TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
            MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
            VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
            DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
            GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
            MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
            USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
            DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
            MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
            RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
            TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
            ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
            ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
            ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
            ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
            ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
            REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
            SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
            REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
            ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
            REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
            PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
            REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
            ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
            APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
            CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
            PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
            CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
            READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
            MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
            MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
            EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
            ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
            CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
            ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
            GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
            PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a
        };
        Object.assign(types, {
            FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm-sentiment-analysis')) Object.assign(types, {
            SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
        });
        Object.assign(types, {
            SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('remove_epic_link_and_parent_link_from_issue_view')) {
            Object.assign(types, {
                EPIC_TYPE: $81f079589240b9b7$export$9f2fedcd916d2a79
            });
            Object.assign(types, {
                PARENT_CF_TYPE: $81f079589240b9b7$export$3e71e11f80203acb
            });
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap')) Object.assign(types, {
            ORGANIZATION_CF_TYPE: $81f079589240b9b7$export$c1e26582406f77ec
        });
        return types;
    };
    const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, (0, parcelRequire("8QpSo")).default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);
});
parcelRegister("gl0PU", function(module, exports) {
    $parcel$export(module.exports, "toErrorId", ()=>$b5e194c6e2cc34cd$export$706bbe4209d93dfe);
    $parcel$export(module.exports, "toErrorMessage", ()=>$b5e194c6e2cc34cd$export$95506c204c060a3);
    const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
    const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;
});
parcelRegister("1RLjE", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$b0fc9ceb76f86c8e$export$58da9968c3170cb1);
    var $dJl1T;
    var $jcw0u;
    const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: packageName,
                id: errorId,
                teamName: 'morphinecake'
            },
            attributes: {
                ...attributes,
                message: message
            },
            error: error
        });
        const location = `${packageName}.${errorId}`;
        (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, message, error);
    };
});
parcelRegister("gEFwt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b024406020849893$export$2e2bcd8739ae039);
    var $az4zD;
    var $4V6Dv;
    var $b024406020849893$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("4V6Dv")).default));
});
parcelRegister("az4zD", function(module, exports) {
    $parcel$export(module.exports, "injectIntlV2", ()=>$90dc1bd887533804$export$440265f0ca78e98e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dY8Js = parcelRequire("dY8Js");
    var $koVbs;
    const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
    function $90dc1bd887533804$var$getDisplayName(Component) {
        if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) return Component.displayName;
        if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
        return 'Component';
    }
    const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
        const { withRef: withRef = false } = options || {};
        const WithIntl = (props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const intlRef = (0, $5uXOq.useRef)(null);
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatNumber: intl.formatNumber,
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            });
        };
        WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
        WithIntl.WrappedComponent = WrappedComponent;
        if (withRef) return (0, ($parcel$interopDefault($dY8Js)))((0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WithIntl, {
                ...props,
                forwardedRef: ref
            })), WrappedComponent);
        return (0, ($parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
    };
});
parcelRegister("4V6Dv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83ca195db24613ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $81ps3;
    var $bnbo9;
    const $83ca195db24613ad$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
        const ProjectsBreadcrumb = {
            href: '/jira/projects',
            text: formatMessage((0, (0, parcelRequire("bnbo9")).default).projectsTitle),
            type: 'projectsDirectory',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProjectsList'
            }
        };
        if (projectKey != null && projectName != null) {
            const breadcrumb = {
                href: (0, (0, parcelRequire("81ps3")).createProjectUrl)(projectKey),
                text: projectName,
                type: 'projectName',
                analyticsAttributes: {
                    nextGenProject: isSimplifiedProject,
                    projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
                },
                analyticsFields: {
                    name: 'navigateToProject',
                    containerId: projectId,
                    containerType: 'project'
                }
            };
            const ProjectNameBreadcrumb = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: breadcrumb
            }, children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: ProjectsBreadcrumb
            }, ProjectNameBreadcrumb);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: ProjectsBreadcrumb
        }, children);
    };
    $83ca195db24613ad$var$ProjectBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined,
        projectKey: undefined,
        projectName: undefined
    };
    var $83ca195db24613ad$export$2e2bcd8739ae039 = $83ca195db24613ad$var$ProjectBreadcrumb;
});
parcelRegister("bnbo9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b60cdda05341e39$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1b60cdda05341e39$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsTitle: {
            "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("75PvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc6b338da4258947$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    const $fc6b338da4258947$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
        const breadcrumb = {
            href: profileUrl,
            text: name,
            type: 'userName'
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: breadcrumb
        }, children);
    };
    var $fc6b338da4258947$export$2e2bcd8739ae039 = $fc6b338da4258947$var$UserBreadcrumb;
});
parcelRegister("7OPFF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760c31310830da08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $760c31310830da08$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
            ...legacyCrumb,
            legacyId: id,
            type: 'legacy'
        });
    const $760c31310830da08$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ContextProvider, null, ({ data: data })=>{
            if (!data) return children;
            const boardBreadcrumb = data.scope ? (0, ($parcel$interopDefault($5uXOq))).createElement(BoardBreadcrumb, {
                boardId: data.scope.id,
                boardName: data.scope.name || 'Board'
            }, children) : children;
            return data.contextType === 'user' ? (0, ($parcel$interopDefault($5uXOq))).createElement(UserBreadcrumb, {
                profileUrl: data.user.profileUrl,
                name: data.user.name
            }, boardBreadcrumb) : (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectBreadcrumb, {
                projectKey: data.project.key,
                projectName: data.project.name,
                projectId: data.project.id,
                isSimplifiedProject: data.project.isSimplified
            }, boardBreadcrumb);
        });
    const $760c31310830da08$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
        const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Breadcrumb, {
                breadcrumb: currentCrumb
            }, accumulatedCrumbs);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($760c31310830da08$var$ContextBreadcrumbs, {
            BoardBreadcrumb: BoardBreadcrumb,
            ProjectBreadcrumb: ProjectBreadcrumb,
            UserBreadcrumb: UserBreadcrumb,
            ContextProvider: ContextProvider
        }, legacyTrail.map($760c31310830da08$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
    };
    var $760c31310830da08$export$2e2bcd8739ae039 = $760c31310830da08$var$LegacyBreadcrumbConnector;
});
parcelRegister("5fGpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cc7aa08354ae9ed$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $4DPZY;
    var $bmKPg;
    var $ieDtd;
    const $2cc7aa08354ae9ed$export$9f27bc3417b4524d = ({ children: children })=>{
        const [boardId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('boardId');
        const [rapidView] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('rapidView');
        const [{ data: ctxData, loading: loading, error: error }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, ($parcel$interopDefault($fr1K2)))(ctxData, 'scope');
        return children({
            data: data,
            loading: loading,
            error: error
        });
    };
    var $2cc7aa08354ae9ed$export$2e2bcd8739ae039 = $2cc7aa08354ae9ed$export$9f27bc3417b4524d;
});
parcelRegister("4DPZY", function(module, exports) {
    $parcel$export(module.exports, "useContainerContext", ()=>$a65e0c39573f7437$export$c7066c2d215990cf);
    $parcel$export(module.exports, "ContainerContextSubscriber", ()=>$a65e0c39573f7437$export$5b87a78c45d5dd17);
    var $5uXOq = parcelRequire("5uXOq");
    var $7xTO3;
    var $ggg5j;
    var $2YP9W;
    var $6SkQo;
    const $a65e0c39573f7437$var$useProjectContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource));
        const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getProjectContext)(data), [
            data
        ]);
        return [
            {
                data: projectContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource));
        const userContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getUserContext)(data), [
            data
        ]);
        return [
            {
                data: userContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
        const projectContext = $a65e0c39573f7437$var$useProjectContext();
        const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
        if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
        return projectContext;
    };
    const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
        const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
        return props.children(data, actions);
    };
    $a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';
});
parcelRegister("6SkQo", function(module, exports) {
    $parcel$export(module.exports, "getUserContext", ()=>$84cf60e2c9c0e289$export$114c35c2c23732ab);
    $parcel$export(module.exports, "getProjectContext", ()=>$84cf60e2c9c0e289$export$d17fffd59c7b3c60);
    var $2vSU6;
    var $bsuuc;
    const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
        const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
        return {
            contextType: 'user',
            user: {
                id: owner.id,
                name: owner.name,
                avatarUrl: owner.avatarUrl,
                profileUrl: owner.profileUrl,
                accountId: owner.accountId
            },
            scope: {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            }
        };
    };
    const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
        if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
            const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
            return {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            };
        }
        return undefined;
    };
    const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
        switch(projectType){
            case 'business':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'software':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'service_desk':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'product_discovery':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
        const project = (0, (0, parcelRequire("bsuuc")).extractData)(projectNavInfo);
        const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
        if (project) {
            const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
            if (projectType) return {
                contextType: 'project',
                project: {
                    key: project.key,
                    id: project.id,
                    name: project.name,
                    type: projectType,
                    isSimplified: project.isSimplified,
                    avatarUrl: project.avatarUrl,
                    style: (0, (0, parcelRequire("bsuuc")).getStyle)(project.isSimplified)
                },
                scope: scope
            };
        }
        return null;
    };
});
parcelRegister("3XHss", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65b3956e27a1612f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $jS4lj;
    const $65b3956e27a1612f$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
    class $65b3956e27a1612f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidCatch(error) {
            const { targetElement: targetElement } = this.props;
            const targetId = targetElement ? targetElement.id : 'not-found';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($65b3956e27a1612f$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
        }
        render() {
            const { targetElement: targetElement } = this.props;
            return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null), targetElement);
        }
    }
});
parcelRegister("jS4lj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c6eafb2b612d104$export$2e2bcd8739ae039);
    var $1bJTy;
    var $9sGI6;
    var $9OXo1;
    var $0SW74;
    const $8c6eafb2b612d104$var$fireAnalytics = (analyticsEvent)=>(0, (0, parcelRequire("1bJTy")).fireOperationalAnalytics)(analyticsEvent, {
            name: 'breadcrumbRendererMounted'
        });
    var $8c6eafb2b612d104$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("0SW74")).default), {
        onMount: $8c6eafb2b612d104$var$fireAnalytics,
        TenantContextSubscriber: (0, parcelRequire("9OXo1")).TenantContextSubscriber
    });
});
parcelRegister("0SW74", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa2b8169c8c69f79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8oe80;
    var $4R6GH;
    var $6lcpk;
    var $3HwlS;
    var $aIVNN;
    const $fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
                ...crumb,
                target: crumb.target || '_self'
            }));
    const $fa2b8169c8c69f79$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
        const [{ trail: trail }] = (0, (0, parcelRequire("aIVNN")).useBreadcrumbs)();
        const items = (0, $5uXOq.useMemo)(()=>$fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems(trail), [
            trail
        ]);
        (0, $5uXOq.useEffect)(onMount, []);
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) return (0, ($parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lcpk")).default), {
            isVisible: true,
            items: items
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapperOld, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lcpk")).default), {
            isVisible: true,
            items: items
        }));
    };
    var $fa2b8169c8c69f79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('breadcrumbsRenderer', {
        onMount: 'mounted'
    })($fa2b8169c8c69f79$var$BreadcrumbRenderer);
    const $fa2b8169c8c69f79$var$BreadcrumbsWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1tcg",
                __cmplp.className
            ])
        });
    });
    const $fa2b8169c8c69f79$var$BreadcrumbsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1tcg _nwukvy9e _1o8h13fh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6lcpk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$741d99934750459a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $j6iTu;
    function $741d99934750459a$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6iTu")).default), {
            isVisible: isVisible,
            items: items
        }));
    }
});
parcelRegister("j6iTu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5be1ac78992edda2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $1eHCV;
    var $dkxUw;
    var $koVbs;
    var $hDzhb;
    var $92r9l;
    var $2UzOj;
    const $5be1ac78992edda2$export$67abef37aa2929b0 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ...props,
            ref: ref,
            type: "a"
        }));
    function $5be1ac78992edda2$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return isVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dkxUw")).default), {
            onExpand: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($gccSB)))(items) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eHCV")).default), {
            text: "",
            "aria-label": formatMessage((0, (0, parcelRequire("2UzOj")).default).breadcrumbsLabel)
        }) : items.map((breadcrumb, index)=>{
            const breadcrumbItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92r9l")).default), {
                key: index,
                index: index,
                hasSeparator: true,
                text: breadcrumb.text,
                target: __SPA__ ? undefined : breadcrumb.target,
                href: breadcrumb.href,
                component: __SPA__ ? $5be1ac78992edda2$export$67abef37aa2929b0 : undefined,
                legacyId: breadcrumb.legacyId,
                type: breadcrumb.type,
                analyticsAttributes: breadcrumb.analyticsAttributes,
                analyticsFields: breadcrumb.analyticsFields
            });
            return breadcrumbItem;
        }))) : null;
    }
});
parcelRegister("1eHCV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e8c51cb2306014d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $MGmIU;
    var $harrN;
    var $j9LYN;
    const $6e8c51cb2306014d$var$itemWrapperStyles = null;
    const $6e8c51cb2306014d$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
    const $6e8c51cb2306014d$var$ICON_WIDTH_ESTIMATE = 24;
    const $6e8c51cb2306014d$var$staticItemStyles = null;
    const $6e8c51cb2306014d$var$staticItemWithTruncationStyles = null;
    const $6e8c51cb2306014d$var$staticItemWithoutTruncationStyles = null;
    const $6e8c51cb2306014d$var$BreadcrumbsItem = (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, ...rest })=>{
        const buttonRef = (0, $5uXOq.useRef)(null);
        let iconWidthAllowance = 0;
        if (iconBefore) iconWidthAllowance += $6e8c51cb2306014d$var$ICON_WIDTH_ESTIMATE;
        if (iconAfter) iconWidthAllowance += $6e8c51cb2306014d$var$ICON_WIDTH_ESTIMATE;
        const [hasOverflow, showTooltip] = (0, (0, parcelRequire("j9LYN")).default)(truncationWidth, buttonRef.current, iconWidthAllowance);
        const dynamicItemStyles = {
            [$6e8c51cb2306014d$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
        };
        const step = $5uXOq.createElement((0, (0, parcelRequire("harrN")).default), {
            ...rest,
            analyticsContext: analyticsContext,
            component: component,
            hasOverflow: hasOverflow,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            ref: buttonRef,
            target: target,
            testId: testId,
            style: truncationWidth ? dynamicItemStyles : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1hhk _vwz41txs _1rjc1tvq",
                truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
            ])
        }, text);
        return $5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _18s8ze3t _1yt4ze3t _2lx2vrvc _1dsoftgi _toskidpf _15621n76 _5nddv77o _1j1pu2gc _191d1h6o"
            ])
        }, showTooltip ? $5uXOq.createElement((0, (0, parcelRequire("MGmIU")).default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown
        }, step) : step);
    });
    var $6e8c51cb2306014d$export$2e2bcd8739ae039 = $6e8c51cb2306014d$var$BreadcrumbsItem;
});
parcelRegister("harrN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fb07e2df619f49b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3tZix;
    var $89thI;
    var $ePBXU;
    const $6fb07e2df619f49b$var$analyticsAttributes = {
        componentName: 'breadcrumbsItem',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $6fb07e2df619f49b$var$noop = (0, (0, parcelRequire("ePBXU")).default);
    const $6fb07e2df619f49b$var$Step = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $6fb07e2df619f49b$var$noop, target: target, testId: testId, ...props }, ref)=>{
        const handleClicked = (0, (0, parcelRequire("3tZix")).usePlatformLeafEventHandler)({
            fn: onClickProvided,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$6fb07e2df619f49b$var$analyticsAttributes
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: hasOverflow ? undefined : iconAfter,
            iconBefore: hasOverflow ? undefined : iconBefore,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
    });
    var $6fb07e2df619f49b$export$2e2bcd8739ae039 = $6fb07e2df619f49b$var$Step;
});
parcelRegister("j9LYN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b81bd27faf6d3bb3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b81bd27faf6d3bb3$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
        const [hasOverflow, setOverflow] = (0, $5uXOq.useState)(true);
        const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (truncationWidth && buttonRefCurrent) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        }, [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance
        ]);
        return [
            hasOverflow,
            showTooltip
        ];
    }
});
parcelRegister("dkxUw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad9ae648cf01cd8f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3tZix;
    var $oUGyo;
    var $ePBXU;
    var $4uQn9;
    var $8duIu;
    const $ad9ae648cf01cd8f$var$defaultMaxItems = 8;
    const $ad9ae648cf01cd8f$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
    const $ad9ae648cf01cd8f$var$defaultEllipsisLabel = 'Show more breadcrumbs';
    const { toArray: $ad9ae648cf01cd8f$var$toArray } = (0, ($parcel$interopDefault($5uXOq))).Children;
    const $ad9ae648cf01cd8f$var$analyticsAttributes = {
        componentName: 'breadcrumbs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $ad9ae648cf01cd8f$var$noop = (0, (0, parcelRequire("ePBXU")).default);
    const $ad9ae648cf01cd8f$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
    const $ad9ae648cf01cd8f$var$breadcrumbStyles = null;
    const $ad9ae648cf01cd8f$var$InnerBreadcrumbs = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $ad9ae648cf01cd8f$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $ad9ae648cf01cd8f$var$noop, analyticsContext: analyticsContext, label: label = $ad9ae648cf01cd8f$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $ad9ae648cf01cd8f$var$defaultEllipsisLabel } = props;
        const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
        const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const isControlled = typeof isExpanded !== 'undefined';
        const isExpansionHandled = providedExpanse !== $ad9ae648cf01cd8f$var$noop;
        const shouldExpand = isControlled ? isExpanded : expanded;
        const focusFirstRevealed = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
                const interactiveElements = listItems.map((li)=>li.querySelector($ad9ae648cf01cd8f$var$interactiveElementSelector));
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        (0, (0, parcelRequire("8duIu")).useOnRevealed)(focusFirstRevealed, {
            isExpanded: shouldExpand,
            isDisabled: !isClickedBySpace
        });
        const handleExpansion = (0, (0, parcelRequire("3tZix")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (!isControlled) setExpanse((expanded)=>!expanded);
                if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
                return providedExpanse(event, analyticsEvent);
            },
            action: 'expanded',
            analyticsData: analyticsContext,
            ...$ad9ae648cf01cd8f$var$analyticsAttributes
        });
        const childrenArray = $ad9ae648cf01cd8f$var$toArray(children);
        const breadcrumbsArray = (0, ($parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
            if (typeof child === 'string') return child;
            return childrenArray.length - 1 === index ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                'aria-current': 'page'
            }) : child;
        });
        const renderItemsWithEllipsis = ()=>{
            const allItems = breadcrumbsArray;
            if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
            const beforeItems = allItems.slice(0, itemsBeforeCollapse);
            const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
            return [
                ...beforeItems,
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQn9")).default), {
                    key: "ellipsis",
                    testId: testId && `${testId}--breadcrumb-ellipsis`,
                    onClick: handleExpansion,
                    label: ellipsisLabel
                }),
                ...afterItems
            ];
        };
        const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
        const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("nav", {
            "aria-label": label,
            ref: (0, (0, parcelRequire("oUGyo")).default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("ol", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18s8ze3t _1yt4ze3t _1n261g80 _syaz1wmz"
            ])
        }, breadcrumbsItems));
    });
    const $ad9ae648cf01cd8f$var$Breadcrumbs = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ad9ae648cf01cd8f$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            ref: ref,
            testId: testId
        })));
    var $ad9ae648cf01cd8f$export$2e2bcd8739ae039 = $ad9ae648cf01cd8f$var$Breadcrumbs;
});
parcelRegister("4uQn9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37a93983ffdf070$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $89thI;
    var $ePBXU;
    const $e37a93983ffdf070$var$noop = (0, (0, parcelRequire("ePBXU")).default);
    const $e37a93983ffdf070$var$itemWrapperStyles = null;
    const $e37a93983ffdf070$var$staticItemStyles = null;
    const $e37a93983ffdf070$var$EllipsisItem = (0, $5uXOq.memo)(({ label: label, onClick: onClick = $e37a93983ffdf070$var$noop, testId: testId })=>$5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _18s8ze3t _1yt4ze3t _2lx2vrvc _1dsou2gc _toskidpf _15621n76 _5nddv77o _1j1pu2gc _191d1h6o"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("89thI")).default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1hhk _vwz41txs _1rjc1tvq"
            ])
        }, "\u2026")));
    var $e37a93983ffdf070$export$2e2bcd8739ae039 = $e37a93983ffdf070$var$EllipsisItem;
});
parcelRegister("8duIu", function(module, exports) {
    $parcel$export(module.exports, "useOnRevealed", ()=>$c2d13d155d18e571$export$e9c4922b2ecf808a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jHB2D;
    function $c2d13d155d18e571$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
        const prevExtended = (0, (0, parcelRequire("jHB2D")).default)(isExpanded);
        (0, $5uXOq.useEffect)(()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        }, [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ]);
    }
});
parcelRegister("92r9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77e0cddbf99d95bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eHCV;
    var $dOvpK;
    class $77e0cddbf99d95bf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                href: undefined,
                legacyId: undefined,
                type: 'unspecified',
                analyticsAttributes: {},
                analyticsFields: {}
            };
        }
        render() {
            const { index: index, text: text, target: target, href: href, component: component } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eHCV")).default), {
                key: index,
                text: text,
                onClick: this.onBreadCrumbClick,
                target: target,
                href: href,
                component: component
            });
        }
        constructor(...args){
            super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
                const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
                (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                    name: '',
                    attributes: {
                        legacyId: legacyId,
                        depth: index + 1,
                        type: type,
                        ...analyticsAttributes
                    },
                    ...analyticsFields
                });
            };
        }
    }
});
parcelRegister("dOvpK", function(module, exports) {
    $parcel$export(module.exports, "fireUiAnalytics", ()=>$8c2abcc805e894f7$export$4909253b5bf1eed7);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
    const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $8c2abcc805e894f7$var$isNotUndefined);
    };
    const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
        event.update({
            ...$8c2abcc805e894f7$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("2UzOj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e3ad53695e8cbba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8e3ad53695e8cbba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        breadcrumbsLabel: {
            "id": "navigation-apps.breadcrumbs.aria-label",
            "defaultMessage": "Empty Breadcrumbs item"
        }
    });
});
parcelRegister("1DFxi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3b01c7b039743c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $9b3b01c7b039743c$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
    const $9b3b01c7b039743c$var$defaultInitialState = {
        trail: [],
        targetElement: null
    };
    class $9b3b01c7b039743c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                initialState: $9b3b01c7b039743c$var$defaultInitialState
            };
        }
        constructor(props){
            super(props), this.onInsertItem = (item)=>{
                this.setState((state)=>({
                        trail: [
                            ...state.trail,
                            item
                        ].sort($9b3b01c7b039743c$var$compareBreadcrumbs)
                    }));
            }, this.onRemoveItem = (id)=>{
                this.setState((state)=>({
                        trail: state.trail.filter((b)=>b.id !== id)
                    }));
            }, this.onTargetSet = (targetElement)=>{
                this.setState({
                    targetElement: targetElement
                });
            }, this.api = {
                setTargetElement: this.onTargetSet,
                insertItem: this.onInsertItem,
                removeItem: this.onRemoveItem
            };
            this.state = props.initialState;
        }
        render() {
            const { children: children } = this.props;
            return children({
                state: this.state,
                api: this.api
            });
        }
    }
});
parcelRegister("lDu2T", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$c284a07391432f3b$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $lsa9q;
    var $clxrE;
    const $c284a07391432f3b$export$6e4bfef9e80c7eb0 = ()=>{
        const [{ hasLoaded: hasLoaded }] = (0, (0, parcelRequire("lsa9q")).default)();
        const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, (0, parcelRequire("clxrE")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (hasLoaded) {
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            } else resetPhase();
        }, [
            hasLoaded,
            resetPhase,
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("jnXgM", function(module, exports) {
    $parcel$export(module.exports, "TrackClicksBeforeTTI", ()=>$0e1519f86dabd57c$export$2846c12b8c092470);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $95EVP;
    var $6yXtV;
    const $0e1519f86dabd57c$var$cleanUrl = (pathname)=>{
        let url = pathname.replace(/\/$/, '');
        if (/\/browse\/\w+$/.test(url)) url = 'browse';
        if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
        return url;
    };
    const $0e1519f86dabd57c$export$2846c12b8c092470 = ()=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isReady) return;
            try {
                const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
                if (sessionStorageItems == null || sessionStorageItems === '') return;
                const items = JSON.parse(sessionStorageItems);
                items.forEach((item)=>{
                    let extras = {
                        elementId: item.dataId,
                        currentUrl: $0e1519f86dabd57c$var$cleanUrl(item.currentUrl),
                        bundleId: item.bundleId,
                        time: item.time
                    };
                    if (item.redirectUrl !== '') extras = {
                        ...extras,
                        redirectUrl: $0e1519f86dabd57c$var$cleanUrl(item.redirectUrl)
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                        action: 'clicked'
                    }), 'nonInteractiveElement clicked', '', extras);
                });
                sessionStorage.removeItem('clicks-before-tti');
            } catch (error) {
                console.error(error);
            }
        }, [
            createAnalyticsEvent,
            isReady
        ]);
        return null;
    };
});
parcelRegister("EgodS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bnKSn")
    ]).then(()=>parcelRequire('6kz4R'));
});
parcelRegister("aQHAS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kpDDc").then(()=>parcelRequire('a8CW2'));
});
parcelRegister("i1RfD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("humN1").then(()=>parcelRequire('7l6f4'));
});
parcelRegister("iRWz9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("pGAVo").then(()=>parcelRequire('hfEgP'));
});
parcelRegister("D2tCn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8f0xo").then(()=>parcelRequire('cDo25'));
});
parcelRegister("lGCVr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3TwVo").then(()=>parcelRequire('aUZKu'));
});
parcelRegister("gmCnE", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$08223c6bc94e2fa4$export$3b4e64e77073e307);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwIPs;
    var $2Upgn;
    var $co1wz;
    var $7XYc4;
    var $4R6GH;
    var $asgRx;
    var $6ohPr;
    var $3HwlS;
    var $iqLcb;
    var $9L6Zg;
    var $gk4cG;
    var $adRnT;
    var $iaN8D;
    var $14pJv;
    var $921us;
    var $9Cdg4;
    var $aAExw;
    var $9ylrc;
    var $l8ruj;
    var $dm0Uk;
    const $08223c6bc94e2fa4$var$TEST_ID = 'page-layout.banner';
    const $08223c6bc94e2fa4$export$496ffd8dda3bf451 = ()=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Banner), {
            height: banner.height,
            testId: $08223c6bc94e2fa4$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
            bannerName: banner.name
        }))) : null;
    };
    const $08223c6bc94e2fa4$export$b5cfff585ada92ce = ()=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dm0Uk")).ZIndexWrapper), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).banner
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Banner), {
            height: banner.height
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
            bannerName: banner.name
        })))) : null;
    };
    const $08223c6bc94e2fa4$var$BannerContent = ({ bannerName: bannerName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, bannerName === (0, (0, parcelRequire("gk4cG")).NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adRnT")).BannerAnnouncementAsync), null), bannerName === (0, (0, parcelRequire("asgRx")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ohPr")).IPBlocklistingBannerAsync), null), bannerName === (0, (0, parcelRequire("aAExw")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ylrc")).ReturnToMobileBanner), null), bannerName === (0, $91be75e714d10b24$export$41956b146268af93) && (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-cookie-controls-banner-show') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Upgn")).CookieConsentBannerAsync), null), (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, (0, parcelRequire("iaN8D")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("14pJv")).BannerTransitionAsync), null), bannerName === (0, (0, parcelRequire("921us")).BANNER_NAME) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Cdg4")).MailExpiryBannerAsync), null));
    const $08223c6bc94e2fa4$export$3b4e64e77073e307 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $08223c6bc94e2fa4$export$496ffd8dda3bf451, $08223c6bc94e2fa4$export$b5cfff585ada92ce);
});
const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;
parcelRegister("2Upgn", function(module, exports) {
    $parcel$export(module.exports, "CookieConsentBannerAsync", ()=>$8357736d9e1344aa$export$f110a9cbbbd3fa3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $jJ1Sb;
    var $7CMCs;
    var $lfTZh;
    var $hPtZI;
    const $8357736d9e1344aa$var$LazyCookieConsentBanner = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("1h3FB")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
        moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
    });
    const $8357736d9e1344aa$export$f110a9cbbbd3fa3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8357736d9e1344aa$var$boxStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-cookie-consent-banner",
            packageName: "jiraCookieConsentBanner",
            teamName: "Magma"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-cookie-consent-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8357736d9e1344aa$var$LazyCookieConsentBanner, null))));
    const $8357736d9e1344aa$var$boxStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'elevation.surface.sunken',
        height: '100%'
    });
});
parcelRegister("1h3FB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lK1GY")
    ]).then(()=>parcelRequire('vtgYF'));
});
parcelRegister("asgRx", function(module, exports) {
    $parcel$export(module.exports, "bannerHeight", ()=>$692526aac37c19f2$export$86047f02632f9f5b);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$692526aac37c19f2$export$41956b146268af93);
    var $gwIPs;
    const $692526aac37c19f2$export$86047f02632f9f5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 7;
    const $692526aac37c19f2$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';
});
parcelRegister("6ohPr", function(module, exports) {
    $parcel$export(module.exports, "IPBlocklistingBannerAsync", ()=>$f9467d6df1e451da$export$fafc306b802ab39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $f9467d6df1e451da$var$IPBlocklistingBannerComp = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("57iCZ")).then((m)=>m.IPBlocklistingBanner), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
    });
    const $f9467d6df1e451da$export$fafc306b802ab39d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-ip-block-listing-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f9467d6df1e451da$var$IPBlocklistingBannerComp, null));
});
parcelRegister("57iCZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("12K5T")
    ]).then(()=>parcelRequire('h9o9V'));
});
parcelRegister("9L6Zg", function(module, exports) {
    $parcel$export(module.exports, "useBanner", ()=>$83eb9a3cdcaec997$export$de40f69ba30f2376);
    var $5uXOq = parcelRequire("5uXOq");
    var $iPh5B;
    var $co1wz;
    var $4R6GH;
    var $iMzQW;
    var $14V0U;
    var $6RMJw;
    var $hESBP;
    var $2jAre;
    var $lrZro;
    const $83eb9a3cdcaec997$var$noBanner = {
        name: null,
        height: 0,
        isEnabled: false
    };
    const $83eb9a3cdcaec997$export$de40f69ba30f2376 = ()=>{
        const [isChromeless] = (0, (0, parcelRequire("14V0U")).useIsChromeless)();
        const announcement = (0, (0, parcelRequire("6RMJw")).useBannerAnnouncement)();
        const transition = (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, (0, parcelRequire("hESBP")).useBannerEocTransition)() : undefined;
        const returnToMobile = (0, (0, parcelRequire("lrZro")).useBannerReturnToMobile)();
        const IPBlocklisting = (0, (0, parcelRequire("iMzQW")).useBannerIPBlocklisting)();
        const cookieConsent = (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-cookie-controls-banner-show') ? (0, (0, parcelRequire("iPh5B")).useBannerCookieConsent)() : undefined;
        const mailExpiry = (0, (0, parcelRequire("2jAre")).useBannerMailExpiry)();
        return (0, $5uXOq.useMemo)(()=>{
            if (cookieConsent?.isEnabled) return cookieConsent;
            if (isChromeless) return $83eb9a3cdcaec997$var$noBanner;
            if (IPBlocklisting.isEnabled) return IPBlocklisting;
            if (returnToMobile.isEnabled) return returnToMobile;
            if (announcement.isEnabled) return announcement;
            if (transition?.isEnabled) return transition;
            if (mailExpiry?.isEnabled) return mailExpiry;
            return $83eb9a3cdcaec997$var$noBanner;
        }, [
            cookieConsent,
            isChromeless,
            IPBlocklisting,
            returnToMobile,
            announcement,
            transition,
            mailExpiry
        ]);
    };
});
parcelRegister("iPh5B", function(module, exports) {
    $parcel$export(module.exports, "useBannerCookieConsent", ()=>$e552544bdd302edb$export$c7a51b5ee06f5794);
    var $5uXOq = parcelRequire("5uXOq");
    var $aNX8l;
    var $fHMqi;
    var $3TzYp;
    var $co1wz;
    var $e5wyW;
    var $2eyDn;
    var $gubdC;
    const $e552544bdd302edb$export$5503c67b1001ec45 = (data)=>{
        try {
            const shouldShowBannerBit = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("aNX8l")).ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
            const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
            return data && (0, (0, parcelRequire("fHMqi")).shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
        } catch (e) {
            return true;
        }
    };
    const $e552544bdd302edb$var$useBannerCookieConsentV2 = ()=>{
        const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, (0, parcelRequire("gubdC")).useCookieConsentBannerSettings)();
        const { data: data } = (0, (0, parcelRequire("2eyDn")).useConsentBannerUserPreferencesResource)();
        (0, $5uXOq.useEffect)(()=>{
            const shouldRender = $e552544bdd302edb$export$5503c67b1001ec45(data);
            if (shouldRender && !(0, (0, parcelRequire("gubdC")).isInIframe)()) onShow();
        }, [
            data,
            onShow
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $91be75e714d10b24$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $e552544bdd302edb$var$useBannerCookieConsentV1 = ()=>{
        const [{ isDismissed: isDismissed, height: height }] = (0, (0, parcelRequire("gubdC")).useCookieConsentBannerSettings)();
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $91be75e714d10b24$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $e552544bdd302edb$export$c7a51b5ee06f5794 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), $e552544bdd302edb$var$useBannerCookieConsentV2, $e552544bdd302edb$var$useBannerCookieConsentV1);
});
parcelRegister("fHMqi", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBannerPrefetched", ()=>$be895980ecb6dc89$export$6406464aa126433e);
    var $294ns;
    var $kwkcg;
    var $NxBvE;
    var $4cCG9;
    const $be895980ecb6dc89$export$6406464aa126433e = (prefetchedPreferencesData)=>{
        if ((0, (0, parcelRequire("294ns")).fg)('platform_moonjelly_bsc_ssr_killswitch')) return false;
        if (!prefetchedPreferencesData) return true;
        if ('consentToken' in prefetchedPreferencesData) {
            const { isValid: isValid } = (0, (0, parcelRequire("NxBvE")).checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
            return isValid ? (0, (0, parcelRequire("4cCG9")).getBannerVisibility)(prefetchedPreferencesData) : true;
        }
        const consentPrefsData = (0, (0, parcelRequire("kwkcg")).buildConsentPreferences)(prefetchedPreferencesData);
        return (0, (0, parcelRequire("4cCG9")).getBannerVisibility)(consentPrefsData);
    };
});
parcelRegister("kwkcg", function(module, exports) {
    $parcel$export(module.exports, "buildConsentPreferences", ()=>$0155cc04b1f36427$export$bd9f5bcbf9cd947c);
    $parcel$export(module.exports, "fetchConsentPreferences", ()=>$0155cc04b1f36427$export$86467566615ab85e);
    $parcel$export(module.exports, "saveConsentPreferences", ()=>$0155cc04b1f36427$export$f8422650c3dec8b2);
    var $6rvxM;
    var $1VJEY;
    const $0155cc04b1f36427$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
    const $0155cc04b1f36427$var$POST_CONSENTS_URL = `${$0155cc04b1f36427$var$BASE_CONSENTS_URL}/user`;
    const $0155cc04b1f36427$var$GET_CONSENTS_URL = `${$0155cc04b1f36427$var$POST_CONSENTS_URL}/consents/cookies`;
    const $0155cc04b1f36427$export$bd9f5bcbf9cd947c = (consentData)=>{
        if (consentData) {
            const serializedConsents = (0, (0, parcelRequire("1VJEY")).serializeConsents)(consentData);
            const consentTimestamp = (0, (0, parcelRequire("1VJEY")).getConsentTimestamp)(consentData);
            return {
                consentToken: serializedConsents,
                consentTimestamp: consentTimestamp
            };
        }
        return {
            consentToken: (0, (0, parcelRequire("1VJEY")).serializeConsents)({}),
            consentHubInaccessible: true
        };
    };
    const $0155cc04b1f36427$export$86467566615ab85e = async ()=>{
        const { origin: origin } = window.location;
        const getFromConsentHubURL = `${origin}${$0155cc04b1f36427$var$GET_CONSENTS_URL}`;
        try {
            const response = await fetch(getFromConsentHubURL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
            const consentData = await response.json();
            return $0155cc04b1f36427$export$bd9f5bcbf9cd947c(consentData);
        } catch (err) {
            (0, (0, parcelRequire("6rvxM")).Logger).errorWithOperationalEvent({
                action: 'fetchConsentPreferencesError',
                message: err.message || ''
            });
            return $0155cc04b1f36427$export$bd9f5bcbf9cd947c();
        }
    };
    const $0155cc04b1f36427$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
        const { origin: origin, pathname: pathname } = window.location;
        const deserializedConsents = (0, (0, parcelRequire("1VJEY")).deserializeConsents)(unpackedUserPreferences, displayedTextMap);
        const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
        const consentRequestBody = {
            action: action,
            consents: deserializedConsents,
            formUrl: `${origin}${pathname}`,
            locale: 'UNKNOWN',
            site: 'atlassian',
            source: 'COOKIE_PREFERENCES'
        };
        return JSON.stringify(consentRequestBody);
    };
    const $0155cc04b1f36427$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
        const saveToConsentHubURL = `${window.location.origin}${$0155cc04b1f36427$var$POST_CONSENTS_URL}`;
        try {
            const response = await fetch(saveToConsentHubURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: $0155cc04b1f36427$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
            });
            if (!response.ok || response.status !== 202 && response.status !== 200) {
                const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
                const errWithStatusCode = new (0, (0, parcelRequire("1VJEY")).StatusCodeError)(errMsg, response.status);
                throw errWithStatusCode;
            }
        } catch (err) {
            (0, (0, parcelRequire("6rvxM")).Logger).errorWithOperationalEvent({
                action: 'saveConsentPreferencesError',
                message: err.message || ''
            });
            throw err;
        }
    };
});
parcelRegister("1VJEY", function(module, exports) {
    $parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", ()=>$c6603f654f7d3553$export$42b0ca8aba2631e4);
    $parcel$export(module.exports, "checkIfTokenIsDefault", ()=>$c6603f654f7d3553$export$497a647f0eb30ef4);
    $parcel$export(module.exports, "serializeConsents", ()=>$c6603f654f7d3553$export$92ba0b2fe50f90df);
    $parcel$export(module.exports, "deserializeConsents", ()=>$c6603f654f7d3553$export$bfa0c91662787fb0);
    $parcel$export(module.exports, "getConsentTimestamp", ()=>$c6603f654f7d3553$export$13e4cff933f26b03);
    $parcel$export(module.exports, "checkIfConsentsAreStale", ()=>$c6603f654f7d3553$export$3387347b75450ae1);
    $parcel$export(module.exports, "StatusCodeError", ()=>$c6603f654f7d3553$export$a79c0ea3d7c2444a);
    var $gVXpY;
    var $aNX8l;
    var $kdrsV;
    var $5mg3z;
    var $gve1h;
    const $c6603f654f7d3553$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV2Schema = version === (0, (0, parcelRequire("aNX8l")).V002_SCHEMA_KEY);
        return isV2Schema;
    };
    const $c6603f654f7d3553$var$isLegacyV1Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV1Schema = version === (0, (0, parcelRequire("aNX8l")).V001_SCHEMA_KEY);
        return isV1Schema;
    };
    const $c6603f654f7d3553$export$42b0ca8aba2631e4 = (consentToken)=>{
        if ($c6603f654f7d3553$var$isLegacyGeoTargetingV2Token(consentToken)) {
            const consentedUnderGDPR = consentToken[8] === '1';
            const consentedUnderCPRA = consentToken[9] === '1';
            const consentedUnderLGPD = consentToken[10] === '1';
            const consentedUnderFADP = consentToken[11] === '1';
            const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
            return hasConsentedPreviously;
        }
        return false;
    };
    const $c6603f654f7d3553$export$497a647f0eb30ef4 = (consentToken)=>{
        const isLegacyV2ConsentToken = $c6603f654f7d3553$var$isLegacyGeoTargetingV2Token(consentToken);
        const isLegacyV1ConsentToken = $c6603f654f7d3553$var$isLegacyV1Token(consentToken);
        if (isLegacyV2ConsentToken) {
            const legacyTokenHasConsents = $c6603f654f7d3553$export$42b0ca8aba2631e4(consentToken);
            return !legacyTokenHasConsents;
        }
        if (isLegacyV1ConsentToken) return false;
        const isDefaultToken = (0, (0, parcelRequire("gVXpY")).getBoolFromBitValue)(consentToken[7]);
        return isDefaultToken;
    };
    const $c6603f654f7d3553$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
        const version = (0, (0, parcelRequire("aNX8l")).V003_SCHEMA_KEY);
        const serializedBits = Object.entries((0, (0, parcelRequire("aNX8l")).DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
            if (key === (0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary) return acc;
            if (key === (0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).UserIsAuthenticated) {
                const userIsAuthed = !consentsUnavailable;
                return acc + (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userIsAuthed);
            }
            if (key === (0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable) return acc + (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(!!consentsUnavailable);
            return acc + (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(val);
        }, '');
        return `${version}${serializedBits}`;
    };
    const $c6603f654f7d3553$export$42a0b3fb1e53e7b9 = (consents)=>{
        const version = (0, (0, parcelRequire("aNX8l")).V003_SCHEMA_KEY);
        const functionalConsent = (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("gve1h")).ConsentHubKey).Functional)?.granted);
        const analyticsConsent = (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("gve1h")).ConsentHubKey).Analytics)?.granted);
        const marketingConsent = (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("gve1h")).ConsentHubKey).Marketing)?.granted);
        const unknownConsent = (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(!!consents.find((key)=>key.key === (0, (0, parcelRequire("gve1h")).ConsentHubKey).Unknown)?.granted);
        const isDefaultToken = 0;
        const userIsAuthenticated = 1;
        const consentHubDataUnavailable = 0;
        return [
            version,
            functionalConsent,
            analyticsConsent,
            marketingConsent,
            unknownConsent,
            isDefaultToken,
            userIsAuthenticated,
            consentHubDataUnavailable
        ].join('');
    };
    const $c6603f654f7d3553$export$92ba0b2fe50f90df = ({ consents: consents })=>{
        if (!consents) {
            const existingFallbackToken = (0, (0, parcelRequire("kdrsV")).getCookie)((0, (0, parcelRequire("aNX8l")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if (existingFallbackToken) return existingFallbackToken;
            return $c6603f654f7d3553$export$c42e1a74e60f4d73(true);
        } else if (consents.length === 0) return $c6603f654f7d3553$export$c42e1a74e60f4d73();
        else return $c6603f654f7d3553$export$42a0b3fb1e53e7b9(consents);
    };
    const $c6603f654f7d3553$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
        const validConsentHubCookieConsents = [
            (0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary,
            (0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional,
            (0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics,
            (0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing,
            (0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown
        ];
        const consentKeyMap = {
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary]: (0, (0, parcelRequire("gve1h")).ConsentHubKey).StrictlyNecessary,
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]: (0, (0, parcelRequire("gve1h")).ConsentHubKey).Functional,
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]: (0, (0, parcelRequire("gve1h")).ConsentHubKey).Analytics,
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]: (0, (0, parcelRequire("gve1h")).ConsentHubKey).Marketing,
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]: (0, (0, parcelRequire("gve1h")).ConsentHubKey).Unknown
        };
        const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
            const key = consentKeyMap[consentKey];
            return {
                key: key,
                granted: !!unpackedUserPreferences[consentKey],
                gatheredTs: new Date().toISOString(),
                displayedText: displayedTextMap[consentKey]
            };
        });
        return consentRecords;
    };
    const $c6603f654f7d3553$export$13e4cff933f26b03 = ({ consents: consents })=>{
        if (consents && consents.length) {
            const timestamps = consents.map((consent)=>{
                return new Date(consent.updatedTs).getTime();
            });
            const maxTimestamp = Math.max(...timestamps);
            const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
            return mostRecentConsentTimestamp;
        }
    };
    const $c6603f654f7d3553$export$3387347b75450ae1 = (consentTimestamp)=>{
        let consentedOverAYearAgo = false;
        if (consentTimestamp) {
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
            consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
        }
        return consentedOverAYearAgo;
    };
    class $c6603f654f7d3553$export$a79c0ea3d7c2444a extends Error {
        constructor(message, status){
            super(message);
            this.status = status;
            Object.setPrototypeOf(this, $c6603f654f7d3553$export$a79c0ea3d7c2444a.prototype);
            if (Error.captureStackTrace) Error.captureStackTrace(this, $c6603f654f7d3553$export$a79c0ea3d7c2444a);
            this.name = 'StatusCodeError';
        }
    }
});
parcelRegister("gVXpY", function(module, exports) {
    $parcel$export(module.exports, "getBitValueFromBool", ()=>$418982e476d7f344$export$929f1500428a1fc8);
    $parcel$export(module.exports, "getBoolFromBitValue", ()=>$418982e476d7f344$export$27647458f3cf29d2);
    const $418982e476d7f344$export$929f1500428a1fc8 = (value)=>{
        return Number(value).toString();
    };
    const $418982e476d7f344$export$27647458f3cf29d2 = (bitValue)=>{
        if (bitValue) return !!Number(bitValue);
    };
});
parcelRegister("gve1h", function(module, exports) {
    $parcel$export(module.exports, "ConsentHubKey", ()=>$5d054ad6eac8704d$export$31140359b1e505cf);
    var $5d054ad6eac8704d$export$31140359b1e505cf;
    (function(ConsentHubKey) {
        ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
        ConsentHubKey["Functional"] = "functionalCookies";
        ConsentHubKey["Analytics"] = "performanceCookies";
        ConsentHubKey["Marketing"] = "targetingCookies";
        ConsentHubKey["Unknown"] = "unknownCookies";
    })($5d054ad6eac8704d$export$31140359b1e505cf || ($5d054ad6eac8704d$export$31140359b1e505cf = {}));
});
parcelRegister("NxBvE", function(module, exports) {
    $parcel$export(module.exports, "checkTokenVersionValidity", ()=>$9c76337dd61a6f85$export$64b31470e8522819);
    $parcel$export(module.exports, "packUserPreferences", ()=>$9c76337dd61a6f85$export$3199823fec979bd1);
    $parcel$export(module.exports, "unpackUserPreferencesCookie", ()=>$9c76337dd61a6f85$export$8d213cb390bab4fa);
    $parcel$export(module.exports, "initialPreferencesAreMissing", ()=>$9c76337dd61a6f85$export$67f70eb55341bd29);
    $parcel$export(module.exports, "initializePreferencesData", ()=>$9c76337dd61a6f85$export$7962405c3ca274b1);
    var $kcbTK;
    var $gVXpY;
    var $aNX8l;
    var $1VJEY;
    var $5mg3z;
    const $9c76337dd61a6f85$export$64b31470e8522819 = (consentToken)=>{
        if (consentToken.length < 3) return {
            isValid: false,
            isV001: false,
            isV002: false,
            isV003: false
        };
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV001 = version === (0, (0, parcelRequire("aNX8l")).V001_SCHEMA_KEY) && consentToken.length === 7;
        const isV002 = version === (0, (0, parcelRequire("aNX8l")).V002_SCHEMA_KEY) && consentToken.length === 12;
        const isV003 = version === (0, (0, parcelRequire("aNX8l")).V003_SCHEMA_KEY) && consentToken.length === 10;
        const isSupportedVersion = [
            (0, (0, parcelRequire("aNX8l")).V001_SCHEMA_KEY),
            (0, (0, parcelRequire("aNX8l")).V002_SCHEMA_KEY),
            (0, (0, parcelRequire("aNX8l")).V003_SCHEMA_KEY)
        ].includes(version);
        const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
        return {
            isValid: isValid,
            isV001: isV001,
            isV002: isV002,
            isV003: isV003
        };
    };
    const $9c76337dd61a6f85$var$packPrefsVersion001 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("aNX8l")).V001_SCHEMA_KEY);
        return [
            version,
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences.FUNCTIONAL),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences.ANALYTICS),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences.MARKETING),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences.UNKNOWN)
        ].join('');
    };
    const $9c76337dd61a6f85$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
        if (userPreferencesCookie.length !== 7) return;
        return {
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary]: true,
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
        };
    };
    const $9c76337dd61a6f85$var$packPrefsVersion002 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("aNX8l")).V003_SCHEMA_KEY);
        const hasConsentedPreviously = userPreferences[(0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderFADP];
        const isDefaultConsentBit = !hasConsentedPreviously;
        const existingConsentDataUnavailableBit = userPreferences[(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable];
        const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
        return [
            version,
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(isDefaultConsentBit),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userIsAuthenticatedBit),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(existingConsentDataUnavailableBit)
        ].join('');
    };
    const $9c76337dd61a6f85$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
        const isADefaultConsentToken = (0, (0, parcelRequire("1VJEY")).checkIfTokenIsDefault)(userPreferencesCookie);
        const consentDataUnavailable = userPreferencesCookie[7] === '1';
        const userIsDeemedAuthenticated = !consentDataUnavailable;
        return {
            ...$9c76337dd61a6f85$var$unpackPrefsVersion003(userPreferencesCookie),
            [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
            [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
            [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
        };
    };
    const $9c76337dd61a6f85$var$packPrefsVersion003 = (userPreferences)=>{
        const version = (0, (0, parcelRequire("aNX8l")).V003_SCHEMA_KEY);
        return [
            version,
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentsAreDefault]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).UserIsAuthenticated]),
            (0, (0, parcelRequire("gVXpY")).getBitValueFromBool)(userPreferences[(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable])
        ].join('');
    };
    const $9c76337dd61a6f85$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
        return {
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).StrictlyNecessary]: true,
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, (0, parcelRequire("5mg3z")).PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
            [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
            [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
            [(0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
        };
    };
    const $9c76337dd61a6f85$var$V002SpecificBitKeys = [
        (0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable,
        (0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderGDPR,
        (0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderCPRA,
        (0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderLGPD,
        (0, (0, parcelRequire("5mg3z")).ConsentPreferenceV2).ConsentedUnderFADP
    ];
    const $9c76337dd61a6f85$var$V003SpecificBitKeys = [
        (0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentsAreDefault,
        (0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).UserIsAuthenticated,
        (0, (0, parcelRequire("5mg3z")).ContextualConsentProperty).ConsentDataUnavailable
    ];
    function $9c76337dd61a6f85$export$3199823fec979bd1(userPreferences) {
        if ((0, (0, parcelRequire("kcbTK")).getBscGlobalState)().localConsentMode) return $9c76337dd61a6f85$var$packPrefsVersion001(userPreferences);
        const isV002 = $9c76337dd61a6f85$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV002) return $9c76337dd61a6f85$var$packPrefsVersion002(userPreferences);
        const isV003 = $9c76337dd61a6f85$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV003) return $9c76337dd61a6f85$var$packPrefsVersion003(userPreferences);
        return $9c76337dd61a6f85$var$packPrefsVersion001(userPreferences);
    }
    function $9c76337dd61a6f85$export$8d213cb390bab4fa(userPreferencesCookie) {
        if ((0, (0, parcelRequire("kcbTK")).getBscGlobalState)().localConsentMode) {
            if (userPreferencesCookie.length < 3) return;
            const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
            if (version === (0, (0, parcelRequire("aNX8l")).V001_SCHEMA_KEY)) return $9c76337dd61a6f85$var$unpackPrefsVersion001(userPreferencesCookie);
            return;
        }
        const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $9c76337dd61a6f85$export$64b31470e8522819(userPreferencesCookie);
        if (!isValid) return;
        if (isV001) return $9c76337dd61a6f85$var$unpackPrefsVersion001(userPreferencesCookie);
        if (isV002) return $9c76337dd61a6f85$var$unpackPrefsVersion002(userPreferencesCookie);
        if (isV003) return $9c76337dd61a6f85$var$unpackPrefsVersion003(userPreferencesCookie);
    }
    const $9c76337dd61a6f85$export$67f70eb55341bd29 = (initialPreferences)=>{
        if (!initialPreferences) return true;
        const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
        return prefExistButAreEmpty;
    };
    const $9c76337dd61a6f85$export$7962405c3ca274b1 = (initialPreferences)=>{
        if (initialPreferences !== (0, (0, parcelRequire("5mg3z")).PrefetchedPreferenceState).INTERNAL) {
            if ($9c76337dd61a6f85$export$67f70eb55341bd29(initialPreferences)) return {
                prefs: undefined,
                isPrefetchedPrefsInternalState: true
            };
            const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
            if (consentToken) {
                const unpackedExistingPrefs = $9c76337dd61a6f85$export$8d213cb390bab4fa(consentToken);
                return {
                    prefs: unpackedExistingPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
                };
            }
            if (initialPreferences && 'consents' in initialPreferences) {
                const serializedPrefetchedConsentToken = (0, (0, parcelRequire("1VJEY")).serializeConsents)(initialPreferences);
                const unpackedPrefetchedPrefs = $9c76337dd61a6f85$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
                return {
                    prefs: unpackedPrefetchedPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
                };
            }
        }
        if (initialPreferences === (0, (0, parcelRequire("5mg3z")).PrefetchedPreferenceState).INTERNAL) return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: false
        };
    };
});
parcelRegister("4cCG9", function(module, exports) {
    $parcel$export(module.exports, "getBannerVisibility", ()=>$7bc8c9907b316972$export$bfdb9f82a9194c1e);
    var $gKQFw;
    var $gVXpY;
    var $aNX8l;
    var $1VJEY;
    var $kdrsV;
    var $NxBvE;
    const $7bc8c9907b316972$var$getUserIsAuthenticatedBit = (consentToken)=>{
        const { isV002: isV002 } = (0, (0, parcelRequire("NxBvE")).checkTokenVersionValidity)(consentToken);
        let userIsAuthenticatedBit = consentToken[8];
        if (isV002) {
            const legacyV2ConsentDataUnavailableBit = consentToken[7];
            userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
        }
        return userIsAuthenticatedBit;
    };
    const $7bc8c9907b316972$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $7bc8c9907b316972$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, (0, parcelRequire("gVXpY")).getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, (0, parcelRequire("1VJEY")).checkIfTokenIsDefault)(fallbackConsentToken);
            const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
            const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (loggedOutUserPreviouslyConsentedWhileLoggedIn) return false;
        }
        return true;
    };
    const $7bc8c9907b316972$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, (0, parcelRequire("1VJEY")).checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $7bc8c9907b316972$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
        const localOnlyUserHasConsented = (0, (0, parcelRequire("1VJEY")).hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
        if (localOnlyUserHasConsented) return fallbackConsentToken ? false : true;
        return true;
    };
    const $7bc8c9907b316972$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $7bc8c9907b316972$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, (0, parcelRequire("gVXpY")).getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, (0, parcelRequire("1VJEY")).checkIfTokenIsDefault)(fallbackConsentToken);
            if (fallbackTokenHasGenuineConsents) {
                if (isLoggedOutFallbackConsents) return true;
                return false;
            }
            return true;
        }
        return true;
    };
    const $7bc8c9907b316972$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, (0, parcelRequire("1VJEY")).checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $7bc8c9907b316972$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
        if (consentTimestamp) {
            const showBannerIfStale = (0, (0, parcelRequire("1VJEY")).checkIfConsentsAreStale)(consentTimestamp);
            return showBannerIfStale;
        }
        return fallbackConsentToken ? false : true;
    };
    const $7bc8c9907b316972$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
        const fallbackConsentToken = (0, (0, parcelRequire("gKQFw")).isSSR)() ? fallbackConsents : fallbackConsents || (0, (0, parcelRequire("kdrsV")).getCookie)((0, (0, parcelRequire("aNX8l")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        let userIsAuthenticatedBit = $7bc8c9907b316972$var$getUserIsAuthenticatedBit(consentToken);
        const isLoggedOutConsentToken = !(0, (0, parcelRequire("gVXpY")).getBoolFromBitValue)(userIsAuthenticatedBit);
        let isBannerVisible = true;
        if (isLoggedOutConsentToken) isBannerVisible = $7bc8c9907b316972$var$shouldShowBannerForLoggedOutUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        });
        else isBannerVisible = $7bc8c9907b316972$var$shouldShowBannerForLoggedInUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            consentTimestamp: consentTimestamp
        });
        return isBannerVisible;
    };
});
parcelRegister("gubdC", function(module, exports) {
    $parcel$export(module.exports, "isInIframe", ()=>$53f6acf0285fde21$export$9f140ed41af5108c);
    $parcel$export(module.exports, "useCookieConsentBannerSettings", ()=>$53f6acf0285fde21$export$ae97931560f092a4);
    $parcel$export(module.exports, "useCookieConsentBannerSettingsActions", ()=>$53f6acf0285fde21$export$ecbab4dc5f9ad844);
    var $gKZoD;
    var $kdrsV;
    var $aNX8l;
    var $co1wz;
    var $3sQ5x;
    var $iXqE5;
    function $53f6acf0285fde21$export$8d213cb390bab4fa(userPreferencesCookie) {
        if (userPreferencesCookie.length < 3) return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version !== '001') return;
        if (userPreferencesCookie.length !== 7) return;
        return {
            STRICTLY_NECESSARY: true,
            FUNCTIONAL: userPreferencesCookie[3] === '1',
            ANALYTICS: userPreferencesCookie[4] === '1',
            MARKETING: userPreferencesCookie[5] === '1',
            UNKNOWN: userPreferencesCookie[6] === '1'
        };
    }
    const $53f6acf0285fde21$export$1de6a888ae076ff8 = ()=>{
        if (false) return undefined;
        const packedPrefs = (0, (0, parcelRequire("kdrsV")).getCookie)((0, (0, parcelRequire("aNX8l")).LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return $53f6acf0285fde21$export$8d213cb390bab4fa(packedPrefs);
    };
    const $53f6acf0285fde21$export$9f140ed41af5108c = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        if (false) return false;
        return window !== window.top;
    };
    const $53f6acf0285fde21$export$aa1483cc2e197f6e = ()=>{
        if (false) return false;
        if ((0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
        return $53f6acf0285fde21$export$1de6a888ae076ff8() !== undefined || $53f6acf0285fde21$export$9f140ed41af5108c();
    };
    const $53f6acf0285fde21$export$d4c72bab9d6cc13a = {
        isDismissed: $53f6acf0285fde21$export$aa1483cc2e197f6e(),
        height: 0
    };
    const $53f6acf0285fde21$export$e324594224ef24da = {
        onShow: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: false
                });
            },
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: true
                });
            },
        setHeight: (height)=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    height: height
                });
            }
    };
    const $53f6acf0285fde21$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'cookie-consent-banner',
        initialState: $53f6acf0285fde21$export$d4c72bab9d6cc13a,
        actions: $53f6acf0285fde21$export$e324594224ef24da
    });
    const $53f6acf0285fde21$export$ae97931560f092a4 = (0, (0, parcelRequire("3sQ5x")).createHook)($53f6acf0285fde21$var$Store);
    const $53f6acf0285fde21$export$ecbab4dc5f9ad844 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($53f6acf0285fde21$var$Store);
});
parcelRegister("iMzQW", function(module, exports) {
    $parcel$export(module.exports, "useBannerIPBlocklisting", ()=>$014906e38669dbae$export$564412c1d9cd4ccc);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    var $asgRx;
    const $014906e38669dbae$export$564412c1d9cd4ccc = ()=>{
        const [shouldShowBanner, setBannerState] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            });
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: shouldShowBanner,
                name: (0, (0, parcelRequire("asgRx")).BANNER_NAME),
                height: (0, (0, parcelRequire("asgRx")).bannerHeight)
            }), [
            shouldShowBanner
        ]);
    };
});
parcelRegister("6RMJw", function(module, exports) {
    $parcel$export(module.exports, "useBannerAnnouncement", ()=>$6710252c02f204b2$export$1e775b1ab04f2888);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kYzp;
    var $cZpsT;
    var $gk4cG;
    const $6710252c02f204b2$export$1e775b1ab04f2888 = ()=>{
        const { data: data } = (0, (0, parcelRequire("5kYzp")).useAnnouncementBannerSettingsV4Resource)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
                name: (0, (0, parcelRequire("gk4cG")).NAME),
                height: (0, (0, parcelRequire("gk4cG")).HEIGHT)
            }), [
            data?.isDismissed,
            data?.isEnabled,
            data?.visibility,
            isAnonymous
        ]);
    };
});
parcelRegister("cZpsT", function(module, exports) {
    $parcel$export(module.exports, "useIsAnonymous", ()=>$5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);
    var $9OXo1;
    const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAnonymous;
    };
});
parcelRegister("gk4cG", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$8ea828cd42179fda$export$809d2b099693a9a8);
    $parcel$export(module.exports, "NAME", ()=>$8ea828cd42179fda$export$3c5e605ca7ade9f2);
    var $gwIPs;
    const $8ea828cd42179fda$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $8ea828cd42179fda$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';
});
parcelRegister("hESBP", function(module, exports) {
    $parcel$export(module.exports, "useBannerEocTransition", ()=>$304370119e420b48$export$b6539a8209f95b48);
    var $5uXOq = parcelRequire("5uXOq");
    var $ez5GD;
    var $201IG;
    var $8J6rn;
    var $itmJb;
    var $cNd4s;
    var $iaN8D;
    const $304370119e420b48$export$b6539a8209f95b48 = ()=>{
        const { data: data, error: error } = (0, (0, parcelRequire("ez5GD")).useOgConsolidationUserState)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const isEnabled = Boolean((isAdmin || isSiteAdmin) && !tenantInfoError && isTransitionEligible && !error && data && (!data.isTransitionBannerDismissed || (0, (0, parcelRequire("201IG")).shouldRenderBenefitModal)({
            bannerDismissedAt: data.transitionBannerDismissedAt,
            isDismissed: data.isBenefitModalDismissed
        })));
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, (0, parcelRequire("iaN8D")).BANNER_NAME),
                height: data && (0, (0, parcelRequire("201IG")).shouldRenderBenefitModal)({
                    bannerDismissedAt: data.transitionBannerDismissedAt
                }) ? 0 : (0, (0, parcelRequire("iaN8D")).HEIGHT)
            }), [
            data,
            isEnabled
        ]);
    };
});
parcelRegister("ez5GD", function(module, exports) {
    $parcel$export(module.exports, "useOgConsolidationUserState", ()=>$e71f39314801737b$export$c35632c02599163f);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $iXaZ3;
    var $kMiZJ;
    var $9OXo1;
    var $2YP9W;
    var $fLIp1;
    const $e71f39314801737b$export$c35632c02599163f = ()=>{
        const errorRef = (0, $5uXOq.useRef)();
        const loadingRef = (0, $5uXOq.useRef)(false);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
        errorRef.current = userPropertiesError || transitionResourceError;
        const { atlassianAccountId: accountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const update = (0, $5uXOq.useCallback)((newState)=>{
            if (errorRef.current) return Promise.reject(errorRef.current);
            let updatedData = {};
            updateTransitionResource((oldState)=>{
                updatedData = {
                    ...oldState,
                    ...newState
                };
                return updatedData;
            });
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    showFlag({
                        type: 'error',
                        isAutoDismiss: true,
                        title: formatMessage((0, (0, parcelRequire("fLIp1")).default).errorFlagTitle)
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
            return Promise.resolve();
        }, [
            updateTransitionResource,
            accountId,
            formatMessage,
            showFlag
        ]);
        const reopenTransitionLozenge = (0, $5uXOq.useCallback)(()=>{
            update({
                isTransitionHomeHidden: false
            });
        }, [
            update
        ]);
        return {
            data: data,
            update: update,
            error: errorRef.current,
            reopenTransitionLozenge: reopenTransitionLozenge
        };
    };
});
parcelRegister("fLIp1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19c9811268c2fa85$export$2e2bcd8739ae039);
    var $7VHMR;
    var $19c9811268c2fa85$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
            "defaultMessage": "Something went wrong while updating user properties."
        }
    });
});
parcelRegister("201IG", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBenefitModal", ()=>$f068b5042603902f$export$25a52eb2dc74e2f9);
    const $f068b5042603902f$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
        if (!bannerDismissedAt || isDismissed) return false;
        return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
    };
});
parcelRegister("8J6rn", function(module, exports) {
    $parcel$export(module.exports, "useOgTenantInfo", ()=>$31f27587daf0b28f$export$990ea9ff15ca04f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $bHhiy;
    var $daoB1;
    var $2YP9W;
    var $3H5ry;
    const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
        const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
        const isRefreshed = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
                refresh();
                isRefreshed.current = true;
            }
        }, [
            data,
            loading,
            refresh
        ]);
    };
    const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
        const tenantInfoResource = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)());
        const applicationPermissions = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
        return {
            loading: tenantInfoResource.loading,
            error: tenantInfoResource.error,
            shouldUseJSM: (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(tenantInfoResource.data),
            isConsolidated: (0, (0, parcelRequire("3H5ry")).checkIsConsolidated)(tenantInfoResource.data),
            isOpsAdmin: (0, (0, parcelRequire("4R6GH")).fg)('operations-tenant-info-endpoint-update') && (0, (0, parcelRequire("3H5ry")).checkIsOpsAdmin)(tenantInfoResource.data),
            isTransitioning: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfoResource.data),
            isTransitioned: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, (0, parcelRequire("3H5ry")).checkIsTransitioned)(tenantInfoResource.data),
            isTransitionEligible: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, (0, parcelRequire("3H5ry")).checkIsTransitionEligible)(tenantInfoResource.data),
            shouldAccessUnlockOperations: (0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, (0, parcelRequire("3H5ry")).checkShouldAccessUnlockOperations)(tenantInfoResource.data),
            cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
        };
    };
});
parcelRegister("daoB1", function(module, exports) {
    $parcel$export(module.exports, "ApplicationPermissionsSubscriber", ()=>$77add4b5420e5058$export$d8c76f7e52d0a856);
    $parcel$export(module.exports, "useApplicationPermissions", ()=>$77add4b5420e5058$export$4d9cadb4042acc1b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $51nlc;
    var $2gywT;
    var $9OXo1;
    const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
            data: {
                applicationPermissions: applicationPermissions
            }
        }));
    const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("2gywT")).default), {
        displayName: 'ApplicationPermissionsSubscriber',
        selector: $77add4b5420e5058$var$selector
    });
    const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appPermissions;
    };
});
parcelRegister("cNd4s", function(module, exports) {
    $parcel$export(module.exports, "useIsSiteAdmin", ()=>$3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);
    var $9OXo1;
    const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isSiteAdmin || false;
    };
});
parcelRegister("iaN8D", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$d45809d2691157ce$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$d45809d2691157ce$export$41956b146268af93);
    var $gwIPs;
    const $d45809d2691157ce$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $d45809d2691157ce$export$41956b146268af93 = 'EOC_TRANSITION';
});
parcelRegister("2jAre", function(module, exports) {
    $parcel$export(module.exports, "useBannerMailExpiry", ()=>$85ae441f6f576caa$export$3906461ac9b87d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $hZhhj;
    var $921us;
    var $1cxlJ;
    const $85ae441f6f576caa$export$3906461ac9b87d2 = ()=>{
        const { responseStatus: responseStatus, state: state } = (0, (0, parcelRequire("hZhhj")).useIncomingMailExpiryStatus)();
        const { onStateFetch: onStateFetch } = (0, (0, parcelRequire("1cxlJ")).useBannerActions)();
        const { isBannerShown: isBannerShown } = (0, (0, parcelRequire("1cxlJ")).useBannerState)();
        (0, $5uXOq.useEffect)(()=>{
            if (responseStatus === 'error') {
                onStateFetch((0, (0, parcelRequire("hZhhj")).DEFAULT_RESPONSE));
                return;
            }
            if (responseStatus === 'success') onStateFetch(state);
        }, [
            onStateFetch,
            responseStatus,
            state
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isBannerShown,
                name: (0, (0, parcelRequire("921us")).BANNER_NAME),
                height: (0, (0, parcelRequire("921us")).HEIGHT)
            }), [
            isBannerShown
        ]);
    };
});
parcelRegister("921us", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$c8abb4ba3ebc926f$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$c8abb4ba3ebc926f$export$41956b146268af93);
    var $gwIPs;
    const $c8abb4ba3ebc926f$export$809d2b099693a9a8 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $c8abb4ba3ebc926f$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';
});
parcelRegister("1cxlJ", function(module, exports) {
    $parcel$export(module.exports, "useBannerActions", ()=>$b47a5e6c2ea18541$export$664f3e2467f0f5af);
    $parcel$export(module.exports, "useBannerState", ()=>$b47a5e6c2ea18541$export$fa4ffa872ee90bd0);
    var $3sQ5x;
    var $iXqE5;
    const $b47a5e6c2ea18541$export$d4c72bab9d6cc13a = {
        isBannerShown: false,
        isAdmin: false,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $b47a5e6c2ea18541$export$e324594224ef24da = {
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: false
                });
            },
        onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
            'GMAIL_OAUTH'
        ] })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: showBanner && isAdmin,
                    isAdmin: isAdmin,
                    OauthTypes: OauthTypes
                });
            }
    };
    const $b47a5e6c2ea18541$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'mail-expiry-banner',
        initialState: $b47a5e6c2ea18541$export$d4c72bab9d6cc13a,
        actions: $b47a5e6c2ea18541$export$e324594224ef24da
    });
    const $b47a5e6c2ea18541$export$664f3e2467f0f5af = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($b47a5e6c2ea18541$var$Store);
    const $b47a5e6c2ea18541$export$fa4ffa872ee90bd0 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($b47a5e6c2ea18541$var$Store);
});
parcelRegister("lrZro", function(module, exports) {
    $parcel$export(module.exports, "useBannerReturnToMobileState", ()=>$2d8151e19ddaa4d5$export$571311559507e90);
    $parcel$export(module.exports, "useBannerReturnToMobile", ()=>$2d8151e19ddaa4d5$export$a898dd7b7ec9917a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bCdIp;
    var $c0dQj;
    var $3sQ5x;
    var $iXqE5;
    var $aAExw;
    const $2d8151e19ddaa4d5$var$initialState = {
        isEnabled: (0, (0, parcelRequire("bCdIp")).shouldShowReturnToMobileBanner)()
    };
    const $2d8151e19ddaa4d5$var$actions = {
        disable: ()=>({ setState: setState })=>{
                setState({
                    isEnabled: false
                });
            }
    };
    const $2d8151e19ddaa4d5$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2d8151e19ddaa4d5$var$initialState,
        actions: $2d8151e19ddaa4d5$var$actions
    });
    const $2d8151e19ddaa4d5$export$571311559507e90 = (0, (0, parcelRequire("3sQ5x")).createHook)($2d8151e19ddaa4d5$var$store);
    const $2d8151e19ddaa4d5$export$a898dd7b7ec9917a = ()=>{
        const [{ isEnabled: isEnabledOriginal }] = $2d8151e19ddaa4d5$export$571311559507e90();
        const isEnabled = (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? isEnabledOriginal && (0, (0, parcelRequire("bCdIp")).shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
        return (0, $5uXOq.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, (0, parcelRequire("aAExw")).BANNER_NAME),
                height: (0, (0, parcelRequire("aAExw")).mobileBannerHeight)
            }), [
            isEnabled
        ]);
    };
});
parcelRegister("aAExw", function(module, exports) {
    $parcel$export(module.exports, "mobileBannerHeight", ()=>$61da032f64bef3a5$export$aa875602f5712b77);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$61da032f64bef3a5$export$41956b146268af93);
    $parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", ()=>$61da032f64bef3a5$export$698c82a2c8445300);
    var $gwIPs;
    const $61da032f64bef3a5$export$aa875602f5712b77 = (0, (0, parcelRequire("gwIPs")).gridSize) * 6;
    const $61da032f64bef3a5$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
    const $61da032f64bef3a5$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');
});
parcelRegister("adRnT", function(module, exports) {
    $parcel$export(module.exports, "BannerAnnouncementAsync", ()=>$30e1d77986915234$export$aa03f7909e0828ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $30e1d77986915234$var$BannerAnnouncement = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("6QDgx")).then((module)=>module.BannerAnnouncement), {
        ssr: true,
        moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/BannerAnnouncement.tsx"
    });
    const $30e1d77986915234$export$aa03f7909e0828ec = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-platform-ui-banners-announcement",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($30e1d77986915234$var$BannerAnnouncement, null));
});
parcelRegister("6QDgx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bxnv2")
    ]).then(()=>parcelRequire('dqid6'));
});
parcelRegister("14pJv", function(module, exports) {
    $parcel$export(module.exports, "BannerTransitionAsync", ()=>$710b388646922007$export$8bf182764b9d2eb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $710b388646922007$var$BannerTransition = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("kUqkC")).then((module)=>module.BannerTransition), {
        moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
    });
    const $710b388646922007$export$8bf182764b9d2eb8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-banner-eoc-transition",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($710b388646922007$var$BannerTransition, null));
});
parcelRegister("kUqkC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OPKz").then(()=>parcelRequire('iGIQS'));
});
parcelRegister("9Cdg4", function(module, exports) {
    $parcel$export(module.exports, "MailExpiryBannerAsync", ()=>$9a323272de0aa4c0$export$11a26ffa2d1b48ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $hPtZI;
    const $9a323272de0aa4c0$var$LazyMailExpiryBanner = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("fKslw")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
        moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
    });
    const $9a323272de0aa4c0$export$11a26ffa2d1b48ed = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async-mail-expiry-banner",
            packageName: "jiraPlatformUiMailExpiryReminder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-mail-expiry-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9a323272de0aa4c0$var$LazyMailExpiryBanner, null)));
});
parcelRegister("fKslw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hjh1F")
    ]).then(()=>parcelRequire('4tHNi'));
});
parcelRegister("9ylrc", function(module, exports) {
    $parcel$export(module.exports, "ReturnToMobileBanner", ()=>$369ea7a3ed2830c2$export$81c4f1e869d5a87);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $369ea7a3ed2830c2$var$LazyReturnToMobileBanner = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("7jJzW")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
        moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/main.tsx"
    });
    const $369ea7a3ed2830c2$export$81c4f1e869d5a87 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-return-to-mobile-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($369ea7a3ed2830c2$var$LazyReturnToMobileBanner, null));
});
parcelRegister("7jJzW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("MUWFq")
    ]).then(()=>parcelRequire('4TzBF'));
});
parcelRegister("dm0Uk", function(module, exports) {
    $parcel$export(module.exports, "ZIndexWrapper", ()=>$1be350c372161cad$export$6bdda512681a5774);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $1be350c372161cad$export$6bdda512681a5774 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.zIndex),
                "--_1vj9tq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.top)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pby1fcb _kqswh2mm _154i1ter",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kc9FZ", function(module, exports) {
    $parcel$export(module.exports, "GlobalComponents", ()=>$87d424e5b411dd1e$export$461c2ed3163c74ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $6jY6G;
    var $1XrjK;
    var $2SVPM;
    var $imS60;
    const $87d424e5b411dd1e$var$routeComponents = [];
    const $87d424e5b411dd1e$var$RouteGlobalComponents = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)(route.layout?.globalComponents || $87d424e5b411dd1e$var$routeComponents));
    };
    const $87d424e5b411dd1e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)(sharedGlobalComponents));
    const $87d424e5b411dd1e$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
        const globalComponentsPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$fb9876ab4228d985), (0, $9ccbd88c704da1ef$export$c20831be6f780cb5), (0, $9ccbd88c704da1ef$export$398df1bca49f9884), true, true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$c20831be6f780cb5)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "shared-global-components"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$SharedGlobalComponents, {
            sharedGlobalComponents: sharedGlobalComponents
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "route-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "route-global-components"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$RouteGlobalComponents, null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$398df1bca49f9884),
            onSet: globalComponentsPerformanceTiming
        }));
    };
});
parcelRegister("imS60", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6b7686623a2955e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $80cnJ;
    var $ahIoY;
    var $7UTZj;
    const $b6b7686623a2955e$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
            ...context,
            getInteractionContext: ()=>interactionContext
        };
    const $b6b7686623a2955e$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
    const $b6b7686623a2955e$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
                value: contextValue
            }, node) : node;
    function $b6b7686623a2955e$var$JiraUFOLabelWrapper({ children: children }) {
        const context = (0, (0, parcelRequire("80cnJ")).useInteractionContext)();
        const rllProfilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("7UTZj")).ProfilerContext));
        const relayProfilerContext = (0, $5uXOq.useContext)((0, $8Uumt.ProfilerContext));
        const newRllProfilerContext = (0, $5uXOq.useMemo)(()=>({
                current: $b6b7686623a2955e$var$newContextWithUfoContext(rllProfilerContext?.current, context)
            }), [
            context,
            rllProfilerContext
        ]);
        const newRelayProfilerContext = (0, $5uXOq.useMemo)(()=>$b6b7686623a2955e$var$newContextWithUfoContext(relayProfilerContext, context), [
            context,
            relayProfilerContext
        ]);
        return $b6b7686623a2955e$var$flowRight([
            $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $8Uumt.ProfilerContext), newRelayProfilerContext),
            $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, (0, parcelRequire("7UTZj")).ProfilerContext), newRllProfilerContext)
        ])((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children));
    }
    function $b6b7686623a2955e$export$2e2bcd8739ae039({ name: name, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ahIoY")).default), {
            name: name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b6b7686623a2955e$var$JiraUFOLabelWrapper, null, children));
    }
});
parcelRegister("ahIoY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8539d521fcd1ce3b$export$2e2bcd8739ae039);
    var $8gOd7;
    var $8539d521fcd1ce3b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8gOd7")).default);
});
parcelRegister("8gOd7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e638cc8636b341d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $80cnJ;
    function $7e638cc8636b341d$export$2e2bcd8739ae039({ name: name, children: children }) {
        const context = (0, (0, parcelRequire("80cnJ")).useInteractionContext)();
        const newContext = (0, $5uXOq.useMemo)(()=>{
            if (context) return {
                ...context,
                labelStack: context.labelStack == null ? [
                    {
                        name: name
                    }
                ] : [
                    ...context.labelStack,
                    {
                        name: name
                    }
                ]
            };
            else return context;
        }, [
            context,
            name
        ]);
        return context ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("80cnJ")).default).Provider, {
            value: newContext
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
});
parcelRegister("6DLIs", function(module, exports) {
    $parcel$export(module.exports, "GlobalContainers", ()=>$1f7483f6f5b15b02$export$3b677a7048d7ae0);
    var $5uXOq = parcelRequire("5uXOq");
    var $iCYVp;
    var $lRFpu;
    var $jD5no;
    var $2i4sA;
    var $gAeCk;
    var $5tsrJ;
    var $j8DrX;
    var $lJ5jf;
    var $3HwlS;
    var $8ApFP;
    var $4yEIl;
    var $iPMn1;
    var $fiv1r;
    var $14XJw;
    var $2SVPM;
    var $9OXo1;
    var $eKtC8;
    var $bAjl9;
    var $lvG9V;
    var $gPTB6;
    var $9kep9;
    var $eSznd;
    var $ivvwC;
    const $1f7483f6f5b15b02$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const globalContainersPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$4f341d86a3c214), (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366), (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca), true, true);
            (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$7048c99f32c60b34), (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7), (0, $9ccbd88c704da1ef$export$aac77afee74c49d0), true, true);
        }, []);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const MonolithStyleOverride = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
                dangerouslySetInnerHTML: {
                    __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
                }
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bAjl9")).IntlProviders), {
            messages: messages,
            locale: locale
        }, __SPA__ && (0, ($parcel$interopDefault($5uXOq))).createElement(MonolithStyleOverride, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
            orgId: orgId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
            experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
            experienceId: (0, $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7),
            application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
            edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
            additionalAttributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKtC8")).ErrorBoundary), {
            id: id,
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Router, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCYVp")).default), {
            UNSAFE_isThemingDisabled: true,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9kep9")).PageConfigContainers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvG9V")).MetricsContainers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPTB6")).NavigationContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivvwC")).UserContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eSznd")).UiManagers), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4yEIl")).PostOfficeRouterListener), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "page-container-v2.nav-v3.app-base",
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: (0, $9ccbd88c704da1ef$export$aac77afee74c49d0),
            onSet: globalContainersPerformanceTiming
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJ5jf")).SidebarNav4ControllerProvider), null, children) : children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iPMn1")).ScreenSpaceFlagsPlacement), null)))))))))))))));
    };
});
parcelRegister("iCYVp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$baec75778fdbaca4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42dL7;
    var $foY2Q;
    const $baec75778fdbaca4$var$InsideAppProviderContext = (0, $5uXOq.createContext)(false);
    function $baec75778fdbaca4$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
        const isInsideAppProvider = (0, $5uXOq.useContext)($baec75778fdbaca4$var$InsideAppProviderContext);
        if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
        const routerLinkProvider = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42dL7")).default), {
            routerLinkComponent: routerLinkComponent
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($baec75778fdbaca4$var$InsideAppProviderContext.Provider, {
            value: true
        }, UNSAFE_isThemingDisabled ? routerLinkProvider : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("foY2Q")).default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme
        }, routerLinkProvider));
    }
    var $baec75778fdbaca4$export$2e2bcd8739ae039 = $baec75778fdbaca4$export$c7dacf3845253dcf;
});
parcelRegister("2i4sA", function(module, exports) {
    $parcel$export(module.exports, "ViewExperienceTrackingProvider", ()=>$c08cc6207a190361$export$a5efa46877be148f);
    $parcel$export(module.exports, "SubExperienceTrackingProvider", ()=>$c08cc6207a190361$export$e0241c84ce5db240);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $jNwWT;
    var $aD4Nm;
    var $ehKaJ;
    const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehKaJ")).default), {
            isExperienceReady: isExperienceReady,
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            additionalAttributes: additionalAttributes
        }, children);
    $c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
        isExperienceReady: true,
        experienceId: null,
        additionalAttributes: {}
    };
    var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
    const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNwWT")).default).Consumer, null, (context)=>{
            if (context == null) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
                return children;
            }
            const { experienceId: experienceId } = context;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aD4Nm")).ExperienceTracker), {
                location: location,
                parentProviders: parentProviders
            }, (trackerCallbacks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehKaJ")).default), {
                    parentTrackerCallbacks: trackerCallbacks,
                    experience: location,
                    experienceId: experienceId,
                    analyticsSource: null,
                    application: null,
                    edition: null,
                    isExperienceReady: true
                }, children));
        });
    $c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
        parentProviders: null
    };
});
parcelRegister("ehKaJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a267f2f54170b1c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $jNwWT;
    class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                parentTrackerCallbacks: null,
                additionalAttributes: {}
            };
        }
        constructor(props){
            super(props), this.onPending = ()=>{
                this.pendingCount += 1;
                this.shouldTrackExperience = true;
                this.checkAndStartTimer();
            }, this.onSuccess = ()=>{
                this.pendingCount -= 1;
                this.checkAndStartTimer();
            }, this.onFailure = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            }, this.onAbort = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            };
            this.resetExperience();
        }
        componentDidMount() {
            this.checkAndStartTimer();
        }
        componentDidUpdate(prevProps) {
            if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
        }
        componentDidCatch(error) {
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: 'error-reached-provider',
                additionalAttributes: {
                    errorMessage: error.message,
                    errorName: error.name,
                    ...this.props?.additionalAttributes
                }
            });
            throw error;
        }
        componentWillUnmount() {
            clearTimeout(this.timerId);
        }
        checkAndStartTimer() {
            if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
        }
        startTimer() {
            clearTimeout(this.timerId);
            this.timerId = setTimeout(()=>{
                if (this.pendingCount === 0) this.trackExperience({
                    wasExperienceSuccesful: true
                });
            }, 1000);
        }
        resetExperience() {
            clearTimeout(this.timerId);
            this.timerId = undefined;
            this.shouldTrackExperience = false;
            this.hasTrackedExperience = false;
            this.pendingCount = 0;
            this.memoizedContext = {
                consumerCallbacks: {
                    onPending: this.onPending,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                    onAbort: this.onAbort
                },
                experienceId: this.props.experienceId,
                experience: this.props.experience
            };
        }
        trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
            if (this.hasTrackedExperience) return;
            this.hasTrackedExperience = true;
            const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
            if (parentTrackerCallbacks) {
                if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
                else parentTrackerCallbacks.onExperienceFailure(location, {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                });
            } else {
                const { experience: experience } = this.memoizedContext;
                const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
                analyticsSource && (0, (0, parcelRequire("hh0bW")).default)({
                    experience: experience,
                    action: action,
                    wasExperienceSuccesful: wasExperienceSuccesful,
                    location: location,
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: {
                        ...additionalAttributesFromProps,
                        ...additionalAttributes
                    }
                });
            }
        }
        checkExperienceIdForExperienceReset() {
            if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
        }
        render() {
            this.checkExperienceIdForExperienceReset();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNwWT")).default).Provider, {
                value: this.memoizedContext
            }, this.props.children);
        }
    }
});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';
parcelRegister("lJ5jf", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ControllerProvider", ()=>$ba2af518cd3fa886$export$ec25d268893d889d);
    $parcel$export(module.exports, "useSidebarNav4Controller", ()=>$ba2af518cd3fa886$export$641950c86d73374);
    var $5uXOq = parcelRequire("5uXOq");
    var $fMcVX;
    const $ba2af518cd3fa886$var$SidebarNav4ControllerContext = (0, $5uXOq.createContext)(null);
    function $ba2af518cd3fa886$export$ec25d268893d889d(props) {
        const { children: children, controlledPath: initialControlledPath = null } = props;
        const [controlledPath, setControlledPath] = (0, $5uXOq.useState)(initialControlledPath);
        const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
                isControlledNav: controlledPath !== null,
                isControlledPath: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(controlledPath ?? []),
                setControlledPath: setControlledPath
            }), [
            controlledPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ba2af518cd3fa886$var$SidebarNav4ControllerContext.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $ba2af518cd3fa886$export$641950c86d73374() {
        const context = (0, $5uXOq.useContext)($ba2af518cd3fa886$var$SidebarNav4ControllerContext);
        if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
        return context;
    }
});
parcelRegister("4yEIl", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$21214568f856c41e$export$fb465b6e855c1e85);
    $parcel$export(module.exports, "PostOfficeRouterListener", ()=>$21214568f856c41e$export$9f8d3084fd3d5fc0);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $4R6GH;
    var $jQsty;
    var $lpwtK;
    var $14XJw;
    var $fY39E;
    var $k9JTq;
    var $koeKL;
    var $2tT7R;
    var $cNd4s;
    var $DVljb;
    var $4RunP;
    var $5kgkl;
    var $doZTA;
    var $adncp;
    const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const editions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const subproduct = data?.type;
        const context = (0, $5uXOq.useMemo)(()=>{
            const edition = (0, (0, parcelRequire("adncp")).subproductToEdition)(subproduct, editions);
            return {
                current: {
                    ...(0, (0, parcelRequire("adncp")).tenantToPostOfficeContext)({
                        activationId: activationId,
                        cloudId: cloudId,
                        isSiteAdmin: isSiteAdmin,
                        locale: locale
                    }),
                    orgId: orgId,
                    productEdition: edition || undefined,
                    subproduct: subproduct
                }
            };
        }, [
            cloudId,
            orgId,
            activationId,
            subproduct,
            isSiteAdmin,
            locale,
            editions
        ]);
        const env = (0, $5uXOq.useMemo)(()=>({
                env: (0, (0, parcelRequire("adncp")).transformJiraEnvToPostOfficeEnvironment)(environment)
            }), [
            environment
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4RunP")).PostOfficeProvider), {
            context: context,
            environment: env
        }, children);
    };
    const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, (0, parcelRequire("jQsty")).default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "postOfficeJiraProvider",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
        const [route] = (0, (0, parcelRequire("doZTA")).useRouter)();
        (0, (0, parcelRequire("5kgkl")).usePostOfficeRouteUpdate)([
            route.basePath,
            route.location.pathname
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, (0, parcelRequire("jQsty")).default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled && (0, (0, parcelRequire("4R6GH")).fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("2tT7R", function(module, exports) {
    $parcel$export(module.exports, "useEnvironment", ()=>$6bd66e47d4948917$export$ea7ed2425832167d);
    $parcel$export(module.exports, "useIsStagingOrDevOrLocal", ()=>$6bd66e47d4948917$export$b0d8f74f433a09c9);
    var $9OXo1;
    const $6bd66e47d4948917$var$ENVIRONMENT = {
        STAGING: 'staging',
        DEV: 'dev',
        LOCAL: 'local',
        PROD: 'prod'
    };
    const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
    };
    const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
        const env = $6bd66e47d4948917$export$ea7ed2425832167d();
        return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
    };
});
parcelRegister("DVljb", function(module, exports) {
    $parcel$export(module.exports, "useLocale", ()=>$7c760643dc748494$export$43bb16f9c6d9e3f7);
    $parcel$export(module.exports, "useNativeLocale", ()=>$7c760643dc748494$export$31652d9c30d7d3f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale);
    };
    const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
        const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
        const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale), [
            locale
        ]);
        return standardizedLocale;
    };
});
parcelRegister("4RunP", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$b5acce10fab86688$export$fb465b6e855c1e85);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqtM5;
    var $fCLyO;
    var $5kgkl;
    var $2jPLg;
    var $d5DcG;
    var $kkbo9;
    var $c5psN;
    var $kHKSW;
    const $b5acce10fab86688$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
        const stableEnvironment = (0, (0, parcelRequire("kkbo9")).useStableObject)((0, (0, parcelRequire("kHKSW")).generateEnvironmentConfigWithOverrides)((0, (0, parcelRequire("fCLyO")).defaultEnvironmentValues), envWithOverrides));
        const stableContext = (0, (0, parcelRequire("kkbo9")).useStableObject)($b5acce10fab86688$var$composeConfig((0, (0, parcelRequire("iqtM5")).defaultPostOfficeContextValue), context.current));
        const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("c5psN")).createMessagePlacementValues)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCLyO")).PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqtM5")).InternalPostOfficeContextProvider), {
            value: stableContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2jPLg")).PostOfficeScreenContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5psN")).MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5kgkl")).RouteListenerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d5DcG")).TriggerContextProvider), null, children))))));
    };
    const $b5acce10fab86688$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
            for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
            return {
                ...acc,
                ...v
            };
        }, {
            ...base
        });
});
parcelRegister("iqtM5", function(module, exports) {
    $parcel$export(module.exports, "defaultPostOfficeContextValue", ()=>$966f0df4e8ee86cc$export$da5dc9062cba6715);
    $parcel$export(module.exports, "InternalPostOfficeContextProvider", ()=>$966f0df4e8ee86cc$export$3a10495c2cd2db0c);
    $parcel$export(module.exports, "PostOfficeContextProvider", ()=>$966f0df4e8ee86cc$export$b77983be89bb0a4e);
    $parcel$export(module.exports, "usePostOfficeContext", ()=>$966f0df4e8ee86cc$export$5bd9099e0ae94a43);
    var $5uXOq = parcelRequire("5uXOq");
    const $966f0df4e8ee86cc$export$da5dc9062cba6715 = {
        product: undefined,
        subproduct: undefined,
        locale: undefined,
        isSiteAdmin: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $966f0df4e8ee86cc$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($966f0df4e8ee86cc$export$da5dc9062cba6715);
    const $966f0df4e8ee86cc$export$3a10495c2cd2db0c = $966f0df4e8ee86cc$export$a228be81fcb77b42.Provider;
    const $966f0df4e8ee86cc$export$b77983be89bb0a4e = $966f0df4e8ee86cc$export$3a10495c2cd2db0c;
    const $966f0df4e8ee86cc$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($966f0df4e8ee86cc$export$a228be81fcb77b42);
});
parcelRegister("fCLyO", function(module, exports) {
    $parcel$export(module.exports, "defaultEnvironmentValues", ()=>$234fa19a996f66da$export$b4ede87479bfcf09);
    $parcel$export(module.exports, "PostOfficeEnvironmentProvider", ()=>$234fa19a996f66da$export$604607f913ef367c);
    $parcel$export(module.exports, "usePostOfficeEnvironment", ()=>$234fa19a996f66da$export$877b97169cc75e8b);
    var $5uXOq = parcelRequire("5uXOq");
    const $234fa19a996f66da$export$b4ede87479bfcf09 = {
        currentEnv: 'local',
        envConfigs: {
            test: {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $f773fdd9c7a555de$export$1e9fed4c0197724c),
                    pathname: (0, $f773fdd9c7a555de$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $f773fdd9c7a555de$export$1e9fed4c0197724c),
                    pathname: (0, $f773fdd9c7a555de$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $f773fdd9c7a555de$export$1e9fed4c0197724c),
                    pathname: (0, $f773fdd9c7a555de$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $f773fdd9c7a555de$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $f773fdd9c7a555de$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $f773fdd9c7a555de$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: (0, $f773fdd9c7a555de$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $f773fdd9c7a555de$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            }
        }
    };
    const $234fa19a996f66da$export$fceca2c399b32565 = (0, $5uXOq.createContext)($234fa19a996f66da$export$b4ede87479bfcf09);
    const $234fa19a996f66da$export$604607f913ef367c = $234fa19a996f66da$export$fceca2c399b32565.Provider;
    const $234fa19a996f66da$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($234fa19a996f66da$export$fceca2c399b32565);
});
var $f773fdd9c7a555de$exports = {};
$parcel$export($f773fdd9c7a555de$exports, "API_ORIGIN_LOCAL", ()=>$f773fdd9c7a555de$export$1e9fed4c0197724c);
$parcel$export($f773fdd9c7a555de$exports, "API_PATHNAME_LOCAL", ()=>$f773fdd9c7a555de$export$919a9569bce66f17);
$parcel$export($f773fdd9c7a555de$exports, "API_PATHNAME_STG_PROD", ()=>$f773fdd9c7a555de$export$d4fe3482c88e73a8);
$parcel$export($f773fdd9c7a555de$exports, "REMOTE_MODULE_URI_LOCAL", ()=>$f773fdd9c7a555de$export$67be2569ef5d7666);
$parcel$export($f773fdd9c7a555de$exports, "REMOTE_MODULE_URI_STG", ()=>$f773fdd9c7a555de$export$b49738b89db261cd);
$parcel$export($f773fdd9c7a555de$exports, "REMOTE_MODULE_URI_PROD", ()=>$f773fdd9c7a555de$export$bbd96cd490b0df63);
const $f773fdd9c7a555de$export$1e9fed4c0197724c = 'http://localhost:8081';
const $f773fdd9c7a555de$export$919a9569bce66f17 = '/api/v1/placements/';
const $f773fdd9c7a555de$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $f773fdd9c7a555de$export$67be2569ef5d7666 = 'http://localhost:9009';
const $f773fdd9c7a555de$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $f773fdd9c7a555de$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
parcelRegister("5kgkl", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeRouteUpdate", ()=>$41a991cae7bd564a$export$bb606326acdd1a64);
    $parcel$export(module.exports, "RouteListenerProvider", ()=>$41a991cae7bd564a$export$31986273b686f5ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $3M7BC;
    var $8uSQj;
    const $41a991cae7bd564a$var$noop = ()=>{};
    const $41a991cae7bd564a$var$RouteListenerContext = (0, $5uXOq.createContext)({
        update: $41a991cae7bd564a$var$noop
    });
    const $41a991cae7bd564a$export$7a2084f4baac29a7 = ()=>(0, (0, parcelRequire("3M7BC")).createSimplePubSub)();
    const $41a991cae7bd564a$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($41a991cae7bd564a$var$RouteListenerContext);
    const $41a991cae7bd564a$export$755edb1665399d41 = ()=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = $41a991cae7bd564a$export$7a2084f4baac29a7();
        const [routeSubscriber, updateRoute] = ref.current;
        const routeConfig = (0, $5uXOq.useMemo)(()=>({
                initialUrl: new URL(window.location.href),
                routeSubscriber: routeSubscriber
            }), [
            routeSubscriber
        ]);
        const routeUpdater = (0, $5uXOq.useMemo)(()=>({
                update: updateRoute
            }), [
            updateRoute
        ]);
        return [
            routeConfig,
            routeUpdater
        ];
    };
    const $41a991cae7bd564a$export$bb606326acdd1a64 = (deps)=>{
        const { update: update } = $41a991cae7bd564a$export$72fd8977abf03d60();
        (0, $5uXOq.useEffect)(()=>{
            if (typeof window === 'undefined') return;
            update({
                next: new URL(window.location.href)
            });
        }, deps);
    };
    const $41a991cae7bd564a$export$31986273b686f5ea = ({ children: children })=>{
        const [route, routeUpdater] = $41a991cae7bd564a$export$755edb1665399d41();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($41a991cae7bd564a$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8uSQj")).PostOfficeRouteProvider), route, children));
    };
});
parcelRegister("3M7BC", function(module, exports) {
    $parcel$export(module.exports, "createSimplePubSub", ()=>$0c586aaca1a7afe4$export$92469b55607f005b);
    const $0c586aaca1a7afe4$export$92469b55607f005b = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((callback)=>callback(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
});
parcelRegister("8uSQj", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeRouteContext", ()=>$cfcf4d29ea2e33b1$export$f7f47a74e8b47b1f);
    $parcel$export(module.exports, "PostOfficeRouteProvider", ()=>$cfcf4d29ea2e33b1$export$89eadc6b3e5f4e9e);
    $parcel$export(module.exports, "usePostOfficeRoute", ()=>$cfcf4d29ea2e33b1$export$79301b66f7808cd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8tyNL = parcelRequire("8tyNL");
    var $kkbo9;
    const $cfcf4d29ea2e33b1$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
        let state = $cfcf4d29ea2e33b1$var$initializeState({
            initialUrl: initialUrl
        });
        const handleUpdate = (routeChange)=>{
            const next = routeChange.next?.toString();
            if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
            state = {
                previous: state.current,
                current: next,
                searchParams: routeChange.next?.searchParams
            };
        };
        const subscribe = (next)=>routeSubscriber((routeChange)=>{
                handleUpdate(routeChange);
                next();
            });
        const getSnapshot = ()=>{
            return state;
        };
        return {
            subscribe: subscribe,
            getSnapshot: getSnapshot
        };
    };
    const $cfcf4d29ea2e33b1$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
        const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
        return (0, (0, parcelRequire("kkbo9")).useStableObject)(route);
    };
    const $cfcf4d29ea2e33b1$var$initialState = {
        previous: undefined,
        current: undefined,
        searchParams: undefined
    };
    const $cfcf4d29ea2e33b1$var$initializeState = ({ initialUrl: initialUrl })=>({
            ...$cfcf4d29ea2e33b1$var$initialState,
            current: initialUrl ? initialUrl?.toString() : undefined,
            searchParams: initialUrl?.searchParams
        });
    const $cfcf4d29ea2e33b1$export$f7f47a74e8b47b1f = (0, $5uXOq.createContext)($cfcf4d29ea2e33b1$var$initialState);
    const $cfcf4d29ea2e33b1$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current) ref.current = $cfcf4d29ea2e33b1$export$98c77e1bd702ed15(props);
        const route = $cfcf4d29ea2e33b1$var$usePostOfficeRouteStore(ref.current);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cfcf4d29ea2e33b1$export$f7f47a74e8b47b1f.Provider, {
            value: route
        }, children);
    };
    const $cfcf4d29ea2e33b1$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($cfcf4d29ea2e33b1$export$f7f47a74e8b47b1f);
});
parcelRegister("kkbo9", function(module, exports) {
    $parcel$export(module.exports, "useStableObject", ()=>$61e07a9b03df656e$export$ed02d4adf2068b08);
    var $5uXOq = parcelRequire("5uXOq");
    function $61e07a9b03df656e$export$cdf98ded28406f69(obj) {
        return Object.entries(obj).sort().flatMap((v)=>v);
    }
    function $61e07a9b03df656e$export$ed02d4adf2068b08(obj) {
        return (0, $5uXOq.useMemo)(()=>obj, $61e07a9b03df656e$export$cdf98ded28406f69(obj));
    }
});
parcelRegister("2jPLg", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeScreenContextProvider", ()=>$6b69159a90740629$export$ca77a8cbe94108fe);
    $parcel$export(module.exports, "usePostOfficeScreenPlacement", ()=>$6b69159a90740629$export$f51d04a086368016);
    var $5uXOq = parcelRequire("5uXOq");
    var $dnQxe;
    const $6b69159a90740629$var$initialPlacementState = {
        currentlyMounted: [],
        hasMounted: []
    };
    const $6b69159a90740629$var$PostOfficeScreenContext = (0, $5uXOq.createContext)({
        placements: $6b69159a90740629$var$initialPlacementState
    });
    const $6b69159a90740629$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($6b69159a90740629$var$PostOfficeScreenContext);
    const $6b69159a90740629$var$PostOfficeScreenUpdateContext = (0, $5uXOq.createContext)({
        placementMount: ()=>{},
        placementUnmount: ()=>{}
    });
    const $6b69159a90740629$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($6b69159a90740629$var$PostOfficeScreenUpdateContext);
    const $6b69159a90740629$export$ca77a8cbe94108fe = ({ children: children })=>{
        const [placements, setPlacements] = (0, $5uXOq.useState)($6b69159a90740629$var$initialPlacementState);
        const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: (0, (0, parcelRequire("dnQxe")).uniqueArray)([
                        ...state.currentlyMounted,
                        placementId
                    ]),
                    hasMounted: (0, (0, parcelRequire("dnQxe")).uniqueArray)([
                        ...state.hasMounted,
                        placementId
                    ])
                }), []);
        const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
                }), []);
        const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
                placementMount: placementMount,
                placementUnmount: placementUnmount
            }), [
            placementMount,
            placementUnmount
        ]);
        const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
                placements: placements
            }), [
            placements
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6b69159a90740629$var$PostOfficeScreenUpdateContext.Provider, {
            value: postOfficeScreenUpdateContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6b69159a90740629$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext
        }, children));
    };
    const $6b69159a90740629$export$f51d04a086368016 = ({ placementId: placementId })=>{
        const { placementMount: placementMount, placementUnmount: placementUnmount } = $6b69159a90740629$export$5d27c0ee02be2a23();
        (0, $5uXOq.useEffect)(()=>{
            if (!placementId) return;
            placementMount({
                placementId: placementId
            });
            return ()=>{
                placementUnmount({
                    placementId: placementId
                });
            };
        }, [
            placementId,
            placementMount,
            placementUnmount
        ]);
    };
});
parcelRegister("dnQxe", function(module, exports) {
    $parcel$export(module.exports, "uniqueArray", ()=>$1b050bbeb12fcf07$export$bbd17ecb0679edd7);
    const $1b050bbeb12fcf07$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
});
parcelRegister("d5DcG", function(module, exports) {
    $parcel$export(module.exports, "TriggerContextProvider", ()=>$6448076f01b73454$export$e80a5720bb4c8fe3);
    $parcel$export(module.exports, "useTrigger", ()=>$6448076f01b73454$export$3b196fe93a948c18);
    $parcel$export(module.exports, "useFirePostOfficeTrigger", ()=>$6448076f01b73454$export$83b33e5fe4cce64);
    var $5uXOq = parcelRequire("5uXOq");
    const $6448076f01b73454$var$initialActiveTriggerState = {
        activeTriggerState: {
            activeTriggerId: undefined
        }
    };
    const $6448076f01b73454$var$initialTriggerDispatchState = {
        setTriggerState: ()=>{
            console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
        }
    };
    const $6448076f01b73454$var$TriggerContext = (0, ($parcel$interopDefault($5uXOq))).createContext($6448076f01b73454$var$initialActiveTriggerState);
    const $6448076f01b73454$var$TriggerDispatchContext = (0, ($parcel$interopDefault($5uXOq))).createContext($6448076f01b73454$var$initialTriggerDispatchState);
    const $6448076f01b73454$export$e80a5720bb4c8fe3 = ({ children: children })=>{
        const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($6448076f01b73454$var$initialActiveTriggerState.activeTriggerState);
        const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
            setActiveTriggerState((current)=>{
                const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
                if (!hasStateChanged) return current;
                if (isActive) return {
                    activeTriggerId: triggerId
                };
                return {
                    activeTriggerId: undefined
                };
            });
        }, []);
        const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
                activeTriggerState: activeTriggerState
            }), [
            activeTriggerState
        ]);
        const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
                setTriggerState: setTriggerState
            }), [
            setTriggerState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6448076f01b73454$var$TriggerContext.Provider, {
            value: triggerContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6448076f01b73454$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue
        }, children));
    };
    const $6448076f01b73454$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($6448076f01b73454$var$TriggerContext);
    const $6448076f01b73454$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($6448076f01b73454$var$TriggerDispatchContext);
    const $6448076f01b73454$export$3b196fe93a948c18 = (triggerId)=>{
        const { activeTriggerState: activeTriggerState } = $6448076f01b73454$export$454c1d7c35958f5e();
        return triggerId ? {
            isActive: activeTriggerState.activeTriggerId === triggerId
        } : {
            isActive: undefined
        };
    };
    const $6448076f01b73454$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
        const { setTriggerState: setContextTriggerState } = $6448076f01b73454$export$23cbf084e08bdb93();
        const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        }, [
            setContextTriggerState,
            triggerId
        ]);
        return {
            fireTrigger: fireTrigger
        };
    };
});
parcelRegister("c5psN", function(module, exports) {
    $parcel$export(module.exports, "createMessagePlacementValues", ()=>$75991cf589aff8c6$export$a28a0c048b24fc5a);
    $parcel$export(module.exports, "MessagePlacementProvider", ()=>$75991cf589aff8c6$export$c7535f8ebc5b75a9);
    $parcel$export(module.exports, "useMessagePlacementHooks", ()=>$75991cf589aff8c6$export$89f8e1f623d8f5ac);
    var $5uXOq = parcelRequire("5uXOq");
    const $75991cf589aff8c6$var$createPubSub = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((cb)=>cb(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
    const $75991cf589aff8c6$export$a28a0c048b24fc5a = ()=>{
        const [onMessageSnooze, snoozeMessageFromPlacement] = $75991cf589aff8c6$var$createPubSub();
        const [onMessageDismiss, dismissMessageFromPlacement] = $75991cf589aff8c6$var$createPubSub();
        const [onMessageRead, markReadFromPlacement] = $75991cf589aff8c6$var$createPubSub();
        const [onMessageViewed, markViewedFromPlacement] = $75991cf589aff8c6$var$createPubSub();
        const [onMessageClicked, markClickedFromPlacement] = $75991cf589aff8c6$var$createPubSub();
        return {
            onMessageSnooze: onMessageSnooze,
            snoozeMessageFromPlacement: snoozeMessageFromPlacement,
            onMessageDismiss: onMessageDismiss,
            dismissMessageFromPlacement: dismissMessageFromPlacement,
            onMessageRead: onMessageRead,
            markReadFromPlacement: markReadFromPlacement,
            onMessageViewed: onMessageViewed,
            markViewedFromPlacement: markViewedFromPlacement,
            onMessageClicked: onMessageClicked,
            markClickedFromPlacement: markClickedFromPlacement
        };
    };
    const $75991cf589aff8c6$export$ea58328f3ceee4d4 = (0, $5uXOq.createContext)($75991cf589aff8c6$export$a28a0c048b24fc5a());
    const $75991cf589aff8c6$export$c7535f8ebc5b75a9 = $75991cf589aff8c6$export$ea58328f3ceee4d4.Provider;
    const $75991cf589aff8c6$export$c4b5cec0911af177 = ()=>({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($75991cf589aff8c6$export$c7535f8ebc5b75a9, {
                value: $75991cf589aff8c6$export$a28a0c048b24fc5a()
            }, children);
    const $75991cf589aff8c6$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($75991cf589aff8c6$export$ea58328f3ceee4d4);
});
parcelRegister("kHKSW", function(module, exports) {
    $parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", ()=>$d80b108543e7e030$export$ae3dab16eb1fc2cc);
    const $d80b108543e7e030$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
        const { env: env, overrides: overrides } = environmentWithOverrides;
        return {
            currentEnv: env,
            envConfigs: {
                ...defaultEnvironmentValues.envConfigs,
                [env]: {
                    remoteModule: {
                        origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                        pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                        searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                    },
                    api: {
                        origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                        pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                        searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                    }
                }
            }
        };
    };
});
parcelRegister("adncp", function(module, exports) {
    $parcel$export(module.exports, "tenantToPostOfficeContext", ()=>$8d0bdd2f51e19696$export$d8f2c334a0924146);
    $parcel$export(module.exports, "subproductToEdition", ()=>$8d0bdd2f51e19696$export$2d690d13b91ea44f);
    $parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", ()=>$8d0bdd2f51e19696$export$cfacfecb20987ff1);
    var $8dYib;
    const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
    const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
        product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
        locale: 'en'
    };
    const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
        return (0, (0, parcelRequire("8dYib")).JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString();
    };
    const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
        const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale } = tenantData;
        const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
            activationId: activationId,
            cloudId: cloudId
        });
        return {
            ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
            locale: locale,
            isSiteAdmin: isSiteAdmin,
            tenantId: cloudId,
            workspaceAri: workspaceAri,
            workspaceId: activationId,
            orgId: undefined,
            subproduct: undefined,
            productEdition: undefined
        };
    };
    const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
        switch(subproduct){
            case 'core':
                return editions.core;
            case 'software':
                return editions.software;
            case 'customerService':
                return editions.customerService;
            case 'serviceDesk':
                return editions.serviceDesk;
            default:
                undefined;
        }
    };
    const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
        switch(environment){
            case 'dev':
            case 'staging':
                return 'staging';
            case 'prod':
                return 'production';
            case 'local':
                return 'local';
            default:
                return 'local';
        }
    };
});
parcelRegister("8dYib", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAri", ()=>$5fce4e6fa5e3542e$export$d4d0794234e3fd53);
    var $b1EkX;
    var $9KGzW;
    var $1C2Ux;
    var $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("b1EkX")).JiraWorkspaceAriResourceOwner),
        resourceType: (0, (0, parcelRequire("b1EkX")).JiraWorkspaceAriResourceType),
        resourceIdSlug: "{activationId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/
        }
    };
    var $5fce4e6fa5e3542e$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.qualifier,
                platformQualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceOwner,
                resourceType: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceType,
                resourceId: `${opts.activationId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId
            };
        }
    };
});
parcelRegister("b1EkX", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", ()=>$806f13cc47cff352$export$e52ccdf6abac8896);
    $parcel$export(module.exports, "JiraWorkspaceAriResourceType", ()=>$806f13cc47cff352$export$669cd5f7b3746bb);
    var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";
});
parcelRegister("iPMn1", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacement", ()=>$3ba8955bb8ac2826$export$f6564e60882bdf90);
    var $5uXOq = parcelRequire("5uXOq");
    var $cDLGE;
    var $4R6GH;
    var $jQsty;
    var $2NxK6;
    var $5MOXH;
    const $3ba8955bb8ac2826$var$PLACEMENT_ID = 'screen-space-flags';
    const $3ba8955bb8ac2826$export$f6564e60882bdf90 = ()=>{
        return !false && !(0, (0, parcelRequire("jQsty")).default)((0, $d0ca21152325de6b$export$37d4bb5bc0e315db)) && (0, (0, parcelRequire("4R6GH")).fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MOXH")).ScreenSpaceFlagPlacementPreviewSwitcher), {
            isEnabled: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2NxK6")).default), {
            placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID,
            PlacementComponent: (0, (0, parcelRequire("cDLGE")).default),
            disableInitialData: true
        })) : null;
    };
});
parcelRegister("cDLGE", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", ()=>$f82ab07a9af059bf$export$c60b43809441c5b0);
    $parcel$export(module.exports, "default", ()=>$f82ab07a9af059bf$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    var $70qxv;
    var $btmIZ;
    var $c5psN;
    var $8xLFf;
    var $KSWm7;
    var $dIjzl;
    var $2GR5b;
    var $eKmOv;
    var $779Sq;
    var $a0yxQ;
    const $f82ab07a9af059bf$export$c60b43809441c5b0 = (0, (0, parcelRequire("a0yxQ")).withScreenSpaceFlagsIntlProvider)((0, (0, parcelRequire("KSWm7")).createPlacementComponent)((0, $b5a546abf3692d8d$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
        const [localMessageState, setLocalMessageState] = (0, $5uXOq.useState)();
        (0, (0, parcelRequire("dIjzl")).useInitialData)(initialData);
        const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, (0, parcelRequire("c5psN")).useMessagePlacementHooks)();
        const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
            setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
        };
        (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
            onMessageDismiss
        ]);
        (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
            onMessageClicked
        ]);
        (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleDismiss), [
            onMessageSnooze
        ]);
        const activeScopes = (0, (0, parcelRequire("btmIZ")).usePostOfficeContextScope)({
            scopes: (0, parcelRequire("eKmOv")).scopes
        });
        const messagesState = (0, (0, parcelRequire("2GR5b")).usePlacementApi)('/update-messages', {
            requestOptions: {
                method: 'POST',
                body: JSON.stringify(activeScopes)
            },
            throttleTime: 100,
            autoRefetch: {
                isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
                updateKey: activeScopes.updateKey ?? ''
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
        }, [
            messagesState.data
        ]);
        return (0, (0, parcelRequire("70qxv")).default).checkGate('post-office-screen-space-flags-shadow') ? (0, $2OMIu.jsx)($f82ab07a9af059bf$var$SuppressIfModalIsPresent, {
            children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>(0, $5uXOq.createElement)((0, (0, parcelRequire("779Sq")).MessageRenderer), {
                    ...props,
                    key: messageInstanceId,
                    id: messageInstanceId,
                    messageInstanceId: messageInstanceId,
                    onDismissed: ()=>setLocalMessageState([])
                }))
        }) : null;
    }));
    var $f82ab07a9af059bf$export$2e2bcd8739ae039 = $f82ab07a9af059bf$export$c60b43809441c5b0;
    const $f82ab07a9af059bf$var$SuppressIfModalIsPresent = ({ children: children })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
        const handleVisibilityChange = (0, $5uXOq.useCallback)((modalOnScreen)=>{
            const shouldShow = !modalOnScreen;
            if (!shouldShow) fireAnalyticsEvent({
                eventType: 'operational',
                action: 'suppressed',
                actionSubject: 'screenSpaceFlags'
            });
            setIsVisible(shouldShow);
        }, [
            fireAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const modalOnScreen = !!document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
            handleVisibilityChange(modalOnScreen);
        }, [
            handleVisibilityChange
        ]);
        return (0, (0, parcelRequire("70qxv")).default).checkGate('post-office-screen-space-flags-modal-detector') ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: isVisible && children
        }) : (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("2OMIu", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("iIkmJ"));
});
parcelRegister("iIkmJ", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$d9fc223fda04f9ed$export$ffb0004e005737fa, (v)=>$d9fc223fda04f9ed$export$ffb0004e005737fa = v);
    $parcel$export(module.exports, "jsx", ()=>$d9fc223fda04f9ed$export$34b9dba7ce09269b, (v)=>$d9fc223fda04f9ed$export$34b9dba7ce09269b = v);
    $parcel$export(module.exports, "jsxs", ()=>$d9fc223fda04f9ed$export$25062201e9e25d76, (v)=>$d9fc223fda04f9ed$export$25062201e9e25d76 = v);
    var $d9fc223fda04f9ed$export$ffb0004e005737fa;
    var $d9fc223fda04f9ed$export$34b9dba7ce09269b;
    var $d9fc223fda04f9ed$export$25062201e9e25d76;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    var $d9fc223fda04f9ed$var$k = Symbol.for("react.element"), $d9fc223fda04f9ed$var$l = Symbol.for("react.fragment"), $d9fc223fda04f9ed$var$m = Object.prototype.hasOwnProperty, $d9fc223fda04f9ed$var$n = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9fc223fda04f9ed$var$p = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function $d9fc223fda04f9ed$var$q(c, a, g) {
        var b, d = {}, e = null, h = null;
        void 0 !== g && (e = "" + g);
        void 0 !== a.key && (e = "" + a.key);
        void 0 !== a.ref && (h = a.ref);
        for(b in a)$d9fc223fda04f9ed$var$m.call(a, b) && !$d9fc223fda04f9ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
        if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
        return {
            $$typeof: $d9fc223fda04f9ed$var$k,
            type: c,
            key: e,
            ref: h,
            props: d,
            _owner: $d9fc223fda04f9ed$var$n.current
        };
    }
    $d9fc223fda04f9ed$export$ffb0004e005737fa = $d9fc223fda04f9ed$var$l;
    $d9fc223fda04f9ed$export$34b9dba7ce09269b = $d9fc223fda04f9ed$var$q;
    $d9fc223fda04f9ed$export$25062201e9e25d76 = $d9fc223fda04f9ed$var$q;
});
parcelRegister("btmIZ", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeContextScope", ()=>$e867560061defd31$export$daf66a67c26dc848);
    var $5uXOq = parcelRequire("5uXOq");
    var $kye0Q = parcelRequire("kye0Q");
    var $iqtM5;
    var $8uSQj;
    var $3M7BC;
    const $e867560061defd31$export$daf66a67c26dc848 = (config)=>{
        const scopeNames = $e867560061defd31$var$scopesNamesAsString(config.scopes);
        const matchScopes = (0, $5uXOq.useCallback)((input)=>$e867560061defd31$export$ec890b48cae4cc1c(config)(input), [
            scopeNames
        ]);
        const [state, setState] = (0, $5uXOq.useState)($e867560061defd31$var$initialState);
        const route = (0, (0, parcelRequire("8uSQj")).usePostOfficeRoute)();
        const context = (0, (0, parcelRequire("iqtM5")).usePostOfficeContext)();
        const next = matchScopes({
            route: route,
            context: context
        });
        $e867560061defd31$var$usePostOfficeScopeSpy(state, config);
        (0, $5uXOq.useEffect)(()=>{
            if ($e867560061defd31$export$fcc046cb16c47539({
                next: next,
                state: state
            })) setState(({ current: current })=>({
                    updateKey: Math.random().toString(36).substring(2),
                    current: next,
                    previous: current
                }));
        }, [
            $e867560061defd31$var$scopesNamesAsString(next)
        ]);
        return state;
    };
    const $e867560061defd31$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
    const $e867560061defd31$var$initialState = {
        updateKey: undefined,
        current: [],
        previous: []
    };
    const $e867560061defd31$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
            const contextMatch = route?.current ? {
                route: $e867560061defd31$var$extractRelevantUrlFields(route.current),
                context: context
            } : {
                route: undefined,
                context: context
            };
            const inputMatch = input.when;
            return $e867560061defd31$var$matchScope({
                contextMatch: contextMatch,
                inputMatch: inputMatch
            });
        };
    const $e867560061defd31$var$extractRelevantUrlFields = (route)=>{
        const { hostname: hostname, pathname: pathname } = new URL(route);
        return {
            hostname: hostname,
            pathname: pathname
        };
    };
    const $e867560061defd31$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, ($parcel$interopDefault($kye0Q)))(contextMatch, inputMatch, (contextValue, inputValue)=>$e867560061defd31$var$isValueMatchDeep({
                contextValue: contextValue,
                inputValue: inputValue
            }));
    const $e867560061defd31$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
        if (!contextValue || !inputValue) return false;
        if (typeof inputValue === 'string') return contextValue === inputValue;
        if (inputValue?.equals) return contextValue === inputValue.equals;
        if (!inputValue?.matches) return false;
        if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
        return new RegExp(inputValue.matches).test(contextValue);
    };
    const $e867560061defd31$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $e867560061defd31$var$matchScope({
            contextMatch: contextValue,
            inputMatch: inputValue
        }) : $e867560061defd31$var$isValueMatch({
            contextValue: contextValue,
            inputValue: inputValue
        });
    const $e867560061defd31$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($e867560061defd31$var$createMatchScope(input)).map((scope)=>({
                    name: scope.name
                }));
    const $e867560061defd31$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
        const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
        const nextSet = Array.from(new Set(next.map((e)=>e.name)));
        if (nextSet.length !== currentSet.length) return true;
        return !nextSet.every((e)=>currentSet.includes(e));
    };
    const $e867560061defd31$var$usePostOfficeScopeSpy = (state, config)=>{
        if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
            const [listen, update] = (0, (0, parcelRequire("3M7BC")).createSimplePubSub)();
            window.postOffice = {
                ...window.postOffice,
                scopes: {
                    [config?.consoleSpy.name]: {
                        listen: listen,
                        update: update,
                        list: config.scopes
                    }
                }
            };
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!config?.consoleSpy) return;
            if (!window.postOffice?.scopes) return;
            window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
        }, [
            $e867560061defd31$var$scopesNamesAsString(state.current)
        ]);
    };
});
parcelRegister("kye0Q", function(module, exports) {
    var $b1bUS = parcelRequire("b1bUS");
    var $2TGin = parcelRequire("2TGin");
    function $ef61da41fa345164$var$isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined;
        return $b1bUS(object, source, $2TGin(source), customizer);
    }
    module.exports = $ef61da41fa345164$var$isMatchWith;
});
parcelRegister("8xLFf", function(module, exports) {
    $parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", ()=>$fa64923352b3b4db$export$57d19d18d6e255a5);
    var $95EVP;
    var $5uXOq = parcelRequire("5uXOq");
    const $fa64923352b3b4db$export$85183a312807388d = 'postOffice';
    const $fa64923352b3b4db$export$57d19d18d6e255a5 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event, attributes)=>{
            createAnalyticsEvent({
                ...event,
                side: 'client',
                attributes: {
                    ...event.attributes,
                    ...attributes
                }
            }).fire($fa64923352b3b4db$export$85183a312807388d);
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    };
});
parcelRegister("KSWm7", function(module, exports) {
    $parcel$export(module.exports, "createPlacementComponent", ()=>$da1a363583dfeaa8$export$8a57effc6307f916);
    var $2OMIu = parcelRequire("2OMIu");
    var $kkbo9;
    var $fNQNn;
    var $c8NFt;
    var $7jfY2;
    var $1SbZ3;
    var $fX1Ft;
    const $da1a363583dfeaa8$export$eaeb39efb2b24b52 = (placementId, Component)=>(0, (0, parcelRequire("fX1Ft")).withErrorBoundary)((props)=>{
            const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
            const { postOfficeRoute: route, ...context } = contextWithRoute;
            const stableContext = (0, (0, parcelRequire("kkbo9")).useStableObject)(context);
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("7jfY2")).PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("1SbZ3")).StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    children: (0, $2OMIu.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            });
        });
    const $da1a363583dfeaa8$export$8a57effc6307f916 = (placementId, Component)=>{
        const placement = $da1a363583dfeaa8$export$eaeb39efb2b24b52(placementId, Component);
        return (props)=>{
            const { onError: onError, fallbackRender: fallbackRender } = (0, (0, parcelRequire("c8NFt")).useComponentErrorHandling)(props);
            return placement({
                ...props,
                errorBoundaryLocation: (0, (0, parcelRequire("fNQNn")).ERROR_BOUNDARY_LOCATION),
                onError: onError,
                fallbackRender: fallbackRender
            });
        };
    };
});
parcelRegister("fNQNn", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CONTEXT", ()=>$c06b009a298abea9$export$9c542858adf7dcd0);
    $parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", ()=>$c06b009a298abea9$export$71ff7382870ef1b0);
    const $c06b009a298abea9$export$9c542858adf7dcd0 = {
        isSiteAdmin: undefined,
        locale: undefined,
        product: undefined,
        subproduct: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $c06b009a298abea9$export$71ff7382870ef1b0 = 'create-placement-component';
});
parcelRegister("c8NFt", function(module, exports) {
    $parcel$export(module.exports, "useComponentErrorHandling", ()=>$1f0fe0b5813eee15$export$3d127465d22fe4e5);
    var $5uXOq = parcelRequire("5uXOq");
    const $1f0fe0b5813eee15$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
        const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
            onError?.(error, info);
        }, [
            onEvent,
            onError
        ]);
        const internalFallbackRender = fallbackRender ?? errorFallback;
        return {
            onError: internalOnError,
            fallbackRender: internalFallbackRender
        };
    };
});
parcelRegister("7jfY2", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracking", ()=>$935a458fa373c062$export$9a335a42ce02bdb8);
    var $2OMIu = parcelRequire("2OMIu");
    var $70qxv;
    var $hD3e9;
    var $axj9f;
    var $gftgD;
    const $935a458fa373c062$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
        const isUFOEnabled = (0, (0, parcelRequire("70qxv")).default).checkGate('enable_ufo_tracking_in_post_office');
        const { isLoading: isLoading, onMount: onMount } = (0, (0, parcelRequire("gftgD")).usePerformanceTracking)(props);
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("hD3e9")).UFOv2).SegmentNames.PLACEMENT,
            children: [
                isUFOEnabled && isLoading && (0, $2OMIu.jsx)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOLoadHold, {
                    name: (0, (0, parcelRequire("hD3e9")).UFOv2).HoldNames.PLACEMENT
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("axj9f")).TrackMount), {
                    onMount: onMount,
                    children: children
                })
            ]
        });
    };
});
parcelRegister("hD3e9", function(module, exports) {
    $parcel$export(module.exports, "UFOv2", ()=>$26716b6da26c4700$export$c91b09caa8ecbab1);
    var $le2LN;
    var $77kYm;
    const $26716b6da26c4700$export$c91b09caa8ecbab1 = {
        SegmentNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
            PLACEMENT: 'post-office-placement',
            MESSAGE: 'post-office-message'
        },
        HoldNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
            PLACEMENT: 'post-office-placement-loading',
            MESSAGE: 'post-office-message-loading'
        },
        UFOLoadHold: (0, parcelRequire("le2LN")).default,
        UFOSegment: (0, parcelRequire("77kYm")).default
    };
});
parcelRegister("axj9f", function(module, exports) {
    $parcel$export(module.exports, "TrackMount", ()=>$334bbed401768fe3$export$21b400a8c8ebc91a);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $334bbed401768fe3$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            const onUnmount = onMount();
            return onUnmount;
        }, []);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("gftgD", function(module, exports) {
    $parcel$export(module.exports, "usePerformanceTracking", ()=>$bee6b527df2ee3f9$export$317d52099614f316);
    var $5uXOq = parcelRequire("5uXOq");
    const $bee6b527df2ee3f9$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const onMount = (0, $5uXOq.useCallback)(()=>{
            return ()=>onEvent?.({
                    type: 'unmount'
                });
        }, [
            onEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (initialData) initialData.then(()=>{
                onEvent?.({
                    type: 'initial-data-complete'
                });
            }).catch((error)=>{
                onEvent?.({
                    type: 'initial-data-error',
                    error: error
                });
            }).finally(()=>{
                setIsLoading(false);
            });
            else setIsLoading(false);
        }, [
            initialData,
            onEvent
        ]);
        const onComponentError = (0, $5uXOq.useCallback)((error)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
        }, [
            onEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLoading === false) onEvent?.({
                type: 'component-ready'
            });
        }, [
            isLoading
        ]);
        return {
            onMount: onMount,
            isLoading: isLoading,
            onComponentError: onComponentError
        };
    };
});
parcelRegister("1SbZ3", function(module, exports) {
    $parcel$export(module.exports, "StableProviders", ()=>$813a43fead88a99c$export$2b6596bcb1383a71);
    var $2OMIu = parcelRequire("2OMIu");
    var $e0FVZ;
    var $hzExC;
    var $eBZDe;
    var $ealoC;
    var $3gyPZ;
    var $ec6zo;
    var $7jfY2;
    const $813a43fead88a99c$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("ealoC")).StableContextProvider), {
            context: context,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("3gyPZ")).StablePlacementProvider), {
                placement: placement,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("ec6zo")).StableRouteProvider), {
                    route: route,
                    children: (0, $2OMIu.jsx)((0, (0, parcelRequire("hzExC")).StableAnaltyicsProvider), {
                        children: (0, $2OMIu.jsx)((0, (0, parcelRequire("eBZDe")).StableChoreographerProvider), {
                            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("e0FVZ")).RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        });
});
parcelRegister("e0FVZ", function(module, exports) {
    $parcel$export(module.exports, "RenderTrackerProvider", ()=>$7980dab7b6808bdf$export$2d84fd9af6c9e378);
    var $2OMIu = parcelRequire("2OMIu");
    var $8xLFf;
    var $5uXOq = parcelRequire("5uXOq");
    const $7980dab7b6808bdf$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
        'screen-space-flags'
    ];
    const $7980dab7b6808bdf$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if ($7980dab7b6808bdf$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
            fireAnalyticsEvent({
                eventType: 'track',
                action: 'rendered',
                actionSubject: 'placement'
            });
        }, [
            fireAnalyticsEvent,
            placementId
        ]);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("hzExC", function(module, exports) {
    $parcel$export(module.exports, "StableAnaltyicsProvider", ()=>$1346e445e7638143$export$5a66cdc9893b43e);
    var $2OMIu = parcelRequire("2OMIu");
    var $2WlU9 = parcelRequire("2WlU9");
    const $1346e445e7638143$var$postOfficeAnalyticsContextData = {
        attributes: {
            build: {
                c: undefined,
                b: undefined,
                t: undefined
            }
        }
    };
    const $1346e445e7638143$export$5a66cdc9893b43e = ({ children: children })=>{
        return (0, $2OMIu.jsx)((0, $2WlU9.PostOfficeAnalyticsContext), {
            data: $1346e445e7638143$var$postOfficeAnalyticsContextData,
            children: children
        });
    };
});
parcelRegister("eBZDe", function(module, exports) {
    $parcel$export(module.exports, "StableChoreographerProvider", ()=>$cc13de8591dbdd1d$export$e68b2c75bfb5682a);
    $parcel$export(module.exports, "useChoreographerContext", ()=>$cc13de8591dbdd1d$export$cab5a8adbabcee23);
    var $2OMIu = parcelRequire("2OMIu");
    var $iqtM5;
    var $fCLyO;
    var $5uXOq = parcelRequire("5uXOq");
    var $jZ48m;
    const $cc13de8591dbdd1d$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
    const $cc13de8591dbdd1d$var$defaultContext = {
        choreographerEnabled: $cc13de8591dbdd1d$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
        setChoreographerEnabled: ()=>{},
        factory: undefined
    };
    const $cc13de8591dbdd1d$var$ChoreographerContext = (0, $5uXOq.createContext)($cc13de8591dbdd1d$var$defaultContext);
    const $cc13de8591dbdd1d$export$e68b2c75bfb5682a = ({ children: children })=>{
        const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)($cc13de8591dbdd1d$var$defaultContext.choreographerEnabled);
        const environmentContext = (0, (0, parcelRequire("fCLyO")).usePostOfficeEnvironment)();
        const context = (0, (0, parcelRequire("iqtM5")).usePostOfficeContext)();
        const choreographerFactory = new (0, (0, parcelRequire("jZ48m")).default)(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory();
        const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
                factory: choreographerFactory,
                choreographerEnabled: choreographerEnabled,
                setChoreographerEnabled: setChoreographerEnabled
            }), [
            choreographerFactory,
            choreographerEnabled,
            setChoreographerEnabled
        ]);
        return (0, $2OMIu.jsx)($cc13de8591dbdd1d$var$ChoreographerContext.Provider, {
            value: stableChoreographerContext,
            children: children
        });
    };
    const $cc13de8591dbdd1d$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($cc13de8591dbdd1d$var$ChoreographerContext);
});
parcelRegister("jZ48m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68606b5429fb68b1$export$2e2bcd8739ae039);
    var $8WQGU;
    var $3iMQo;
    var $bpIMA;
    const $68606b5429fb68b1$var$mapEnvToAnalyticsEnv = (env)=>{
        switch(env){
            case 'test':
            case 'local':
                return (0, (0, parcelRequire("bpIMA")).envType).LOCAL;
            case 'dev':
                return (0, (0, parcelRequire("bpIMA")).envType).DEV;
            case 'staging':
            case 'stg-fedm-east':
                return (0, (0, parcelRequire("bpIMA")).envType).STAGING;
            case 'production':
            case 'prod-fedm-east':
                return (0, (0, parcelRequire("bpIMA")).envType).PROD;
            default:
                return (0, (0, parcelRequire("bpIMA")).envType).DEV;
        }
    };
    class $68606b5429fb68b1$var$ChoreographerRegistry {
        constructor(product, environment){
            this.product = product;
            this.environment = environment;
        }
        getPostOfficeChoreographerFactory() {
            if (window.choreographerRegistry === undefined) window.choreographerRegistry = new Map();
            const maybeChoreographerFactory = window.choreographerRegistry.get((0, (0, parcelRequire("3iMQo")).ProductIds).POST_OFFICE);
            if (maybeChoreographerFactory) return maybeChoreographerFactory;
            const factory = (0, (0, parcelRequire("8WQGU")).choreographerFactory)((0, (0, parcelRequire("3iMQo")).ProductIds).POST_OFFICE, $68606b5429fb68b1$var$mapEnvToAnalyticsEnv(this.environment), {
                sourceProductId: this.product
            });
            window.choreographerRegistry.set((0, (0, parcelRequire("3iMQo")).ProductIds).POST_OFFICE, factory);
            return factory;
        }
    }
    var $68606b5429fb68b1$export$2e2bcd8739ae039 = $68606b5429fb68b1$var$ChoreographerRegistry;
});
parcelRegister("ealoC", function(module, exports) {
    $parcel$export(module.exports, "StableContextProvider", ()=>$a10c8879e2e4731b$export$d4982c0a28b18f63);
    var $2OMIu = parcelRequire("2OMIu");
    var $iqtM5;
    var $kkbo9;
    var $fNQNn;
    const $a10c8879e2e4731b$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
        const stableContext = (0, (0, parcelRequire("kkbo9")).useStableObject)({
            ...(0, (0, parcelRequire("fNQNn")).DEFAULT_CONTEXT),
            ...context
        });
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("iqtM5")).PostOfficeContextProvider), {
            value: stableContext,
            children: children
        });
    };
});
parcelRegister("3gyPZ", function(module, exports) {
    $parcel$export(module.exports, "StablePlacementProvider", ()=>$30f368b9b3d7ad7e$export$e9fd288527498af6);
    var $2OMIu = parcelRequire("2OMIu");
    var $kkbo9;
    var $g6WFU;
    const $30f368b9b3d7ad7e$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
        const stableValue = (0, (0, parcelRequire("kkbo9")).useStableObject)(placement);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("g6WFU")).PlacementProvider), {
            value: stableValue,
            children: children
        });
    };
});
parcelRegister("g6WFU", function(module, exports) {
    $parcel$export(module.exports, "PlacementProvider", ()=>$7ebeedc1a1880992$export$6272e220478c7f1d);
    $parcel$export(module.exports, "usePlacementContext", ()=>$7ebeedc1a1880992$export$4fc0446ee742ad80);
    var $2OMIu = parcelRequire("2OMIu");
    var $2WlU9 = parcelRequire("2WlU9");
    var $2jPLg;
    var $5uXOq = parcelRequire("5uXOq");
    const $7ebeedc1a1880992$export$6394bf86db095a8 = (0, $5uXOq.createContext)({
        placementId: undefined
    });
    const $7ebeedc1a1880992$export$6272e220478c7f1d = ({ value: value, children: children })=>{
        const memoizedValue = (0, $5uXOq.useMemo)(()=>({
                placementId: value.placementId
            }), [
            value.placementId
        ]);
        (0, (0, parcelRequire("2jPLg")).usePostOfficeScreenPlacement)(memoizedValue);
        return (0, $2OMIu.jsx)($7ebeedc1a1880992$export$6394bf86db095a8.Provider, {
            value: memoizedValue,
            children: (0, $2OMIu.jsx)((0, $2WlU9.PostOfficeAnalyticsContext), {
                data: memoizedValue,
                children: children
            })
        });
    };
    const $7ebeedc1a1880992$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($7ebeedc1a1880992$export$6394bf86db095a8);
});
parcelRegister("ec6zo", function(module, exports) {
    $parcel$export(module.exports, "StableRouteProvider", ()=>$9aa6d0f692c77bfd$export$ce13d00e696dfc96);
    var $2OMIu = parcelRequire("2OMIu");
    var $8uSQj;
    var $kkbo9;
    var $bHBhq;
    const $9aa6d0f692c77bfd$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
        const href = (0, (0, parcelRequire("bHBhq")).useLocationHref)();
        const stableRoute = (0, (0, parcelRequire("kkbo9")).useStableObject)(route ?? {
            previous: href,
            current: href
        });
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("8uSQj")).PostOfficeRouteContext).Provider, {
            value: stableRoute,
            children: children
        });
    };
});
parcelRegister("bHBhq", function(module, exports) {
    $parcel$export(module.exports, "useLocationHref", ()=>$85feb2ff6467df91$export$49fc3f3d8c7f99);
    const $85feb2ff6467df91$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
    const $85feb2ff6467df91$export$49fc3f3d8c7f99 = ()=>{
        return $85feb2ff6467df91$var$isLocationAvailable() ? globalThis.location.href : undefined;
    };
});
parcelRegister("fX1Ft", function(module, exports) {
    $parcel$export(module.exports, "withErrorBoundary", ()=>$ce9a5b0748bae6ae$export$f0c7a449e0cfaec7);
    var $2OMIu = parcelRequire("2OMIu");
    var $8xLFf;
    var $cHp9U;
    const $ce9a5b0748bae6ae$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
            const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                    if (onError) onError(error, info);
                    fireAnalyticsEvent({
                        eventType: (0, $a428e064f91eae50$export$12346a674644c156),
                        action: 'caughtError',
                        actionSubject: 'PostOfficeErrorBoundary',
                        actionSubjectId: additionalAnalytics.errorBoundaryLocation
                    }, {
                        error: error,
                        info: info
                    });
                };
            const internalFallbackRender = (FallbackRender)=>(props)=>{
                    if (FallbackRender) return (0, $2OMIu.jsx)(FallbackRender, {
                        ...props
                    });
                    return null;
                };
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("cHp9U")).ErrorBoundary), {
                fallbackRender: internalFallbackRender(fallbackRender),
                onError: internalOnError({
                    errorBoundaryLocation: errorBoundaryLocation
                }, onError),
                children: (0, $2OMIu.jsx)(Component, {
                    ...data
                })
            });
        };
});
const $a428e064f91eae50$export$a1562d08625f5d7e = 'ui';
const $a428e064f91eae50$export$947dac6c72b26f81 = 'track';
const $a428e064f91eae50$export$f1d537d508d2945a = 'screen';
const $a428e064f91eae50$export$12346a674644c156 = 'operational';
const $a428e064f91eae50$export$b055de0e665cb20c = 'unknown';
parcelRegister("cHp9U", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$0262ca640bff785f$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    'use client';
    const $0262ca640bff785f$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
    const $0262ca640bff785f$var$initialState = {
        didCatch: false,
        error: null
    };
    class $0262ca640bff785f$export$e926676385687eaf extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $0262ca640bff785f$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($0262ca640bff785f$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $0262ca640bff785f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($0262ca640bff785f$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $5uXOq.createElement)($0262ca640bff785f$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $0262ca640bff785f$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $0262ca640bff785f$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $0262ca640bff785f$export$c052f6604b7d51fe() {
        const context = (0, $5uXOq.useContext)($0262ca640bff785f$export$b16d9fb1a22de840);
        $0262ca640bff785f$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $5uXOq.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $5uXOq.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $0262ca640bff785f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($0262ca640bff785f$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
parcelRegister("dIjzl", function(module, exports) {
    $parcel$export(module.exports, "useInitialData", ()=>$5534bdfe2cfd8ac1$export$5523c5f3222291d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $k1Pz6;
    const $5534bdfe2cfd8ac1$export$5523c5f3222291d0 = (initialData)=>{
        const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
            if (typeof initialData === 'undefined') return undefined;
            return ()=>initialData;
        }, [
            initialData
        ]);
        return (0, (0, parcelRequire("k1Pz6")).useData)(initialDataCallback, {
            analytics: {
                name: 'initialData'
            }
        });
    };
});
parcelRegister("k1Pz6", function(module, exports) {
    $parcel$export(module.exports, "AlreadyRunningError", ()=>$2cdf7965e92ea2b1$export$8c5224d3af2f3c8b);
    $parcel$export(module.exports, "useData", ()=>$2cdf7965e92ea2b1$export$c1cf1cf4c5d51937);
    var $8xLFf;
    var $lzG7s = parcelRequire("lzG7s");
    var $5uXOq = parcelRequire("5uXOq");
    var $AyWIa;
    class $2cdf7965e92ea2b1$export$8c5224d3af2f3c8b extends Error {
        constructor(){
            super('Request is already running.');
            this.name = 'AlreadyRunningError';
        }
    }
    const $2cdf7965e92ea2b1$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
        const [state, setState] = (0, $5uXOq.useState)((0, (0, parcelRequire("AyWIa")).toLoading)());
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
        const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
            name: 'unknown'
        };
        (0, $5uXOq.useEffect)(()=>{
            if (typeof promiseToResolve !== 'function') return;
            const abortController = new AbortController();
            const { signal: signal } = abortController;
            promiseToResolve({
                signal: signal
            }).then((0, (0, parcelRequire("AyWIa")).assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
                setState((0, (0, parcelRequire("AyWIa")).toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }).catch((err)=>{
                if (err instanceof $2cdf7965e92ea2b1$export$8c5224d3af2f3c8b || signal.aborted) return;
                const errorState = (0, (0, parcelRequire("AyWIa")).toError)(err);
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: errorState.error.name ?? 'unknown',
                        errorMessage: errorState.error.message ?? 'unknown'
                    }
                });
                setState(errorState);
            });
            return ()=>{
                abortController.abort();
            };
        }, [
            promiseToResolve
        ]);
        return state;
    };
});
parcelRegister("lzG7s", function(module, exports) {
    (function() {
        var undefined;
        var VERSION = '4.17.21';
        var LARGE_ARRAY_SIZE = 200;
        var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        var MAX_MEMOIZE_SIZE = 500;
        var PLACEHOLDER = '__lodash_placeholder__';
        var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
        var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
        var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
        var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
        var HOT_COUNT = 800, HOT_SPAN = 16;
        var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
        var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
        var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        var wrapFlags = [
            [
                'ary',
                WRAP_ARY_FLAG
            ],
            [
                'bind',
                WRAP_BIND_FLAG
            ],
            [
                'bindKey',
                WRAP_BIND_KEY_FLAG
            ],
            [
                'curry',
                WRAP_CURRY_FLAG
            ],
            [
                'curryRight',
                WRAP_CURRY_RIGHT_FLAG
            ],
            [
                'flip',
                WRAP_FLIP_FLAG
            ],
            [
                'partial',
                WRAP_PARTIAL_FLAG
            ],
            [
                'partialRight',
                WRAP_PARTIAL_RIGHT_FLAG
            ],
            [
                'rearg',
                WRAP_REARG_FLAG
            ]
        ];
        var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
        var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
        var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
        var reTrimStart = /^\s+/;
        var reWhitespace = /\s/;
        var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
        var reEscapeChar = /\\(\\)?/g;
        var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
        var reFlags = /\w*$/;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var reIsOctal = /^0o[0-7]+$/i;
        var reIsUint = /^(?:0|[1-9]\d*)$/;
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        var reNoMatch = /($^)/;
        var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
        var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
        var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
        var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
            rsNonAstral,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
            rsDingbat,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
            rsNonAstral + rsCombo + '?',
            rsCombo,
            rsRegional,
            rsSurrPair,
            rsAstral
        ].join('|') + ')';
        var reApos = RegExp(rsApos, 'g');
        var reComboMark = RegExp(rsCombo, 'g');
        var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
        var reUnicodeWord = RegExp([
            rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
                rsBreak,
                rsUpper,
                '$'
            ].join('|') + ')',
            rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
                rsBreak,
                rsUpper + rsMiscLower,
                '$'
            ].join('|') + ')',
            rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
            rsUpper + '+' + rsOptContrUpper,
            rsOrdUpper,
            rsOrdLower,
            rsDigits,
            rsEmoji
        ].join('|'), 'g');
        var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        var contextProps = [
            'Array',
            'Buffer',
            'DataView',
            'Date',
            'Error',
            'Float32Array',
            'Float64Array',
            'Function',
            'Int8Array',
            'Int16Array',
            'Int32Array',
            'Map',
            'Math',
            'Object',
            'Promise',
            'RegExp',
            'Set',
            'String',
            'Symbol',
            'TypeError',
            'Uint8Array',
            'Uint8ClampedArray',
            'Uint16Array',
            'Uint32Array',
            'WeakMap',
            '_',
            'clearTimeout',
            'isFinite',
            'parseInt',
            'setTimeout'
        ];
        var templateCounter = -1;
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        var cloneableTags = {};
        cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
        cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
        var deburredLetters = {
            '\xc0': 'A',
            '\xc1': 'A',
            '\xc2': 'A',
            '\xc3': 'A',
            '\xc4': 'A',
            '\xc5': 'A',
            '\xe0': 'a',
            '\xe1': 'a',
            '\xe2': 'a',
            '\xe3': 'a',
            '\xe4': 'a',
            '\xe5': 'a',
            '\xc7': 'C',
            '\xe7': 'c',
            '\xd0': 'D',
            '\xf0': 'd',
            '\xc8': 'E',
            '\xc9': 'E',
            '\xca': 'E',
            '\xcb': 'E',
            '\xe8': 'e',
            '\xe9': 'e',
            '\xea': 'e',
            '\xeb': 'e',
            '\xcc': 'I',
            '\xcd': 'I',
            '\xce': 'I',
            '\xcf': 'I',
            '\xec': 'i',
            '\xed': 'i',
            '\xee': 'i',
            '\xef': 'i',
            '\xd1': 'N',
            '\xf1': 'n',
            '\xd2': 'O',
            '\xd3': 'O',
            '\xd4': 'O',
            '\xd5': 'O',
            '\xd6': 'O',
            '\xd8': 'O',
            '\xf2': 'o',
            '\xf3': 'o',
            '\xf4': 'o',
            '\xf5': 'o',
            '\xf6': 'o',
            '\xf8': 'o',
            '\xd9': 'U',
            '\xda': 'U',
            '\xdb': 'U',
            '\xdc': 'U',
            '\xf9': 'u',
            '\xfa': 'u',
            '\xfb': 'u',
            '\xfc': 'u',
            '\xdd': 'Y',
            '\xfd': 'y',
            '\xff': 'y',
            '\xc6': 'Ae',
            '\xe6': 'ae',
            '\xde': 'Th',
            '\xfe': 'th',
            '\xdf': 'ss',
            '\u0100': 'A',
            '\u0102': 'A',
            '\u0104': 'A',
            '\u0101': 'a',
            '\u0103': 'a',
            '\u0105': 'a',
            '\u0106': 'C',
            '\u0108': 'C',
            '\u010a': 'C',
            '\u010c': 'C',
            '\u0107': 'c',
            '\u0109': 'c',
            '\u010b': 'c',
            '\u010d': 'c',
            '\u010e': 'D',
            '\u0110': 'D',
            '\u010f': 'd',
            '\u0111': 'd',
            '\u0112': 'E',
            '\u0114': 'E',
            '\u0116': 'E',
            '\u0118': 'E',
            '\u011a': 'E',
            '\u0113': 'e',
            '\u0115': 'e',
            '\u0117': 'e',
            '\u0119': 'e',
            '\u011b': 'e',
            '\u011c': 'G',
            '\u011e': 'G',
            '\u0120': 'G',
            '\u0122': 'G',
            '\u011d': 'g',
            '\u011f': 'g',
            '\u0121': 'g',
            '\u0123': 'g',
            '\u0124': 'H',
            '\u0126': 'H',
            '\u0125': 'h',
            '\u0127': 'h',
            '\u0128': 'I',
            '\u012a': 'I',
            '\u012c': 'I',
            '\u012e': 'I',
            '\u0130': 'I',
            '\u0129': 'i',
            '\u012b': 'i',
            '\u012d': 'i',
            '\u012f': 'i',
            '\u0131': 'i',
            '\u0134': 'J',
            '\u0135': 'j',
            '\u0136': 'K',
            '\u0137': 'k',
            '\u0138': 'k',
            '\u0139': 'L',
            '\u013b': 'L',
            '\u013d': 'L',
            '\u013f': 'L',
            '\u0141': 'L',
            '\u013a': 'l',
            '\u013c': 'l',
            '\u013e': 'l',
            '\u0140': 'l',
            '\u0142': 'l',
            '\u0143': 'N',
            '\u0145': 'N',
            '\u0147': 'N',
            '\u014a': 'N',
            '\u0144': 'n',
            '\u0146': 'n',
            '\u0148': 'n',
            '\u014b': 'n',
            '\u014c': 'O',
            '\u014e': 'O',
            '\u0150': 'O',
            '\u014d': 'o',
            '\u014f': 'o',
            '\u0151': 'o',
            '\u0154': 'R',
            '\u0156': 'R',
            '\u0158': 'R',
            '\u0155': 'r',
            '\u0157': 'r',
            '\u0159': 'r',
            '\u015a': 'S',
            '\u015c': 'S',
            '\u015e': 'S',
            '\u0160': 'S',
            '\u015b': 's',
            '\u015d': 's',
            '\u015f': 's',
            '\u0161': 's',
            '\u0162': 'T',
            '\u0164': 'T',
            '\u0166': 'T',
            '\u0163': 't',
            '\u0165': 't',
            '\u0167': 't',
            '\u0168': 'U',
            '\u016a': 'U',
            '\u016c': 'U',
            '\u016e': 'U',
            '\u0170': 'U',
            '\u0172': 'U',
            '\u0169': 'u',
            '\u016b': 'u',
            '\u016d': 'u',
            '\u016f': 'u',
            '\u0171': 'u',
            '\u0173': 'u',
            '\u0174': 'W',
            '\u0175': 'w',
            '\u0176': 'Y',
            '\u0177': 'y',
            '\u0178': 'Y',
            '\u0179': 'Z',
            '\u017b': 'Z',
            '\u017d': 'Z',
            '\u017a': 'z',
            '\u017c': 'z',
            '\u017e': 'z',
            '\u0132': 'IJ',
            '\u0133': 'ij',
            '\u0152': 'Oe',
            '\u0153': 'oe',
            '\u0149': "'n",
            '\u017f': 's'
        };
        var htmlEscapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        var htmlUnescapes = {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'"
        };
        var stringEscapes = {
            '\\': '\\',
            "'": "'",
            '\n': 'n',
            '\r': 'r',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
        };
        var freeParseFloat = parseFloat, freeParseInt = parseInt;
        var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function('return this')();
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
            try {
                var types = freeModule && freeModule.require && freeModule.require('util').types;
                if (types) return types;
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        }();
        var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        function apply(func, thisArg, args) {
            switch(args.length){
                case 0:
                    return func.call(thisArg);
                case 1:
                    return func.call(thisArg, args[0]);
                case 2:
                    return func.call(thisArg, args[0], args[1]);
                case 3:
                    return func.call(thisArg, args[0], args[1], args[2]);
            }
            return func.apply(thisArg, args);
        }
        function arrayAggregator(array, setter, iteratee, accumulator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                var value = array[index];
                setter(accumulator, value, iteratee(value), array);
            }
            return accumulator;
        }
        function arrayEach(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        function arrayEachRight(array, iteratee) {
            var length = array == null ? 0 : array.length;
            while(length--){
                if (iteratee(array[length], length, array) === false) break;
            }
            return array;
        }
        function arrayEvery(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (!predicate(array[index], index, array)) return false;
            }
            return true;
        }
        function arrayFilter(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) result[resIndex++] = value;
            }
            return result;
        }
        function arrayIncludes(array, value) {
            var length = array == null ? 0 : array.length;
            return !!length && baseIndexOf(array, value, 0) > -1;
        }
        function arrayIncludesWith(array, value, comparator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (comparator(value, array[index])) return true;
            }
            return false;
        }
        function arrayMap(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length, result = Array(length);
            while(++index < length)result[index] = iteratee(array[index], index, array);
            return result;
        }
        function arrayPush(array, values) {
            var index = -1, length = values.length, offset = array.length;
            while(++index < length)array[offset + index] = values[index];
            return array;
        }
        function arrayReduce(array, iteratee, accumulator, initAccum) {
            var index = -1, length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[++index];
            while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
            return accumulator;
        }
        function arrayReduceRight(array, iteratee, accumulator, initAccum) {
            var length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[--length];
            while(length--)accumulator = iteratee(accumulator, array[length], length, array);
            return accumulator;
        }
        function arraySome(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        var asciiSize = baseProperty('length');
        function asciiToArray(string) {
            return string.split('');
        }
        function asciiWords(string) {
            return string.match(reAsciiWord) || [];
        }
        function baseFindKey(collection, predicate, eachFunc) {
            var result;
            eachFunc(collection, function(value, key, collection) {
                if (predicate(value, key, collection)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
            var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
            while(fromRight ? index-- : ++index < length){
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        }
        function baseIndexOf(array, value, fromIndex) {
            return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        function baseIndexOfWith(array, value, fromIndex, comparator) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (comparator(array[index], value)) return index;
            }
            return -1;
        }
        function baseIsNaN(value) {
            return value !== value;
        }
        function baseMean(array, iteratee) {
            var length = array == null ? 0 : array.length;
            return length ? baseSum(array, iteratee) / length : NAN;
        }
        function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        function basePropertyOf(object) {
            return function(key) {
                return object == null ? undefined : object[key];
            };
        }
        function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
            eachFunc(collection, function(value, index, collection) {
                accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
        }
        function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);
            while(length--)array[length] = array[length].value;
            return array;
        }
        function baseSum(array, iteratee) {
            var result, index = -1, length = array.length;
            while(++index < length){
                var current = iteratee(array[index]);
                if (current !== undefined) result = result === undefined ? current : result + current;
            }
            return result;
        }
        function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        function baseToPairs(object, props) {
            return arrayMap(props, function(key) {
                return [
                    key,
                    object[key]
                ];
            });
        }
        function baseTrim(string) {
            return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
        }
        function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        function baseValues(object, props) {
            return arrayMap(props, function(key) {
                return object[key];
            });
        }
        function cacheHas(cache, key) {
            return cache.has(key);
        }
        function charsStartIndex(strSymbols, chrSymbols) {
            var index = -1, length = strSymbols.length;
            while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function charsEndIndex(strSymbols, chrSymbols) {
            var index = strSymbols.length;
            while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function countHolders(array, placeholder) {
            var length = array.length, result = 0;
            while(length--)if (array[length] === placeholder) ++result;
            return result;
        }
        var deburrLetter = basePropertyOf(deburredLetters);
        var escapeHtmlChar = basePropertyOf(htmlEscapes);
        function escapeStringChar(chr) {
            return '\\' + stringEscapes[chr];
        }
        function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        function hasUnicode(string) {
            return reHasUnicode.test(string);
        }
        function hasUnicodeWord(string) {
            return reHasUnicodeWord.test(string);
        }
        function iteratorToArray(iterator) {
            var data, result = [];
            while(!(data = iterator.next()).done)result.push(data.value);
            return result;
        }
        function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        function replaceHolders(array, placeholder) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value === placeholder || value === PLACEHOLDER) {
                    array[index] = PLACEHOLDER;
                    result[resIndex++] = index;
                }
            }
            return result;
        }
        function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        function setToPairs(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = [
                    value,
                    value
                ];
            });
            return result;
        }
        function strictIndexOf(array, value, fromIndex) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (array[index] === value) return index;
            }
            return -1;
        }
        function strictLastIndexOf(array, value, fromIndex) {
            var index = fromIndex + 1;
            while(index--){
                if (array[index] === value) return index;
            }
            return index;
        }
        function stringSize(string) {
            return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
        }
        function stringToArray(string) {
            return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }
        function trimmedEndIndex(string) {
            var index = string.length;
            while(index-- && reWhitespace.test(string.charAt(index)));
            return index;
        }
        var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
        function unicodeSize(string) {
            var result = reUnicode.lastIndex = 0;
            while(reUnicode.test(string))++result;
            return result;
        }
        function unicodeToArray(string) {
            return string.match(reUnicode) || [];
        }
        function unicodeWords(string) {
            return string.match(reUnicodeWord) || [];
        }
        var runInContext = function runInContext(context) {
            context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
            var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
            var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
            var coreJsData = context['__core-js_shared__'];
            var funcToString = funcProto.toString;
            var hasOwnProperty = objectProto.hasOwnProperty;
            var idCounter = 0;
            var maskSrcKey = function() {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
            }();
            var nativeObjectToString = objectProto.toString;
            var objectCtorString = funcToString.call(Object1);
            var oldDash = root._;
            var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
            var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
            var defineProperty = function() {
                try {
                    var func = getNative(Object1, 'defineProperty');
                    func({}, '', {});
                    return func;
                } catch (e) {}
            }();
            var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
            var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
            var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
            var metaMap = WeakMap && new WeakMap;
            var realNames = {};
            var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
            var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            function lodash(value) {
                if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                    if (value instanceof LodashWrapper) return value;
                    if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
                }
                return new LodashWrapper(value);
            }
            var baseCreate = function() {
                function object() {}
                return function(proto) {
                    if (!isObject(proto)) return {};
                    if (objectCreate) return objectCreate(proto);
                    object.prototype = proto;
                    var result = new object;
                    object.prototype = undefined;
                    return result;
                };
            }();
            function baseLodash() {}
            function LodashWrapper(value, chainAll) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__chain__ = !!chainAll;
                this.__index__ = 0;
                this.__values__ = undefined;
            }
            lodash.templateSettings = {
                'escape': reEscape,
                'evaluate': reEvaluate,
                'interpolate': reInterpolate,
                'variable': '',
                'imports': {
                    '_': lodash
                }
            };
            lodash.prototype = baseLodash.prototype;
            lodash.prototype.constructor = lodash;
            LodashWrapper.prototype = baseCreate(baseLodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;
            function LazyWrapper(value) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__dir__ = 1;
                this.__filtered__ = false;
                this.__iteratees__ = [];
                this.__takeCount__ = MAX_ARRAY_LENGTH;
                this.__views__ = [];
            }
            function lazyClone() {
                var result = new LazyWrapper(this.__wrapped__);
                result.__actions__ = copyArray(this.__actions__);
                result.__dir__ = this.__dir__;
                result.__filtered__ = this.__filtered__;
                result.__iteratees__ = copyArray(this.__iteratees__);
                result.__takeCount__ = this.__takeCount__;
                result.__views__ = copyArray(this.__views__);
                return result;
            }
            function lazyReverse() {
                if (this.__filtered__) {
                    var result = new LazyWrapper(this);
                    result.__dir__ = -1;
                    result.__filtered__ = true;
                } else {
                    result = this.clone();
                    result.__dir__ *= -1;
                }
                return result;
            }
            function lazyValue() {
                var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
                if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
                var result = [];
                outer: while(length-- && resIndex < takeCount){
                    index += dir;
                    var iterIndex = -1, value = array[index];
                    while(++iterIndex < iterLength){
                        var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                        if (type == LAZY_MAP_FLAG) value = computed;
                        else if (!computed) {
                            if (type == LAZY_FILTER_FLAG) continue outer;
                            else break outer;
                        }
                    }
                    result[resIndex++] = value;
                }
                return result;
            }
            LazyWrapper.prototype = baseCreate(baseLodash.prototype);
            LazyWrapper.prototype.constructor = LazyWrapper;
            function Hash(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
                this.size = 0;
            }
            function hashDelete(key) {
                var result = this.has(key) && delete this.__data__[key];
                this.size -= result ? 1 : 0;
                return result;
            }
            function hashGet(key) {
                var data = this.__data__;
                if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                }
                return hasOwnProperty.call(data, key) ? data[key] : undefined;
            }
            function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
            }
            function hashSet(key, value) {
                var data = this.__data__;
                this.size += this.has(key) ? 0 : 1;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
            }
            Hash.prototype.clear = hashClear;
            Hash.prototype['delete'] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            function ListCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function listCacheClear() {
                this.__data__ = [];
                this.size = 0;
            }
            function listCacheDelete(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) return false;
                var lastIndex = data.length - 1;
                if (index == lastIndex) data.pop();
                else splice.call(data, index, 1);
                --this.size;
                return true;
            }
            function listCacheGet(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
            }
            function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
            }
            function listCacheSet(key, value) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    ++this.size;
                    data.push([
                        key,
                        value
                    ]);
                } else data[index][1] = value;
                return this;
            }
            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype['delete'] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            function MapCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function mapCacheClear() {
                this.size = 0;
                this.__data__ = {
                    'hash': new Hash,
                    'map': new (Map || ListCache),
                    'string': new Hash
                };
            }
            function mapCacheDelete(key) {
                var result = getMapData(this, key)['delete'](key);
                this.size -= result ? 1 : 0;
                return result;
            }
            function mapCacheGet(key) {
                return getMapData(this, key).get(key);
            }
            function mapCacheHas(key) {
                return getMapData(this, key).has(key);
            }
            function mapCacheSet(key, value) {
                var data = getMapData(this, key), size = data.size;
                data.set(key, value);
                this.size += data.size == size ? 0 : 1;
                return this;
            }
            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype['delete'] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            function SetCache(values) {
                var index = -1, length = values == null ? 0 : values.length;
                this.__data__ = new MapCache;
                while(++index < length)this.add(values[index]);
            }
            function setCacheAdd(value) {
                this.__data__.set(value, HASH_UNDEFINED);
                return this;
            }
            function setCacheHas(value) {
                return this.__data__.has(value);
            }
            SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
            SetCache.prototype.has = setCacheHas;
            function Stack(entries) {
                var data = this.__data__ = new ListCache(entries);
                this.size = data.size;
            }
            function stackClear() {
                this.__data__ = new ListCache;
                this.size = 0;
            }
            function stackDelete(key) {
                var data = this.__data__, result = data['delete'](key);
                this.size = data.size;
                return result;
            }
            function stackGet(key) {
                return this.__data__.get(key);
            }
            function stackHas(key) {
                return this.__data__.has(key);
            }
            function stackSet(key, value) {
                var data = this.__data__;
                if (data instanceof ListCache) {
                    var pairs = data.__data__;
                    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                        pairs.push([
                            key,
                            value
                        ]);
                        this.size = ++data.size;
                        return this;
                    }
                    data = this.__data__ = new MapCache(pairs);
                }
                data.set(key, value);
                this.size = data.size;
                return this;
            }
            Stack.prototype.clear = stackClear;
            Stack.prototype['delete'] = stackDelete;
            Stack.prototype.get = stackGet;
            Stack.prototype.has = stackHas;
            Stack.prototype.set = stackSet;
            function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
                for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) result.push(key);
                return result;
            }
            function arraySample(array) {
                var length = array.length;
                return length ? array[baseRandom(0, length - 1)] : undefined;
            }
            function arraySampleSize(array, n) {
                return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
            }
            function arrayShuffle(array) {
                return shuffleSelf(copyArray(array));
            }
            function assignMergeValue(object, key, value) {
                if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assignValue(object, key, value) {
                var objValue = object[key];
                if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assocIndexOf(array, key) {
                var length = array.length;
                while(length--){
                    if (eq(array[length][0], key)) return length;
                }
                return -1;
            }
            function baseAggregator(collection, setter, iteratee, accumulator) {
                baseEach(collection, function(value, key, collection) {
                    setter(accumulator, value, iteratee(value), collection);
                });
                return accumulator;
            }
            function baseAssign(object, source) {
                return object && copyObject(source, keys(source), object);
            }
            function baseAssignIn(object, source) {
                return object && copyObject(source, keysIn(source), object);
            }
            function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
                else object[key] = value;
            }
            function baseAt(object, paths) {
                var index = -1, length = paths.length, result = Array1(length), skip = object == null;
                while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
                return result;
            }
            function baseClamp(number, lower, upper) {
                if (number === number) {
                    if (upper !== undefined) number = number <= upper ? number : upper;
                    if (lower !== undefined) number = number >= lower ? number : lower;
                }
                return number;
            }
            function baseClone(value, bitmask, customizer, key, object, stack) {
                var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
                if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
                if (result !== undefined) return result;
                if (!isObject(value)) return value;
                var isArr = isArray(value);
                if (isArr) {
                    result = initCloneArray(value);
                    if (!isDeep) return copyArray(value, result);
                } else {
                    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                    if (isBuffer(value)) return cloneBuffer(value, isDeep);
                    if (tag == objectTag || tag == argsTag || isFunc && !object) {
                        result = isFlat || isFunc ? {} : initCloneObject(value);
                        if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                    } else {
                        if (!cloneableTags[tag]) return object ? value : {};
                        result = initCloneByTag(value, tag, isDeep);
                    }
                }
                stack || (stack = new Stack);
                var stacked = stack.get(value);
                if (stacked) return stacked;
                stack.set(value, result);
                if (isSet(value)) value.forEach(function(subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
                else if (isMap(value)) value.forEach(function(subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                var props = isArr ? undefined : keysFunc(value);
                arrayEach(props || value, function(subValue, key) {
                    if (props) {
                        key = subValue;
                        subValue = value[key];
                    }
                    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
            }
            function baseConforms(source) {
                var props = keys(source);
                return function(object) {
                    return baseConformsTo(object, source, props);
                };
            }
            function baseConformsTo(object, source, props) {
                var length = props.length;
                if (object == null) return !length;
                object = Object1(object);
                while(length--){
                    var key = props[length], predicate = source[key], value = object[key];
                    if (value === undefined && !(key in object) || !predicate(value)) return false;
                }
                return true;
            }
            function baseDelay(func, wait, args) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return setTimeout(function() {
                    func.apply(undefined, args);
                }, wait);
            }
            function baseDifference(array, values, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
                if (!length) return result;
                if (iteratee) values = arrayMap(values, baseUnary(iteratee));
                if (comparator) {
                    includes = arrayIncludesWith;
                    isCommon = false;
                } else if (values.length >= LARGE_ARRAY_SIZE) {
                    includes = cacheHas;
                    isCommon = false;
                    values = new SetCache(values);
                }
                outer: while(++index < length){
                    var value = array[index], computed = iteratee == null ? value : iteratee(value);
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var valuesIndex = valuesLength;
                        while(valuesIndex--){
                            if (values[valuesIndex] === computed) continue outer;
                        }
                        result.push(value);
                    } else if (!includes(values, computed, comparator)) result.push(value);
                }
                return result;
            }
            var baseEach = createBaseEach(baseForOwn);
            var baseEachRight = createBaseEach(baseForOwnRight, true);
            function baseEvery(collection, predicate) {
                var result = true;
                baseEach(collection, function(value, index, collection) {
                    result = !!predicate(value, index, collection);
                    return result;
                });
                return result;
            }
            function baseExtremum(array, iteratee, comparator) {
                var index = -1, length = array.length;
                while(++index < length){
                    var value = array[index], current = iteratee(value);
                    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
                }
                return result;
            }
            function baseFill(array, value, start, end) {
                var length = array.length;
                start = toInteger(start);
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end === undefined || end > length ? length : toInteger(end);
                if (end < 0) end += length;
                end = start > end ? 0 : toLength(end);
                while(start < end)array[start++] = value;
                return array;
            }
            function baseFilter(collection, predicate) {
                var result = [];
                baseEach(collection, function(value, index, collection) {
                    if (predicate(value, index, collection)) result.push(value);
                });
                return result;
            }
            function baseFlatten(array, depth, predicate, isStrict, result) {
                var index = -1, length = array.length;
                predicate || (predicate = isFlattenable);
                result || (result = []);
                while(++index < length){
                    var value = array[index];
                    if (depth > 0 && predicate(value)) {
                        if (depth > 1) baseFlatten(value, depth - 1, predicate, isStrict, result);
                        else arrayPush(result, value);
                    } else if (!isStrict) result[result.length] = value;
                }
                return result;
            }
            var baseFor = createBaseFor();
            var baseForRight = createBaseFor(true);
            function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
            }
            function baseForOwnRight(object, iteratee) {
                return object && baseForRight(object, iteratee, keys);
            }
            function baseFunctions(object, props) {
                return arrayFilter(props, function(key) {
                    return isFunction(object[key]);
                });
            }
            function baseGet(object, path) {
                path = castPath(path, object);
                var index = 0, length = path.length;
                while(object != null && index < length)object = object[toKey(path[index++])];
                return index && index == length ? object : undefined;
            }
            function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                var result = keysFunc(object);
                return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
            }
            function baseGetTag(value) {
                if (value == null) return value === undefined ? undefinedTag : nullTag;
                return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
            }
            function baseGt(value, other) {
                return value > other;
            }
            function baseHas(object, key) {
                return object != null && hasOwnProperty.call(object, key);
            }
            function baseHasIn(object, key) {
                return object != null && key in Object1(object);
            }
            function baseInRange(number, start, end) {
                return number >= nativeMin(start, end) && number < nativeMax(start, end);
            }
            function baseIntersection(arrays, iteratee, comparator) {
                var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
                while(othIndex--){
                    var array = arrays[othIndex];
                    if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                    maxLength = nativeMin(array.length, maxLength);
                    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                }
                array = arrays[0];
                var index = -1, seen = caches[0];
                outer: while(++index < length && result.length < maxLength){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                        othIndex = othLength;
                        while(--othIndex){
                            var cache = caches[othIndex];
                            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                        }
                        if (seen) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseInverter(object, setter, iteratee, accumulator) {
                baseForOwn(object, function(value, key, object) {
                    setter(accumulator, iteratee(value), key, object);
                });
                return accumulator;
            }
            function baseInvoke(object, path, args) {
                path = castPath(path, object);
                object = parent(object, path);
                var func = object == null ? object : object[toKey(last(path))];
                return func == null ? undefined : apply(func, object, args);
            }
            function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
            }
            function baseIsArrayBuffer(value) {
                return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
            }
            function baseIsDate(value) {
                return isObjectLike(value) && baseGetTag(value) == dateTag;
            }
            function baseIsEqual(value, other, bitmask, customizer, stack) {
                if (value === other) return true;
                if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
                return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }
            function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
                objTag = objTag == argsTag ? objectTag : objTag;
                othTag = othTag == argsTag ? objectTag : othTag;
                var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
                if (isSameTag && isBuffer(object)) {
                    if (!isBuffer(other)) return false;
                    objIsArr = true;
                    objIsObj = false;
                }
                if (isSameTag && !objIsObj) {
                    stack || (stack = new Stack);
                    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                }
                if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                    if (objIsWrapped || othIsWrapped) {
                        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                        stack || (stack = new Stack);
                        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                    }
                }
                if (!isSameTag) return false;
                stack || (stack = new Stack);
                return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
            }
            function baseIsMap(value) {
                return isObjectLike(value) && getTag(value) == mapTag;
            }
            function baseIsMatch(object, source, matchData, customizer) {
                var index = matchData.length, length = index, noCustomizer = !customizer;
                if (object == null) return !length;
                object = Object1(object);
                while(index--){
                    var data = matchData[index];
                    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
                }
                while(++index < length){
                    data = matchData[index];
                    var key = data[0], objValue = object[key], srcValue = data[1];
                    if (noCustomizer && data[2]) {
                        if (objValue === undefined && !(key in object)) return false;
                    } else {
                        var stack = new Stack;
                        if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                    }
                }
                return true;
            }
            function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) return false;
                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
            }
            function baseIsRegExp(value) {
                return isObjectLike(value) && baseGetTag(value) == regexpTag;
            }
            function baseIsSet(value) {
                return isObjectLike(value) && getTag(value) == setTag;
            }
            function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
            }
            function baseIteratee(value) {
                if (typeof value == 'function') return value;
                if (value == null) return identity;
                if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                return property(value);
            }
            function baseKeys(object) {
                if (!isPrototype(object)) return nativeKeys(object);
                var result = [];
                for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
                return result;
            }
            function baseKeysIn(object) {
                if (!isObject(object)) return nativeKeysIn(object);
                var isProto = isPrototype(object), result = [];
                for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
                return result;
            }
            function baseLt(value, other) {
                return value < other;
            }
            function baseMap(collection, iteratee) {
                var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value, key, collection) {
                    result[++index] = iteratee(value, key, collection);
                });
                return result;
            }
            function baseMatches(source) {
                var matchData = getMatchData(source);
                if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                return function(object) {
                    return object === source || baseIsMatch(object, source, matchData);
                };
            }
            function baseMatchesProperty(path, srcValue) {
                if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
                return function(object) {
                    var objValue = get(object, path);
                    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                };
            }
            function baseMerge(object, source, srcIndex, customizer, stack) {
                if (object === source) return;
                baseFor(source, function(srcValue, key) {
                    stack || (stack = new Stack);
                    if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                    else {
                        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                        if (newValue === undefined) newValue = srcValue;
                        assignMergeValue(object, key, newValue);
                    }
                }, keysIn);
            }
            function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
                if (stacked) {
                    assignMergeValue(object, key, stacked);
                    return;
                }
                var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                var isCommon = newValue === undefined;
                if (isCommon) {
                    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                    newValue = srcValue;
                    if (isArr || isBuff || isTyped) {
                        if (isArray(objValue)) newValue = objValue;
                        else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                        else if (isBuff) {
                            isCommon = false;
                            newValue = cloneBuffer(srcValue, true);
                        } else if (isTyped) {
                            isCommon = false;
                            newValue = cloneTypedArray(srcValue, true);
                        } else newValue = [];
                    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                        newValue = objValue;
                        if (isArguments(objValue)) newValue = toPlainObject(objValue);
                        else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                    } else isCommon = false;
                }
                if (isCommon) {
                    stack.set(srcValue, newValue);
                    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                    stack['delete'](srcValue);
                }
                assignMergeValue(object, key, newValue);
            }
            function baseNth(array, n) {
                var length = array.length;
                if (!length) return;
                n += n < 0 ? length : 0;
                return isIndex(n, length) ? array[n] : undefined;
            }
            function baseOrderBy(collection, iteratees, orders) {
                if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                    if (isArray(iteratee)) return function(value) {
                        return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                    };
                    return iteratee;
                });
                else iteratees = [
                    identity
                ];
                var index = -1;
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                var result = baseMap(collection, function(value, key, collection) {
                    var criteria = arrayMap(iteratees, function(iteratee) {
                        return iteratee(value);
                    });
                    return {
                        'criteria': criteria,
                        'index': ++index,
                        'value': value
                    };
                });
                return baseSortBy(result, function(object, other) {
                    return compareMultiple(object, other, orders);
                });
            }
            function basePick(object, paths) {
                return basePickBy(object, paths, function(value, path) {
                    return hasIn(object, path);
                });
            }
            function basePickBy(object, paths, predicate) {
                var index = -1, length = paths.length, result = {};
                while(++index < length){
                    var path = paths[index], value = baseGet(object, path);
                    if (predicate(value, path)) baseSet(result, castPath(path, object), value);
                }
                return result;
            }
            function basePropertyDeep(path) {
                return function(object) {
                    return baseGet(object, path);
                };
            }
            function basePullAll(array, values, iteratee, comparator) {
                var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
                if (array === values) values = copyArray(values);
                if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
                while(++index < length){
                    var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                    while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                        if (seen !== array) splice.call(seen, fromIndex, 1);
                        splice.call(array, fromIndex, 1);
                    }
                }
                return array;
            }
            function basePullAt(array, indexes) {
                var length = array ? indexes.length : 0, lastIndex = length - 1;
                while(length--){
                    var index = indexes[length];
                    if (length == lastIndex || index !== previous) {
                        var previous = index;
                        if (isIndex(index)) splice.call(array, index, 1);
                        else baseUnset(array, index);
                    }
                }
                return array;
            }
            function baseRandom(lower, upper) {
                return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
            }
            function baseRange(start, end, step, fromRight) {
                var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
                while(length--){
                    result[fromRight ? length : ++index] = start;
                    start += step;
                }
                return result;
            }
            function baseRepeat(string, n) {
                var result = '';
                if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
                do {
                    if (n % 2) result += string;
                    n = nativeFloor(n / 2);
                    if (n) string += string;
                }while (n)
                return result;
            }
            function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
            }
            function baseSample(collection) {
                return arraySample(values(collection));
            }
            function baseSampleSize(collection, n) {
                var array = values(collection);
                return shuffleSelf(array, baseClamp(n, 0, array.length));
            }
            function baseSet(object, path, value, customizer) {
                if (!isObject(object)) return object;
                path = castPath(path, object);
                var index = -1, length = path.length, lastIndex = length - 1, nested = object;
                while(nested != null && ++index < length){
                    var key = toKey(path[index]), newValue = value;
                    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                    if (index != lastIndex) {
                        var objValue = nested[key];
                        newValue = customizer ? customizer(objValue, key, nested) : undefined;
                        if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                    }
                    assignValue(nested, key, newValue);
                    nested = nested[key];
                }
                return object;
            }
            var baseSetData = !metaMap ? identity : function(func, data) {
                metaMap.set(func, data);
                return func;
            };
            var baseSetToString = !defineProperty ? identity : function(func, string) {
                return defineProperty(func, 'toString', {
                    'configurable': true,
                    'enumerable': false,
                    'value': constant(string),
                    'writable': true
                });
            };
            function baseShuffle(collection) {
                return shuffleSelf(values(collection));
            }
            function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end > length ? length : end;
                if (end < 0) end += length;
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array1(length);
                while(++index < length)result[index] = array[index + start];
                return result;
            }
            function baseSome(collection, predicate) {
                var result;
                baseEach(collection, function(value, index, collection) {
                    result = predicate(value, index, collection);
                    return !result;
                });
                return !!result;
            }
            function baseSortedIndex(array, value, retHighest) {
                var low = 0, high = array == null ? low : array.length;
                if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                    while(low < high){
                        var mid = low + high >>> 1, computed = array[mid];
                        if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                        else high = mid;
                    }
                    return high;
                }
                return baseSortedIndexBy(array, value, identity, retHighest);
            }
            function baseSortedIndexBy(array, value, iteratee, retHighest) {
                var low = 0, high = array == null ? 0 : array.length;
                if (high === 0) return 0;
                value = iteratee(value);
                var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
                while(low < high){
                    var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                    if (valIsNaN) var setLow = retHighest || othIsReflexive;
                    else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                    else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                    else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                    else if (othIsNull || othIsSymbol) setLow = false;
                    else setLow = retHighest ? computed <= value : computed < value;
                    if (setLow) low = mid + 1;
                    else high = mid;
                }
                return nativeMin(high, MAX_ARRAY_INDEX);
            }
            function baseSortedUniq(array, iteratee) {
                var index = -1, length = array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    if (!index || !eq(computed, seen)) {
                        var seen = computed;
                        result[resIndex++] = value === 0 ? 0 : value;
                    }
                }
                return result;
            }
            function baseToNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                return +value;
            }
            function baseToString(value) {
                if (typeof value == 'string') return value;
                if (isArray(value)) return arrayMap(value, baseToString) + '';
                if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function baseUniq(array, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
                if (comparator) {
                    isCommon = false;
                    includes = arrayIncludesWith;
                } else if (length >= LARGE_ARRAY_SIZE) {
                    var set = iteratee ? null : createSet(array);
                    if (set) return setToArray(set);
                    isCommon = false;
                    includes = cacheHas;
                    seen = new SetCache;
                } else seen = iteratee ? [] : result;
                outer: while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var seenIndex = seen.length;
                        while(seenIndex--){
                            if (seen[seenIndex] === computed) continue outer;
                        }
                        if (iteratee) seen.push(computed);
                        result.push(value);
                    } else if (!includes(seen, computed, comparator)) {
                        if (seen !== result) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseUnset(object, path) {
                path = castPath(path, object);
                object = parent(object, path);
                return object == null || delete object[toKey(last(path))];
            }
            function baseUpdate(object, path, updater, customizer) {
                return baseSet(object, path, updater(baseGet(object, path)), customizer);
            }
            function baseWhile(array, predicate, isDrop, fromRight) {
                var length = array.length, index = fromRight ? length : -1;
                while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
                return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
            }
            function baseWrapperValue(value, actions) {
                var result = value;
                if (result instanceof LazyWrapper) result = result.value();
                return arrayReduce(actions, function(result, action) {
                    return action.func.apply(action.thisArg, arrayPush([
                        result
                    ], action.args));
                }, result);
            }
            function baseXor(arrays, iteratee, comparator) {
                var length = arrays.length;
                if (length < 2) return length ? baseUniq(arrays[0]) : [];
                var index = -1, result = Array1(length);
                while(++index < length){
                    var array = arrays[index], othIndex = -1;
                    while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                }
                return baseUniq(baseFlatten(result, 1), iteratee, comparator);
            }
            function baseZipObject(props, values, assignFunc) {
                var index = -1, length = props.length, valsLength = values.length, result = {};
                while(++index < length){
                    var value = index < valsLength ? values[index] : undefined;
                    assignFunc(result, props[index], value);
                }
                return result;
            }
            function castArrayLikeObject(value) {
                return isArrayLikeObject(value) ? value : [];
            }
            function castFunction(value) {
                return typeof value == 'function' ? value : identity;
            }
            function castPath(value, object) {
                if (isArray(value)) return value;
                return isKey(value, object) ? [
                    value
                ] : stringToPath(toString(value));
            }
            var castRest = baseRest;
            function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
            }
            var clearTimeout = ctxClearTimeout || function(id) {
                return root.clearTimeout(id);
            };
            function cloneBuffer(buffer, isDeep) {
                if (isDeep) return buffer.slice();
                var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
                buffer.copy(result);
                return result;
            }
            function cloneArrayBuffer(arrayBuffer) {
                var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                return result;
            }
            function cloneDataView(dataView, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
            }
            function cloneRegExp(regexp) {
                var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                result.lastIndex = regexp.lastIndex;
                return result;
            }
            function cloneSymbol(symbol) {
                return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
            }
            function cloneTypedArray(typedArray, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
            }
            function compareAscending(value, other) {
                if (value !== other) {
                    var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                    var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
                }
                return 0;
            }
            function compareMultiple(object, other, orders) {
                var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
                while(++index < length){
                    var result = compareAscending(objCriteria[index], othCriteria[index]);
                    if (result) {
                        if (index >= ordersLength) return result;
                        var order = orders[index];
                        return result * (order == 'desc' ? -1 : 1);
                    }
                }
                return object.index - other.index;
            }
            function composeArgs(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
                while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
                while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
                while(rangeLength--)result[leftIndex++] = args[argsIndex++];
                return result;
            }
            function composeArgsRight(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
                while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
                var offset = argsIndex;
                while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
                while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
                return result;
            }
            function copyArray(source, array) {
                var index = -1, length = source.length;
                array || (array = Array1(length));
                while(++index < length)array[index] = source[index];
                return array;
            }
            function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                    if (newValue === undefined) newValue = source[key];
                    if (isNew) baseAssignValue(object, key, newValue);
                    else assignValue(object, key, newValue);
                }
                return object;
            }
            function copySymbols(source, object) {
                return copyObject(source, getSymbols(source), object);
            }
            function copySymbolsIn(source, object) {
                return copyObject(source, getSymbolsIn(source), object);
            }
            function createAggregator(setter, initializer) {
                return function(collection, iteratee) {
                    var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                    return func(collection, setter, getIteratee(iteratee, 2), accumulator);
                };
            }
            function createAssigner(assigner) {
                return baseRest(function(object, sources) {
                    var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                        customizer = length < 3 ? undefined : customizer;
                        length = 1;
                    }
                    object = Object1(object);
                    while(++index < length){
                        var source = sources[index];
                        if (source) assigner(object, source, index, customizer);
                    }
                    return object;
                });
            }
            function createBaseEach(eachFunc, fromRight) {
                return function(collection, iteratee) {
                    if (collection == null) return collection;
                    if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                    var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                    while(fromRight ? index-- : ++index < length){
                        if (iteratee(iterable[index], index, iterable) === false) break;
                    }
                    return collection;
                };
            }
            function createBaseFor(fromRight) {
                return function(object, iteratee, keysFunc) {
                    var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                    while(length--){
                        var key = props[fromRight ? length : ++index];
                        if (iteratee(iterable[key], key, iterable) === false) break;
                    }
                    return object;
                };
            }
            function createBind(func, bitmask, thisArg) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return fn.apply(isBind ? thisArg : this, arguments);
                }
                return wrapper;
            }
            function createCaseFirst(methodName) {
                return function(string) {
                    string = toString(string);
                    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                    return chr[methodName]() + trailing;
                };
            }
            function createCompounder(callback) {
                return function(string) {
                    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                };
            }
            function createCtor(Ctor) {
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return new Ctor;
                        case 1:
                            return new Ctor(args[0]);
                        case 2:
                            return new Ctor(args[0], args[1]);
                        case 3:
                            return new Ctor(args[0], args[1], args[2]);
                        case 4:
                            return new Ctor(args[0], args[1], args[2], args[3]);
                        case 5:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                        case 6:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                        case 7:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                    }
                    var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                    return isObject(result) ? result : thisBinding;
                };
            }
            function createCurry(func, bitmask, arity) {
                var Ctor = createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                    while(index--)args[index] = arguments[index];
                    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                    length -= holders.length;
                    if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return apply(fn, this, args);
                }
                return wrapper;
            }
            function createFind(findIndexFunc) {
                return function(collection, predicate, fromIndex) {
                    var iterable = Object1(collection);
                    if (!isArrayLike(collection)) {
                        var iteratee = getIteratee(predicate, 3);
                        collection = keys(collection);
                        predicate = function(key) {
                            return iteratee(iterable[key], key, iterable);
                        };
                    }
                    var index = findIndexFunc(collection, predicate, fromIndex);
                    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                };
            }
            function createFlow(fromRight) {
                return flatRest(function(funcs) {
                    var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                    if (fromRight) funcs.reverse();
                    while(index--){
                        var func = funcs[index];
                        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                        if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                    }
                    index = wrapper ? index : length;
                    while(++index < length){
                        func = funcs[index];
                        var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                        if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                        else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                    }
                    return function() {
                        var args = arguments, value = args[0];
                        if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                        var index = 0, result = length ? funcs[index].apply(this, args) : value;
                        while(++index < length)result = funcs[index].call(this, result);
                        return result;
                    };
                });
            }
            function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
                var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length;
                    while(index--)args[index] = arguments[index];
                    if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                    if (partials) args = composeArgs(args, partials, holders, isCurried);
                    if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                    length -= holdersCount;
                    if (isCurried && length < arity) {
                        var newHolders = replaceHolders(args, placeholder);
                        return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                    }
                    var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                    length = args.length;
                    if (argPos) args = reorder(args, argPos);
                    else if (isFlip && length > 1) args.reverse();
                    if (isAry && ary < length) args.length = ary;
                    if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                    return fn.apply(thisBinding, args);
                }
                return wrapper;
            }
            function createInverter(setter, toIteratee) {
                return function(object, iteratee) {
                    return baseInverter(object, setter, toIteratee(iteratee), {});
                };
            }
            function createMathOperation(operator, defaultValue) {
                return function(value, other) {
                    var result;
                    if (value === undefined && other === undefined) return defaultValue;
                    if (value !== undefined) result = value;
                    if (other !== undefined) {
                        if (result === undefined) return other;
                        if (typeof value == 'string' || typeof other == 'string') {
                            value = baseToString(value);
                            other = baseToString(other);
                        } else {
                            value = baseToNumber(value);
                            other = baseToNumber(other);
                        }
                        result = operator(value, other);
                    }
                    return result;
                };
            }
            function createOver(arrayFunc) {
                return flatRest(function(iteratees) {
                    iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                    return baseRest(function(args) {
                        var thisArg = this;
                        return arrayFunc(iteratees, function(iteratee) {
                            return apply(iteratee, thisArg, args);
                        });
                    });
                });
            }
            function createPadding(length, chars) {
                chars = chars === undefined ? ' ' : baseToString(chars);
                var charsLength = chars.length;
                if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
                var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
                return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
            }
            function createPartial(func, bitmask, thisArg, partials) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                    while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                    return apply(fn, isBind ? thisArg : this, args);
                }
                return wrapper;
            }
            function createRange(fromRight) {
                return function(start, end, step) {
                    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                    start = toFinite(start);
                    if (end === undefined) {
                        end = start;
                        start = 0;
                    } else end = toFinite(end);
                    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                    return baseRange(start, end, step, fromRight);
                };
            }
            function createRelationalOperation(operator) {
                return function(value, other) {
                    if (!(typeof value == 'string' && typeof other == 'string')) {
                        value = toNumber(value);
                        other = toNumber(other);
                    }
                    return operator(value, other);
                };
            }
            function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
                var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
                bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
                if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newHolders,
                    newPartialsRight,
                    newHoldersRight,
                    argPos,
                    ary,
                    arity
                ];
                var result = wrapFunc.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return setWrapToString(result, func, bitmask);
            }
            function createRound(methodName) {
                var func = Math[methodName];
                return function(number, precision) {
                    number = toNumber(number);
                    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                    if (precision && nativeIsFinite(number)) {
                        var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                        pair = (toString(value) + 'e').split('e');
                        return +(pair[0] + 'e' + (+pair[1] - precision));
                    }
                    return func(number);
                };
            }
            var createSet = !(Set && 1 / setToArray(new Set([
                ,
                -0
            ]))[1] == INFINITY) ? noop : function(values) {
                return new Set(values);
            };
            function createToPairs(keysFunc) {
                return function(object) {
                    var tag = getTag(object);
                    if (tag == mapTag) return mapToArray(object);
                    if (tag == setTag) return setToPairs(object);
                    return baseToPairs(object, keysFunc(object));
                };
            }
            function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var length = partials ? partials.length : 0;
                if (!length) {
                    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                    partials = holders = undefined;
                }
                ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                arity = arity === undefined ? arity : toInteger(arity);
                length -= holders ? holders.length : 0;
                if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                    var partialsRight = partials, holdersRight = holders;
                    partials = holders = undefined;
                }
                var data = isBindKey ? undefined : getData(func);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    partialsRight,
                    holdersRight,
                    argPos,
                    ary,
                    arity
                ];
                if (data) mergeData(newData, data);
                func = newData[0];
                bitmask = newData[1];
                thisArg = newData[2];
                partials = newData[3];
                holders = newData[4];
                arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
                if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
                else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
                else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
                else result = createHybrid.apply(undefined, newData);
                var setter = data ? baseSetData : setData;
                return setWrapToString(setter(result, newData), func, bitmask);
            }
            function customDefaultsAssignIn(objValue, srcValue, key, object) {
                if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
                return objValue;
            }
            function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                if (isObject(objValue) && isObject(srcValue)) {
                    stack.set(srcValue, objValue);
                    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                    stack['delete'](srcValue);
                }
                return objValue;
            }
            function customOmitClone(value) {
                return isPlainObject(value) ? undefined : value;
            }
            function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
                if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
                var arrStacked = stack.get(array);
                var othStacked = stack.get(other);
                if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
                var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
                stack.set(array, other);
                stack.set(other, array);
                while(++index < arrLength){
                    var arrValue = array[index], othValue = other[index];
                    if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                    if (compared !== undefined) {
                        if (compared) continue;
                        result = false;
                        break;
                    }
                    if (seen) {
                        if (!arraySome(other, function(othValue, othIndex) {
                            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                        })) {
                            result = false;
                            break;
                        }
                    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        result = false;
                        break;
                    }
                }
                stack['delete'](array);
                stack['delete'](other);
                return result;
            }
            function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                switch(tag){
                    case dataViewTag:
                        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                        object = object.buffer;
                        other = other.buffer;
                    case arrayBufferTag:
                        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                        return true;
                    case boolTag:
                    case dateTag:
                    case numberTag:
                        return eq(+object, +other);
                    case errorTag:
                        return object.name == other.name && object.message == other.message;
                    case regexpTag:
                    case stringTag:
                        return object == other + '';
                    case mapTag:
                        var convert = mapToArray;
                    case setTag:
                        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                        convert || (convert = setToArray);
                        if (object.size != other.size && !isPartial) return false;
                        var stacked = stack.get(object);
                        if (stacked) return stacked == other;
                        bitmask |= COMPARE_UNORDERED_FLAG;
                        stack.set(object, other);
                        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                        stack['delete'](object);
                        return result;
                    case symbolTag:
                        if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
                return false;
            }
            function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
                if (objLength != othLength && !isPartial) return false;
                var index = objLength;
                while(index--){
                    var key = objProps[index];
                    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
                }
                var objStacked = stack.get(object);
                var othStacked = stack.get(other);
                if (objStacked && othStacked) return objStacked == other && othStacked == object;
                var result = true;
                stack.set(object, other);
                stack.set(other, object);
                var skipCtor = isPartial;
                while(++index < objLength){
                    key = objProps[index];
                    var objValue = object[key], othValue = other[key];
                    if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                        result = false;
                        break;
                    }
                    skipCtor || (skipCtor = key == 'constructor');
                }
                if (result && !skipCtor) {
                    var objCtor = object.constructor, othCtor = other.constructor;
                    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
                }
                stack['delete'](object);
                stack['delete'](other);
                return result;
            }
            function flatRest(func) {
                return setToString(overRest(func, undefined, flatten), func + '');
            }
            function getAllKeys(object) {
                return baseGetAllKeys(object, keys, getSymbols);
            }
            function getAllKeysIn(object) {
                return baseGetAllKeys(object, keysIn, getSymbolsIn);
            }
            var getData = !metaMap ? noop : function(func) {
                return metaMap.get(func);
            };
            function getFuncName(func) {
                var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
                while(length--){
                    var data = array[length], otherFunc = data.func;
                    if (otherFunc == null || otherFunc == func) return data.name;
                }
                return result;
            }
            function getHolder(func) {
                var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
                return object.placeholder;
            }
            function getIteratee() {
                var result = lodash.iteratee || iteratee;
                result = result === iteratee ? baseIteratee : result;
                return arguments.length ? result(arguments[0], arguments[1]) : result;
            }
            function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
            }
            function getMatchData(object) {
                var result = keys(object), length = result.length;
                while(length--){
                    var key = result[length], value = object[key];
                    result[length] = [
                        key,
                        value,
                        isStrictComparable(value)
                    ];
                }
                return result;
            }
            function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
            }
            function getRawTag(value) {
                var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
                try {
                    value[symToStringTag] = undefined;
                    var unmasked = true;
                } catch (e) {}
                var result = nativeObjectToString.call(value);
                if (unmasked) {
                    if (isOwn) value[symToStringTag] = tag;
                    else delete value[symToStringTag];
                }
                return result;
            }
            var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
                if (object == null) return [];
                object = Object1(object);
                return arrayFilter(nativeGetSymbols(object), function(symbol) {
                    return propertyIsEnumerable.call(object, symbol);
                });
            };
            var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
                var result = [];
                while(object){
                    arrayPush(result, getSymbols(object));
                    object = getPrototype(object);
                }
                return result;
            };
            var getTag = baseGetTag;
            if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
                var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
                if (ctorString) switch(ctorString){
                    case dataViewCtorString:
                        return dataViewTag;
                    case mapCtorString:
                        return mapTag;
                    case promiseCtorString:
                        return promiseTag;
                    case setCtorString:
                        return setTag;
                    case weakMapCtorString:
                        return weakMapTag;
                }
                return result;
            };
            function getView(start, end, transforms) {
                var index = -1, length = transforms.length;
                while(++index < length){
                    var data = transforms[index], size = data.size;
                    switch(data.type){
                        case 'drop':
                            start += size;
                            break;
                        case 'dropRight':
                            end -= size;
                            break;
                        case 'take':
                            end = nativeMin(end, start + size);
                            break;
                        case 'takeRight':
                            start = nativeMax(start, end - size);
                            break;
                    }
                }
                return {
                    'start': start,
                    'end': end
                };
            }
            function getWrapDetails(source) {
                var match = source.match(reWrapDetails);
                return match ? match[1].split(reSplitDetails) : [];
            }
            function hasPath(object, path, hasFunc) {
                path = castPath(path, object);
                var index = -1, length = path.length, result = false;
                while(++index < length){
                    var key = toKey(path[index]);
                    if (!(result = object != null && hasFunc(object, key))) break;
                    object = object[key];
                }
                if (result || ++index != length) return result;
                length = object == null ? 0 : object.length;
                return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
            }
            function initCloneArray(array) {
                var length = array.length, result = new array.constructor(length);
                if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                    result.index = array.index;
                    result.input = array.input;
                }
                return result;
            }
            function initCloneObject(object) {
                return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
            }
            function initCloneByTag(object, tag, isDeep) {
                var Ctor = object.constructor;
                switch(tag){
                    case arrayBufferTag:
                        return cloneArrayBuffer(object);
                    case boolTag:
                    case dateTag:
                        return new Ctor(+object);
                    case dataViewTag:
                        return cloneDataView(object, isDeep);
                    case float32Tag:
                    case float64Tag:
                    case int8Tag:
                    case int16Tag:
                    case int32Tag:
                    case uint8Tag:
                    case uint8ClampedTag:
                    case uint16Tag:
                    case uint32Tag:
                        return cloneTypedArray(object, isDeep);
                    case mapTag:
                        return new Ctor;
                    case numberTag:
                    case stringTag:
                        return new Ctor(object);
                    case regexpTag:
                        return cloneRegExp(object);
                    case setTag:
                        return new Ctor;
                    case symbolTag:
                        return cloneSymbol(object);
                }
            }
            function insertWrapDetails(source, details) {
                var length = details.length;
                if (!length) return source;
                var lastIndex = length - 1;
                details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                details = details.join(length > 2 ? ', ' : ' ');
                return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
            }
            function isFlattenable(value) {
                return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
            }
            function isIndex(value, length) {
                var type = typeof value;
                length = length == null ? MAX_SAFE_INTEGER : length;
                return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
            }
            function isIterateeCall(value, index, object) {
                if (!isObject(object)) return false;
                var type = typeof index;
                if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
                return false;
            }
            function isKey(value, object) {
                if (isArray(value)) return false;
                var type = typeof value;
                if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
            }
            function isKeyable(value) {
                var type = typeof value;
                return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
            }
            function isLaziable(func) {
                var funcName = getFuncName(func), other = lodash[funcName];
                if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
                if (func === other) return true;
                var data = getData(other);
                return !!data && func === data[0];
            }
            function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
            }
            var isMaskable = coreJsData ? isFunction : stubFalse;
            function isPrototype(value) {
                var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
                return value === proto;
            }
            function isStrictComparable(value) {
                return value === value && !isObject(value);
            }
            function matchesStrictComparable(key, srcValue) {
                return function(object) {
                    if (object == null) return false;
                    return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
                };
            }
            function memoizeCapped(func) {
                var result = memoize(func, function(key) {
                    if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                    return key;
                });
                var cache = result.cache;
                return result;
            }
            function mergeData(data, source) {
                var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
                if (!(isCommon || isCombo)) return data;
                if (srcBitmask & WRAP_BIND_FLAG) {
                    data[2] = source[2];
                    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                }
                var value = source[3];
                if (value) {
                    var partials = data[3];
                    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                }
                value = source[5];
                if (value) {
                    partials = data[5];
                    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                }
                value = source[7];
                if (value) data[7] = value;
                if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                if (data[9] == null) data[9] = source[9];
                data[0] = source[0];
                data[1] = newBitmask;
                return data;
            }
            function nativeKeysIn(object) {
                var result = [];
                if (object != null) for(var key in Object1(object))result.push(key);
                return result;
            }
            function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function() {
                    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                    while(++index < length)array[index] = args[start + index];
                    index = -1;
                    var otherArgs = Array1(start + 1);
                    while(++index < start)otherArgs[index] = args[index];
                    otherArgs[start] = transform(array);
                    return apply(func, this, otherArgs);
                };
            }
            function parent(object, path) {
                return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
            }
            function reorder(array, indexes) {
                var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
                while(length--){
                    var index = indexes[length];
                    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                }
                return array;
            }
            function safeGet(object, key) {
                if (key === 'constructor' && typeof object[key] === 'function') return;
                if (key == '__proto__') return;
                return object[key];
            }
            var setData = shortOut(baseSetData);
            var setTimeout = ctxSetTimeout || function(func, wait) {
                return root.setTimeout(func, wait);
            };
            var setToString = shortOut(baseSetToString);
            function setWrapToString(wrapper, reference, bitmask) {
                var source = reference + '';
                return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
            }
            function shortOut(func) {
                var count = 0, lastCalled = 0;
                return function() {
                    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                    lastCalled = stamp;
                    if (remaining > 0) {
                        if (++count >= HOT_COUNT) return arguments[0];
                    } else count = 0;
                    return func.apply(undefined, arguments);
                };
            }
            function shuffleSelf(array, size) {
                var index = -1, length = array.length, lastIndex = length - 1;
                size = size === undefined ? length : size;
                while(++index < size){
                    var rand = baseRandom(index, lastIndex), value = array[rand];
                    array[rand] = array[index];
                    array[index] = value;
                }
                array.length = size;
                return array;
            }
            var stringToPath = memoizeCapped(function(string) {
                var result = [];
                if (string.charCodeAt(0) === 46) result.push('');
                string.replace(rePropName, function(match, number, quote, subString) {
                    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
                });
                return result;
            });
            function toKey(value) {
                if (typeof value == 'string' || isSymbol(value)) return value;
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function toSource(func) {
                if (func != null) {
                    try {
                        return funcToString.call(func);
                    } catch (e) {}
                    try {
                        return func + '';
                    } catch (e) {}
                }
                return '';
            }
            function updateWrapDetails(details, bitmask) {
                arrayEach(wrapFlags, function(pair) {
                    var value = '_.' + pair[0];
                    if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
                });
                return details.sort();
            }
            function wrapperClone(wrapper) {
                if (wrapper instanceof LazyWrapper) return wrapper.clone();
                var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                result.__actions__ = copyArray(wrapper.__actions__);
                result.__index__ = wrapper.__index__;
                result.__values__ = wrapper.__values__;
                return result;
            }
            function chunk(array, size, guard) {
                if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
                else size = nativeMax(toInteger(size), 0);
                var length = array == null ? 0 : array.length;
                if (!length || size < 1) return [];
                var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
                while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
                return result;
            }
            function compact(array) {
                var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index];
                    if (value) result[resIndex++] = value;
                }
                return result;
            }
            function concat() {
                var length = arguments.length;
                if (!length) return [];
                var args = Array1(length - 1), array = arguments[0], index = length;
                while(index--)args[index - 1] = arguments[index];
                return arrayPush(isArray(array) ? copyArray(array) : [
                    array
                ], baseFlatten(args, 1));
            }
            var difference = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
            });
            var differenceBy = baseRest(function(array, values) {
                var iteratee = last(values);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
            });
            var differenceWith = baseRest(function(array, values) {
                var comparator = last(values);
                if (isArrayLikeObject(comparator)) comparator = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
            });
            function drop(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function dropRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function dropRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
            }
            function dropWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
            }
            function fill(array, value, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                    start = 0;
                    end = length;
                }
                return baseFill(array, value, start, end);
            }
            function findIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseFindIndex(array, getIteratee(predicate, 3), index);
            }
            function findLastIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length - 1;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return baseFindIndex(array, getIteratee(predicate, 3), index, true);
            }
            function flatten(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, 1) : [];
            }
            function flattenDeep(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, INFINITY) : [];
            }
            function flattenDepth(array, depth) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(array, depth);
            }
            function fromPairs(pairs) {
                var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
                while(++index < length){
                    var pair = pairs[index];
                    result[pair[0]] = pair[1];
                }
                return result;
            }
            function head(array) {
                return array && array.length ? array[0] : undefined;
            }
            function indexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseIndexOf(array, value, index);
            }
            function initial(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 0, -1) : [];
            }
            var intersection = baseRest(function(arrays) {
                var mapped = arrayMap(arrays, castArrayLikeObject);
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
            });
            var intersectionBy = baseRest(function(arrays) {
                var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                if (iteratee === last(mapped)) iteratee = undefined;
                else mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
            });
            var intersectionWith = baseRest(function(arrays) {
                var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                if (comparator) mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
            });
            function join(array, separator) {
                return array == null ? '' : nativeJoin.call(array, separator);
            }
            function last(array) {
                var length = array == null ? 0 : array.length;
                return length ? array[length - 1] : undefined;
            }
            function lastIndexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
            }
            function nth(array, n) {
                return array && array.length ? baseNth(array, toInteger(n)) : undefined;
            }
            var pull = baseRest(pullAll);
            function pullAll(array, values) {
                return array && array.length && values && values.length ? basePullAll(array, values) : array;
            }
            function pullAllBy(array, values, iteratee) {
                return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
            }
            function pullAllWith(array, values, comparator) {
                return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
            }
            var pullAt = flatRest(function(array, indexes) {
                var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
                basePullAt(array, arrayMap(indexes, function(index) {
                    return isIndex(index, length) ? +index : index;
                }).sort(compareAscending));
                return result;
            });
            function remove(array, predicate) {
                var result = [];
                if (!(array && array.length)) return result;
                var index = -1, indexes = [], length = array.length;
                predicate = getIteratee(predicate, 3);
                while(++index < length){
                    var value = array[index];
                    if (predicate(value, index, array)) {
                        result.push(value);
                        indexes.push(index);
                    }
                }
                basePullAt(array, indexes);
                return result;
            }
            function reverse(array) {
                return array == null ? array : nativeReverse.call(array);
            }
            function slice(array, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                    start = 0;
                    end = length;
                } else {
                    start = start == null ? 0 : toInteger(start);
                    end = end === undefined ? length : toInteger(end);
                }
                return baseSlice(array, start, end);
            }
            function sortedIndex(array, value) {
                return baseSortedIndex(array, value);
            }
            function sortedIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
            }
            function sortedIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value);
                    if (index < length && eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedLastIndex(array, value) {
                return baseSortedIndex(array, value, true);
            }
            function sortedLastIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
            }
            function sortedLastIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value, true) - 1;
                    if (eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedUniq(array) {
                return array && array.length ? baseSortedUniq(array) : [];
            }
            function sortedUniqBy(array, iteratee) {
                return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function tail(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 1, length) : [];
            }
            function take(array, n, guard) {
                if (!(array && array.length)) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function takeRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function takeRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
            }
            function takeWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
            }
            var union = baseRest(function(arrays) {
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
            });
            var unionBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
            });
            var unionWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
            });
            function uniq(array) {
                return array && array.length ? baseUniq(array) : [];
            }
            function uniqBy(array, iteratee) {
                return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function uniqWith(array, comparator) {
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return array && array.length ? baseUniq(array, undefined, comparator) : [];
            }
            function unzip(array) {
                if (!(array && array.length)) return [];
                var length = 0;
                array = arrayFilter(array, function(group) {
                    if (isArrayLikeObject(group)) {
                        length = nativeMax(group.length, length);
                        return true;
                    }
                });
                return baseTimes(length, function(index) {
                    return arrayMap(array, baseProperty(index));
                });
            }
            function unzipWith(array, iteratee) {
                if (!(array && array.length)) return [];
                var result = unzip(array);
                if (iteratee == null) return result;
                return arrayMap(result, function(group) {
                    return apply(iteratee, undefined, group);
                });
            }
            var without = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, values) : [];
            });
            var xor = baseRest(function(arrays) {
                return baseXor(arrayFilter(arrays, isArrayLikeObject));
            });
            var xorBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
            });
            var xorWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
            });
            var zip = baseRest(unzip);
            function zipObject(props, values) {
                return baseZipObject(props || [], values || [], assignValue);
            }
            function zipObjectDeep(props, values) {
                return baseZipObject(props || [], values || [], baseSet);
            }
            var zipWith = baseRest(function(arrays) {
                var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
                iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
                return unzipWith(arrays, iteratee);
            });
            function chain(value) {
                var result = lodash(value);
                result.__chain__ = true;
                return result;
            }
            function tap(value, interceptor) {
                interceptor(value);
                return value;
            }
            function thru(value, interceptor) {
                return interceptor(value);
            }
            var wrapperAt = flatRest(function(paths) {
                var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                    return baseAt(object, paths);
                };
                if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
                value = value.slice(start, +start + (length ? 1 : 0));
                value.__actions__.push({
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(value, this.__chain__).thru(function(array) {
                    if (length && !array.length) array.push(undefined);
                    return array;
                });
            });
            function wrapperChain() {
                return chain(this);
            }
            function wrapperCommit() {
                return new LodashWrapper(this.value(), this.__chain__);
            }
            function wrapperNext() {
                if (this.__values__ === undefined) this.__values__ = toArray(this.value());
                var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
                return {
                    'done': done,
                    'value': value
                };
            }
            function wrapperToIterator() {
                return this;
            }
            function wrapperPlant(value) {
                var result, parent = this;
                while(parent instanceof baseLodash){
                    var clone = wrapperClone(parent);
                    clone.__index__ = 0;
                    clone.__values__ = undefined;
                    if (result) previous.__wrapped__ = clone;
                    else result = clone;
                    var previous = clone;
                    parent = parent.__wrapped__;
                }
                previous.__wrapped__ = value;
                return result;
            }
            function wrapperReverse() {
                var value = this.__wrapped__;
                if (value instanceof LazyWrapper) {
                    var wrapped = value;
                    if (this.__actions__.length) wrapped = new LazyWrapper(this);
                    wrapped = wrapped.reverse();
                    wrapped.__actions__.push({
                        'func': thru,
                        'args': [
                            reverse
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(wrapped, this.__chain__);
                }
                return this.thru(reverse);
            }
            function wrapperValue() {
                return baseWrapperValue(this.__wrapped__, this.__actions__);
            }
            var countBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) ++result[key];
                else baseAssignValue(result, key, 1);
            });
            function every(collection, predicate, guard) {
                var func = isArray(collection) ? arrayEvery : baseEvery;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            function filter(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, getIteratee(predicate, 3));
            }
            var find = createFind(findIndex);
            var findLast = createFind(findLastIndex);
            function flatMap(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), 1);
            }
            function flatMapDeep(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), INFINITY);
            }
            function flatMapDepth(collection, iteratee, depth) {
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(map(collection, iteratee), depth);
            }
            function forEach(collection, iteratee) {
                var func = isArray(collection) ? arrayEach : baseEach;
                return func(collection, getIteratee(iteratee, 3));
            }
            function forEachRight(collection, iteratee) {
                var func = isArray(collection) ? arrayEachRight : baseEachRight;
                return func(collection, getIteratee(iteratee, 3));
            }
            var groupBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) result[key].push(value);
                else baseAssignValue(result, key, [
                    value
                ]);
            });
            function includes(collection, value, fromIndex, guard) {
                collection = isArrayLike(collection) ? collection : values(collection);
                fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
                var length = collection.length;
                if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
                return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
            }
            var invokeMap = baseRest(function(collection, path, args) {
                var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value) {
                    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
                });
                return result;
            });
            var keyBy = createAggregator(function(result, value, key) {
                baseAssignValue(result, key, value);
            });
            function map(collection, iteratee) {
                var func = isArray(collection) ? arrayMap : baseMap;
                return func(collection, getIteratee(iteratee, 3));
            }
            function orderBy(collection, iteratees, orders, guard) {
                if (collection == null) return [];
                if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                    iteratees
                ];
                orders = guard ? undefined : orders;
                if (!isArray(orders)) orders = orders == null ? [] : [
                    orders
                ];
                return baseOrderBy(collection, iteratees, orders);
            }
            var partition = createAggregator(function(result, value, key) {
                result[key ? 0 : 1].push(value);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function reduce(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
            }
            function reduceRight(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
            }
            function reject(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, negate(getIteratee(predicate, 3)));
            }
            function sample(collection) {
                var func = isArray(collection) ? arraySample : baseSample;
                return func(collection);
            }
            function sampleSize(collection, n, guard) {
                if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                var func = isArray(collection) ? arraySampleSize : baseSampleSize;
                return func(collection, n);
            }
            function shuffle(collection) {
                var func = isArray(collection) ? arrayShuffle : baseShuffle;
                return func(collection);
            }
            function size(collection) {
                if (collection == null) return 0;
                if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
                var tag = getTag(collection);
                if (tag == mapTag || tag == setTag) return collection.size;
                return baseKeys(collection).length;
            }
            function some(collection, predicate, guard) {
                var func = isArray(collection) ? arraySome : baseSome;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            var sortBy = baseRest(function(collection, iteratees) {
                if (collection == null) return [];
                var length = iteratees.length;
                if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
                else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                    iteratees[0]
                ];
                return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
            });
            var now = ctxNow || function() {
                return root.Date.now();
            };
            function after(n, func) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n < 1) return func.apply(this, arguments);
                };
            }
            function ary(func, n, guard) {
                n = guard ? undefined : n;
                n = func && n == null ? func.length : n;
                return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
            }
            function before(n, func) {
                var result;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n > 0) result = func.apply(this, arguments);
                    if (n <= 1) func = undefined;
                    return result;
                };
            }
            var bind = baseRest(function(func, thisArg, partials) {
                var bitmask = WRAP_BIND_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bind));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(func, bitmask, thisArg, partials, holders);
            });
            var bindKey = baseRest(function(object, key, partials) {
                var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bindKey));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(key, bitmask, object, partials, holders);
            });
            function curry(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curry.placeholder;
                return result;
            }
            function curryRight(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryRight.placeholder;
                return result;
            }
            function debounce(func, wait, options) {
                var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                wait = toNumber(wait) || 0;
                if (isObject(options)) {
                    leading = !!options.leading;
                    maxing = 'maxWait' in options;
                    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                function invokeFunc(time) {
                    var args = lastArgs, thisArg = lastThis;
                    lastArgs = lastThis = undefined;
                    lastInvokeTime = time;
                    result = func.apply(thisArg, args);
                    return result;
                }
                function leadingEdge(time) {
                    lastInvokeTime = time;
                    timerId = setTimeout(timerExpired, wait);
                    return leading ? invokeFunc(time) : result;
                }
                function remainingWait(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
                }
                function shouldInvoke(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                }
                function timerExpired() {
                    var time = now();
                    if (shouldInvoke(time)) return trailingEdge(time);
                    timerId = setTimeout(timerExpired, remainingWait(time));
                }
                function trailingEdge(time) {
                    timerId = undefined;
                    if (trailing && lastArgs) return invokeFunc(time);
                    lastArgs = lastThis = undefined;
                    return result;
                }
                function cancel() {
                    if (timerId !== undefined) clearTimeout(timerId);
                    lastInvokeTime = 0;
                    lastArgs = lastCallTime = lastThis = timerId = undefined;
                }
                function flush() {
                    return timerId === undefined ? result : trailingEdge(now());
                }
                function debounced() {
                    var time = now(), isInvoking = shouldInvoke(time);
                    lastArgs = arguments;
                    lastThis = this;
                    lastCallTime = time;
                    if (isInvoking) {
                        if (timerId === undefined) return leadingEdge(lastCallTime);
                        if (maxing) {
                            clearTimeout(timerId);
                            timerId = setTimeout(timerExpired, wait);
                            return invokeFunc(lastCallTime);
                        }
                    }
                    if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                    return result;
                }
                debounced.cancel = cancel;
                debounced.flush = flush;
                return debounced;
            }
            var defer = baseRest(function(func, args) {
                return baseDelay(func, 1, args);
            });
            var delay = baseRest(function(func, wait, args) {
                return baseDelay(func, toNumber(wait) || 0, args);
            });
            function flip(func) {
                return createWrap(func, WRAP_FLIP_FLAG);
            }
            function memoize(func, resolver) {
                if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var memoized = function() {
                    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                    if (cache.has(key)) return cache.get(key);
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result) || cache;
                    return result;
                };
                memoized.cache = new (memoize.Cache || MapCache);
                return memoized;
            }
            memoize.Cache = MapCache;
            function negate(predicate) {
                if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return !predicate.call(this);
                        case 1:
                            return !predicate.call(this, args[0]);
                        case 2:
                            return !predicate.call(this, args[0], args[1]);
                        case 3:
                            return !predicate.call(this, args[0], args[1], args[2]);
                    }
                    return !predicate.apply(this, args);
                };
            }
            function once(func) {
                return before(2, func);
            }
            var overArgs = castRest(function(func, transforms) {
                transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
                var funcsLength = transforms.length;
                return baseRest(function(args) {
                    var index = -1, length = nativeMin(args.length, funcsLength);
                    while(++index < length)args[index] = transforms[index].call(this, args[index]);
                    return apply(func, this, args);
                });
            });
            var partial = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partial));
                return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
            });
            var partialRight = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partialRight));
                return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
            });
            var rearg = flatRest(function(func, indexes) {
                return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
            });
            function rest(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start === undefined ? start : toInteger(start);
                return baseRest(func, start);
            }
            function spread(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start == null ? 0 : nativeMax(toInteger(start), 0);
                return baseRest(function(args) {
                    var array = args[start], otherArgs = castSlice(args, 0, start);
                    if (array) arrayPush(otherArgs, array);
                    return apply(func, this, otherArgs);
                });
            }
            function throttle(func, wait, options) {
                var leading = true, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                if (isObject(options)) {
                    leading = 'leading' in options ? !!options.leading : leading;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                return debounce(func, wait, {
                    'leading': leading,
                    'maxWait': wait,
                    'trailing': trailing
                });
            }
            function unary(func) {
                return ary(func, 1);
            }
            function wrap(value, wrapper) {
                return partial(castFunction(wrapper), value);
            }
            function castArray() {
                if (!arguments.length) return [];
                var value = arguments[0];
                return isArray(value) ? value : [
                    value
                ];
            }
            function clone(value) {
                return baseClone(value, CLONE_SYMBOLS_FLAG);
            }
            function cloneWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
            }
            function cloneDeep(value) {
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
            }
            function cloneDeepWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
            }
            function conformsTo(object, source) {
                return source == null || baseConformsTo(object, source, keys(source));
            }
            function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            var gt = createRelationalOperation(baseGt);
            var gte = createRelationalOperation(function(value, other) {
                return value >= other;
            });
            var isArguments = baseIsArguments(function() {
                return arguments;
            }()) ? baseIsArguments : function(value) {
                return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
            };
            var isArray = Array1.isArray;
            var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
            function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
            }
            function isArrayLikeObject(value) {
                return isObjectLike(value) && isArrayLike(value);
            }
            function isBoolean(value) {
                return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
            }
            var isBuffer = nativeIsBuffer || stubFalse;
            var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
            function isElement(value) {
                return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
            }
            function isEmpty(value) {
                if (value == null) return true;
                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
                var tag = getTag(value);
                if (tag == mapTag || tag == setTag) return !value.size;
                if (isPrototype(value)) return !baseKeys(value).length;
                for(var key in value){
                    if (hasOwnProperty.call(value, key)) return false;
                }
                return true;
            }
            function isEqual(value, other) {
                return baseIsEqual(value, other);
            }
            function isEqualWith(value, other, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                var result = customizer ? customizer(value, other) : undefined;
                return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
            }
            function isError(value) {
                if (!isObjectLike(value)) return false;
                var tag = baseGetTag(value);
                return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
            }
            function isFinite(value) {
                return typeof value == 'number' && nativeIsFinite(value);
            }
            function isFunction(value) {
                if (!isObject(value)) return false;
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            function isInteger(value) {
                return typeof value == 'number' && value == toInteger(value);
            }
            function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
            }
            function isObjectLike(value) {
                return value != null && typeof value == 'object';
            }
            var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
            function isMatch(object, source) {
                return object === source || baseIsMatch(object, source, getMatchData(source));
            }
            function isMatchWith(object, source, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseIsMatch(object, source, getMatchData(source), customizer);
            }
            function isNaN(value) {
                return isNumber(value) && value != +value;
            }
            function isNative(value) {
                if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
                return baseIsNative(value);
            }
            function isNull(value) {
                return value === null;
            }
            function isNil(value) {
                return value == null;
            }
            function isNumber(value) {
                return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
            }
            function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
                var proto = getPrototype(value);
                if (proto === null) return true;
                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
            function isSafeInteger(value) {
                return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
            }
            var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
            function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            function isSymbol(value) {
                return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
            }
            var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
            function isUndefined(value) {
                return value === undefined;
            }
            function isWeakMap(value) {
                return isObjectLike(value) && getTag(value) == weakMapTag;
            }
            function isWeakSet(value) {
                return isObjectLike(value) && baseGetTag(value) == weakSetTag;
            }
            var lt = createRelationalOperation(baseLt);
            var lte = createRelationalOperation(function(value, other) {
                return value <= other;
            });
            function toArray(value) {
                if (!value) return [];
                if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
                if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
                var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
                return func(value);
            }
            function toFinite(value) {
                if (!value) return value === 0 ? value : 0;
                value = toNumber(value);
                if (value === INFINITY || value === -INFINITY) {
                    var sign = value < 0 ? -1 : 1;
                    return sign * MAX_INTEGER;
                }
                return value === value ? value : 0;
            }
            function toInteger(value) {
                var result = toFinite(value), remainder = result % 1;
                return result === result ? remainder ? result - remainder : result : 0;
            }
            function toLength(value) {
                return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
            }
            function toNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                if (isObject(value)) {
                    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                    value = isObject(other) ? other + '' : other;
                }
                if (typeof value != 'string') return value === 0 ? value : +value;
                value = baseTrim(value);
                var isBinary = reIsBinary.test(value);
                return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
            }
            function toPlainObject(value) {
                return copyObject(value, keysIn(value));
            }
            function toSafeInteger(value) {
                return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
            }
            function toString(value) {
                return value == null ? '' : baseToString(value);
            }
            var assign = createAssigner(function(object, source) {
                if (isPrototype(source) || isArrayLike(source)) {
                    copyObject(source, keys(source), object);
                    return;
                }
                for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
            });
            var assignIn = createAssigner(function(object, source) {
                copyObject(source, keysIn(source), object);
            });
            var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keysIn(source), object, customizer);
            });
            var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keys(source), object, customizer);
            });
            var at = flatRest(baseAt);
            function create(prototype, properties) {
                var result = baseCreate(prototype);
                return properties == null ? result : baseAssign(result, properties);
            }
            var defaults = baseRest(function(object, sources) {
                object = Object1(object);
                var index = -1;
                var length = sources.length;
                var guard = length > 2 ? sources[2] : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
                while(++index < length){
                    var source = sources[index];
                    var props = keysIn(source);
                    var propsIndex = -1;
                    var propsLength = props.length;
                    while(++propsIndex < propsLength){
                        var key = props[propsIndex];
                        var value = object[key];
                        if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                    }
                }
                return object;
            });
            var defaultsDeep = baseRest(function(args) {
                args.push(undefined, customDefaultsMerge);
                return apply(mergeWith, undefined, args);
            });
            function findKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
            }
            function findLastKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
            }
            function forIn(object, iteratee) {
                return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
            }
            function forInRight(object, iteratee) {
                return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
            }
            function forOwn(object, iteratee) {
                return object && baseForOwn(object, getIteratee(iteratee, 3));
            }
            function forOwnRight(object, iteratee) {
                return object && baseForOwnRight(object, getIteratee(iteratee, 3));
            }
            function functions(object) {
                return object == null ? [] : baseFunctions(object, keys(object));
            }
            function functionsIn(object) {
                return object == null ? [] : baseFunctions(object, keysIn(object));
            }
            function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
            }
            function has(object, path) {
                return object != null && hasPath(object, path, baseHas);
            }
            function hasIn(object, path) {
                return object != null && hasPath(object, path, baseHasIn);
            }
            var invert = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                result[value] = key;
            }, constant(identity));
            var invertBy = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                if (hasOwnProperty.call(result, value)) result[value].push(key);
                else result[value] = [
                    key
                ];
            }, getIteratee);
            var invoke = baseRest(baseInvoke);
            function keys(object) {
                return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
            }
            function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
            }
            function mapKeys(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, iteratee(value, key, object), value);
                });
                return result;
            }
            function mapValues(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, key, iteratee(value, key, object));
                });
                return result;
            }
            var merge = createAssigner(function(object, source, srcIndex) {
                baseMerge(object, source, srcIndex);
            });
            var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
                baseMerge(object, source, srcIndex, customizer);
            });
            var omit = flatRest(function(object, paths) {
                var result = {};
                if (object == null) return result;
                var isDeep = false;
                paths = arrayMap(paths, function(path) {
                    path = castPath(path, object);
                    isDeep || (isDeep = path.length > 1);
                    return path;
                });
                copyObject(object, getAllKeysIn(object), result);
                if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                var length = paths.length;
                while(length--)baseUnset(result, paths[length]);
                return result;
            });
            function omitBy(object, predicate) {
                return pickBy(object, negate(getIteratee(predicate)));
            }
            var pick = flatRest(function(object, paths) {
                return object == null ? {} : basePick(object, paths);
            });
            function pickBy(object, predicate) {
                if (object == null) return {};
                var props = arrayMap(getAllKeysIn(object), function(prop) {
                    return [
                        prop
                    ];
                });
                predicate = getIteratee(predicate);
                return basePickBy(object, props, function(value, path) {
                    return predicate(value, path[0]);
                });
            }
            function result(object, path, defaultValue) {
                path = castPath(path, object);
                var index = -1, length = path.length;
                if (!length) {
                    length = 1;
                    object = undefined;
                }
                while(++index < length){
                    var value = object == null ? undefined : object[toKey(path[index])];
                    if (value === undefined) {
                        index = length;
                        value = defaultValue;
                    }
                    object = isFunction(value) ? value.call(object) : value;
                }
                return object;
            }
            function set(object, path, value) {
                return object == null ? object : baseSet(object, path, value);
            }
            function setWith(object, path, value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseSet(object, path, value, customizer);
            }
            var toPairs = createToPairs(keys);
            var toPairsIn = createToPairs(keysIn);
            function transform(object, iteratee, accumulator) {
                var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
                iteratee = getIteratee(iteratee, 4);
                if (accumulator == null) {
                    var Ctor = object && object.constructor;
                    if (isArrLike) accumulator = isArr ? new Ctor : [];
                    else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                    else accumulator = {};
                }
                (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                    return iteratee(accumulator, value, index, object);
                });
                return accumulator;
            }
            function unset(object, path) {
                return object == null ? true : baseUnset(object, path);
            }
            function update(object, path, updater) {
                return object == null ? object : baseUpdate(object, path, castFunction(updater));
            }
            function updateWith(object, path, updater, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
            }
            function values(object) {
                return object == null ? [] : baseValues(object, keys(object));
            }
            function valuesIn(object) {
                return object == null ? [] : baseValues(object, keysIn(object));
            }
            function clamp(number, lower, upper) {
                if (upper === undefined) {
                    upper = lower;
                    lower = undefined;
                }
                if (upper !== undefined) {
                    upper = toNumber(upper);
                    upper = upper === upper ? upper : 0;
                }
                if (lower !== undefined) {
                    lower = toNumber(lower);
                    lower = lower === lower ? lower : 0;
                }
                return baseClamp(toNumber(number), lower, upper);
            }
            function inRange(number, start, end) {
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                number = toNumber(number);
                return baseInRange(number, start, end);
            }
            function random(lower, upper, floating) {
                if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
                if (floating === undefined) {
                    if (typeof upper == 'boolean') {
                        floating = upper;
                        upper = undefined;
                    } else if (typeof lower == 'boolean') {
                        floating = lower;
                        lower = undefined;
                    }
                }
                if (lower === undefined && upper === undefined) {
                    lower = 0;
                    upper = 1;
                } else {
                    lower = toFinite(lower);
                    if (upper === undefined) {
                        upper = lower;
                        lower = 0;
                    } else upper = toFinite(upper);
                }
                if (lower > upper) {
                    var temp = lower;
                    lower = upper;
                    upper = temp;
                }
                if (floating || lower % 1 || upper % 1) {
                    var rand = nativeRandom();
                    return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
                }
                return baseRandom(lower, upper);
            }
            var camelCase = createCompounder(function(result, word, index) {
                word = word.toLowerCase();
                return result + (index ? capitalize(word) : word);
            });
            function capitalize(string) {
                return upperFirst(toString(string).toLowerCase());
            }
            function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
            }
            function endsWith(string, target, position) {
                string = toString(string);
                target = baseToString(target);
                var length = string.length;
                position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
                var end = position;
                position -= target.length;
                return position >= 0 && string.slice(position, end) == target;
            }
            function escape(string) {
                string = toString(string);
                return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
            }
            function escapeRegExp(string) {
                string = toString(string);
                return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
            }
            var kebabCase = createCompounder(function(result, word, index) {
                return result + (index ? '-' : '') + word.toLowerCase();
            });
            var lowerCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toLowerCase();
            });
            var lowerFirst = createCaseFirst('toLowerCase');
            function pad(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                if (!length || strLength >= length) return string;
                var mid = (length - strLength) / 2;
                return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
            }
            function padEnd(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
            }
            function padStart(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
            }
            function parseInt1(string, radix, guard) {
                if (guard || radix == null) radix = 0;
                else if (radix) radix = +radix;
                return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
            }
            function repeat(string, n, guard) {
                if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                return baseRepeat(toString(string), n);
            }
            function replace() {
                var args = arguments, string = toString(args[0]);
                return args.length < 3 ? string : string.replace(args[1], args[2]);
            }
            var snakeCase = createCompounder(function(result, word, index) {
                return result + (index ? '_' : '') + word.toLowerCase();
            });
            function split(string, separator, limit) {
                if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
                limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
                if (!limit) return [];
                string = toString(string);
                if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                    separator = baseToString(separator);
                    if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
                }
                return string.split(separator, limit);
            }
            var startCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + upperFirst(word);
            });
            function startsWith(string, target, position) {
                string = toString(string);
                position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
                target = baseToString(target);
                return string.slice(position, position + target.length) == target;
            }
            function template(string, options, guard) {
                var settings = lodash.templateSettings;
                if (guard && isIterateeCall(string, options, guard)) options = undefined;
                string = toString(string);
                options = assignInWith({}, options, settings, customDefaultsAssignIn);
                var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
                var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
                var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
                var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
                string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                    interpolateValue || (interpolateValue = esTemplateValue);
                    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                    if (escapeValue) {
                        isEscaping = true;
                        source += "' +\n__e(" + escapeValue + ") +\n'";
                    }
                    if (evaluateValue) {
                        isEvaluating = true;
                        source += "';\n" + evaluateValue + ";\n__p += '";
                    }
                    if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                    index = offset + match.length;
                    return match;
                });
                source += "';\n";
                var variable = hasOwnProperty.call(options, 'variable') && options.variable;
                if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
                else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
                source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
                source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
                var result = attempt(function() {
                    return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
                });
                result.source = source;
                if (isError(result)) throw result;
                return result;
            }
            function toLower(value) {
                return toString(value).toLowerCase();
            }
            function toUpper(value) {
                return toString(value).toUpperCase();
            }
            function trim(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return baseTrim(string);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
                return castSlice(strSymbols, start, end).join('');
            }
            function trimEnd(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
                return castSlice(strSymbols, 0, end).join('');
            }
            function trimStart(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
                return castSlice(strSymbols, start).join('');
            }
            function truncate(string, options) {
                var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
                if (isObject(options)) {
                    var separator = 'separator' in options ? options.separator : separator;
                    length = 'length' in options ? toInteger(options.length) : length;
                    omission = 'omission' in options ? baseToString(options.omission) : omission;
                }
                string = toString(string);
                var strLength = string.length;
                if (hasUnicode(string)) {
                    var strSymbols = stringToArray(string);
                    strLength = strSymbols.length;
                }
                if (length >= strLength) return string;
                var end = length - stringSize(omission);
                if (end < 1) return omission;
                var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
                if (separator === undefined) return result + omission;
                if (strSymbols) end += result.length - end;
                if (isRegExp(separator)) {
                    if (string.slice(end).search(separator)) {
                        var match, substring = result;
                        if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                        separator.lastIndex = 0;
                        while(match = separator.exec(substring))var newEnd = match.index;
                        result = result.slice(0, newEnd === undefined ? end : newEnd);
                    }
                } else if (string.indexOf(baseToString(separator), end) != end) {
                    var index = result.lastIndexOf(separator);
                    if (index > -1) result = result.slice(0, index);
                }
                return result + omission;
            }
            function unescape(string) {
                string = toString(string);
                return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
            }
            var upperCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toUpperCase();
            });
            var upperFirst = createCaseFirst('toUpperCase');
            function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;
                if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                return string.match(pattern) || [];
            }
            var attempt = baseRest(function(func, args) {
                try {
                    return apply(func, undefined, args);
                } catch (e) {
                    return isError(e) ? e : new Error(e);
                }
            });
            var bindAll = flatRest(function(object, methodNames) {
                arrayEach(methodNames, function(key) {
                    key = toKey(key);
                    baseAssignValue(object, key, bind(object[key], object));
                });
                return object;
            });
            function cond(pairs) {
                var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
                pairs = !length ? [] : arrayMap(pairs, function(pair) {
                    if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    return [
                        toIteratee(pair[0]),
                        pair[1]
                    ];
                });
                return baseRest(function(args) {
                    var index = -1;
                    while(++index < length){
                        var pair = pairs[index];
                        if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                    }
                });
            }
            function conforms(source) {
                return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
            }
            function constant(value) {
                return function() {
                    return value;
                };
            }
            function defaultTo(value, defaultValue) {
                return value == null || value !== value ? defaultValue : value;
            }
            var flow = createFlow();
            var flowRight = createFlow(true);
            function identity(value) {
                return value;
            }
            function iteratee(func) {
                return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
            }
            function matches(source) {
                return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
            }
            function matchesProperty(path, srcValue) {
                return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
            }
            var method = baseRest(function(path, args) {
                return function(object) {
                    return baseInvoke(object, path, args);
                };
            });
            var methodOf = baseRest(function(object, args) {
                return function(path) {
                    return baseInvoke(object, path, args);
                };
            });
            function mixin(object, source, options) {
                var props = keys(source), methodNames = baseFunctions(source, props);
                if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                    options = source;
                    source = object;
                    object = this;
                    methodNames = baseFunctions(source, keys(source));
                }
                var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
                arrayEach(methodNames, function(methodName) {
                    var func = source[methodName];
                    object[methodName] = func;
                    if (isFunc) object.prototype[methodName] = function() {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                            actions.push({
                                'func': func,
                                'args': arguments,
                                'thisArg': object
                            });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([
                            this.value()
                        ], arguments));
                    };
                });
                return object;
            }
            function noConflict() {
                if (root._ === this) root._ = oldDash;
                return this;
            }
            function noop() {}
            function nthArg(n) {
                n = toInteger(n);
                return baseRest(function(args) {
                    return baseNth(args, n);
                });
            }
            var over = createOver(arrayMap);
            var overEvery = createOver(arrayEvery);
            var overSome = createOver(arraySome);
            function property(path) {
                return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
            }
            function propertyOf(object) {
                return function(path) {
                    return object == null ? undefined : baseGet(object, path);
                };
            }
            var range = createRange();
            var rangeRight = createRange(true);
            function stubArray() {
                return [];
            }
            function stubFalse() {
                return false;
            }
            function stubObject() {
                return {};
            }
            function stubString() {
                return '';
            }
            function stubTrue() {
                return true;
            }
            function times(n, iteratee) {
                n = toInteger(n);
                if (n < 1 || n > MAX_SAFE_INTEGER) return [];
                var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
                iteratee = getIteratee(iteratee);
                n -= MAX_ARRAY_LENGTH;
                var result = baseTimes(length, iteratee);
                while(++index < n)iteratee(index);
                return result;
            }
            function toPath(value) {
                if (isArray(value)) return arrayMap(value, toKey);
                return isSymbol(value) ? [
                    value
                ] : copyArray(stringToPath(toString(value)));
            }
            function uniqueId(prefix) {
                var id = ++idCounter;
                return toString(prefix) + id;
            }
            var add = createMathOperation(function(augend, addend) {
                return augend + addend;
            }, 0);
            var ceil = createRound('ceil');
            var divide = createMathOperation(function(dividend, divisor) {
                return dividend / divisor;
            }, 1);
            var floor = createRound('floor');
            function max(array) {
                return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
            }
            function maxBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
            }
            function mean(array) {
                return baseMean(array, identity);
            }
            function meanBy(array, iteratee) {
                return baseMean(array, getIteratee(iteratee, 2));
            }
            function min(array) {
                return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
            }
            function minBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
            }
            var multiply = createMathOperation(function(multiplier, multiplicand) {
                return multiplier * multiplicand;
            }, 1);
            var round = createRound('round');
            var subtract = createMathOperation(function(minuend, subtrahend) {
                return minuend - subtrahend;
            }, 0);
            function sum(array) {
                return array && array.length ? baseSum(array, identity) : 0;
            }
            function sumBy(array, iteratee) {
                return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
            }
            lodash.after = after;
            lodash.ary = ary;
            lodash.assign = assign;
            lodash.assignIn = assignIn;
            lodash.assignInWith = assignInWith;
            lodash.assignWith = assignWith;
            lodash.at = at;
            lodash.before = before;
            lodash.bind = bind;
            lodash.bindAll = bindAll;
            lodash.bindKey = bindKey;
            lodash.castArray = castArray;
            lodash.chain = chain;
            lodash.chunk = chunk;
            lodash.compact = compact;
            lodash.concat = concat;
            lodash.cond = cond;
            lodash.conforms = conforms;
            lodash.constant = constant;
            lodash.countBy = countBy;
            lodash.create = create;
            lodash.curry = curry;
            lodash.curryRight = curryRight;
            lodash.debounce = debounce;
            lodash.defaults = defaults;
            lodash.defaultsDeep = defaultsDeep;
            lodash.defer = defer;
            lodash.delay = delay;
            lodash.difference = difference;
            lodash.differenceBy = differenceBy;
            lodash.differenceWith = differenceWith;
            lodash.drop = drop;
            lodash.dropRight = dropRight;
            lodash.dropRightWhile = dropRightWhile;
            lodash.dropWhile = dropWhile;
            lodash.fill = fill;
            lodash.filter = filter;
            lodash.flatMap = flatMap;
            lodash.flatMapDeep = flatMapDeep;
            lodash.flatMapDepth = flatMapDepth;
            lodash.flatten = flatten;
            lodash.flattenDeep = flattenDeep;
            lodash.flattenDepth = flattenDepth;
            lodash.flip = flip;
            lodash.flow = flow;
            lodash.flowRight = flowRight;
            lodash.fromPairs = fromPairs;
            lodash.functions = functions;
            lodash.functionsIn = functionsIn;
            lodash.groupBy = groupBy;
            lodash.initial = initial;
            lodash.intersection = intersection;
            lodash.intersectionBy = intersectionBy;
            lodash.intersectionWith = intersectionWith;
            lodash.invert = invert;
            lodash.invertBy = invertBy;
            lodash.invokeMap = invokeMap;
            lodash.iteratee = iteratee;
            lodash.keyBy = keyBy;
            lodash.keys = keys;
            lodash.keysIn = keysIn;
            lodash.map = map;
            lodash.mapKeys = mapKeys;
            lodash.mapValues = mapValues;
            lodash.matches = matches;
            lodash.matchesProperty = matchesProperty;
            lodash.memoize = memoize;
            lodash.merge = merge;
            lodash.mergeWith = mergeWith;
            lodash.method = method;
            lodash.methodOf = methodOf;
            lodash.mixin = mixin;
            lodash.negate = negate;
            lodash.nthArg = nthArg;
            lodash.omit = omit;
            lodash.omitBy = omitBy;
            lodash.once = once;
            lodash.orderBy = orderBy;
            lodash.over = over;
            lodash.overArgs = overArgs;
            lodash.overEvery = overEvery;
            lodash.overSome = overSome;
            lodash.partial = partial;
            lodash.partialRight = partialRight;
            lodash.partition = partition;
            lodash.pick = pick;
            lodash.pickBy = pickBy;
            lodash.property = property;
            lodash.propertyOf = propertyOf;
            lodash.pull = pull;
            lodash.pullAll = pullAll;
            lodash.pullAllBy = pullAllBy;
            lodash.pullAllWith = pullAllWith;
            lodash.pullAt = pullAt;
            lodash.range = range;
            lodash.rangeRight = rangeRight;
            lodash.rearg = rearg;
            lodash.reject = reject;
            lodash.remove = remove;
            lodash.rest = rest;
            lodash.reverse = reverse;
            lodash.sampleSize = sampleSize;
            lodash.set = set;
            lodash.setWith = setWith;
            lodash.shuffle = shuffle;
            lodash.slice = slice;
            lodash.sortBy = sortBy;
            lodash.sortedUniq = sortedUniq;
            lodash.sortedUniqBy = sortedUniqBy;
            lodash.split = split;
            lodash.spread = spread;
            lodash.tail = tail;
            lodash.take = take;
            lodash.takeRight = takeRight;
            lodash.takeRightWhile = takeRightWhile;
            lodash.takeWhile = takeWhile;
            lodash.tap = tap;
            lodash.throttle = throttle;
            lodash.thru = thru;
            lodash.toArray = toArray;
            lodash.toPairs = toPairs;
            lodash.toPairsIn = toPairsIn;
            lodash.toPath = toPath;
            lodash.toPlainObject = toPlainObject;
            lodash.transform = transform;
            lodash.unary = unary;
            lodash.union = union;
            lodash.unionBy = unionBy;
            lodash.unionWith = unionWith;
            lodash.uniq = uniq;
            lodash.uniqBy = uniqBy;
            lodash.uniqWith = uniqWith;
            lodash.unset = unset;
            lodash.unzip = unzip;
            lodash.unzipWith = unzipWith;
            lodash.update = update;
            lodash.updateWith = updateWith;
            lodash.values = values;
            lodash.valuesIn = valuesIn;
            lodash.without = without;
            lodash.words = words;
            lodash.wrap = wrap;
            lodash.xor = xor;
            lodash.xorBy = xorBy;
            lodash.xorWith = xorWith;
            lodash.zip = zip;
            lodash.zipObject = zipObject;
            lodash.zipObjectDeep = zipObjectDeep;
            lodash.zipWith = zipWith;
            lodash.entries = toPairs;
            lodash.entriesIn = toPairsIn;
            lodash.extend = assignIn;
            lodash.extendWith = assignInWith;
            mixin(lodash, lodash);
            lodash.add = add;
            lodash.attempt = attempt;
            lodash.camelCase = camelCase;
            lodash.capitalize = capitalize;
            lodash.ceil = ceil;
            lodash.clamp = clamp;
            lodash.clone = clone;
            lodash.cloneDeep = cloneDeep;
            lodash.cloneDeepWith = cloneDeepWith;
            lodash.cloneWith = cloneWith;
            lodash.conformsTo = conformsTo;
            lodash.deburr = deburr;
            lodash.defaultTo = defaultTo;
            lodash.divide = divide;
            lodash.endsWith = endsWith;
            lodash.eq = eq;
            lodash.escape = escape;
            lodash.escapeRegExp = escapeRegExp;
            lodash.every = every;
            lodash.find = find;
            lodash.findIndex = findIndex;
            lodash.findKey = findKey;
            lodash.findLast = findLast;
            lodash.findLastIndex = findLastIndex;
            lodash.findLastKey = findLastKey;
            lodash.floor = floor;
            lodash.forEach = forEach;
            lodash.forEachRight = forEachRight;
            lodash.forIn = forIn;
            lodash.forInRight = forInRight;
            lodash.forOwn = forOwn;
            lodash.forOwnRight = forOwnRight;
            lodash.get = get;
            lodash.gt = gt;
            lodash.gte = gte;
            lodash.has = has;
            lodash.hasIn = hasIn;
            lodash.head = head;
            lodash.identity = identity;
            lodash.includes = includes;
            lodash.indexOf = indexOf;
            lodash.inRange = inRange;
            lodash.invoke = invoke;
            lodash.isArguments = isArguments;
            lodash.isArray = isArray;
            lodash.isArrayBuffer = isArrayBuffer;
            lodash.isArrayLike = isArrayLike;
            lodash.isArrayLikeObject = isArrayLikeObject;
            lodash.isBoolean = isBoolean;
            lodash.isBuffer = isBuffer;
            lodash.isDate = isDate;
            lodash.isElement = isElement;
            lodash.isEmpty = isEmpty;
            lodash.isEqual = isEqual;
            lodash.isEqualWith = isEqualWith;
            lodash.isError = isError;
            lodash.isFinite = isFinite;
            lodash.isFunction = isFunction;
            lodash.isInteger = isInteger;
            lodash.isLength = isLength;
            lodash.isMap = isMap;
            lodash.isMatch = isMatch;
            lodash.isMatchWith = isMatchWith;
            lodash.isNaN = isNaN;
            lodash.isNative = isNative;
            lodash.isNil = isNil;
            lodash.isNull = isNull;
            lodash.isNumber = isNumber;
            lodash.isObject = isObject;
            lodash.isObjectLike = isObjectLike;
            lodash.isPlainObject = isPlainObject;
            lodash.isRegExp = isRegExp;
            lodash.isSafeInteger = isSafeInteger;
            lodash.isSet = isSet;
            lodash.isString = isString;
            lodash.isSymbol = isSymbol;
            lodash.isTypedArray = isTypedArray;
            lodash.isUndefined = isUndefined;
            lodash.isWeakMap = isWeakMap;
            lodash.isWeakSet = isWeakSet;
            lodash.join = join;
            lodash.kebabCase = kebabCase;
            lodash.last = last;
            lodash.lastIndexOf = lastIndexOf;
            lodash.lowerCase = lowerCase;
            lodash.lowerFirst = lowerFirst;
            lodash.lt = lt;
            lodash.lte = lte;
            lodash.max = max;
            lodash.maxBy = maxBy;
            lodash.mean = mean;
            lodash.meanBy = meanBy;
            lodash.min = min;
            lodash.minBy = minBy;
            lodash.stubArray = stubArray;
            lodash.stubFalse = stubFalse;
            lodash.stubObject = stubObject;
            lodash.stubString = stubString;
            lodash.stubTrue = stubTrue;
            lodash.multiply = multiply;
            lodash.nth = nth;
            lodash.noConflict = noConflict;
            lodash.noop = noop;
            lodash.now = now;
            lodash.pad = pad;
            lodash.padEnd = padEnd;
            lodash.padStart = padStart;
            lodash.parseInt = parseInt1;
            lodash.random = random;
            lodash.reduce = reduce;
            lodash.reduceRight = reduceRight;
            lodash.repeat = repeat;
            lodash.replace = replace;
            lodash.result = result;
            lodash.round = round;
            lodash.runInContext = runInContext;
            lodash.sample = sample;
            lodash.size = size;
            lodash.snakeCase = snakeCase;
            lodash.some = some;
            lodash.sortedIndex = sortedIndex;
            lodash.sortedIndexBy = sortedIndexBy;
            lodash.sortedIndexOf = sortedIndexOf;
            lodash.sortedLastIndex = sortedLastIndex;
            lodash.sortedLastIndexBy = sortedLastIndexBy;
            lodash.sortedLastIndexOf = sortedLastIndexOf;
            lodash.startCase = startCase;
            lodash.startsWith = startsWith;
            lodash.subtract = subtract;
            lodash.sum = sum;
            lodash.sumBy = sumBy;
            lodash.template = template;
            lodash.times = times;
            lodash.toFinite = toFinite;
            lodash.toInteger = toInteger;
            lodash.toLength = toLength;
            lodash.toLower = toLower;
            lodash.toNumber = toNumber;
            lodash.toSafeInteger = toSafeInteger;
            lodash.toString = toString;
            lodash.toUpper = toUpper;
            lodash.trim = trim;
            lodash.trimEnd = trimEnd;
            lodash.trimStart = trimStart;
            lodash.truncate = truncate;
            lodash.unescape = unescape;
            lodash.uniqueId = uniqueId;
            lodash.upperCase = upperCase;
            lodash.upperFirst = upperFirst;
            lodash.each = forEach;
            lodash.eachRight = forEachRight;
            lodash.first = head;
            mixin(lodash, function() {
                var source = {};
                baseForOwn(lodash, function(func, methodName) {
                    if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
                });
                return source;
            }(), {
                'chain': false
            });
            lodash.VERSION = VERSION;
            arrayEach([
                'bind',
                'bindKey',
                'curry',
                'curryRight',
                'partial',
                'partialRight'
            ], function(methodName) {
                lodash[methodName].placeholder = lodash;
            });
            arrayEach([
                'drop',
                'take'
            ], function(methodName, index) {
                LazyWrapper.prototype[methodName] = function(n) {
                    n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                    var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                    if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                    else result.__views__.push({
                        'size': nativeMin(n, MAX_ARRAY_LENGTH),
                        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                    });
                    return result;
                };
                LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                    return this.reverse()[methodName](n).reverse();
                };
            });
            arrayEach([
                'filter',
                'map',
                'takeWhile'
            ], function(methodName, index) {
                var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
                LazyWrapper.prototype[methodName] = function(iteratee) {
                    var result = this.clone();
                    result.__iteratees__.push({
                        'iteratee': getIteratee(iteratee, 3),
                        'type': type
                    });
                    result.__filtered__ = result.__filtered__ || isFilter;
                    return result;
                };
            });
            arrayEach([
                'head',
                'last'
            ], function(methodName, index) {
                var takeName = 'take' + (index ? 'Right' : '');
                LazyWrapper.prototype[methodName] = function() {
                    return this[takeName](1).value()[0];
                };
            });
            arrayEach([
                'initial',
                'tail'
            ], function(methodName, index) {
                var dropName = 'drop' + (index ? '' : 'Right');
                LazyWrapper.prototype[methodName] = function() {
                    return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
                };
            });
            LazyWrapper.prototype.compact = function() {
                return this.filter(identity);
            };
            LazyWrapper.prototype.find = function(predicate) {
                return this.filter(predicate).head();
            };
            LazyWrapper.prototype.findLast = function(predicate) {
                return this.reverse().find(predicate);
            };
            LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
                if (typeof path == 'function') return new LazyWrapper(this);
                return this.map(function(value) {
                    return baseInvoke(value, path, args);
                });
            });
            LazyWrapper.prototype.reject = function(predicate) {
                return this.filter(negate(getIteratee(predicate)));
            };
            LazyWrapper.prototype.slice = function(start, end) {
                start = toInteger(start);
                var result = this;
                if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
                if (start < 0) result = result.takeRight(-start);
                else if (start) result = result.drop(start);
                if (end !== undefined) {
                    end = toInteger(end);
                    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                }
                return result;
            };
            LazyWrapper.prototype.takeRightWhile = function(predicate) {
                return this.reverse().takeWhile(predicate).reverse();
            };
            LazyWrapper.prototype.toArray = function() {
                return this.take(MAX_ARRAY_LENGTH);
            };
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
                if (!lodashFunc) return;
                lodash.prototype[methodName] = function() {
                    var value = this.__wrapped__, args = isTaker ? [
                        1
                    ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                    var interceptor = function(value) {
                        var result = lodashFunc.apply(lodash, arrayPush([
                            value
                        ], args));
                        return isTaker && chainAll ? result[0] : result;
                    };
                    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) isLazy = useLazy = false;
                    var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                    if (!retUnwrapped && useLazy) {
                        value = onlyLazy ? value : new LazyWrapper(this);
                        var result = func.apply(value, args);
                        result.__actions__.push({
                            'func': thru,
                            'args': [
                                interceptor
                            ],
                            'thisArg': undefined
                        });
                        return new LodashWrapper(result, chainAll);
                    }
                    if (isUnwrapped && onlyLazy) return func.apply(this, args);
                    result = this.thru(interceptor);
                    return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
                };
            });
            arrayEach([
                'pop',
                'push',
                'shift',
                'sort',
                'splice',
                'unshift'
            ], function(methodName) {
                var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
                lodash.prototype[methodName] = function() {
                    var args = arguments;
                    if (retUnwrapped && !this.__chain__) {
                        var value = this.value();
                        return func.apply(isArray(value) ? value : [], args);
                    }
                    return this[chainName](function(value) {
                        return func.apply(isArray(value) ? value : [], args);
                    });
                };
            });
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var lodashFunc = lodash[methodName];
                if (lodashFunc) {
                    var key = lodashFunc.name + '';
                    if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                    realNames[key].push({
                        'name': methodName,
                        'func': lodashFunc
                    });
                }
            });
            realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
                {
                    'name': 'wrapper',
                    'func': undefined
                }
            ];
            LazyWrapper.prototype.clone = lazyClone;
            LazyWrapper.prototype.reverse = lazyReverse;
            LazyWrapper.prototype.value = lazyValue;
            lodash.prototype.at = wrapperAt;
            lodash.prototype.chain = wrapperChain;
            lodash.prototype.commit = wrapperCommit;
            lodash.prototype.next = wrapperNext;
            lodash.prototype.plant = wrapperPlant;
            lodash.prototype.reverse = wrapperReverse;
            lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
            lodash.prototype.first = lodash.prototype.head;
            if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
            return lodash;
        };
        var _ = runInContext();
        if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
            root._ = _;
            define(function() {
                return _;
            });
        } else if (freeModule) {
            (freeModule.exports = _)._ = _;
            freeExports._ = _;
        } else root._ = _;
    }).call(this);
});
parcelRegister("AyWIa", function(module, exports) {
    $parcel$export(module.exports, "assertResponseIsOk", ()=>$da8ddd7870bed246$export$b3732c8ff6f9c463);
    $parcel$export(module.exports, "toLoading", ()=>$da8ddd7870bed246$export$f9a5bd0ffba29ffc);
    $parcel$export(module.exports, "toError", ()=>$da8ddd7870bed246$export$cc3b967c039ed3e7);
    $parcel$export(module.exports, "toData", ()=>$da8ddd7870bed246$export$24a6b176bdc41ce5);
    const $da8ddd7870bed246$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
            status: status,
            statusText: statusText
        });
    const $da8ddd7870bed246$export$b3732c8ff6f9c463 = (res)=>{
        if (res.ok) return res;
        throw new Error($da8ddd7870bed246$export$18a0019e5439b209(res));
    };
    const $da8ddd7870bed246$export$f9a5bd0ffba29ffc = ()=>({
            isLoading: true,
            data: undefined,
            error: undefined
        });
    const $da8ddd7870bed246$export$cc3b967c039ed3e7 = (error)=>({
            isLoading: false,
            error: error instanceof Error ? error : Error(String(error)),
            data: undefined
        });
    const $da8ddd7870bed246$export$24a6b176bdc41ce5 = (data)=>({
            isLoading: false,
            error: undefined,
            data: data
        });
});
parcelRegister("2GR5b", function(module, exports) {
    $parcel$export(module.exports, "usePlacementApi", ()=>$3da9ced9cf5594dd$export$201bbce8187a6e3c);
    var $iqtM5;
    var $bviTi;
    var $15e4O;
    var $g6WFU;
    var $5uXOq = parcelRequire("5uXOq");
    const $3da9ced9cf5594dd$export$201bbce8187a6e3c = (path, config)=>{
        const { placementId: placementId } = (0, (0, parcelRequire("g6WFU")).usePlacementContext)();
        const context = (0, (0, parcelRequire("iqtM5")).usePostOfficeContext)();
        const fetcher = (0, (0, parcelRequire("bviTi")).usePlacementFetchingContext)();
        const placementApi = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!placementId) return ()=>({
                    isLoading: false,
                    data: undefined,
                    error: new Error('No placementId found, make this is used as a child of PlacementProvider')
                });
            return (0, (0, parcelRequire("15e4O")).createUsePlacement)(placementId, fetcher);
        }, [
            placementId,
            fetcher
        ]);
        return placementApi(path, context, config?.requestOptions, {
            throttleTime: config?.throttleTime,
            isEnabled: config?.autoRefetch?.isEnabled,
            deps: [
                config?.autoRefetch?.updateKey
            ]
        });
    };
});
parcelRegister("bviTi", function(module, exports) {
    $parcel$export(module.exports, "usePlacementFetchingContext", ()=>$fb36864b91d4d2bc$export$e1e2cdb0425a9fa8);
    $parcel$export(module.exports, "PlacementFetchingProvider", ()=>$fb36864b91d4d2bc$export$5f25a6ddf0324fa8);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $fb36864b91d4d2bc$export$afec669dc416ee7e = (0, $5uXOq.createContext)({
        fetch: (...args)=>globalThis.fetch(...args)
    });
    const $fb36864b91d4d2bc$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($fb36864b91d4d2bc$export$afec669dc416ee7e);
    const $fb36864b91d4d2bc$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                fetch: fetch
            }), [
            fetch
        ]);
        return (0, $2OMIu.jsx)($fb36864b91d4d2bc$export$afec669dc416ee7e.Provider, {
            value: value,
            children: children
        });
    };
});
parcelRegister("15e4O", function(module, exports) {
    $parcel$export(module.exports, "createUsePlacement", ()=>$f510d742c5cbfc2d$export$ee1d67e435d25cb5);
    var $b8mfz;
    var $5uXOq = parcelRequire("5uXOq");
    var $k1Pz6;
    const $f510d742c5cbfc2d$var$depsIsValid = (deps)=>Array.isArray(deps);
    const $f510d742c5cbfc2d$export$ee1d67e435d25cb5 = (placementId, fetcher = {
        fetch: (...args)=>globalThis.fetch(...args)
    })=>{
        if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
        return (path, context, requestOptions, config)=>{
            const dependencyList = $f510d742c5cbfc2d$var$depsIsValid(config?.deps) ? [
                ...config.deps,
                config?.isEnabled
            ] : [
                path,
                config?.isEnabled
            ];
            const timerRef = (0, $5uXOq.useRef)();
            const isRunningPromise = (0, $5uXOq.useRef)(false);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    if (timerRef.current) clearTimeout(timerRef.current);
                };
            }, []);
            const promiseToResolve = (0, $5uXOq.useMemo)(()=>{
                if (config?.isEnabled === false) return undefined;
                return ({ signal: signal })=>{
                    if (isRunningPromise.current) return Promise.reject(new (0, (0, parcelRequire("k1Pz6")).AlreadyRunningError)());
                    isRunningPromise.current = true;
                    timerRef.current = setTimeout(()=>{
                        isRunningPromise.current = false;
                    }, config?.throttleTime ?? 0);
                    return (0, (0, parcelRequire("b8mfz")).fetchPlacementData)(placementId, path, context, fetcher, {
                        ...requestOptions,
                        signal: signal
                    });
                };
            }, dependencyList);
            return (0, (0, parcelRequire("k1Pz6")).useData)(promiseToResolve, {
                analytics: {
                    name: placementId,
                    path: path
                }
            });
        };
    };
});
parcelRegister("b8mfz", function(module, exports) {
    $parcel$export(module.exports, "fetchPlacementData", ()=>$05459bb8d87618df$export$ce743d02f83ee521);
    const $05459bb8d87618df$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
    const $05459bb8d87618df$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
    const $05459bb8d87618df$var$stringifyObjectValues = (input)=>{
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, value])=>$05459bb8d87618df$var$isNotEmpty(value)).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    };
    const $05459bb8d87618df$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
        const defaultHeaders = {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        };
        const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
        const contextAsSearchParams = new URLSearchParams($05459bb8d87618df$var$stringifyObjectValues(context)).toString();
        const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
        const url = encodeURI(`${$05459bb8d87618df$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
        return fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...defaultHeaders,
                ...requestOptions?.headers
            }
        });
    };
});
parcelRegister("eKmOv", function(module, exports) {
    $parcel$export(module.exports, "scopes", ()=>$db86b903007d68d7$export$54a06e3f4a159ad8);
    const $db86b903007d68d7$export$54a06e3f4a159ad8 = [
        {
            name: 'all',
            when: {
                route: {
                    pathname: {
                        matches: '.*'
                    }
                }
            }
        },
        {
            name: 'jira/all',
            when: {
                context: {
                    product: 'jira'
                }
            }
        },
        {
            name: 'jira/kanban',
            when: {
                context: {
                    product: 'jira'
                },
                route: {
                    pathname: {
                        matches: 'boards'
                    }
                }
            }
        },
        {
            name: 'confluence/all',
            when: {
                context: {
                    product: 'confluence'
                }
            }
        },
        {
            name: 'pop3/all',
            when: {
                context: {
                    product: 'pop3'
                }
            }
        },
        {
            name: 'admin/all',
            when: {
                context: {
                    product: 'admin'
                }
            }
        },
        {
            name: 'pop3/send-it',
            when: {
                context: {
                    product: 'pop3'
                },
                route: {
                    pathname: {
                        matches: 'send-it'
                    }
                }
            }
        },
        {
            name: 'admin/products',
            when: {
                context: {
                    product: 'admin'
                },
                route: {
                    pathname: {
                        matches: 'products'
                    }
                }
            }
        },
        {
            name: 'trello/all',
            when: {
                context: {
                    product: 'trello'
                }
            }
        }
    ];
});
parcelRegister("779Sq", function(module, exports) {
    $parcel$export(module.exports, "MessageRenderer", ()=>$aab7ea545290ae86$export$2df1250b8f917a59);
    var $9ZOEt;
    var $if5K1;
    var $8yh3U;
    var $58Z1z;
    var $kjYhl;
    const $aab7ea545290ae86$export$e30378e28ad3e6ab = {
        ...(0, (0, parcelRequire("if5K1")).default),
        ...(0, (0, parcelRequire("8yh3U")).default),
        ...(0, (0, parcelRequire("58Z1z")).default),
        ...(0, (0, parcelRequire("kjYhl")).default)
    };
    const { initializeMessageRenderer: $aab7ea545290ae86$export$bce4e5106d86e473, MessageRenderer: $aab7ea545290ae86$export$2df1250b8f917a59 } = (0, (0, parcelRequire("9ZOEt")).asMessageRenderer)($aab7ea545290ae86$export$e30378e28ad3e6ab);
});
parcelRegister("9ZOEt", function(module, exports) {
    $parcel$export(module.exports, "asMessageRenderer", ()=>$b66578c9f655edde$export$7b7e5a348ef9a7c1);
    var $2OMIu = parcelRequire("2OMIu");
    var $70qxv;
    var $bJnZB;
    var $hD3e9;
    var $itr7P;
    var $bqbi2;
    var $3ur7Z = parcelRequire("3ur7Z");
    var $iGvhs;
    var $5uXOq = parcelRequire("5uXOq");
    var $45cmT;
    var $cXAiM;
    var $axj9f;
    var $fX1Ft;
    const $b66578c9f655edde$export$14fe1fc3395b6e3f = ({ children: children })=>{
        const { messageViewed: messageViewed } = (0, $3ur7Z.useMessageEvent)();
        const messageViewedVoidFunction = (0, $5uXOq.useCallback)(()=>{
            messageViewed();
        }, [
            messageViewed
        ]);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("axj9f")).TrackMount), {
            onMount: messageViewedVoidFunction,
            children: children
        });
    };
    const $b66578c9f655edde$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
        const initializeMessageRenderer = ()=>{
            return ({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, ...data })=>{
                const isUFOEnabled = (0, (0, parcelRequire("70qxv")).default).checkGate('enable_ufo_tracking_in_post_office');
                const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                    const messagePerformanceTracker = isUFOEnabled ? new (0, (0, parcelRequire("bJnZB")).UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                    const onMessageSuccess = ()=>{
                        messagePerformanceTracker?.markSuccess();
                    };
                    const markMessageFailed = (onError)=>(error, info)=>{
                            messagePerformanceTracker?.markFailure(error);
                            onError && onError(error, info);
                        };
                    return {
                        markMessageUnmounted: messagePerformanceTracker?.abort,
                        markMessageFailed: markMessageFailed,
                        messageSuccessComponent: (0, $2OMIu.jsx)((0, (0, parcelRequire("axj9f")).TrackMount), {
                            onMount: onMessageSuccess
                        })
                    };
                }, [
                    messageTemplateId
                ]);
                (0, $5uXOq.useEffect)(()=>{
                    return ()=>{
                        markMessageUnmounted?.();
                    };
                }, [
                    markMessageUnmounted
                ]);
                const Core = ()=>{
                    const Component = messageComponents?.[messageTemplateId];
                    if (!Component) throw new (0, (0, parcelRequire("itr7P")).InvalidMessageTemplateIdError)(JSON.stringify({
                        messageTemplateId: messageTemplateId,
                        messageInstanceId: messageInstanceId
                    }));
                    let validatedMessage;
                    if (messageValidator) {
                        validatedMessage = messageValidator(data);
                        if (!validatedMessage) throw new (0, (0, parcelRequire("itr7P")).MessageRendererEmptyValidationResponseError)();
                    }
                    const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? (0, $2OMIu.jsx)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOLoadHold, {
                            name: (0, (0, parcelRequire("hD3e9")).UFOv2).HoldNames.MESSAGE,
                            children: loadingFallback ?? null
                        }) : (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                            children: loadingFallback ?? null
                        }), [
                        loadingFallback,
                        isUFOEnabled
                    ]);
                    const componentProps = messageValidator ? validatedMessage : data;
                    if (!Component) return null;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("45cmT")).ChoreographerWrapper), {
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        children: (0, $2OMIu.jsx)($b66578c9f655edde$var$FeatureFlaggedUfoWrapper, {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("bqbi2")).MessageContextProvider), {
                                value: {
                                    messageInstanceId: messageInstanceId,
                                    messageTemplateId: messageTemplateId,
                                    triggerId: triggerId,
                                    messageCreationType: messageCreationType,
                                    transactionAccountId: componentProps.transactionAccountId,
                                    analyticsDetails: postOffice?.analyticsDetails
                                },
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("iGvhs")).RecommendationProvider), {
                                    value: recommendationSession ?? {},
                                    children: (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                                        fallback: loadingComponent,
                                        children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("cXAiM")).MessageAnalyticsContextProvider), {
                                            children: [
                                                messageSuccessComponent,
                                                (0, $2OMIu.jsx)(Component, {
                                                    ...componentProps
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    });
                };
                return (0, (0, parcelRequire("fX1Ft")).withErrorBoundary)(Core)({
                    errorBoundaryLocation: 'placement-message-renderer-component',
                    fallbackRender: fallbackRender,
                    onError: markMessageFailed(onError)
                });
            };
        };
        return {
            initializeMessageRenderer: initializeMessageRenderer,
            MessageRenderer: initializeMessageRenderer()
        };
    };
    const $b66578c9f655edde$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
        if (isEnabled) return (0, $2OMIu.jsx)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("hD3e9")).UFOv2).SegmentNames.MESSAGE,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOSegment, {
                name: `${(0, (0, parcelRequire("hD3e9")).UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
                children: children
            })
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("bJnZB", function(module, exports) {
    $parcel$export(module.exports, "UFOv1", ()=>$0847861551065cad$export$96236906ebaa7f87);
    var $eZoqk;
    var $cPwP8;
    const $0847861551065cad$export$96236906ebaa7f87 = {
        MessagePerformanceTracker: (0, parcelRequire("eZoqk")).MessagePerformanceTracker,
        PlacementPerformanceTracker: (0, parcelRequire("cPwP8")).PlacementPerformanceTracker
    };
});
parcelRegister("eZoqk", function(module, exports) {
    $parcel$export(module.exports, "MessagePerformanceTracker", ()=>$15182a3aab84b4e8$export$ae5c73c7c4f454e6);
    var $hNAhd;
    var $d3cxT;
    var $3SayW;
    class $15182a3aab84b4e8$export$ae5c73c7c4f454e6 {
        constructor(messageTemplateId){
            this.metadata = {};
            this.markSuccess = ()=>{
                for (const experience of this.experiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFailure = (error)=>{
                for (const experience of this.experiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.abort = ()=>{
                for (const experience of this.experiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, (0, parcelRequire("d3cxT")).UFOExperience)((0, (0, parcelRequire("3SayW")).UFOExperienceNames).MESSAGE, {
                performanceType: (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, (0, parcelRequire("hNAhd")).ExperienceTypes).Load,
                platform: {
                    component: (0, (0, parcelRequire("3SayW")).POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.messageSpecificExperience = new (0, (0, parcelRequire("d3cxT")).UFOExperience)(`${(0, (0, parcelRequire("3SayW")).UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
                performanceType: (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, (0, parcelRequire("hNAhd")).ExperienceTypes).Load,
                platform: {
                    component: (0, (0, parcelRequire("3SayW")).POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.experiences = [
                this.aggregatedExperience,
                this.messageSpecificExperience
            ];
            this.experiences.forEach((experience)=>experience.start());
            this.metadata = {
                messageTemplateId: messageTemplateId
            };
        }
    }
});
parcelRegister("3SayW", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceNames", ()=>$64af87a1fa5c89ea$export$cc7ddf8ca628f6f1);
    $parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", ()=>$64af87a1fa5c89ea$export$6d482cfa20c9d220);
    const $64af87a1fa5c89ea$export$cc7ddf8ca628f6f1 = {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    };
    const $64af87a1fa5c89ea$export$6d482cfa20c9d220 = 'post-office';
});
parcelRegister("cPwP8", function(module, exports) {
    $parcel$export(module.exports, "PlacementPerformanceTracker", ()=>$1c987f9242f61d97$export$8b48c2105ba0b35a);
    var $hNAhd;
    var $d3cxT;
    var $3SayW;
    const $1c987f9242f61d97$var$STEPS = {
        RML_FETCH: 'rml-fetch',
        RML_RENDER: 'rml-render',
        INITIAL_DATA: 'initial-data-load',
        COMPONENT_READY: 'component-ready'
    };
    const $1c987f9242f61d97$var$UFO_EXPERIENCE_CONFIG = {
        performanceType: (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageSegmentLoad,
        type: (0, (0, parcelRequire("hNAhd")).ExperienceTypes).Load,
        platform: {
            component: (0, (0, parcelRequire("3SayW")).POST_OFFICE_PLATFORM_NAME)
        },
        timings: [
            {
                key: `${$1c987f9242f61d97$var$STEPS.RML_FETCH}-complete`,
                endMark: `${$1c987f9242f61d97$var$STEPS.RML_FETCH}-complete`
            },
            {
                key: `${$1c987f9242f61d97$var$STEPS.RML_RENDER}-complete`,
                endMark: `${$1c987f9242f61d97$var$STEPS.RML_RENDER}-complete`
            },
            {
                key: `${$1c987f9242f61d97$var$STEPS.INITIAL_DATA}-complete`,
                endMark: `${$1c987f9242f61d97$var$STEPS.INITIAL_DATA}-complete`
            },
            {
                key: `${$1c987f9242f61d97$var$STEPS.INITIAL_DATA}-error`,
                endMark: `${$1c987f9242f61d97$var$STEPS.INITIAL_DATA}-error`
            }
        ]
    };
    class $1c987f9242f61d97$export$8b48c2105ba0b35a {
        constructor(placementId, consumptionType = 'remote'){
            this.placementExperiences = [];
            this.metadata = {};
            this.markFetchComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$1c987f9242f61d97$var$STEPS.RML_FETCH}-complete`);
            };
            this.markRenderComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$1c987f9242f61d97$var$STEPS.RML_RENDER}-complete`);
            };
            this.markInitialDataComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$1c987f9242f61d97$var$STEPS.INITIAL_DATA}-complete`);
            };
            this.markComponentReady = ()=>{
                for (const experience of this.placementExperiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFetchFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $1c987f9242f61d97$var$STEPS.RML_FETCH,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markRenderFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $1c987f9242f61d97$var$STEPS.RML_RENDER,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markInitialDataFailure = (_)=>{
                for (const experience of this.placementExperiences)experience.mark(`${$1c987f9242f61d97$var$STEPS.INITIAL_DATA}-error`);
            };
            this.markComponentFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $1c987f9242f61d97$var$STEPS.COMPONENT_READY,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markComponentAborted = ()=>{
                for (const experience of this.placementExperiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, (0, parcelRequire("d3cxT")).UFOExperience)((0, (0, parcelRequire("3SayW")).UFOExperienceNames).PLACEMENT, $1c987f9242f61d97$var$UFO_EXPERIENCE_CONFIG);
            this.placementSpecificExperience = new (0, (0, parcelRequire("d3cxT")).UFOExperience)(`${(0, (0, parcelRequire("3SayW")).UFOExperienceNames).PLACEMENT}.${placementId}`, $1c987f9242f61d97$var$UFO_EXPERIENCE_CONFIG);
            this.placementExperiences = [
                this.aggregatedExperience,
                this.placementSpecificExperience
            ];
            for (const experience of this.placementExperiences)experience.start();
            this.metadata = {
                placementId: placementId,
                consumptionType: consumptionType
            };
        }
    }
});
parcelRegister("itr7P", function(module, exports) {
    $parcel$export(module.exports, "InvalidMessageTemplateIdError", ()=>$b61943c82a6df1bb$export$19cb89dd679394cb);
    $parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", ()=>$b61943c82a6df1bb$export$3dfc27a8d3942f4d);
    var $b61943c82a6df1bb$export$b9722560029694e7;
    (function(PostOfficeErrorCodes) {
        PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
        PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
        PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
        PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
        PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
        PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
        PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
        PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
        PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
        PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
        PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
        PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
        PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
        PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
        PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
        PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
        PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
        PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
        PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
        PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
        PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
        PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
        PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
        PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
        PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
        PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
        PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
        PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
        PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
        PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
        PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
        PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
        PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
        PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    })($b61943c82a6df1bb$export$b9722560029694e7 || ($b61943c82a6df1bb$export$b9722560029694e7 = {}));
    class $b61943c82a6df1bb$export$46f86d28cd0a5d38 extends Error {
    }
    class $b61943c82a6df1bb$export$627bc00a5ef5f6ae extends Error {
    }
    class $b61943c82a6df1bb$export$d145ea5319863172 extends Error {
        constructor(message, code){
            super(message), this.code = code;
        }
    }
    class $b61943c82a6df1bb$export$f649da38897d27f7 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$c2852c1c4d9aba3e extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionProcessingError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$4b7b4e09547e4bb3 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$360a094a97597d87 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message){
            super(message, "RecipientExpansionManagerError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$4d068b43eb55165b extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$ac007ee150add337 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message){
            super(message, "ReceiverInputValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$b79ba63f8ae791e0 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message){
            super(message, "HandlerValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$19cb89dd679394cb extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message){
            super(message, "InvalidMessageTemplateIdError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$78651662ad470cc5 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Message Template not found', "MessageTemplateNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$913b8e68dc7ae8fe extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Placement not found', "PlacementNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$3dfc27a8d3942f4d extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$e5ccdf8bbfead7a2 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "IngestionHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$823733742d803ae6 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "OrchestrationHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$a6f2aad8fa094b39 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(accountId){
            super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$2f1e27130c2bf271 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, payloadSize){
            super(message, "InvalidPayloadError");
            this.name = this.constructor.name;
            this.payloadSize = payloadSize;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$d0dc094613469f2b extends $b61943c82a6df1bb$export$46f86d28cd0a5d38 {
        constructor(message, workspaceId){
            super(message);
            this.name = this.constructor.name;
            this.workspaceId = workspaceId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$5603eab37ce562f5 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(fileType){
            super('The attachment file is not supported', "UnsupportedAttachmentType");
            this.name = this.constructor.name;
            this.fileType = fileType;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$b35ca1cf49054efc extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, email){
            super(message, "UnsupportedEmailError");
            this.name = this.constructor.name;
            this.email = email;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$e0e9aa0e9c6b37ff extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, error){
            super(message, "InvalidEmailRequestHeader");
            this.name = this.constructor.name;
            this.error = error;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$3ad818f64601e141 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message){
            super(message, "NonProdEmailDomainError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$25470bb6cba4fba0 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
            super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$ce14d445679448b6 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
            super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.messageInstanceId = messageInstanceId;
            this.placementId = placementId;
            this.stack = error?.stack;
        }
    }
    class $b61943c82a6df1bb$export$c9a26a17db1045c8 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor({ placementId: placementId }){
            super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
            this.name = this.constructor.name;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$8ab4fb362168b928 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$2afd69f57fe5285f extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(){
            super('Recipient expander not found for mapper', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$7635d2b1a281d626 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, errors){
            super(message, "GrowthRecRecommendationsError");
            this.errors = errors;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$9e1c6d00e675bc86 extends $b61943c82a6df1bb$export$d145ea5319863172 {
        constructor(message, recipient){
            super(message, "RichRecipientError");
            this.name = this.constructor.name;
            this.recipient = recipient;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$90bef7fa95eca3fa extends Error {
        constructor(status){
            super('Posting Mobile Notifications message failed'), this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$6d1a4929f6ff1a32 extends $b61943c82a6df1bb$export$46f86d28cd0a5d38 {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$89bf5f64fbf0698 extends $b61943c82a6df1bb$export$46f86d28cd0a5d38 {
        constructor(message, error){
            super(message, {
                ...error ? {
                    cause: error
                } : {}
            }), this.error = error;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$c19fc5e8aa4e064d extends Error {
        constructor(){
            super('Ingestion source is required when custom profile is specified');
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$2d3a68dab93b8cc4 extends Error {
        constructor(){
            super('A renderRedacted function is required when redactionLevel is set to a non-null value');
            this.name = this.constructor.name;
        }
    }
    class $b61943c82a6df1bb$export$175c1dbb0d7c238a extends Error {
        constructor(status){
            super('Enqueueing email failed'), this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$23fab744b3076342 extends Error {
        constructor(message, status){
            super(message), this.message = message, this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $b61943c82a6df1bb$export$194adecfa0265ea1 extends Error {
        constructor(msg, messageInstanceId, error){
            super(msg);
            this.msg = msg;
            this.messageInstanceId = messageInstanceId;
            if (error instanceof Error) this.stack = error.stack;
            else Error.captureStackTrace(this, this.constructor);
            this.name = this.constructor.name;
        }
    }
});
parcelRegister("bqbi2", function(module, exports) {
    $parcel$export(module.exports, "MessageContextProvider", ()=>$6899fbb8371df364$export$42de33f7652dc3de);
    $parcel$export(module.exports, "useMessageContext", ()=>$6899fbb8371df364$export$a5b6d14a2e25725a);
    var $5uXOq = parcelRequire("5uXOq");
    const $6899fbb8371df364$var$initialValue = {};
    const $6899fbb8371df364$export$b060d577040138d8 = (0, $5uXOq.createContext)($6899fbb8371df364$var$initialValue);
    const $6899fbb8371df364$export$42de33f7652dc3de = $6899fbb8371df364$export$b060d577040138d8.Provider;
    const $6899fbb8371df364$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($6899fbb8371df364$export$b060d577040138d8);
});
parcelRegister("3ur7Z", function(module, exports) {
    $parcel$export(module.exports, "useMessageEvent", ()=>$17341e876fd95f83$export$3cbbf1e81e2ecb39);
    var $c5psN;
    var $iqtM5;
    var $bqbi2;
    var $g6WFU;
    var $iGvhs;
    var $eLMzF = parcelRequire("eLMzF");
    var $44kjw = parcelRequire("44kjw");
    var $iI4Tp = parcelRequire("iI4Tp");
    const $17341e876fd95f83$export$3cbbf1e81e2ecb39 = ()=>{
        if (!window.postOfficeMessageEventClient) window.postOfficeMessageEventClient = new (0, $44kjw.MessageEventClient)();
        const client = window.postOfficeMessageEventClient;
        const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, (0, parcelRequire("c5psN")).useMessagePlacementHooks)();
        const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, (0, parcelRequire("bqbi2")).useMessageContext)();
        const { placementId: placementId } = (0, (0, parcelRequire("g6WFU")).usePlacementContext)();
        const browserContext = (0, (0, parcelRequire("iqtM5")).usePostOfficeContext)();
        const recommendationContext = (0, (0, parcelRequire("iGvhs")).useRecommendationContext)();
        const context = {
            browser: browserContext,
            recommendation: recommendationContext
        };
        return {
            markAllAsRead: async (messages)=>{
                const messagesEventPostPayload = messages.map((message)=>{
                    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
                    if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                    return {
                        messageInstanceId: message['messageInstanceId'],
                        messageTemplateId: message['messageTemplateId'],
                        type: (0, $iI4Tp.InAppMessageEventType).Read,
                        placement: placementId,
                        createdAt: Date.now(),
                        analyticsDetails: analyticsDetails,
                        context: context
                    };
                });
                try {
                    await client.markAllAsReadEvent(messagesEventPostPayload);
                } catch (error) {
                    throw new (0, $eLMzF.MessageLifecycleClientError)();
                }
            },
            messageRead: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                markReadFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                try {
                    await client.sendEvent({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        type: (0, $iI4Tp.InAppMessageEventType).Read,
                        placement: placementId,
                        createdAt: Date.now(),
                        analyticsDetails: analyticsDetails,
                        context: context
                    });
                } catch (error) {
                    throw new (0, $eLMzF.MessageLifecycleClientError)();
                }
            },
            messageUnread: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                try {
                    await client.sendEvent({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        type: (0, $iI4Tp.InAppMessageEventType).Unread,
                        placement: placementId,
                        createdAt: Date.now(),
                        context: context,
                        analyticsDetails: analyticsDetails
                    });
                } catch (error) {
                    throw new (0, $eLMzF.MessageLifecycleClientError)();
                }
            },
            messageViewed: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                markViewedFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $iI4Tp.InAppMessageEventType).Viewed,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageClicked: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                markClickedFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $iI4Tp.InAppMessageEventType).Clicked,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageClickedSecondary: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $iI4Tp.InAppMessageEventType).ClickedSecondary,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageAcknowledged: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $iI4Tp.InAppMessageEventType).Acknowledged,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageDismissed: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                dismissMessageFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $iI4Tp.InAppMessageEventType).Dismissed,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageSnoozed: async (snoozeDays)=>{
                const MILLIS_IN_A_DAY = 86400000;
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $eLMzF.MessageLifecycleContextError)();
                snoozeMessageFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $iI4Tp.InAppMessageEventType).Snoozed,
                    placement: placementId,
                    createdAt: Date.now(),
                    statusExpiryTime: statusExpiryTime,
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            }
        };
    };
});
parcelRegister("iGvhs", function(module, exports) {
    $parcel$export(module.exports, "RecommendationProvider", ()=>$1886c5930800ae95$export$f60e87d7b5f59562);
    $parcel$export(module.exports, "useRecommendationContext", ()=>$1886c5930800ae95$export$3321c0b02f750bcc);
    var $2OMIu = parcelRequire("2OMIu");
    var $bYdUR;
    var $5uXOq = parcelRequire("5uXOq");
    const $1886c5930800ae95$export$ba2f44035effd9c1 = (0, $5uXOq.createContext)({
        sessionId: undefined,
        entityId: undefined
    });
    const $1886c5930800ae95$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
        return (0, $2OMIu.jsx)($1886c5930800ae95$export$ba2f44035effd9c1.Provider, {
            value: value,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("bYdUR")).default), {
                data: value,
                children: children
            })
        });
    };
    const $1886c5930800ae95$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($1886c5930800ae95$export$ba2f44035effd9c1);
});
parcelRegister("eLMzF", function(module, exports) {
    $parcel$export(module.exports, "MessageLifecycleContextError", ()=>$eadee39824ed66b7$export$12bb62b204112f55);
    $parcel$export(module.exports, "MessageLifecycleClientError", ()=>$eadee39824ed66b7$export$44f397e2afeb89e0);
    class $eadee39824ed66b7$export$12bb62b204112f55 extends Error {
        constructor(){
            super('useMessageLifecycle must be used inside a Message template render component.');
        }
    }
    class $eadee39824ed66b7$export$44f397e2afeb89e0 extends Error {
        constructor(){
            super('API call to /messages failed due to an error');
        }
    }
});
parcelRegister("44kjw", function(module, exports) {
    $parcel$export(module.exports, "MessageEventClient", ()=>$69162f6a2b3a6832$export$ae86a6dabe385178);
    const $69162f6a2b3a6832$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
    const $69162f6a2b3a6832$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
    const $69162f6a2b3a6832$var$MESSAGE_EVENTS_BATCH_SIZE = 250;
    if (typeof fetch === 'undefined') (parcelRequire("fS9d8"));
    class $69162f6a2b3a6832$export$ae86a6dabe385178 {
        async sendEvent(event) {
            const url = `${this.endpointUrl}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            });
            if (!response.ok) console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
        }
        batchSendEvent(event) {
            this.batchEvents.push(event);
            if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $69162f6a2b3a6832$var$FLUSH_BATCH_EVENTS_TIMEOUT);
        }
        async markAllAsReadEvent(messages) {
            this.batchEvents.push(...messages);
            await this.flushBatchEvents();
        }
        async sendMessageEvents(events) {
            const url = `${this.endpointUrl}/bulk`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(events)
            });
            if (!response.ok) console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
        }
        async flushBatchEvents() {
            if (this.batchEvents.length === 0) return;
            if (this.batchEvents.length > $69162f6a2b3a6832$var$MESSAGE_EVENTS_BATCH_SIZE) {
                const batch = this.batchEvents.slice(0, $69162f6a2b3a6832$var$MESSAGE_EVENTS_BATCH_SIZE);
                await this.sendMessageEvents(batch);
                if (this.scheduledTimeout !== null) window.clearTimeout(this.scheduledTimeout);
                this.batchEvents = this.batchEvents.slice($69162f6a2b3a6832$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
                this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $69162f6a2b3a6832$var$FLUSH_BATCH_EVENTS_TIMEOUT);
                return;
            }
            await this.sendMessageEvents(this.batchEvents);
            this.batchEvents = [];
            if (this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        }
        constructor(){
            this.endpointUrl = $69162f6a2b3a6832$var$DEFAULT_PATH;
            this.scheduledTimeout = null;
            this.batchEvents = [];
        }
    }
});
parcelRegister("fS9d8", function(module, exports) {
    $parcel$export(module.exports, "Headers", ()=>$b8e30b448f738d08$export$79b704688b15c0f4);
    $parcel$export(module.exports, "Request", ()=>$b8e30b448f738d08$export$7fa6c5b6f8193917);
    $parcel$export(module.exports, "Response", ()=>$b8e30b448f738d08$export$9f633d56d7ec90d3);
    $parcel$export(module.exports, "DOMException", ()=>$b8e30b448f738d08$export$fe58bcf938607f6a);
    $parcel$export(module.exports, "fetch", ()=>$b8e30b448f738d08$export$e7aa7bc5c1b3cfb3);
    var $b8e30b448f738d08$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global || {};
    var $b8e30b448f738d08$var$support = {
        searchParams: 'URLSearchParams' in $b8e30b448f738d08$var$g,
        iterable: 'Symbol' in $b8e30b448f738d08$var$g && 'iterator' in Symbol,
        blob: 'FileReader' in $b8e30b448f738d08$var$g && 'Blob' in $b8e30b448f738d08$var$g && function() {
            try {
                new Blob();
                return true;
            } catch (e) {
                return false;
            }
        }(),
        formData: 'FormData' in $b8e30b448f738d08$var$g,
        arrayBuffer: 'ArrayBuffer' in $b8e30b448f738d08$var$g
    };
    function $b8e30b448f738d08$var$isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
    }
    if ($b8e30b448f738d08$var$support.arrayBuffer) {
        var $b8e30b448f738d08$var$viewClasses = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]'
        ];
        var $b8e30b448f738d08$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && $b8e30b448f738d08$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
    }
    function $b8e30b448f738d08$var$normalizeName(name) {
        if (typeof name !== 'string') name = String(name);
        if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
        return name.toLowerCase();
    }
    function $b8e30b448f738d08$var$normalizeValue(value) {
        if (typeof value !== 'string') value = String(value);
        return value;
    }
    function $b8e30b448f738d08$var$iteratorFor(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if ($b8e30b448f738d08$var$support.iterable) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function $b8e30b448f738d08$export$79b704688b15c0f4(headers) {
        this.map = {};
        if (headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4) headers.forEach(function(value, name) {
            this.append(name, value);
        }, this);
        else if (Array.isArray(headers)) headers.forEach(function(header) {
            if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
            this.append(header[0], header[1]);
        }, this);
        else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
        }, this);
    }
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.append = function(name, value) {
        name = $b8e30b448f738d08$var$normalizeName(name);
        value = $b8e30b448f738d08$var$normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ', ' + value : value;
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype['delete'] = function(name) {
        delete this.map[$b8e30b448f738d08$var$normalizeName(name)];
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.get = function(name) {
        name = $b8e30b448f738d08$var$normalizeName(name);
        return this.has(name) ? this.map[name] : null;
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.has = function(name) {
        return this.map.hasOwnProperty($b8e30b448f738d08$var$normalizeName(name));
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.set = function(name, value) {
        this.map[$b8e30b448f738d08$var$normalizeName(name)] = $b8e30b448f738d08$var$normalizeValue(value);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
        for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push(name);
        });
        return $b8e30b448f738d08$var$iteratorFor(items);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
            items.push(value);
        });
        return $b8e30b448f738d08$var$iteratorFor(items);
    };
    $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
        });
        return $b8e30b448f738d08$var$iteratorFor(items);
    };
    if ($b8e30b448f738d08$var$support.iterable) $b8e30b448f738d08$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries;
    function $b8e30b448f738d08$var$consumed(body) {
        if (body._noBody) return;
        if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
        body.bodyUsed = true;
    }
    function $b8e30b448f738d08$var$fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
            reader.onload = function() {
                resolve(reader.result);
            };
            reader.onerror = function() {
                reject(reader.error);
            };
        });
    }
    function $b8e30b448f738d08$var$readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
    }
    function $b8e30b448f738d08$var$readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
        var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
        var encoding = match ? match[1] : 'utf-8';
        reader.readAsText(blob, encoding);
        return promise;
    }
    function $b8e30b448f738d08$var$readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
        return chars.join('');
    }
    function $b8e30b448f738d08$var$bufferClone(buf) {
        if (buf.slice) return buf.slice(0);
        else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
        }
    }
    function $b8e30b448f738d08$var$Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
            this.bodyUsed = this.bodyUsed;
            this._bodyInit = body;
            if (!body) {
                this._noBody = true;
                this._bodyText = '';
            } else if (typeof body === 'string') this._bodyText = body;
            else if ($b8e30b448f738d08$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
            else if ($b8e30b448f738d08$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
            else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
            else if ($b8e30b448f738d08$var$support.arrayBuffer && $b8e30b448f738d08$var$support.blob && $b8e30b448f738d08$var$isDataView(body)) {
                this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body.buffer);
                this._bodyInit = new Blob([
                    this._bodyArrayBuffer
                ]);
            } else if ($b8e30b448f738d08$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b8e30b448f738d08$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body);
            else this._bodyText = body = Object.prototype.toString.call(body);
            if (!this.headers.get('content-type')) {
                if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
        };
        if ($b8e30b448f738d08$var$support.blob) this.blob = function() {
            var rejected = $b8e30b448f738d08$var$consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
            else return Promise.resolve(new Blob([
                this._bodyText
            ]));
        };
        this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var isConsumed = $b8e30b448f738d08$var$consumed(this);
                if (isConsumed) return isConsumed;
                else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                else return Promise.resolve(this._bodyArrayBuffer);
            } else if ($b8e30b448f738d08$var$support.blob) return this.blob().then($b8e30b448f738d08$var$readBlobAsArrayBuffer);
            else throw new Error('could not read as ArrayBuffer');
        };
        this.text = function() {
            var rejected = $b8e30b448f738d08$var$consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return $b8e30b448f738d08$var$readBlobAsText(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve($b8e30b448f738d08$var$readArrayBufferAsText(this._bodyArrayBuffer));
            else if (this._bodyFormData) throw new Error('could not read FormData body as text');
            else return Promise.resolve(this._bodyText);
        };
        if ($b8e30b448f738d08$var$support.formData) this.formData = function() {
            return this.text().then($b8e30b448f738d08$var$decode);
        };
        this.json = function() {
            return this.text().then(JSON.parse);
        };
        return this;
    }
    var $b8e30b448f738d08$var$methods = [
        'CONNECT',
        'DELETE',
        'GET',
        'HEAD',
        'OPTIONS',
        'PATCH',
        'POST',
        'PUT',
        'TRACE'
    ];
    function $b8e30b448f738d08$var$normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return $b8e30b448f738d08$var$methods.indexOf(upcased) > -1 ? upcased : method;
    }
    function $b8e30b448f738d08$export$7fa6c5b6f8193917(input, options) {
        if (!(this instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        options = options || {};
        var body = options.body;
        if (input instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917) {
            if (input.bodyUsed) throw new TypeError('Already read');
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(input.headers);
            this.method = input.method;
            this.mode = input.mode;
            this.signal = input.signal;
            if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
            }
        } else this.url = String(input);
        this.credentials = options.credentials || this.credentials || 'same-origin';
        if (options.headers || !this.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
        this.method = $b8e30b448f738d08$var$normalizeMethod(options.method || this.method || 'GET');
        this.mode = options.mode || this.mode || null;
        this.signal = options.signal || this.signal || function() {
            if ('AbortController' in $b8e30b448f738d08$var$g) {
                var ctrl = new AbortController();
                return ctrl.signal;
            }
        }();
        this.referrer = null;
        if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
        this._initBody(body);
        if (this.method === 'GET' || this.method === 'HEAD') {
            if (options.cache === 'no-store' || options.cache === 'no-cache') {
                var reParamSearch = /([?&])_=[^&]*/;
                if (reParamSearch.test(this.url)) this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                else {
                    var reQueryString = /\?/;
                    this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                }
            }
        }
    }
    $b8e30b448f738d08$export$7fa6c5b6f8193917.prototype.clone = function() {
        return new $b8e30b448f738d08$export$7fa6c5b6f8193917(this, {
            body: this._bodyInit
        });
    };
    function $b8e30b448f738d08$var$decode(body) {
        var form = new FormData();
        body.trim().split('&').forEach(function(bytes) {
            if (bytes) {
                var split = bytes.split('=');
                var name = split.shift().replace(/\+/g, ' ');
                var value = split.join('=').replace(/\+/g, ' ');
                form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
        });
        return form;
    }
    function $b8e30b448f738d08$var$parseHeaders(rawHeaders) {
        var headers = new $b8e30b448f738d08$export$79b704688b15c0f4();
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
        preProcessedHeaders.split('\r').map(function(header) {
            return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
        }).forEach(function(line) {
            var parts = line.split(':');
            var key = parts.shift().trim();
            if (key) {
                var value = parts.join(':').trim();
                try {
                    headers.append(key, value);
                } catch (error) {
                    console.warn('Response ' + error.message);
                }
            }
        });
        return headers;
    }
    $b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$7fa6c5b6f8193917.prototype);
    function $b8e30b448f738d08$export$9f633d56d7ec90d3(bodyInit, options) {
        if (!(this instanceof $b8e30b448f738d08$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (!options) options = {};
        this.type = 'default';
        this.status = options.status === undefined ? 200 : options.status;
        if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
        this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
        this.url = options.url || '';
        this._initBody(bodyInit);
    }
    $b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$9f633d56d7ec90d3.prototype);
    $b8e30b448f738d08$export$9f633d56d7ec90d3.prototype.clone = function() {
        return new $b8e30b448f738d08$export$9f633d56d7ec90d3(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new $b8e30b448f738d08$export$79b704688b15c0f4(this.headers),
            url: this.url
        });
    };
    $b8e30b448f738d08$export$9f633d56d7ec90d3.error = function() {
        var response = new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
            status: 200,
            statusText: ''
        });
        response.ok = false;
        response.status = 0;
        response.type = 'error';
        return response;
    };
    var $b8e30b448f738d08$var$redirectStatuses = [
        301,
        302,
        303,
        307,
        308
    ];
    $b8e30b448f738d08$export$9f633d56d7ec90d3.redirect = function(url, status) {
        if ($b8e30b448f738d08$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
        return new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
            status: status,
            headers: {
                location: url
            }
        });
    };
    var $b8e30b448f738d08$export$fe58bcf938607f6a = $b8e30b448f738d08$var$g.DOMException;
    try {
        new $b8e30b448f738d08$export$fe58bcf938607f6a();
    } catch (err) {
        $b8e30b448f738d08$export$fe58bcf938607f6a = function(message, name) {
            this.message = message;
            this.name = name;
            var error = Error(message);
            this.stack = error.stack;
        };
        $b8e30b448f738d08$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
        $b8e30b448f738d08$export$fe58bcf938607f6a.prototype.constructor = $b8e30b448f738d08$export$fe58bcf938607f6a;
    }
    function $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3(input, init) {
        return new Promise(function(resolve, reject) {
            var request = new $b8e30b448f738d08$export$7fa6c5b6f8193917(input, init);
            if (request.signal && request.signal.aborted) return reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            var xhr = new XMLHttpRequest();
            function abortXhr() {
                xhr.abort();
            }
            xhr.onload = function() {
                var options = {
                    statusText: xhr.statusText,
                    headers: $b8e30b448f738d08$var$parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                else options.status = xhr.status;
                options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                var body = 'response' in xhr ? xhr.response : xhr.responseText;
                setTimeout(function() {
                    resolve(new $b8e30b448f738d08$export$9f633d56d7ec90d3(body, options));
                }, 0);
            };
            xhr.onerror = function() {
                setTimeout(function() {
                    reject(new TypeError('Network request failed'));
                }, 0);
            };
            xhr.ontimeout = function() {
                setTimeout(function() {
                    reject(new TypeError('Network request timed out'));
                }, 0);
            };
            xhr.onabort = function() {
                setTimeout(function() {
                    reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
                }, 0);
            };
            function fixUrl(url) {
                try {
                    return url === '' && $b8e30b448f738d08$var$g.location.href ? $b8e30b448f738d08$var$g.location.href : url;
                } catch (e) {
                    return url;
                }
            }
            xhr.open(request.method, fixUrl(request.url), true);
            if (request.credentials === 'include') xhr.withCredentials = true;
            else if (request.credentials === 'omit') xhr.withCredentials = false;
            if ('responseType' in xhr) {
                if ($b8e30b448f738d08$var$support.blob) xhr.responseType = 'blob';
                else if ($b8e30b448f738d08$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
            }
            if (init && typeof init.headers === 'object' && !(init.headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4 || $b8e30b448f738d08$var$g.Headers && init.headers instanceof $b8e30b448f738d08$var$g.Headers)) {
                var names = [];
                Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    names.push($b8e30b448f738d08$var$normalizeName(name));
                    xhr.setRequestHeader(name, $b8e30b448f738d08$var$normalizeValue(init.headers[name]));
                });
                request.headers.forEach(function(value, name) {
                    if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                });
            } else request.headers.forEach(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            if (request.signal) {
                request.signal.addEventListener('abort', abortXhr);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                };
            }
            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
        });
    }
    $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3.polyfill = true;
    if (!$b8e30b448f738d08$var$g.fetch) {
        $b8e30b448f738d08$var$g.fetch = $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3;
        $b8e30b448f738d08$var$g.Headers = $b8e30b448f738d08$export$79b704688b15c0f4;
        $b8e30b448f738d08$var$g.Request = $b8e30b448f738d08$export$7fa6c5b6f8193917;
        $b8e30b448f738d08$var$g.Response = $b8e30b448f738d08$export$9f633d56d7ec90d3;
    }
});
parcelRegister("iI4Tp", function(module, exports) {
    $parcel$export(module.exports, "InAppMessageEventType", ()=>$ce570ed0dd679379$export$b31ffc6f7c85f1b);
    var $ce570ed0dd679379$export$b31ffc6f7c85f1b;
    (function(InAppMessageEventType) {
        InAppMessageEventType["Viewed"] = "viewed";
        InAppMessageEventType["Acknowledged"] = "acknowledged";
        InAppMessageEventType["Clicked"] = "clicked";
        InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
        InAppMessageEventType["Dismissed"] = "dismissed";
        InAppMessageEventType["Snoozed"] = "snoozed";
        InAppMessageEventType["Read"] = "read";
        InAppMessageEventType["Unread"] = "unread";
    })($ce570ed0dd679379$export$b31ffc6f7c85f1b || ($ce570ed0dd679379$export$b31ffc6f7c85f1b = {}));
});
parcelRegister("45cmT", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerWrapper", ()=>$12059845dd5a62c8$export$8db7ba034addcd65);
    var $2OMIu = parcelRequire("2OMIu");
    var $70qxv;
    var $8xLFf;
    var $5uXOq = parcelRequire("5uXOq");
    var $eBZDe;
    const $12059845dd5a62c8$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
        const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const shouldRender = useChoreographedRender({
            messageId: messageId
        });
        if (shouldRender) return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
        return null;
    };
    const $12059845dd5a62c8$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
        const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, (0, parcelRequire("eBZDe")).useChoreographerContext)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const isTrackingChoreographedPostOfficeMessagesEnabled = (0, (0, parcelRequire("70qxv")).default).checkGate('enable_tracking_choreographed_post_office_messages');
            if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
                eventType: 'operational',
                action: 'maybeChoreographed',
                actionSubject: 'postOfficeMessage'
            }, {
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory
            });
        }, [
            fireAnalyticsEvent
        ]);
        const isChoreographedPostOfficeMessagesEnabled = (0, (0, parcelRequire("70qxv")).default).checkGate('enable_choreographed_post_office_messages');
        if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && factory) {
            const { shouldBeChoreographed: shouldBeChoreographed } = factory;
            const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
            if (shouldBeChoreographed({
                messageType: messageType
            })) return (0, $2OMIu.jsx)($12059845dd5a62c8$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: messageId,
                children: children
            });
        }
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("cXAiM", function(module, exports) {
    $parcel$export(module.exports, "MessageAnalyticsContextProvider", ()=>$74b9859dd9089db9$export$1737ab199e83455e);
    $parcel$export(module.exports, "useMessageAnalyticsContext", ()=>$74b9859dd9089db9$export$bb426ba114b64992);
    var $2OMIu = parcelRequire("2OMIu");
    var $5uXOq = parcelRequire("5uXOq");
    const $74b9859dd9089db9$var$defaultMessageAnalyticsContextValue = {
        fireMessageViewedInMessageComponent: null,
        setFireMessageViewedInMessageComponent: ()=>{}
    };
    const $74b9859dd9089db9$export$c81717973c6c4a90 = (0, $5uXOq.createContext)($74b9859dd9089db9$var$defaultMessageAnalyticsContextValue);
    const $74b9859dd9089db9$export$1737ab199e83455e = ({ children: children })=>{
        const fireMessageViewedInMessageComponent = (0, $5uXOq.useRef)(false);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
                setFireMessageViewedInMessageComponent: (value)=>{
                    fireMessageViewedInMessageComponent.current = value;
                }
            }), [
            fireMessageViewedInMessageComponent
        ]);
        return (0, $2OMIu.jsx)($74b9859dd9089db9$export$c81717973c6c4a90.Provider, {
            value: contextValue,
            children: children
        });
    };
    const $74b9859dd9089db9$export$bb426ba114b64992 = ()=>(0, $5uXOq.useContext)($74b9859dd9089db9$export$c81717973c6c4a90);
});
parcelRegister("if5K1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d267e56dddc0ccd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2d267e56dddc0ccd$export$2e2bcd8739ae039 = {
        'marketing-screen-space-flag-contentful-usecase': (0, $5uXOq.lazy)(()=>(parcelRequire("pMmuG")))
    };
});
parcelRegister("pMmuG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1ffWp")
    ]).then(()=>parcelRequire('6jYbY'));
});
parcelRegister("8yh3U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12cd4fcc101730b3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $12cd4fcc101730b3$export$2e2bcd8739ae039 = {
        'end-of-trial-extension': (0, $5uXOq.lazy)(()=>(parcelRequire("9TXKi")))
    };
});
parcelRegister("9TXKi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8rThu").then(()=>parcelRequire('9qRLf'));
});
parcelRegister("58Z1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e34d71c14d951791$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e34d71c14d951791$export$2e2bcd8739ae039 = {
        'message-template-template': (0, $5uXOq.lazy)(()=>(parcelRequire("lNIQ2")))
    };
});
parcelRegister("lNIQ2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8njml").then(()=>parcelRequire('ifGf7'));
});
parcelRegister("kjYhl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7eb2a9721debb1a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a7eb2a9721debb1a$export$2e2bcd8739ae039 = {
        'test-message-inapp': (0, $5uXOq.lazy)(()=>(parcelRequire("6aHio"))),
        'test-message-inapp-implicit-pendo': (0, $5uXOq.lazy)(()=>(parcelRequire("c7J2M")))
    };
});
parcelRegister("6aHio", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gnzC8").then(()=>parcelRequire('jXKup'));
});
parcelRegister("c7J2M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aHImK").then(()=>parcelRequire('8I3Qr'));
});
const $b5a546abf3692d8d$export$a5cfae247d8360ef = 'screen-space-flags';
parcelRegister("a0yxQ", function(module, exports) {
    $parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", ()=>$ee3308f7f76c3625$export$b0eee5de066b2bf5);
    var $aRzm0;
    var $eI3un;
    var $dOVoM;
    var $e6sqF;
    var $8bKEE;
    const $ee3308f7f76c3625$var$loadMessagesByTeam = async (locale)=>{
        return Promise.allSettled([
            (0, (0, parcelRequire("eI3un")).messagesLoader)(locale),
            (0, (0, parcelRequire("dOVoM")).messagesLoader)(locale),
            (0, (0, parcelRequire("e6sqF")).messagesLoader)(locale),
            (0, (0, parcelRequire("8bKEE")).messagesLoader)(locale)
        ]).then((results)=>{
            return results.reduce((acc, result)=>{
                if (result.status === 'fulfilled') return {
                    messages: {
                        ...acc.messages,
                        ...result.value
                    },
                    errors: [
                        ...acc.errors
                    ]
                };
                else if (result.status === 'rejected') return {
                    messages: {
                        ...acc.messages
                    },
                    errors: [
                        ...acc.errors,
                        `Failed to load translations with ${result.reason}`
                    ]
                };
                return acc;
            }, {
                messages: {},
                errors: []
            });
        });
    };
    const $ee3308f7f76c3625$export$b0eee5de066b2bf5 = (Component)=>{
        return (0, (0, parcelRequire("aRzm0")).withIntlProvider)({
            messagesLoader: $ee3308f7f76c3625$var$loadMessagesByTeam
        }, Component);
    };
});
parcelRegister("aRzm0", function(module, exports) {
    $parcel$export(module.exports, "withIntlProvider", ()=>$e8480e5e33438c37$export$a5d940130f33be3f);
    var $2OMIu = parcelRequire("2OMIu");
    var $2VA7O;
    const $e8480e5e33438c37$export$a5d940130f33be3f = (intlProviderProps, Component)=>(props)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("2VA7O")).default), {
                ...intlProviderProps,
                children: (0, $2OMIu.jsx)(Component, {
                    ...props
                })
            });
});
parcelRegister("2VA7O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71cb9417c275d8e1$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $8xLFf;
    var $i5FdW;
    var $koVbs;
    var $eiPN1;
    function $71cb9417c275d8e1$var$useFetchLocale() {
        let locale = 'en';
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
        try {
            const { locale: intlLocale } = (0, (0, parcelRequire("koVbs")).default)();
            locale = intlLocale;
        } catch (err) {
            fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlProvider',
                eventType: 'operational',
                attributes: {
                    errorMessage: err
                }
            });
        }
        return {
            locale: locale
        };
    }
    function $71cb9417c275d8e1$export$2e2bcd8739ae039(props) {
        const { locale: locale } = $71cb9417c275d8e1$var$useFetchLocale();
        const messages = (0, (0, parcelRequire("eiPN1")).useIntlMessages)(locale, props.messagesLoader);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            messages: messages,
            children: props.children
        });
    }
});
parcelRegister("eiPN1", function(module, exports) {
    $parcel$export(module.exports, "useIntlMessages", ()=>$0411190952f2199e$export$2641ec9a2025a81f);
    var $8xLFf;
    var $5uXOq = parcelRequire("5uXOq");
    const $0411190952f2199e$export$2641ec9a2025a81f = (locale, messageLoader)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("8xLFf")).useFirePostOfficeAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            messageLoader(locale).then((loadedMessages)=>{
                if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
                if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                    action: 'errored',
                    actionSubject: 'intlMessagesLoader',
                    eventType: 'operational',
                    attributes: {
                        locale: locale,
                        errorMessage: loadedMessages.errors
                    }
                });
            }).catch(console.error);
        }, [
            locale
        ]);
        return messages;
    };
});
parcelRegister("eI3un", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$4943b9f972924054$export$720676d8cac8fbb);
    var $byr54;
    var $2FQzx;
    const $4943b9f972924054$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $4943b9f972924054$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("2FQzx")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("erLkb")));
            case 'da':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("kl5cC")));
            case 'de':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("7xEhn")));
            case 'en-GB':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("hD5Dy")));
            case 'en-US':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("hpeOw")));
            case 'en-XA':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("frtjn")));
            case 'en-XB':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("4iAs4")));
            case 'en-ZZ':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("aJ1pq")));
            case 'en':
                return $4943b9f972924054$var$importHelper(await Promise.resolve((parcelRequire("byr54"))));
            case 'es':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("iWI5c")));
            case 'et':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("9tO3l")));
            case 'fi':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("lEgFu")));
            case 'fr':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("28elK")));
            case 'hu':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("4LwRT")));
            case 'it':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("1pM8M")));
            case 'ja':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("e6gNJ")));
            case 'ko':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("bWUWZ")));
            case 'nb':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("iNn5C")));
            case 'nl':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("kbuUE")));
            case 'pl':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("1jYAB")));
            case 'pt-BR':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("3C6BG")));
            case 'ro':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("l9oOe")));
            case 'ru':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("3IUF5")));
            case 'sv':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("9pxS4")));
            case 'th':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("4OQdt")));
            case 'tr':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("2Hmpe")));
            case 'uk':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("9mXRZ")));
            case 'vi':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("hAYO7")));
            case 'zh-CN':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("9c4ds")));
            case 'zh-TW':
                return $4943b9f972924054$var$importHelper(await (parcelRequire("ih8HD")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("byr54"))));
        }
    };
});
parcelRegister("byr54", function(module, exports) {
    module.exports = JSON.parse("{}");
});
parcelRegister("erLkb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("evRfW").then(()=>parcelRequire('fPRS6'));
});
parcelRegister("kl5cC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ahAea").then(()=>parcelRequire('hFt57'));
});
parcelRegister("7xEhn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("pp8Vp").then(()=>parcelRequire('9YwcT'));
});
parcelRegister("hD5Dy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iuhGu").then(()=>parcelRequire('ajyBs'));
});
parcelRegister("hpeOw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("146Ry").then(()=>parcelRequire('8vQfQ'));
});
parcelRegister("frtjn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gVzxz").then(()=>parcelRequire('4TvcC'));
});
parcelRegister("4iAs4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a0n3v").then(()=>parcelRequire('kwYLT'));
});
parcelRegister("aJ1pq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("50gWH").then(()=>parcelRequire('8hirJ'));
});
parcelRegister("iWI5c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kQo8o").then(()=>parcelRequire('cpfM2'));
});
parcelRegister("9tO3l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Scnh").then(()=>parcelRequire('gry5P'));
});
parcelRegister("lEgFu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iI9df").then(()=>parcelRequire('6Z7F8'));
});
parcelRegister("28elK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4koHx").then(()=>parcelRequire('gMueM'));
});
parcelRegister("4LwRT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jErpI").then(()=>parcelRequire('eO8fy'));
});
parcelRegister("1pM8M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gn3HL").then(()=>parcelRequire('lW0vy'));
});
parcelRegister("e6gNJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d75KG").then(()=>parcelRequire('3VD8s'));
});
parcelRegister("bWUWZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jy2LX").then(()=>parcelRequire('dSYZw'));
});
parcelRegister("iNn5C", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aV6gh").then(()=>parcelRequire('iORmD'));
});
parcelRegister("kbuUE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Oz2z").then(()=>parcelRequire('5ZHJE'));
});
parcelRegister("1jYAB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1lb9F").then(()=>parcelRequire('dv0jy'));
});
parcelRegister("3C6BG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dL2w1").then(()=>parcelRequire('diBNp'));
});
parcelRegister("l9oOe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9L74a").then(()=>parcelRequire('kwMzh'));
});
parcelRegister("3IUF5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("esbLG").then(()=>parcelRequire('iH8az'));
});
parcelRegister("9pxS4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2S6JB").then(()=>parcelRequire('1FS9y'));
});
parcelRegister("4OQdt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3CAtk").then(()=>parcelRequire('4o772'));
});
parcelRegister("2Hmpe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9vy3i").then(()=>parcelRequire('532R8'));
});
parcelRegister("9mXRZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fWzjw").then(()=>parcelRequire('04qI8'));
});
parcelRegister("hAYO7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aEWio").then(()=>parcelRequire('86FNU'));
});
parcelRegister("9c4ds", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jwdJB").then(()=>parcelRequire('5Fx5r'));
});
parcelRegister("ih8HD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hyLEg").then(()=>parcelRequire('aE7EE'));
});
parcelRegister("dOVoM", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$9f17da90e00c2db8$export$720676d8cac8fbb);
    var $iDaw3;
    var $2FQzx;
    const $9f17da90e00c2db8$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $9f17da90e00c2db8$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("2FQzx")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("cv0NB")));
            case 'da':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("7OiHZ")));
            case 'de':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("1AaT0")));
            case 'en-GB':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("9ZEuH")));
            case 'en-US':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("79EI0")));
            case 'en-XA':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("cOuBw")));
            case 'en-XB':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("bD9jM")));
            case 'en-ZZ':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("baMA9")));
            case 'en':
                return $9f17da90e00c2db8$var$importHelper(await Promise.resolve((parcelRequire("iDaw3"))));
            case 'es':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("eloi9")));
            case 'et':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("byQsJ")));
            case 'fi':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("a9vka")));
            case 'fr':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("9JCSe")));
            case 'hu':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("2K7kh")));
            case 'it':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("d4rnX")));
            case 'ja':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("8DokZ")));
            case 'ko':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("3W7d9")));
            case 'nb':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("fAQPT")));
            case 'nl':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("ehTQ1")));
            case 'pl':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("8qsLT")));
            case 'pt-BR':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("eKe0H")));
            case 'ro':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("jKG5Y")));
            case 'ru':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("jtrra")));
            case 'sv':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("efOlM")));
            case 'th':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("3tSnb")));
            case 'tr':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("81a9c")));
            case 'uk':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("7Dbrw")));
            case 'vi':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("aK43C")));
            case 'zh-CN':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("f75YX")));
            case 'zh-TW':
                return $9f17da90e00c2db8$var$importHelper(await (parcelRequire("dm8wZ")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("iDaw3"))));
        }
    };
});
parcelRegister("iDaw3", function(module, exports) {
    module.exports = JSON.parse("{\"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"playground.playground-local-execution-message.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"playground.playground-local-execution-message.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hello, fellow child \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"playground.playground-local-execution-message.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"We are currently trying to locally execute this message!\"}],\"playground.playground-local-execution-message.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Playground Team\"}],\"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");
});
parcelRegister("cv0NB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gzU60").then(()=>parcelRequire('iRQpW'));
});
parcelRegister("7OiHZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lb2Tu").then(()=>parcelRequire('7trXu'));
});
parcelRegister("1AaT0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l0ABo").then(()=>parcelRequire('f0Xe6'));
});
parcelRegister("9ZEuH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8sh5m").then(()=>parcelRequire('bEBPH'));
});
parcelRegister("79EI0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bWpk9").then(()=>parcelRequire('7je98'));
});
parcelRegister("cOuBw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eaPYI").then(()=>parcelRequire('jtmid'));
});
parcelRegister("bD9jM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3WyiK").then(()=>parcelRequire('bIUXp'));
});
parcelRegister("baMA9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l3kr9").then(()=>parcelRequire('lS242'));
});
parcelRegister("eloi9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6K5yD").then(()=>parcelRequire('8XWZN'));
});
parcelRegister("byQsJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6Tx3v").then(()=>parcelRequire('aEVWC'));
});
parcelRegister("a9vka", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eKeQP").then(()=>parcelRequire('9i2zg'));
});
parcelRegister("9JCSe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ey9vf").then(()=>parcelRequire('51PBB'));
});
parcelRegister("2K7kh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hUTF3").then(()=>parcelRequire('6jSdq'));
});
parcelRegister("d4rnX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kR04t").then(()=>parcelRequire('gzLKM'));
});
parcelRegister("8DokZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ggsD5").then(()=>parcelRequire('duDuC'));
});
parcelRegister("3W7d9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ecxca").then(()=>parcelRequire('aDxbD'));
});
parcelRegister("fAQPT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iHNxR").then(()=>parcelRequire('c4XO6'));
});
parcelRegister("ehTQ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h4CuB").then(()=>parcelRequire('4YPMu'));
});
parcelRegister("8qsLT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Vpgk").then(()=>parcelRequire('3xNOM'));
});
parcelRegister("eKe0H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("r1hFq").then(()=>parcelRequire('iqKVF'));
});
parcelRegister("jKG5Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3FN85").then(()=>parcelRequire('9lxSk'));
});
parcelRegister("jtrra", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dkhrC").then(()=>parcelRequire('flVSQ'));
});
parcelRegister("efOlM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a6vuH").then(()=>parcelRequire('fkDwX'));
});
parcelRegister("3tSnb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("amCQN").then(()=>parcelRequire('HQOUx'));
});
parcelRegister("81a9c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hj4Le").then(()=>parcelRequire('8tIoB'));
});
parcelRegister("7Dbrw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g1S6e").then(()=>parcelRequire('grLDU'));
});
parcelRegister("aK43C", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jBvqe").then(()=>parcelRequire('azMan'));
});
parcelRegister("f75YX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1jD0d").then(()=>parcelRequire('6fr7j'));
});
parcelRegister("dm8wZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l9E0I").then(()=>parcelRequire('h6bXz'));
});
parcelRegister("e6sqF", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$b3db1236ad5ab448$export$720676d8cac8fbb);
    var $4yxsk;
    var $2FQzx;
    const $b3db1236ad5ab448$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $b3db1236ad5ab448$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("2FQzx")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("lbvC2")));
            case 'da':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("7w4BN")));
            case 'de':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("1OJOa")));
            case 'en-GB':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("j4t4l")));
            case 'en-US':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("a3jAK")));
            case 'en-XA':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("gdAIe")));
            case 'en-XB':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("9OjZG")));
            case 'en-ZZ':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("8dpFw")));
            case 'en':
                return $b3db1236ad5ab448$var$importHelper(await Promise.resolve((parcelRequire("4yxsk"))));
            case 'es':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("1WHIj")));
            case 'et':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("lNiW9")));
            case 'fi':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("aJ2l5")));
            case 'fr':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("fiO8L")));
            case 'hu':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("k8E9z")));
            case 'it':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("bpDYD")));
            case 'ja':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("jCtnb")));
            case 'ko':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("cSVxf")));
            case 'nb':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("bLHK8")));
            case 'nl':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("3H4vd")));
            case 'pl':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("2Zggu")));
            case 'pt-BR':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("d25bi")));
            case 'ro':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("kqUBh")));
            case 'ru':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("h1vHU")));
            case 'sv':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("eak9R")));
            case 'th':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("lE2Fn")));
            case 'tr':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("2S1jH")));
            case 'uk':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("hVrZg")));
            case 'vi':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("5h8xq")));
            case 'zh-CN':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("cl1Kl")));
            case 'zh-TW':
                return $b3db1236ad5ab448$var$importHelper(await (parcelRequire("gbcRS")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("4yxsk"))));
        }
    };
});
parcelRegister("4yxsk", function(module, exports) {
    module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");
});
parcelRegister("lbvC2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("avAVb").then(()=>parcelRequire('hzYRh'));
});
parcelRegister("7w4BN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cD4PZ").then(()=>parcelRequire('gImjq'));
});
parcelRegister("1OJOa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fsauL").then(()=>parcelRequire('YNuQv'));
});
parcelRegister("j4t4l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cf431").then(()=>parcelRequire('1EszO'));
});
parcelRegister("a3jAK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aQa0A").then(()=>parcelRequire('96GNv'));
});
parcelRegister("gdAIe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gpPTW").then(()=>parcelRequire('2YjXk'));
});
parcelRegister("9OjZG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9PGuE").then(()=>parcelRequire('aNSCG'));
});
parcelRegister("8dpFw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("vN108").then(()=>parcelRequire('7EofI'));
});
parcelRegister("1WHIj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8FyGr").then(()=>parcelRequire('6rXEg'));
});
parcelRegister("lNiW9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eNIWW").then(()=>parcelRequire('1m6zT'));
});
parcelRegister("aJ2l5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jzdSg").then(()=>parcelRequire('7mBxr'));
});
parcelRegister("fiO8L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6hYA1").then(()=>parcelRequire('aqiZW'));
});
parcelRegister("k8E9z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("awnYp").then(()=>parcelRequire('lCdBJ'));
});
parcelRegister("bpDYD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iaD95").then(()=>parcelRequire('cTMUo'));
});
parcelRegister("jCtnb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1BEqF").then(()=>parcelRequire('fyS8N'));
});
parcelRegister("cSVxf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j4BdW").then(()=>parcelRequire('75f0b'));
});
parcelRegister("bLHK8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4UX4M").then(()=>parcelRequire('bC11i'));
});
parcelRegister("3H4vd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8ftM8").then(()=>parcelRequire('bBCdu'));
});
parcelRegister("2Zggu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7TOLZ").then(()=>parcelRequire('kpUpu'));
});
parcelRegister("d25bi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("klqOS").then(()=>parcelRequire('gpFEL'));
});
parcelRegister("kqUBh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jWPpS").then(()=>parcelRequire('kURum'));
});
parcelRegister("h1vHU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iHZUx").then(()=>parcelRequire('aqGng'));
});
parcelRegister("eak9R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hSHVv").then(()=>parcelRequire('buKCk'));
});
parcelRegister("lE2Fn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ffb7P").then(()=>parcelRequire('jAOJL'));
});
parcelRegister("2S1jH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ewAj9").then(()=>parcelRequire('i8Vea'));
});
parcelRegister("hVrZg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8M5Xq").then(()=>parcelRequire('rhno8'));
});
parcelRegister("5h8xq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7MDNY").then(()=>parcelRequire('dNSzw'));
});
parcelRegister("cl1Kl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lPJE6").then(()=>parcelRequire('cxqhJ'));
});
parcelRegister("gbcRS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3Sod7").then(()=>parcelRequire('jJYiN'));
});
parcelRegister("8bKEE", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$35553dea44acdddb$export$720676d8cac8fbb);
    var $30U7x;
    var $2FQzx;
    const $35553dea44acdddb$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
    const $35553dea44acdddb$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("2FQzx")).default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("jOLak")));
            case 'da':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("jfwge")));
            case 'de':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("e8ZVW")));
            case 'en-GB':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("7nDdl")));
            case 'en-US':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("c3IDl")));
            case 'en-XA':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("14eyQ")));
            case 'en-XB':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("jbe0E")));
            case 'en-ZZ':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("3ypg0")));
            case 'en':
                return $35553dea44acdddb$var$importHelper(await Promise.resolve((parcelRequire("30U7x"))));
            case 'es':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("7C7AB")));
            case 'et':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("h7J0z")));
            case 'fi':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("gTbkO")));
            case 'fr':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("hB2c6")));
            case 'hu':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("e2Y98")));
            case 'it':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("5HnWc")));
            case 'ja':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("3InKV")));
            case 'ko':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("94wMm")));
            case 'nb':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("jQaRG")));
            case 'nl':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("8oSVN")));
            case 'pl':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("lgA2g")));
            case 'pt-BR':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("fGDnK")));
            case 'ro':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("6FdoE")));
            case 'ru':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("irzub")));
            case 'sv':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("5POlf")));
            case 'th':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("jcuhQ")));
            case 'tr':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("bxs17")));
            case 'uk':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("4nFsT")));
            case 'vi':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("8FoyM")));
            case 'zh-CN':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("2p7N8")));
            case 'zh-TW':
                return $35553dea44acdddb$var$importHelper(await (parcelRequire("lTtmA")));
            default:
                return 0, ($parcel$interopDefault((0, parcelRequire("30U7x"))));
        }
    };
});
parcelRegister("30U7x", function(module, exports) {
    module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");
});
parcelRegister("jOLak", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gKdMl").then(()=>parcelRequire('ctoJr'));
});
parcelRegister("jfwge", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cbpwe").then(()=>parcelRequire('ka5ww'));
});
parcelRegister("e8ZVW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iAsyD").then(()=>parcelRequire('bFkOj'));
});
parcelRegister("7nDdl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e3y3n").then(()=>parcelRequire('hpSRq'));
});
parcelRegister("c3IDl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aXTbo").then(()=>parcelRequire('1EghR'));
});
parcelRegister("14eyQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gXq7X").then(()=>parcelRequire('3gPub'));
});
parcelRegister("jbe0E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("qxxAM").then(()=>parcelRequire('iycxg'));
});
parcelRegister("3ypg0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c5NXd").then(()=>parcelRequire('erVVU'));
});
parcelRegister("7C7AB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("KsjKG").then(()=>parcelRequire('ebJuY'));
});
parcelRegister("h7J0z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("76QxR").then(()=>parcelRequire('dAY2b'));
});
parcelRegister("gTbkO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("01RWt").then(()=>parcelRequire('3Dlt5'));
});
parcelRegister("hB2c6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8vAJ8").then(()=>parcelRequire('dDktO'));
});
parcelRegister("e2Y98", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fCgvF").then(()=>parcelRequire('gmWRq'));
});
parcelRegister("5HnWc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9cseC").then(()=>parcelRequire('7mXs1'));
});
parcelRegister("3InKV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3Hmpt").then(()=>parcelRequire('aVIfJ'));
});
parcelRegister("94wMm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jdsH4").then(()=>parcelRequire('d0cNB'));
});
parcelRegister("jQaRG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j9ncp").then(()=>parcelRequire('6Wore'));
});
parcelRegister("8oSVN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Gss6U").then(()=>parcelRequire('aZUDr'));
});
parcelRegister("lgA2g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dphRv").then(()=>parcelRequire('aFg4m'));
});
parcelRegister("fGDnK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8IZT2").then(()=>parcelRequire('aME0x'));
});
parcelRegister("6FdoE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4QxWI").then(()=>parcelRequire('aXepj'));
});
parcelRegister("irzub", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bYYz6").then(()=>parcelRequire('1lOZC'));
});
parcelRegister("5POlf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ffqnP").then(()=>parcelRequire('dzCVk'));
});
parcelRegister("jcuhQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bEbEF").then(()=>parcelRequire('lQEg3'));
});
parcelRegister("bxs17", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erZVI").then(()=>parcelRequire('hNwW9'));
});
parcelRegister("4nFsT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jeTTw").then(()=>parcelRequire('hWS0B'));
});
parcelRegister("8FoyM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Ej2sm").then(()=>parcelRequire('f03gt'));
});
parcelRegister("2p7N8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("mzFBS").then(()=>parcelRequire('8vnox'));
});
parcelRegister("lTtmA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lzHYr").then(()=>parcelRequire('kab7D'));
});
parcelRegister("2NxK6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3b9ecc94c924c4c$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $kkbo9;
    var $dZQ5a;
    var $KSWm7;
    var $5uXOq = parcelRequire("5uXOq");
    var $aMWg0;
    const $e3b9ecc94c924c4c$var$STABLE_OBJECT = {};
    const $e3b9ecc94c924c4c$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, Fallback: Fallback = null, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
        const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("KSWm7")).createPlacementComponent)(placementId, PlacementComponent), [
            placementId,
            PlacementComponent
        ]);
        const stableLocalPlacementProps = (0, (0, parcelRequire("kkbo9")).useStableObject)(placementProps ?? $e3b9ecc94c924c4c$var$STABLE_OBJECT);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("dZQ5a")).default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("aMWg0")).default), {
                    analyticsChannel: (0, $8b2df375607033fc$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                        fallback: Fallback,
                        children: (0, $2OMIu.jsx)(MemoizedPlacement, {
                            initialData: initialData,
                            context: context,
                            errorFallback: ErrorFallback,
                            ...stableLocalPlacementProps,
                            children: children
                        })
                    })
                })
        });
    };
    var $e3b9ecc94c924c4c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e3b9ecc94c924c4c$var$Placement);
});
parcelRegister("dZQ5a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aad3fbd652dce7e8$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $2WlU9 = parcelRequire("2WlU9");
    var $70qxv;
    var $iqtM5;
    var $8uSQj;
    var $kkbo9;
    var $bJnZB;
    var $hD3e9;
    var $bviTi;
    var $5uXOq = parcelRequire("5uXOq");
    var $elktR;
    var $56kpX;
    var $jbSDv;
    const $aad3fbd652dce7e8$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
        const fetcher = (0, (0, parcelRequire("bviTi")).usePlacementFetchingContext)();
        return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, (0, parcelRequire("elktR")).requestInitialData)(placementId, context, fetcher.fetch, {
                baseUrl: baseUrl,
                path: path
            }), [
            disableInitialData,
            baseUrl,
            path,
            placementId,
            context,
            fetcher.fetch
        ]);
    };
    const $aad3fbd652dce7e8$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
        const isUFOEnabled = (0, (0, parcelRequire("70qxv")).default).checkGate('enable_ufo_tracking_in_post_office');
        const postOfficeRoute = (0, (0, parcelRequire("8uSQj")).usePostOfficeRoute)();
        const context = (0, (0, parcelRequire("iqtM5")).usePostOfficeContext)();
        const { baseUrl: baseUrl, path: path } = (0, (0, parcelRequire("56kpX")).useBuildBasePath)();
        const stableContextWithRoute = (0, (0, parcelRequire("kkbo9")).useStableObject)({
            ...context,
            postOfficeRoute: postOfficeRoute
        });
        const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, (0, parcelRequire("bJnZB")).UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
            isUFOEnabled,
            placementId,
            consumptionType
        ]);
        const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure(error);
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure(error);
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure(error);
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure(error);
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }, [
            placementOnEvent,
            ufoV1PlacementTracker
        ]);
        const initialData = $aad3fbd652dce7e8$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
        const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
                source: (0, $e73218ef4db7c1d3$export$f7109619a5e9e0d6),
                componentName: `Placement`,
                attributes: {
                    placementId: placementId,
                    channel: 'in-app',
                    postOfficeFrontendVersion: (0, parcelRequire("jbSDv")).version
                }
            }), [
            placementId
        ]);
        return (0, $2OMIu.jsx)($aad3fbd652dce7e8$var$FeatureFlaggedUfoWrapper, {
            placementId: placementId,
            isEnabled: isUFOEnabled,
            children: (0, $2OMIu.jsx)((0, $2WlU9.PostOfficeAnalyticsContext), {
                data: placementAnalyticsContext,
                children: children({
                    initialData: initialData,
                    context: stableContextWithRoute,
                    onEvent: remoteComponentOnEvent
                })
            })
        });
    };
    var $aad3fbd652dce7e8$export$2e2bcd8739ae039 = $aad3fbd652dce7e8$var$Placement;
    const $aad3fbd652dce7e8$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
        if (isEnabled) return (0, $2OMIu.jsx)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOSegment, {
            name: (0, (0, parcelRequire("hD3e9")).UFOv2).SegmentNames.PLACEMENT,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("hD3e9")).UFOv2).UFOSegment, {
                name: `${(0, (0, parcelRequire("hD3e9")).UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
                children: children
            })
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
const $e73218ef4db7c1d3$export$85183a312807388d = 'postOffice';
const $e73218ef4db7c1d3$export$f7109619a5e9e0d6 = 'post-office-frontend';
parcelRegister("elktR", function(module, exports) {
    $parcel$export(module.exports, "requestInitialData", ()=>$ac9f7339341baed0$export$c4c39037cc4b06ab);
    const $ac9f7339341baed0$var$defaultFetcher = (url)=>fetch(url, {
            headers: {
                credentials: 'include',
                mode: 'cors',
                'Content-Type': 'application/json'
            }
        });
    const $ac9f7339341baed0$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $ac9f7339341baed0$var$defaultFetcher, options)=>{
        const baseUrl = options.baseUrl;
        const path = options.path;
        const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
        function stringifyObjectValues(input) {
            const entries = Object.entries(input);
            const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                    key,
                    String(value)
                ]);
            return Object.fromEntries(stringifiedEntries);
        }
        const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
        contextAsSearchParams.sort();
        const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams.toString()}`);
        return fetcher(url);
    };
});
parcelRegister("56kpX", function(module, exports) {
    $parcel$export(module.exports, "useBuildBasePath", ()=>$5a3dead9cd566c8f$export$83d6c58b7ab7ae67);
    var $d9RMb;
    var $fCLyO;
    var $5uXOq = parcelRequire("5uXOq");
    const $5a3dead9cd566c8f$export$83d6c58b7ab7ae67 = ()=>{
        const postOfficeEnvironment = (0, (0, parcelRequire("fCLyO")).usePostOfficeEnvironment)();
        return (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("d9RMb")).buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
            postOfficeEnvironment.currentEnv,
            postOfficeEnvironment.envConfigs
        ]);
    };
});
parcelRegister("d9RMb", function(module, exports) {
    $parcel$export(module.exports, "buildBasePath", ()=>$c735a34da49eaf51$export$e8b30f9c4a80230f);
    var $fCLyO;
    const $c735a34da49eaf51$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, (0, parcelRequire("fCLyO")).defaultEnvironmentValues).envConfigs)=>{
        const baseUrl = envConfigs[currentEnv].api.origin;
        const path = envConfigs[currentEnv].api.pathname ?? (0, $f773fdd9c7a555de$export$d4fe3482c88e73a8);
        return {
            baseUrl: baseUrl,
            path: path
        };
    };
});
parcelRegister("jbSDv", function(module, exports) {
    module.exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.4.1\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"exports\":{\".\":\"./src/index.ts\",\"./request-initial-data\":\"./src/initialDataClient.ts\"},\"publishConfig\":{\"exports\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"types\":\"./dist/types/index.d.ts\"}},\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn exec parcel build\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@atlassian/post-office-placement-data\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");
});
parcelRegister("aMWg0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b09d3b0a57db22e$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    var $fpTxz;
    var $5uXOq = parcelRequire("5uXOq");
    class $2b09d3b0a57db22e$var$ErrorBoundary extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        componentDidCatch(error, errorInfo) {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'handled',
                actionSubject: 'error',
                actionSubjectId: 'postOfficePlacementErrorBoundary',
                attributes: {
                    error: error?.message,
                    errorInfo: errorInfo,
                    placementId: this.props.placementId
                }
            });
            analyticsEvent.fire(this.props.analyticsChannel);
            this.props.onError({
                error: error,
                type: 'render-error'
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError) return this.props.fallback ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                children: this.props.fallback
            }) : null;
            return this.props.children;
        }
    }
    var $2b09d3b0a57db22e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("fpTxz")).default)()($2b09d3b0a57db22e$var$ErrorBoundary);
});
const $8b2df375607033fc$export$85183a312807388d = 'postOffice';
parcelRegister("5MOXH", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", ()=>$28b0af1f43bac953$export$46db7cd62b063064);
    var $2OMIu = parcelRequire("2OMIu");
    var $8uSQj;
    var $dBISY;
    var $cDLGE;
    var $2btzz;
    var $2NxK6;
    const $28b0af1f43bac953$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError })=>(0, $2OMIu.jsx)((0, (0, parcelRequire("2btzz")).ErrorBoundary), {
            fallback: errorFallback,
            onError: onError,
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("dBISY")).PlacementPreviewProvider), {
                eligibleMessages: eligibleMessages,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("2NxK6")).default), {
                    PlacementComponent: PlacementComponent,
                    placementId: placementId
                })
            })
        });
    const $28b0af1f43bac953$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
        const { searchParams: searchParams } = (0, (0, parcelRequire("8uSQj")).usePostOfficeRoute)();
        const previewId = searchParams?.get('contentfulPreviewId');
        const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
        const eligibleMessage = [
            {
                messageInstanceId: 'messageInstanceId',
                messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
                messageCategory: 'Engagement',
                context: {
                    id: previewId
                },
                createdAt: new Date().toString(),
                eventTime: new Date().toString(),
                triggerId: 'triggerId',
                messageCreationType: 'explicit'
            }
        ];
        if (isEnabled && hasPreviewType) return (0, $2OMIu.jsx)($28b0af1f43bac953$export$16e97e6603eadea, {
            placementId: "screen-space-flags",
            PlacementComponent: (0, (0, parcelRequire("cDLGE")).ScreenSpaceFlagsPlacementComponent),
            eligibleMessages: eligibleMessage
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    };
});
parcelRegister("dBISY", function(module, exports) {
    $parcel$export(module.exports, "PlacementPreviewProvider", ()=>$2fad84642f3fefc9$export$52e362b70e115c68);
    var $bviTi;
    var $5uXOq = parcelRequire("5uXOq");
    const $2fad84642f3fefc9$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
    const $2fad84642f3fefc9$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
    const $2fad84642f3fefc9$export$52e362b70e115c68 = ({ eligibleMessages: eligibleMessages, children: children })=>{
        const fetch = (0, $5uXOq.useMemo)(()=>$2fad84642f3fefc9$export$c05392ff95b4319d({
                eligibleMessages: eligibleMessages
            }), [
            eligibleMessages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bviTi")).PlacementFetchingProvider), {
            fetch: fetch
        }, children);
    };
    const $2fad84642f3fefc9$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
            const finalUrl = url.replace($2fad84642f3fefc9$export$e5ffd38dcf6e5c53, $2fad84642f3fefc9$export$85c4756977e87c75);
            const payload = {
                originalMethod: options?.method || 'GET',
                originalBody: $2fad84642f3fefc9$var$parseBody(options?.body),
                eligibleMessages: eligibleMessages
            };
            return globalThis.fetch(finalUrl, {
                ...options,
                method: 'POST',
                headers: {
                    ...options?.headers || {}
                },
                body: $2fad84642f3fefc9$var$stringifyPayload(payload)
            });
        };
    const $2fad84642f3fefc9$var$objectHasKeys = (input)=>!!Object.keys(input).length;
    const $2fad84642f3fefc9$var$parseBody = (body)=>{
        if (typeof body === 'undefined' || body === null) return undefined;
        try {
            const parsedBody = JSON.parse(body);
            if ($2fad84642f3fefc9$var$objectHasKeys(parsedBody)) return parsedBody;
            throw new Error();
        } catch  {
            throw new Error('Unable to parse preview body. Is it a valid object?');
        }
    };
    const $2fad84642f3fefc9$var$stringifyPayload = (payload)=>{
        try {
            return JSON.stringify(payload);
        } catch  {
            throw new Error('Unable to parse preview body. Is it a valid object?');
        }
    };
});
parcelRegister("2btzz", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$19738c62011ce94f$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    'use client';
    const $19738c62011ce94f$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
    const $19738c62011ce94f$var$initialState = {
        didCatch: false,
        error: null
    };
    class $19738c62011ce94f$export$e926676385687eaf extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $19738c62011ce94f$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($19738c62011ce94f$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $19738c62011ce94f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($19738c62011ce94f$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $5uXOq.createElement)($19738c62011ce94f$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $19738c62011ce94f$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $19738c62011ce94f$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $19738c62011ce94f$export$c052f6604b7d51fe() {
        const context = (0, $5uXOq.useContext)($19738c62011ce94f$export$b16d9fb1a22de840);
        $19738c62011ce94f$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $5uXOq.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $5uXOq.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $19738c62011ce94f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($19738c62011ce94f$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
const $d0ca21152325de6b$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';
parcelRegister("eKtC8", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$31b7f947593face8$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $heNNl;
    const $31b7f947593face8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
        if (false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: "jiraEntry",
            fallback: "page",
            withExperienceTracker: withExperienceTracker
        }, children);
    };
});
parcelRegister("bAjl9", function(module, exports) {
    $parcel$export(module.exports, "IntlProviders", ()=>$fad1cef37914a278$export$c9d8cd4516cc55a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $1nUas;
    const $fad1cef37914a278$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
            messages: messages,
            locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale)
        }, children);
});
parcelRegister("1nUas", function(module, exports) {
    $parcel$export(module.exports, "IntlProvider", ()=>$0264700d4de7e638$export$480518999dfc4151);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...props,
            defaultLocale: props.locale
        }, children);
});
parcelRegister("lvG9V", function(module, exports) {
    $parcel$export(module.exports, "MetricsContainers", ()=>$2bc2dec1250f1cf8$export$2d1617bc0040e5d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $jb5yn;
    var $8ApFP;
    var $iXVV6;
    var $kDdFQ;
    const $2bc2dec1250f1cf8$export$2d1617bc0040e5d9 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jb5yn")).ExperienceTrackerProvider), null, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "metrics-containers-subproduct-updater",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDdFQ")).SubProductUpdater), null)), children));
});
parcelRegister("jb5yn", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTrackerProvider", ()=>$bcd25bc85dfeb009$export$6f49c95a810d59fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnN0Q;
    var $6XbhC;
    var $9sAyK;
    const $bcd25bc85dfeb009$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
            callback
        ]);
    const $bcd25bc85dfeb009$export$6f49c95a810d59fa = ({ children: children })=>{
        const [experienceTracker] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("jnN0Q")).ExperienceTracker)());
        const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, (0, parcelRequire("9sAyK")).sliSubscriber)));
        const cleanup = (0, $5uXOq.useCallback)(()=>{
            cleanupSliSub();
        }, [
            cleanupSliSub
        ]);
        $bcd25bc85dfeb009$var$useUnmount(cleanup);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XbhC")).ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, children);
    };
});
parcelRegister("9sAyK", function(module, exports) {
    $parcel$export(module.exports, "sliSubscriber", ()=>$6b2f2360dd11edee$export$db0b99fe17114899);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6b2f2360dd11edee$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: action,
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                reason: location,
                analyticsSource: analyticsSource,
                application: $6b2f2360dd11edee$var$transformApplication(application),
                edition: $6b2f2360dd11edee$var$transformEdition(edition),
                ...errorMessage && {
                    errorMessage: errorMessage
                }
            }
        });
    const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
    const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
        const { name: name, action: action } = event;
        const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
        if (disableSli) return;
        switch(action){
            case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    ...event.error && {
                        errorMessage: String(event.error)
                    },
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
                break;
            default:
        }
    };
});
parcelRegister("kDdFQ", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5dc03f10b4b74566$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $cfDZ3;
    var $16v4H;
    const $5dc03f10b4b74566$export$eb40d3df56aa5c53 = ()=>{
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cfDZ3")).setSubProduct)(subProduct);
        }, [
            subProduct
        ]);
        return null;
    };
});
parcelRegister("16v4H", function(module, exports) {
    $parcel$export(module.exports, "subProductFromProjectType", ()=>$f7eda04ad2dc7e84$export$246e1e2a5c86a633);
    $parcel$export(module.exports, "useSubProduct", ()=>$f7eda04ad2dc7e84$export$16aa2ad52cd8992a);
    var $4DPZY;
    const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
        switch(projectType){
            case 'business':
                return 'core';
            case 'product_discovery':
            case 'software':
                return 'software';
            case 'service_desk':
                return 'serviceDesk';
            default:
                projectType;
                return 'unknown';
        }
    };
    const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
        const [{ data: data }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        if (!data?.project) return null;
        return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
    };
});
parcelRegister("gPTB6", function(module, exports) {
    $parcel$export(module.exports, "NavigationContainers", ()=>$1720b620f5483501$export$36f9ed697cae18ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $8ploF;
    let $1720b620f5483501$var$Containers = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (!false) $1720b620f5483501$var$Containers = (0, (0, parcelRequire("8ploF")).ClientOnlyNavigationContainers);
    const $1720b620f5483501$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)($1720b620f5483501$var$Containers);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1720b620f5483501$var$Containers, {
            baseUrl: baseUrl
        }, children);
    };
});
parcelRegister("8ploF", function(module, exports) {
    $parcel$export(module.exports, "ClientOnlyNavigationContainers", ()=>$f5cf024286957bf6$export$68d7c1e44acfd599);
    var $5uXOq = parcelRequire("5uXOq");
    var $axSKo;
    const $f5cf024286957bf6$export$68d7c1e44acfd599 = ({ children: children })=>{
        if (!false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("axSKo")).Provider), null, children);
        return null;
    };
});
parcelRegister("9kep9", function(module, exports) {
    $parcel$export(module.exports, "PageConfigContainers", ()=>$83e79f36d4d977db$export$9c661932489b4130);
    var $5uXOq = parcelRequire("5uXOq");
    var $9MAC1;
    var $j8DrX;
    var $6nkVm;
    var $aX7Cy;
    const $83e79f36d4d977db$export$9c661932489b4130 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MAC1")).ThemeContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleContainer), {
            titleSuffix: (0, (0, parcelRequire("aX7Cy")).ripTitleTemplateFromMeta)((0, (0, parcelRequire("j8DrX")).default))
        }, children));
});
parcelRegister("9MAC1", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$a1f770a9d49220c1$export$93d4e7f90805808f);
    $parcel$export(module.exports, "ThemeContainer", ()=>$a1f770a9d49220c1$export$11eb671888ed6e7d);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $LtWMd;
    const $a1f770a9d49220c1$var$initialState = {
        navigationTheme: {
            shouldShowTitle: false,
            logoUrl: '',
            usesCustomColours: false,
            backgroundColor: '',
            highlightColor: ''
        }
    };
    const $a1f770a9d49220c1$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'theme',
        initialState: $a1f770a9d49220c1$var$initialState,
        actions: (0, parcelRequire("LtWMd"))
    });
    const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, (0, parcelRequire("51nlc")).createSubscriber)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, (0, parcelRequire("3sQ5x")).createHook)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, (0, parcelRequire("gg7kZ")).createContainer)($a1f770a9d49220c1$var$Store, {
        onInit: (0, parcelRequire("LtWMd")).bootstrap
    });
});
parcelRegister("LtWMd", function(module, exports) {
    $parcel$export(module.exports, "bootstrap", ()=>$9594f0aa641d3463$export$36aff1fbb4f5dfc6);
    $parcel$export(module.exports, "update", ()=>$9594f0aa641d3463$export$722fbec263ad908a);
    const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
            const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
            const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
            const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $5e0c0d4e15efb4a6$exports).N0 || ajsHighlightColor !== (0, $5e0c0d4e15efb4a6$exports).B400);
            const navigationTheme = {
                shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
                logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
                usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
                backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
                highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $5e0c0d4e15efb4a6$exports).B400})`
            };
            if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
            setState({
                navigationTheme: navigationTheme
            });
        };
    const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
            const navigationTheme = {
                ...getState().navigationTheme,
                ...item
            };
            setState({
                navigationTheme: navigationTheme
            });
        };
});
parcelRegister("6nkVm", function(module, exports) {
    $parcel$export(module.exports, "useDocumentTitleActions", ()=>$301148c3154b34a4$export$57c0fda036e12d67);
    $parcel$export(module.exports, "DocumentTitleContainer", ()=>$301148c3154b34a4$export$1aad43993172f16f);
    $parcel$export(module.exports, "DocumentTitleSubscriber", ()=>$301148c3154b34a4$export$b88d5abf3e0bec8c);
    $parcel$export(module.exports, "DocumentTitleHelper", ()=>$301148c3154b34a4$export$573bf8d2ae7d60dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $51nlc;
    var $3Nww0;
    var $aX7Cy;
    const $301148c3154b34a4$var$initialState = {
        title: '',
        defaultTitle: '',
        contextArray: []
    };
    const $301148c3154b34a4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'document-title',
        initialState: $301148c3154b34a4$var$initialState,
        actions: (0, parcelRequire("3Nww0"))
    });
    const $301148c3154b34a4$export$57c0fda036e12d67 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($301148c3154b34a4$var$Store);
    const $301148c3154b34a4$export$1aad43993172f16f = (0, (0, parcelRequire("gg7kZ")).createContainer)($301148c3154b34a4$var$Store, {
        displayName: 'DocumentTitleContainer'
    });
    const $301148c3154b34a4$export$b88d5abf3e0bec8c = (0, (0, parcelRequire("51nlc")).createSubscriber)($301148c3154b34a4$var$Store, {
        displayName: 'DocumentTitleSubscriber'
    });
    class $301148c3154b34a4$export$573bf8d2ae7d60dc extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.myself = Symbol('document title identifier');
            this.props.addDocumentTitle(this.myself);
        }
        componentDidMount() {
            this.updateTitle();
        }
        componentDidUpdate() {
            this.updateTitle();
        }
        componentWillUnmount() {
            this.props.removeDocumentTitle(this.myself);
            this.updateTitle();
        }
        updateTitle() {
            if ((0, (0, parcelRequire("aX7Cy")).checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("3Nww0", function(module, exports) {
    $parcel$export(module.exports, "setTitle", ()=>(parcelRequire("9vNeL")).default);
    $parcel$export(module.exports, "addDocumentTitle", ()=>(parcelRequire("5Oj7f")).addDocumentTitle);
    $parcel$export(module.exports, "removeDocumentTitle", ()=>(parcelRequire("gJBAO")).removeDocumentTitle);
    var $9vNeL;
    var $5Oj7f;
    var $gJBAO;
});
parcelRegister("9vNeL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa0c91bbbd212a23$export$2e2bcd8739ae039);
    var $aX7Cy;
    var $aa0c91bbbd212a23$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
            const state = getState();
            const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
            const newTitle = (0, (0, parcelRequire("aX7Cy")).createTitleFromTemplate)(title, titleTemplate);
            document.title = newTitle;
            setState({
                ...state,
                title: newTitle
            });
        };
});
parcelRegister("aX7Cy", function(module, exports) {
    $parcel$export(module.exports, "createTitleFromTemplate", ()=>$45855f8363268b1b$export$3795256dd54a9c9d);
    $parcel$export(module.exports, "ripTitleTemplateFromMeta", ()=>$45855f8363268b1b$export$b7d18105f80195c);
    $parcel$export(module.exports, "checkDocumentTitle", ()=>$45855f8363268b1b$export$7f8be70a0bed1bae);
    const $45855f8363268b1b$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
    const $45855f8363268b1b$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
    const $45855f8363268b1b$export$7f8be70a0bed1bae = (title, contextArray)=>{
        if (contextArray[contextArray.length - 1] === title) return true;
        return false;
    };
});
parcelRegister("5Oj7f", function(module, exports) {
    $parcel$export(module.exports, "addDocumentTitle", ()=>$53f35561ab86eb34$export$a0c188c0ea474bb8);
    const $53f35561ab86eb34$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            contextArray.push(title);
            setState({
                contextArray: contextArray
            });
        };
});
parcelRegister("gJBAO", function(module, exports) {
    $parcel$export(module.exports, "removeDocumentTitle", ()=>$bcdbd43154f62b45$export$e844009b77f80a72);
    const $bcdbd43154f62b45$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            setState({
                contextArray: contextArray.filter((symbol)=>symbol !== title)
            });
        };
});
parcelRegister("eSznd", function(module, exports) {
    $parcel$export(module.exports, "UiManagers", ()=>$ca023ab667a452ba$export$41286c339a88ca24);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $e0Brz;
    var $5zgk6;
    var $9rAvm;
    let $ca023ab667a452ba$var$ClientUiManagers = (0, $5uXOq.Fragment);
    if (!false) $ca023ab667a452ba$var$ClientUiManagers = (0, (0, parcelRequire("9rAvm")).ClientUiManagers);
    const $ca023ab667a452ba$export$41286c339a88ca24 = ({ children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)($ca023ab667a452ba$var$ClientUiManagers);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5zgk6")).LayoutManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement($ca023ab667a452ba$var$ClientUiManagers, null, children)));
    };
});
parcelRegister("e0Brz", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbManager", ()=>$e20dc5e8426041f9$export$cd5073909dd92c28);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIVNN;
    const $e20dc5e8426041f9$export$cd5073909dd92c28 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aIVNN")).BreadcrumbContainer), null, children);
});
parcelRegister("5zgk6", function(module, exports) {
    $parcel$export(module.exports, "LayoutManager", ()=>$20f0b1159f4863ef$export$4a04ad01c410b415);
    var $5uXOq = parcelRequire("5uXOq");
    var $c34Wf;
    var $lODMY;
    var $2YP9W;
    var $gg7kZ;
    var $8CM3x;
    var $5e5zm;
    const $20f0b1159f4863ef$var$LayoutContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        displayName: 'JiraLayoutContainer',
        onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setIsChromeless(isChromeless));
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setLeftSidebarState(leftSidebar));
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setRightSidebarState(rightSidebar));
            },
        onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
                dispatch((0, (0, parcelRequire("8CM3x")).actions).setIsChromeless(isChromeless));
            }
    });
    const $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
        stackState: []
    };
    const $20f0b1159f4863ef$var$useIsChromeless = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
    const $20f0b1159f4863ef$export$4a04ad01c410b415 = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c34Wf")).navigationUiStateResource));
        const isChromeless = $20f0b1159f4863ef$var$useIsChromeless();
        const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
        const leftSidebarWidth = data?.leftSidebar?.width ?? (0, (0, parcelRequire("5e5zm")).DEFAULT_LEFT_SIDEBAR_WIDTH);
        const leftSidebar = (0, $5uXOq.useMemo)(()=>({
                isVisible: true,
                isCollapsed: isLeftSidebarCollapsed,
                width: leftSidebarWidth,
                isFlyoutOpen: false
            }), [
            isLeftSidebarCollapsed,
            leftSidebarWidth
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($20f0b1159f4863ef$var$LayoutContainer, {
            isGlobal: true,
            isChromeless: isChromeless,
            leftSidebar: leftSidebar,
            rightSidebar: $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE
        }, children);
    };
});
parcelRegister("9rAvm", function(module, exports) {
    $parcel$export(module.exports, "ClientUiManagers", ()=>$2b5f3846e82b020b$export$d1db6ae5bf84e489);
    var $5uXOq = parcelRequire("5uXOq");
    var $hfc8j;
    var $6pvrS;
    var $4041n;
    var $pa9q9;
    var $2HbP2;
    var $4yEIl;
    var $bKCrm;
    const $2b5f3846e82b020b$export$d1db6ae5bf84e489 = ({ children: children })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6pvrS")).CrossFlowProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4yEIl")).PostOfficeProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4041n")).FavoriteChangeProvider), {
            onShowFlag: showFlag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hfc8j")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, children))))));
    };
});
parcelRegister("6pvrS", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$2cd77fddb456dca8$export$d900e4062895cd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $kNJj6 = parcelRequire("kNJj6");
    var $fjcgS;
    var $9OXo1;
    var $g2XuF;
    var $5emZd;
    const $2cd77fddb456dca8$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
            sendUIEvent: ()=>{},
            sendOperationalEvent: ()=>{},
            sendTrackEvent: ()=>{},
            sendScreenEvent: ()=>{}
        }) : (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
    const $2cd77fddb456dca8$export$d900e4062895cd7c = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $kNJj6.default), {
                cloudId: cloudId,
                analyticsClient: $2cd77fddb456dca8$var$getAnalyticsInstance(),
                locale: locale,
                plugins: [
                    (0, (0, parcelRequire("g2XuF")).getContainersPlugin),
                    (0, (0, parcelRequire("5emZd")).getUsersPlugin)
                ]
            }, children));
});
parcelRegister("kNJj6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78de319c5642be75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7kdd7 = parcelRequire("7kdd7");
    var $ar8lZ = parcelRequire("ar8lZ");
    const $78de319c5642be75$var$JiraProvider = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7kdd7.CrossFlowProvider), {
            ...props,
            originProduct: "jira"
        });
    };
    var $78de319c5642be75$export$2e2bcd8739ae039 = $78de319c5642be75$var$JiraProvider;
});
parcelRegister("7kdd7", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$ec5775ca769d37f4$export$d900e4062895cd7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f9lvx = parcelRequire("f9lvx");
    var $i1gCV;
    var $70qxv;
    var $2Pyf3 = parcelRequire("2Pyf3");
    var $2hF7U = parcelRequire("2hF7U");
    var $8htSm = parcelRequire("8htSm");
    var $c2r1L = parcelRequire("c2r1L");
    var $jOZg3 = parcelRequire("jOZg3");
    var $dXjol = parcelRequire("dXjol");
    var $l5wq2 = parcelRequire("l5wq2");
    const $ec5775ca769d37f4$var$IntegrationView = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("2kVuq")));
    const $ec5775ca769d37f4$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
            const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
            const tblz852ExperimentCohort = (0, (0, parcelRequire("70qxv")).default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
                fireExperimentExposure: false
            });
            const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
            const onCloseResolver = (0, $5uXOq.useRef)();
            const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $5uXOq.useState)(false);
            const fireEvent = (0, $5uXOq.useMemo)(()=>(0, $2Pyf3.analyticsWrapper)(analyticsClient), [
                analyticsClient
            ]);
            const [requestOptions, setRequestOptions] = (0, $5uXOq.useState)();
            const onAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
                const gasV3Event = (0, $2hF7U.transformEvent)(payload);
                if (gasV3Event) {
                    const enrichedEvent = (0, $dXjol.enrichWithRequestOptions)((0, $jOZg3.enrichWithPackageDetails)(gasV3Event), requestOptions);
                    fireEvent(enrichedEvent);
                }
            }, [
                fireEvent,
                requestOptions
            ]);
            const onHandShake = (0, $5uXOq.useCallback)((appName)=>{
                if (!firstHandshakeReceived) {
                    onAnalyticsEvent({
                        payload: {
                            eventType: (0, $a428e064f91eae50$export$12346a674644c156),
                            action: (0, $l5wq2.uiInitialized),
                            actionSubject: (0, $l5wq2.crossFlowActionSubject),
                            attributes: {
                                appName: appName
                            }
                        },
                        context: [
                            {
                                source: $l5wq2.source
                            }
                        ]
                    });
                    setFirstHandshakeReceived(true);
                }
            }, [
                firstHandshakeReceived,
                onAnalyticsEvent
            ]);
            const onOpen = (0, $5uXOq.useCallback)((options)=>{
                setFirstHandshakeReceived(false);
                const analyticsEvent = {
                    payload: (0, $dXjol.enrichWithRequestOptions)({
                        eventType: (0, $a428e064f91eae50$export$12346a674644c156),
                        action: (0, $l5wq2.openInvoked),
                        actionSubject: (0, $l5wq2.crossFlowActionSubject)
                    }, options),
                    context: [
                        {
                            source: $l5wq2.source
                        }
                    ]
                };
                onAnalyticsEvent(analyticsEvent);
                if (options.journey === (0, $f9lvx.Journeys).GET_STARTED && redirectToWac) {
                    (0, $8htSm.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                    const completionStatus = {};
                    return Promise.resolve(completionStatus);
                }
                const updatedExperimentalOptions = {
                    ...globalExperimentalOptions || {},
                    ...options.experimentalOptions || {}
                };
                options.experimentalOptions = updatedExperimentalOptions;
                setRequestOptions(options);
                return new Promise((resolve)=>{
                    onCloseResolver.current = resolve;
                });
            }, [
                onAnalyticsEvent,
                env,
                redirectToWac,
                globalExperimentalOptions
            ]);
            const onClose = (0, $5uXOq.useCallback)((completionStatus)=>{
                setFirstHandshakeReceived(false);
                setRequestOptions(undefined);
                onCloseResolver.current && onCloseResolver.current(completionStatus);
            }, []);
            const { colorMode: colorMode } = (0, (0, parcelRequire("i1gCV")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $f9lvx.BaseCrossFlowApiProvider), {
                onOpen: onOpen
            }, children, requestOptions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c2r1L.ErrorBoundary), {
                onAnalyticsEvent: onAnalyticsEvent,
                onError: onError
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(IntegrationView, {
                ...baseProviderProps,
                ...requestOptions,
                onAnalyticsEvent: onAnalyticsEvent,
                originProduct: originProduct,
                theme: colorMode,
                onClose: onClose,
                onHandShake: onHandShake,
                plugins: plugins,
                env: env,
                redirectToWac: redirectToWac,
                isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
                zIndex: requestOptions.zIndex ?? 1000
            }))));
        };
    const $ec5775ca769d37f4$export$d900e4062895cd7c = $ec5775ca769d37f4$export$79d79d8dd8574306($ec5775ca769d37f4$var$IntegrationView);
});
parcelRegister("2Pyf3", function(module, exports) {
    $parcel$export(module.exports, "analyticsWrapper", ()=>$5f38743e5bd06d60$export$91b4dd3bfc301325);
    const $5f38743e5bd06d60$export$91b4dd3bfc301325 = (analyticsClient)=>{
        return (event)=>{
            return Promise.resolve(analyticsClient).then((client)=>{
                switch(event.eventType){
                    case 0, $a428e064f91eae50$export$a1562d08625f5d7e:
                        client.sendUIEvent(event);
                        break;
                    case 0, $a428e064f91eae50$export$947dac6c72b26f81:
                        client.sendTrackEvent(event);
                        break;
                    case 0, $a428e064f91eae50$export$12346a674644c156:
                        client.sendOperationalEvent(event);
                        break;
                    case 0, $a428e064f91eae50$export$f1d537d508d2945a:
                        client.sendScreenEvent(event);
                        break;
                }
            });
        };
    };
});
parcelRegister("2hF7U", function(module, exports) {
    $parcel$export(module.exports, "transformEvent", ()=>$026bccee06a4004f$export$3f40e8c44448be30);
    const $026bccee06a4004f$var$GROWTH_TAG = 'growth';
    const $026bccee06a4004f$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
            propertyNames.forEach((propertyName)=>{
                const navContextProp = contextItem ? contextItem[propertyName] : null;
                acc.push(navContextProp || contextItem[propertyName]);
            });
            return acc;
        }, []).filter(Boolean);
    const $026bccee06a4004f$var$getSources = (context)=>$026bccee06a4004f$var$extractFromEventContext([
            'source'
        ], context);
    const $026bccee06a4004f$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
            const newAttributes = {
                ...ans,
                ...contextProps
            };
            return attributes ? {
                ...newAttributes,
                ...attributes
            } : newAttributes;
        }, {});
    const $026bccee06a4004f$var$getPackageInfo = (context)=>context.map((contextItem)=>({
                packageName: contextItem.packageName,
                packageVersion: contextItem.packageVersion
            })).filter((p)=>p.packageName);
    const $026bccee06a4004f$var$last = (values)=>values[values.length - 1];
    const $026bccee06a4004f$export$3f40e8c44448be30 = (event)=>{
        const { context: context, payload: payload } = event;
        if (!payload) return null;
        const sources = $026bccee06a4004f$var$getSources(context);
        const source = $026bccee06a4004f$var$last(sources) || (0, $a428e064f91eae50$export$b055de0e665cb20c);
        const extraAttributes = $026bccee06a4004f$var$getExtraAttributes(context);
        const { packageName: packageName, packageVersion: packageVersion } = $026bccee06a4004f$var$last($026bccee06a4004f$var$getPackageInfo(context)) || {};
        const { eventType: eventType = (0, $a428e064f91eae50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
        const attributes = {
            packageName: packageName,
            packageVersion: packageVersion,
            ...extraAttributes,
            ...payloadAttributes
        };
        const tags = payload.tags || [];
        tags.push($026bccee06a4004f$var$GROWTH_TAG);
        switch(eventType){
            case 0, $a428e064f91eae50$export$a1562d08625f5d7e:
            case 0, $a428e064f91eae50$export$12346a674644c156:
            case 0, $a428e064f91eae50$export$947dac6c72b26f81:
                return {
                    eventType: eventType,
                    source: source,
                    actionSubject: actionSubject,
                    action: action,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes,
                    tags: tags.slice(0)
                };
            case 0, $a428e064f91eae50$export$f1d537d508d2945a:
                return {
                    eventType: eventType,
                    name: name,
                    attributes: attributes,
                    source: source,
                    tags: tags.slice(0)
                };
            default:
                break;
        }
        return null;
    };
});
parcelRegister("8htSm", function(module, exports) {
    $parcel$export(module.exports, "setProductSignUpLocation", ()=>$2dc48449442b3996$export$2827e2473cb9a346);
    var $1EKWF = parcelRequire("1EKWF");
    var $3BtVI = parcelRequire("3BtVI");
    const $2dc48449442b3996$var$utmCampaignMap = {
        'atlassian-switcher': (0, $3BtVI.UtmCampaign)['atlassian-switcher']
    };
    const $2dc48449442b3996$var$isBundledProduct = (productKey)=>{
        return [
            (0, $1EKWF.Targets).JIRA_SOFTWARE,
            (0, $1EKWF.Targets).JIRA_SERVICE_DESK,
            (0, $1EKWF.Targets).JIRA_CORE,
            (0, $1EKWF.Targets).CONFLUENCE
        ].includes(productKey);
    };
    const $2dc48449442b3996$var$getBundleSignUpParams = (productKey)=>{
        const bundles = {
            [(0, $1EKWF.Targets).JIRA_SOFTWARE]: 'jira-software',
            [(0, $1EKWF.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
            [(0, $1EKWF.Targets).JIRA_CORE]: 'jira-core',
            [(0, $1EKWF.Targets).CONFLUENCE]: 'confluence'
        };
        return `bundle=${bundles[productKey]}&edition=free`;
    };
    const $2dc48449442b3996$var$isProductWithCustomSignUpPath = (productKey)=>{
        return [
            (0, $1EKWF.Targets).OPSGENIE
        ].includes(productKey);
    };
    const $2dc48449442b3996$var$getProductCustomSignUpPath = (productKey)=>{
        const links = {
            [(0, $1EKWF.Targets).OPSGENIE]: (0, $c065e6de1a6db434$export$fb1e43fdafe12e9b)
        };
        return links[productKey];
    };
    const $2dc48449442b3996$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
        return Boolean($2dc48449442b3996$var$utmCampaignMap[sourceComponent]);
    };
    const $2dc48449442b3996$var$getUtmParams = (sourceComponent, sourceContext)=>{
        let utmParams = '';
        if (sourceComponent && $2dc48449442b3996$var$isSourceComponentWithUtmParams(sourceComponent)) {
            utmParams = utmParams + `utm_campaign=${$2dc48449442b3996$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
            if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
        }
        return utmParams;
    };
    const $2dc48449442b3996$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
        const wacUrl = env === 'staging' ? (0, $c065e6de1a6db434$export$c37558e5c67d2b01) : (0, $c065e6de1a6db434$export$f199baf8dfc7621e);
        const utmParams = $2dc48449442b3996$var$getUtmParams(sourceComponent, sourceContext);
        let queryParams = '';
        let bundleParams = '';
        let path = (0, $c065e6de1a6db434$export$2a45a00073911255);
        if ($2dc48449442b3996$var$isBundledProduct(productKey)) {
            path = (0, $c065e6de1a6db434$export$e6c04a1dd86d1c14);
            bundleParams = $2dc48449442b3996$var$getBundleSignUpParams(productKey);
        } else if ($2dc48449442b3996$var$isProductWithCustomSignUpPath(productKey)) path = $2dc48449442b3996$var$getProductCustomSignUpPath(productKey);
        if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
        if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
        return wacUrl + path + queryParams;
    };
    const $2dc48449442b3996$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
        const url = $2dc48449442b3996$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
        window.open(url, '_blank');
    };
});
const $c065e6de1a6db434$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $c065e6de1a6db434$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $c065e6de1a6db434$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $c065e6de1a6db434$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $c065e6de1a6db434$export$2a45a00073911255 = '/software';
parcelRegister("3BtVI", function(module, exports) {
    $parcel$export(module.exports, "UtmCampaign", ()=>$dea2f50e8d79908b$export$fc604aa353a97e10);
    var $dea2f50e8d79908b$export$fc604aa353a97e10;
    (function(UtmCampaign) {
        UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    })($dea2f50e8d79908b$export$fc604aa353a97e10 || ($dea2f50e8d79908b$export$fc604aa353a97e10 = {}));
});
parcelRegister("c2r1L", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$d0801c3fce9fcc73$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $l5wq2 = parcelRequire("l5wq2");
    const $d0801c3fce9fcc73$var$name = "platform-pkg";
    const $d0801c3fce9fcc73$var$version = "0.0.0-use.local";
    const $d0801c3fce9fcc73$var$payload = {
        eventType: (0, $a428e064f91eae50$export$12346a674644c156),
        action: (0, $l5wq2.errorBoundaryAction),
        actionSubject: (0, $l5wq2.errorBoundaryActionSubject)
    };
    const $d0801c3fce9fcc73$var$context = [
        {
            source: $l5wq2.source
        },
        {
            packageName: $d0801c3fce9fcc73$var$name,
            packageVersion: $d0801c3fce9fcc73$var$version
        }
    ];
    class $d0801c3fce9fcc73$export$e926676385687eaf extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        componentDidCatch(error) {
            this.props.onAnalyticsEvent({
                payload: $d0801c3fce9fcc73$var$payload,
                context: $d0801c3fce9fcc73$var$context
            });
            if (this.props.onError) this.props.onError(error);
        }
        render() {
            if (this.state.hasError) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            };
        }
    }
});
parcelRegister("l5wq2", function(module, exports) {
    $parcel$export(module.exports, "source", ()=>$6d066a4c001da312$export$b4d5da5f34fb77ad);
    $parcel$export(module.exports, "errorBoundaryAction", ()=>$6d066a4c001da312$export$9d8252a268f4fa72);
    $parcel$export(module.exports, "errorBoundaryActionSubject", ()=>$6d066a4c001da312$export$1045419caf49b395);
    $parcel$export(module.exports, "crossFlowActionSubject", ()=>$6d066a4c001da312$export$d54c183f56e39aa5);
    $parcel$export(module.exports, "uiInitialized", ()=>$6d066a4c001da312$export$e5c2c058fa8068a6);
    $parcel$export(module.exports, "openInvoked", ()=>$6d066a4c001da312$export$e67cdcb8867a3bd0);
    $parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", ()=>$a428e064f91eae50$export$12346a674644c156);
    const $6d066a4c001da312$export$b4d5da5f34fb77ad = 'crossFlowProvider';
    const $6d066a4c001da312$export$9d8252a268f4fa72 = 'errorCaught';
    const $6d066a4c001da312$export$1045419caf49b395 = 'errorBoundary';
    const $6d066a4c001da312$export$d54c183f56e39aa5 = 'crossFlowSupport';
    const $6d066a4c001da312$export$e5c2c058fa8068a6 = 'uiInitialized';
    const $6d066a4c001da312$export$e67cdcb8867a3bd0 = 'openInvoked';
});
parcelRegister("jOZg3", function(module, exports) {
    $parcel$export(module.exports, "enrichWithPackageDetails", ()=>$caa4562a392de104$export$59518efab336a8b5);
    const $caa4562a392de104$var$version = "0.0.0-use.local";
    const $caa4562a392de104$export$84f9cf7ef89d4c26 = {
        version: $caa4562a392de104$var$version
    };
    const $caa4562a392de104$export$59518efab336a8b5 = (event)=>{
        const attributes = {
            ...event.attributes || {},
            crossFlowSupport: $caa4562a392de104$export$84f9cf7ef89d4c26
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("dXjol", function(module, exports) {
    $parcel$export(module.exports, "enrichWithRequestOptions", ()=>$122989aee9057316$export$a5a156dc5df42f0);
    const $122989aee9057316$export$a5a156dc5df42f0 = (event, requestOptions)=>{
        if (!requestOptions) return event;
        const attributes = {
            ...requestOptions.extraAnalyticsAttributes || {},
            ...event.attributes || {},
            sourceComponent: requestOptions.sourceComponent,
            sourceContext: requestOptions.sourceContext
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("2kVuq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("48puu")
    ]).then(()=>parcelRequire('h9JBA'));
});
parcelRegister("g2XuF", function(module, exports) {
    $parcel$export(module.exports, "getContainersPlugin", ()=>$014cd965663d7125$export$81d1d40061d190bc);
    parcelRequire("aLpJf");
    var $26IAH = parcelRequire("26IAH");
    var $aLpJf = parcelRequire("aLpJf");
    var $4Pf62;
    const $014cd965663d7125$var$getCloudId = async ()=>{
        const { cloudName: cloudName, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const containers = [
            {
                id: cloudId,
                displayName: cloudName,
                type: (0, $26IAH.ContainerTypes).ATLASSIAN_CLOUD_ID
            }
        ];
        return {
            type: (0, $26IAH.ContainerTypes).ATLASSIAN_CLOUD_ID,
            containers: containers
        };
    };
    const $014cd965663d7125$export$81d1d40061d190bc = (0, $aLpJf.createGetContainersPlugin)($014cd965663d7125$var$getCloudId);
});
parcelRegister("aLpJf", function(module, exports) {
    $parcel$export(module.exports, "createGetContainersPlugin", ()=>$6af176c6eeaa5c75$export$76378b0f825c024c);
    $parcel$export(module.exports, "createGetUsersPlugin", ()=>$6af176c6eeaa5c75$export$8feb7eae83cf8cd5);
    $parcel$export(module.exports, "ContainerTypes", ()=>(parcelRequire("26IAH")).ContainerTypes);
    $parcel$export(module.exports, "UserIdTypes", ()=>(parcelRequire("26IAH")).UserIdTypes);
    var $26IAH = parcelRequire("26IAH");
    const $6af176c6eeaa5c75$export$76378b0f825c024c = (fetch)=>{
        return [
            (0, $26IAH.PluginTypes).GetContainers,
            fetch
        ];
    };
    const $6af176c6eeaa5c75$export$8feb7eae83cf8cd5 = (fetch)=>{
        return [
            (0, $26IAH.PluginTypes).GetUsers,
            fetch
        ];
    };
    const $6af176c6eeaa5c75$export$21d120847be2aff4 = (fetch)=>{
        return [
            (0, $26IAH.PluginTypes).GetSuggestedSiteNames,
            fetch
        ];
    };
    const $6af176c6eeaa5c75$export$d7c1699c6a2ca18a = (fetch)=>{
        return [
            (0, $26IAH.PluginTypes).GetAvailableSites,
            fetch
        ];
    };
});
parcelRegister("26IAH", function(module, exports) {
    $parcel$export(module.exports, "PluginTypes", ()=>$c9d439fa3e146d2f$export$a235a73f7b906dce);
    $parcel$export(module.exports, "ContainerTypes", ()=>$c9d439fa3e146d2f$export$6e383182a26455ff);
    $parcel$export(module.exports, "UserIdTypes", ()=>$c9d439fa3e146d2f$export$e391bab95adb8396);
    const $c9d439fa3e146d2f$export$a235a73f7b906dce = {
        GetContainers: 'GetContainers',
        GetUsers: 'GetUsers',
        GetSuggestedSiteNames: 'GetSuggestedSiteNames',
        GetAvailableSites: 'GetAvailableSites'
    };
    const $c9d439fa3e146d2f$export$6e383182a26455ff = {
        BITBUCKET_WORKSPACE: 'bitbucket-workspace',
        ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
        JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
    };
    const $c9d439fa3e146d2f$export$e391bab95adb8396 = {
        ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
        TRELLO_ID: 'TRELLO_ID'
    };
    const $c9d439fa3e146d2f$export$4f378ba35c571906 = {
        JIRA_BUSINESS: 'JIRA_BUSINESS',
        JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
        JIRA_SOFTWARE: 'JIRA_SOFTWARE',
        CONFLUENCE: 'CONFLUENCE',
        OPSGENIE: 'OPSGENIE',
        BITBUCKET: 'BITBUCKET',
        STATUSPAGE: 'STATUSPAGE',
        TRELLO: 'TRELLO',
        COMPASS: 'COMPASS'
    };
});
parcelRegister("5emZd", function(module, exports) {
    $parcel$export(module.exports, "getUsersPlugin", ()=>$83dd2c216cba0381$export$7c44908d2777db01);
    var $aLpJf = parcelRequire("aLpJf");
    var $26IAH = parcelRequire("26IAH");
    const $83dd2c216cba0381$var$getUsers = async (containerId)=>{
        const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
        try {
            const response = await fetch(getUsersUrl, {
                credentials: 'same-origin'
            });
            if (response.ok) {
                const data = await response.json();
                return data.map((value)=>({
                        id: value.id,
                        idType: (0, $26IAH.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                        displayName: value.displayName
                    }));
            }
            throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
        } catch (error) {
            throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
        }
    };
    const $83dd2c216cba0381$export$7c44908d2777db01 = (0, $aLpJf.createGetUsersPlugin)($83dd2c216cba0381$var$getUsers);
});
parcelRegister("4041n", function(module, exports) {
    $parcel$export(module.exports, "FavoriteChangeContext", ()=>$e574e5c3227b76f4$export$a5d258b9665ce94b);
    $parcel$export(module.exports, "FavoriteChangeProvider", ()=>$e574e5c3227b76f4$export$b06b5ce59fd5e408);
    $parcel$export(module.exports, "FavoriteChangeConsumer", ()=>$e574e5c3227b76f4$export$f227cdfbb355444a);
    $parcel$export(module.exports, "useChangeFavorite", ()=>$e574e5c3227b76f4$export$cfa169f3278459e8);
    var $kZupY;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $dXq4S;
    var $8zOmE;
    var $koeKL;
    var $e73oS;
    var $j6ttF;
    var $7lK06;
    var $eXQym;
    var $5c9oS;
    var $7SIuT;
    const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
                ...state,
                [item.type]: {
                    ...state[item.type],
                    [item.id]: item
                }
            });
    const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
                ...state,
                items: {
                    ...state.items,
                    [item.type]: {
                        ...state.items[item.type],
                        [item.id]: item
                    }
                }
            });
    const $e574e5c3227b76f4$export$b212ddc707077772 = {
        items: {
            boards: {},
            filters: {},
            issues: {},
            dashboards: {},
            projects: {},
            queues: {},
            plans: {}
        },
        changeFavorite: ()=>new Promise((0, ($parcel$interopDefault($8Rkzz)))),
        changeFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavorite: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        updateFavoriteState: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $e574e5c3227b76f4$export$a5d258b9665ce94b = (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
    const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
            if (type === (0, (0, parcelRequire("eXQym")).PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
                const ari = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'project',
                    resourceId: id,
                    cloudId: cloudId
                });
                const projectRecordId = (0, (0, parcelRequire("e73oS")).default)({
                    id: ari
                }, 'JiraProject');
                if (projectRecordId) {
                    const projectRecord = store.get(projectRecordId);
                    const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(value, 'isFavourite');
                }
            });
        }, [
            cloudId,
            environment
        ]);
        return {
            commitUpdate: commitUpdate
        };
    };
    const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
        const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
        const [items, setItems] = (0, $5uXOq.useState)({
            boards: {},
            filters: {},
            dashboards: {},
            issues: {},
            projects: {},
            queues: {},
            plans: {}
        });
        const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
        }, []);
        const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
            if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
        }, []);
        const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                value: !item.value,
                pending: false
            }));
            if (onShowFlag) onShowFlag((0, (0, parcelRequire("7SIuT")).errorFlag)());
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: analyticsId,
                    packageName: 'jiraFavouriteChangeProvider',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onShowFlag
        ]);
        const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
            const performChange = async ()=>{
                onChangeStart(item);
                try {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: item.value
                    });
                    await (0, (0, parcelRequire("5c9oS")).default)(item);
                    const typename = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(item.type, item.id);
                    if (typename) (0, (0, parcelRequire("7lK06")).publishFavorite)(typename, {
                        type: 'REST',
                        entityId: item.id,
                        isFavourite: item.value
                    });
                    onChangeSuccess(item, analyticsEvent);
                } catch (error) {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: !item.value
                    });
                    onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
                }
            };
            return performChange();
        }, [
            commitUpdate,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const [commitMutation] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("kZupY")).default));
        const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("e73oS")).default)({
                id: payload.id
            }, payload.typename);
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            const onUpdate = (store, isOptimistic)=>{
                if (!dataId) return;
                (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                    type: 'MUTATION',
                    store: store,
                    dataId: dataId,
                    entityId: payload.id,
                    isFavourite: payload.value,
                    isOptimistic: isOptimistic
                });
                const record = store.get(dataId);
                if (record) {
                    if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                    if (isOptimistic) {
                        const favoriteRecord = record.getLinkedRecord('favouriteValue');
                        favoriteRecord?.setValue(payload.value, 'isFavourite');
                    }
                }
            };
            onChangeStart(restItem);
            commitMutation({
                variables: {
                    input: {
                        entityId: payload.id,
                        isFavourite: payload.value,
                        beforeEntityId: payload.beforeEntity?.id ?? null
                    }
                },
                optimisticUpdater: (store)=>{
                    onUpdate(store, true);
                },
                updater: (store, response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
                },
                onCompleted: (response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                    else onChangeFail(restItem, 'changeFavoriteMutation');
                },
                onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
            });
        }, [
            commitMutation,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
        }, []);
        const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            onChangeSuccess(payload, analyticsEvent);
            const typeName = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(payload.type, payload.id);
            if (typeName) (0, (0, parcelRequire("7lK06")).publishFavorite)(typeName, {
                type: 'REST',
                entityId: payload.id,
                isFavourite: payload.value
            });
        }, [
            onChangeSuccess
        ]);
        const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)((payload, store, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("e73oS")).default)({
                id: payload.id
            }, payload.typename) ?? '';
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            onChangeSuccess(restItem, analyticsEvent);
            (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: false
            });
        }, [
            onChangeSuccess
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>({
                items: items,
                changeFavorite: changeFavorite,
                changeFavoriteMutation: changeFavoriteMutation,
                emitChangedFavorite: emitChangedFavorite,
                emitChangedFavoriteMutation: emitChangedFavoriteMutation,
                updateFavoriteState: updateFavoriteState
            }), [
            items,
            changeFavorite,
            changeFavoriteMutation,
            emitChangedFavorite,
            emitChangedFavoriteMutation,
            updateFavoriteState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
            value: providerValue
        }, children);
    };
    const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
    const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
        const WithFavoriteChangeConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    favoriteChangeContext: favoriteChangeContext
                }));
        const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
        return WithFavoriteChangeConsumer;
    };
    const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);
});
parcelRegister("kZupY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d64781493fbfe6b0$export$2e2bcd8739ae039);
    const $d64781493fbfe6b0$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraSetIsFavouritePayload",
                        "kind": "LinkedField",
                        "name": "setEntityIsFavourite",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewSetFavouriteMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewSetFavouriteMutation",
                "selections": v1
            },
            "params": {
                "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
                "metadata": {},
                "name": "viewSetFavouriteMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
    var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;
});
parcelRegister("dXq4S", function(module, exports) {
    $parcel$export(module.exports, "isAri", ()=>$5c4418bd595ae8cf$export$8e68286aef4c3a8b);
    $parcel$export(module.exports, "createAri", ()=>$5c4418bd595ae8cf$export$594d18a0ad2e0e57);
    $parcel$export(module.exports, "toAri", ()=>$5c4418bd595ae8cf$export$24b47820a324e614);
    $parcel$export(module.exports, "toAriOrDefault", ()=>$5c4418bd595ae8cf$export$e2789192113e8b07);
    $parcel$export(module.exports, "parseAri", ()=>$5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
    $parcel$export(module.exports, "getAriConfig", ()=>$5c4418bd595ae8cf$export$3d8d7031a11613fd);
    const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
    const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
    const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
        if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
        if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
        return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
    };
    const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
        return undefined;
    };
    const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
    const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
            const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
            if (parts?.groups) {
                const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
                return {
                    resourceOwner: resourceOwner,
                    cloudId: cloudId,
                    resourceType: resourceType,
                    workspaceId: workspaceId,
                    resourceId: resourceId,
                    activationId: activationId
                };
            }
        }
        return undefined;
    };
    const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
        const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
        if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
        return config;
    };
});
parcelRegister("j6ttF", function(module, exports) {
    $parcel$export(module.exports, "favoriteTypeToTypename", ()=>$b9c3378eb0d73712$export$b98f76d96728a853);
    $parcel$export(module.exports, "favoriteMutationToRestPayload", ()=>$b9c3378eb0d73712$export$717886a1047f1287);
    var $1Y49U;
    var $1WQct;
    var $k0goX;
    var $gbLWS;
    var $89DrR;
    var $j5YhT;
    function $b9c3378eb0d73712$var$assertUnreachable(_) {
        throw new Error('Unexpected entity type');
    }
    const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
    const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
        switch(type){
            case 'projects':
                return 'JiraProject';
            case 'filters':
                return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
            case 'dashboards':
                return 'JiraDashboard';
            case 'plans':
                return 'JiraPlan';
            case 'boards':
                return 'JiraBoard';
            case 'queues':
                return 'JiraServiceManagementQueue';
            default:
                return undefined;
        }
    };
    const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
        switch(typename){
            case 'JiraProject':
                return (0, (0, parcelRequire("j5YhT")).JiraProjectAri).parse(ari).projectId;
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return (0, (0, parcelRequire("gbLWS")).JiraFilterAri).parse(ari).filterId;
            case 'JiraDashboard':
                return (0, (0, parcelRequire("k0goX")).JiraDashboardAri).parse(ari).dashboardId;
            case 'JiraPlan':
                return (0, (0, parcelRequire("89DrR")).JiraPlanAri).parse(ari).planId;
            case 'JiraBoard':
                return (0, (0, parcelRequire("1WQct")).JiraSoftwareBoardAri).parse(ari).boardId;
            case 'JiraServiceManagementQueue':
                return (0, (0, parcelRequire("1Y49U")).JiraServicedeskQueueAri).parse(ari).queueId;
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
        switch(typename){
            case 'JiraProject':
                return 'projects';
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return 'filters';
            case 'JiraDashboard':
                return 'dashboards';
            case 'JiraPlan':
                return 'plans';
            case 'JiraBoard':
                return 'boards';
            case 'JiraServiceManagementQueue':
                return 'queues';
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
            id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
            value: value,
            beforeEntity: beforeEntity ? {
                id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
                type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
            } : undefined
        });
});
parcelRegister("7lK06", function(module, exports) {
    $parcel$export(module.exports, "publishFavorite", ()=>$703ce7b9c2eadfdd$export$229a24253fb568e1);
    $parcel$export(module.exports, "useSubscribeToFavorite", ()=>$703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);
    var $5uXOq = parcelRequire("5uXOq");
    class $703ce7b9c2eadfdd$var$FavoritePubSub {
        constructor(){
            this.subscribers = {};
            this.subscribe = (typename, subscriber)=>{
                this.subscribers[typename] = [
                    ...this.subscribers[typename] ?? [],
                    subscriber
                ];
                return ()=>{
                    this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
                };
            };
            this.publish = (typename, payload)=>{
                this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
            };
        }
    }
    const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
    const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
    const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
        (0, $5uXOq.useEffect)(()=>{
            const typenames = Array.isArray(typename) ? typename : [
                typename
            ];
            const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
            return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
        }, [
            typename,
            subscriber
        ]);
    };
});
parcelRegister("eXQym", function(module, exports) {
    $parcel$export(module.exports, "BOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$aade82542e73ffc8);
    $parcel$export(module.exports, "FILTERS_ITEM_TYPE", ()=>$6c76a5a290814989$export$a448ebfa10cebc74);
    $parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$f8099f229527572c);
    $parcel$export(module.exports, "ISSUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e58083dcbb878d);
    $parcel$export(module.exports, "PLANS_ITEM_TYPE", ()=>$6c76a5a290814989$export$2fd44a6cb58b66cb);
    $parcel$export(module.exports, "PROJECTS_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e2cd98172988d7e);
    $parcel$export(module.exports, "QUEUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$6b0c8e47d2c7f1d9);
    $parcel$export(module.exports, "VALID_ITEM_TYPES", ()=>$6c76a5a290814989$export$9c8cfad65800ddfb);
    $parcel$export(module.exports, "VALID_ITEM_TYPENAMES", ()=>$6c76a5a290814989$export$2d63a9c2e78633c8);
    const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
    const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
    const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
    const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
    const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
    const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
    const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
    const $6c76a5a290814989$export$9c8cfad65800ddfb = [
        $6c76a5a290814989$export$aade82542e73ffc8,
        $6c76a5a290814989$export$f8099f229527572c,
        $6c76a5a290814989$export$a448ebfa10cebc74,
        $6c76a5a290814989$export$8e58083dcbb878d,
        $6c76a5a290814989$export$2fd44a6cb58b66cb,
        $6c76a5a290814989$export$8e2cd98172988d7e,
        $6c76a5a290814989$export$6b0c8e47d2c7f1d9
    ];
    const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
        'JiraProject',
        'JiraCustomFilter',
        'JiraSystemFilter',
        'JiraDashboard',
        'JiraPlan',
        'JiraBoard',
        'JiraServiceManagementQueue'
    ];
});
parcelRegister("5c9oS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9559749111f2eca$export$2e2bcd8739ae039);
    var $7eYK2;
    var $f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, (0, parcelRequire("7eYK2")).updateFavorite)(request);
});
parcelRegister("7eYK2", function(module, exports) {
    $parcel$export(module.exports, "updateFavorite", ()=>$16085bb5bdb7219b$export$8c2f00130cc945dc);
    var $eusud;
    const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
        if (request.value) return (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/2/favourites', {
            body: JSON.stringify({
                entity: {
                    id: request.id,
                    type: request.type
                },
                beforeEntityPosition: request.beforeEntity || null
            })
        });
        return (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
    };
});
parcelRegister("7SIuT", function(module, exports) {
    $parcel$export(module.exports, "errorFlag", ()=>$7252fdcfc0e15292$export$b9a7f1ebeaa76953);
    var $0YlRJ;
    const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            ...(0, (0, parcelRequire("0YlRJ")).default)
        });
});
parcelRegister("0YlRJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87ad72b3da53041c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
            "defaultMessage": "Something\u2019s gone wrong"
        },
        description: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
            "defaultMessage": "You cannot star items right now due to an error."
        }
    });
});
parcelRegister("2HbP2", function(module, exports) {
    $parcel$export(module.exports, "ModalContextProvider", ()=>$d012230882eb31a4$export$7c9538f5f3c365e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkDqR;
    var $gJdig;
    function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
        const id = (0, $5uXOq.useRef)(1);
        const [modals, setModals] = (0, $5uXOq.useState)([]);
        const modalContext = (0, $5uXOq.useMemo)(()=>({
                openModal: (component)=>{
                    const key = String(id.current++);
                    const close = ()=>{
                        setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                    };
                    setModals((mdls)=>[
                            ...mdls,
                            {
                                close: close,
                                component: component,
                                key: key
                            }
                        ]);
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gJdig")).ModalContext).Provider, {
            value: modalContext
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkDqR")).default), null, modals.map((modal)=>(0, ($parcel$interopDefault($5uXOq))).createElement(modal.component, {
                key: modal.key,
                onClose: modal.close
            }))));
    }
});
parcelRegister("gJdig", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$308ba6e6ba886f08$export$ab57792b9b6974a6);
    var $5uXOq = parcelRequire("5uXOq");
    const $308ba6e6ba886f08$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
        openModal: ()=>{}
    });
});
parcelRegister("bKCrm", function(module, exports) {
    $parcel$export(module.exports, "ProjectCreateDrawerProvider", ()=>$645a52f2fa143509$export$9a1c5dbd93c42bca);
    $parcel$export(module.exports, "ProjectCreateDrawerConsumer", ()=>$645a52f2fa143509$export$9a8662cd60931de1);
    $parcel$export(module.exports, "useProjectCreateDrawer", ()=>$645a52f2fa143509$export$8172ff4ed0f75a1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $58GFP;
    var $8YEE2;
    var $lVJAU;
    var $gL2cg;
    const $645a52f2fa143509$var$Context = (0, $5uXOq.createContext)({
        data: {
            shouldRenderDrawer: false,
            isOpen: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined
        },
        methods: {
            open: (0, ($parcel$interopDefault($8Rkzz))),
            close: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCreateStarted: (0, ($parcel$interopDefault($8Rkzz))),
            setOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz))),
            clearOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
        }
    });
    const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
        render() {
            const { children: children } = this.props;
            const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
                value: {
                    data: {
                        isOpen: isOpen,
                        isNextGen: isNextGen,
                        source: source,
                        showExperienceSelection: showExperienceSelection,
                        shouldRenderDrawer: shouldRenderDrawer,
                        recommendedTemplate: recommendedTemplate,
                        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                        isImportProjectOpenInitially: isImportProjectOpenInitially,
                        selectedProjectType: selectedProjectType,
                        recommendationSessionId: recommendationSessionId
                    },
                    methods: {
                        open: this.open,
                        close: this.close,
                        onSuccess: this.onSuccess,
                        onCreateStarted: this.onCreateStarted,
                        setOnCloseCallback: this.setOnCloseCallback,
                        clearOnCloseCallback: this.clearOnCloseCallback
                    }
                }
            }, children);
        }
        constructor(...args){
            super(...args), this.state = {
                isOpen: false,
                shouldRenderDrawer: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined,
                onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
            }, this.onSuccess = (projectKey)=>{
                if (projectKey) {
                    this.props.setLocation(projectKey.returnUrl);
                    this.close(true);
                } else this.close(false);
            }, this.setOnCloseCallback = (callback)=>{
                this.setState({
                    onCloseCallback: callback
                });
            }, this.clearOnCloseCallback = ()=>{
                this.setState({
                    onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
                });
            }, this.open = (attributes = {})=>{
                this.setState({
                    isOpen: true,
                    shouldRenderDrawer: true,
                    ...attributes
                });
            }, this.close = (projectCreated)=>{
                const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    isImportProjectOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                if (callOnCloseCallBack) this.state.onCloseCallback();
            }, this.closeOld = ()=>{
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                this.state.onCloseCallback();
            }, this.onCreateStarted = (projectKey, templateKey)=>{
                if ((0, (0, parcelRequire("58GFP")).getIsJsmBlankProjectTemplate)(templateKey)) (0, (0, parcelRequire("8YEE2")).LazyComponent).preload();
                (0, (0, parcelRequire("gL2cg")).clearResourcesAssociatedWithProjectKey)(projectKey);
            };
        }
    };
    const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
            ...props,
            setLocation: push
        });
    };
    const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
    $645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
    const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
        const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
        if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
        return projectCreateDrawer;
    };
});
parcelRegister("58GFP", function(module, exports) {
    $parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$f40a08fc76eb112d);
    $parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$e3844688f2693533);
    $parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$e3cec071fcb2fbd3);
    $parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$21783d461e3ef6d);
    $parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6cd1c1b2ba0f6e2d);
    $parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$57d877f2e01e0029);
    $parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6f4213a3addc3fdb);
    $parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", ()=>$c364c398187f9175$export$7492b6cc3ef89883);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7d9a4e0ef5194fe1);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$477ca3550da12e43);
    $parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$b5ab111fb8825075);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$14139f0ec41d437e);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$ebf7af45376deb8b);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7b6945581ccdab4a);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$310a9ac5c28d65f6);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$4d29ee0c00eb5df4);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$6278b41164dbde6c);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$17a2f771efabf02f);
    $parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$bd14946bcde77195);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", ()=>$c364c398187f9175$export$e8df553a3f519284);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$97fc32bd703bb4d1);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", ()=>$c364c398187f9175$export$8eecdf6acea9494);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$ff16be7794ed4222);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$9917830b560a2f4);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$b0928b02ffab3875);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$fd75f6abc7861439);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$fb658bddae7f81bb);
    $parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$2bc7db2da3df8313);
    $parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", ()=>$c364c398187f9175$export$87a8fff98b5bc81);
    $parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$7c567eb725bd36f);
    $parcel$export(module.exports, "getIsJsmBlankProjectTemplate", ()=>$c364c398187f9175$export$73fd025e86012868);
    $parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", ()=>$c364c398187f9175$export$a062badd78c9993);
    const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
    const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
    const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
    const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
    const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
    const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
    const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
    const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
    const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
    const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
    const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
    const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
    const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
    const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
    const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
    const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
    const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
    const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
    const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
    const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
    const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
    const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
    const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
    const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
    const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
    const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
    const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
    const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
    const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
    const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
    const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
    const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
    const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
    const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
    const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
    const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
    const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
    const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
    const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
    const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
    const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
    const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
    const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
    const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
    const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
    const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
    const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
    const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
    const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
    const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
    const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
    const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
    const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
    const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
    const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
    const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
    const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
    const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
    const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
    const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
    const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
    const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
    const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
    const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
    const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
    const $c364c398187f9175$export$a062badd78c9993 = {
        [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
        [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
    };
});
parcelRegister("8YEE2", function(module, exports) {
    $parcel$export(module.exports, "LazyComponent", ()=>$300188a98a9fded7$export$31f1740ae531af94);
    $parcel$export(module.exports, "AsyncProjectBuilderDrawer", ()=>$300188a98a9fded7$export$54a4eade9eae9473);
    $parcel$export(module.exports, "canUseProjectBuilder", ()=>$300188a98a9fded7$export$ff317c5d87147a19);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $9noxX;
    var $hPtZI;
    const $300188a98a9fded7$export$31f1740ae531af94 = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("dQEVq")), {
        ssr: false,
        moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
    });
    const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-async-project-builder",
            packageName: "jira-servicedesk-project-builder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: null,
            name: "jsm-project-builder"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
            isOpenInitial: !!props.isOpenInitial,
            ...props
        }))));
    const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;
});
parcelRegister("9noxX", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskAnalyticsContext", ()=>$12b9024f66e7ef57$export$ac31f8f3368d6881);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $4DPZY;
    var $8H3A4;
    const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
        const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
        const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
        if ((0, $5uXOq.Children).count(children) > 0) {
            const loading = containerContextLoading || analyticsContextLoading;
            const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
            if (!shouldRenderChildren) return null;
            const context = {};
            if (containerContextData && containerContextData.project) {
                const { id: id, type: type } = containerContextData.project;
                context.containerType = 'project';
                context.containerId = `${id}`;
                context.containers = {
                    project: {
                        id: `${id}`,
                        type: type
                    }
                };
                if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), context, children);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    $12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
        forceRenderWhileLoading: false,
        useServiceDeskAnalyticsContext: (0, (0, parcelRequire("8H3A4")).useServiceDeskAnalyticsContext),
        useContainerContext: (0, (0, parcelRequire("4DPZY")).useContainerContext)
    };
});
parcelRegister("8H3A4", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAnalyticsContextResource", ()=>$4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    $parcel$export(module.exports, "useServiceDeskAnalyticsContext", ()=>$4d76b3bac8f2b7c8$export$bc2de1c42df30b10);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $2M1hQ;
    var $2YP9W;
    const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("1M51R"));
    const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
    const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
        maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
    });
    const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("2YP9W")).useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';
parcelRegister("1M51R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("3rvO2")
    ]).then(()=>parcelRequire('btHFe'));
});
parcelRegister("dQEVq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kWrFZ"),
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c8LNs")
    ]).then(()=>parcelRequire('c9lEE'));
});
parcelRegister("gL2cg", function(module, exports) {
    $parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", ()=>$e1d0138bae1db723$export$c0c81c1828c7638c);
    var $jcw0u;
    var $8fYaK;
    const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
        try {
            const { storeState: storeState } = (0, (0, parcelRequire("8fYaK")).getResourceStore)();
            const prevState = storeState.getState();
            storeState.setState({
                ...prevState,
                data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                    const { [projectKey]: _, ...rest } = value;
                    return [
                        resourceType,
                        rest
                    ];
                }))
            });
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'clearResourcesAssociatedWithProjectKey',
                    packageName: 'jiraProjectCreateDrawerContext',
                    teamName: 'helix'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
            });
        }
    };
});
parcelRegister("ivvwC", function(module, exports) {
    $parcel$export(module.exports, "UserContainers", ()=>$0fd080febb09e205$export$c1b371eec908681a);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9VAQ;
    var $leRCk;
    const $0fd080febb09e205$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("leRCk")).UserContainer), {
            isGlobal: true,
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9VAQ")).UserPreferencesContainer), {
            isGlobal: true
        }, children));
});
parcelRegister("d9VAQ", function(module, exports) {
    $parcel$export(module.exports, "UserPreferencesContainer", ()=>$3038471ea054300f$export$aa278641ded1adf);
    var $gg7kZ;
    var $51nlc;
    var $eYegl;
    const $3038471ea054300f$export$be74e04eaea4530 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("eYegl")).default), {
        displayName: 'UserPreferencesSubscriber'
    });
    const $3038471ea054300f$export$aa278641ded1adf = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("eYegl")).default));
});
parcelRegister("eYegl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc414d73e667f785$export$2e2bcd8739ae039);
    var $iXqE5;
    var $7AJyg;
    const $bc414d73e667f785$var$initialState = {
        'issue-view-experiment': {
            data: {
                value: false
            },
            loading: false,
            error: null
        }
    };
    var $bc414d73e667f785$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'user-preference',
        initialState: $bc414d73e667f785$var$initialState,
        actions: (0, parcelRequire("7AJyg"))
    });
});
parcelRegister("7AJyg", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>(parcelRequire("g6Vt5")).default);
    $parcel$export(module.exports, "fetchIssueCreate", ()=>(parcelRequire("ePV4l")).default);
    $parcel$export(module.exports, "updateExperiment", ()=>(parcelRequire("8Lrq8")).default);
    var $g6Vt5;
    var $ePV4l;
    var $8Lrq8;
});
parcelRegister("g6Vt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a561c8a03710a3f2$export$2e2bcd8739ae039);
    var $goEOn;
    var $a561c8a03710a3f2$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
            const currentState = getState();
            if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
            setState({
                [preferenceKey]: {
                    data: currentState.data,
                    loading: true,
                    error: null
                }
            });
            try {
                const data = await (0, (0, parcelRequire("goEOn")).default)({
                    baseUrl: baseUrl,
                    preferenceKey: preferenceKey
                });
                setState({
                    [preferenceKey]: {
                        data: data,
                        loading: false,
                        error: null
                    }
                });
            } catch (err) {
                setState({
                    [preferenceKey]: {
                        data: getState().data,
                        loading: false,
                        error: err
                    }
                });
            }
        };
});
parcelRegister("goEOn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0be3c96b3fac1b7f$export$2e2bcd8739ae039);
    var $4Lzq2;
    var $0be3c96b3fac1b7f$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
        try {
            const result = await (0, (0, parcelRequire("4Lzq2")).default)(baseUrl, preferenceKey);
            return {
                value: result
            };
        } catch (e) {
            if (e.statusCode === 404) return {
                value: undefined
            };
            throw e;
        }
    };
});
parcelRegister("4Lzq2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efdd8b3604a0d493$export$2e2bcd8739ae039);
    var $eusud;
    var $efdd8b3604a0d493$export$2e2bcd8739ae039 = (baseUrl, key)=>{
        const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(requestUrl);
    };
});
parcelRegister("ePV4l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01fcb0eb90bce4cf$export$2e2bcd8739ae039);
    var $g6Vt5;
    var $01fcb0eb90bce4cf$export$2e2bcd8739ae039 = ()=>(0, (0, parcelRequire("g6Vt5")).default)('issue-create');
});
parcelRegister("8Lrq8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aea442a302ef98b1$export$2e2bcd8739ae039);
    var $aea442a302ef98b1$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
            setState({
                [experimentKey]: {
                    data: {
                        value: value
                    },
                    loading: false,
                    error: null
                }
            });
        };
});
parcelRegister("62C9r", function(module, exports) {
    $parcel$export(module.exports, "HorizontalNav", ()=>$df8ca37c4f42ad24$export$3821fe730064297d);
    $parcel$export(module.exports, "HorizontalNavWrapper", ()=>$df8ca37c4f42ad24$export$8798384053a023ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cPiXk;
    var $cM67N;
    var $erBFB;
    const $df8ca37c4f42ad24$var$NavErrorBoundaryFallback = ()=>null;
    const $df8ca37c4f42ad24$export$3821fe730064297d = ()=>{
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        return HorizontalNavComponent && $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
        }, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $5uXOq.createElement((0, (0, parcelRequire("erBFB")).ProjectViewNavigationSkipLink), null)), $5uXOq.createElement(HorizontalNavComponent, null));
    };
    const $df8ca37c4f42ad24$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
        return $5uXOq.createElement($df8ca37c4f42ad24$var$ThemedContainer, null, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
        }, $5uXOq.createElement((0, (0, parcelRequire("cM67N")).NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $5uXOq.createElement((0, (0, parcelRequire("erBFB")).ProjectViewNavigationSkipLink), null)), $5uXOq.createElement(HorizontalNavComponent, null)), children);
    };
    const $df8ca37c4f42ad24$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7mmei _11q31r52 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cM67N", function(module, exports) {
    $parcel$export(module.exports, "NavErrorBoundary", ()=>$5ad940bec1d10db7$export$afc779e659fd533f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $jcw0u;
    var $7XYc4;
    var $4R6GH;
    var $3HwlS;
    var $dCm1o;
    function $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20240814() {
        return [
            [
                'jira_nav4',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4')
            ],
            [
                'jira_nav4_dogfooding',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')
            ],
            [
                'jira_nav4_dogfooding_phase-1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1')
            ],
            [
                'jira_nav4_dogfooding_phase-2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2')
            ]
        ];
    }
    function $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20241025() {
        return [
            [
                'getWillShowNav4()',
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)()
            ],
            [
                'jira_nav4_dogfooding',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')
            ],
            [
                'jira_nav4_eap',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap')
            ],
            [
                'jira_nav4_eap_drop_1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')
            ],
            [
                'jira_nav4_eap_drop_2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')
            ],
            [
                'jira_nav4_beta_drop_1',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')
            ],
            [
                'jira_nav4_beta_drop_2',
                (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')
            ],
            [
                'isVisualRefreshEnabled()',
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            ]
        ];
    }
    const $5ad940bec1d10db7$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
    function $5ad940bec1d10db7$var$inferNavRevision() {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'v4' : 'v3';
    }
    function $5ad940bec1d10db7$var$getExtraAttributes(_error) {
        const relevantFFlags = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20241025() : $5ad940bec1d10db7$var$getRelevantFFlagsForObservability20240814();
        const attributes = {
            ffs: relevantFFlags.filter(([, value])=>value).map(([key])=>key).join(),
            rev: $5ad940bec1d10db7$var$inferNavRevision()
        };
        return attributes;
    }
    function $5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision) {
        const payload = {
            error: error,
            meta: {
                id: 'logic',
                packageName: 'JiraNav'
            },
            attributes: {
                ...$5ad940bec1d10db7$var$getExtraAttributes(error),
                pkg: meta.packageName,
                id: meta.id,
                ...navRevision && {
                    rev: navRevision
                }
            },
            skipSentry: true
        };
        return payload;
    }
    const $5ad940bec1d10db7$export$5ac21f1e947e70d6 = (props)=>{
        const { id: id, packageName: packageName, navRevision: navRevision } = props;
        const onError = (0, $5uXOq.useMemo)(()=>{
            const meta = {
                id: id,
                packageName: packageName
            };
            const _onError = (...args)=>{
                if ($5ad940bec1d10db7$export$1d1321d2b374d697()) return;
                const [_, error] = args;
                (0, (0, parcelRequire("jcw0u")).default)($5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision));
            };
            return _onError;
        }, [
            id,
            packageName,
            navRevision
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            ...props,
            onError: onError
        });
    };
    const $5ad940bec1d10db7$export$afc779e659fd533f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5ad940bec1d10db7$export$5ac21f1e947e70d6, props), (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), props));
});
parcelRegister("dCm1o", function(module, exports) {
    $parcel$export(module.exports, "isVisualRefreshEnabled", ()=>$322f7f27e3ad3058$export$48345cb467db19b6);
    var $6s1PB;
    var $4R6GH;
    var $1MhR0;
    const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
    const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-beta-existing-customers') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-beta-sandboxes') || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_free-customers', 'isVisualRefreshEnabled', false) || (0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_new-customers', 'isVisualRefreshEnabled', false);
});
parcelRegister("erBFB", function(module, exports) {
    $parcel$export(module.exports, "TopNavigationSkipLink", ()=>$cd61d83e2e343ff1$export$47de2191d46337b7);
    $parcel$export(module.exports, "LeftSidebarSkipLink", ()=>$cd61d83e2e343ff1$export$46697df0d7c5e8be);
    $parcel$export(module.exports, "ProjectViewNavigationSkipLink", ()=>$cd61d83e2e343ff1$export$2e2fc9c237996c06);
    $parcel$export(module.exports, "MainContentSkipLink", ()=>$cd61d83e2e343ff1$export$b1498dd122ea3284);
    var $koVbs;
    var $iqLcb;
    var $lOt1w;
    const $cd61d83e2e343ff1$export$47de2191d46337b7 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-jira-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToJiraNavigation), 0);
        return null;
    };
    const $cd61d83e2e343ff1$export$46697df0d7c5e8be = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-side-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToSideNavigation), 1);
        return null;
    };
    const $cd61d83e2e343ff1$export$2e2fc9c237996c06 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToProjectViewNavigation), 2);
        return null;
    };
    const $cd61d83e2e343ff1$export$b1498dd122ea3284 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("iqLcb")).useCustomSkipLink)('ak-main-content', formatMessage((0, (0, parcelRequire("lOt1w")).default).skipToMainContent), 3);
        return null;
    };
});
parcelRegister("lOt1w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d368a0de790f751$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2d368a0de790f751$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        skipToJiraNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
            "defaultMessage": "Skip to Jira Navigation"
        },
        skipToSideNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
            "defaultMessage": "Skip to Side Navigation"
        },
        skipToProjectViewNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
            "defaultMessage": "Skip to View Navigation"
        },
        skipToMainContent: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
            "defaultMessage": "Skip to Main Content"
        }
    });
});
parcelRegister("4s15Z", function(module, exports) {
    $parcel$export(module.exports, "RightSidebar", ()=>$ac6bd493ba1cffad$export$84d58c19c21f637f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $2Ioew;
    var $frBVt;
    var $7CMCs;
    var $7XYc4;
    var $hsmeR;
    var $3HwlS;
    var $iqLcb;
    var $6jY6G;
    var $8zOmE;
    var $95EVP;
    var $1XrjK;
    var $6ncxj;
    var $gwZ1O;
    var $l8ruj;
    const $ac6bd493ba1cffad$var$TEST_ID = 'page-layout.aside';
    const $ac6bd493ba1cffad$var$routeComponents = [];
    const $ac6bd493ba1cffad$var$SharedRightSidebars = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)((0, (0, parcelRequire("6ncxj")).sharedLayout).rightSidebars));
    const $ac6bd493ba1cffad$var$RightSidebarRouteComponents = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("1XrjK")).renderGlobalComponents)(route.layout?.rightSidebars || $ac6bd493ba1cffad$var$routeComponents));
    };
    const $ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint = ()=>{
        const rightSideBarEntryPoint = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb));
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entrypoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        if (!entrypoint || !rightSideBarEntryPoint) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar-through-entrypoint"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-through-entrypoint",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            name: "right-sidebar-through-entrypoint",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gwZ1O")).ProjectListSidebarSkeleton), null),
            entryPoint: entrypoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: rightSideBarEntryPoint,
            props: {}
        }))));
    };
    const $ac6bd493ba1cffad$var$NewRightSidebar = ()=>{
        const lastPanelIdRef = (0, $5uXOq.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).RightPanel), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
            testId: $ac6bd493ba1cffad$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null))));
    };
    const $ac6bd493ba1cffad$var$OldRightSidebar = ()=>{
        const lastPanelIdRef = (0, $5uXOq.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarPanelWrapper, {
            id: "right-sidebar-panel-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).RightSidebar), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, ($parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null)))));
    };
    const $ac6bd493ba1cffad$var$RightSidebarPanelWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $ac6bd493ba1cffad$export$84d58c19c21f637f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $ac6bd493ba1cffad$var$NewRightSidebar, $ac6bd493ba1cffad$var$OldRightSidebar);
});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
parcelRegister("2Ioew", function(module, exports) {
    $parcel$export(module.exports, "usePageLayoutEntryPoint", ()=>$dcf886ac39f7cfda$export$fe1c839e8baf4110);
    var $h22md;
    var $6jY6G;
    const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entryPointReference = (0, (0, parcelRequire("h22md")).useRouteEntryPoint)({
            route: route
        });
        return entryPointReference?.entryPoints[layoutField];
    };
});
parcelRegister("h22md", function(module, exports) {
    $parcel$export(module.exports, "useRouteEntryPoint", ()=>$4e1bc9edc261b42d$export$c96377f800cdddb4);
    var $3I4nj;
    const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
        const [lastLoadedRoute] = (0, (0, parcelRequire("3I4nj")).useLastLoadedRoute)();
        if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
        return null;
    };
});
parcelRegister("3I4nj", function(module, exports) {
    $parcel$export(module.exports, "useLastLoadedRoute", ()=>$f09634e8d32626d1$export$895238443fc3eae4);
    $parcel$export(module.exports, "getEntryPointsStore", ()=>$f09634e8d32626d1$export$fe654a734624d17f);
    $parcel$export(module.exports, "getLastLoadedRoute", ()=>$f09634e8d32626d1$export$5763b2305b3056df);
    $parcel$export(module.exports, "getPrefetchingRoute", ()=>$f09634e8d32626d1$export$7e18f3e3cbd04326);
    var $3sQ5x;
    var $iXqE5;
    var $bKpgX;
    const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
            setState({
                lastLoadedRoute: {
                    route: route,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
            setState({
                prefetchingRoute: {
                    routerContext: routerContext,
                    expiresAt: expiresAt,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$var$actions = {
        setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
        setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
    };
    const $f09634e8d32626d1$var$EntryPointsStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            lastLoadedRoute: null,
            prefetchingRoute: null
        },
        actions: $f09634e8d32626d1$var$actions,
        name: 'react-resource-router/entry-points'
    });
    const $f09634e8d32626d1$export$895238443fc3eae4 = (0, (0, parcelRequire("3sQ5x")).createHook)($f09634e8d32626d1$var$EntryPointsStore, {
        selector: (state)=>state.lastLoadedRoute
    });
    const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
    const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
    const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
    const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;
});
parcelRegister("gwZ1O", function(module, exports) {
    $parcel$export(module.exports, "ProjectListSidebarSkeleton", ()=>$b3acbd60cf8d3dfa$export$808c25bcc6102427);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $d8ped = parcelRequire("d8ped");
    const $b3acbd60cf8d3dfa$var$customCssStyles = null;
    const $b3acbd60cf8d3dfa$var$sidebarCssStyles = null;
    const $b3acbd60cf8d3dfa$export$808c25bcc6102427 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1bsb1gwv _1yt41ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d8ped))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_t6vdidpf _hr4jidpf"
            ])
        }));
});
parcelRegister("d8ped", function(module, exports) {
    module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();
});
parcelRegister("eF0qp", function(module, exports) {
    $parcel$export(module.exports, "Sidebar", ()=>$803f61b5dea1399f$export$1ba59dacbcbf90fe);
    var $fZBia;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $ajpes = parcelRequire("ajpes");
    var $8Uumt = parcelRequire("8Uumt");
    var $6T4rd;
    var $fHbE4;
    var $jJ1Sb;
    var $j9yTe;
    var $5e7oM;
    var $azzrO;
    var $gwIPs;
    var $7CMCs;
    var $7XYc4;
    var $4R6GH;
    var $pa9q9;
    var $aWse0;
    var $gPQRI;
    var $5e5zm;
    var $2fwuR;
    var $acDan;
    var $c6x3L;
    var $3HwlS;
    var $jHUgj;
    var $4DrQd;
    var $eGkew;
    var $iqLcb;
    var $ht71P;
    var $lfTZh;
    var $6jY6G;
    var $ao2h1;
    var $5M3R9;
    var $4V52L;
    var $16v4H;
    var $cZpsT;
    var $l8ruj;
    var $b97pv;
    var $a2MWg;
    var $b2nyH;
    var $erBFB;
    var $gxq4u;
    var $7x18A;
    const $803f61b5dea1399f$var$footerStyles = {
        root: "_bfhkhp5a"
    };
    const $803f61b5dea1399f$var$SidebarNew = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const { queryReference: queryReference } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource));
        if (isAnonymous) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar.anonymous"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "sidebar.anonymous"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalAnonymous, null)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "sidebar"
        }, queryReference ? (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternal, {
            queryReference: queryReference
        }) : null));
    };
    const $803f61b5dea1399f$var$SidebarInternalAnonymous = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const defaultCollapsed = false;
        const defaultWidth = 340;
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6x3L")).SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a2MWg")).SideNav), {
            testId: $803f61b5dea1399f$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHUgj")).SidebarSelector), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b97pv")).PanelSplitter), {
            label: formatMessage((0, (0, parcelRequire("gxq4u")).messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        })));
    };
    const $803f61b5dea1399f$var$TEST_ID = 'page-layout.sidebar';
    const $803f61b5dea1399f$var$SidebarInternal = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("fZBia")).default), queryReference);
        const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, (0, parcelRequire("4DrQd")).IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
        const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, (0, parcelRequire("4DrQd")).LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6x3L")).SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a2MWg")).SideNav), {
            testId: $803f61b5dea1399f$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHUgj")).SidebarSelector), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2nyH")).SideNavFooter), {
            xcss: $803f61b5dea1399f$var$footerStyles.root
        }, (0, (0, parcelRequire("4R6GH")).fg)('jira_global_invite_nav4') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $803f61b5dea1399f$var$globalInviteButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9yTe")).GlobalInvite), {
            testId: "page-container-v2.common.ui.sidebar.global-invite",
            product: "jira",
            subProduct: subProduct ?? undefined,
            showFlag: showFlag
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V52L")).SidebarFeedbackButton), null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4V52L")).SidebarFeedbackButton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b97pv")).PanelSplitter), {
            label: formatMessage((0, (0, parcelRequire("gxq4u")).messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ht71P")).AsyncNudgeBundledUsersFlagContainer), null)));
    };
    const $803f61b5dea1399f$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
    const $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY = 'sidebar';
    const $803f61b5dea1399f$var$sidebarOverrides = {
        ResizeButton: {
            render: (Component, props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                    id: "sidebar-resize-tooltip",
                    packageName: "page-container",
                    fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                    name: "side_bar_button",
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7x18A")).AsyncResizeButtonTooltip), {
                    isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props))))
        }
    };
    const $803f61b5dea1399f$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
        const { width: width, isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const shouldNotRenderSidebarInServerSide = false && isCollapsed;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "left-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarStyleOverrides, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "leftSidebarSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).LeftSidebarSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).LeftSidebar), {
            isFixed: true,
            width: width,
            testId: $803f61b5dea1399f$var$SIDEBAR_TEST_ID,
            resizeButtonLabel: intl.formatMessage((0, (0, parcelRequire("gxq4u")).messages).sidebarNavigation),
            collapsedState: isCollapsed ? 'collapsed' : 'expanded',
            overrides: $803f61b5dea1399f$var$sidebarOverrides,
            id: "ak-side-navigation"
        }, !shouldNotRenderSidebarInServerSide && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, route !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "start",
            traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
        })), sidebar, route !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
        }))))));
    };
    const $803f61b5dea1399f$var$SidebarInternalOldMemo = (0, $5uXOq.memo)($803f61b5dea1399f$var$SidebarInternalOld, (0, ($parcel$interopDefault($ajpes))));
    const $803f61b5dea1399f$var$renderChildren = (sidebar)=>sidebar !== null ? (0, ($parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalOldMemo, {
            sidebar: sidebar
        }) : null;
    const $803f61b5dea1399f$var$SidebarOld = ()=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eGkew")).SidebarSelectorProvider), {
            sidebar: route.navigation?.sidebar ?? null
        }, $803f61b5dea1399f$var$renderChildren);
    };
    const $803f61b5dea1399f$export$1ba59dacbcbf90fe = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $803f61b5dea1399f$var$SidebarNew, $803f61b5dea1399f$var$SidebarOld);
    const $803f61b5dea1399f$var$SidebarStyleOverrides = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1d7w7yr": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gwIPs")).layers).leftSidebar)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1pbyg9ti _14c1glyw",
                __cmplp.className
            ])
        });
    });
    const $803f61b5dea1399f$var$globalInviteButtonStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        flexGrow: 1
    });
});
parcelRegister("j9yTe", function(module, exports) {
    $parcel$export(module.exports, "GlobalInvite", ()=>$525ecb24de1aec94$export$93cb436db3d27b7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $8B7Zd;
    var $8D8Pf;
    var $c5qBf;
    const $525ecb24de1aec94$var$LazyGlobalInviteModalDialogContent = (0, $5uXOq.lazy)(()=>(parcelRequire("37wh2")).then((module)=>({
                default: module.ModalDialogContent
            })));
    function $525ecb24de1aec94$var$AsyncGlobalInviteModalDialogContent(props) {
        return $5uXOq.createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallback: $5uXOq.createElement((0, (0, parcelRequire("8B7Zd")).ErrorState), null)
        }, $5uXOq.createElement((0, $5uXOq.Suspense), {
            fallback: $5uXOq.createElement((0, (0, parcelRequire("8D8Pf")).LoadingState), null)
        }, $5uXOq.createElement($525ecb24de1aec94$var$LazyGlobalInviteModalDialogContent, props)));
    }
    const $525ecb24de1aec94$export$93cb436db3d27b7e = (0, (0, parcelRequire("c5qBf")).withModalDialog)($525ecb24de1aec94$var$AsyncGlobalInviteModalDialogContent);
});
parcelRegister("f4cXA", function(module, exports) {
    (function(global, factory) {
        factory(module.exports, (parcelRequire("5uXOq")));
    })(module.exports, function(exports1, React) {
        'use strict';
        function _interopNamespace(e) {
            if (e && e.__esModule) return e;
            var n = Object.create(null);
            if (e) Object.keys(e).forEach(function(k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
            n["default"] = e;
            return Object.freeze(n);
        }
        var React__namespace = _interopNamespace(React);
        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass);
        }
        var changedArray = function changedArray(a, b) {
            if (a === void 0) a = [];
            if (b === void 0) b = [];
            return a.length !== b.length || a.some(function(item, index) {
                return !Object.is(item, b[index]);
            });
        };
        var initialState = {
            error: null
        };
        var ErrorBoundary = function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary() {
                var _this;
                for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(_args)) || this;
                _this.state = initialState;
                _this.resetErrorBoundary = function() {
                    var _this$props;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                    _this.reset();
                };
                return _this;
            }
            ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            };
            var _proto = ErrorBoundary.prototype;
            _proto.reset = function reset() {
                this.setState(initialState);
            };
            _proto.componentDidCatch = function componentDidCatch(error, info) {
                var _this$props$onError, _this$props2;
                (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
            };
            _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
                var error = this.state.error;
                var resetKeys = this.props.resetKeys;
                if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                    var _this$props$onResetKe, _this$props3;
                    (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                    this.reset();
                }
            };
            _proto.render = function render() {
                var error = this.state.error;
                var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
                if (error !== null) {
                    var _props = {
                        error: error,
                        resetErrorBoundary: this.resetErrorBoundary
                    };
                    if (React__namespace.isValidElement(fallback)) return fallback;
                    else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                    else if (FallbackComponent) return React__namespace.createElement(FallbackComponent, _props);
                    else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React__namespace.Component);
        function withErrorBoundary(Component, errorBoundaryProps) {
            var Wrapped = function Wrapped(props) {
                return React__namespace.createElement(ErrorBoundary, errorBoundaryProps, React__namespace.createElement(Component, props));
            };
            var name = Component.displayName || Component.name || 'Unknown';
            Wrapped.displayName = "withErrorBoundary(" + name + ")";
            return Wrapped;
        }
        function useErrorHandler(givenError) {
            var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
            if (givenError != null) throw givenError;
            if (error != null) throw error;
            return setError;
        }
        exports1.ErrorBoundary = ErrorBoundary;
        exports1.useErrorHandler = useErrorHandler;
        exports1.withErrorBoundary = withErrorBoundary;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    });
});
parcelRegister("8B7Zd", function(module, exports) {
    $parcel$export(module.exports, "ErrorState", ()=>$f19b0899f3e32d55$export$c1ed4f415b9e7023);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $hgYNN;
    var $iaTnv;
    var $1m92z;
    var $jJ1Sb;
    var $ePWI8;
    const $f19b0899f3e32d55$var$styles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        paddingBlock: 'space.1000',
        paddingInline: 'space.100',
        textAlign: 'center'
    });
    function $f19b0899f3e32d55$export$c1ed4f415b9e7023() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.050",
            testId: "global-invite--error-state",
            xcss: $f19b0899f3e32d55$var$styles
        }, $5uXOq.createElement((0, (0, parcelRequire("hgYNN")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("ePWI8")).messages).errorStateHeading)), $5uXOq.createElement((0, (0, parcelRequire("1m92z")).default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("ePWI8")).messages).errorStateDescription)));
    }
});
parcelRegister("ePWI8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$41c9904b463dde43$export$defe85febe8b728c);
    var $7VHMR;
    const $41c9904b463dde43$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorStateHeading: {
            id: 'navigation.global-invite.error-state-heading',
            description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
            defaultMessage: "We can't load the invite list right now"
        },
        errorStateDescription: {
            id: 'navigation.global-invite.error-state-description',
            description: "Description of the error state UI indicating we couldn't load the invite people widget.",
            defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
        }
    });
});
parcelRegister("8D8Pf", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$14ab342691e55af0$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $6T4rd;
    var $iaTnv;
    var $jJ1Sb;
    var $eBKuY;
    var $8tUJa;
    var $9caJc;
    const $14ab342691e55af0$var$styles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        paddingBlock: 'space.500',
        paddingInline: 'space.300'
    });
    function $14ab342691e55af0$export$62aa48085237e36f() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const items = Array.from({
            length: 5
        }, (_, index)=>$5uXOq.createElement((0, (0, parcelRequire("eBKuY")).default), {
                isShimmering: true,
                width: "100%",
                height: "var(--ds-space-200, 16px)",
                testId: "skeleton-shimmering",
                key: index
            }));
        return $5uXOq.createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $14ab342691e55af0$var$styles,
            testId: "global-invite--loading-state"
        }, $5uXOq.createElement((0, (0, parcelRequire("8tUJa")).default), null, formatMessage((0, (0, parcelRequire("9caJc")).messages).loadingLabel)), $5uXOq.createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            testId: "skeleton-group"
        }, items));
    }
});
parcelRegister("eBKuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55656459e2d6b9c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $55656459e2d6b9c5$var$shimmerKeyframes = null;
    const $55656459e2d6b9c5$var$skeletonStyles = null;
    const $55656459e2d6b9c5$var$activeShimmerStyles = null;
    const $55656459e2d6b9c5$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
        const groupDataAttribute = groupName && `data-${groupName}`;
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            style: {
                width: width,
                height: height,
                borderRadius: borderRadius,
                backgroundColor: color,
                '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
                '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
            },
            ...groupDataAttribute && {
                [groupDataAttribute]: 'true'
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
                isShimmering && "",
                isShimmering && "_j7hq1y0p"
            ])
        });
    };
    var $55656459e2d6b9c5$export$2e2bcd8739ae039 = $55656459e2d6b9c5$var$Skeleton;
});
parcelRegister("9caJc", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$89ea036e81d83d4f$export$defe85febe8b728c);
    var $7VHMR;
    const $89ea036e81d83d4f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadingLabel: {
            id: 'navigation.global-invite.loading-visually-hidden-label',
            description: 'Visually hidden text to indicate the invite people UI is loading.',
            defaultMessage: 'Loading'
        }
    });
});
parcelRegister("c5qBf", function(module, exports) {
    $parcel$export(module.exports, "withModalDialog", ()=>$626453c5e63c2316$export$2d7d84d397d9a585);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dHJL9;
    var $dOHxT;
    var $lkDqR;
    var $7UygT;
    function $626453c5e63c2316$export$2d7d84d397d9a585(Content) {
        return function ModalDialog({ testId: testId = (0, $4e2ebeb1f99bbbef$export$bb76aeb9f599715c), triggerElement: TriggerElement, ...props }) {
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const [isModalDialogOpen, setIsModalDialogOpen] = (0, $5uXOq.useState)(false);
            const openModalDialog = (0, $5uXOq.useCallback)(()=>{
                setIsModalDialogOpen(true);
            }, []);
            const closeModalDialog = (0, $5uXOq.useCallback)(()=>{
                setIsModalDialogOpen(false);
            }, []);
            const focusDialog = (0, $5uXOq.useCallback)((node)=>{
                node.focus();
            }, []);
            return $5uXOq.createElement("div", {
                "data-testid": testId
            }, TriggerElement ? $5uXOq.createElement(TriggerElement, {
                onClick: openModalDialog
            }) : $5uXOq.createElement((0, (0, parcelRequire("dHJL9")).default), {
                shouldFitContainer: true,
                onClick: openModalDialog,
                testId: `${testId}--${(0, $4e2ebeb1f99bbbef$export$1dab7caa4b20a4cc)}`
            }, formatMessage((0, (0, parcelRequire("7UygT")).messages).triggerElementLabel)), $5uXOq.createElement((0, (0, parcelRequire("lkDqR")).default), null, isModalDialogOpen ? $5uXOq.createElement((0, (0, parcelRequire("dOHxT")).default), {
                width: "small",
                shouldScrollInViewport: true,
                shouldReturnFocus: true,
                onClose: closeModalDialog,
                autoFocus: false,
                onOpenComplete: focusDialog,
                testId: `${testId}--${(0, $4e2ebeb1f99bbbef$export$7622d28bacf170d1)}`
            }, $5uXOq.createElement(Content, {
                closeModalDialog: closeModalDialog,
                ...props
            })) : null));
        };
    }
});
const $4e2ebeb1f99bbbef$export$bb76aeb9f599715c = 'global-invite';
const $4e2ebeb1f99bbbef$export$7622d28bacf170d1 = 'modal-dialog';
const $4e2ebeb1f99bbbef$export$1dab7caa4b20a4cc = 'trigger-element';
parcelRegister("7UygT", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$05f05c0b0d3f76c8$export$defe85febe8b728c);
    var $7VHMR;
    const $05f05c0b0d3f76c8$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerElementLabel: {
            id: 'navigation.global-invite.trigger-element-label',
            description: 'Text content of the button that triggers the modal dialog.',
            defaultMessage: 'Invite people'
        }
    });
});
parcelRegister("37wh2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8RPJ5")
    ]).then(()=>parcelRequire('3PaX2'));
});
parcelRegister("aWse0", function(module, exports) {
    $parcel$export(module.exports, "useIntlV2", ()=>$6b28e3c9e1c89fbd$export$d82607073b68786);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
        const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, (0, parcelRequire("koVbs")).default)();
        const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
            const modifiedIntl = {
                messages: messages,
                locale: locale,
                formats: formats,
                formatDate: formatDate,
                formatMessage: formatMessage,
                formatNumber: formatNumber,
                formatPlural: formatPlural,
                formatTime: formatTime
            };
            return modifiedIntl;
        }, [
            formatDate,
            formatMessage,
            formatPlural,
            formatTime,
            formatNumber,
            formats,
            locale,
            messages
        ]);
        return memoisedIntl;
    };
});
parcelRegister("c6x3L", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ContextProvider", ()=>$313dc1bbe6a8339e$export$ebf7cdfc2e83bcef);
    $parcel$export(module.exports, "useSidebarNav4", ()=>$313dc1bbe6a8339e$export$dc46c14934833db2);
    var $5uXOq = parcelRequire("5uXOq");
    var $doZTA;
    var $3Jbkp;
    var $fMcVX;
    var $7Ckoi;
    const $313dc1bbe6a8339e$var$SidebarNav4Context = (0, $5uXOq.createContext)(null);
    function $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef(props) {
        const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
        const [routerContext] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
        const [selectedPath, setSelectedPath] = (0, $5uXOq.useState)(initialSelectedPath);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setSelectedPath((currentPath)=>{
                const newPath = (0, (0, parcelRequire("7Ckoi")).routeToSelectedPath)(routerContext);
                return currentPath.toString() === newPath.toString() ? currentPath : newPath;
            });
        }, [
            routerContext
        ]);
        const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
                isInitialSelectedPath: isInitialSelectedPath ?? (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath),
                isSelectedPath: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(selectedPath)
            }), [
            initialSelectedPath,
            isInitialSelectedPath,
            selectedPath
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $313dc1bbe6a8339e$export$dc46c14934833db2() {
        const context = (0, $5uXOq.useContext)($313dc1bbe6a8339e$var$SidebarNav4Context);
        if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
        return context;
    }
});
parcelRegister("jHUgj", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelector", ()=>$727f611db6c21522$export$7937e2d32a777fcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $65Ltd;
    var $8J6rn;
    var $4R6GH;
    var $lmyls;
    var $3F9p6;
    var $jKa0E;
    var $3ed52;
    var $dOB7H;
    var $dEbXe;
    var $Tdcaw;
    var $fbami;
    var $bCaZu;
    var $gYSoA;
    var $ieEgo;
    var $kNJsg;
    var $aWnEG;
    var $2KXa8;
    var $hrRcW;
    var $lF3VU;
    var $bJJms;
    var $6ZLHo;
    var $7VBev;
    var $YiTdm;
    var $kqEpF;
    var $1G9rm;
    var $drQWa;
    var $2DtJE;
    var $cnyf1;
    var $iXVV6;
    var $dAfqg;
    var $c1mlA;
    var $doZTA;
    const $727f611db6c21522$var$entitySettingsSidebarAnalyticsAttributes = {
        navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9)
    };
    const $727f611db6c21522$var$ProjectSettingsSidebarSelector = ()=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        let sidebar = null;
        if (loading) sidebar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null);
        if (error) throw error;
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ZLHo")).default), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJJms")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnyf1")).default), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2DtJE")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) sidebar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqEpF")).default), {
            project: project
        });
        if (project?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) || project?.projectType === (0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drQWa")).AsyncJsmTmpProjectSettingsSidebar), {
            project: project
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1G9rm")).AsyncJsmCmpProjectSettingsSidebar), {
            project: project
        });
        if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project",
            attributes: $727f611db6c21522$var$entitySettingsSidebarAnalyticsAttributes
        }, sidebar);
    };
    const $727f611db6c21522$var$BoardSettingsSidebar = ()=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dEbXe")).Skeleton), null);
        if (error) throw error;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project",
            attributes: $727f611db6c21522$var$entitySettingsSidebarAnalyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOB7H")).default), null));
    };
    const $727f611db6c21522$var$REDIRECT_ROUTES_NAMES = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT)
    ]);
    const $727f611db6c21522$var$InternalSidebarSelector = ()=>{
        const [{ match: { params: params }, route: route, location: location, query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { saveCurrentRoute: saveCurrentRoute } = (0, (0, parcelRequire("jKa0E")).useNavigateBack)();
        const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, (0, parcelRequire("Tdcaw")).useGlobalAppsSettingsConnectItemActive)();
        const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, (0, parcelRequire("kNJsg")).useGlobalSystemSettingsConnectItemActive)();
        const { isActive: isProjectSettingsConnectAppActive } = (0, (0, parcelRequire("YiTdm")).useIsConnectAppActive)();
        const { shouldUseJSM: shouldUseJSM } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        switch(route.navigation?.sidebarId){
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lF3VU")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
                if (!location.pathname.includes('/discover')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbami")).default), null);
                break;
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ieEgo")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bCaZu")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
                if (location.pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, (0, parcelRequire("4R6GH")).fg)('fix_chatops_new_nav_bug')) break;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYSoA")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWnEG")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrRcW")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).HELP_CENTER_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KXa8")).default), null);
            case (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS:
                return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
            default:
                break;
        }
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS) && params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
        if (route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE) && (0, (0, parcelRequire("c1mlA")).BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(query.config) && (0, (0, parcelRequire("4R6GH")).fg)('simplified-boards-milestone-2_07hbk')) return (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$BoardSettingsSidebar, null);
        if (isGlobalAppsSettingsConnectItemActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbami")).default), null);
        if (isGlobalSystemSettingsConnectItemActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWnEG")).default), null);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') || !$727f611db6c21522$var$REDIRECT_ROUTES_NAMES.has(route.name)) saveCurrentRoute();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ed52")).default), null);
    };
    const $727f611db6c21522$export$7937e2d32a777fcb = ()=>{
        const attributes = (0, $5uXOq.useMemo)(()=>({
                navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
                navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
                navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
                stage: (0, (0, parcelRequire("3F9p6")).getNav4Rollout)().stage
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKa0E")).NavigateBackProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: attributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$InternalSidebarSelector, null)));
    };
});
const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';
const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';
parcelRegister("3F9p6", function(module, exports) {
    $parcel$export(module.exports, "getNav4Rollout", ()=>$826ce4e4d6cfd68d$export$84a05d3b37ec5d2);
    var $9glig = parcelRequire("9glig");
    var $cxSdl = parcelRequire("cxSdl");
    var $hMlwW = parcelRequire("hMlwW");
    var $6s1PB;
    var $4R6GH;
    var $c0dQj;
    var $7qZOo;
    var $396KQ;
    var $8O1QZ;
    var $32Frn;
    const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, ($parcel$interopDefault($9glig)))([
        [
            ()=>!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4'),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_NONE))
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding'),
            (0, (0, parcelRequire("8O1QZ")).getNav4RolloutForDogfooding)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap'),
            (0, (0, parcelRequire("32Frn")).getNav4RolloutForEap)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_existing-customers'),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('existing-customers')
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_sandboxes'),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('sandboxes')
        ],
        [
            ()=>(0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('free-customers')
        ],
        [
            ()=>(0, (0, parcelRequire("6s1PB")).expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
            (0, (0, parcelRequire("396KQ")).getNav4RolloutForBetaCohort)('new-customers')
        ],
        [
            ()=>(0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)(),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_MOBILE))
        ],
        [
            (0, ($parcel$interopDefault($hMlwW))),
            (0, ($parcel$interopDefault($cxSdl)))((0, (0, parcelRequire("7qZOo")).NAV4_ROLLOUT_NONE))
        ]
    ]);
});
parcelRegister("9glig", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $1nIHN = parcelRequire("1nIHN");
    var $bxDef = parcelRequire("bxDef");
    var $g7i7g = parcelRequire("g7i7g");
    var $6be62026d39b34ea$var$FUNC_ERROR_TEXT = 'Expected a function';
    function $6be62026d39b34ea$var$cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = $bxDef;
        pairs = !length ? [] : $1nIHN(pairs, function(pair) {
            if (typeof pair[1] != 'function') throw new TypeError($6be62026d39b34ea$var$FUNC_ERROR_TEXT);
            return [
                toIteratee(pair[0]),
                pair[1]
            ];
        });
        return $g7i7g(function(args) {
            var index = -1;
            while(++index < length){
                var pair = pairs[index];
                if ($hlchF(pair[0], this, args)) return $hlchF(pair[1], this, args);
            }
        });
    }
    module.exports = $6be62026d39b34ea$var$cond;
});
parcelRegister("hMlwW", function(module, exports) {
    function $cf179ed6624748c2$var$stubTrue() {
        return true;
    }
    module.exports = $cf179ed6624748c2$var$stubTrue;
});
parcelRegister("396KQ", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForBetaCohort", ()=>$61e8415b5cadda16$export$d0b7d7e3a8d0a0c9);
    var $1MhR0;
    const $61e8415b5cadda16$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
                stage: 'beta',
                cohort: cohort
            } : {
                stage: 'beta',
                cohort: cohort,
                isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
            };
});
parcelRegister("8O1QZ", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForDogfooding", ()=>$48ac6742e168ff29$export$f1e751a9a9d68fb5);
    var $9glig = parcelRequire("9glig");
    var $hMlwW = parcelRequire("hMlwW");
    var $4R6GH;
    var $1MhR0;
    const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
                stage: 'dogfooding',
                phase: phase,
                isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
            } : {
                stage: 'dogfooding',
                phase: phase
            };
    const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, ($parcel$interopDefault($9glig)))([
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2'),
            $48ac6742e168ff29$var$dogfoodingPhase(2)
        ],
        [
            ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1'),
            $48ac6742e168ff29$var$dogfoodingPhase(1)
        ],
        [
            (0, ($parcel$interopDefault($hMlwW))),
            $48ac6742e168ff29$var$dogfoodingPhase(3)
        ]
    ]);
});
parcelRegister("32Frn", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForEap", ()=>$d3197687d5551826$export$42dd8c002a342b8);
    var $1MhR0;
    const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
            stage: 'eap',
            isUserOptOut: (0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)()
        });
});
parcelRegister("jKa0E", function(module, exports) {
    $parcel$export(module.exports, "useNavigateBack", ()=>$e131d9d1fc634955$export$7ce1f551d78f9130);
    $parcel$export(module.exports, "NavigateBackProvider", ()=>$e131d9d1fc634955$export$e1e76f4ee7f8174d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $dIHnK;
    var $lVJAU;
    var $bOr6i;
    const $e131d9d1fc634955$var$STORAGE_KEY = 'back-button-url';
    const $e131d9d1fc634955$var$NavigateBackContext = (0, $5uXOq.createContext)(undefined);
    const $e131d9d1fc634955$export$7ce1f551d78f9130 = ()=>{
        const context = (0, $5uXOq.useContext)($e131d9d1fc634955$var$NavigateBackContext);
        if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
        return context;
    };
    const $e131d9d1fc634955$export$e1e76f4ee7f8174d = ({ children: children })=>{
        (0, (0, parcelRequire("gKZoD")).di)(window);
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [previousUrl, setPreviousUrl] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("bOr6i")).storageProvider).get($e131d9d1fc634955$var$STORAGE_KEY));
        const saveCurrentRoute = (0, $5uXOq.useCallback)(()=>{
            const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            setPreviousUrl(url);
            (0, (0, parcelRequire("bOr6i")).storageProvider).set($e131d9d1fc634955$var$STORAGE_KEY, url);
        }, []);
        const goBack = (0, $5uXOq.useCallback)(()=>push(previousUrl ?? (0, (0, parcelRequire("dIHnK")).jiraHomeRoute).path), [
            previousUrl,
            push
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                saveCurrentRoute: saveCurrentRoute,
                goBack: goBack
            }), [
            saveCurrentRoute,
            goBack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e131d9d1fc634955$var$NavigateBackContext.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("dIHnK", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeRoute", ()=>$90d9eefc14df7b5b$export$11ebbd6d4e57759c);
    var $65Ltd;
    const $90d9eefc14df7b5b$export$11ebbd6d4e57759c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        path: '/jira/your-work'
    };
});
parcelRegister("bOr6i", function(module, exports) {
    $parcel$export(module.exports, "storageProvider", ()=>$36fbcced1b17c587$export$ce7751641b93537d);
    var $eNf8a;
    const $36fbcced1b17c587$export$ce7751641b93537d = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('sidebar-navigation');
});
parcelRegister("3ed52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2e015ea5d0812b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $hPtZI;
    const $a2e015ea5d0812b1$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("iSW4Y")).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/core/src/index.tsx"
    });
    const $a2e015ea5d0812b1$var$AsyncSidebarContent = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "asyncSidebarContent",
            packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazySidebarContent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a2e015ea5d0812b1$var$LazySidebarContent, null))));
    $a2e015ea5d0812b1$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
    var $a2e015ea5d0812b1$export$2e2bcd8739ae039 = $a2e015ea5d0812b1$var$AsyncSidebarContent;
});
parcelRegister("cljJ9", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$f6d5489447b9aa6b$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $8dXDG;
    var $93jKl;
    var $cfDZ3;
    var $cKjfv;
    var $6Jt8x;
    const $f6d5489447b9aa6b$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName })=>{
        const { experience: experience, attributes: attributes } = (0, (0, parcelRequire("cKjfv")).useSidebarExperience)();
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience,
            attributes: attributes
        });
        const onAbort = (0, (0, parcelRequire("8dXDG")).useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const isNotSSR = !false;
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                userLocation: userLocation
            }), [
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Jt8x")).Fallback), {
                error: error
            }), []);
        const handleError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
                error: error
            });
            else onFail(location, error);
        }, [
            onAbort,
            onFail
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            extraEventData: extraEventData,
            fallback: fallback,
            teamName: teamName,
            onError: handleError
        }, isNotSSR && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cKjfv")).SidebarStart), null), children);
    };
});
parcelRegister("8dXDG", function(module, exports) {
    $parcel$export(module.exports, "useExperienceAbort", ()=>$2df1decadd95b490$export$cc92b7ce453f4403);
    var $5uXOq = parcelRequire("5uXOq");
    var $l9g16;
    const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
            const { current: current } = self;
            current.experienceTracker.abort({
                name: current.name,
                reason: reason,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("cKjfv", function(module, exports) {
    $parcel$export(module.exports, "useSidebarExperience", ()=>$c4243e40cbbf3b86$export$d4fa533dfe4d7583);
    $parcel$export(module.exports, "SidebarStart", ()=>$c4243e40cbbf3b86$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarReady", ()=>$c4243e40cbbf3b86$export$a06ecbbe5820282);
    var $5uXOq = parcelRequire("5uXOq");
    var $3w7PN;
    var $kaHBi;
    var $3bQtK;
    var $6jY6G;
    var $8zOmE;
    var $95EVP;
    var $6IzHB;
    const $c4243e40cbbf3b86$export$d4fa533dfe4d7583 = ()=>{
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        return (0, $5uXOq.useMemo)(()=>({
                experience: 'viewSidebarNavigation',
                experienceId: pageId,
                analyticsSource: 'Sidebar',
                attributes: {
                    sidebar: 'v4'
                }
            }), [
            pageId
        ]);
    };
    const $c4243e40cbbf3b86$export$6738d1299dc79710 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource
        });
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) return;
            onStartExperience();
        }, [
            onStartExperience,
            route
        ]);
        return null;
    };
    const $c4243e40cbbf3b86$export$a06ecbbe5820282 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { experience: experience, attributes: attributes } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
        const onSuccessfulExperience = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experience,
            attributes: attributes
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const doNotRunEffects = route.isRedirect || false;
        const sidebarId = route.navigation?.sidebarId ?? 'default';
        (0, $5uXOq.useEffect)(()=>{
            if (doNotRunEffects) return;
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            doNotRunEffects,
            routeName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (doNotRunEffects) return;
            onSuccessfulExperience();
        }, [
            doNotRunEffects,
            onSuccessfulExperience,
            route
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                sidebarType: sidebarId
            }), [
            sidebarId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3w7PN")).default), {
            data: customData
        });
    };
});
parcelRegister("3w7PN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b8c8ffcfcff35f7$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "addUFOCustomData", ()=>$3b8c8ffcfcff35f7$export$d12f56a472cdbe6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $80cnJ;
    var $20wDi;
    var $iNl9c;
    function $3b8c8ffcfcff35f7$export$2e2bcd8739ae039({ data: data }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("80cnJ")).default));
        (0, $5uXOq.useMemo)(()=>{
            if (!interactionContext) return;
            interactionContext.addCustomData(data);
        }, [
            data,
            interactionContext
        ]);
        return null;
    }
    function $3b8c8ffcfcff35f7$export$d12f56a472cdbe6c(data) {
        const interactionId = (0, (0, parcelRequire("20wDi")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, (0, parcelRequire("iNl9c")).addCustomData)(currentInteractionId, [], data);
    }
});
parcelRegister("6Jt8x", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$d1b1aff7b337b0d4$export$fb8d7f40caaeea67);
    var $5uXOq = parcelRequire("5uXOq");
    var $hgYNN;
    var $6T4rd;
    var $iaTnv;
    var $1m92z;
    var $kobfu;
    var $7q5TP;
    var $koVbs;
    var $5Ntjt;
    const $d1b1aff7b337b0d4$var$styles = {
        wrapper: "_bfhkm7j4 _syaz1gjq _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc",
        error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
    };
    const $d1b1aff7b337b0d4$export$fb8d7f40caaeea67 = ({ error: error })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            xcss: $d1b1aff7b337b0d4$var$styles.wrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7q5TP")).default), {
            width: "40px",
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgYNN")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("5Ntjt")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1m92z")).default), null, formatMessage((0, (0, parcelRequire("5Ntjt")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d1b1aff7b337b0d4$var$styles.error
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("7q5TP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc8d7b09135bd30b$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("8ODZY")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("b2nX8")))));
    var $dCLgq;
    var $b2nX8 = parcelRequire("b2nX8");
    var $8ODZY = parcelRequire("8ODZY");
    const $dc8d7b09135bd30b$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($8ODZY)),
        srcDark: ($parcel$interopDefault($b2nX8))
    });
    var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
    const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        212
    ];
});
parcelRegister("dCLgq", function(module, exports) {
    $parcel$export(module.exports, "Illustration", ()=>$191b30bb5e9fa934$export$d43c2e2ca9b2c105);
    $parcel$export(module.exports, "createIllustration", ()=>$191b30bb5e9fa934$export$4d00e7be716a0093);
    var $5uXOq = parcelRequire("5uXOq");
    var $10ozQ;
    function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("10ozQ")).AsImg), props);
    }
    function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
                srcLight: srcLight,
                srcDark: srcDark,
                autoDark: autoDark,
                ...props
            });
    }
});
parcelRegister("10ozQ", function(module, exports) {
    $parcel$export(module.exports, "AsImg", ()=>$b5af8835f639f069$export$75e378065cb7d6c0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $disyi;
    const $b5af8835f639f069$var$defaultStyles = null;
    const $b5af8835f639f069$var$fillStyles = null;
    const $b5af8835f639f069$var$autoDarkModeStyles = null;
    function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("disyi")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: colorMode === 'dark' ? srcDark : srcLight,
            alt: alt,
            "data-testid": testId,
            ...imgProps,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
                fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
                colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
            ])
        });
    }
});
parcelRegister("b2nX8", function(module, exports) {
    module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();
});
parcelRegister("8ODZY", function(module, exports) {
    module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();
});
parcelRegister("5Ntjt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ef9823ba7f6e404$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ef9823ba7f6e404$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("iSW4Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("3cwJf")),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("c5OxX")
    ]).then(()=>parcelRequire('gyZtn'));
});
parcelRegister("dOB7H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$358df587d3e80a76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $hPtZI;
    var $dEbXe;
    const $358df587d3e80a76$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8AK0s")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
    });
    const $358df587d3e80a76$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.board-settings",
            packageName: "jiraNavigationAppsSidebarNav4BoardSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.board-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dEbXe")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($358df587d3e80a76$var$LazySidebarContent, null)));
    var $358df587d3e80a76$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($358df587d3e80a76$var$AsyncSidebar);
});
parcelRegister("dEbXe", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$ff13cb96c7f2cede$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $fHbE4;
    var $iaTnv;
    var $jJ1Sb;
    const $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $ff13cb96c7f2cede$var$menuItem
        })));
    const $ff13cb96c7f2cede$var$containerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $ff13cb96c7f2cede$var$backButton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $ff13cb96c7f2cede$var$headingSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $ff13cb96c7f2cede$var$menuItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("8AK0s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gS3ma")
    ]).then(()=>parcelRequire('gNcDN'));
});
parcelRegister("Tdcaw", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$a54a68c44d0262b5$export$f0785b98c99d344c);
    $parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", ()=>$a54a68c44d0262b5$export$8dd86b1eb9fdf786);
    $parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", ()=>$a54a68c44d0262b5$export$83008eebb9fccef3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $hWBtO;
    var $efOLn;
    var $bYoAQ;
    var $hz6Yb;
    var $doZTA;
    const $a54a68c44d0262b5$var$getItems = (d)=>(0, (0, parcelRequire("hWBtO")).getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, (0, parcelRequire("efOLn")).transformLink)).filter(Boolean);
    const $a54a68c44d0262b5$export$f0785b98c99d344c = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("bYoAQ")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $a54a68c44d0262b5$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    };
    const $a54a68c44d0262b5$export$ae997bf97ec22b71 = new Set([
        'configurePage',
        'postInstallPage'
    ]);
    const $a54a68c44d0262b5$export$8dd86b1eb9fdf786 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("hz6Yb")).useConnectGeneralResource)();
        return {
            isActive: $a54a68c44d0262b5$export$ae997bf97ec22b71.has(data?.moduleType),
            loading: loading,
            error: error
        };
    };
    const $a54a68c44d0262b5$export$83008eebb9fccef3 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = $a54a68c44d0262b5$export$f0785b98c99d344c();
        const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $a54a68c44d0262b5$export$8dd86b1eb9fdf786();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, (0, parcelRequire("8maDO")).findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || isAppsSettingsConnectAppModuleActive,
            loading: loading || isAppsSettingsConnectAppModuleLoading,
            error: error || isAppsSettingsConnectAppModuleError
        };
    };
});
parcelRegister("8maDO", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$c4af9df81f308e02$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $c4af9df81f308e02$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $c4af9df81f308e02$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $c4af9df81f308e02$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $c4af9df81f308e02$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $c4af9df81f308e02$var$splitRelevantQs(itemQs);
            const sameQuery = $c4af9df81f308e02$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $c4af9df81f308e02$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("k0iPT", function(module, exports) {
    $parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", ()=>$c82776b15970ab04$export$a8aac2ba4dc1f57);
    $parcel$export(module.exports, "CONNECT_ROUTES_SET", ()=>$c82776b15970ab04$export$c47bf667d3008c53);
    var $65Ltd;
    const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
    ]);
    const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
    ]);
});
parcelRegister("hWBtO", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$90a1a565c575dc5b$export$8054dcb2b42da45c);
    var $9KzPc;
    const $90a1a565c575dc5b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $90a1a565c575dc5b$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $90a1a565c575dc5b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $90a1a565c575dc5b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
    const $90a1a565c575dc5b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = $90a1a565c575dc5b$var$getLinksFromSidebar(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, (0, parcelRequire("9KzPc")).connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, (0, parcelRequire("9KzPc")).connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, (0, parcelRequire("9KzPc")).jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("9KzPc", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$f13744297e4a8bc9$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$f13744297e4a8bc9$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$f13744297e4a8bc9$export$b1c2c1fc5d10280);
    var $16J3A;
    const $f13744297e4a8bc9$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $f13744297e4a8bc9$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $f13744297e4a8bc9$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $f13744297e4a8bc9$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $f13744297e4a8bc9$export$b1c2c1fc5d10280 = [
        $f13744297e4a8bc9$var$legacyAddonPanelLinkId,
        (0, (0, parcelRequire("16J3A")).REPORTS_IDS).REPORTS_ADDONS,
        $f13744297e4a8bc9$var$jsdQueuesConnectSection
    ];
});
parcelRegister("efOLn", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$179f73798c754e8b$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$179f73798c754e8b$export$27267b6b6650eaa5);
    const $179f73798c754e8b$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($179f73798c754e8b$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $179f73798c754e8b$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($179f73798c754e8b$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("bYoAQ", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$37852a2b10dca6fc$export$1e1c317ed5b99faa);
    var $atU1t;
    var $2YP9W;
    const $37852a2b10dca6fc$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource));
        return {
            data: data && data.response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("hz6Yb", function(module, exports) {
    $parcel$export(module.exports, "connectGeneralResources", ()=>$07e636c36bc19b52$export$f34ab0d904621847);
    $parcel$export(module.exports, "useConnectGeneralResource", ()=>$07e636c36bc19b52$export$53479840ec6d4024);
    var $2M1hQ;
    var $2YP9W;
    const $07e636c36bc19b52$export$f34ab0d904621847 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
        getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
            if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        getDataLoader: ()=>(parcelRequire("bBygl"))
    });
    const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)($07e636c36bc19b52$export$f34ab0d904621847);
});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';
parcelRegister("bBygl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("W2aDd").then(()=>parcelRequire('6LiLg'));
});
parcelRegister("fbami", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f82a04fb3eb62635$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $hPtZI;
    const $f82a04fb3eb62635$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ajhZM")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
    });
    const $f82a04fb3eb62635$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.apps-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "apps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.apps-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f82a04fb3eb62635$var$LazySidebarContent, null))));
    var $f82a04fb3eb62635$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f82a04fb3eb62635$var$AsyncSidebar);
});
parcelRegister("cnlm7", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$eb45bd1b3d8207f6$export$49e8f7b58a4df4ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $hgYNN;
    var $dsFR3;
    var $iaTnv;
    var $jJ1Sb;
    var $koVbs;
    var $iI75Y;
    var $1IN5o;
    var $bqsCp;
    var $9pSh6;
    var $9GB5z;
    var $jDuwy;
    const $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pSh6")).SideNavHeader), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.200",
            xcss: $eb45bd1b3d8207f6$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dsFR3")).default), {
            alignBlock: "center",
            grow: "hug",
            space: "space.100",
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iI75Y")).BackButton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgYNN")).default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("jDuwy")).default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9GB5z")).AsyncPageSwitcher), {
            currentPageName: currentPageName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bqsCp")).SideNavContent), {
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IN5o")).MenuList), null, children)));
    };
    const $eb45bd1b3d8207f6$var$headingStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        paddingInlineStart: 'space.050'
    });
});
parcelRegister("iI75Y", function(module, exports) {
    $parcel$export(module.exports, "BackButton", ()=>$8c6efbfad9d4699a$export$e0d897ee21382f67);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0OK7;
    var $cPeBC;
    var $MGmIU;
    var $koVbs;
    var $8zOmE;
    var $95EVP;
    var $jKa0E;
    var $dJXtD;
    const $8c6efbfad9d4699a$export$e0d897ee21382f67 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { goBack: goBack } = (0, (0, parcelRequire("jKa0E")).useNavigateBack)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MGmIU")).default), {
            content: formatMessage((0, (0, parcelRequire("dJXtD")).default).tooltip),
            hideTooltipOnMouseDown: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0OK7")).default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("cPeBC"))))),
            label: formatMessage((0, (0, parcelRequire("dJXtD")).default).label),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
                goBack();
            }
        }));
    };
});
parcelRegister("dJXtD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b400b92991a2960$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0b400b92991a2960$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
            "defaultMessage": "Go back"
        },
        label: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
            "defaultMessage": "Navigate back to the previous page"
        }
    });
});
parcelRegister("1IN5o", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$105aecfecfb55175$export$d4c4e98c5044dc8);
    var $9Fdip;
    const $105aecfecfb55175$export$d4c4e98c5044dc8 = (0, (0, parcelRequire("9Fdip")).List);
});
parcelRegister("9Fdip", function(module, exports) {
    $parcel$export(module.exports, "List", ()=>$c9f707164884d39d$export$54c2e3dc7acea9f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $oUGyo;
    function $c9f707164884d39d$var$_List({ children: children, xcss: xcss }, forwardedRef) {
        const internalRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            var child;
        }, []);
        const ref = (0, (0, parcelRequire("oUGyo")).default)([
            internalRef,
            forwardedRef
        ]);
        return ($5uXOq.createElement("div", {
            role: "list",
            ref: ref,
            className: xcss
        }, children));
    }
    const $c9f707164884d39d$export$54c2e3dc7acea9f5 = (0, $5uXOq.forwardRef)($c9f707164884d39d$var$_List);
    function $c9f707164884d39d$var$isValidChild(element) {
        if (element.tagName === 'STYLE' || element.tagName === 'SCRIPT') return true;
        if (element.tagName === 'DIV' && element.getAttribute('role') === null) return Array.from(element.children).every($c9f707164884d39d$var$isValidChild);
        return element.getAttribute('role') === 'listitem';
    }
});
parcelRegister("bqsCp", function(module, exports) {
    $parcel$export(module.exports, "SideNavContent", ()=>$37d18648a1eb45ef$export$babe3c784778f3ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $37d18648a1eb45ef$export$babe3c784778f3ba = (0, $5uXOq.forwardRef)($37d18648a1eb45ef$var$_SideNavContent);
    const $37d18648a1eb45ef$var$styles = {
        scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
        paddingContainer: "_1yt4utpp"
    };
    function $37d18648a1eb45ef$var$_SideNavContent({ children: children, testId: testId }, ref) {
        return $5uXOq.createElement("div", {
            ref: ref,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37d18648a1eb45ef$var$styles.scrollContainer
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37d18648a1eb45ef$var$styles.paddingContainer
            ])
        }, children));
    }
});
parcelRegister("9pSh6", function(module, exports) {
    $parcel$export(module.exports, "SideNavHeader", ()=>$430e50fcb7450d1d$export$9d28ff3a0d89869c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $430e50fcb7450d1d$var$styles = {
        root: "_18zrutpp _1q51utpp _85i51b66"
    };
    const $430e50fcb7450d1d$export$9d28ff3a0d89869c = ({ children: children })=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $430e50fcb7450d1d$var$styles.root
            ])
        }, children);
    };
});
parcelRegister("9GB5z", function(module, exports) {
    $parcel$export(module.exports, "AsyncPageSwitcher", ()=>$8f72ed6ff9af1bd8$export$3130bd98029942c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $iaTnv;
    var $jJ1Sb;
    var $lfTZh;
    var $hPtZI;
    const $8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8f72ed6ff9af1bd8$var$headingSkeleton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8f72ed6ff9af1bd8$var$dropdownSkeleton
        }));
    const $8f72ed6ff9af1bd8$var$LazyPageSwitcher = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("iPVb9")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
    });
    const $8f72ed6ff9af1bd8$export$3130bd98029942c = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.page-switcher",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$var$LazyPageSwitcher, props));
    const $8f72ed6ff9af1bd8$var$headingSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $8f72ed6ff9af1bd8$var$dropdownSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("iPVb9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6XfVR")
    ]).then(()=>parcelRequire('8dyHT'));
});
parcelRegister("jDuwy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfdc401436033e3a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dfdc401436033e3a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
            "defaultMessage": "Jira admin settings"
        }
    });
});
parcelRegister("i8077", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$8a8cf6e18096ea33$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $iaTnv;
    var $jJ1Sb;
    const $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$sectionHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$sectionHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $8a8cf6e18096ea33$var$menuItem
        }));
    const $8a8cf6e18096ea33$var$sectionHeading = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100',
        marginTop: 'space.100'
    });
    const $8a8cf6e18096ea33$var$menuItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("ajhZM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4HmNO")
    ]).then(()=>parcelRequire('6JIAx'));
});
parcelRegister("bCaZu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58b39e5bf0fb90a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $hPtZI;
    const $58b39e5bf0fb90a0$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("gxGwA")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
    });
    const $58b39e5bf0fb90a0$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.issues-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "issues"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.issues-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($58b39e5bf0fb90a0$var$LazySidebarContent, null))));
    var $58b39e5bf0fb90a0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($58b39e5bf0fb90a0$var$AsyncSidebar);
});
parcelRegister("gxGwA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hEv4j")
    ]).then(()=>parcelRequire('fUdDx'));
});
parcelRegister("gYSoA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$425ce2b571ab3ef5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $hPtZI;
    const $425ce2b571ab3ef5$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("f6lak")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
    });
    const $425ce2b571ab3ef5$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.products-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "products"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.products-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($425ce2b571ab3ef5$var$LazySidebarContent, null))));
    var $425ce2b571ab3ef5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($425ce2b571ab3ef5$var$AsyncSidebar);
});
parcelRegister("f6lak", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eOt8B")
    ]).then(()=>parcelRequire('864s3'));
});
parcelRegister("ieEgo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b88bb6161ed4902f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $hPtZI;
    const $b88bb6161ed4902f$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jLd8z")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
    });
    const $b88bb6161ed4902f$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.projects-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.projects-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b88bb6161ed4902f$var$LazySidebarContent, null))));
    var $b88bb6161ed4902f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b88bb6161ed4902f$var$AsyncSidebar);
});
parcelRegister("jLd8z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7bkDd")
    ]).then(()=>parcelRequire('fbdwm'));
});
parcelRegister("kNJsg", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", ()=>$90305fd4b8d90c67$export$68950d4e14439158);
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", ()=>$90305fd4b8d90c67$export$5efb701a2106707a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $hWBtO;
    var $efOLn;
    var $fgeiD;
    var $bYoAQ;
    var $hz6Yb;
    var $doZTA;
    const $90305fd4b8d90c67$var$getItems = (d)=>(0, (0, parcelRequire("hWBtO")).getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, (0, parcelRequire("efOLn")).transformLink)).filter(Boolean);
    const $90305fd4b8d90c67$export$68950d4e14439158 = (0, (0, parcelRequire("fgeiD")).withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("bYoAQ")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $90305fd4b8d90c67$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    });
    const $90305fd4b8d90c67$export$5efb701a2106707a = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = $90305fd4b8d90c67$export$68950d4e14439158();
        const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, (0, parcelRequire("hz6Yb")).useConnectGeneralResource)();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, (0, parcelRequire("8maDO")).findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
            loading: loading || connectGeneralResourceLoading,
            error: error || connectGeneralResourceError
        };
    };
});
parcelRegister("fgeiD", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$f9ce174aaa2e063b$export$a018832f2ec4dc91);
    var $gKZoD;
    const $f9ce174aaa2e063b$var$isDataEmpty = (data)=>data == null;
    function $f9ce174aaa2e063b$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, (0, parcelRequire("gKZoD")).di)(theHook);
            const result = theHook(...args);
            if (!false && $f9ce174aaa2e063b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("aWnEG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59776b430a24875d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $cnlm7;
    var $i8077;
    var $lfTZh;
    var $hPtZI;
    const $59776b430a24875d$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("gsY8o")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
    });
    const $59776b430a24875d$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.global-settings.system-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnlm7")).SidebarContent), {
            currentPageName: "system"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.global-settings.system-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8077")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($59776b430a24875d$var$LazySidebarContent, null))));
    var $59776b430a24875d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($59776b430a24875d$var$AsyncSidebar);
});
parcelRegister("gsY8o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9yM86")
    ]).then(()=>parcelRequire('rQUQs'));
});
parcelRegister("2KXa8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5d93ac4546abf11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $hPtZI;
    var $aUxXz;
    const $b5d93ac4546abf11$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("68Ad0")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
    });
    const $b5d93ac4546abf11$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.help-center-settings",
            packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.help-center-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aUxXz")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b5d93ac4546abf11$var$LazySidebarContent, null)));
    var $b5d93ac4546abf11$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b5d93ac4546abf11$var$AsyncSidebar);
});
parcelRegister("aUxXz", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$c42d7c14b1508227$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $fHbE4;
    var $iaTnv;
    var $jJ1Sb;
    const $c42d7c14b1508227$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $c42d7c14b1508227$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $c42d7c14b1508227$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $c42d7c14b1508227$var$menuItem
        })));
    const $c42d7c14b1508227$var$backButton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $c42d7c14b1508227$var$headingSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $c42d7c14b1508227$var$menuItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("68Ad0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jvUDk")
    ]).then(()=>parcelRequire('22iKv'));
});
parcelRegister("hrRcW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e7cdaae12475462$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $lfTZh;
    var $hPtZI;
    var $jUfLV;
    const $8e7cdaae12475462$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("bVy1q")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
    });
    const $8e7cdaae12475462$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.personal-settings",
            packageName: "jiraNavigationAppsSidebarNav4PersonalSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.personal-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUfLV")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8e7cdaae12475462$var$LazySidebarContent, null)));
    var $8e7cdaae12475462$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8e7cdaae12475462$var$AsyncSidebar);
});
parcelRegister("jUfLV", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$1cdf070fb698d8d2$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $fHbE4;
    var $iaTnv;
    var $jJ1Sb;
    const $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $1cdf070fb698d8d2$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $1cdf070fb698d8d2$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $1cdf070fb698d8d2$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $1cdf070fb698d8d2$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $1cdf070fb698d8d2$var$menuItem
        })));
    const $1cdf070fb698d8d2$var$containerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $1cdf070fb698d8d2$var$backButton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $1cdf070fb698d8d2$var$headingSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $1cdf070fb698d8d2$var$menuItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("bVy1q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6lHZh")
    ]).then(()=>parcelRequire('hox2O'));
});
parcelRegister("lF3VU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$442721cda4044790$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    var $bhcrK;
    const $442721cda4044790$var$LazyPlanSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("eNhKs")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
    });
    const $442721cda4044790$var$AsyncSidebar = ({ store: store })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "asyncSidebarPlanSettings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bhcrK")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($442721cda4044790$var$LazyPlanSettingsSidebar, {
            store: store
        }));
    var $442721cda4044790$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($442721cda4044790$var$AsyncSidebar);
});
parcelRegister("bhcrK", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$d204c752b5086975$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $fHbE4;
    var $iaTnv;
    var $jJ1Sb;
    const $d204c752b5086975$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$titleSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$subtitleItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $d204c752b5086975$var$menuItem
        })));
    const $d204c752b5086975$var$titleSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-800, 64px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$backButton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$headingSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $d204c752b5086975$var$menuItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $d204c752b5086975$var$subtitleItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-1000, 80px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("eNhKs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b8Lgd")
    ]).then(()=>parcelRequire('7UsxD'));
});
parcelRegister("bJJms", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cce9becc602ac5ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $hPtZI;
    const $cce9becc602ac5ad$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("04yzC")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
    });
    const $cce9becc602ac5ad$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.business.company-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cce9becc602ac5ad$var$LazySidebarContent, {
            project: project
        })));
    var $cce9becc602ac5ad$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cce9becc602ac5ad$var$AsyncSidebar);
});
parcelRegister("7VBev", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$af3b5ba721400353$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $fHbE4;
    var $c9Fym;
    var $iaTnv;
    var $jJ1Sb;
    const $af3b5ba721400353$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.200",
            xcss: $af3b5ba721400353$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$backButton
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$headingSkeleton
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9Fym")).default), {
            columnGap: "space.100",
            rowGap: "space.050",
            alignItems: "center",
            templateAreas: [
                'avatar name',
                'avatar type'
            ],
            templateColumns: "min-content 1fr",
            xcss: $af3b5ba721400353$var$projectHeading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$projectAvatar,
            style: {
                gridArea: 'avatar'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$projectName,
            style: {
                gridArea: 'name'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$projectType,
            style: {
                gridArea: 'type'
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $af3b5ba721400353$var$menuItem
        })));
    const $af3b5ba721400353$var$containerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        height: '100%',
        padding: 'space.200'
    });
    const $af3b5ba721400353$var$backButton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$headingSkeleton = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $af3b5ba721400353$var$projectHeading = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        marginTop: 'space.100',
        marginBottom: 'space.100'
    });
    const $af3b5ba721400353$var$projectAvatar = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$projectName = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$projectType = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-100, 8px)",
        borderRadius: 'border.radius.100'
    });
    const $af3b5ba721400353$var$menuItem = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("04yzC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("f7rnD")
    ]).then(()=>parcelRequire('kaECc'));
});
parcelRegister("6ZLHo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b222bb97daacff3e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $hPtZI;
    const $b222bb97daacff3e$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3J9D1")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
    });
    const $b222bb97daacff3e$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.business.team-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b222bb97daacff3e$var$LazySidebarContent, {
            project: project
        })));
    var $b222bb97daacff3e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b222bb97daacff3e$var$AsyncSidebar);
});
parcelRegister("3J9D1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("l1ol4")
    ]).then(()=>parcelRequire('v17He'));
});
parcelRegister("YiTdm", function(module, exports) {
    $parcel$export(module.exports, "useIsConnectAppActive", ()=>$c92d349d32b0fe9a$export$249b2e8512031cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $8maDO;
    var $doZTA;
    var $eNZur;
    const $c92d349d32b0fe9a$export$249b2e8512031cae = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: connectApps, error: error, loading: loading } = (0, (0, parcelRequire("eNZur")).useConnectApps)();
        const isActive = (0, $5uXOq.useMemo)(()=>Boolean((0, (0, parcelRequire("8maDO")).findItemAndStack)(connectApps, route.name, location)?.selected), [
            connectApps,
            location,
            route.name
        ]);
        return {
            isActive: isActive,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("eNZur", function(module, exports) {
    $parcel$export(module.exports, "useConnectApps", ()=>$5ce3bcf534d9d0ea$export$4864478dcab77643);
    var $5uXOq = parcelRequire("5uXOq");
    var $loy04;
    var $efOLn;
    var $9MFH3;
    const $5ce3bcf534d9d0ea$export$4864478dcab77643 = ()=>{
        const { data: connectResourceItems, error: error, loading: loading } = (0, (0, parcelRequire("loy04")).useProjectSettingsSidebarConnectAddonsNavigationResource)();
        const connectApps = (0, $5uXOq.useMemo)(()=>{
            if (connectResourceItems == null) return [];
            const transformedConnectApps = [];
            for (const item of connectResourceItems){
                const transformedItem = (0, (0, parcelRequire("efOLn")).transformLinkV4)(item);
                if (transformedItem && !(0, (0, parcelRequire("9MFH3")).LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
            }
            return transformedConnectApps;
        }, [
            connectResourceItems
        ]);
        return {
            data: connectApps,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("9MFH3", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", ()=>$b25e3cd9691dd3ed$export$911a3d81a5d162b6);
    const $b25e3cd9691dd3ed$export$911a3d81a5d162b6 = new Set([
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ]);
});
parcelRegister("kqEpF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2c80e831fc4dee6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $hPtZI;
    const $c2c80e831fc4dee6$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("lLMvP")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
    });
    const $c2c80e831fc4dee6$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.jpd-settings",
            packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.jpd-settings",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c2c80e831fc4dee6$var$LazySidebarContent, {
            project: project
        })));
    var $c2c80e831fc4dee6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c2c80e831fc4dee6$var$AsyncSidebar);
});
parcelRegister("lLMvP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9Dnuj")
    ]).then(()=>parcelRequire('aDwWR'));
});
parcelRegister("1G9rm", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", ()=>$5b1e7bac8593a90d$export$2ce6ad449436c545);
    var $5uXOq = parcelRequire("5uXOq");
    var $juTur;
    var $cljJ9;
    var $7VBev;
    var $84dyl;
    var $lfTZh;
    var $hPtZI;
    const $5b1e7bac8593a90d$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4CeCe")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
    });
    const $5b1e7bac8593a90d$var$analyticsAttributes = {
        projectStyle: 'cmp',
        navVersion: undefined
    };
    const $5b1e7bac8593a90d$export$2ce6ad449436c545 = (0, $5uXOq.memo)(({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-cmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("84dyl")).MENU_ID_JSM_SETTINGS),
            attributes: $5b1e7bac8593a90d$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5b1e7bac8593a90d$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("juTur", function(module, exports) {
    $parcel$export(module.exports, "ContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$198470770171c65);
    $parcel$export(module.exports, "IssuesContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$bc7f6eebc16e6127);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $iXVV6;
    var $lpwtK;
    var $3d1up;
    const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                navVersion: '3',
                viewId: (0, (0, parcelRequire("3d1up")).generateViewId)(menuId, ...stack),
                navigationLayer: 'container',
                ...attributes
            }
        });
    const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, (0, parcelRequire("lpwtK")).useProject), ...rest })=>{
        const { data: project } = useProject();
        const projectConfig = (project?.isSimplified ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC) || undefined;
        const projectType = project?.type || undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                ...attributes,
                projectConfig: projectConfig,
                projectType: projectType,
                navigatorScope: navigatorScope
            }
        });
    };
});
parcelRegister("3d1up", function(module, exports) {
    $parcel$export(module.exports, "generateViewId", ()=>$2f6f53381b1f04e0$export$5b5545ed894dc47a);
    const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');
});
parcelRegister("84dyl", function(module, exports) {
    $parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", ()=>$8fdaf51231934b8c$export$4c5fa21d31710030);
    $parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", ()=>$8fdaf51231934b8c$export$8092325c2fa271de);
    const $8fdaf51231934b8c$export$4c5fa21d31710030 = 'project/service-desk/settings';
    const $8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES = {
        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        level: 1
    };
    const $8fdaf51231934b8c$export$8092325c2fa271de = {
        ...$8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES,
        actionSubjectId: (0, $d59b407ab907bf7b$export$13171e509c859bbf)
    };
});
const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';
parcelRegister("4CeCe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("k1zH8")
    ]).then(()=>parcelRequire('58Da3'));
});
parcelRegister("drQWa", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", ()=>$723c8db5701ca405$export$dadf0f8c840cb26d);
    var $5uXOq = parcelRequire("5uXOq");
    var $juTur;
    var $cljJ9;
    var $7VBev;
    var $84dyl;
    var $lfTZh;
    var $hPtZI;
    const $723c8db5701ca405$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("fHZDR")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
    });
    const $723c8db5701ca405$var$analyticsAttributes = {
        projectStyle: 'tmp',
        navVersion: undefined
    };
    const $723c8db5701ca405$export$dadf0f8c840cb26d = (0, $5uXOq.memo)(({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.jsm-tmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("84dyl")).MENU_ID_JSM_SETTINGS),
            attributes: $723c8db5701ca405$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($723c8db5701ca405$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("fHZDR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ALx4")
    ]).then(()=>parcelRequire('dJT47'));
});
parcelRegister("2DtJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd62495e40b7984d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $hPtZI;
    const $fd62495e40b7984d$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("218yI")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
    });
    const $fd62495e40b7984d$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.software.company-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fd62495e40b7984d$var$LazySidebarContent, {
            project: project
        })));
    var $fd62495e40b7984d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($fd62495e40b7984d$var$AsyncSidebar);
});
parcelRegister("218yI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iNMXx")
    ]).then(()=>parcelRequire('cLlaG'));
});
parcelRegister("cnyf1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$713dabe47adbee45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cljJ9;
    var $7VBev;
    var $lfTZh;
    var $hPtZI;
    const $713dabe47adbee45$var$LazySidebarContent = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("h8vhS")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
    });
    const $713dabe47adbee45$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cljJ9")).SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav4.sidebar.project-settings.software.team-managed",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VBev")).Skeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($713dabe47adbee45$var$LazySidebarContent, {
            project: project
        })));
    var $713dabe47adbee45$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($713dabe47adbee45$var$AsyncSidebar);
});
parcelRegister("h8vhS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cxRoY")
    ]).then(()=>parcelRequire('4yoHz'));
});
parcelRegister("4DrQd", function(module, exports) {
    $parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", ()=>$e2413e530566d4f6$export$47f3715a07cde7e8);
    $parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", ()=>$e2413e530566d4f6$export$f5a7bd7eb586e4e8);
    $parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", ()=>$e2413e530566d4f6$export$6a976dc7193b8a18);
    $parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", ()=>$e2413e530566d4f6$export$9fcc53f3b36e0949);
    $parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", ()=>$e2413e530566d4f6$export$2eb8dda9e83d33ff);
    $parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", ()=>$e2413e530566d4f6$export$9cf873ba2e9a3ce0);
    $parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", ()=>$e2413e530566d4f6$export$a495ba70b16d4d90);
    $parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", ()=>$e2413e530566d4f6$export$89de709e88232646);
    var $3odnd;
    var $5sz0N;
    var $fwt53;
    var $55Gpo;
    var $ksmPu;
    var $iGVTS;
    var $oNPTN;
    var $94o37;
    var $c3VY0;
    var $2g5Dt;
    var $17g9K;
    var $2PONs;
    var $2nE7Z;
    var $jhS4y;
    var $6x874;
    var $ih7ba;
    var $46Cti;
    const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
    const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
    const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
    const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID));
    const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
    const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).APPS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).apps,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("5sz0N")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).GOALS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).goals,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("94o37")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ROADMAPS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).roadmaps,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("3odnd")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).PLANS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).plans,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("17g9K")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).PROJECTS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).projects,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2g5Dt")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).FILTERS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).filters,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("iGVTS")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).DASHBOARDS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).dashboards,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("ksmPu")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).OVERVIEWS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).overviews,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("oNPTN")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).OPERATIONS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).operations,
            Icon: (0, (0, parcelRequire("6x874")).default)
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).ASSETS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).assets,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("fwt53")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).TEAMS]: {
            message: (0, (0, parcelRequire("ih7ba")).default).teams,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2nE7Z")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).RECENT]: {
            message: (0, (0, parcelRequire("ih7ba")).default).recent,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("55Gpo")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).STARRED]: {
            message: (0, (0, parcelRequire("ih7ba")).default).starred,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2PONs")))))
        },
        [(0, (0, parcelRequire("46Cti")).L1_MENU_ID).CUSTOMER_SERVICE]: {
            message: (0, (0, parcelRequire("ih7ba")).default).customerService,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("c3VY0")))))
        }
    };
    const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240;
    const $e2413e530566d4f6$export$6621cd553335536a = 320;
    const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
    const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
    const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
    const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
    const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
    const $e2413e530566d4f6$export$89de709e88232646 = 25;
});
parcelRegister("3odnd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $277dfcace1e1e492$var$_react = $277dfcace1e1e492$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $277dfcace1e1e492$var$_UNSAFE_baseNew = $277dfcace1e1e492$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $277dfcace1e1e492$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $277dfcace1e1e492$var$RoadmapsPlanIcon = (props)=>$277dfcace1e1e492$var$_react.default.createElement($277dfcace1e1e492$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.25 3.5h5.5a2.25 2.25 0 0 1 0 4.5h-5.5a2.25 2.25 0 0 0 0 4.5h5.5m-5.5-9a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm5.5 9a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z"/>`
        }, props));
    $277dfcace1e1e492$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
    var $277dfcace1e1e492$var$_default = module.exports.default = $277dfcace1e1e492$var$RoadmapsPlanIcon;
});
parcelRegister("fwt53", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b4d066f8c1712a1a$var$_react = $b4d066f8c1712a1a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b4d066f8c1712a1a$var$_UNSAFE_baseNew = $b4d066f8c1712a1a$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $b4d066f8c1712a1a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b4d066f8c1712a1a$var$AssetsIcon = (props)=>$b4d066f8c1712a1a$var$_react.default.createElement($b4d066f8c1712a1a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.59 6.409a2.25 2.25 0 0 1 0 3.182m0-3.182a2.25 2.25 0 0 0-3.181 0m3.182 0 2.598-2.598M9.591 9.59a2.25 2.25 0 0 1-3.182 0m3.182 0 2.598 2.598M6.41 9.591a2.25 2.25 0 0 1 0-3.182m0 3.182-2.6 2.598m2.598-5.78L3.81 3.811m8.378 0a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122Zm0 8.378a1.5 1.5 0 1 0 2.122 2.122 1.5 1.5 0 0 0-2.122-2.122ZM3.811 3.811a1.5 1.5 0 1 0-2.122-2.122 1.5 1.5 0 0 0 2.122 2.122Zm0 8.378a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122Z"/>`
        }, props));
    $b4d066f8c1712a1a$var$AssetsIcon.displayName = 'AssetsIcon';
    var $b4d066f8c1712a1a$var$_default = module.exports.default = $b4d066f8c1712a1a$var$AssetsIcon;
});
parcelRegister("oNPTN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $04a8e669bf87bdba$var$_react = $04a8e669bf87bdba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $04a8e669bf87bdba$var$_UNSAFE_baseNew = $04a8e669bf87bdba$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $04a8e669bf87bdba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $04a8e669bf87bdba$var$GlobeIcon = (props)=>$04a8e669bf87bdba$var$_react.default.createElement($04a8e669bf87bdba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
        }, props));
    $04a8e669bf87bdba$var$GlobeIcon.displayName = 'GlobeIcon';
    var $04a8e669bf87bdba$var$_default = module.exports.default = $04a8e669bf87bdba$var$GlobeIcon;
});
parcelRegister("94o37", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $69a7247b5ca42b11$var$_react = $69a7247b5ca42b11$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $69a7247b5ca42b11$var$_UNSAFE_baseNew = $69a7247b5ca42b11$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $69a7247b5ca42b11$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $69a7247b5ca42b11$var$GoalIcon = (props)=>$69a7247b5ca42b11$var$_react.default.createElement($69a7247b5ca42b11$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
        }, props));
    $69a7247b5ca42b11$var$GoalIcon.displayName = 'GoalIcon';
    var $69a7247b5ca42b11$var$_default = module.exports.default = $69a7247b5ca42b11$var$GoalIcon;
});
parcelRegister("c3VY0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c82bad57650daa4$var$_react = $8c82bad57650daa4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c82bad57650daa4$var$_UNSAFE_baseNew = $8c82bad57650daa4$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $8c82bad57650daa4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c82bad57650daa4$var$MarketplaceIcon = (props)=>$8c82bad57650daa4$var$_react.default.createElement($8c82bad57650daa4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.167 1.75H2.5L1.25 5.5m4.917-3.75h3.666m-3.666 0-.5 4.5m4.166-4.5H13.5l1.251 3.75M9.833 1.75l.5 4.5m0 0a2.334 2.334 0 0 1-4.667 0m4.668 0a2.334 2.334 0 0 0 2.916 2.26M5.666 6.25A2.334 2.334 0 0 1 2.75 8.51m10.5 0a2.335 2.335 0 0 0 1.751-2.26l-.25-.75M13.25 8.51V13c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V8.51m0 0A2.335 2.335 0 0 1 1 6.25l.25-.75m0 0h13.5"/>`
        }, props));
    $8c82bad57650daa4$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
    var $8c82bad57650daa4$var$_default = module.exports.default = $8c82bad57650daa4$var$MarketplaceIcon;
});
parcelRegister("17g9K", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0d02fa34b4772bda$var$_react = $0d02fa34b4772bda$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0d02fa34b4772bda$var$_UNSAFE_baseNew = $0d02fa34b4772bda$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $0d02fa34b4772bda$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0d02fa34b4772bda$var$RoadmapIcon = (props)=>$0d02fa34b4772bda$var$_react.default.createElement($0d02fa34b4772bda$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
        }, props));
    $0d02fa34b4772bda$var$RoadmapIcon.displayName = 'RoadmapIcon';
    var $0d02fa34b4772bda$var$_default = module.exports.default = $0d02fa34b4772bda$var$RoadmapIcon;
});
parcelRegister("6x874", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$079d8146cc6d581f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $evETN;
    var $9DrYg;
    var $4R6GH;
    const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('nav4_operations_icon_update')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("evETN"))))), props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9DrYg"))))), props);
    };
    var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;
});
parcelRegister("evETN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a903af9f448a8eec$var$_react = $a903af9f448a8eec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a903af9f448a8eec$var$_UNSAFE_baseNew = $a903af9f448a8eec$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $a903af9f448a8eec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a903af9f448a8eec$var$OperationsIcon = (props)=>$a903af9f448a8eec$var$_react.default.createElement($a903af9f448a8eec$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.652 5.348A3.75 3.75 0 1 0 8 11.75m-.25-3.5 5.377-5.377A7.25 7.25 0 1 0 8 15.25"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 1 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 1 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
        }, props));
    $a903af9f448a8eec$var$OperationsIcon.displayName = 'OperationsIcon';
    var $a903af9f448a8eec$var$_default = module.exports.default = $a903af9f448a8eec$var$OperationsIcon;
});
parcelRegister("9DrYg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $703d740cff6a3e12$var$_react = $703d740cff6a3e12$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $703d740cff6a3e12$var$_UNSAFE_baseNew = $703d740cff6a3e12$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $703d740cff6a3e12$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $703d740cff6a3e12$var$ShieldIcon = (props)=>$703d740cff6a3e12$var$_react.default.createElement($703d740cff6a3e12$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 4.5S10.75 3.5 8 .75C5.25 3.5 1.75 4.5 1.75 4.5 1.75 12.75 8 15.125 8 15.125S14.25 12.75 14.25 4.5Z"/>`
        }, props));
    $703d740cff6a3e12$var$ShieldIcon.displayName = 'ShieldIcon';
    var $703d740cff6a3e12$var$_default = module.exports.default = $703d740cff6a3e12$var$ShieldIcon;
});
parcelRegister("ih7ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c16ecaa1449e546$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projects: {
            "id": "navigation-apps-sidebar-nav4-common.common.projects",
            "defaultMessage": "Projects"
        },
        filters: {
            "id": "navigation-apps-sidebar-nav4-common.common.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
            "defaultMessage": "Dashboards"
        },
        overviews: {
            "id": "navigation-apps-sidebar-nav4-common.common.overviews",
            "defaultMessage": "Overviews"
        },
        teams: {
            "id": "navigation-apps-sidebar-nav4-common.common.teams",
            "defaultMessage": "Teams"
        },
        assets: {
            "id": "navigation-apps-sidebar-nav4-common.common.assets",
            "defaultMessage": "Assets"
        },
        plans: {
            "id": "navigation-apps-sidebar-nav4-common.common.plans",
            "defaultMessage": "Plans"
        },
        apps: {
            "id": "navigation-apps-sidebar-nav4-common.common.apps",
            "defaultMessage": "Apps"
        },
        operations: {
            "id": "navigation-apps-sidebar-nav4-common.common.operations",
            "defaultMessage": "Operations"
        },
        goals: {
            "id": "navigation-apps-sidebar-nav4-common.common.goals",
            "defaultMessage": "Goals"
        },
        recent: {
            "id": "navigation-apps-sidebar-nav4-common.common.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-common.common.starred",
            "defaultMessage": "Starred"
        },
        roadmaps: {
            "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
            "defaultMessage": "Roadmaps"
        },
        customerService: {
            "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
            "defaultMessage": "Customer service"
        }
    });
});
parcelRegister("46Cti", function(module, exports) {
    $parcel$export(module.exports, "L1_MENU_ID", ()=>$2d5b83df0b5ff159$export$918aea3cf024d90b);
    var $jhS4y;
    const $2d5b83df0b5ff159$export$f263c05bb04cefc9 = {
        OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
        OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
    };
    const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
        ...(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID),
        BOARDS: 'jira.sidebar.boards',
        QUEUES: 'jira.sidebar.queues',
        ALL: 'jira.sidebar.all'
    };
    const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
        YOUR_WORK: 'jira.sidebar.yourWork',
        ...(0, (0, parcelRequire("jhS4y")).CONFIGURABLE_MENU_ID),
        ...$2d5b83df0b5ff159$export$f263c05bb04cefc9
    };
});
parcelRegister("eGkew", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelectorProvider", ()=>$8451f19a8196b45e$export$6af584355cfb32c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $2vSU6;
    var $lpwtK;
    var $lGo7j;
    var $cin8p;
    var $awp39;
    var $b69Lc;
    var $dlYil;
    var $jjzbO;
    var $hWtQt;
    var $jfqNX;
    var $gZbSF;
    var $dmKXV;
    var $iFaFr;
    var $4IWRY;
    var $hBv66;
    var $iHiHz;
    var $cOg46;
    var $7AyKX;
    var $koWFd;
    var $937TY;
    var $lgSL3;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    var $hz6Yb;
    var $2YP9W;
    const $8451f19a8196b45e$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
            isFull: true
        });
        if (!project) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2IHt2")).default), null);
        switch(project.type){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0bZU")).default), null);
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lgSL3")).default), null);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (project.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koWFd")).default), null);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9s3j1")).default), null);
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dmKXV")).default), null);
            default:
                return null;
        }
    };
    const $8451f19a8196b45e$var$ProjectSidebar = (0, $5uXOq.memo)($8451f19a8196b45e$var$renderProjectSidebar, (0, ($parcel$interopDefault($ajpes))));
    const $8451f19a8196b45e$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
        const projectState = (0, (0, parcelRequire("lpwtK")).useProject)();
        const isInsightMenuSelected = (0, (0, parcelRequire("jjzbO")).useInsight)();
        const shouldRenderInsightObjectSchemaSidebar = (0, (0, parcelRequire("jjzbO")).useInsightObjectSchemaSidebar)();
        const { selected: pSelected, loading: pLoading } = (0, (0, parcelRequire("gZbSF")).useProjectConnectItems)();
        const { selected: prSelected, loading: prLoading } = (0, (0, parcelRequire("hWtQt")).useProjectReportsConnectItems)();
        const { selected: psSelected, loading: psLoading } = (0, (0, parcelRequire("jfqNX")).useProjectSettingsConnectItems)();
        const { selected: gSelected, loading: gLoading } = (0, (0, parcelRequire("dlYil")).useGlobalConnectItems)();
        const { selected: gsSelected, loading: gsLoading } = (0, (0, parcelRequire("b69Lc")).useGlobalSettingsConnectItems)();
        const { selected: gssSelected, loading: gssLoading } = (0, (0, parcelRequire("awp39")).useGlobalSettingsSystemConnectItems)();
        const { data: gresData, loading: gresLoading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("hz6Yb")).connectGeneralResources));
        const { sections: fgSections, loading: fgLoading } = (0, (0, parcelRequire("4IWRY")).useForgeGlobalPageItems)();
        if (shouldRenderInsightObjectSchemaSidebar) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7AyKX")).default), null));
        if (isInsightMenuSelected) return null;
        if (sidebar === (0, (0, parcelRequire("937TY")).default)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("937TY")).default), null));
        if (sidebar === (0, (0, parcelRequire("iFaFr")).default)) {
            if (fgLoading) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            }));
            if (fgSections?.length) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFaFr")).default), null));
            return children(null);
        }
        if (!Array.isArray(sidebar)) {
            const Sidebar = sidebar;
            return children(Sidebar != null ? (0, ($parcel$interopDefault($5uXOq))).createElement(Sidebar, null) : null);
        }
        if (sidebar === (0, (0, parcelRequire("hBv66")).genericConnectSidebars)) {
            const foundInProject = pSelected || prSelected || psSelected || [
                'jiraProjectAdminTabPanels'
            ].includes(gresData?.moduleType);
            const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
            const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
            if (stillLoading && !foundSomewhere) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            }));
            if (foundInProject) {
                const projectSidebar = (0, ($parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
                return children(projectSidebar);
            }
            if (gSelected) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cin8p")).default), null));
            if (gsSelected || [
                'configurePage',
                'postInstallPage'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHiHz")).default), null));
            if (gssSelected || [
                'adminPages'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOg46")).default), null));
            return children(null);
        }
        const projectSidebar = (0, ($parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
        return children(projectSidebar);
    };
});
parcelRegister("awp39", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$6ac80db07eab2a1e$export$f601efaceb0636f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $doZTA;
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $6ac80db07eab2a1e$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter(Boolean));
    const $6ac80db07eab2a1e$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $6ac80db07eab2a1e$export$f601efaceb0636f4 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $6ac80db07eab2a1e$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $6ac80db07eab2a1e$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("aUDLa", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$dbad5a19b82e4911$export$1e1c317ed5b99faa);
    var $5uXOq = parcelRequire("5uXOq");
    var $atU1t;
    var $2YP9W;
    const $dbad5a19b82e4911$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource));
        const response = (0, $5uXOq.useMemo)(()=>data && data.response, [
            data
        ]);
        return {
            data: response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("7tsV0", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$93fa8c16baad19b1$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
            const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("4gymV", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$6dc7ee8ba2a1371f$export$8054dcb2b42da45c);
    var $83mn0;
    var $7NH5Y;
    const $6dc7ee8ba2a1371f$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = (0, (0, parcelRequire("83mn0")).getLinksFromSidebar)(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, (0, parcelRequire("7NH5Y")).connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, (0, parcelRequire("7NH5Y")).connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, (0, parcelRequire("7NH5Y")).jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("83mn0", function(module, exports) {
    $parcel$export(module.exports, "hasItemInSidebar", ()=>$90215f5482fce08d$export$57dd40eec4c64521);
    $parcel$export(module.exports, "getLinksFromSidebar", ()=>$90215f5482fce08d$export$9b7e0e4dd8bfade8);
    const $90215f5482fce08d$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
        if (!Array.isArray(arrayOfLinks)) return undefined;
        for(let i = 0; i < arrayOfLinks.length; i += 1){
            const link = arrayOfLinks[i];
            if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
            if (link.id === legacyId) return link;
            if (link.links) {
                const linkFound = $90215f5482fce08d$var$findLink(link.links, legacyId, partialMatch);
                if (linkFound) return linkFound;
            }
        }
        return undefined;
    };
    const $90215f5482fce08d$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $90215f5482fce08d$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
    const $90215f5482fce08d$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($90215f5482fce08d$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
    const $90215f5482fce08d$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $90215f5482fce08d$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $90215f5482fce08d$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $90215f5482fce08d$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
});
parcelRegister("7NH5Y", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$a36a125359bfc961$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$a36a125359bfc961$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$a36a125359bfc961$export$b1c2c1fc5d10280);
    var $kvHKs;
    const $a36a125359bfc961$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $a36a125359bfc961$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $a36a125359bfc961$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $a36a125359bfc961$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $a36a125359bfc961$export$b1c2c1fc5d10280 = [
        $a36a125359bfc961$var$legacyAddonPanelLinkId,
        (0, (0, parcelRequire("kvHKs")).REPORTS_IDS).REPORTS_ADDONS,
        $a36a125359bfc961$var$jsdQueuesConnectSection
    ];
});
parcelRegister("5W6pd", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$1efacbf40a7b73c8$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$1efacbf40a7b73c8$export$27267b6b6650eaa5);
    const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("b69Lc", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$ba4edc5b901e34a6$export$f0785b98c99d344c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $doZTA;
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $ba4edc5b901e34a6$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter(Boolean));
    const $ba4edc5b901e34a6$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $ba4edc5b901e34a6$export$f0785b98c99d344c = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const items = (0, $5uXOq.useMemo)(()=>data && $ba4edc5b901e34a6$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $ba4edc5b901e34a6$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("dlYil", function(module, exports) {
    $parcel$export(module.exports, "useGlobalConnectItems", ()=>$17cad8174f7acae6$export$ee355b2e42d6462b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $aUDLa;
    var $doZTA;
    var $7tsV0;
    var $4gymV;
    var $5W6pd;
    const $17cad8174f7acae6$var$getItemsMemo = (0, (0, parcelRequire("8QpSo")).default)((d)=>(0, (0, parcelRequire("4gymV")).getLinks)(d, [
            'global-navigation-product'
        ]).map((0, (0, parcelRequire("5W6pd")).transformLink)).filter((item)=>item != null && item.items));
    const $17cad8174f7acae6$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $17cad8174f7acae6$export$ee355b2e42d6462b = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const sidebars = (0, $5uXOq.useMemo)(()=>data && $17cad8174f7acae6$var$getItemsMemo(data), [
            data
        ]);
        const searchResult = (0, $5uXOq.useMemo)(()=>{
            let result = {
                stack: [],
                selected: null,
                title: null,
                data: null
            };
            if (sidebars != null) sidebars.some((sidebar)=>{
                const { items: items } = sidebar || {};
                if (!sidebar || !route || items == null) return false;
                const found = $17cad8174f7acae6$var$findItemAndStackMemo(items, route.name, location);
                if (found) {
                    result = {
                        ...found,
                        title: sidebar.name,
                        data: items
                    };
                    return true;
                }
                return false;
            });
            return result;
        }, [
            sidebars,
            route,
            location
        ]);
        return {
            ...searchResult,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jjzbO", function(module, exports) {
    $parcel$export(module.exports, "useInsight", ()=>$25e0b1dc21125803$export$e24dad0705701755);
    $parcel$export(module.exports, "useInsightObjectSchemaSidebar", ()=>$25e0b1dc21125803$export$1f0bd21403710fc);
    var $3HwlS;
    var $6jY6G;
    const $25e0b1dc21125803$export$e24dad0705701755 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if (route.navigation) return route.navigation.menuId === 'INSIGHT';
        return false;
    };
    const $25e0b1dc21125803$export$1f0bd21403710fc = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return false;
        return route.name === 'servicedesk-cmdb-object-schema';
    };
});
parcelRegister("hWtQt", function(module, exports) {
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$a740427f233367ba$export$a1c75c386c088992);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $doZTA;
    var $7tsV0;
    var $5W6pd;
    const $a740427f233367ba$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectReportsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean) : [], [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
                'reports'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            error: error,
            loading: loading,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("jfqNX", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$662340ab1e9d2787$export$41a50100db18b578);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $doZTA;
    var $7tsV0;
    var $5W6pd;
    const $662340ab1e9d2787$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSettingsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
                'settings'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("gZbSF", function(module, exports) {
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fcf7bc53994ae8f3$export$f23d0c24c77d7608);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $doZTA;
    var $7tsV0;
    var $5W6pd;
    const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
        const [{ route: route, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("iFaFr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b86720f4c83cfbb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("l65XP")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
    });
    const $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "forgeGlobalPage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar, null)));
    $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
    var $b86720f4c83cfbb5$export$2e2bcd8739ae039 = $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar;
});
parcelRegister("l65XP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6eoVI")
    ]).then(()=>parcelRequire('4opkK'));
});
parcelRegister("4IWRY", function(module, exports) {
    $parcel$export(module.exports, "useForgeGlobalPageItems", ()=>$e660bc01a5db5a53$export$ff333fd2f0bf5254);
    var $5uXOq = parcelRequire("5uXOq");
    var $4NrfJ;
    var $7Tlti;
    var $c70gQ;
    var $doZTA;
    const $e660bc01a5db5a53$export$ff333fd2f0bf5254 = ()=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: modules, loading: loading, error: error } = (0, (0, parcelRequire("4NrfJ")).useGlobalForgeApps)();
        const extension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        const sections = (0, $5uXOq.useMemo)(()=>extension && (0, (0, parcelRequire("7Tlti")).toSections)(extension), [
            extension
        ]);
        return {
            extension: extension,
            sections: sections,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("4NrfJ", function(module, exports) {
    $parcel$export(module.exports, "getItemHref", ()=>$7a76aaaa3a23f02a$export$ed6342e0e28465a6);
    $parcel$export(module.exports, "useGlobalForgeApps", ()=>$7a76aaaa3a23f02a$export$f834c14187f80532);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $e0AC8;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $2YP9W;
    const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/apps/${appId}/${envId}`;
    };
    const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeGlobalModuleV1Resource));
        const globalPageData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: globalPageData ? globalPageData.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, {})) : null,
                loading: loading,
                error: error
            }), [
            globalPageData,
            loading,
            error
        ]);
    };
    const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5bkvv")).forgeGlobalModuleV2Resource));
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, {}, 'global-forge-apps-hook');
        return (0, $5uXOq.useMemo)(()=>({
                data: data ? data.filter((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) : null,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $7a76aaaa3a23f02a$export$f834c14187f80532 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2, $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1);
});
parcelRegister("awp3q", function(module, exports) {
    $parcel$export(module.exports, "useDoesExtensionMeetConditions", ()=>$bd52741229b769de$export$642911220fb6609f);
    $parcel$export(module.exports, "doesExtensionMeetConditions", ()=>$bd52741229b769de$export$b1e4ed7044e85aa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQVg = parcelRequire("kvQVg");
    var $4Pf62;
    var $daoB1;
    var $9OXo1;
    const $bd52741229b769de$export$642911220fb6609f = ()=>{
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return (0, $5uXOq.useCallback)((extension, extraContext)=>{
            const { displayConditions: displayConditions } = extension.properties;
            if (displayConditions == null) return true;
            const context = {
                ...extraContext,
                isAdmin: isAdmin,
                isLoggedIn: !isAnonymous,
                isSiteAdmin: isSiteAdmin,
                hasCoreAccess: hasCoreAccess,
                hasServiceManagementAccess: hasServiceManagementAccess,
                hasSoftwareAccess: hasSoftwareAccess
            };
            return (0, $kvQVg.doesMeetConditions)(displayConditions, context);
        }, [
            hasCoreAccess,
            hasServiceManagementAccess,
            hasSoftwareAccess,
            isAdmin,
            isAnonymous,
            isSiteAdmin
        ]);
    };
    const $bd52741229b769de$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const context = {
            ...extraContext,
            isAdmin: isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasSoftwareAccess: hasSoftwareAccess,
            hasServiceManagementAccess: hasServiceDeskAccess,
            hasCoreAccess: hasCoreAccess
        };
        return displayConditions ? (0, $kvQVg.doesMeetConditions)(displayConditions, context) : true;
    };
});
parcelRegister("dvdr4", function(module, exports) {
    $parcel$export(module.exports, "useDisplayConditionsConsistencyCheck", ()=>$79a96011350576c4$export$cd62caf01a15f56b);
    $parcel$export(module.exports, "checkDisplayConditionsConsistency", ()=>$79a96011350576c4$export$4169695e1a68bda7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $dJl1T;
    var $4R6GH;
    var $awp3q;
    var $5cmSg;
    const $79a96011350576c4$export$cd62caf01a15f56b = (data, context = {}, consumer)=>{
        const memoizedContext = $79a96011350576c4$var$useMemoizedStateObject(context);
        const memoizedData = $79a96011350576c4$var$useMemoizedStateObject(data);
        (0, $5uXOq.useEffect)(()=>{
            $79a96011350576c4$export$4169695e1a68bda7(memoizedData, memoizedContext, consumer);
        }, [
            memoizedContext,
            memoizedData,
            consumer
        ]);
    };
    const $79a96011350576c4$export$4169695e1a68bda7 = (data, context = {}, consumer)=>{
        if (data == null) return;
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            if ('extensions' in data) {
                (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called with a data from the old query', {
                    consumer: consumer
                });
                return;
            }
        } else {
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called while the FG is being turned off', {
                consumer: consumer
            });
            return;
        }
        const falsePositives = new Set();
        const falseNegatives = new Set();
        data.forEach((extension)=>{
            const perClient = (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context);
            const perServer = !(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByDisplayConditions)(extension);
            if (perClient !== perServer) {
                if (perServer) falsePositives.add(extension);
                else falseNegatives.add(extension);
            }
        });
        if (falsePositives.size || falseNegatives.size) (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'Display conditions evaluation is not consistent', {
            consumer: consumer,
            context: JSON.stringify(context),
            falsePositives_count: falsePositives.size,
            falsePositives_data: falsePositives.size ? JSON.stringify(Array.from(falsePositives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null,
            falseNegatives_count: falseNegatives.size,
            falseNegatives_data: falseNegatives.size ? JSON.stringify(Array.from(falseNegatives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null
        });
    };
    const $79a96011350576c4$var$useMemoizedStateObject = (data, equalityCheck = (0, ($parcel$interopDefault($ajpes))))=>{
        const memoizedData = (0, $5uXOq.useRef)(data);
        return (0, $5uXOq.useMemo)(()=>{
            if (!equalityCheck(data, memoizedData.current)) {
                memoizedData.current = data;
                return data;
            }
            return memoizedData.current;
        }, [
            data,
            equalityCheck
        ]);
    };
});
parcelRegister("7Tlti", function(module, exports) {
    $parcel$export(module.exports, "toSections", ()=>$25b31557e9750c03$export$29678d1e04c0e8c4);
    var $8QpSo;
    const $25b31557e9750c03$var$normalizeSection = (section)=>({
            header: section?.header,
            pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                    icon: page?.icon,
                    route: page?.route,
                    title: page?.title
                })) : []
        });
    const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, (0, parcelRequire("8QpSo")).default)((extension)=>{
        const { properties: properties } = extension;
        if (typeof properties.resource !== 'string') return [];
        if (typeof properties.pages !== 'undefined' && properties.pages?.length) return [
            {
                pages: properties.pages
            }
        ].map($25b31557e9750c03$var$normalizeSection);
        if (typeof properties.sections !== 'undefined' && properties.sections?.length) return properties.sections.map($25b31557e9750c03$var$normalizeSection);
        return [];
    });
});
parcelRegister("c70gQ", function(module, exports) {
    $parcel$export(module.exports, "useMatchedExtension", ()=>$b661f1f04cec9385$export$13375c0abccaf6f6);
    $parcel$export(module.exports, "useExtensionBasePath", ()=>$b661f1f04cec9385$export$25abed85383f0fbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0AC8;
    const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
                const parsedExtensionId = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(app.id);
                return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
            }), [
            modules,
            match.params.appId,
            match.params.envId
        ]);
    const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');
});
parcelRegister("7AyKX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cf06d255b5e49f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("UPwyz")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
    });
    const $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "insight-object-schema-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar, null)));
    $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
    var $6cf06d255b5e49f4$export$2e2bcd8739ae039 = $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar;
});
parcelRegister("UPwyz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("a8Tkc")
    ]).then(()=>parcelRequire('48ZOK'));
});
parcelRegister("937TY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$375ae1bde651f684$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $375ae1bde651f684$var$LazyPlanSidebar = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("9Kv1r")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
    });
    const $375ae1bde651f684$var$PlanSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "Plan"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($375ae1bde651f684$var$LazyPlanSidebar, null)));
    $375ae1bde651f684$var$PlanSidebar.displayName = 'PlanSidebar';
    var $375ae1bde651f684$export$2e2bcd8739ae039 = $375ae1bde651f684$var$PlanSidebar;
});
parcelRegister("9Kv1r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fRQHe")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("exGqx")
    ]).then(()=>parcelRequire('5q8CD'));
});
parcelRegister("lgSL3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$756fa7b51ff3cfd4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("9vvGA")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
    });
    const $756fa7b51ff3cfd4$var$PolarisProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "polarisProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar, null)));
    $756fa7b51ff3cfd4$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
    var $756fa7b51ff3cfd4$export$2e2bcd8739ae039 = $756fa7b51ff3cfd4$var$PolarisProjectSidebar;
});
parcelRegister("9vvGA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("blsmD")
    ]).then(()=>parcelRequire('aSh9m'));
});
parcelRegister("ht71P", function(module, exports) {
    $parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", ()=>$7676eec527946b59$export$30d9dff000fbaa2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $hPtZI;
    const $7676eec527946b59$var$NudgeBundledUsersFlagContainer = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("esy1S")).then((module)=>module.NudgeBundledUsersXflow), {
        ssr: false,
        moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
    });
    const $7676eec527946b59$export$30d9dff000fbaa2d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "nudgeBundledUserFlag",
            packageName: "nudgeBundledUsersToJoinConnie",
            fallback: "unmount",
            teamName: "confluenceOnboarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nudge-bundled-users-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7676eec527946b59$var$NudgeBundledUsersFlagContainer, null)));
});
parcelRegister("esy1S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ev3ZS").then(()=>parcelRequire('6vucW'));
});
parcelRegister("4V52L", function(module, exports) {
    $parcel$export(module.exports, "SidebarFeedbackButton", ()=>$ea1c2dd9a94de02f$export$b270ed097d20c023);
    var $5uXOq = parcelRequire("5uXOq");
    var $dHJL9;
    var $e0OK7;
    var $b4U16;
    var $29ctK;
    var $MGmIU;
    var $4R6GH;
    var $7iULw;
    var $dseDh;
    var $ousew;
    var $koVbs;
    var $j5Q6Z;
    var $dkkQn;
    var $4DrQd;
    var $bw7Gm;
    var $koeKL;
    var $2tT7R;
    var $83YFz;
    function $ea1c2dd9a94de02f$export$b270ed097d20c023() {
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const onClickHandler = (0, $5uXOq.useCallback)(()=>{
            const showFeedbackTitleDetailsWithLink = (0, (0, parcelRequire("j5Q6Z")).getWillShowNav4UserOptIn)() || (0, (0, parcelRequire("dkkQn")).getWillShowNav4UserOptOut)();
            const formattedMessageNode = showFeedbackTitleDetailsWithLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("83YFz")).default).feedbackTitleDetailsWithLink,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29ctK")).default), {
                            href: "/jira/settings/personal/general",
                            onClick: closeFeedbackCollector
                        }, chunks)
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("83YFz")).default).feedbackTitleDetailsNoLink);
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_NAVIGATION_REFRESH),
                feedbackContext: [
                    {
                        id: 'environment',
                        value: environment
                    },
                    {
                        id: 'cloud-id',
                        value: cloudId
                    },
                    {
                        id: 'location',
                        value: (0, (0, parcelRequire("bw7Gm")).default)(window?.location?.href ?? '')
                    }
                ],
                feedbackGroupId: (0, (0, parcelRequire("4DrQd")).NAV4_GENERAL_FEEDBACK_GROUP_ID),
                feedbackTitle: formatMessage((0, (0, parcelRequire("83YFz")).default).feedbackTitle),
                feedbackTitleDetails: formattedMessageNode
            });
        }, [
            closeFeedbackCollector,
            cloudId,
            environment,
            formatMessage,
            openFeedbackCollector
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MGmIU")).default), {
            content: formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel),
            position: "top"
        }, (0, (0, parcelRequire("4R6GH")).fg)('jira_global_invite_nav4') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0OK7")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("b4U16"))))),
            onClick: onClickHandler,
            label: formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHJL9")).default), {
            iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("b4U16"))))),
            appearance: "subtle",
            onClick: onClickHandler
        }, formatMessage((0, (0, parcelRequire("83YFz")).default).sidebarFeedbackButtonLabel)));
    }
});
parcelRegister("b4U16", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $810b852cbd4baf63$var$_react = $810b852cbd4baf63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $810b852cbd4baf63$var$_UNSAFE_baseNew = $810b852cbd4baf63$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $810b852cbd4baf63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $810b852cbd4baf63$var$MegaphoneIcon = (props)=>$810b852cbd4baf63$var$_react.default.createElement($810b852cbd4baf63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
        }, props));
    $810b852cbd4baf63$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
    var $810b852cbd4baf63$var$_default = module.exports.default = $810b852cbd4baf63$var$MegaphoneIcon;
});
parcelRegister("7iULw", function(module, exports) {
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", ()=>$384a8a865c8f714d$export$baea5c8192e79adc);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", ()=>$384a8a865c8f714d$export$4eda1e3a4a311d13);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", ()=>$384a8a865c8f714d$export$5fb38521eb7ad63c);
    $parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", ()=>$384a8a865c8f714d$export$345c45dd28f28a32);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", ()=>$384a8a865c8f714d$export$8962f2e618411469);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", ()=>$384a8a865c8f714d$export$7d7f2319141db3c5);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", ()=>$384a8a865c8f714d$export$4725635e6fe1907a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", ()=>$384a8a865c8f714d$export$3a50f2efd6cfd6f3);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", ()=>$384a8a865c8f714d$export$5bd148c13bb23f7a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", ()=>$384a8a865c8f714d$export$b4de0744c1fd450d);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", ()=>$384a8a865c8f714d$export$1a7c42187130faf9);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", ()=>$384a8a865c8f714d$export$e84c34a7e1dbcf78);
    $parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", ()=>$384a8a865c8f714d$export$23f6d7b16d2210c1);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", ()=>$384a8a865c8f714d$export$1b65c2053cba0686);
    $parcel$export(module.exports, "EntryKeys", ()=>$384a8a865c8f714d$export$12d01b6c311a909a);
    const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
    const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
    const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
    const $384a8a865c8f714d$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
    const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
    const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
    const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
    const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
    const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
    const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
    const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
    const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
    const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
    const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
    const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
    const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
        CLOUD_ID: 'cloud-id',
        OPT_OUT: 'Opt-out',
        REASON: 'reason',
        FEELING: 'feeling',
        IS_ADMIN: 'is-admin',
        IS_SITE_ADMIN: 'is-site-admin',
        IS_PROJECT_SETTINGS: 'is-project-settings',
        INLINE_FEEDBACK_ID: 'inlineFeedbackId',
        IS_JSD_EVALUATOR: 'is-jsd-evaluator',
        IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
        SUPPORTED_PROJECT_TYPES: 'supported-project-types',
        FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
        FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
        FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
        LOCATION: 'Location',
        PROJECT_TYPE: 'project-type',
        BOARD_TYPE: 'board-type',
        REFERER: 'Referer',
        ROUTE_GROUP: 'route-group',
        ROUTE_NAME: 'route-name',
        USER_AGENT: 'User-Agent',
        SCREEN_RESOLUTION: 'Screen Resolution',
        SOURCE: 'Source',
        SUB_PRODUCT: 'Sub-product',
        JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
        JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
        DEPLOYMENT_PROVIDERS: 'deployment-providers',
        JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
        VERSION_CONTROL_PROVIDERS: 'version-control-providers',
        DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
        CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
        SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
        INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
        IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
        FEEDBACK_GROUP_ID: 'feedback-group-id',
        EDITION: 'edition',
        ENV: 'environment',
        SMART_REPLIES: 'smart-replies'
    });
});
parcelRegister("dseDh", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$c996142feb877ddb$export$4be696be8a3bff13);
    $parcel$export(module.exports, "useFeedbackCollectorActions", ()=>$c996142feb877ddb$export$dfb2ee2d9e73fa48);
    $parcel$export(module.exports, "FeedbackActionsSubscriber", ()=>$c996142feb877ddb$export$c35dbf16ebe9df04);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
        isFeedbackCollectorOpen: false,
        entrypointId: undefined,
        email: undefined,
        additionalFields: undefined,
        feedbackTitle: undefined,
        feedbackContext: undefined,
        feedbackCollectorId: undefined,
        showTypeField: true,
        submitButtonLabel: undefined,
        canBeContactedLabel: undefined,
        summaryPlaceholder: undefined,
        feedbackGroupLabels: undefined,
        onClose: undefined,
        feedbackTitleDetails: undefined,
        triggerRef: undefined,
        renderCustomContent: undefined,
        customFeedbackOptions: []
    };
    const $c996142feb877ddb$export$e324594224ef24da = {
        openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
                dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
                setState({
                    ...feedbackCollectorProps,
                    isFeedbackCollectorOpen: true
                });
            },
        closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
                const { triggerRef: triggerRef } = getState();
                if (triggerRef) setTimeout(()=>triggerRef.current?.focus(), 50);
                setState({
                    isFeedbackCollectorOpen: false,
                    triggerRef: undefined
                });
            },
        resetFeedbackCollectorState: ()=>({ setState: setState })=>{
                setState({
                    ...$c996142feb877ddb$export$d4c72bab9d6cc13a
                });
            },
        updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
                setState({
                    renderCustomContent: updatedCustomRenderContent
                });
            },
        updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
                setState({
                    additionalFields: updatedAdditionalFields
                });
            }
    };
    const $c996142feb877ddb$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'feedback-collector',
        initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
        actions: $c996142feb877ddb$export$e324594224ef24da
    });
    const $c996142feb877ddb$export$4be696be8a3bff13 = (0, (0, parcelRequire("3sQ5x")).createHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, (0, parcelRequire("51nlc")).createSubscriber)($c996142feb877ddb$var$Store, {
        selector: null
    });
});
parcelRegister("j5Q6Z", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptIn", ()=>$13f1e9a404b61bdc$export$46a00895da9889a2);
    var $4R6GH;
    const $13f1e9a404b61bdc$export$46a00895da9889a2 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers();
    const $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers = ()=>false;
});
parcelRegister("dkkQn", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOut", ()=>$1db1544bbdad6d19$export$acb346134ed05173);
    var $4R6GH;
    var $9Qkfw;
    var $d1JDF;
    const $1db1544bbdad6d19$export$acb346134ed05173 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("9Qkfw")).getWillShowNav4UserOptOutForDogfooding)() || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap') || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_existing-customers')) || (0, (0, parcelRequire("d1JDF")).getWillShowNav4UserOptOutForVisualRefresh)();
});
parcelRegister("9Qkfw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", ()=>$a6cd9fbcbab14454$export$9edbe3a98989e15b);
    var $4R6GH;
    const $a6cd9fbcbab14454$export$9edbe3a98989e15b = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding') && ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1') || (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2'));
});
parcelRegister("d1JDF", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", ()=>$1ed6defa01bf1a51$export$17e35ae7beae962d);
    var $4R6GH;
    const $1ed6defa01bf1a51$export$17e35ae7beae962d = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ((0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap') || (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-beta-existing-customers'));
});
parcelRegister("83YFz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$583ab6a643d91da5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $583ab6a643d91da5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sidebarFeedbackButtonLabel: {
            "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
            "defaultMessage": "Give feedback on the new navigation"
        },
        feedbackTitle: {
            "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
            "defaultMessage": "Help us improve the new navigation"
        },
        feedbackTitleDetailsWithLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
        },
        feedbackTitleDetailsNoLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
        }
    });
});
parcelRegister("b97pv", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitter", ()=>$9d376c8464898c2d$export$db67e3f8d3d6da0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $3joPi = parcelRequire("3joPi");
    var $leVjT = parcelRequire("leVjT");
    var $7Gk7K = parcelRequire("7Gk7K");
    parcelRequire("gkXF4");
    var $9LWHd = parcelRequire("9LWHd");
    parcelRequire("ikmvz");
    var $6jon0 = parcelRequire("6jon0");
    parcelRequire("lIi0N");
    var $4hF6k = parcelRequire("4hF6k");
    var $9nD7C;
    var $8tUJa;
    var $cbdZQ;
    var $fLJc4;
    var $8eIFK;
    const $9d376c8464898c2d$var$containerStyles = {
        root: "_1e0cglyw _kqswstnw _u7coidpf _152tidpf _12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _181n1ule",
        positionEnd: "_rjxpftgi",
        positionStart: "_1e02zeo2"
    };
    const $9d376c8464898c2d$var$buttonStyles = {
        grabArea: "_1bsbl52n _4t3i1osq _kqswstnw _1yt4ze3t _syaz3acm _bfhk18uv _v5645ge5 _1lww5cps _d0aluf7j _1gavfnf5 _v0vwaqb7 _30l3aqb7 _1gk412xp _o7ks12xp _9h8h16c2 _1gglglyw",
        content: "_1bsb1osq _4t3i1osq"
    };
    const $9d376c8464898c2d$var$lineStyles = {
        root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
    };
    const $9d376c8464898c2d$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>{
        const splitterRef = (0, $5uXOq.useRef)(null);
        const panelSplitterContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("cbdZQ")).PanelSplitterContext));
        (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
        const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
        (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
        const direction = (0, (0, parcelRequire("8eIFK")).useTextDirection)(portalRef.current);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const splitter = splitterRef.current;
            (0, $3joPi.default)(splitter, 'Splitter ref must be set');
            return (0, $leVjT.combine)((0, $9LWHd.blockDraggingToIFrames)({
                element: splitter
            }), (0, $7Gk7K.draggable)({
                element: splitter,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $6jon0.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $4hF6k.preventUnhandled).start();
                },
                getInitialData () {
                    (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                    return {
                        initialWidth: (0, (0, parcelRequire("fLJc4")).getPixelWidth)(panelRef.current)
                    };
                },
                onDragStart ({ source: source }) {
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    onResizeStart?.({
                        initialWidth: source.data.initialWidth
                    });
                },
                onDrag ({ location: location, source: source }) {
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, (0, parcelRequire("fLJc4")).getWidthFromDragLocation)({
                        initialWidth: source.data.initialWidth,
                        location: location,
                        direction: direction,
                        position: position
                    })}px, ${resizeBounds.max})`);
                },
                onDrop ({ source: source }) {
                    (0, $4hF6k.preventUnhandled).stop();
                    (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                    (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    const finalWidth = (0, (0, parcelRequire("fLJc4")).getPixelWidth)(panelRef.current);
                    onCompleteResize(finalWidth);
                    onResizeEnd?.({
                        initialWidth: source.data.initialWidth,
                        finalWidth: finalWidth
                    });
                    panelRef.current.style.removeProperty(resizingCssVar);
                }
            }));
        }, [
            onCompleteResize,
            onResizeStart,
            onResizeEnd,
            panelRef,
            resizingCssVar,
            panelWidth,
            resizeBounds,
            direction,
            position,
            isEnabled
        ]);
        if (!isEnabled) return null;
        return (0, $7nsd3.createPortal)($5uXOq.createElement("div", {
            "data-testid": testId ? `${testId}-container` : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $9d376c8464898c2d$var$containerStyles.root,
                position === 'start' && $9d376c8464898c2d$var$containerStyles.positionStart,
                position === 'end' && $9d376c8464898c2d$var$containerStyles.positionEnd
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("9nD7C")).default), {
            style: {
                outline: 'none'
            },
            ref: splitterRef,
            xcss: $9d376c8464898c2d$var$buttonStyles.grabArea,
            interactionName: interactionName,
            testId: testId
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $9d376c8464898c2d$var$buttonStyles.content
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("8tUJa")).default), null, label), $5uXOq.createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $9d376c8464898c2d$var$lineStyles.root
            ])
        })))), portalRef.current);
    };
    const $9d376c8464898c2d$var$ClientOnly = ({ children: children })=>{
        const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasMounted(true);
        }, []);
        return $5uXOq.createElement((0, $5uXOq.Fragment), null, hasMounted ? children : null);
    };
    const $9d376c8464898c2d$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>$5uXOq.createElement($9d376c8464898c2d$var$ClientOnly, null, $5uXOq.createElement($9d376c8464898c2d$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            interactionName: interactionName,
            testId: testId
        }));
});
parcelRegister("gkXF4", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>(parcelRequire("9LWHd")).blockDraggingToIFrames);
    var $9LWHd = parcelRequire("9LWHd");
});
parcelRegister("9LWHd", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>$354aecacb74e295a$export$6ae1d8fab001518c);
    var $7ZhsK = parcelRequire("7ZhsK");
    var $eSb8x = parcelRequire("eSb8x");
    function $354aecacb74e295a$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
        const originalValue = el.style.getPropertyValue(property);
        const originalPriority = el.style.getPropertyPriority(property);
        el.style.setProperty(property, rule, priority);
        return function cleanup() {
            el.style.setProperty(property, originalValue, originalPriority);
        };
    }
    let $354aecacb74e295a$var$isActive = false;
    function $354aecacb74e295a$var$tryStart() {
        if ($354aecacb74e295a$var$isActive) return;
        $354aecacb74e295a$var$isActive = true;
        const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$354aecacb74e295a$var$setStyle(iframe, {
                property: 'pointer-events',
                rule: 'none',
                priority: 'important'
            }));
        const cleanup = (0, $eSb8x.combine)(...iframeCleanups, (0, $7ZhsK.monitorForElements)({
            onDrop () {
                cleanup();
            }
        }), function release() {
            $354aecacb74e295a$var$isActive = false;
        });
    }
    function $354aecacb74e295a$export$6ae1d8fab001518c({ element: element }) {
        return (0, $7ZhsK.monitorForElements)({
            onGenerateDragPreview ({ source: source }) {
                if (source.element === element) $354aecacb74e295a$var$tryStart();
            }
        });
    }
});
parcelRegister("ikmvz", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>(parcelRequire("6jon0")).disableNativeDragPreview);
    var $6jon0 = parcelRequire("6jon0");
});
parcelRegister("6jon0", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>$7be0c66836f72e9e$export$c588cb30ff3b876e);
    const $7be0c66836f72e9e$var$tinyTransparentImage = (()=>{
        if (typeof window === 'undefined') return null;
        const img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
        return img;
    })();
    function $7be0c66836f72e9e$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
        if (nativeSetDragImage && $7be0c66836f72e9e$var$tinyTransparentImage) nativeSetDragImage($7be0c66836f72e9e$var$tinyTransparentImage, 0, 0);
    }
});
parcelRegister("lIi0N", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>(parcelRequire("4hF6k")).preventUnhandled);
    var $4hF6k = parcelRequire("4hF6k");
});
parcelRegister("4hF6k", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>$1f71b20a3b76dc96$export$453c0582481cc59d);
    var $cBeZP;
    var $eWEqP = parcelRequire("eWEqP");
    function $1f71b20a3b76dc96$var$acceptDrop(event) {
        if (event.defaultPrevented) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        event.preventDefault();
    }
    let $1f71b20a3b76dc96$var$unbindEvents = null;
    function $1f71b20a3b76dc96$var$start() {
        $1f71b20a3b76dc96$var$cleanup();
        $1f71b20a3b76dc96$var$unbindEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragover',
                listener: $1f71b20a3b76dc96$var$acceptDrop
            },
            {
                type: 'dragenter',
                listener: $1f71b20a3b76dc96$var$acceptDrop
            },
            {
                type: 'drop',
                listener (event) {
                    event.preventDefault();
                    $1f71b20a3b76dc96$var$cleanup();
                }
            },
            {
                type: 'dragend',
                listener: $1f71b20a3b76dc96$var$cleanup
            },
            ...(0, $eWEqP.getBindingsForBrokenDrags)({
                onDragEnd: $1f71b20a3b76dc96$var$cleanup
            })
        ], {
            capture: false
        });
    }
    function $1f71b20a3b76dc96$var$cleanup() {
        $1f71b20a3b76dc96$var$unbindEvents?.();
        $1f71b20a3b76dc96$var$unbindEvents = null;
    }
    function $1f71b20a3b76dc96$var$stop() {
        if (window.event?.type === 'drop') window.event?.preventDefault();
        $1f71b20a3b76dc96$var$cleanup();
    }
    const $1f71b20a3b76dc96$export$453c0582481cc59d = {
        start: $1f71b20a3b76dc96$var$start,
        stop: $1f71b20a3b76dc96$var$stop
    };
});
parcelRegister("fLJc4", function(module, exports) {
    $parcel$export(module.exports, "getWidthFromDragLocation", ()=>$406548ef9a672352$export$e360234971cb95b8);
    $parcel$export(module.exports, "getPixelWidth", ()=>$406548ef9a672352$export$d942790ad00c41f9);
    const $406548ef9a672352$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
        const diffX = location.current.input.clientX - location.initial.input.clientX;
        if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
        return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
    };
    const $406548ef9a672352$export$d942790ad00c41f9 = (element)=>{
        const { width: width } = window.getComputedStyle(element);
        return parseInt(width);
    };
});
parcelRegister("8eIFK", function(module, exports) {
    $parcel$export(module.exports, "useTextDirection", ()=>$a80f4cbe72f92e47$export$cf24a79f32f45545);
    var $5uXOq = parcelRequire("5uXOq");
    const $a80f4cbe72f92e47$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
            const { direction: direction } = window.getComputedStyle(element);
            return direction === 'rtl' ? 'rtl' : 'ltr';
        }, [
            element
        ]);
});
parcelRegister("b2nyH", function(module, exports) {
    $parcel$export(module.exports, "SideNavFooter", ()=>$acf5a034c32a280c$export$b773c4c9cf740fbe);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $acf5a034c32a280c$var$styles = {
        root: "_1yt4utpp _7myae4h9 _1sw7nqa1 _qgnumuej"
    };
    const $acf5a034c32a280c$export$b773c4c9cf740fbe = ({ children: children, xcss: xcss })=>{
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $acf5a034c32a280c$var$styles.root,
                xcss
            ])
        }, children);
    };
});
parcelRegister("gxq4u", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$17a71abc75e8d96c$export$defe85febe8b728c);
    var $7VHMR;
    const $17a71abc75e8d96c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sidebarNavigation: {
            "id": "page-container-v2.common.sidebar.sidebar-navigation",
            "defaultMessage": "Sidebar navigation"
        },
        sideBarPanelSplitterLabel: {
            "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
            "defaultMessage": "Resize side navigation panel"
        }
    });
});
parcelRegister("7x18A", function(module, exports) {
    $parcel$export(module.exports, "AsyncResizeButtonTooltip", ()=>$15587b8ab3be3aba$export$e12f5b3a390577de);
    var $hPtZI;
    const $15587b8ab3be3aba$export$e12f5b3a390577de = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("gHSSC")), {
        ssr: false,
        moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
    });
});
parcelRegister("gHSSC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ikCLZ").then(()=>parcelRequire('iIrS6'));
});
parcelRegister("gxCm0", function(module, exports) {
    $parcel$export(module.exports, "TopNav", ()=>$5815562a2673ba2a$export$41d0d88a6b0e456f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5e7oM;
    var $azzrO;
    var $Mp6qH;
    var $ghgbB;
    var $eoNiZ;
    var $e6AHy;
    var $44v1T;
    var $gwIPs;
    var $7CMCs;
    var $93jKl;
    var $7XYc4;
    var $cSD7y;
    var $4R6GH;
    var $3bl6P;
    var $9aaiB;
    var $5X3WH;
    var $3HwlS;
    var $iqLcb;
    var $lfTZh;
    var $5M3R9;
    var $l8ruj;
    var $erBFB;
    var $dm0Uk;
    var $iIpJ6;
    const $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
    const $5815562a2673ba2a$var$LegacyPageNavigationStyles = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
            }
        });
    const $5815562a2673ba2a$var$TEST_ID = 'page-layout.top-nav';
    function $5815562a2673ba2a$var$NewTopNavWithoutCustomTheming() {
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav4'
        });
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            testId: $5815562a2673ba2a$var$TEST_ID
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null)))));
    }
    function $5815562a2673ba2a$var$NewTopNavWithCustomTheming() {
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        const theme = (0, (0, parcelRequire("eoNiZ")).useNav4Theme)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav4'
        });
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            testId: $5815562a2673ba2a$var$TEST_ID,
            theme: theme
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null)))));
    }
    const $5815562a2673ba2a$var$NewTopNav = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_nav4_theming', $5815562a2673ba2a$var$NewTopNavWithCustomTheming, $5815562a2673ba2a$var$NewTopNavWithoutCustomTheming);
    const $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
    function $5815562a2673ba2a$var$OldTopNav() {
        const fullscreenRef = (0, $5uXOq.useRef)(null);
        const { isFullscreen: isFullscreen } = (0, (0, parcelRequire("3bl6P")).useIsFullscreen)(fullscreenRef.current);
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("9aaiB")).useTopNavState)();
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("Mp6qH")).EXPERIENCE_NAVIGATION_TOP_MAIN)
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav_version_exposure')) (0, (0, parcelRequire("5X3WH")).sendNavExposure)({
            componentName: 'nav3'
        });
        const height = isFullscreen ? 0 : $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dm0Uk")).ZIndexWrapper), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).navigation,
            top: (0, (0, parcelRequire("iqLcb")).UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
            "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
            ref: fullscreenRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).TopNavigation), {
            isFixed: true,
            height: height,
            id: "ak-jira-navigation"
        }, !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgbB")).AtlassianNavigationStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainer",
            fallback: "flag",
            onError: onFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).PlaceholderNew), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "start",
            traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIpJ6")).AsyncAtlassianNavigation), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavTopSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
        }))))));
    }
    const $5815562a2673ba2a$export$41d0d88a6b0e456f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $5815562a2673ba2a$var$NewTopNav, $5815562a2673ba2a$var$OldTopNav);
});
parcelRegister("Mp6qH", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", ()=>$d722fd8ef23adae6$export$ea341e6cc435ed40);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", ()=>$d722fd8ef23adae6$export$cb66c02d110b1531);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", ()=>$d722fd8ef23adae6$export$22ea57e66775a6b2);
    $parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", ()=>$d722fd8ef23adae6$export$4766f0c4b6fe35dc);
    $parcel$export(module.exports, "NAVIGATION_ITEM_ID", ()=>$d722fd8ef23adae6$export$1a9b265c626e9d44);
    $parcel$export(module.exports, "MODAL_ID", ()=>$d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$6037915bf3452cf3);
    $parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$286c2faa2103eb9c);
    $parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$c0d6ac131d4391b9);
    $parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", ()=>$d722fd8ef23adae6$export$8d9442dfaec4086f);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", ()=>$d722fd8ef23adae6$export$3014c5ec440d8824);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", ()=>$d722fd8ef23adae6$export$69cbedccc0df48);
    $parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", ()=>$d722fd8ef23adae6$export$1935aad1d702494c);
    $parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", ()=>$d722fd8ef23adae6$export$cc578bc72d7a7308);
    const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
    const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
    const $d722fd8ef23adae6$export$8666f31c8873bff = 10;
    const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
    const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
    const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
    const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
        ADDONS: 'apps',
        CREATE: 'createIssue',
        APP_SWITCHER: 'atlassianSwitcher',
        DASHBOARDS: 'dashboards',
        FILTERS: 'filters',
        HELP: 'help',
        HELP_BADGE: 'helpBadge',
        HOME: 'home',
        INSIGHT: 'insight',
        LOGO: 'productLogo',
        NOTIFICATIONS: 'notifications',
        PEOPLE: 'people',
        PLANS: 'plans',
        PROFILE: 'profile',
        PROJECTS: 'projects',
        ROADMAPS: 'roadmaps',
        SEARCH: 'search',
        SERVICE_HUB: 'services',
        SETTINGS: 'settings',
        SIGN_IN: 'signIn',
        YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
        CONVERSATION_ASSISTANT: 'conversationAssistant',
        ROVO_DEMAND_TESTS: 'rovoDemandTests'
    };
    const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
        DASHBOARD_CREATE: 'DASHBOARD_CREATE',
        KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
        PROJECT_CREATE: 'PROJECT_CREATE'
    };
    const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
    const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
    const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
    const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
    const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
    const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
    const $d722fd8ef23adae6$export$1935aad1d702494c = {
        RECENT: 'RECENT',
        BOARDS: 'BOARDS',
        QUEUES: 'QUEUES',
        ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
        ADD_FILTER: 'ADD_FILTER',
        ALERTS: 'ALERTS'
    };
    const $d722fd8ef23adae6$export$bbaa49b5be375ff3 = 3;
    const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
    const $d722fd8ef23adae6$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';
});
parcelRegister("ghgbB", function(module, exports) {
    $parcel$export(module.exports, "AtlassianNavigationStart", ()=>$d610646e169deef8$export$831e6a6e875b5ef8);
    var $5uXOq = parcelRequire("5uXOq");
    var $kaHBi;
    var $8CVvd;
    var $4oDnX;
    var $6IzHB;
    var $doZTA;
    var $Mp6qH;
    const $d610646e169deef8$export$831e6a6e875b5ef8 = ()=>{
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)({
            location: location,
            startTime: Date.now()
        });
        (0, $5uXOq.useMemo)(()=>{
            if (location !== startRef.current.location) startRef.current = {
                location: location,
                startTime: Date.now()
            };
        }, [
            location
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStartWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82), startRef.current.startTime);
        }, [
            location,
            setAppStartWithAppId
        ]);
        return (0, (0, parcelRequire("8CVvd")).getWillShowNav3)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experience: (0, (0, parcelRequire("Mp6qH")).EXPERIENCE_NAVIGATION_TOP_MAIN),
            analyticsSource: "atlassian-navigation",
            experienceId: pageId
        });
    };
});
parcelRegister("8CVvd", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav3", ()=>$5acda4891dbe9afe$export$23a7d978e17f1720);
    var $3HwlS;
    const $5acda4891dbe9afe$export$23a7d978e17f1720 = ()=>!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
});
parcelRegister("eoNiZ", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$96d5309c36bfdfee$export$93d4e7f90805808f);
    $parcel$export(module.exports, "useNav4Theme", ()=>$96d5309c36bfdfee$export$b761e7abf0bdf352);
    var $5uXOq = parcelRequire("5uXOq");
    var $iFLr2;
    var $kh4KP;
    var $disyi;
    var $9MAC1;
    var $2Ql51;
    var $bt2pf;
    var $ihBhD;
    const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
    const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
        if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
            const fallback = isDarkMode ? '#1d2125' : '#ffffff';
            return (0, (0, parcelRequire("kh4KP")).default)('elevation.surface', fallback);
        }
        return isDarkMode ? (0, (0, parcelRequire("ihBhD")).capLightness)(backgroundColor, 35) : backgroundColor;
    };
    const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("disyi")).default)();
        const { theme: preference } = (0, (0, parcelRequire("2Ql51")).useThemePreference)();
        return false ? preference === 'dark' : colorMode === 'dark';
    };
    const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
        const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bt2pf")).addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return (0, (0, parcelRequire("iFLr2")).generateTheme)({
            name: 'jira',
            backgroundColor: bg,
            highlightColor: highlightColor
        });
    };
    const $96d5309c36bfdfee$export$b761e7abf0bdf352 = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
        const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bt2pf")).addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return {
            backgroundColor: bg,
            highlightColor: highlightColor
        };
    };
});
parcelRegister("bt2pf", function(module, exports) {
    $parcel$export(module.exports, "addThemeColor", ()=>$274a73c0f1d6297a$export$7b20d133831b2b0f);
    const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
    const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
        if (!content || typeof document === 'undefined' || false) return;
        const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
        const meta = document.createElement('meta');
        meta.name = 'theme-color';
        meta.content = content;
        if (existingMeta) existingMeta.replaceWith?.(meta);
        else {
            const head = $274a73c0f1d6297a$var$getHead();
            if (head) head.appendChild?.(meta);
        }
    };
});
parcelRegister("ihBhD", function(module, exports) {
    $parcel$export(module.exports, "capLightness", ()=>$dbd7508aaed6851f$export$8b5544bab97b10dd);
    const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
        const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
    const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
    const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
        const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
        if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
        return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
    };
});
parcelRegister("e6AHy", function(module, exports) {
    $parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", ()=>$33751c6bf425b3ee$export$38e532bc6b824200);
    var $5uXOq = parcelRequire("5uXOq");
    var $bo2Xq;
    var $le2LN;
    var $eoNiZ;
    const $33751c6bf425b3ee$export$38e532bc6b824200 = ()=>{
        const theme = (0, (0, parcelRequire("eoNiZ")).useTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("le2LN")).default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bo2Xq")).NavigationSkeleton), {
            theme: theme
        }));
    };
});
parcelRegister("bo2Xq", function(module, exports) {
    $parcel$export(module.exports, "NavigationSkeleton", ()=>$e97dd4a439d264bc$export$ad5e8e6ace98cc2);
    var $f8Sb3;
    var $4hk1m;
    var $hTNtX;
    var $Vb7G9;
    var $2aUqd;
    var $fpCXz;
    var $iTxnC;
    var $gPJOM;
    function $e97dd4a439d264bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e97dd4a439d264bc$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        height: (0, $ca0f2966c3a33e95$export$30fa7cc5f2690a43),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`}`,
        paddingInlineEnd: "var(--ds-space-150, 12px)",
        paddingInlineStart: "var(--ds-space-150, 12px)"
    });
    const $e97dd4a439d264bc$var$leftStyles = {
        name: "vtikxo",
        styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
    };
    const $e97dd4a439d264bc$var$rightStyles = {
        name: "1mwlrd6",
        styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
    };
    const $e97dd4a439d264bc$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, (0, parcelRequire("4hk1m")).defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hTNtX")).ThemeProvider), {
            value: theme
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.navigation,
            css: $e97dd4a439d264bc$var$containerStyles,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $e97dd4a439d264bc$var$leftStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("Vb7G9")).IconButtonSkeleton), {
            marginLeft: 0,
            marginRight: 5,
            size: 26
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fpCXz")).ProductHomeSkeleton), {
            showSiteName: showSiteName
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2aUqd")).PrimaryItemsContainerSkeleton), {
            count: primaryItemsCount
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $e97dd4a439d264bc$var$rightStyles
        }, shouldShowSearch && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gPJOM")).SearchSkeleton), null), Array.from({
            length: secondaryItemsCount
        }, (_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("Vb7G9")).IconButtonSkeleton), {
                key: index,
                marginLeft: 0,
                marginRight: 4,
                size: 26
            })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iTxnC")).ProfileSkeleton), null))));
    };
    var $e97dd4a439d264bc$export$2e2bcd8739ae039 = $e97dd4a439d264bc$export$ad5e8e6ace98cc2;
});
const $ca0f2966c3a33e95$export$30fa7cc5f2690a43 = 56;
const $ca0f2966c3a33e95$export$4033a111ca79977d = 1280;
const $ca0f2966c3a33e95$export$24ec62cee78b7042 = 1130;
const $ca0f2966c3a33e95$export$d8bde68ac946124f = '--ds--ans--fbc';
const $ca0f2966c3a33e95$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $ca0f2966c3a33e95$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $ca0f2966c3a33e95$export$d81606c1fc5119bc = '--ds--ans--c';
const $ca0f2966c3a33e95$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("Vb7G9", function(module, exports) {
    $parcel$export(module.exports, "IconButtonSkeleton", ()=>$cdec40bf9c8b7494$export$7a24471cb6f25433);
    var $f8Sb3;
    var $eGqCc;
    function $cdec40bf9c8b7494$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $cdec40bf9c8b7494$var$buttonHeight = "var(--ds-space-400, 32px)";
    const $cdec40bf9c8b7494$var$skeletonStyles = {
        name: "28gj0e",
        styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
    };
    const $cdec40bf9c8b7494$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
        const theme = (0, (0, parcelRequire("eGqCc")).useTheme)();
        const dynamicStyles = {
            marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
            marginRight: typeof marginRight === 'number' ? marginRight : 0,
            width: typeof size === 'number' ? size : $cdec40bf9c8b7494$var$buttonHeight,
            height: typeof size === 'number' ? size : $cdec40bf9c8b7494$var$buttonHeight,
            ...theme.mode.skeleton
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: dynamicStyles,
            css: $cdec40bf9c8b7494$var$skeletonStyles
        });
    };
});
parcelRegister("2aUqd", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainerSkeleton", ()=>$e50a333f93a4a9dc$export$fdfc48d2117b79a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7PDz0;
    function $e50a333f93a4a9dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e50a333f93a4a9dc$var$primaryButtonSkeletonStyles = {
        name: "yn5kop",
        styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
    };
    const $e50a333f93a4a9dc$export$fdfc48d2117b79a8 = (0, $5uXOq.memo)(({ count: count })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, Array.from({
            length: count
        }, (_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7PDz0")).PrimaryButtonSkeleton), {
                key: index,
                css: $e50a333f93a4a9dc$var$primaryButtonSkeletonStyles
            }))));
});
parcelRegister("7PDz0", function(module, exports) {
    $parcel$export(module.exports, "PrimaryButtonSkeleton", ()=>$b06c40059ffcc515$export$4bc51fe36728414d);
    var $f8Sb3;
    var $eGqCc;
    const $b06c40059ffcc515$var$paddingAll = 4;
    const $b06c40059ffcc515$var$buttonHeight = 32;
    const $b06c40059ffcc515$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        width: '68px',
        height: `${$b06c40059ffcc515$var$buttonHeight - $b06c40059ffcc515$var$paddingAll * 2.5}px`,
        borderRadius: "var(--ds-border-radius, 4px)",
        opacity: 0.15
    });
    const $b06c40059ffcc515$export$4bc51fe36728414d = (props)=>{
        const theme = (0, (0, parcelRequire("eGqCc")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $b06c40059ffcc515$var$skeletonStyles,
            className: props.className
        });
    };
});
parcelRegister("fpCXz", function(module, exports) {
    $parcel$export(module.exports, "ProductHomeSkeleton", ()=>$fd91891810c75dd7$export$3e79e535d76cce4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGqCc;
    var $eLnMI;
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $fd91891810c75dd7$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
    const $fd91891810c75dd7$var$productHomeButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:active': {
            backgroundColor: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus': {
            backgroundColor: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            boxShadow: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
            color: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: 0
        },
        '&:hover': {
            backgroundColor: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $ca0f2966c3a33e95$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $ca0f2966c3a33e95$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $fd91891810c75dd7$var$productLogoStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: 120,
        maxWidth: 120,
        height: 24,
        maxHeight: 28,
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (max-width: ${(0, $ca0f2966c3a33e95$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $fd91891810c75dd7$var$productIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: 28,
        height: 28,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (min-width: ${0, $ca0f2966c3a33e95$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $fd91891810c75dd7$var$siteTitleStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: "var(--ds-space-500, 40px)",
        alignItems: 'center',
        backgroundColor: 'transparent',
        marginInlineEnd: "var(--ds-space-050, 4px)",
        marginInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-200, 16px)",
        '&:after': {
            width: '100%',
            height: 14,
            backgroundColor: `var(${$fd91891810c75dd7$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
            borderRadius: "var(--ds-border-radius, 4px)",
            content: '""'
        }
    });
    const $fd91891810c75dd7$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
        const theme = (0, (0, parcelRequire("eGqCc")).useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const productHomeButtonDynamicStyles = (0, (0, parcelRequire("eLnMI")).stripEmptyProperties)({
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$fd91891810c75dd7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
            [$fd91891810c75dd7$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        });
        const siteTitleDynamicStyles = {
            borderRight: theme.mode.productHome.borderRight,
            opacity: theme.mode.skeleton.opacity,
            [$fd91891810c75dd7$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: productHomeButtonDynamicStyles,
            css: $fd91891810c75dd7$var$productHomeButtonStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $fd91891810c75dd7$var$productLogoStyles
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $fd91891810c75dd7$var$productIconStyles
        })), showSiteName && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: siteTitleDynamicStyles,
            css: $fd91891810c75dd7$var$siteTitleStyles
        }));
    };
});
parcelRegister("iTxnC", function(module, exports) {
    $parcel$export(module.exports, "ProfileSkeleton", ()=>$d3c1d8d5bf58c017$export$2bab43fd33adda3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $Vb7G9;
    const $d3c1d8d5bf58c017$export$2bab43fd33adda3b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Vb7G9")).IconButtonSkeleton), {
            marginLeft: 6,
            marginRight: 6,
            size: 26
        });
});
parcelRegister("gPJOM", function(module, exports) {
    $parcel$export(module.exports, "SearchSkeleton", ()=>$d81972f47b3801f6$export$d8fbade3e5bbb8e0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGqCc;
    var $Vb7G9;
    const $d81972f47b3801f6$var$searchInputContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginRight: "var(--ds-space-100, 8px)",
        marginLeft: "var(--ds-space-250, 20px)",
        position: 'relative',
        [`@media (max-width: ${(0, $ca0f2966c3a33e95$export$24ec62cee78b7042) - 1}px)`]: {
            display: 'none !important'
        }
    });
    const $d81972f47b3801f6$var$searchInputSkeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: '220px',
        height: "var(--ds-space-400, 32px)",
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
        borderRadius: "var(--ds-border-radius-200, 6px)",
        opacity: 0.15
    });
    const $d81972f47b3801f6$var$searchIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [`@media (min-width: ${0, $ca0f2966c3a33e95$export$24ec62cee78b7042}px)`]: {
            display: 'none !important'
        }
    });
    const $d81972f47b3801f6$export$d8fbade3e5bbb8e0 = ()=>{
        const theme = (0, (0, parcelRequire("eGqCc")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d81972f47b3801f6$var$searchInputContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: theme.mode.skeleton,
            css: $d81972f47b3801f6$var$searchInputSkeletonStyles
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("Vb7G9")).IconButtonSkeleton), {
            css: $d81972f47b3801f6$var$searchIconStyles,
            marginRight: 5,
            size: 26
        }));
    };
});
parcelRegister("3bl6P", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$0124d1f81a2437a4$export$d397eccea5f37b0a);
    var $5uXOq = parcelRequire("5uXOq");
    const $0124d1f81a2437a4$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
    const $0124d1f81a2437a4$export$d397eccea5f37b0a = (target)=>{
        const [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const handleFullscreen = ()=>{
                setIsFullscreen($0124d1f81a2437a4$var$fullscreenClassnameExists(target));
            };
            const mutationObserver = new MutationObserver(handleFullscreen);
            if (target) mutationObserver.observe(target, {
                attributes: true
            });
            return ()=>mutationObserver.disconnect();
        }, [
            target
        ]);
        return {
            isFullscreen: isFullscreen
        };
    };
});
parcelRegister("9aaiB", function(module, exports) {
    $parcel$export(module.exports, "useTopNavState", ()=>$dd484d7e2bde5991$export$bccbd45ab793bd09);
    var $3sQ5x;
    var $5e5zm;
    const $dd484d7e2bde5991$var$useTopNav = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.topNavigation,
                shouldRender: !state.isChromeless
            })
    });
    const $dd484d7e2bde5991$export$bccbd45ab793bd09 = ()=>{
        const [state] = $dd484d7e2bde5991$var$useTopNav();
        return state;
    };
});
parcelRegister("5X3WH", function(module, exports) {
    $parcel$export(module.exports, "sendNavExposure", ()=>$f4ce7b379b641f97$export$4d75b96ec704d87d);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fjcgS;
    const $f4ce7b379b641f97$export$4d75b96ec704d87d = (0, ($parcel$interopDefault($gJBT6)))($f4ce7b379b641f97$var$_sendNavExposure, (p)=>p.componentName);
    function $f4ce7b379b641f97$var$_sendNavExposure(params) {
        const { componentName: componentName } = params;
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                actionSubject: componentName,
                action: 'viewed',
                source: 'navExposure',
                attributes: {}
            });
        });
        return componentName;
    }
});
parcelRegister("iIpJ6", function(module, exports) {
    $parcel$export(module.exports, "AsyncAtlassianNavigation", ()=>$8c4a7263d22ebdbf$export$932edb7b1b20d079);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $adY3A;
    var $ffza4;
    var $e6AHy;
    var $fDtbf;
    var $2Ioew;
    var $frBVt;
    var $6jY6G;
    var $2SVPM;
    const $8c4a7263d22ebdbf$export$932edb7b1b20d079 = ()=>{
        const isUsingEntryPoint = Boolean((0, (0, parcelRequire("6jY6G")).useCurrentRoute)().entryPoint?.());
        const topNavEntryPointReference = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
        (0, $5uXOq.useState)(()=>{
            if (!false && isUsingEntryPoint) (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint).root.onComplete(()=>{
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
                const resources = performance.getEntriesByType('mark');
                for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                    (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                    break;
                }
            });
            return undefined;
        });
        return isUsingEntryPoint ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6AHy")).JiraAtlassianNavigationSkeleton), null),
            entryPoint: (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint)
        }, topNavEntryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: topNavEntryPointReference,
            props: {}
        }) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation), null);
    };
});
parcelRegister("adY3A", function(module, exports) {
    $parcel$export(module.exports, "topNavigationEntryPoint", ()=>$e6a45c27809ae082$export$f780be9e138f456f);
    var $2Ftxm;
    var $ikgNX;
    const $e6a45c27809ae082$export$f780be9e138f456f = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("lesge")), {
            moduleId: "1f1265b4"
        }),
        getPreloadProps: (extraProps)=>({
                extraProps: extraProps
            })
    });
});
parcelRegister("lesge", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1eG9i")
    ]).then(()=>parcelRequire('9DfkH'));
});
parcelRegister("lvpKt", function(module, exports) {
    $parcel$export(module.exports, "FullHeight", ()=>$c63a700e8bea75a2$export$33e617ec5e4e4f76);
    var $5uXOq = parcelRequire("5uXOq");
    const $c63a700e8bea75a2$var$styleFullHeight = {
        height: '100vh'
    };
    const $c63a700e8bea75a2$export$33e617ec5e4e4f76 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: $c63a700e8bea75a2$var$styleFullHeight
        }, children);
});
parcelRegister("8Ceqd", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$5b61f4226ddd6087$export$ce1303eaa27a0d3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kHcJ3;
    var $disyi;
    var $fjcgS;
    var $dZJHS;
    var $2Ql51;
    var $2YP9W;
    const $5b61f4226ddd6087$var$darkThemeMediaMatchQuery = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    const $5b61f4226ddd6087$var$GlobalThemeSetter = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("2Ql51")).themePreferenceResource));
        const { colorMode: colorMode } = (0, (0, parcelRequire("disyi")).default)();
        const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $5uXOq.useState)(false);
        const setThemeWithToken = (0, $5uXOq.useCallback)(async (theme)=>{
            if (theme !== colorMode) {
                const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("hxMHI"));
                loadThemeTokens(theme);
            }
        }, [
            colorMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loading || error || !data) return undefined;
            if (data?.theme === 'auto') {
                setThemeWithToken($5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
                const handler = (e)=>{
                    setThemeWithToken(e.matches ? 'dark' : 'light');
                };
                $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
                return ()=>{
                    $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                };
            }
            if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
            if (!data?.theme) {
                document.documentElement.removeAttribute('data-theme');
                document.documentElement.removeAttribute('data-color-mode');
            }
            return undefined;
        }, [
            data,
            loading,
            error,
            setThemeWithToken
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loading || error || !data) return;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                if (data?.theme) client.setUIViewedAttributes({
                    theme: data.theme
                });
                else client.removeUIViewedAttribute('theme');
            });
        }, [
            data,
            loading,
            error
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                client.setUIViewedAttributes({
                    OStheme: $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
                });
            });
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
        }, []);
        if (!data?.theme || !data?.attrs || !data?.styles) return null;
        const ssrAutoScript = (0, (0, parcelRequire("kHcJ3")).default)(data.theme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
                key: theme.id,
                ...theme.attrs,
                dangerouslySetInnerHTML: {
                    __html: theme.css
                }
            })) : null, (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: Object.entries(data.attrs).map(([key, val])=>{
                    if (key === 'data-color-mode' && ssrAutoScript) return '';
                    return `document.documentElement.setAttribute("${key}", "${val}");`;
                }).join('\n')
            }
        }), ssrAutoScript ? (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: ssrAutoScript
            }
        }) : null);
    };
    const $5b61f4226ddd6087$export$ce1303eaa27a0d3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5b61f4226ddd6087$var$GlobalThemeSetter, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZJHS")).ThemeSetter), null));
});
parcelRegister("kHcJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c133db20e96ae625$export$2e2bcd8739ae039);
    var $294ns;
    var $2aOPL;
    var $i27Nq;
    const $c133db20e96ae625$var$getSSRAutoScript = (colorMode, contrastMode)=>{
        if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
        const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, (0, parcelRequire("i27Nq")).darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, (0, parcelRequire("2aOPL")).COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
        const setContrastMode = contrastMode === 'auto' && (0, (0, parcelRequire("294ns")).fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, (0, parcelRequire("i27Nq")).moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, (0, parcelRequire("2aOPL")).CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
        return `(() => {${setColorMode}${setContrastMode}})()`;
    };
    var $c133db20e96ae625$export$2e2bcd8739ae039 = $c133db20e96ae625$var$getSSRAutoScript;
});
parcelRegister("dZJHS", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$724d37049e8e9e6c$export$ce1303eaa27a0d3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7eveN;
    var $ceKVk;
    var $65Ltd;
    var $3HwlS;
    var $6jY6G;
    var $dC4s3;
    var $1MaBz;
    const $724d37049e8e9e6c$export$ce1303eaa27a0d3a = ()=>{
        const projectTheme = (0, (0, parcelRequire("ceKVk")).useProjectTheme)();
        const overviewTheme = (0, (0, parcelRequire("7eveN")).useOverviewTheme)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const entityTheme = (0, $5uXOq.useMemo)(()=>{
            let result = projectTheme ?? overviewTheme;
            if (result != null) {
                const isFormSubmitView = route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT) || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED);
                if (isFormSubmitView) result = {
                    ...result,
                    themeSetting: null
                };
            }
            return result;
        }, [
            projectTheme,
            overviewTheme,
            route.name
        ]);
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MaBz")).ThemeContainer), {
            isGlobal: true,
            entityTheme: entityTheme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC4s3")).ThemeTokensSetter), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1MaBz")).ThemeContainerOld), {
            isGlobal: true,
            ...entityTheme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC4s3")).ThemeTokensSetter), null));
    };
});
parcelRegister("7eveN", function(module, exports) {
    $parcel$export(module.exports, "useOverviewTheme", ()=>$c0a2b1dfc34915dc$export$a55763fd17eab357);
    var $6cG4N;
    var $jrO9m;
    const $c0a2b1dfc34915dc$export$a55763fd17eab357 = ()=>{
        const { data: data } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        if (data != null) return {
            themeSetting: {
                type: 'color',
                value: data.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
            },
            entityId: `overview/${data.id}`
        };
        return null;
    };
});
parcelRegister("ceKVk", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$f0c1f93a3181b765$export$18084206b9430153);
    var $5uXOq = parcelRequire("5uXOq");
    var $6cG4N;
    var $l2N2a;
    var $2YP9W;
    const $f0c1f93a3181b765$export$18084206b9430153 = ()=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("l2N2a")).projectDetailsResource));
        return (0, $5uXOq.useMemo)(()=>{
            if (data != null) {
                const entityId = `project/${data.currentProject?.id}`;
                const themeSetting = data.themeSetting ?? {
                    type: 'color',
                    value: (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
                };
                return {
                    themeSetting: themeSetting,
                    entityId: entityId
                };
            }
            return null;
        }, [
            data
        ]);
    };
});
parcelRegister("dC4s3", function(module, exports) {
    $parcel$export(module.exports, "ThemeTokensSetter", ()=>$5026069bddf1adf4$export$41f41c7ff10d45cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $gwIPs;
    var $6cG4N;
    var $fHEdP;
    var $4R6GH;
    var $3HwlS;
    var $1MaBz;
    var $1r9V3;
    function $5026069bddf1adf4$var$mergeThemes(theme, ...partialThemes) {
        return (0, ($parcel$interopDefault($1UikQ)))({}, theme, ...partialThemes);
    }
    const $5026069bddf1adf4$var$buildHorizontalNavVariables = (theme)=>{
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return `${0, $ff284ecc2ab07e14$export$539c074adec2188a}: ${theme['color.link']};
${0, $ff284ecc2ab07e14$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $ff284ecc2ab07e14$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $ff284ecc2ab07e14$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $ff284ecc2ab07e14$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $ff284ecc2ab07e14$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $ff284ecc2ab07e14$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $ff284ecc2ab07e14$export$4cd72d361867c565}: ${theme['color.border']};
${0, $ff284ecc2ab07e14$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
        return '';
    };
    const $5026069bddf1adf4$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
        const applicationColorMode = isDarkMode ? 'dark' : 'light';
        const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, (0, parcelRequire("6cG4N")).HIGH_BRIGHTNESS_THEME) : (0, (0, parcelRequire("6cG4N")).LOW_BRIGHTNESS_THEME);
        const isImageConfig = config.name === 'image';
        const isGradientConfig = (0, (0, parcelRequire("fHEdP")).themeManager).isGradientTheme(config.name);
        const theme = $5026069bddf1adf4$var$mergeThemes((0, (0, parcelRequire("6cG4N")).BASE_THEME), isImageConfig ? {} : brightnessOverrides, isGradientConfig ? (0, (0, parcelRequire("6cG4N")).GRADIENT_THEME) : {}, config.theme[applicationColorMode]);
        let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
        if (backgroundImageUrl) elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
        else if (applicationColorMode === 'dark') {
            if ((0, (0, parcelRequire("6cG4N")).NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
        }
        const withWrapper = config.name !== (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name;
        const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : 'unset';
        const wrapperBorderRadius = withWrapper ? `${0, (0, parcelRequire("gwIPs")).gridSize}px` : '0';
        const isNav4 = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const businessWrapperWithBackgroundHeight = isNav4 ? (0, (0, parcelRequire("4R6GH")).fg)('horizontal_navigation_increase_tab_height') ? (0, (0, parcelRequire("6cG4N")).NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, (0, parcelRequire("6cG4N")).NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
        const businessWrapperHeight = isNav4 ? (0, (0, parcelRequire("4R6GH")).fg)('horizontal_navigation_increase_tab_height') ? (0, (0, parcelRequire("6cG4N")).NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT) : (0, (0, parcelRequire("6cG4N")).NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_HEIGHT);
        const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
        const wrapperPadding = withWrapper ? `${0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_PADDING}px` : '0';
        const wrapperWidth = withWrapper ? (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WIDTH);
        return `
${(0, (0, parcelRequire("6cG4N")).Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_LINK}: ${theme['color.link']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, (0, parcelRequire("6cG4N")).Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, (0, parcelRequire("6cG4N")).Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, (0, parcelRequire("6cG4N")).Variables).CONTENT_WIDTH}: ${0, (0, parcelRequire("6cG4N")).BUSINESS_WRAPPER_WIDTH};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, (0, parcelRequire("6cG4N")).Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, (0, parcelRequire("6cG4N")).Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$5026069bddf1adf4$var$buildHorizontalNavVariables(theme)}`;
    };
    const $5026069bddf1adf4$export$41f41c7ff10d45cd = (0, $5uXOq.memo)(()=>{
        const [{ themeSetting: themeSetting }] = (0, (0, parcelRequire("1MaBz")).useThemeHook)();
        const backgroundConfig = (0, (0, parcelRequire("fHEdP")).themeManager).get({
            themeSetting: themeSetting,
            enableImages: true
        });
        const backgroundImageUrl = (0, (0, parcelRequire("1r9V3")).useBackgroundImageUrl)(themeSetting);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `:root{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
            }
        }));
    });
});
parcelRegister("fHEdP", function(module, exports) {
    $parcel$export(module.exports, "themeManager", ()=>$a34e148e1f33a06a$export$aba92a7f3273f617);
    $parcel$export(module.exports, "generateMediaImageUrl", ()=>$a34e148e1f33a06a$export$fe2402bbc6ac3125);
    var $6cG4N;
    class $a34e148e1f33a06a$var$ThemeManager {
        init() {
            (0, (0, parcelRequire("6cG4N")).GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.gradients.set(theme.name, theme);
                this.gradientNames.add(theme.name);
            });
            (0, (0, parcelRequire("6cG4N")).SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.colors.set(theme.name, theme);
                this.colorNames.add(theme.name);
            });
            (0, (0, parcelRequire("6cG4N")).BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
                this.oldColorNames.add(theme.name);
            });
        }
        isColorTheme(themeName) {
            return this.colorNames.has(themeName);
        }
        isOldColorTheme(themeName) {
            return this.oldColorNames.has(themeName);
        }
        isGradientTheme(themeName) {
            return this.gradientNames.has(themeName);
        }
        isImageTheme(themeSetting) {
            return themeSetting.type === 'image';
        }
        getGradient(themeName) {
            return this.gradients.get(themeName);
        }
        getColor(themeName) {
            return this.colors.get(themeName);
        }
        get({ themeSetting: themeSetting, enableImages: enableImages }) {
            if (!themeSetting) return 0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG;
            if (enableImages && themeSetting.type === 'image') return 0, (0, parcelRequire("6cG4N")).IMAGE_BACKGROUND_CONFIG;
            if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG);
            if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG);
            return ((0, (0, parcelRequire("6cG4N")).OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG));
        }
        constructor(){
            this.gradients = new Map();
            this.gradientNames = new Set();
            this.colors = new Map();
            this.colorNames = new Set();
            this.oldColorNames = new Set();
            this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
        }
    }
    const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
    $a34e148e1f33a06a$export$aba92a7f3273f617.init();
    function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
        const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
        url.searchParams.append('client', mediaClientId);
        Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
        return url.toString();
    }
});
parcelRegister("1MaBz", function(module, exports) {
    $parcel$export(module.exports, "ThemeContainerOld", ()=>$5ffb1b62a0c37aa6$export$c6e50a832af54243);
    $parcel$export(module.exports, "ThemeContainer", ()=>$5ffb1b62a0c37aa6$export$11eb671888ed6e7d);
    $parcel$export(module.exports, "useThemeHook", ()=>$5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb);
    $parcel$export(module.exports, "useThemeSetting", ()=>$5ffb1b62a0c37aa6$export$87d26f94ea053d38);
    $parcel$export(module.exports, "useSelectedThemeSetting", ()=>$5ffb1b62a0c37aa6$export$4ba6f9d407e18961);
    var $ajpes = parcelRequire("ajpes");
    var $fHEdP;
    var $gg7kZ;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if ((0, (0, parcelRequire("fHEdP")).themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
                entityId: entityId,
                selectedThemeSetting: selectedThemeSetting,
                themeSetting: newTheme
            });
        };
    const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if (newTheme === null || (0, (0, parcelRequire("fHEdP")).themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
                entityId: entityId,
                themeSetting: themeSetting,
                selectedThemeSetting: newTheme
            });
        };
    const $5ffb1b62a0c37aa6$var$actions = {
        setTheme: $5ffb1b62a0c37aa6$var$setTheme,
        setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
    };
    const $5ffb1b62a0c37aa6$var$initialState = {
        themeSetting: null,
        selectedThemeSetting: null,
        entityId: ''
    };
    const $5ffb1b62a0c37aa6$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $5ffb1b62a0c37aa6$var$initialState,
        actions: $5ffb1b62a0c37aa6$var$actions,
        name: 'ProjectTheme'
    });
    const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, (0, parcelRequire("gg7kZ")).createContainer)($5ffb1b62a0c37aa6$var$Store, {
        onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
        onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
    });
    const $5ffb1b62a0c37aa6$export$11eb671888ed6e7d = (0, (0, parcelRequire("gg7kZ")).createContainer)($5ffb1b62a0c37aa6$var$Store, {
        onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
            },
        onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
            }
    });
    const $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb = (0, (0, parcelRequire("3sQ5x")).createHook)($5ffb1b62a0c37aa6$var$Store);
    const $5ffb1b62a0c37aa6$var$getThemeSetting = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
    const $5ffb1b62a0c37aa6$export$87d26f94ea053d38 = (0, (0, parcelRequire("3sQ5x")).createHook)($5ffb1b62a0c37aa6$var$Store, {
        selector: $5ffb1b62a0c37aa6$var$getThemeSetting
    });
    const $5ffb1b62a0c37aa6$var$getSelectedThemeSetting = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
    const $5ffb1b62a0c37aa6$export$4ba6f9d407e18961 = (0, (0, parcelRequire("3sQ5x")).createHook)($5ffb1b62a0c37aa6$var$Store, {
        selector: $5ffb1b62a0c37aa6$var$getSelectedThemeSetting
    });
});
const $ff284ecc2ab07e14$export$d1b9ea3245b6a5de = 2;
const $ff284ecc2ab07e14$export$7f37240649d2a1e2 = 36;
const $ff284ecc2ab07e14$export$d07bba395c9390f1 = 56;
const $ff284ecc2ab07e14$export$29911ec08ab2ca2d = 5;
const $ff284ecc2ab07e14$export$b61e6f89a9db76de = 12;
const $ff284ecc2ab07e14$export$7fd2e391116c6ef5 = 9;
const $ff284ecc2ab07e14$export$e1633e494d305bfb = 'MORE';
const $ff284ecc2ab07e14$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $ff284ecc2ab07e14$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $ff284ecc2ab07e14$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $ff284ecc2ab07e14$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $ff284ecc2ab07e14$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $ff284ecc2ab07e14$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $ff284ecc2ab07e14$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $ff284ecc2ab07e14$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $ff284ecc2ab07e14$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $ff284ecc2ab07e14$export$cf26c31143daa350 = '--hn-yjlbv';
parcelRegister("1r9V3", function(module, exports) {
    $parcel$export(module.exports, "useBackgroundImageUrl", ()=>$e9bd8754684007f4$export$16f28a2a10ece447);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $fHEdP;
    var $jcw0u;
    var $fZneA;
    var $l2N2a;
    var $azoug;
    const $e9bd8754684007f4$export$16f28a2a10ece447 = (themeSetting)=>{
        (0, (0, parcelRequire("gKZoD")).di)(URL, fetch);
        const media = (0, (0, parcelRequire("l2N2a")).useMediaConfiguration)();
        const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, (0, parcelRequire("fHEdP")).generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                token: themeSetting.mediaReadToken,
                mediaEndpoint: 'image',
                width: 1000,
                'max-age': Number.MAX_SAFE_INTEGER
            }) : null, [
            media,
            themeSetting
        ]);
        const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
        const currentThemeId = (0, $5uXOq.useRef)(null);
        currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
        (0, $5uXOq.useEffect)(()=>{
            setImageUrl(lowResUrl);
            if (!media || themeSetting?.type !== 'image') return;
            const binaryUrl = (0, (0, parcelRequire("fHEdP")).generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                }
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                if (currentThemeId.current === themeSetting.id) {
                    setImageUrl(objectUrl);
                    if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, (0, parcelRequire("azoug")).unsplashTracker).trackImage(themeSetting.sourceIdentifier);
                }
            }).catch((error)=>{
                if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            themeSetting,
            media,
            lowResUrl
        ]);
        return imageUrl;
    };
});
parcelRegister("azoug", function(module, exports) {
    $parcel$export(module.exports, "unsplashTracker", ()=>$959ca91ba94e3a4e$export$1869e04dbed4c16c);
    var $azYnG = parcelRequire("azYnG");
    var $lFKmC = parcelRequire("lFKmC");
    const $959ca91ba94e3a4e$var$APP_ID = '7066';
    const $959ca91ba94e3a4e$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$959ca91ba94e3a4e$var$APP_ID}`;
    const $959ca91ba94e3a4e$var$MAX_URL_LENGTH = 2083;
    const $959ca91ba94e3a4e$var$ID_LENGTH = 12;
    const $959ca91ba94e3a4e$export$28219189b23a0628 = Math.floor($959ca91ba94e3a4e$var$MAX_URL_LENGTH / $959ca91ba94e3a4e$var$ID_LENGTH);
    class $959ca91ba94e3a4e$var$UnsplashTracker {
        send() {
            if (this.queue.size === 0) return;
            const imageIds = Array.from(this.queue);
            this.queue.clear();
            (0, ($parcel$interopDefault($azYnG)))(imageIds, $959ca91ba94e3a4e$export$28219189b23a0628).forEach((chunkIds)=>{
                const url = `${$959ca91ba94e3a4e$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
                const now = new Date();
                imageIds.forEach((imageId)=>{
                    this.trackedImages.set(imageId, now);
                });
                const handleFailure = ()=>{
                    imageIds.forEach((imageId)=>{
                        this.queue.add(imageId);
                        this.trackedImages.delete(imageId);
                    });
                };
                fetch(url).then((response)=>{
                    if (!response.ok) handleFailure();
                }).catch(()=>handleFailure());
            });
        }
        trackImage(sourceIdentifier) {
            const imageId = sourceIdentifier.split('-').pop();
            if (!imageId) return;
            const lastTracked = this.trackedImages.get(imageId);
            if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
            this.queue.add(imageId);
            this.sendDebounced();
        }
        trackWhileInViewport(element, sourceIdentifier) {
            let trackIntervalId = null;
            const observer = new IntersectionObserver((entry)=>{
                if (entry[0].isIntersecting && !trackIntervalId) {
                    $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    trackIntervalId = window.setInterval(()=>{
                        $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    }, this.trackingInterval + 10);
                } else if (trackIntervalId) window.clearInterval(trackIntervalId);
            }, {
                rootMargin: '0px',
                threshold: 1.0
            });
            observer.observe(element);
            return ()=>{
                observer.disconnect();
                if (trackIntervalId) window.clearInterval(trackIntervalId);
            };
        }
        static getInstance() {
            if (!$959ca91ba94e3a4e$var$UnsplashTracker.instance) $959ca91ba94e3a4e$var$UnsplashTracker.instance = new $959ca91ba94e3a4e$var$UnsplashTracker();
            return $959ca91ba94e3a4e$var$UnsplashTracker.instance;
        }
        constructor(){
            this.trackedImages = new Map();
            this.trackingInterval = 600000;
            this.queue = new Set();
            this.sendDebounced = (0, ($parcel$interopDefault($lFKmC)))(this.send, 1000);
        }
    }
    const $959ca91ba94e3a4e$export$1869e04dbed4c16c = $959ca91ba94e3a4e$var$UnsplashTracker.getInstance();
});
parcelRegister("azYnG", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $4rDUz = parcelRequire("4rDUz");
    var $kPZpS = parcelRequire("kPZpS");
    var $7b3c02adf390bcc6$var$nativeCeil = Math.ceil, $7b3c02adf390bcc6$var$nativeMax = Math.max;
    function $7b3c02adf390bcc6$var$chunk(array, size, guard) {
        if (guard ? $4rDUz(array, size, guard) : size === undefined) size = 1;
        else size = $7b3c02adf390bcc6$var$nativeMax($kPZpS(size), 0);
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) return [];
        var index = 0, resIndex = 0, result = Array($7b3c02adf390bcc6$var$nativeCeil(length / size));
        while(index < length)result[resIndex++] = $dM3Z8(array, index, index += size);
        return result;
    }
    module.exports = $7b3c02adf390bcc6$var$chunk;
});
parcelRegister("hxMHI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("OgDz0").then(()=>parcelRequire('gEdc8'));
});
parcelRegister("erjJQ", function(module, exports) {
    $parcel$export(module.exports, "Content", ()=>$780b11bdb912365c$export$7c6e2c02157bb7d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $7XYc4;
    var $76I3s;
    var $3HwlS;
    var $iqLcb;
    var $3Uek9;
    var $gk293;
    var $5M3R9;
    var $enQ8X;
    var $erBFB;
    var $h0PjI;
    const $780b11bdb912365c$var$SPA_TRACE_KEY = 'spa';
    const $780b11bdb912365c$var$NewContent = (props)=>{
        const { isInset: isInset, hasTheming: hasTheming } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const renderContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).MainContentSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enQ8X")).default), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "end"
        }));
        if (hasTheming) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gk293")).ThemedContentLayout), {
            appearance: isInset ? 'inset' : 'default'
        }, renderContent);
        return renderContent;
    };
    const $780b11bdb912365c$var$OldContent = (props)=>{
        const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, (0, parcelRequire("3Uek9")).useProjectTheme)();
        const renderContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("76I3s")).MainHeightFixCss), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("erBFB")).MainContentSkipLink), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqLcb")).Main), {
            id: "ak-main-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enQ8X")).default), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
            type: "end"
        })));
        if (hasProjectViewNavigation) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gk293")).ProjectThemeWrapper), {
            withWhiteBackground: isInset
        }, renderContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0PjI")).LayoutMainWrapper), null, renderContent);
    };
    const $780b11bdb912365c$export$7c6e2c02157bb7d2 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $780b11bdb912365c$var$NewContent, $780b11bdb912365c$var$OldContent);
});
parcelRegister("76I3s", function(module, exports) {
    $parcel$export(module.exports, "MainHeightFixCss", ()=>$0251eb7e80a5bbb6$export$2fcd4100c556a49e);
    var $5uXOq = parcelRequire("5uXOq");
    var $44v1T;
    const $0251eb7e80a5bbb6$export$2fcd4100c556a49e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)}) }`
            }
        });
});
parcelRegister("gk293", function(module, exports) {
    $parcel$export(module.exports, "ThemedContentLayout", ()=>$24fd52a828227843$export$c2c3c7c0b13a1f9d);
    $parcel$export(module.exports, "ProjectThemeWrapper", ()=>$24fd52a828227843$export$65c56727ada4372d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3HwlS;
    var $dCm1o;
    var $jtC5b;
    const $24fd52a828227843$var$styles = {
        rootOld: "_kqswh2mm",
        root: "_kqswh2mm _1pbyidpf",
        fullHeight: "_1tkeidpf _4t3i1osq",
        insetRoot: "_1yt4y9h4",
        insetRootVisualRefresh: "_ca0qv47k",
        insetContainer: "_2rko1gnp _bfhkp043"
    };
    const $24fd52a828227843$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && $24fd52a828227843$var$styles.root,
                !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && $24fd52a828227843$var$styles.rootOld,
                $24fd52a828227843$var$styles.fullHeight,
                appearance === 'inset' && $24fd52a828227843$var$styles.insetRoot,
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && appearance === 'inset' && $24fd52a828227843$var$styles.insetRootVisualRefresh
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $24fd52a828227843$var$styles.fullHeight,
                appearance === 'inset' && $24fd52a828227843$var$styles.insetContainer
            ])
        }, children));
    const $24fd52a828227843$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
        if (withWhiteBackground) return $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).OuterWrapperWithBackground), null, $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).InnerWrapperWithBackground), null, children));
        return $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).OuterWrapper), null, $5uXOq.createElement((0, (0, parcelRequire("jtC5b")).InnerWrapper), null, children));
    };
});
parcelRegister("jtC5b", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$c37919f3b01a53ae$export$edaaad985a878983);
    $parcel$export(module.exports, "OuterWrapperWithBackground", ()=>$c37919f3b01a53ae$export$69c6ec128d3729c9);
    $parcel$export(module.exports, "InnerWrapper", ()=>$c37919f3b01a53ae$export$f185744748c379a7);
    $parcel$export(module.exports, "InnerWrapperWithBackground", ()=>$c37919f3b01a53ae$export$2e149d12a18af14b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $cSD7y;
    var $3HwlS;
    const $c37919f3b01a53ae$var$Nav3OuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1jzz",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$var$Nav4OuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154ieda8",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$var$Nav4HighTabOuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1f46",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$edaaad985a878983 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("cSD7y")).componentWithFG)('horizontal_navigation_increase_tab_height', $c37919f3b01a53ae$var$Nav4HighTabOuterWrapper, $c37919f3b01a53ae$var$Nav4OuterWrapper), $c37919f3b01a53ae$var$Nav3OuterWrapper);
    const $c37919f3b01a53ae$export$69c6ec128d3729c9 = (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4y9h4",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$f185744748c379a7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2d3f3q3i _japi1o48 _iu1g1fl4 _fok81wug _q7c11wug",
                __cmplp.className
            ])
        });
    });
    const $c37919f3b01a53ae$export$2e149d12a18af14b = (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("enQ8X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f1817a083d388c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $gAeCk;
    var $2SVPM;
    var $gEwZr;
    const $1f1817a083d388c8$var$onSpaShellReady = ()=>{
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
    };
    const $1f1817a083d388c8$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: "JIRA_SPA_SHELL_READY",
            onSet: $1f1817a083d388c8$var$onSpaShellReady
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEwZr")).default), {
            initRoute: initRoute,
            routes: routes
        }));
    var $1f1817a083d388c8$export$2e2bcd8739ae039 = $1f1817a083d388c8$var$Spa;
});
parcelRegister("gEwZr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$308f7fd68513e9ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fq71H;
    var $8Orxo = parcelRequire("8Orxo");
    var $cgkki;
    var $hHEga;
    var $x9xyg;
    var $dJl1T;
    var $7CMCs;
    var $4R6GH;
    var $8zOmE;
    var $95EVP;
    var $2SVPM;
    var $4oDnX;
    var $6IjvB;
    var $imS60;
    var $lODMY;
    var $2Gs5h;
    var $lVJAU;
    var $gF0M5;
    var $gjcBJ;
    var $5GhjE;
    var $l9F59;
    var $i6dHx;
    var $Smjim;
    const $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF = 'OFF';
    const $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
    const $308f7fd68513e9ff$var$useRouterLocation = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.location);
    const $308f7fd68513e9ff$var$useRouterAction = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.action);
    const $308f7fd68513e9ff$var$useRouterQuery = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.query);
    const $308f7fd68513e9ff$var$useRouterRoute = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route);
    const $308f7fd68513e9ff$var$useRouterMatch = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.match);
    const $308f7fd68513e9ff$var$useRouterRoutes = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.routes);
    let $308f7fd68513e9ff$var$hasPendingForceReloadAction = false;
    const $308f7fd68513e9ff$var$getRemoteActionsRolloutStage = ()=>(0, (0, parcelRequire("4R6GH")).fg)('remote_actions_-_killswitch_-_temporary') ? $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM : $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF;
    const $308f7fd68513e9ff$export$88fe66870dd8f843 = (value)=>{
        $308f7fd68513e9ff$var$hasPendingForceReloadAction = value;
    };
    const $308f7fd68513e9ff$export$39e8f9fc07dd3395 = ()=>$308f7fd68513e9ff$var$hasPendingForceReloadAction;
    const $308f7fd68513e9ff$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
            source: 'transitionBlocker',
            actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
            frontendVersion: window.BUILD_KEY,
            currentRouteName: currentRoute?.route.name || '',
            targetRouteName: targetRoute?.route.name || '',
            remoteActionsRolloutStage: $308f7fd68513e9ff$var$getRemoteActionsRolloutStage(),
            attempts: attempts,
            lastAttemptedAt: lastAttemptedAt
        });
    const $308f7fd68513e9ff$var$updateSentryBreadcrumb = (route, nextRoute)=>{
        const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
        const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
        (0, (0, parcelRequire("fq71H")).addBreadcrumb)({
            type: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
    const $308f7fd68513e9ff$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
        (0, $5uXOq.useMemo)(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)('jira-spa/view.start');
        }, []);
        const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6IjvB")).createCheckShouldResetPage)(), []);
        const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
        }, []);
        const { registerBlock: registerBlock } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const location = $308f7fd68513e9ff$var$useRouterLocation();
        const action = $308f7fd68513e9ff$var$useRouterAction();
        const query = $308f7fd68513e9ff$var$useRouterQuery();
        const route = $308f7fd68513e9ff$var$useRouterRoute();
        const match = $308f7fd68513e9ff$var$useRouterMatch();
        const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
        if ((0, (0, parcelRequire("gF0M5")).isLazyRouteMapExperimentEnabled)()) routes = routerRoutes;
        const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, (0, parcelRequire("gjcBJ")).useShouldPerformAction)({
            actionName: 'forceReload'
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
        const [, { resetCurrentPage: resetCurrentPage }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const transitionBlocker = (0, $5uXOq.useCallback)(async (nextLocation, nextAction)=>{
            const nextMatch = (0, (0, parcelRequire("2Gs5h")).default)(routes, nextLocation.pathname, nextLocation.search);
            const canDo = (0, (0, parcelRequire("l9F59")).default)(currentMatchObjectRef.current, nextMatch);
            if ((0, (0, parcelRequire("gF0M5")).isLazyRouteMapExperimentEnabled)()) {
                if (!canDo && routes.length <= 3) await (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
                    route: nextMatch?.route.name
                });
            }
            if (!canDo) {
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
            }
            const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
            if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
                const currentMatch = currentMatchObjectRef.current;
                if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                    $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                    const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                    performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                        window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                    }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    });
                }
            }
            return canDo;
        }, [
            performAction,
            routes,
            shouldPerformAction,
            createAnalyticsEvent
        ]);
        const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
            const nextMatchObject = (0, (0, parcelRequire("2Gs5h")).default)(routes, nextLocation.pathname, nextLocation.search);
            if (nextMatchObject && match && route) {
                const { match: nextMatch, route: nextRoute } = nextMatchObject;
                const shouldReset = checkShouldResetPage({
                    nextMatch: nextMatch,
                    nextRoute: nextRoute,
                    currentMatch: match,
                    currentRoute: route,
                    action: nextAction
                });
                const nextRouteUfoName = (0, (0, parcelRequire("cgkki")).default)(nextRoute);
                if (shouldReset) {
                    resetCurrentPage(nextRouteUfoName, nextRoute.name);
                    (0, (0, parcelRequire("5GhjE")).GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
                }
                const isCurrentRouteRedirecting = route.isRedirect === true;
                if (isCurrentRouteRedirecting) {
                    const currentRouteName = (0, (0, parcelRequire("cgkki")).default)(route);
                    (0, (0, parcelRequire("hHEga")).default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
                }
            }
            $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
            return true;
        }, [
            checkShouldResetPage,
            match,
            resetCurrentPage,
            route,
            routes
        ]);
        registerBlock(transitionBlocker);
        registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
        const renderRouteComponent = (0, $5uXOq.useCallback)(()=>{
            const { component: RouteComponent, shouldCreateNestedRootTemp: shouldCreateNestedRootTemp } = route;
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira-concurrent-incremental')) {
                if (shouldCreateNestedRootTemp) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i6dHx")).ConcurrentRootComponent), null);
            }
            return RouteComponent && (0, ($parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
                location: location,
                route: route,
                match: match,
                action: action,
                query: query
            });
        }, [
            action,
            location,
            match,
            query,
            route
        ]);
        if (!(route && match)) return null;
        const { meta: meta } = route;
        const entryPoint = route.entryPoint?.();
        const { reporting: reporting } = meta || {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "route-component"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: `routeApp.${String(route.name)}`,
            packageName: "jiraSpa",
            extraEventData: {
                routeGroup: route.group ?? '',
                isSSR: false
            },
            fallback: "page",
            sendToPrivacyUnsafeSplunk: Boolean(reporting),
            ...reporting
        }, entryPoint ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Smjim")).RouteEntryPointContainer), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }) : renderRouteComponent()));
    };
    var $308f7fd68513e9ff$export$2e2bcd8739ae039 = $308f7fd68513e9ff$var$Spa;
});
parcelRegister("8Orxo", function(module, exports) {
    $parcel$export(module.exports, "addLeadingSlash", ()=>$66a85aa0db68ca7e$export$5b4913142e03bca8, (v)=>$66a85aa0db68ca7e$export$5b4913142e03bca8 = v);
    $parcel$export(module.exports, "hasBasename", ()=>$66a85aa0db68ca7e$export$10497c7ce66fcb84, (v)=>$66a85aa0db68ca7e$export$10497c7ce66fcb84 = v);
    $parcel$export(module.exports, "stripBasename", ()=>$66a85aa0db68ca7e$export$b69e3301ce081aa3, (v)=>$66a85aa0db68ca7e$export$b69e3301ce081aa3 = v);
    $parcel$export(module.exports, "stripTrailingSlash", ()=>$66a85aa0db68ca7e$export$d95b4586d238a081, (v)=>$66a85aa0db68ca7e$export$d95b4586d238a081 = v);
    $parcel$export(module.exports, "parsePath", ()=>$66a85aa0db68ca7e$export$8ccf933b0513f8d0, (v)=>$66a85aa0db68ca7e$export$8ccf933b0513f8d0 = v);
    $parcel$export(module.exports, "createPath", ()=>$66a85aa0db68ca7e$export$fe53371bee54353d, (v)=>$66a85aa0db68ca7e$export$fe53371bee54353d = v);
    var $66a85aa0db68ca7e$export$1e511d4a378977f5;
    var $66a85aa0db68ca7e$export$5b4913142e03bca8;
    var $66a85aa0db68ca7e$export$79c5b1569e3be9e6;
    var $66a85aa0db68ca7e$export$10497c7ce66fcb84;
    var $66a85aa0db68ca7e$export$b69e3301ce081aa3;
    var $66a85aa0db68ca7e$export$d95b4586d238a081;
    var $66a85aa0db68ca7e$export$8ccf933b0513f8d0;
    var $66a85aa0db68ca7e$export$fe53371bee54353d;
    'use strict';
    $66a85aa0db68ca7e$export$1e511d4a378977f5 = true;
    var $66a85aa0db68ca7e$var$addLeadingSlash = $66a85aa0db68ca7e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
        return path.charAt(0) === '/' ? path : '/' + path;
    };
    var $66a85aa0db68ca7e$var$stripLeadingSlash = $66a85aa0db68ca7e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
        return path.charAt(0) === '/' ? path.substr(1) : path;
    };
    var $66a85aa0db68ca7e$var$hasBasename = $66a85aa0db68ca7e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
        return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
    };
    var $66a85aa0db68ca7e$var$stripBasename = $66a85aa0db68ca7e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
        return $66a85aa0db68ca7e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
    };
    var $66a85aa0db68ca7e$var$stripTrailingSlash = $66a85aa0db68ca7e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
        return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
    };
    var $66a85aa0db68ca7e$var$parsePath = $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = function parsePath(path) {
        var pathname = path || '/';
        var search = '';
        var hash = '';
        var hashIndex = pathname.indexOf('#');
        if (hashIndex !== -1) {
            hash = pathname.substr(hashIndex);
            pathname = pathname.substr(0, hashIndex);
        }
        var searchIndex = pathname.indexOf('?');
        if (searchIndex !== -1) {
            search = pathname.substr(searchIndex);
            pathname = pathname.substr(0, searchIndex);
        }
        return {
            pathname: pathname,
            search: search === '?' ? '' : search,
            hash: hash === '#' ? '' : hash
        };
    };
    var $66a85aa0db68ca7e$var$createPath = $66a85aa0db68ca7e$export$fe53371bee54353d = function createPath(location) {
        var pathname = location.pathname, search = location.search, hash = location.hash;
        var path = pathname || '/';
        if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
        if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
        return path;
    };
});
parcelRegister("hHEga", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7d7ff6c8f098377$export$2e2bcd8739ae039);
    var $20wDi;
    var $iNl9c;
    var $ibksR;
    function $b7d7ff6c8f098377$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
        (0, (0, parcelRequire("ibksR")).default).current = nextUfoName;
        const interactionId = (0, (0, parcelRequire("20wDi")).DefaultInteractionID).current;
        if (interactionId) (0, (0, parcelRequire("iNl9c")).addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
    }
});
parcelRegister("6IjvB", function(module, exports) {
    $parcel$export(module.exports, "createCheckShouldResetPage", ()=>$f43999df472d4d05$export$ffb8c03de895ae3);
    var $ajpes = parcelRequire("ajpes");
    var $65Ltd;
    var $vrkiK;
    const $f43999df472d4d05$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR);
    const $f43999df472d4d05$export$ffb8c03de895ae3 = ()=>{
        let rapidBoardPaths = [];
        return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
            let shouldReset = true;
            if ($f43999df472d4d05$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
            else {
                const cleanMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(currentMatch, currentRoute);
                const cleanNextMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(nextMatch, nextRoute);
                shouldReset = !(0, ($parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch) && shouldReset;
                if (shouldReset) {
                    const [paths, resetBoolean] = (0, (0, parcelRequire("vrkiK")).calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                    rapidBoardPaths = paths;
                    if ((0, (0, parcelRequire("vrkiK")).isValidRoute)(nextRoute) || nextRoute.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE)) shouldReset = !resetBoolean;
                }
            }
            return shouldReset;
        };
    };
});
parcelRegister("vrkiK", function(module, exports) {
    $parcel$export(module.exports, "calcRapidBoardResetState", ()=>$fd0af9cf1691807e$export$2350ed3ff6c1a082);
    $parcel$export(module.exports, "getApdexMatchObject", ()=>$fd0af9cf1691807e$export$47e434f08768932b);
    $parcel$export(module.exports, "calcRapidBoardResetStateV2", ()=>$fd0af9cf1691807e$export$dbd9185166d0d04c);
    $parcel$export(module.exports, "isValidRoute", ()=>$fd0af9cf1691807e$export$9f3e656a7f6a3adc);
    var $65Ltd;
    const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
                ];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    resetDone = false;
                    break;
                }
                if (!useStoredSettings && rapidBoardPaths.indexOf((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
                rapidBoardPaths = [];
                break;
            default:
                resetDone = false;
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
        let cleanMatch = {
            ...match,
            params: {
                ...match.params
            },
            query: {
                ...match.query
            }
        };
        if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
            const { params: params, query: query } = match;
            const paramKeys = params && Object.keys(params);
            const queryKeys = query && Object.keys(query);
            const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
            const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
            if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
            if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
        });
        if (match.query && match.query.view && match.query.view === 'detail') cleanMatch.query.view = undefined;
        if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
        cleanMatch = {
            ...cleanMatch,
            url: ''
        };
        return cleanMatch;
    };
    const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                    resetDone = true;
                    rapidBoardPaths = [];
                    break;
                } else if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    break;
                } else {
                    rapidBoardPaths = [];
                    break;
                }
            default:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                    resetDone = true;
                    rapidBoardPaths = [];
                }
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
        if (state) {
            const { currentPage: currentPage, visitedPages: visitedPages } = state;
            const visitedPageLength = visitedPages.length;
            if (currentPage && currentPage.apps[appId]) return true;
            if (visitedPageLength === 0 || searchDepth <= 0) return false;
            for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
                if (visitedPages[visitedPageLength - i].apps[appId]) return true;
            }
        }
        return false;
    };
    const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
        switch(routeToCheck.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                return true;
            default:
                return false;
        }
    };
});
parcelRegister("gjcBJ", function(module, exports) {
    $parcel$export(module.exports, "useShouldPerformAction", ()=>$203d1f884e0bc0b1$export$1bfa74483a8ca772);
    var $5uXOq = parcelRequire("5uXOq");
    var $6TLwF;
    var $7Iueo;
    const $203d1f884e0bc0b1$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
        const metas = (0, (0, parcelRequire("6TLwF")).useMeta)();
        const remoteActions = (0, (0, parcelRequire("6TLwF")).useRemoteActionsData)();
        const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, (0, parcelRequire("6TLwF")).useRemoteActionsStoreActions)();
        const [actionToPerform, setActionToPerform] = (0, $5uXOq.useState)();
        const [shouldPerformAction, setShouldPerformAction] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const matchedAction = Object.values(remoteActions).find((action)=>{
                if (action.name !== actionName) return false;
                return true;
            });
            if (!matchedAction) return;
            setActionToPerform(matchedAction);
            setShouldPerformAction((0, (0, parcelRequire("7Iueo")).computeShouldPerformAction)(matchedAction, metas));
        }, [
            actionName,
            remoteActions,
            metas
        ]);
        const performAction = (onSuccess, onCancel)=>{
            if (!actionToPerform) return;
            const metaForAnalytics = {
                attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
                lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
            };
            if (shouldPerformAction) onSuccess(actionToPerform, metaForAnalytics);
            else onCancel(actionToPerform, metaForAnalytics);
            saveActionPerformedAttempt(actionToPerform.id);
            setShouldPerformAction(false);
        };
        return {
            shouldPerformAction: shouldPerformAction,
            performAction: performAction
        };
    };
});
parcelRegister("6TLwF", function(module, exports) {
    $parcel$export(module.exports, "RemoteActionsContainer", ()=>$f344b0bbacd45622$export$28c2e4c663a86266);
    $parcel$export(module.exports, "useRemoteActions", ()=>$f344b0bbacd45622$export$333357b3de3e67a0);
    $parcel$export(module.exports, "useRemoteActionsData", ()=>$f344b0bbacd45622$export$3cc006661ae2a759);
    $parcel$export(module.exports, "useMeta", ()=>$f344b0bbacd45622$export$3fb9275d3845bd5a);
    $parcel$export(module.exports, "useRemoteActionsStoreActions", ()=>$f344b0bbacd45622$export$3fd21eaf97df4718);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $jOqMN;
    var $2Dh5F;
    if (!Object.isFrozen((0, (0, parcelRequire("jOqMN")).default))) (0, (0, parcelRequire("jOqMN")).default).devtools = false;
    const $f344b0bbacd45622$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            meta: {},
            remoteActions: {},
            lastUpdatedAt: 0,
            isLoaded: false,
            product: undefined
        },
        actions: (0, parcelRequire("2Dh5F")).actions,
        name: 'remoteActionsStore'
    });
    const $f344b0bbacd45622$export$28c2e4c663a86266 = (0, (0, parcelRequire("gg7kZ")).createContainer)($f344b0bbacd45622$var$Store, {
        onInit: ()=>({ dispatch: dispatch })=>{
                dispatch((0, (0, parcelRequire("2Dh5F")).actions).initStore());
            }
    });
    const $f344b0bbacd45622$export$333357b3de3e67a0 = (selector)=>(0, (0, parcelRequire("3sQ5x")).createHook)($f344b0bbacd45622$var$Store, {
            selector: selector
        })();
    const $f344b0bbacd45622$export$3cc006661ae2a759 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f344b0bbacd45622$var$Store, {
        selector: (state)=>state.remoteActions
    });
    const $f344b0bbacd45622$export$3fb9275d3845bd5a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f344b0bbacd45622$var$Store, {
        selector: (state)=>state.meta
    });
    const $f344b0bbacd45622$export$3fd21eaf97df4718 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f344b0bbacd45622$var$Store);
});
parcelRegister("2Dh5F", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$1c14deb470e4895c$export$e324594224ef24da);
    var $9YP96;
    var $ljS6P;
    var $7sH6d;
    var $7NaEO;
    const $1c14deb470e4895c$export$e324594224ef24da = {
        processRemoteActions: (0, parcelRequire("7sH6d")).processRemoteActions,
        saveActionPerformedAttempt: (0, parcelRequire("7NaEO")).saveActionPerformedAttempt,
        initStore: (0, parcelRequire("ljS6P")).initStore,
        clearActionId: (0, parcelRequire("9YP96")).clearActionId
    };
});
parcelRegister("9YP96", function(module, exports) {
    $parcel$export(module.exports, "clearActionId", ()=>$e74c529bc810844d$export$8d8b492eefa9efba);
    var $avXSE;
    const $e74c529bc810844d$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
            const { meta: meta } = getState();
            const newMeta = {
                ...meta
            };
            delete newMeta[actionId];
            setState({
                meta: newMeta
            });
            (0, (0, parcelRequire("avXSE")).writeRemoteActionsMetasToLocalStorage)(product, meta);
        };
});
parcelRegister("avXSE", function(module, exports) {
    $parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", ()=>$70b78e261d4e3a76$export$a221266a05084986);
    $parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", ()=>$70b78e261d4e3a76$export$7228aaade919a8b6);
    const $70b78e261d4e3a76$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
    const $70b78e261d4e3a76$export$a221266a05084986 = (product)=>{
        try {
            return JSON.parse(localStorage.getItem(`${$70b78e261d4e3a76$export$b9e25d3c75cffd71}.${product}`) || '{}');
        } catch (e) {
            console.warn('Could not load from localStorage', e);
            return {};
        }
    };
    const $70b78e261d4e3a76$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
        try {
            localStorage.setItem(`${$70b78e261d4e3a76$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
        } catch (e) {
            console.warn('Could not load from localStorage', e);
        }
    };
});
parcelRegister("ljS6P", function(module, exports) {
    $parcel$export(module.exports, "initStore", ()=>$2154deaeeecd63bd$export$41f27b3823a442c6);
    var $avXSE;
    const $2154deaeeecd63bd$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
            setState({
                meta: (0, (0, parcelRequire("avXSE")).readRemoteActionsMetasFromLocalStorage)(product),
                isLoaded: true,
                product: product
            });
        };
});
parcelRegister("7sH6d", function(module, exports) {
    $parcel$export(module.exports, "processRemoteActions", ()=>$235a97ca8be4c70f$export$15e69d1dd38ccaa3);
    var $cXxJR;
    const $235a97ca8be4c70f$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
            const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
            if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) return;
            const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
                if ((0, (0, parcelRequire("cXxJR")).shouldProcessRemoteAction)(remoteAction)) {
                    const shouldAddAction = remoteAction.conditions.every((condition)=>(0, (0, parcelRequire("cXxJR")).isActionConditionSatisfied)(productData, condition));
                    if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
                }
                return updatedRemoteActions;
            }, {});
            setState({
                meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                    newMeta[id] = meta[id];
                    return newMeta;
                }, {}),
                remoteActions: remoteActions,
                lastUpdatedAt: Date.now()
            });
        };
});
parcelRegister("cXxJR", function(module, exports) {
    $parcel$export(module.exports, "isActionConditionSatisfied", ()=>$b093de9679d7059a$export$9262d8191a70c677);
    $parcel$export(module.exports, "shouldProcessRemoteAction", ()=>$b093de9679d7059a$export$c7cc93192d09a3d7);
    var $5YPeh;
    const $b093de9679d7059a$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
    const $b093de9679d7059a$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
    const $b093de9679d7059a$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
        try {
            const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
            const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
            const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
            if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
            if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
        } catch (error) {
            console.warn('error while parsing a build key', error);
        }
        return false;
    };
    const $b093de9679d7059a$export$9262d8191a70c677 = (productData, condition)=>{
        switch(condition.type){
            case (0, (0, parcelRequire("5YPeh")).ConditionType).buildRange:
                return $b093de9679d7059a$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
            case (0, (0, parcelRequire("5YPeh")).ConditionType).featureFlag:
                return $b093de9679d7059a$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
            case (0, (0, parcelRequire("5YPeh")).ConditionType).featureGate:
                return $b093de9679d7059a$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
            default:
                return false;
        }
    };
    const $b093de9679d7059a$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;
});
parcelRegister("5YPeh", function(module, exports) {
    $parcel$export(module.exports, "ConditionType", ()=>$b2d65005e49a8c6a$export$748d1c753cdf4bfd);
    var $b2d65005e49a8c6a$export$748d1c753cdf4bfd;
    (function(ConditionType) {
        ConditionType["featureFlag"] = "featureFlag";
        ConditionType["featureGate"] = "featureGate";
        ConditionType["buildRange"] = "buildRange";
    })($b2d65005e49a8c6a$export$748d1c753cdf4bfd || ($b2d65005e49a8c6a$export$748d1c753cdf4bfd = {}));
});
parcelRegister("7NaEO", function(module, exports) {
    $parcel$export(module.exports, "saveActionPerformedAttempt", ()=>$4a91b3fd9de43630$export$e3144a2e886e0e77);
    var $avXSE;
    const $4a91b3fd9de43630$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
            const { meta: meta, product: product } = getState();
            const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
            const updatedMetas = {
                ...meta,
                [actionId]: {
                    lastPerformAttemptedAt: Date.now(),
                    attemptCounts: currentAttemptCount + 1
                }
            };
            setState({
                meta: updatedMetas
            });
            if (!product) throw new Error('Product is not defined.');
            (0, (0, parcelRequire("avXSE")).writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
        };
});
parcelRegister("7Iueo", function(module, exports) {
    $parcel$export(module.exports, "computeShouldPerformAction", ()=>$3a8c1c75c9f55ebb$export$6e0db227c9674096);
    const $3a8c1c75c9f55ebb$export$50dbcb44bba3aa5c = 60;
    const $3a8c1c75c9f55ebb$export$b21f5a6e7051e2c2 = (actionMetas)=>{
        const now = Date.now();
        const timeDiff = now - actionMetas.lastPerformAttemptedAt;
        return timeDiff > $3a8c1c75c9f55ebb$export$50dbcb44bba3aa5c * 1000;
    };
    const $3a8c1c75c9f55ebb$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $f672cf41535cb88a$export$f2c0b74311ada874);
    const $3a8c1c75c9f55ebb$export$6e0db227c9674096 = (action, metas)=>{
        const actionMetas = metas[action.id];
        if (!actionMetas) return true;
        if (!$3a8c1c75c9f55ebb$export$6c7cf2cb7d75fad3(actionMetas)) return false;
        if (!$3a8c1c75c9f55ebb$export$b21f5a6e7051e2c2(actionMetas)) return false;
        return true;
    };
});
const $f672cf41535cb88a$export$f2b2f5ef0b498d26 = 5000;
const $f672cf41535cb88a$export$f2c0b74311ada874 = 3;
const $f672cf41535cb88a$export$af2ff676951003fe = 60000;
const $f672cf41535cb88a$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';
parcelRegister("l9F59", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c27c60eec62bb2f2$export$2e2bcd8739ae039);
    var $ajpes = parcelRequire("ajpes");
    const $c27c60eec62bb2f2$var$transitionValidator = (currentMatch, nextMatch)=>{
        if (!currentMatch) return true;
        if (!nextMatch) return false;
        const isSameRoute = currentMatch.route === nextMatch.route;
        const isSameMatch = (0, ($parcel$interopDefault($ajpes)))(currentMatch.match, nextMatch.match);
        if (isSameRoute && isSameMatch) return true;
        const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
        if (canDoNext) return true;
        return false;
    };
    var $c27c60eec62bb2f2$export$2e2bcd8739ae039 = $c27c60eec62bb2f2$var$transitionValidator;
});
parcelRegister("i6dHx", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentRootComponent", ()=>$1fd1d5f168f244bb$export$3224d596e9b1971);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUr4d = parcelRequire("kUr4d");
    var $gG5I6;
    var $4R6GH;
    var $lODMY;
    var $29g8C;
    const $1fd1d5f168f244bb$var$useRouterLocation = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.location);
    const $1fd1d5f168f244bb$var$useRouterAction = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.action);
    const $1fd1d5f168f244bb$var$useRouterQuery = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.query);
    const $1fd1d5f168f244bb$var$useRouterRoute = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.route);
    const $1fd1d5f168f244bb$var$useRouterMatch = (0, (0, parcelRequire("lODMY")).createRouterSelector)((state)=>state.match);
    const $1fd1d5f168f244bb$var$RouteComponentWithRouterProps = ()=>{
        const location = $1fd1d5f168f244bb$var$useRouterLocation();
        const action = $1fd1d5f168f244bb$var$useRouterAction();
        const query = $1fd1d5f168f244bb$var$useRouterQuery();
        const route = $1fd1d5f168f244bb$var$useRouterRoute();
        const match = $1fd1d5f168f244bb$var$useRouterMatch();
        const { component: RouteComponent } = route;
        return RouteComponent && (0, ($parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        });
    };
    function $1fd1d5f168f244bb$export$3224d596e9b1971() {
        const containerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!containerRef.current) throw new Error('ref is not set');
            const root = (0, $kUr4d.createRoot)(containerRef.current);
            root.render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gG5I6")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($1fd1d5f168f244bb$var$RouteComponentWithRouterProps, null), (0, (0, parcelRequire("4R6GH")).fg)('concurrent-rendering-change-advisory') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29g8C")).ConcurrentAdvisory), null) : null));
            return ()=>{
                setTimeout(()=>{
                    root.unmount();
                });
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "concurrent-route-component",
            ref: containerRef
        });
    }
});
parcelRegister("gG5I6", function(module, exports) {
    $parcel$export(module.exports, "JiraContextContainer", ()=>$2e767f203a33f0d2$export$6f7845cc5e693f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $lRFpu;
    var $lzeFL;
    var $5tsrJ;
    var $jb5yn;
    var $j8DrX;
    var $1nUas;
    var $2HbP2;
    var $8ApFP;
    var $iXVV6;
    var $fiv1r;
    var $14XJw;
    var $9OXo1;
    var $a83ud;
    const $2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, children);
    const $2e767f203a33f0d2$export$6f7845cc5e693f16 = (props)=>{
        const state = {
            messages: (parcelRequire("hWnRN"))
        };
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
                messages: state.messages,
                locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(tenantContext.locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
                orgId: orgId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jb5yn")).ExperienceTrackerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, props.children)))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a83ud")).LoadingPhaseManager), null));
    };
});
parcelRegister("a83ud", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $clxrE;
    const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
        const { startNextPhase: startNextPhase } = (0, (0, parcelRequire("clxrE")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (__SPA__) return;
            setTimeout(()=>{
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            }, 2000);
        }, [
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("hWnRN", function(module, exports) {
    module.exports = __LANG;
});
parcelRegister("29g8C", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentAdvisory", ()=>$3f6cbe094065dc4a$export$e7a8408a6ddec2cb);
    var $5uXOq = parcelRequire("5uXOq");
    function $3f6cbe094065dc4a$export$e7a8408a6ddec2cb(props) {
        const { consoleMessage: consoleMessage = 'This route is being rendered with React concurrent rendering go/r18' } = props;
        const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $5uXOq.useState)(true);
        (0, $5uXOq.useEffect)(()=>{
            console.log(`%c\u{203C}\u{FE0F} ${consoleMessage} \u{203C}\u{FE0F}
If you encounter any problems, report them to https://atlassian.enterprise.slack.com/archives/C06176WU6PQ`, 'color: white; background: darkred; font-size: 16px; padding: 4px');
            const timer = setTimeout(()=>{
                setIsAdvisoryVisible(false);
            }, 5000);
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            consoleMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                position: 'absolute',
                left: 8,
                top: 12,
                display: 'flex',
                alignItems: 'center',
                height: 0,
                overflow: 'visible',
                pointerEvents: 'none'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                backgroundColor: isAdvisoryVisible ? 'white' : 'red',
                borderRadius: '50%',
                width: 8,
                height: 8,
                zIndex: 20
            }
        }), isAdvisoryVisible && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                backgroundColor: 'red',
                color: 'white',
                height: '1.5em',
                marginLeft: -12,
                paddingLeft: 16,
                paddingRight: 8,
                borderRadius: 4,
                zIndex: 10
            }
        }, "Rendered in React concurrent mode go/r18"));
    }
});
parcelRegister("Smjim", function(module, exports) {
    $parcel$export(module.exports, "RouteEntryPointContainer", ()=>$813341ccf863a0ac$export$3e4cdfb894377bc9);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $dJl1T;
    var $2Ioew;
    var $frBVt;
    var $7LpuY;
    var $dZw8H;
    const $813341ccf863a0ac$var$LOCATION = 'route-entry-point-container';
    const $813341ccf863a0ac$export$fb85bbdbfb3e6869 = ()=>null;
    const $813341ccf863a0ac$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
        const entryPoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        const entryPointReference = (0, (0, parcelRequire("2Ioew")).usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48));
        const Skeleton = route.skeleton || $813341ccf863a0ac$export$fb85bbdbfb3e6869;
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($813341ccf863a0ac$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        if (!entryPointReference || !entryPoint) return null;
        let pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else pageId = route.pageId;
        }
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
            name: "route_entry_point_redirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
            name: "route_entry_point"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        }))));
    };
});
parcelRegister("h0PjI", function(module, exports) {
    $parcel$export(module.exports, "LayoutMainWrapper", ()=>$571ff4fe4ca2a221$export$712225703044cda);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $571ff4fe4ca2a221$export$712225703044cda = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5eQ1m", function(module, exports) {
    $parcel$export(module.exports, "StrictMode", ()=>$64cfd661e498c7fe$export$5f8d39834fd61797);
    var $5uXOq = parcelRequire("5uXOq");
    const $64cfd661e498c7fe$export$5f8d39834fd61797 = ({ children: children })=>{
        const isStrictModeDisabled = false;
        if (isStrictModeDisabled) return children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).StrictMode, null, children);
    };
});
parcelRegister("81ezV", function(module, exports) {
    $parcel$export(module.exports, "JiraRouterLinkConfiguration", ()=>$33ea5bfeb747665b$export$a580704a2f3cfca);
    var $5uXOq = parcelRequire("5uXOq");
    var $hDzhb;
    const $33ea5bfeb747665b$export$a580704a2f3cfca = (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
        if (!href || typeof href === 'string') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ref: ref,
            href: href || '#',
            ...rest
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ref: ref,
            href: href.href,
            to: href.to,
            replace: href.replace,
            params: href.params,
            query: href.query,
            prefetch: href.prefetch,
            ...rest
        }, children);
    });
});
parcelRegister("b7awD", function(module, exports) {
    $parcel$export(module.exports, "Router", ()=>$87aa2fd82c8be71a$export$55185c17a0fcbe46);
    var $5uXOq = parcelRequire("5uXOq");
    var $hcRPK;
    var $d8orV;
    const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
        const pluginsWithOverride = (0, (0, parcelRequire("d8orV")).usePlugins)({
            resourceContext: props.resourceContext,
            resourceData: props.resourceData
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcRPK")).Router), {
            plugins: pluginsWithOverride,
            ...props
        }, children);
    };
});
parcelRegister("d8orV", function(module, exports) {
    $parcel$export(module.exports, "usePlugins", ()=>$0614c9d3afc2dd7f$export$c41e96fd89bc6106);
    var $5uXOq = parcelRequire("5uXOq");
    var $a2g00;
    var $5yJb9;
    var $9OXo1;
    var $8Y8sk;
    const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
            const jiraPlugins = [];
            const resourcesPlugin = (0, (0, parcelRequire("8Y8sk")).createResourcesPlugin)({
                context: resourceContext,
                resourceData: resourceData
            });
            jiraPlugins.push(resourcesPlugin);
            jiraPlugins.push((0, (0, parcelRequire("a2g00")).createEntryPointsPlugin)({
                environment: (0, (0, parcelRequire("5yJb9")).default)(),
                entryPointParams: {
                    tenantContext: tenantContext
                }
            }));
            return jiraPlugins;
        });
        return pluginsWithOverride;
    };
});
parcelRegister("a2g00", function(module, exports) {
    $parcel$export(module.exports, "createEntryPointsPlugin", ()=>$e3cbf02360bc6f96$export$33586718f82f356f);
    var $8Uumt = parcelRequire("8Uumt");
    var $3gC8D;
    var $3I4nj;
    var $ktB2C;
    const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
            id: 'entry-points-plugin',
            routeLoad: ({ context: context })=>{
                const entryPoint = context.route.entryPoint?.();
                const prefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                let entryPointReference = null;
                if (entryPoint) {
                    if (prefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prefetchingRoute.routerContext.match,
                        nextContextMatch: context.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                    else entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: context,
                        ...entryPointParams
                    });
                }
                (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setLastLoadedRoute({
                    route: context.route,
                    entryPointReference: entryPointReference
                });
                return {
                    entryPoint: entryPointReference
                };
            },
            routePrefetch: ({ nextContext: nextContext })=>{
                const entryPoint = nextContext.route.entryPoint?.();
                if (entryPoint) {
                    const prevPrefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                    if (prevPrefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prevPrefetchingRoute.routerContext.match,
                        nextContextMatch: nextContext.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prevPrefetchingRoute.expiresAt)) return;
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: nextContext,
                        ...entryPointParams
                    });
                    (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                        routerContext: nextContext,
                        expiresAt: (0, (0, parcelRequire("3gC8D")).getExpiresAt)(),
                        entryPointReference: entryPointReference
                    });
                } else (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: 0,
                    entryPointReference: null
                });
            },
            waitForEntryPoint: ()=>{
                const lastLoadedRoute = (0, (0, parcelRequire("3I4nj")).getLastLoadedRoute)();
                const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
                if (entryPointReference) return (0, (0, parcelRequire("ktB2C")).waitForEntryPoint)(entryPointReference);
                return Promise.resolve();
            }
        });
});
parcelRegister("3gC8D", function(module, exports) {
    $parcel$export(module.exports, "getExpiresAt", ()=>$f48ce76f20803aec$export$b65d7ba7fbf150f1);
    $parcel$export(module.exports, "isExpired", ()=>$f48ce76f20803aec$export$57947cfd429801a2);
    $parcel$export(module.exports, "isSameRouteMatch", ()=>$f48ce76f20803aec$export$5997e70fc4543270);
    const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
    const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
    const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
    const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
        const objKeys1 = Object.keys(o1);
        const objKeys2 = Object.keys(o2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>o1[key] === o2[key]);
    };
    const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
});
parcelRegister("ktB2C", function(module, exports) {
    $parcel$export(module.exports, "waitForEntryPoint", ()=>$67d2b262678828c6$export$944f853f194e5dd5);
    var $kipqU;
    const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
        const promises = [];
        try {
            entryPointConfig.getComponent();
        } catch (err) {
            if (err instanceof Promise) promises.push(err);
            else throw err;
        }
        const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) {
                const queryPromise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(String(queries[key].id));
                if (queryPromise) promises.push(queryPromise);
            }
        });
        if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
            const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
            promises.push(nestedEntryPointPromise);
        });
        return Promise.allSettled(promises);
    };
});
parcelRegister("8Y8sk", function(module, exports) {
    $parcel$export(module.exports, "createResourcesPlugin", ()=>$d3b2f44f58ee61bb$export$23ed892c481a96fe);
    var $8fYaK;
    var $4CEu1;
    const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
    const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
        const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
        return Promise.all(requestResources(nextResources, context, {}));
    };
    const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
        const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
        cleanExpiredResources(nextResources, nextContext);
    };
    const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
        let latestLoadedResources = Promise.resolve([]);
        (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.hydrate({
            resourceContext: initialResourceContext,
            resourceData: initialResourceData
        });
        return {
            id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
            beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
            routeLoad: ({ context: context, prevContext: prevContext })=>{
                const { route: route, match: match, query: query } = context;
                if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
                else latestLoadedResources = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.requestAllResources({
                    route: route,
                    match: match,
                    query: query
                }, {
                    timeout: timeout
                });
            },
            routePrefetch: ({ context: context, nextContext: nextContext })=>{
                const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
                const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
                return {
                    resources: prefetchResources(nextResources, nextContext, {})
                };
            },
            getLatestResources: ()=>latestLoadedResources,
            getSerializedResources: async ()=>{
                await latestLoadedResources;
                return (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.getSafeData();
            }
        };
    };
});
parcelRegister("4CEu1", function(module, exports) {
    $parcel$export(module.exports, "getResourcesForNextLocation", ()=>$448a0fea894dd469$export$7cbbc763e2f3d65d);
    var $9KbzN;
    var $dj41J;
    const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
        const { route: prevRoute } = prevRouterStoreContext;
        const { resources: prevResources = [] } = prevRoute || {};
        const { route: nextRoute } = nextRouterStoreContext;
        const { resources: nextResources = [] } = nextRoute || {};
        if (!(0, (0, parcelRequire("dj41J")).routeHasResources)(nextRoute)) return [];
        if ((0, (0, parcelRequire("dj41J")).routeHasChanged)(prevRoute, nextRoute)) return nextResources;
        const prevResourceIdentifiers = (0, (0, parcelRequire("9KbzN")).getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
        return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, (0, parcelRequire("9KbzN")).getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
    };
});
parcelRegister("9KbzN", function(module, exports) {
    $parcel$export(module.exports, "getResourceIdentifier", ()=>$82cfa1d66d41fab5$export$c616b176adf9ad4a);
    $parcel$export(module.exports, "getResourceIdentifiers", ()=>$82cfa1d66d41fab5$export$cd7fbe7e979df558);
    const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
        const { type: type, getKey: getKey } = resource;
        const key = getKey(routerStoreContext, resourceStoreContext);
        return `${type}/${key}`;
    };
    const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
});
parcelRegister("dj41J", function(module, exports) {
    $parcel$export(module.exports, "routeHasResources", ()=>$9c8422e0259b24f6$export$740886389191c640);
    $parcel$export(module.exports, "routeHasChanged", ()=>$9c8422e0259b24f6$export$221027ff1aa38f82);
    const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
    const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
});
parcelRegister("d1K1f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fffa056866f763fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $6vAaw = parcelRequire("6vAaw");
    var $gccSB = parcelRequire("gccSB");
    var $6YRTH;
    var $j8DrX;
    var $1bQGJ;
    var $TtQEC;
    var $7IBED;
    var $5Jsi2;
    const $fffa056866f763fb$var$sessionQueryParams = [
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ];
    const $fffa056866f763fb$var$sessionMeta = [
        'ajs-search-session-id',
        'ajs-search-object-id',
        'ajs-search-container-id',
        'ajs-search-content-type'
    ];
    const $fffa056866f763fb$var$removeDwellComponent = (placeholderId)=>{
        if (placeholderId && document.getElementById(placeholderId)) (0, $7nsd3.unmountComponentAtNode)(document.getElementById(placeholderId));
    };
    const $fffa056866f763fb$var$removeSessionMeta = ()=>$fffa056866f763fb$var$sessionMeta.forEach((0, (0, parcelRequire("7IBED")).removeMetaTag));
    const $fffa056866f763fb$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
        const newMeta = {
            'ajs-search-session-id': sessionId,
            'ajs-search-object-id': objectId,
            'ajs-search-container-id': containerId,
            'ajs-search-content-type': objectType
        };
        Object.entries(newMeta).forEach(([name, content])=>(0, (0, parcelRequire("7IBED")).addMetaTag)(name, content));
    };
    const $fffa056866f763fb$var$getPreviousSessionId = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
    class $fffa056866f763fb$export$f1e582dddb502dd6 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.onClearSessionEvent = ()=>{
                if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                    shouldRemoveSessionBeIgnored: false
                });
            }, this.onHistoryChange = (location)=>{
                $fffa056866f763fb$var$removeDwellComponent('search-dwell-time');
                const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(location.pathname + location.search, true);
                const queryString = parsedUrl.query || {};
                const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
                const { path: path } = parsedUrl;
                const previousSessionId = $fffa056866f763fb$var$getPreviousSessionId();
                const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
                if (!(0, ($parcel$interopDefault($gccSB)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $fffa056866f763fb$var$removeSessionMeta();
                if (searchSessionId) {
                    (0, (0, parcelRequire("6YRTH")).default)($fffa056866f763fb$var$sessionQueryParams);
                    const newState = {
                        sessionId: searchSessionId,
                        objectId: searchObjectId,
                        objectType: searchContentType,
                        containerId: searchContainerId,
                        previousSessionId: $fffa056866f763fb$var$getPreviousSessionId()
                    };
                    $fffa056866f763fb$var$addSessionMeta(newState);
                    const shouldRemoveSession = !!(0, (0, parcelRequire("5Jsi2")).skipClearSessionURLs).find((skipUrlRegex)=>!(0, ($parcel$interopDefault($gccSB)))(path) ? skipUrlRegex.test(path) : false);
                    this.setState({
                        ...newState,
                        shouldRemoveSessionBeIgnored: shouldRemoveSession
                    });
                }
            };
            this.props.history.listen(this.onHistoryChange);
            this.state = {
                shouldRemoveSessionBeIgnored: false,
                sessionId: ''
            };
        }
        componentDidMount() {
            window.addEventListener((0, (0, parcelRequire("5Jsi2")).CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        componentWillUnmount() {
            window.removeEventListener((0, (0, parcelRequire("5Jsi2")).CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        render() {
            if (this.state && this.state.sessionId) {
                const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
                const data = {
                    objectId: objectId,
                    containerId: containerId,
                    objectType: objectType,
                    source: objectType,
                    actionSubject: objectType,
                    attributes: {
                        previousSessionId: previousSessionId
                    }
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
                    sessionId: sessionId,
                    data: data
                });
            }
            return null;
        }
    }
    var $fffa056866f763fb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)($fffa056866f763fb$export$f1e582dddb502dd6);
});
parcelRegister("6YRTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3bd6eeaf3add142$export$2e2bcd8739ae039);
    var $6vAaw = parcelRequire("6vAaw");
    var $fr1K2 = parcelRequire("fr1K2");
    var $e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
        try {
            const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(window.location.href, true);
            const strippedQuery = (0, ($parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
            let strippedUrl = (0, ($parcel$interopDefault($6vAaw))).format({
                ...parsedUrl,
                search: undefined,
                query: strippedQuery
            });
            const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
            if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
            window.history.replaceState({}, '', strippedUrl);
        } catch (e) {}
    };
});
parcelRegister("TtQEC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8ee37fd26b4ccf1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $jzjy1;
    var $jD5no;
    var $l7nSX;
    const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("jzjy1")).AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, (0, parcelRequire("jzjy1")).AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, (0, parcelRequire("l7nSX")).default));
    class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props) {
            const { data: data } = props;
            return {
                DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
            };
        }
        constructor(props){
            super(props);
            this.state = {
                DwellTimeComponent: null
            };
        }
        render() {
            const { sessionId: sessionId, data: data } = this.props;
            const { DwellTimeComponent: DwellTimeComponent } = this.state;
            const enrichedData = {
                ...data,
                source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
                actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
            };
            if (sessionId && DwellTimeComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
                sessionId: sessionId,
                data: enrichedData
            }));
            return null;
        }
    }
});
parcelRegister("l7nSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c5cee06f4a100e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fCuES;
    var $8oe80;
    var $hhweD;
    class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { data: data, sessionId: sessionId } = this.props;
            this.dwellHelper = new (0, (0, parcelRequire("fCuES")).default)(this.sendDwellEvent, data, sessionId);
            this.dwellHelper.start();
        }
        componentDidUpdate(oldProps) {
            if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) this.dwellHelper.newPage(this.props.data, this.props.sessionId);
        }
        componentWillUnmount() {
            if (this.dwellHelper) {
                this.dwellHelper.stop();
                this.dwellHelper.destroy();
            }
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
        }
        constructor(...args){
            super(...args), this.sendDwellEvent = (payload)=>(0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
        }
    }
    var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('dwellTime', {
        onDwell: 'dwelled'
    })($8c5cee06f4a100e3$export$1c7ccff61c195c75);
});
parcelRegister("hhweD", function(module, exports) {
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$a4297ed46523d116$export$13990ad4625571ed);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
    const $a4297ed46523d116$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { action: action, actionSubjectId: actionSubjectId } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            action: action,
            actionSubjectId: actionSubjectId
        }, $a4297ed46523d116$var$isNotUndefined);
    };
    const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
        event.update({
            ...$a4297ed46523d116$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).TRACK_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("7IBED", function(module, exports) {
    $parcel$export(module.exports, "addMetaTag", ()=>$751334a79f9a31ee$export$c79fd820617d7f);
    $parcel$export(module.exports, "removeMetaTag", ()=>$751334a79f9a31ee$export$4267657a25105d9d);
    const $751334a79f9a31ee$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $751334a79f9a31ee$var$getHead = ()=>document.head || document.querySelector('head');
    const $751334a79f9a31ee$export$c79fd820617d7f = (name, content)=>{
        if (!name || !content) return;
        const existingMeta = $751334a79f9a31ee$export$c9d44c736471c518(name);
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = content;
        if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
        else {
            const head = $751334a79f9a31ee$var$getHead();
            if (head) head.appendChild(meta);
        }
    };
    const $751334a79f9a31ee$export$4267657a25105d9d = (name)=>{
        const meta = $751334a79f9a31ee$export$c9d44c736471c518(name);
        if (meta) meta.parentNode?.removeChild(meta);
    };
});
parcelRegister("5Jsi2", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_SEARCH_SESSION", ()=>$65e6525a854bf206$export$b669eaa3e4786d5c);
    $parcel$export(module.exports, "skipClearSessionURLs", ()=>$65e6525a854bf206$export$c092460ed33e0e35);
    const $65e6525a854bf206$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
    const $65e6525a854bf206$export$c092460ed33e0e35 = [
        /.*RapidBoard.jspa.*/,
        /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
        /\/jira\/people\/.*\/boards\/.*/
    ];
});
parcelRegister("fGcGc", function(module, exports) {
    $parcel$export(module.exports, "addInitialPageLoadTimings", ()=>$e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed);
    var $2SVPM;
    const $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed = ()=>{
        if (false) return;
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    };
});
parcelRegister("bShz7", function(module, exports) {
    $parcel$export(module.exports, "setPrefetchStartMark", ()=>$fd73e472799b8227$export$405fde3eab8e39f6);
    $parcel$export(module.exports, "getPrefetchStartMark", ()=>$fd73e472799b8227$export$cbaceb7ffa84279);
    $parcel$export(module.exports, "clearPrefetchStartMarks", ()=>$fd73e472799b8227$export$d6b0928f07bafe57);
    const $fd73e472799b8227$var$prefetchTiming = new Map();
    const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
        const currentMatch = JSON.stringify(match);
        if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
            startPrefetchTime: Date.now()
        });
    };
    const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
        const currentMatch = JSON.stringify(match);
        const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
            startPrefetchTime: null
        };
        return startPrefetchTime;
    };
    const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
        if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
        const currentMatch = JSON.stringify(match);
        const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
        keys.forEach((mark)=>{
            if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
        });
    };
});
parcelRegister("lbyb6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab2f047cd976509c$export$2e2bcd8739ae039);
    var $dJl1T;
    var $7bpAK = parcelRequire("7bpAK");
    var $2Gs5h;
    const $ab2f047cd976509c$var$LOCATION = 'spa.create-spa-history';
    const $ab2f047cd976509c$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
            const matchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(currentRoutes, history.location.pathname, history.location.search);
            if (!matchedRoute) return ()=>{};
            if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
            return ()=>{
                const idx = routeBlockFns.indexOf(blockFn);
                if (idx !== -1) routeBlockFns.splice(idx, 1);
            };
        };
    const $ab2f047cd976509c$var$createSpaHistory = (initialRoutes)=>{
        const routeBlockFns = [];
        let blockArgs = [];
        let nextMatchedRoute;
        const currentRoutes = initialRoutes;
        const history = (0, $7bpAK.createBrowserHistory)({
            getUserConfirmation: async (__, done)=>{
                try {
                    const matchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(currentRoutes, history.location.pathname, history.location.search);
                    if (!matchedRoute || !nextMatchedRoute) return done(true);
                    for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                        const result = await routeBlockFns[i](...blockArgs);
                        if (result === false) return done(false);
                    }
                    routeBlockFns.length = 0;
                    return done(true);
                } catch (err) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($ab2f047cd976509c$var$LOCATION, 'Error with getUserConfirmation', err);
                    return done(true);
                }
            }
        });
        history.refreshRoutes = (newRoutes)=>{
            currentRoutes.length = 0;
            currentRoutes.push(...newRoutes);
            routeBlockFns.length = 0;
        };
        history.block((location, action)=>{
            blockArgs = [
                location,
                action
            ];
            nextMatchedRoute = (0, (0, parcelRequire("2Gs5h")).default)(currentRoutes, location.pathname, location.search);
            return '';
        });
        history.block = $ab2f047cd976509c$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
        return history;
    };
    var $ab2f047cd976509c$export$2e2bcd8739ae039 = (routes)=>$ab2f047cd976509c$var$createSpaHistory(routes);
});
parcelRegister("5HG6S", function(module, exports) {
    $parcel$export(module.exports, "getSpaRouterContext", ()=>$804f5602998bd8a4$export$1f61c5e3f6410afa);
    const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
            tenantContext: tenantContext
        });
});
parcelRegister("kKlrY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71f44f620ca2fe28$export$2e2bcd8739ae039);
    var $6QnC0;
    var $iNl9c;
    var $b8ITv;
    var $1jSjd;
    var $cwKqt;
    var $keu19;
    var $co1wz;
    var $4R6GH;
    var $j8DrX;
    var $aZWa4;
    var $3dQJA;
    var $7UTZj;
    var $fJbQ9;
    var $itoGf;
    var $dQKfU;
    const $71f44f620ca2fe28$var$getUFOConfigFromLD = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('ufo.config', {});
    const $71f44f620ca2fe28$var$getUFOConfigFromStatsig = ()=>{
        return {
            autoGeneratedRate: 1000,
            enabled: true,
            removeUFOPrefixList: [
                'project-versions',
                'filters-directory'
            ],
            removePageSegmentsUFOPrefixes: true,
            doNotAbortActivePressInteractionOnTransition: [
                'jsm-create-cmp-request-type-from-template',
                'jsm-create-tmp-request-type-from-template'
            ],
            killswitch: [
                'jira.fe.load.UNKNOWN'
            ],
            awaitForSegments: {
                'global-issue.create-modal': [
                    'issue-view-details'
                ],
                'global-issue.create-modal-subsequent': [
                    'issue-view-details'
                ]
            },
            removeAllUFOPrefix: true,
            rates: {
                'issue-view-activity-button-worklog': 1,
                'issue-view-activity-button-history': 1,
                'issue-view-activity-button-comments': 1,
                'arj-toggle-view-mode': 1,
                'global-issue.create-modal-subsequent': 5,
                unknown: 1000,
                'issue-view-activity-button-forge-app': 1,
                'view-mode': 1,
                'backlog.issue-view-opened': 5,
                'create-web-link-inline-field-type-tracing': 1000,
                'issue-view-activity-button-connect-app': 1,
                'single-line-text-field-type-tracing': 100,
                'issue-view-activity-button-all': 1,
                'backlog.card-hover': 100,
                'child-issue-inline-create-type-tracing': 100,
                'show-insights-button': 100,
                'board.issue-view-opened': 5,
                'issue-view-activity-button-jsd-comments': 1,
                'backlog.card-list-toggle': 5,
                'global-issue.create-modal': 5,
                'issue-view-activity-button-approvals': 1
            },
            kind: {
                generic: 0,
                hover: 0,
                legacy: 1,
                page_load: 1,
                press: 1,
                transition: 1,
                typing: 0
            },
            awaitBM3TTI: [
                'jwm_project_pages',
                'software-plan-dependencies',
                'advanced-roadmaps.page-plan.dependencies-tab.load-time',
                'servicedesk-cmdb-object-type-configuration',
                'service-management.insight-cmdb-object-type-configuration',
                'project-components-view',
                'project-components',
                'project-settings-components',
                'people-index',
                'people-profiles',
                'rapidboard-report',
                'classic-report',
                'project-settings-servicedesk-ticket-type-fields',
                'project-settings.issue-type.jsm-cmp-customer-view',
                'project-settings.issue-type.jsm-cmp-agent-view',
                'archived-project-direct-link',
                'project-archived',
                'servicedesk-queues-new',
                'service-management.queues.new',
                'project-settings-software-boards-insights',
                'board-settings-apps.insights-settings-page.page.load',
                'admin-oauth-credentials',
                'admin.oauth-credentials',
                'polaris-ideas',
                'jpd.project',
                'project-settings-software-boards-csm',
                'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
                'project-settings-servicedesk-language',
                'service-management.languages',
                'project-settings-servicedesk-language-key',
                'service-management.translations',
                'project-settings-servicedesk-classic-apps',
                'service-management.app-discovery',
                'marketplace-index',
                'embedded-marketplace',
                'project-settings-servicedesk-portal-settings',
                'service-management.portal-settings',
                'service-management.portal-settings.portal-groups',
                'project-settings-servicedesk-automation-create',
                'service-management.automation.create-rule',
                'servicedesk-customers-v2',
                'jsm-customers-component-load',
                'archived-project-direct-link',
                'project-archived',
                'project-settings-software-boards-csm',
                'software.next-gen.boards.column-status-mapping.page.load',
                'jira-connect',
                'knowledge-hub-category',
                'service-management.knowledge.category',
                'servicedesk-queues-landing',
                'servicedesk-practice-landing',
                'servicedesk-practice-custom-and-issue',
                'servicedesk-practice-custom-issue',
                'servicedesk-practice-custom-view',
                'servicedesk-queues-custom-and-issue',
                'servicedesk-queues-custom-issue',
                'servicedesk-queues-custom-view'
            ],
            rules: [],
            capability: {
                feature_flag_access: 1,
                react_profiler: 1
            },
            typingMethod: 'timeout',
            removeInteractionsUFOPrefixes: true,
            doNotAbortActivePressInteraction: [
                'global-issue.create-modal',
                'global-issue.create-modal-subsequent'
            ],
            ufoNameOverrides: {
                'global-issue-navigator': {
                    'global-issue-navigator': 'global-issue-navigator-jfe',
                    'new-issue-navigator': 'global-new-issue-navigator'
                },
                'global-issue-navigator-jfe': {
                    'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
                    'new-issue-navigator': 'global-new-issue-navigator'
                },
                'global-settings-migrations-focus-page': {
                    'admin.c2c-migrations.choose-destination': 'admin.c2c-migrations.choose-destination',
                    'admin.c2c-migrations.choose-projects': 'admin.c2c-migrations.choose-projects',
                    'admin.c2c-migrations.preflight-checks': 'admin.c2c-migrations.preflight-checks',
                    'admin.c2c-migrations.review': 'admin.c2c-migrations.review'
                },
                'polaris-ideas': {
                    'project-settings.details': 'project-settings-details-polaris-ideas'
                },
                'project-settings-servicedesk-portal-settings': {
                    'service-management.portal-settings': 'service-management.portal-settings',
                    'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
                },
                'project-settings-servicedesk-ticket-type-fields': {
                    'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
                    'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
                },
                'servicedesk-practice-custom-and-issue': {
                    'service-management.queues.issue': 'servicedesk-practice-custom-issue',
                    'service-management.queues.view': 'servicedesk-practice-custom-view'
                },
                'servicedesk-queues-custom-and-issue': {
                    'service-management.queues.issue': 'servicedesk-queues-custom-issue',
                    'service-management.queues.view': 'servicedesk-queues-custom-view'
                }
            },
            enableCompleteUsingDoubleRAF: true
        };
    };
    function $71f44f620ca2fe28$var$getAdditionalJiraFields(interaction) {
        try {
            return {
                jira: (0, (0, parcelRequire("3dQJA")).getJiraCustomData)(interaction)
            };
        } catch (error) {
            return {};
        }
    }
    function $71f44f620ca2fe28$var$loadJiraAnalyticsWebClient() {
        return Promise.resolve((parcelRequire("fjcgS")));
    }
    function $71f44f620ca2fe28$export$2e2bcd8739ae039() {
        const ufoConfigFromFF = (0, (0, parcelRequire("4R6GH")).fg)('ufo-use-statsig-config-jira') ? $71f44f620ca2fe28$var$getUFOConfigFromStatsig() : $71f44f620ca2fe28$var$getUFOConfigFromLD();
        (0, (0, parcelRequire("aZWa4")).retrieveAndSetPageLoadTrace)((0, (0, parcelRequire("j8DrX")).default));
        (0, (0, parcelRequire("1jSjd")).configure)((0, (0, parcelRequire("itoGf")).jiraResourceTimingsConfig));
        (0, (0, parcelRequire("cwKqt")).startResourceTimingBuffer)();
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-disable-ufo-bundle-eval-timings')) (0, (0, parcelRequire("6QnC0")).configure)((0, (0, parcelRequire("fJbQ9")).jiraBundleEvalTimingsConfig));
        (0, (0, parcelRequire("keu19")).configure)((0, (0, parcelRequire("dQKfU")).jiraSsrConfig));
        (0, (0, parcelRequire("7UTZj")).GlobalReactLooselyLazyProfiler).current = (0, (0, parcelRequire("iNl9c")).ModuleLoadingProfiler);
        (0, (0, parcelRequire("b8ITv")).init)($71f44f620ca2fe28$var$loadJiraAnalyticsWebClient(), {
            ...ufoConfigFromFF,
            enableSegmentHighlighting: (0, (0, parcelRequire("4R6GH")).fg)('ufo_enable_segment_highlighting_jira'),
            enableAdditionalPerformanceMarks: (0, (0, parcelRequire("4R6GH")).fg)('ufo_enable_segment_highlighting_jira'),
            product: 'jira',
            region: (0, (0, parcelRequire("j8DrX")).default)('ajs-region') || 'unknown',
            additionalPayloadData: $71f44f620ca2fe28$var$getAdditionalJiraFields,
            postInteractionLog: {
                enabled: (0, (0, parcelRequire("4R6GH")).fg)('ufo_capture_late_rerenders_jira'),
                rates: {
                    'issue-view': 1,
                    'new-issue-navigator': 1,
                    'classic-board': 1,
                    'classic-backlog': 1,
                    'next-gen-board': 1,
                    'jwm.list-view': 1,
                    'jwm.jwm-board': 1,
                    'jwm.summary-view': 1,
                    dashboard: 1,
                    'software-issue-navigator': 1,
                    'global-new-issue-navigator': 1,
                    'issue-navigator': 1,
                    'issue-navigator-classic': 1,
                    'issue-navigator-core': 1,
                    'servicedesk-issues': 1
                }
            },
            manuallyTrackReactProfilerMounts: (0, (0, parcelRequire("4R6GH")).fg)('ufo-manually-track-segment-mount-phase-jira'),
            vc: {
                enabled: true,
                heatmapSize: 200,
                oldDomUpdates: false,
                devToolsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('uip_vc_devtools'),
                selectorConfig: {
                    id: true,
                    role: true,
                    className: true,
                    testId: false
                },
                ssr: (0, (0, parcelRequire("4R6GH")).fg)('uip_vc_ssr'),
                stopVCAtInteractionFinish: (0, (0, parcelRequire("4R6GH")).fg)('stop_vc_at_interaction_finish')
            },
            enableBetterPageVisibilityApi: (0, (0, parcelRequire("co1wz")).ff)('uip.vc.better-page-visibility', false)
        });
    }
});
parcelRegister("6QnC0", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$614189b15ef3f5c2$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getBundleEvalTimings", ()=>$614189b15ef3f5c2$export$2eda1519e91a4386);
    var $d6abT;
    let $614189b15ef3f5c2$var$config = null;
    function $614189b15ef3f5c2$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
        $614189b15ef3f5c2$var$config = bundleEvalTimingConfiguration;
    }
    const $614189b15ef3f5c2$var$getPerformanceObject = ()=>(window ?? {}).performance;
    function $614189b15ef3f5c2$export$2eda1519e91a4386(interactionStartTime) {
        if ($614189b15ef3f5c2$var$config == null) return {};
        const started = {};
        const timings = {};
        const cachedConfig = $614189b15ef3f5c2$var$config;
        const performance = $614189b15ef3f5c2$var$getPerformanceObject();
        performance?.getEntriesByType('mark').forEach((mark)=>{
            const result = cachedConfig.mapPerformanceMark(mark.name);
            if (!result) return;
            const { type: type, name: name } = result;
            if (type === 'start' && mark.startTime >= interactionStartTime) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: (0, (0, parcelRequire("d6abT")).roundEpsilon)(started[name].startTime - interactionStartTime),
                    duration: (0, (0, parcelRequire("d6abT")).roundEpsilon)(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (Object.keys(timings).length === 0) return {};
        return timings;
    }
});
parcelRegister("d6abT", function(module, exports) {
    $parcel$export(module.exports, "roundEpsilon", ()=>$3cd97f13205ffd47$export$56014375de40214b);
    const $3cd97f13205ffd47$export$56014375de40214b = (num, places = 3)=>{
        const factor = Math.pow(10, places);
        return Math.round((num + Number.EPSILON) * factor) / factor;
    };
});
parcelRegister("b8ITv", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$f032f42c4a37af85$export$2cd8252107eb640b);
    var $gg6CF = parcelRequire("gg6CF");
    var $haBFE;
    var $9HC2N;
    var $9EJIt;
    var $iNl9c;
    var $8luMn;
    let $f032f42c4a37af85$var$initialized = false;
    function $f032f42c4a37af85$var$sinkInteraction(instance, payloadPackage) {
        (0, (0, parcelRequire("iNl9c")).sinkInteractionHandler)((interactionId, interaction)=>{
            (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                const payloads = payloadPackage.createPayloads(interactionId, interaction);
                payloads?.forEach((payload)=>{
                    instance.sendOperationalEvent(payload);
                });
            });
        });
    }
    function $f032f42c4a37af85$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
        (0, (0, parcelRequire("iNl9c")).sinkPostInteractionLogHandler)((logOutput)=>{
            (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
                const payload = createPostInteractionLogPayload(logOutput);
                if (payload) instance.sendOperationalEvent(payload);
            });
        });
    }
    const $f032f42c4a37af85$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
        if ($f032f42c4a37af85$var$initialized) return;
        try {
            if (window !== undefined) window.__REACT_UFO_ENABLE_PERF_TRACING = Boolean(sessionStorage.getItem('additionalPerfMarks') === 'true');
        } catch (err) {}
        (0, (0, parcelRequire("9HC2N")).setUFOConfig)(config);
        if (config.vc?.enabled) {
            const vcOptions = {
                heatmapSize: config.vc.heatmapSize,
                oldDomUpdates: config.vc.oldDomUpdates,
                devToolsEnabled: config.vc.devToolsEnabled,
                selectorConfig: config.vc.selectorConfig
            };
            (0, (0, parcelRequire("8luMn")).getVCObserver)(vcOptions).start({
                startTime: 0
            });
            (0, (0, parcelRequire("iNl9c")).postInteractionLog).initializeVCObserver(vcOptions);
            (0, (0, parcelRequire("iNl9c")).postInteractionLog).startVCObserver({
                startTime: 0
            });
        }
        (0, (0, parcelRequire("9EJIt")).setupHiddenTimingCapture)();
        (0, (0, parcelRequire("haBFE")).startLighthouseObserver)();
        $f032f42c4a37af85$var$initialized = true;
        Promise.all([
            analyticsWebClientAsync,
            (parcelRequire("3C7Cl")),
            (parcelRequire("kcEYx"))
        ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
            if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
                const instance = client.getInstance();
                $f032f42c4a37af85$var$sinkInteraction(instance, payloadPackage);
                if (config.postInteractionLog?.enabled) $f032f42c4a37af85$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            });
            else if (awc.sendOperationalEvent) {
                $f032f42c4a37af85$var$sinkInteraction(awc, payloadPackage);
                if (config.postInteractionLog?.enabled) $f032f42c4a37af85$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            }
        });
    };
});
parcelRegister("haBFE", function(module, exports) {
    $parcel$export(module.exports, "startLighthouseObserver", ()=>$373e90abe1dad721$export$5ecf2aafafee3e0);
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$373e90abe1dad721$export$b46cecdf698e4bb5);
    var $6YYIj;
    var $d1g7w;
    var $6KrDH;
    var $aDaN0;
    var $4E6sM;
    function $373e90abe1dad721$export$5ecf2aafafee3e0() {
        (0, (0, parcelRequire("4E6sM")).startLSObserver)();
        (0, (0, parcelRequire("4E6sM")).startLTObserver)();
    }
    const $373e90abe1dad721$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, (0, parcelRequire("6KrDH")).getTBT)(start, stop, (0, (0, parcelRequire("aDaN0")).EntriesBuffer)[(0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, (0, parcelRequire("6YYIj")).getCLS)(start, stop, (0, (0, parcelRequire("aDaN0")).EntriesBuffer)[(0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("6YYIj", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$300d0c58592f2fe3$export$fc6227831ee7c7);
    const $300d0c58592f2fe3$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("d1g7w", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$9ea2a77fc2c87b77$export$a4def92db6fc8e17);
    const $9ea2a77fc2c87b77$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("6KrDH", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$017d7e84dc1aa6f4$export$2d6e933b35bd3407);
    const $017d7e84dc1aa6f4$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $017d7e84dc1aa6f4$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $017d7e84dc1aa6f4$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $017d7e84dc1aa6f4$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $017d7e84dc1aa6f4$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("aDaN0", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$21482ab0f9f80e2d$export$f7dc16cbd16f7bbe);
    var $d1g7w;
    class $21482ab0f9f80e2d$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $21482ab0f9f80e2d$export$f7dc16cbd16f7bbe = {
        [(0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LongTask]: new $21482ab0f9f80e2d$export$2c6e86519c9e8188(),
        [(0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LayoutShift]: new $21482ab0f9f80e2d$export$2c6e86519c9e8188()
    };
});
parcelRegister("4E6sM", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$905668c8583579d4$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$905668c8583579d4$export$54fb8b6aaf70ec9c);
    var $d1g7w;
    var $aDaN0;
    let $905668c8583579d4$var$pe = null;
    const $905668c8583579d4$var$getObserver = ()=>{
        if ($905668c8583579d4$var$pe !== null) return $905668c8583579d4$var$pe;
        $905668c8583579d4$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LayoutShift) (0, (0, parcelRequire("aDaN0")).EntriesBuffer)[(0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LongTask) (0, (0, parcelRequire("aDaN0")).EntriesBuffer)[(0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $905668c8583579d4$var$pe;
    };
    const $905668c8583579d4$export$768ccc3ab7bac3ea = ()=>{
        $905668c8583579d4$var$getObserver().observe({
            type: (0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $905668c8583579d4$export$54fb8b6aaf70ec9c = ()=>{
        $905668c8583579d4$var$getObserver().observe({
            type: (0, (0, parcelRequire("d1g7w")).PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("9EJIt", function(module, exports) {
    $parcel$export(module.exports, "setupHiddenTimingCapture", ()=>$444586377bd3ef1c$export$554cefe0f0373da4);
    $parcel$export(module.exports, "getPageVisibilityState", ()=>$444586377bd3ef1c$export$768b2008623433e1);
    var $cBeZP;
    const $444586377bd3ef1c$var$timings = [];
    let $444586377bd3ef1c$var$wasHiddenFlag;
    let $444586377bd3ef1c$var$setupFlag = false;
    function $444586377bd3ef1c$var$isPageHidden() {
        if ('visibilityState' in document) return document.visibilityState === 'hidden';
        else return document.hidden;
    }
    const $444586377bd3ef1c$var$SIZE = 50;
    let $444586377bd3ef1c$var$insertIndex = 0;
    function $444586377bd3ef1c$var$pushHidden(isPageHiddenFlag, time) {
        $444586377bd3ef1c$var$timings[$444586377bd3ef1c$var$insertIndex] = {
            time: time ?? performance.now(),
            hidden: isPageHiddenFlag
        };
        $444586377bd3ef1c$var$insertIndex = ($444586377bd3ef1c$var$insertIndex + 1) % $444586377bd3ef1c$var$SIZE;
        $444586377bd3ef1c$var$wasHiddenFlag = isPageHiddenFlag;
    }
    function $444586377bd3ef1c$var$handleChange() {
        const isPageHiddenFlag = $444586377bd3ef1c$var$isPageHidden();
        if (isPageHiddenFlag) {
            if (!$444586377bd3ef1c$var$wasHiddenFlag) $444586377bd3ef1c$var$pushHidden(isPageHiddenFlag);
            $444586377bd3ef1c$var$wasHiddenFlag = true;
        } else {
            if ($444586377bd3ef1c$var$wasHiddenFlag) $444586377bd3ef1c$var$pushHidden(isPageHiddenFlag);
            $444586377bd3ef1c$var$wasHiddenFlag = false;
        }
    }
    function $444586377bd3ef1c$var$setup() {
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pageshow',
            listener: $444586377bd3ef1c$var$handleChange
        });
        (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'pagehide',
            listener: $444586377bd3ef1c$var$handleChange
        });
        (0, (0, parcelRequire("cBeZP")).bind)(document, {
            type: 'visibilitychange',
            listener: $444586377bd3ef1c$var$handleChange
        });
    }
    function $444586377bd3ef1c$export$554cefe0f0373da4() {
        if (!$444586377bd3ef1c$var$setupFlag) {
            const isPageHiddenFlag = $444586377bd3ef1c$var$isPageHidden();
            $444586377bd3ef1c$var$pushHidden(isPageHiddenFlag, 0);
            $444586377bd3ef1c$var$setup();
            $444586377bd3ef1c$var$setupFlag = true;
        }
    }
    function $444586377bd3ef1c$export$768b2008623433e1(start, end) {
        if ($444586377bd3ef1c$var$timings.length === 0) return 'visible';
        const currentSize = $444586377bd3ef1c$var$timings.length;
        let hiddenState = 'mixed';
        let startIdx = $444586377bd3ef1c$var$insertIndex;
        let endIdx = $444586377bd3ef1c$var$insertIndex;
        for(let i = 0; i < currentSize; i++){
            const tmpIdx = ($444586377bd3ef1c$var$insertIndex + i) % currentSize;
            if ($444586377bd3ef1c$var$timings[tmpIdx].time <= end) {
                endIdx = tmpIdx;
                if ($444586377bd3ef1c$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
            }
        }
        if (endIdx - startIdx === 0) {
            if ($444586377bd3ef1c$var$timings[startIdx].hidden) hiddenState = 'hidden';
            else hiddenState = 'visible';
        }
        return hiddenState;
    }
});
parcelRegister("3C7Cl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bLCVj").then(()=>parcelRequire('5HSAB'));
});
parcelRegister("kcEYx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("22C51").then(()=>parcelRequire('iDJzG'));
});
parcelRegister("1jSjd", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$93f1ac1e1e4fd0cc$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getConfig", ()=>$93f1ac1e1e4fd0cc$export$44487a86467333c3);
    var $9HC2N;
    const $93f1ac1e1e4fd0cc$var$defaultAllowedParams = [
        'operationName',
        'operation',
        'q'
    ];
    const $93f1ac1e1e4fd0cc$var$getAllowedParams = ()=>{
        const config = (0, (0, parcelRequire("9HC2N")).getConfig)();
        return config?.allowedResourcesParams || $93f1ac1e1e4fd0cc$var$defaultAllowedParams;
    };
    const $93f1ac1e1e4fd0cc$var$handleQueryParams = (urlString)=>{
        try {
            if (typeof urlString !== 'string') return urlString;
            const url = new URL(urlString);
            const params = new URLSearchParams(url.search);
            const allowedParams = $93f1ac1e1e4fd0cc$var$getAllowedParams();
            for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
            return url.toString();
        } catch (e) {
            return urlString;
        }
    };
    let $93f1ac1e1e4fd0cc$var$config = {
        mapResources: (url)=>url,
        sanitiseEndpoints: (url)=>{
            return $93f1ac1e1e4fd0cc$var$handleQueryParams(url);
        }
    };
    function $93f1ac1e1e4fd0cc$export$8d21e34596265fa2(resourceTimingConfig) {
        const newConfig = {
            mapResources: resourceTimingConfig.mapResources,
            sanitiseEndpoints: (url)=>{
                const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
                if (sanitised) return $93f1ac1e1e4fd0cc$var$handleQueryParams(sanitised);
                return sanitised;
            }
        };
        $93f1ac1e1e4fd0cc$var$config = newConfig;
    }
    const $93f1ac1e1e4fd0cc$export$44487a86467333c3 = ()=>$93f1ac1e1e4fd0cc$var$config;
});
parcelRegister("cwKqt", function(module, exports) {
    $parcel$export(module.exports, "startResourceTimingBuffer", ()=>$3c36e3dabcf3bfa1$export$a311cb1baa7d2d62);
    var $32LHZ;
    function $3c36e3dabcf3bfa1$export$a311cb1baa7d2d62() {
        (0, (0, parcelRequire("32LHZ")).resourceTimingBuffer).start();
    }
});
parcelRegister("32LHZ", function(module, exports) {
    $parcel$export(module.exports, "resourceTimingBuffer", ()=>$86d5772de48e1eed$export$bea963256235a63e);
    $parcel$export(module.exports, "filterResourceTimings", ()=>$86d5772de48e1eed$export$4138a729ef1db028);
    var $d6abT;
    const $86d5772de48e1eed$var$getPerformanceObject = ()=>(window ?? {}).performance;
    const $86d5772de48e1eed$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
    const $86d5772de48e1eed$export$bea963256235a63e = {
        timings: [],
        maxSize: 1000,
        observer: null,
        transformResource: (entry)=>{
            const duration = (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.duration);
            const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find((timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
            const serverTime = totalBackendTimeEntry ? (0, (0, parcelRequire("d6abT")).roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
            const networkTime = serverTime ? duration - serverTime : undefined;
            return {
                name: entry.name,
                initiatorType: entry.initiatorType,
                transferSize: entry.transferSize,
                startTime: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.startTime),
                duration: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.duration),
                fetchStart: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.fetchStart || 0),
                workerStart: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.workerStart || 0),
                responseStart: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.responseStart || 0),
                requestStart: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.requestStart || 0),
                serverTime: serverTime,
                networkTime: networkTime,
                encodedSize: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.encodedBodySize),
                decodedSize: (0, (0, parcelRequire("d6abT")).roundEpsilon)(entry.decodedBodySize)
            };
        },
        start: ()=>{
            const performance = $86d5772de48e1eed$var$getPerformanceObject();
            const PerformanceObserver = $86d5772de48e1eed$var$getPerformanceObserverObject();
            if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
            if ($86d5772de48e1eed$export$bea963256235a63e.observer) return;
            const resources = performance.getEntriesByType?.('resource');
            if (resources) $86d5772de48e1eed$export$bea963256235a63e.timings = resources.map((resource)=>$86d5772de48e1eed$export$bea963256235a63e.transformResource(resource));
            $86d5772de48e1eed$export$bea963256235a63e.observer = new PerformanceObserver($86d5772de48e1eed$export$bea963256235a63e.addTimings);
            $86d5772de48e1eed$export$bea963256235a63e.observer.observe({
                entryTypes: [
                    'resource'
                ]
            });
        },
        stop: ()=>{
            if ($86d5772de48e1eed$export$bea963256235a63e.observer) {
                $86d5772de48e1eed$export$bea963256235a63e.observer.disconnect();
                $86d5772de48e1eed$export$bea963256235a63e.observer = null;
            }
            $86d5772de48e1eed$export$bea963256235a63e.timings = [];
        },
        addTimings: (list)=>{
            const entries = list.getEntries().map((entry)=>$86d5772de48e1eed$export$bea963256235a63e.transformResource(entry));
            const overflow = $86d5772de48e1eed$export$bea963256235a63e.timings.length + entries.length;
            if (overflow > $86d5772de48e1eed$export$bea963256235a63e.maxSize) {
                const fieldsToRemove = overflow - $86d5772de48e1eed$export$bea963256235a63e.maxSize;
                $86d5772de48e1eed$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
            }
            $86d5772de48e1eed$export$bea963256235a63e.timings.push(...entries);
        }
    };
    const $86d5772de48e1eed$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
    const $86d5772de48e1eed$export$4138a729ef1db028 = (startTime, endTime)=>{
        const performance = $86d5772de48e1eed$var$getPerformanceObject();
        const PerformanceObserver = $86d5772de48e1eed$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !$86d5772de48e1eed$export$bea963256235a63e.observer) {
            const resources = performance?.getEntriesByType('resource');
            if (resources) return resources.filter((timing)=>$86d5772de48e1eed$var$isValidTiming(timing, startTime, endTime));
            return null;
        }
        return $86d5772de48e1eed$export$bea963256235a63e.timings.filter((timing)=>$86d5772de48e1eed$var$isValidTiming(timing, startTime, endTime));
    };
});
parcelRegister("keu19", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$d17b8caf5cb18bef$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getSSRTimings", ()=>$d17b8caf5cb18bef$export$bf7408e83532dcd0);
    $parcel$export(module.exports, "getSSRSuccess", ()=>$d17b8caf5cb18bef$export$c7ad864055e75537);
    $parcel$export(module.exports, "getSSRDoneTime", ()=>$d17b8caf5cb18bef$export$3def7672244bab0c);
    $parcel$export(module.exports, "getSSRFeatureFlags", ()=>$d17b8caf5cb18bef$export$1c4a9b5e6e22393d);
    const $d17b8caf5cb18bef$var$NESTED_METRIC_SEPARATOR = '/';
    const $d17b8caf5cb18bef$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    const $d17b8caf5cb18bef$var$mapEntry = (entry)=>({
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        });
    const $d17b8caf5cb18bef$var$SSR_PREFIX = 'ssr';
    const $d17b8caf5cb18bef$var$mapKey = (key)=>{
        if (key === 'total') return $d17b8caf5cb18bef$var$SSR_PREFIX;
        return `${$d17b8caf5cb18bef$var$SSR_PREFIX}${$d17b8caf5cb18bef$var$NESTED_METRIC_SEPARATOR}${key}`;
    };
    let $d17b8caf5cb18bef$var$config;
    function $d17b8caf5cb18bef$export$8d21e34596265fa2(ssrConfig) {
        $d17b8caf5cb18bef$var$config = ssrConfig;
    }
    function $d17b8caf5cb18bef$export$bf7408e83532dcd0() {
        if (!$d17b8caf5cb18bef$var$config?.getTimings) return {};
        const timings = $d17b8caf5cb18bef$var$config.getTimings();
        if (!timings) return {};
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($d17b8caf5cb18bef$var$filterEntry(entry[1])) acc[$d17b8caf5cb18bef$var$mapKey(entry[0])] = $d17b8caf5cb18bef$var$mapEntry(entry[1]);
            return acc;
        }, {});
        return ssrTimings;
    }
    function $d17b8caf5cb18bef$export$c7ad864055e75537() {
        return !!$d17b8caf5cb18bef$var$config?.getDoneMark();
    }
    function $d17b8caf5cb18bef$export$3def7672244bab0c() {
        return $d17b8caf5cb18bef$var$config?.getDoneMark() ?? undefined;
    }
    function $d17b8caf5cb18bef$export$1c4a9b5e6e22393d() {
        if (!$d17b8caf5cb18bef$var$config?.getFeatureFlags) return undefined;
        try {
            return $d17b8caf5cb18bef$var$config.getFeatureFlags() ?? undefined;
        } catch (e) {}
        return undefined;
    }
});
parcelRegister("aZWa4", function(module, exports) {
    $parcel$export(module.exports, "retrieveAndSetPageLoadTrace", ()=>$b515f2bc55199ff5$export$1a71d2bbe236de99);
    var $6ui18;
    let $b515f2bc55199ff5$var$alreadySet = false;
    const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
        if (false || $b515f2bc55199ff5$var$alreadySet) return;
        const traceId = getMeta('X-B3-TraceId') || '';
        const spanId = traceId?.substring(traceId.length - 16) || '';
        $b515f2bc55199ff5$var$alreadySet = true;
        (0, (0, parcelRequire("6ui18")).setActiveTrace)(traceId, spanId, 'page_load');
    };
});
parcelRegister("3dQJA", function(module, exports) {
    $parcel$export(module.exports, "getJiraCustomData", ()=>$f5569bfee184b069$export$abf5e20822fa925);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $3HwlS;
    var $sUexw;
    var $5YDBW;
    var $5uZVJ;
    var $eV38z;
    var $jgkaQ;
    var $9NJeU;
    var $3Itig;
    var $6R03U;
    var $bo7zb;
    var $ax2PR;
    var $4xsv9;
    function $f5569bfee184b069$export$abf5e20822fa925(interaction) {
        let customData = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        if (shard !== null && shard !== '') customData.shard = shard;
        customData['network:assetEncoding'] = (0, (0, parcelRequire("sUexw")).getAssetEncoding)();
        const buildVariant = window.BUILD_VARIANT;
        if (buildVariant) customData['app:buildVariant'] = buildVariant;
        const bundlerVersion = window.BUNDLER_VERSION;
        if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
        const useBifrostGateway = window.USE_BIFROST_GATEWAY;
        if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
        customData.navType = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? 'nav4' : 'nav3';
        customData.httpProtocol = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
        const { start: start, end: end, apdex: apdex } = interaction;
        const stop = apdex?.[0]?.stopTime ?? end;
        customData.memory = (0, (0, parcelRequire("9NJeU")).getMemoryUsageReport)({
            start: start,
            stop: stop
        });
        const lightHouseMetrics = (0, (0, parcelRequire("eV38z")).getLighthouseMetrics)({
            start: start,
            stop: stop
        });
        customData = {
            ...customData,
            ...lightHouseMetrics
        };
        if (interaction.type === 'page_load') customData = {
            ...customData,
            ...(0, (0, parcelRequire("jgkaQ")).getMarks)({
                start: start
            }),
            ...(0, (0, parcelRequire("3Itig")).getPageSizeMetrics)(),
            ...(0, (0, parcelRequire("3Itig")).getExtraNavigationTimings)(),
            ...(0, (0, parcelRequire("bo7zb")).getServerDurationMetrics)(),
            ...(0, (0, parcelRequire("6R03U")).getRouterResourceMetrics)(),
            ...(0, (0, parcelRequire("4xsv9")).getWRMStats)(),
            ...(0, (0, parcelRequire("3Itig")).getPageSizeInfo)({
                start: start,
                stop: stop
            }),
            ...(0, (0, parcelRequire("5YDBW")).getCacheHitRatio)({
                start: start
            }),
            ...(0, (0, parcelRequire("5uZVJ")).getCHRInfo)({
                start: start
            }),
            ...(0, (0, parcelRequire("ax2PR")).getSSRStateInformation)(),
            'app:version:web': window.BUILD_KEY,
            'app:version:ssr': window.SSR_BUILD_KEY,
            'app:framework:name': 'react',
            'app:framework:version': (0, $5uXOq.version)
        };
        return customData;
    }
});
parcelRegister("sUexw", function(module, exports) {
    $parcel$export(module.exports, "getAssetEncoding", ()=>$7cf3b2ddfe1abab1$export$fd12d8f45e126585);
    function $7cf3b2ddfe1abab1$export$fd12d8f45e126585() {
        const assetEncodings = Array.prototype.map.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')).reduce((acc, i)=>{
            acc[i] = true;
            return acc;
        }, {});
        const uniqueEncodings = Object.keys(assetEncodings).sort();
        let result = 'unknown';
        if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
        if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
        return result;
    }
});
parcelRegister("5YDBW", function(module, exports) {
    $parcel$export(module.exports, "getCacheHitRatio", ()=>$62c0824bd7614469$export$e8a9322c3d9da8a6);
    var $6RCeq;
    const $62c0824bd7614469$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $62c0824bd7614469$var$CACHE_NETWORK = 'network';
    const $62c0824bd7614469$var$CACHE_MEMORY = 'memory';
    const $62c0824bd7614469$var$CACHE_DISK = 'disk';
    const $62c0824bd7614469$var$calculateTransferType = (type, duration, size)=>{
        if (!$62c0824bd7614469$var$cacheableTypes.includes(type)) return $62c0824bd7614469$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $62c0824bd7614469$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $62c0824bd7614469$var$CACHE_DISK;
        if (size === undefined) return null;
        return $62c0824bd7614469$var$CACHE_NETWORK;
    };
    const $62c0824bd7614469$export$e8a9322c3d9da8a6 = ({ start: start })=>{
        let fromCache = 0;
        let preloadFromCache = 0;
        let total = 0;
        let totalPreload = 0;
        if (start !== 0) return {};
        try {
            for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource')){
                const transferType = $62c0824bd7614469$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
                const isPreload = entry.initiatorType === 'link';
                if (transferType === 'disk' || transferType === 'memory') {
                    fromCache += 1;
                    if (isPreload) preloadFromCache += 1;
                }
                if (transferType !== null) {
                    total += 1;
                    if (isPreload) totalPreload += 1;
                }
            }
            const result = {};
            if (total > 0) result.cacheHitRatio = fromCache / total;
            if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
            return result;
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("5uZVJ", function(module, exports) {
    $parcel$export(module.exports, "getCHRInfo", ()=>$e76f22784dfe18ae$export$9e005e111be93521);
    var $x9xyg;
    var $6RCeq;
    var $d1SfZ;
    const $e76f22784dfe18ae$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
    const $e76f22784dfe18ae$export$1faf7d001841a41c = ()=>(0, (0, parcelRequire("x9xyg")).getMark)($e76f22784dfe18ae$var$SPA_SSR_RENDERED)?.startTime || null;
    const $e76f22784dfe18ae$export$9e005e111be93521 = ({ start: start })=>{
        if (start !== 0) return {};
        const ssrMark = $e76f22784dfe18ae$export$1faf7d001841a41c();
        const reporter = new (0, (0, parcelRequire("d1SfZ")).CHRReporter)(ssrMark);
        try {
            for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource'))reporter.add(entry);
            const chr = reporter.get();
            return chr === null ? {} : {
                chr: chr
            };
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("d1SfZ", function(module, exports) {
    $parcel$export(module.exports, "CHRReporter", ()=>$850475b27a81c50e$export$7d0d4cfb6455ffa5);
    var $80WiQ;
    var $d1r8j;
    class $850475b27a81c50e$export$7d0d4cfb6455ffa5 {
        constructor(ssrMark){
            this.preloaded = new (0, (0, parcelRequire("d1r8j")).CHRSummary)();
            this.all = new (0, (0, parcelRequire("d1r8j")).CHRSummary)();
            this.ssrMark = null;
            this.ssrMark = ssrMark;
        }
        add(item) {
            if (item.encodedBodySize === 0) return;
            if (item.initiatorType === 'link' && (0, (0, parcelRequire("80WiQ")).cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
            this.all.add(item);
        }
        static round(n) {
            return Math.round(n * 10000) / 10000;
        }
        makePayload(summary) {
            const bundlesLoadType = {
                mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] / summary.bundlesCount),
                disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY] / summary.bundlesCount),
                net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).NETWORK_KEY] / summary.bundlesCount)
            };
            const bundlesRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] + summary.bundles[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY]) / summary.bundlesCount);
            const sizeLoadType = {
                mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] / summary.sizeTotal),
                disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY] / summary.sizeTotal),
                net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).NETWORK_KEY] / summary.sizeTotal)
            };
            const sizeRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).MEMORY_KEY] + summary.size[(0, (0, parcelRequire("d1r8j")).CHRSummary).DISK_KEY]) / summary.sizeTotal);
            return {
                bundles: {
                    ratio: bundlesRatio,
                    count: summary.bundlesCount,
                    loadType: bundlesLoadType
                },
                size: {
                    ratio: sizeRatio,
                    total: summary.sizeTotal,
                    loadType: sizeLoadType
                }
            };
        }
        get() {
            if (this.all.bundlesCount === 0) return null;
            return {
                preloaded: this.makePayload(this.preloaded),
                all: this.makePayload(this.all)
            };
        }
    }
});
parcelRegister("80WiQ", function(module, exports) {
    $parcel$export(module.exports, "cacheableTypes", ()=>$0b57baf495baebc5$export$5e1aa91d6932ddaa);
    const $0b57baf495baebc5$export$5e1aa91d6932ddaa = [
        'script',
        'link'
    ];
});
parcelRegister("d1r8j", function(module, exports) {
    $parcel$export(module.exports, "CHRSummary", ()=>$d000becd84478ee1$export$783d6618ee601ba);
    var $80WiQ;
    const $d000becd84478ee1$var$calculateTransferType = (type, duration, size)=>{
        if (!(0, (0, parcelRequire("80WiQ")).cacheableTypes).includes(type)) return null;
        if ((size === undefined || size === 0) && duration === 0) return $d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY;
        if (size === 0 && duration > 0) return $d000becd84478ee1$export$783d6618ee601ba.DISK_KEY;
        if (size === undefined) return null;
        return $d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY;
    };
    class $d000becd84478ee1$export$783d6618ee601ba {
        static{
            this.MEMORY_KEY = 'mem';
        }
        static{
            this.DISK_KEY = 'disk';
        }
        static{
            this.NETWORK_KEY = 'net';
        }
        add(item) {
            const type = $d000becd84478ee1$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
            if (type === null) return;
            this.bundles[type] += 1;
            this.bundlesCount += 1;
            this.size[type] += item.encodedBodySize;
            this.sizeTotal += item.encodedBodySize;
        }
        constructor(){
            this.bundles = {
                [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.bundlesCount = 0;
            this.size = {
                [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.sizeTotal = 0;
        }
    }
});
parcelRegister("eV38z", function(module, exports) {
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$45336243ca9d66b9$export$b46cecdf698e4bb5);
    var $akIBh;
    var $5HXkx;
    var $7hESW;
    var $aOwtG;
    var $8YqT3;
    function $45336243ca9d66b9$export$5ecf2aafafee3e0() {
        (0, (0, parcelRequire("8YqT3")).startLSObserver)();
        (0, (0, parcelRequire("8YqT3")).startLTObserver)();
    }
    const $45336243ca9d66b9$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, (0, parcelRequire("7hESW")).getTBT)(start, stop, (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, (0, parcelRequire("akIBh")).getCLS)(start, stop, (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("akIBh", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$b182c515ac203eb1$export$fc6227831ee7c7);
    const $b182c515ac203eb1$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("5HXkx", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$b2a196da23758bb0$export$a4def92db6fc8e17);
    const $b2a196da23758bb0$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("7hESW", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$e79996724decdf66$export$2d6e933b35bd3407);
    const $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $e79996724decdf66$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("aOwtG", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$14dd3fd4391f2796$export$f7dc16cbd16f7bbe);
    var $5HXkx;
    class $14dd3fd4391f2796$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $14dd3fd4391f2796$export$f7dc16cbd16f7bbe = {
        [(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask]: new $14dd3fd4391f2796$export$2c6e86519c9e8188(),
        [(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift]: new $14dd3fd4391f2796$export$2c6e86519c9e8188()
    };
});
parcelRegister("8YqT3", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$f3198686c7919898$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$f3198686c7919898$export$54fb8b6aaf70ec9c);
    var $5HXkx;
    var $aOwtG;
    let $f3198686c7919898$var$pe = null;
    const $f3198686c7919898$var$getObserver = ()=>{
        if ($f3198686c7919898$var$pe !== null) return $f3198686c7919898$var$pe;
        $f3198686c7919898$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift) (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask) (0, (0, parcelRequire("aOwtG")).EntriesBuffer)[(0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $f3198686c7919898$var$pe;
    };
    const $f3198686c7919898$export$768ccc3ab7bac3ea = ()=>{
        $f3198686c7919898$var$getObserver().observe({
            type: (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $f3198686c7919898$export$54fb8b6aaf70ec9c = ()=>{
        $f3198686c7919898$var$getObserver().observe({
            type: (0, (0, parcelRequire("5HXkx")).PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("jgkaQ", function(module, exports) {
    $parcel$export(module.exports, "getMarks", ()=>$0fe8913ad7f2f853$export$9d952633c9c2237b);
    var $bobSR;
    var $fDtbf;
    const $0fe8913ad7f2f853$export$9d952633c9c2237b = (data)=>{
        const userTiming = (0, (0, parcelRequire("bobSR")).getUserTiming)();
        if (userTiming === null) return null;
        const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
        const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
            let candidateName = baseName;
            let counter = 2;
            let validName;
            while(!validName)if (candidateName in collection) {
                candidateName = `${baseName}_${counter}`;
                counter += 1;
            } else validName = candidateName;
            return validName;
        };
        const marks = {};
        userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START)) && !item.name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP)) && item.startTime >= data.start).forEach((item)=>{
            const name = getNextAvailableName({
                baseName: `mark__${sanitizeName(item.name)}`,
                collection: marks
            });
            marks[name] = Math.round(item.startTime - data.start);
        });
        return marks;
    };
});
parcelRegister("9NJeU", function(module, exports) {
    $parcel$export(module.exports, "getMemoryUsageReport", ()=>$8fa3790b95082ce5$export$e5bd2d61c7c80651);
    const $8fa3790b95082ce5$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
        if (typeof performance === 'undefined' || performance?.memory == null) return null;
        const sessionTime = Math.round(stop - start);
        const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
        return {
            sessionTime: sessionTime,
            performanceMemoryEntry: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        };
    };
});
parcelRegister("3Itig", function(module, exports) {
    $parcel$export(module.exports, "getPageSizeMetrics", ()=>$d593ead38e6ee650$export$84e3d676f1564c75);
    $parcel$export(module.exports, "getExtraNavigationTimings", ()=>$d593ead38e6ee650$export$b37a70af06e58097);
    $parcel$export(module.exports, "getPageSizeInfo", ()=>$d593ead38e6ee650$export$b72e035af6568be7);
    var $6RCeq;
    const $d593ead38e6ee650$export$84e3d676f1564c75 = ()=>{
        let maxDepth = -1;
        let maxWidth = -1;
        let numElements = 0;
        const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
            if (!el) return;
            if (depth > maxDepth) maxDepth = depth;
            if (el.children.length > maxWidth) maxWidth = el.children.length;
            let child = el.firstElementChild;
            while(child){
                calculateDOMsizeAndDepth(child, depth + 1);
                if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
                child = child.nextElementSibling;
                numElements += 1;
            }
        };
        calculateDOMsizeAndDepth();
        return {
            totalBodyElements: numElements,
            maxNestedLevels: maxDepth,
            maxChildElements: maxWidth
        };
    };
    const $d593ead38e6ee650$export$b37a70af06e58097 = ()=>{
        if (!(0, (0, parcelRequire("6RCeq")).default)) return {};
        const navigation = (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('navigation')[0];
        if (!navigation) return {};
        return {
            decodedBodySize: navigation.decodedBodySize,
            encodedBodySize: navigation.encodedBodySize,
            transferSize: navigation.transferSize
        };
    };
    const $d593ead38e6ee650$var$assetsTypes = [
        'script',
        'link'
    ];
    const $d593ead38e6ee650$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
        const pageSize = $d593ead38e6ee650$export$b37a70af06e58097();
        if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
        const decoded = {
            total: pageSize.decodedBodySize,
            pageSize: pageSize.decodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const encoded = {
            total: pageSize.encodedBodySize,
            pageSize: pageSize.encodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const net = {
            total: pageSize.transferSize,
            assets: 0,
            endpoints: 0
        };
        for (const entry of (0, (0, parcelRequire("6RCeq")).default).getEntriesByType('resource')){
            if (entry.startTime > stop) continue;
            if ($d593ead38e6ee650$var$assetsTypes.includes(entry.initiatorType)) {
                decoded.total += entry.decodedBodySize;
                decoded.assets += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.assets += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.assets += entry.transferSize;
            } else {
                decoded.total += entry.decodedBodySize;
                decoded.endpoints += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.endpoints += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.endpoints += entry.transferSize;
            }
        }
        const returnValue = {};
        Object.keys(decoded).forEach((key)=>{
            returnValue[`size:decoded:${key}`] = decoded[key];
        });
        Object.keys(encoded).forEach((key)=>{
            returnValue[`size:encoded:${key}`] = encoded[key];
        });
        Object.keys(net).forEach((key)=>{
            returnValue[`size:net:${key}`] = net[key];
        });
        return returnValue;
    };
});
parcelRegister("6R03U", function(module, exports) {
    $parcel$export(module.exports, "getRouterResourceMetrics", ()=>$7077665729c4125c$export$e703af446a67c7f4);
    const $7077665729c4125c$export$e703af446a67c7f4 = ()=>{
        const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
            if (key !== key.toUpperCase()) return false;
            const resource = window.SPA_STATE[key];
            if (typeof resource !== 'object') return false;
            const resourceResponse = resource[Object.keys(resource)[0]];
            return resourceResponse?.error?.name === 'TimeoutError';
        }) : [];
        return {
            ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
        };
    };
});
parcelRegister("bo7zb", function(module, exports) {
    $parcel$export(module.exports, "getServerDurationMetrics", ()=>$c797c35a7f1d14f1$export$efd8b60b870e5282);
    const $c797c35a7f1d14f1$export$efd8b60b870e5282 = ()=>{
        const metrics = {};
        try {
            const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
            if (serverDurationElem) {
                const serverDuration = Number(serverDurationElem.value);
                if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
            }
            const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
            if (serverTraceIdElem) {
                const serverRequestTraceId = serverTraceIdElem.value;
                metrics.serverRequestTraceId = serverRequestTraceId;
            }
            const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
            if (serverTraceSampledElem) {
                const serverRequestTraceSampled = serverTraceSampledElem.value;
                switch(serverRequestTraceSampled){
                    case 'true':
                        metrics.serverRequestTraceSampled = true;
                        break;
                    case 'false':
                        metrics.serverRequestTraceSampled = false;
                        break;
                    default:
                        metrics.serverRequestTraceSampled = null;
                        break;
                }
            }
            const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
            if (concurrentRequestsElem) {
                const concurrentRequests = concurrentRequestsElem.value;
                metrics.concurrentRequests = concurrentRequests;
            }
            const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
            if (serverRequestStartTimeElem) {
                const serverRequestStartTime = serverRequestStartTimeElem.value;
                metrics.serverRequestStartTime = serverRequestStartTime;
            }
            const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
            if (frontendFlushStartTimeElem) {
                const frontendFlushStartTime = frontendFlushStartTimeElem.value;
                metrics.frontendFlushStartTime = frontendFlushStartTime;
            }
        } catch (ignored) {}
        return metrics;
    };
});
parcelRegister("ax2PR", function(module, exports) {
    $parcel$export(module.exports, "getSSRStateInformation", ()=>$cefad605288b959d$export$9a46186893ad76bd);
    var $x9xyg;
    const $cefad605288b959d$var$getState = ()=>{
        if ((0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.state')?.startTime) return 'success';
        if ((0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
        return 'static-fallback';
    };
    const $cefad605288b959d$export$9a46186893ad76bd = ()=>{
        return {
            'ssr:state': $cefad605288b959d$var$getState()
        };
    };
});
parcelRegister("4xsv9", function(module, exports) {
    $parcel$export(module.exports, "getWRMStats", ()=>$a91d766509875677$export$d2d916ddd03b82bc);
    const $a91d766509875677$export$d2d916ddd03b82bc = ()=>{
        const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
        return {
            wrmStats: wrmStats
        };
    };
});
parcelRegister("fJbQ9", function(module, exports) {
    $parcel$export(module.exports, "jiraBundleEvalTimingsConfig", ()=>$f9b1cc066b55fe02$export$791b8c0cbd574ea9);
    var $fDtbf;
    const $f9b1cc066b55fe02$export$791b8c0cbd574ea9 = {
        mapPerformanceMark: (mark)=>{
            if (mark.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) return {
                name: mark.substring(0, mark.indexOf((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))),
                type: 'start'
            };
            if (mark.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP))) return {
                name: mark.substring(0, mark.indexOf((0, (0, parcelRequire("fDtbf")).JS_EVAL_STOP))),
                type: 'end'
            };
            return null;
        }
    };
});
parcelRegister("itoGf", function(module, exports) {
    $parcel$export(module.exports, "jiraResourceTimingsConfig", ()=>$be8f5f0d3efbf58f$export$8fa71550bcdc2104);
    var $aZsz6 = parcelRequire("aZsz6");
    var $6pIol;
    const $be8f5f0d3efbf58f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
    const $be8f5f0d3efbf58f$var$getWRMAssetName = (url)=>{
        const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
        const assetName = (0, (0, parcelRequire("6pIol")).sanitiseAssetName)(false)(url);
        if (!resources) return assetName;
        return `wrm/${resources}/${assetName}`;
    };
    const $be8f5f0d3efbf58f$var$getFileName = (url)=>$be8f5f0d3efbf58f$var$isWRMResource(url) ? $be8f5f0d3efbf58f$var$getWRMAssetName(url) : (0, (0, parcelRequire("6pIol")).sanitiseAssetName)(false)(url);
    const $be8f5f0d3efbf58f$var$sanitiseEndpoints = (url)=>{
        const parsedUrl = (0, ($parcel$interopDefault($aZsz6)))(url, true);
        const { operation: operation, operationName: operationName } = parsedUrl.query;
        const operationNameOverride = operation ?? operationName;
        if (operationNameOverride) return `/${operation}?operation=${operation}`;
        const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>').replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>').replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
        return fileName;
    };
    const $be8f5f0d3efbf58f$export$8fa71550bcdc2104 = {
        sanitiseEndpoints: $be8f5f0d3efbf58f$var$sanitiseEndpoints,
        mapResources: $be8f5f0d3efbf58f$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $be8f5f0d3efbf58f$var$isWRMResource(url),
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
});
parcelRegister("dQKfU", function(module, exports) {
    $parcel$export(module.exports, "jiraSsrConfig", ()=>$ba8cdb329bff9946$export$7bcf91e323db67dd);
    var $LpImS = parcelRequire("LpImS");
    var $x9xyg;
    var $6RCeq;
    var $4R6GH;
    var $j8DrX;
    function $ba8cdb329bff9946$var$insertTotalTiming(key, timings) {
        const timingValues = timings && Object.values(timings);
        if (!timingValues || !timingValues.length) return timings;
        const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
        const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
        const duration = endTime - startTime;
        timings[key] = {
            startTime: startTime,
            duration: duration
        };
        return timings;
    }
    function $ba8cdb329bff9946$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
        return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
            const startTime = value.startTime + startTimeOffsetMs;
            return [
                [
                    prefix,
                    key
                ].filter(Boolean).join('/'),
                {
                    ...value,
                    startTime: startTime
                }
            ];
        }));
    }
    function $ba8cdb329bff9946$var$getTesseractTimings() {
        if (!globalThis.SPA_STATE) return null;
        const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
        const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
        const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
        const timings = (0, ($parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
        if (highLevelMetrics?.data) {
            if ('ssrTotal' in highLevelMetrics.data) {
                const totalKey = (0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings') ? '' : 'total';
                timings[totalKey] = {
                    startTime: 0,
                    duration: highLevelMetrics.data.ssrTotal
                };
            }
            if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
                startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
                duration: highLevelMetrics.data.ssrGetStyle
            };
            if ('ssrPrefetch' in highLevelMetrics.data) {
                const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
                timings.prefetch = {
                    startTime: prefetchStartTime,
                    duration: highLevelMetrics.data.ssrPrefetch
                };
            }
        }
        if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
            timings[`prefetch/${key}`] = value;
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings')) return timings;
        return $ba8cdb329bff9946$var$insertTotalTiming('', timings);
    }
    const $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys = new Set([
        'metatags',
        'feature-flags',
        'statsig',
        'inline-assets',
        'async-inline-assets',
        'css-assets',
        'priority-assets',
        'early-route-flush'
    ]);
    const $ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys = [
        'early-common-flush',
        'prerender-total',
        'resolve-assets'
    ];
    function $ba8cdb329bff9946$var$getJiraFeGatewayTimings() {
        const rawTimings = globalThis._JFGTimings;
        if (!rawTimings) return null;
        const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
                $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
                {
                    startTime: startTime,
                    duration: duration
                }
            ]));
        return $ba8cdb329bff9946$var$insertTotalTiming('', jiraFeGatewayTimings);
    }
    function $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration(timingMetricKey) {
        const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
        return Number(inputElementWithTimingValue?.value ?? 0);
    }
    function $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings() {
        const duration = $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.time');
        if (!duration) return null;
        const timings = {
            '': {
                startTime: 0,
                duration: duration
            },
            'flush-head': {
                startTime: 0,
                duration: $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
            }
        };
        return timings;
    }
    const $ba8cdb329bff9946$var$monolithTimerRenames = {
        'jira-request-server-time': ''
    };
    function $ba8cdb329bff9946$var$getJiraMonolithTimings() {
        if (!globalThis._monolithTimings) return $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings();
        return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
                $ba8cdb329bff9946$var$monolithTimerRenames[name] ?? name,
                {
                    startTime: startTime,
                    duration: duration
                }
            ]));
    }
    function $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
        if (jiraBeTimings || !tesseractTimings) return null;
        const timings = {
            '': {
                startTime: 0,
                duration: tesseractTimings['']?.duration
            }
        };
        return timings;
    }
    function $ba8cdb329bff9946$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
        if (!referenceTimer || !timerToShift) return null;
        if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
        else return referenceTimer.startTime - timerToShift.startTime;
    }
    function $ba8cdb329bff9946$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
        const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
        return $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
    }
    function $ba8cdb329bff9946$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
        const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
        const jiraBeTesseractOffest = $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
        const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
        const bifrostOffset = $ba8cdb329bff9946$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
        return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
    }
    function $ba8cdb329bff9946$var$getEdgeTime() {
        const navigatonPerfTimingEntry = (0, (0, parcelRequire("6RCeq")).default)?.getEntriesByType('navigation')?.[0];
        return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === 'atl-edge')?.duration ?? 0;
    }
    function $ba8cdb329bff9946$export$6d488733a547304() {
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira-ssr-update-perf-portal-timings')) return $ba8cdb329bff9946$var$getTesseractTimings();
        const jiraBeTimings = $ba8cdb329bff9946$var$getJiraMonolithTimings();
        const jiraFeGatewayTimings = $ba8cdb329bff9946$var$getJiraFeGatewayTimings();
        const tesseractTimings = $ba8cdb329bff9946$var$getTesseractTimings();
        const bifrostGatewayTimings = $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
        const edgeTime = $ba8cdb329bff9946$var$getEdgeTime();
        const finalJiraBeTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraBeTimings, {
            startTimeOffsetMs: edgeTime,
            prefix: 'jira-monolith'
        });
        const finalBifrostGatewayTimings = $ba8cdb329bff9946$var$applyTimingOverrides(bifrostGatewayTimings, {
            startTimeOffsetMs: edgeTime,
            prefix: 'bifrost-gateway'
        });
        const jfgOffset = $ba8cdb329bff9946$var$getJfgOffset({
            jiraFeGatewayTimings: jiraFeGatewayTimings,
            jiraBeTimings: finalJiraBeTimings
        });
        const finalJfgTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraFeGatewayTimings, {
            startTimeOffsetMs: jfgOffset,
            prefix: 'jira-fe-gateway'
        });
        const tesseractOffset = $ba8cdb329bff9946$var$getTesseractOffset({
            tesseractTimings: tesseractTimings,
            jiraFeGatewayTimings: finalJfgTimings,
            bifrostGatewayTimings: finalBifrostGatewayTimings
        });
        const finalTesseractTimings = $ba8cdb329bff9946$var$applyTimingOverrides(tesseractTimings, {
            startTimeOffsetMs: tesseractOffset,
            prefix: 'tesseract'
        });
        const timings = {
            ...edgeTime && {
                edge: {
                    startTime: 0,
                    duration: edgeTime
                }
            },
            ...finalJiraBeTimings,
            ...finalJfgTimings,
            ...finalBifrostGatewayTimings,
            ...finalTesseractTimings
        };
        $ba8cdb329bff9946$var$insertTotalTiming('total', timings);
        return Object.keys(timings).length ? timings : null;
    }
    const $ba8cdb329bff9946$var$SSR_FF_META_TAG = 'spa-service-flags';
    let $ba8cdb329bff9946$var$ffCache;
    let $ba8cdb329bff9946$var$ffCacheInitialiser = ()=>{
        try {
            const metaTagValue = (0, (0, parcelRequire("j8DrX")).default)($ba8cdb329bff9946$var$SSR_FF_META_TAG);
            if (metaTagValue === null) return null;
            $ba8cdb329bff9946$var$ffCache = JSON.parse(metaTagValue) || null;
        } catch (e) {
            $ba8cdb329bff9946$var$ffCache = null;
        }
        $ba8cdb329bff9946$var$ffCacheInitialiser = null;
    };
    function $ba8cdb329bff9946$var$getFeatureFlags() {
        if ($ba8cdb329bff9946$var$ffCacheInitialiser != null) $ba8cdb329bff9946$var$ffCacheInitialiser();
        return $ba8cdb329bff9946$var$ffCache;
    }
    const $ba8cdb329bff9946$export$7bcf91e323db67dd = {
        getDoneMark: ()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ssr_success_when_spa_success')) {
                const SPASSRRenderedMark = (0, (0, parcelRequire("x9xyg")).getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime;
                if (SPASSRRenderedMark && (0, (0, parcelRequire("x9xyg")).getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
                return null;
            }
            return (0, (0, parcelRequire("x9xyg")).getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;
        },
        getTimings: $ba8cdb329bff9946$export$6d488733a547304,
        getFeatureFlags: $ba8cdb329bff9946$var$getFeatureFlags
    };
});
parcelRegister("3qHVS", function(module, exports) {
    $parcel$export(module.exports, "visualRefreshResolverOverride", ()=>$56907fa85239d7b0$export$73a94df81a7c0f2c);
    var $dCm1o;
    const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
        'platform-component-visual-refresh',
        'platform-visual-refresh-icons-legacy-facade',
        'platform-visual-refresh-icons'
    ];
    const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
        (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
        (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)
    ];
});
parcelRegister("2ChuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe3490a17e762431$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $6YRTH;
    var $co1wz;
    var $j8DrX;
    var $7AZuS = parcelRequire("7AZuS");
    var $7o9iL = parcelRequire("7o9iL");
    const $fe3490a17e762431$var$isHeartbeatEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jfp.heartbeat_vfp2h', false);
    const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
        (parcelRequire("1mY2B"));
    };
    const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
        (parcelRequire("bUWQg"));
    };
    const $fe3490a17e762431$var$renderHeartbeat = ()=>{
        (parcelRequire("5PCBy"));
    };
    const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("4MqrY"));
    const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("hkk3A"));
    const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
    const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
        const searchSessionId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
        const containerId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-container-id');
        const objectId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-object-id');
        const objectType = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-content-type');
        (0, (0, parcelRequire("6YRTH")).default)([
            'searchSessionId',
            'searchObjectId',
            'searchContainerId',
            'searchContentType'
        ]);
        (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
            containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
            objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
            objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
        });
    };
    const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
        const priorityApps = [];
        if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
        if (args.navigation) priorityApps.push(args.renderNavigation());
        return priorityApps;
    };
    const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
        if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
        if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
        if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
        if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
        if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
        if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
    };
    const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
        await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
            flags: args.flags,
            navigation: args.navigation,
            renderNavigation: args.renderNavigation
        }));
        $fe3490a17e762431$var$installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))(args, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
    };
    const $fe3490a17e762431$var$defaultArgs = {
        flags: true,
        navigation: true,
        upflow: true,
        profileCardNextLegacy: true,
        heartbeat: $fe3490a17e762431$var$isHeartbeatEnabled(),
        connectModules: true,
        engagementMessages: true,
        searchDwellTimeComponent: true,
        renderNavigation: ()=>null
    };
    var $fe3490a17e762431$export$2e2bcd8739ae039 = {
        install: (args)=>{
            const argsWithDefaults = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
        },
        installHighPriorityApps: (args)=>{
            const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installHighPriorityApps({
                flags: flags,
                navigation: navigation,
                renderNavigation: renderNavigation
            });
        },
        installLowPriorityApps: (args)=>{
            const installArgs = (0, ($parcel$interopDefault($fr1K2)))({
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            }, [
                'flags',
                'navigation',
                'renderNavigation'
            ]);
            $fe3490a17e762431$var$installLowPriorityApps(installArgs);
        }
    };
});
parcelRegister("7AZuS", function(module, exports) {
    $parcel$export(module.exports, "renderFlags", ()=>$271711a34feab2aa$export$b6228dc14c5adf51);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $gG5I6;
    var $iNWLk;
    var $5eQ1m;
    var $hPtZI;
    const $271711a34feab2aa$var$throwError = (message)=>{
        const error = new Error(message);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('flags.entry', message, error);
        throw error;
    };
    const $271711a34feab2aa$var$getContainer = ()=>{
        let container = document.getElementById('flags');
        if (container == null) {
            container = document.createElement('div');
            container.id = 'flags';
            if (document.body) document.body.appendChild(container);
            else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
        }
        return container;
    };
    const $271711a34feab2aa$var$Flags = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$var$AfterPaintFlags = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gG5I6")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: "flags-entry"
        }, __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());
});
parcelRegister("iNWLk", function(module, exports) {
    $parcel$export(module.exports, "FlagsBoundary", ()=>$6377b132f88aa82c$export$8b4a0fffcddd96f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    const $6377b132f88aa82c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "flags",
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "flags-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, children));
});
parcelRegister("aw7rz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h46oV")
    ]).then(()=>parcelRequire('3jTq3'));
});
parcelRegister("7o9iL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87698987077682aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $5eQ1m;
    var $TtQEC;
    const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
        const existingPlaceholder = document.getElementById(placeholderId);
        if (existingPlaceholder) return existingPlaceholder;
        const div = document.createElement('div');
        div.id = placeholderId;
        if (document.body) document.body.appendChild(div);
        else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
        return div;
    };
    const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
        if (placeholder && sessionId) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
            sessionId: sessionId,
            data: data
        })), $87698987077682aa$var$getPlaceholder(placeholder));
    };
    var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;
});
parcelRegister("1mY2B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZtG1")
    ]).then(()=>parcelRequire('2Q8el'));
});
parcelRegister("bUWQg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("54DPr")
    ]).then(()=>parcelRequire('forzB'));
});
parcelRegister("5PCBy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bERdS").then(()=>parcelRequire('8ymsB'));
});
parcelRegister("4MqrY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kWrFZ"),
        $6fhBS("i5RRW"),
        $6fhBS("561Jq"),
        $6fhBS("1QYl5"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("hPzOn"),
        $6fhBS("dsiAd"),
        $6fhBS("eNmuD"),
        $6fhBS("dzRix")
    ]).then(()=>parcelRequire('faPQm'));
});
parcelRegister("hkk3A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Nlduf").then(()=>parcelRequire('jEc6C'));
});
parcelRegister("80kW8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5gip9")
    ]).then(()=>parcelRequire('lOTPs'));
});
$parcel$global.rwr("95SjW", ()=>{
    parcelRequire("lRSO6");
    parcelRequire("8oLfs");
    var $x9xyg;
    var $dtV5n;
    var $ghGCX;
    var $2SVPM;
    var $gGB8S = parcelRequire("gGB8S");
    (0, (0, parcelRequire("x9xyg")).setMark)('JIRA_SPA_ENTRY_LOADED');
    const $d7f850f84bfc5cc4$var$getInitialRoutes = ()=>[
            (0, (0, parcelRequire("dtV5n")).browseIssueRouteEntry),
            (0, (0, parcelRequire("dtV5n")).browseIssueEmbedRouteEntry),
            (0, (0, parcelRequire("ghGCX")).legacyRedirectRouteEntry)
        ];
    const $d7f850f84bfc5cc4$var$loadLazyRoutes = async ()=>(0, (0, parcelRequire("2SVPM")).measureInitialPageLoadTimingAsync)('jira-spa/load-lazy-routes', ()=>{
            return new Promise((resolve, reject)=>{
                const cb = ()=>{
                    (parcelRequire("80kW8")).then((mod)=>{
                        resolve(mod.default);
                    }).catch((err)=>{
                        reject(err);
                    });
                };
                if (typeof window !== 'undefined' && typeof window.requestIdleCallback !== 'undefined') window.requestIdleCallback(cb);
                else setTimeout(cb, 500);
            });
        });
    (0, $gGB8S.startJiraSpa)($d7f850f84bfc5cc4$var$getInitialRoutes, $d7f850f84bfc5cc4$var$loadLazyRoutes);
}, [
    "eNmuD",
    "dsiAd",
    "hPzOn",
    "2Lfdl",
    "kfXhT",
    "1QYl5",
    "561Jq",
    "i5RRW",
    "kWrFZ",
    "fr9NE",
    "cM9em",
    "bYT2S",
    "h2MrD",
    "aqf4w"
]);
$parcel$global.rlb("95SjW");
